import {
  __require,
  __toESM
} from "./chunk-6jf1natv.js";

// src/Studio.tsx
import { useLayoutEffect as useLayoutEffect2 } from "react";
import { createPortal } from "react-dom";
import { Internals as Internals70 } from "remotion";

// src/components/Editor.tsx
import { PlayerInternals as PlayerInternals19 } from "@remotion/player";
import React187, { useCallback as useCallback144, useEffect as useEffect90, useMemo as useMemo145 } from "react";
import { Internals as Internals65 } from "remotion";

// src/helpers/colors.ts
var BACKGROUND = "rgb(31,36,40)";
var BACKGROUND__TRANSPARENT = "rgba(31,36,40, 0)";
var INPUT_BACKGROUND = "#2f363d";
var BORDER_COLOR = "#000";
var LIGHT_COLOR = "#ddd";
var SELECTED_BACKGROUND = "hsla(0, 0%, 100%, 0.15)";
var LIGHT_TEXT = "#A6A7A9";
var RULER_COLOR = "#808080";
var VERY_LIGHT_TEXT = "rgba(255, 255, 255, 0.3)";
var SELECTED_HOVER_BACKGROUND = "hsla(0, 0%, 100%, 0.25)";
var CLEAR_HOVER = "rgba(255, 255, 255, 0.06)";
var INPUT_BORDER_COLOR_UNHOVERED = "rgba(0, 0, 0, 0.6)";
var INPUT_BORDER_COLOR_HOVERED = "rgba(255, 255, 255, 0.05)";
var TIMELINE_BACKGROUND = "#111";
var FAIL_COLOR = "#ff3232";
var TEXT_COLOR = "#fff";
var WARNING_COLOR = "#f1c40f";
var BLUE = "#0b84f3";
var BLUE_DISABLED = "#284f73";
var LIGHT_TRANSPARENT = "rgba(255, 255, 255, 0.7)";
var UNSELECTED_GUIDE = "#7e1219";
var SELECTED_GUIDE = "#d22d3a";
var LINE_COLOR = "#363A3E";
var TIMELINE_TRACK_SEPARATOR = "rgba(0, 0, 0, 0.3)";
var getBackgroundFromHoverState = ({
  selected,
  hovered
}) => {
  if (selected) {
    if (hovered) {
      return SELECTED_HOVER_BACKGROUND;
    }
    return SELECTED_BACKGROUND;
  }
  if (hovered) {
    return CLEAR_HOVER;
  }
  return "transparent";
};

// src/helpers/noop.ts
var noop = () => {
  return;
};

// src/state/canvas-ref.ts
import { createRef } from "react";
var canvasRef = createRef();
var drawRef = createRef();

// src/state/timeline-zoom.tsx
import { createContext as createContext2, useMemo as useMemo2, useState } from "react";

// src/components/Timeline/imperative-state.ts
var currentFrame = 0;
var currentZoom = 1;
var currentDuration = 1;
var currentFps = 1;
var getCurrentZoom = () => {
  return currentZoom;
};
var setCurrentZoom = (z) => {
  currentZoom = z;
};
var getCurrentFrame = () => {
  return currentFrame;
};
var setCurrentFrame = (f) => {
  currentFrame = f;
};
var getCurrentDuration = () => {
  return currentDuration;
};
var setCurrentDuration = (d) => {
  currentDuration = d;
};
var getCurrentFps = () => {
  return currentFps;
};
var setCurrentFps = (d) => {
  currentFps = d;
};

// src/components/Timeline/timeline-scroll-logic.ts
import { interpolate } from "remotion";

// src/helpers/timeline-layout.ts
var TIMELINE_PADDING = 16;
var TIMELINE_BORDER = 1;
var TIMELINE_ITEM_BORDER_BOTTOM = 1;
var TIMELINE_TRACK_EXPANDED_HEIGHT = 100;
var SCHEMA_FIELD_ROW_HEIGHT = 22;
var UNSUPPORTED_FIELD_ROW_HEIGHT = 22;
var SUPPORTED_SCHEMA_TYPES = new Set([
  "number",
  "boolean",
  "rotation",
  "translate"
]);
var getSchemaFields = (controls) => {
  if (!controls) {
    return null;
  }
  return Object.entries(controls.schema).map(([key, fieldSchema]) => {
    const typeName = fieldSchema.type;
    const supported = SUPPORTED_SCHEMA_TYPES.has(typeName);
    return {
      key,
      description: fieldSchema.description,
      typeName,
      supported,
      rowHeight: supported ? SCHEMA_FIELD_ROW_HEIGHT : UNSUPPORTED_FIELD_ROW_HEIGHT,
      currentValue: controls.currentValue[key],
      fieldSchema
    };
  });
};
var getExpandedTrackHeight = (controls) => {
  const fields = getSchemaFields(controls);
  if (!fields || fields.length === 0) {
    return TIMELINE_TRACK_EXPANDED_HEIGHT;
  }
  const separators = Math.max(0, fields.length - 1);
  return fields.reduce((sum, f) => sum + f.rowHeight, 0) + separators;
};
var getTimelineLayerHeight = (type) => {
  if (type === "video") {
    return 50;
  }
  return 25;
};

// src/components/Timeline/timeline-refs.ts
import React from "react";
var sliderAreaRef = React.createRef();
var scrollableRef = React.createRef();
var timelineVerticalScroll = React.createRef();

// src/components/Timeline/TimelineSlider.tsx
import {
  createRef as createRef2,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef
} from "react";
import { Internals, useVideoConfig } from "remotion";

// src/helpers/get-left-of-timeline-slider.ts
var getXPositionOfItemInTimelineImperatively = (frame, duration, width) => {
  const proportion = frame / (duration - 1);
  return proportion * (width - TIMELINE_PADDING * 2) + TIMELINE_PADDING;
};

// src/components/Timeline/TimelineSliderHandle.tsx
import { jsx } from "react/jsx-runtime";
var container = {
  width: 20,
  height: 20,
  position: "fixed",
  marginLeft: -8
};
var TimelineSliderHandle = () => {
  return /* @__PURE__ */ jsx("div", {
    style: container,
    children: /* @__PURE__ */ jsx("svg", {
      width: 17,
      viewBox: "0 0 159 212",
      children: /* @__PURE__ */ jsx("path", {
        d: "M17.0234375,1.07763419 L143.355469,1.07763419 C151.63974,1.07763419 158.355469,7.79336295 158.355469,16.0776342 L158.355469,69.390507 C158.355469,73.7938677 156.420655,77.9748242 153.064021,80.8248415 L89.3980057,134.881757 C83.7986799,139.635978 75.5802263,139.635978 69.9809005,134.881757 L6.66764807,81.1243622 C3.0872392,78.0843437 1.0234375,73.6246568 1.0234375,68.9277387 L1.0234375,17.0776342 C1.0234375,8.2410782 8.1868815,1.07763419 17.0234375,1.07763419 Z",
        fill: "#f02c00"
      })
    })
  });
};

// src/components/Timeline/TimelineWidthProvider.tsx
import { PlayerInternals } from "@remotion/player";
import { createContext } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var TimelineWidthContext = createContext(null);
var TimelineWidthProvider = ({ children }) => {
  const size = PlayerInternals.useElementSize(sliderAreaRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  return /* @__PURE__ */ jsx2(TimelineWidthContext.Provider, {
    value: size?.width ?? null,
    children
  });
};

// src/components/Timeline/TimelineSlider.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var container2 = {
  position: "absolute",
  bottom: 0,
  top: 0,
  pointerEvents: "none"
};
var line = {
  height: "100vh",
  width: 1,
  position: "fixed",
  backgroundColor: "#f02c00"
};
var redrawTimelineSliderFast = createRef2();
var TimelineSlider = () => {
  const videoConfig = Internals.useUnsafeVideoConfig();
  const timelineWidth = useContext(TimelineWidthContext);
  if (videoConfig === null || timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx3(Inner, {});
};
var Inner = () => {
  const videoConfig = useVideoConfig();
  const timelinePosition = Internals.Timeline.useTimelinePosition();
  const ref = useRef(null);
  const timelineWidth = useContext(TimelineWidthContext);
  if (timelineWidth === null) {
    throw new Error("Unexpectedly did not have timeline width");
  }
  const style = useMemo(() => {
    const left = getXPositionOfItemInTimelineImperatively(timelinePosition, videoConfig.durationInFrames, timelineWidth);
    return {
      ...container2,
      transform: `translateX(${left}px)`
    };
  }, [timelinePosition, videoConfig.durationInFrames, timelineWidth]);
  useImperativeHandle(redrawTimelineSliderFast, () => {
    return {
      draw: (frame, width) => {
        const { current } = ref;
        if (!current) {
          throw new Error("unexpectedly did not have ref to timelineslider");
        }
        current.style.transform = `translateX(${getXPositionOfItemInTimelineImperatively(frame, getCurrentDuration(), width ?? sliderAreaRef.current?.clientWidth ?? 0)}px)`;
      }
    };
  }, []);
  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", {
    ref,
    style,
    children: [
      /* @__PURE__ */ jsx3("div", {
        style: line
      }),
      /* @__PURE__ */ jsx3(TimelineSliderHandle, {})
    ]
  });
};

// src/components/Timeline/timeline-scroll-logic.ts
var canScrollTimelineIntoDirection = () => {
  const current = scrollableRef.current;
  const { scrollWidth, scrollLeft, clientWidth } = current;
  const canScrollRight = scrollWidth - scrollLeft - clientWidth > TIMELINE_PADDING;
  const canScrollLeft = scrollLeft > TIMELINE_PADDING;
  return { canScrollRight, canScrollLeft };
};
var SCROLL_INCREMENT = 200;
var calculateFrameWhileScrollingRight = ({
  durationInFrames,
  width,
  scrollLeft
}) => {
  return getFrameFromX({
    clientX: scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  }) + Math.ceil((scrollableRef.current?.clientWidth - TIMELINE_PADDING) / getFrameIncrement(durationInFrames));
};
var getFrameWhileScrollingLeft = ({
  durationInFrames,
  width
}) => {
  const nextFrame = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft - SCROLL_INCREMENT,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  const currentFrame2 = getFrameFromX({
    clientX: scrollableRef.current?.scrollLeft,
    durationInFrames,
    width,
    extrapolate: "clamp"
  });
  return Math.max(0, Math.min(currentFrame2 - 1, nextFrame));
};
var isCursorInViewport = ({
  frame,
  durationInFrames
}) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
    nextFrame: frame,
    durationInFrames
  });
  const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
    nextFrame: frame,
    durationInFrames
  });
  const currentFrameRight = calculateFrameWhileScrollingRight({
    durationInFrames,
    scrollLeft,
    width
  });
  return !(scrollPosOnRightEdge >= getScrollPositionForCursorOnRightEdge({
    nextFrame: currentFrameRight,
    durationInFrames
  }) || scrollPosOnLeftEdge < scrollLeft);
};
var ensureFrameIsInViewport = ({
  direction,
  durationInFrames,
  frame
}) => {
  redrawTimelineSliderFast.current?.draw(frame);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const scrollLeft = scrollableRef.current?.scrollLeft ?? 0;
  if (direction === "fit-left") {
    const currentFrameLeft = getFrameFromX({
      clientX: scrollLeft,
      durationInFrames,
      width,
      extrapolate: "clamp"
    });
    const scrollPos = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollLeft = scrollPos <= getScrollPositionForCursorOnLeftEdge({
      nextFrame: currentFrameLeft,
      durationInFrames
    });
    if (needsToScrollLeft) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "fit-right") {
    const currentFrameRight = calculateFrameWhileScrollingRight({
      durationInFrames,
      scrollLeft,
      width
    });
    const scrollPos = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const needsToScrollRight = scrollPos >= getScrollPositionForCursorOnRightEdge({
      nextFrame: currentFrameRight,
      durationInFrames
    });
    if (needsToScrollRight) {
      scrollToTimelineXOffset(scrollPos);
    }
  }
  if (direction === "page-right" || direction === "page-left") {
    if (!isCursorInViewport({ frame, durationInFrames })) {
      scrollToTimelineXOffset(direction === "page-left" ? getScrollPositionForCursorOnRightEdge({
        nextFrame: frame,
        durationInFrames
      }) : getScrollPositionForCursorOnLeftEdge({
        nextFrame: frame,
        durationInFrames
      }));
    }
  }
  if (direction === "center") {
    const scrollPosOnRightEdge = getScrollPositionForCursorOnRightEdge({
      nextFrame: frame,
      durationInFrames
    });
    const scrollPosOnLeftEdge = getScrollPositionForCursorOnLeftEdge({
      nextFrame: frame,
      durationInFrames
    });
    scrollToTimelineXOffset((scrollPosOnLeftEdge + scrollPosOnRightEdge) / 2);
  }
};
var scrollToTimelineXOffset = (scrollPos) => {
  scrollableRef.current?.scroll({
    left: scrollPos
  });
};
var getScrollPositionForCursorOnLeftEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const scrollPos = frameIncrement * nextFrame;
  return scrollPos;
};
var getScrollPositionForCursorOnRightEdge = ({
  nextFrame,
  durationInFrames
}) => {
  const frameIncrement = getFrameIncrement(durationInFrames);
  const framesRemaining = durationInFrames - 1 - nextFrame;
  const fromRight = framesRemaining * frameIncrement + TIMELINE_PADDING;
  const scrollPos = scrollableRef.current?.scrollWidth - fromRight - scrollableRef.current?.clientWidth + TIMELINE_PADDING + 4;
  return scrollPos;
};
var getFrameIncrement = (durationInFrames) => {
  const width = scrollableRef.current?.scrollWidth ?? 0;
  return getFrameIncrementFromWidth(durationInFrames, width);
};
var getFrameIncrementFromWidth = (durationInFrames, width) => {
  return (width - TIMELINE_PADDING * 2) / (durationInFrames - 1);
};
var getFrameWhileScrollingRight = ({
  durationInFrames,
  width
}) => {
  const nextFrame = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft + SCROLL_INCREMENT
  });
  const currentFrame2 = calculateFrameWhileScrollingRight({
    durationInFrames,
    width,
    scrollLeft: scrollableRef.current?.scrollLeft
  });
  return Math.min(durationInFrames - 1, Math.max(nextFrame, currentFrame2 + 1));
};
var getFrameFromX = ({
  clientX,
  durationInFrames,
  width,
  extrapolate
}) => {
  const pos = clientX - TIMELINE_PADDING;
  const frame = Math.round(interpolate(pos, [0, width - TIMELINE_PADDING * 2], [0, durationInFrames - 1], {
    extrapolateLeft: extrapolate,
    extrapolateRight: extrapolate
  }));
  return frame;
};
var zoomAndPreserveCursor = ({
  oldZoom,
  newZoom,
  currentFrame: currentFrame2,
  currentDurationInFrames
}) => {
  const ratio = newZoom / oldZoom;
  if (ratio === 1) {
    return;
  }
  const { current } = scrollableRef;
  if (!current) {
    return;
  }
  const frameIncrement = getFrameIncrement(currentDurationInFrames);
  const prevCursorPosition = frameIncrement * currentFrame2 + TIMELINE_PADDING;
  const newCursorPosition = ratio * (prevCursorPosition - TIMELINE_PADDING) + TIMELINE_PADDING;
  current.scrollLeft += newCursorPosition - prevCursorPosition;
  redrawTimelineSliderFast.current?.draw(currentFrame2, (scrollableRef.current?.clientWidth ?? 0) * ratio);
};

// src/components/ZoomPersistor.tsx
import { useContext as useContext2, useEffect as useEffect2 } from "react";
import { Internals as Internals2 } from "remotion";

// src/helpers/url-state.ts
var getUrlHandlingType = () => {
  if (window.remotion_isReadOnlyStudio) {
    return "query-string";
  }
  return "spa";
};
var pushUrl = (url) => {
  if (getUrlHandlingType() === "query-string") {
    window.history.pushState({}, "Studio", `${window.location.pathname}?${url}`);
  } else {
    window.history.pushState({}, "Studio", url);
  }
};
var clearUrl = () => {
  window.location.href = window.location.pathname;
};
var reloadUrl = () => {
  window.location.reload();
};
var getRoute = () => {
  if (getUrlHandlingType() === "query-string") {
    return window.location.search.substring(1);
  }
  return window.location.pathname;
};

// src/components/load-canvas-content-from-url.ts
var deriveCanvasContentFromUrl = () => {
  const route = getRoute();
  const substrings = route.split("/").filter(Boolean);
  const lastPart = substrings[substrings.length - 1];
  if (substrings[0] === "assets") {
    return {
      type: "asset",
      asset: decodeURIComponent(route.substring("/assets/".length))
    };
  }
  if (substrings[0] === "outputs") {
    return {
      type: "output",
      path: decodeURIComponent(route.substring("/outputs/".length))
    };
  }
  if (lastPart) {
    return {
      type: "composition",
      compositionId: decodeURIComponent(lastPart)
    };
  }
  return null;
};

// src/components/ZoomPersistor.tsx
var makeKey = () => {
  return `remotion.zoom-map`;
};
var persistCurrentZoom = (zoom) => {
  localStorage.setItem(makeKey(), JSON.stringify(zoom));
};
var getZoomFromLocalStorage = () => {
  const zoom = localStorage.getItem(makeKey());
  return zoom ? JSON.parse(zoom) : {};
};
var ZoomPersistor = () => {
  const [playing] = Internals2.Timeline.usePlayingState();
  const { zoom } = useContext2(TimelineZoomCtx);
  const { canvasContent } = useContext2(Internals2.CompositionManager);
  const urlState = deriveCanvasContentFromUrl();
  const isActive = urlState && urlState.type === "composition" && canvasContent && canvasContent.type === "composition" && urlState.compositionId === canvasContent.compositionId;
  useEffect2(() => {
    if (!isActive) {
      return;
    }
    persistCurrentZoom(zoom);
  }, [zoom, isActive, playing, urlState]);
  return null;
};

// src/state/timeline-zoom.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var TIMELINE_MIN_ZOOM = 1;
var TIMELINE_MAX_ZOOM = 5;
var TimelineZoomCtx = createContext2({
  zoom: {},
  setZoom: () => {
    throw new Error("has no context");
  }
});
var TimelineZoomContext = ({ children }) => {
  const [zoom, setZoom] = useState(() => getZoomFromLocalStorage());
  const value = useMemo2(() => {
    return {
      zoom,
      setZoom: (compositionId, callback) => {
        setZoom((prevZoomMap) => {
          const newZoomWithFloatingPointErrors = Math.min(TIMELINE_MAX_ZOOM, Math.max(TIMELINE_MIN_ZOOM, callback(prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM)));
          const newZoom = Math.round(newZoomWithFloatingPointErrors * 10) / 10;
          zoomAndPreserveCursor({
            oldZoom: prevZoomMap[compositionId] ?? TIMELINE_MIN_ZOOM,
            newZoom,
            currentDurationInFrames: getCurrentDuration(),
            currentFrame: getCurrentFrame()
          });
          return { ...prevZoomMap, [compositionId]: newZoom };
        });
      }
    };
  }, [zoom]);
  return /* @__PURE__ */ jsx4(TimelineZoomCtx.Provider, {
    value,
    children
  });
};

// src/state/z-index.tsx
import {
  createContext as createContext5,
  useContext as useContext4,
  useEffect as useEffect4,
  useMemo as useMemo6,
  useRef as useRef3
} from "react";

// src/helpers/use-keybinding.ts
import { useCallback as useCallback2, useContext as useContext3, useEffect as useEffect3, useMemo as useMemo4, useState as useState2 } from "react";

// src/state/keybindings.tsx
import { createContext as createContext3, useCallback, useMemo as useMemo3, useRef as useRef2 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var KeybindingContext = createContext3({
  registerKeybinding: () => {
    throw new Error("Has no keybinding context");
  },
  unregisterKeybinding: () => {
    return;
  },
  unregisterPane: () => {
    return;
  }
});
var KeybindingContextProvider = ({ children }) => {
  const registered = useRef2([]);
  const registerKeybinding = useCallback((binding) => {
    registered.current = [...registered.current, binding];
    window.addEventListener(binding.event, binding.callback);
  }, []);
  const unregisterKeybinding = useCallback((binding) => {
    registered.current = registered.current.filter((r) => {
      if (r.id === binding.id) {
        window.removeEventListener(binding.event, binding.callback);
        return false;
      }
      return true;
    });
  }, []);
  const unregisterPane = useCallback((paneId) => {
    const matchedKeybindings = registered.current.filter((r) => r.registeredFromPane === paneId);
    for (const matched of matchedKeybindings) {
      unregisterKeybinding(matched);
    }
  }, [unregisterKeybinding]);
  const value = useMemo3(() => {
    return {
      registerKeybinding,
      unregisterKeybinding,
      unregisterPane
    };
  }, [registerKeybinding, unregisterKeybinding, unregisterPane]);
  return /* @__PURE__ */ jsx5(KeybindingContext.Provider, {
    value,
    children
  });
};

// src/helpers/use-keybinding.ts
if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
  console.warn("Keyboard shortcuts disabled either due to: a) --disable-keyboard-shortcuts being passed b) Config.setKeyboardShortcutsEnabled(false) being set or c) a Remotion version mismatch.");
}
var areKeyboardShortcutsDisabled = () => {
  return !process.env.KEYBOARD_SHORTCUTS_ENABLED;
};
var useKeybinding = () => {
  const [paneId] = useState2(() => String(Math.random()));
  const context = useContext3(KeybindingContext);
  const { isHighestContext } = useZIndex();
  const registerKeybinding = useCallback2((options) => {
    if (!process.env.KEYBOARD_SHORTCUTS_ENABLED) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    if (!isHighestContext && !options.keepRegisteredWhenNotHighestContext) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    const listener = (e) => {
      const commandKey = window.navigator.platform.startsWith("Mac") ? e.metaKey : e.ctrlKey;
      if (!e.key) {
        return;
      }
      if (e.key.toLowerCase() === options.key.toLowerCase() && options.commandCtrlKey === commandKey) {
        if (!options.triggerIfInputFieldFocused) {
          const { activeElement } = document;
          if (activeElement instanceof HTMLInputElement) {
            return;
          }
          if (activeElement instanceof HTMLTextAreaElement) {
            return;
          }
        }
        options.callback(e);
        if (options.preventDefault) {
          e.preventDefault();
        }
      }
    };
    const toRegister = {
      registeredFromPane: paneId,
      event: options.event,
      key: options.key,
      callback: listener,
      id: String(Math.random())
    };
    context.registerKeybinding(toRegister);
    return {
      unregister: () => context.unregisterKeybinding(toRegister)
    };
  }, [context, isHighestContext, paneId]);
  useEffect3(() => {
    return () => {
      context.unregisterPane(paneId);
    };
  }, [context, paneId]);
  return useMemo4(() => ({ registerKeybinding, isHighestContext }), [registerKeybinding, isHighestContext]);
};

// src/state/highest-z-index.tsx
import { createContext as createContext4, useCallback as useCallback3, useMemo as useMemo5, useState as useState3 } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var HighestZIndexContext = createContext4({
  highestIndex: 0,
  registerZIndex: () => {
    return;
  },
  unregisterZIndex: () => {
    return;
  }
});
var HighestZIndexProvider = ({ children }) => {
  const [zIndexes, setZIndexes] = useState3([]);
  const registerZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => [...prev, newIndex]);
  }, []);
  const unregisterZIndex = useCallback3((newIndex) => {
    setZIndexes((prev) => {
      const index = prev.indexOf(newIndex);
      if (index === -1) {
        throw new Error("did not find z-index " + newIndex);
      }
      return prev.filter((_n, i) => i !== index);
    });
  }, []);
  const highestIndex = Math.max(...zIndexes);
  const value = useMemo5(() => {
    return {
      highestIndex,
      registerZIndex,
      unregisterZIndex
    };
  }, [registerZIndex, unregisterZIndex, highestIndex]);
  return /* @__PURE__ */ jsx6(HighestZIndexContext.Provider, {
    value,
    children
  });
};

// src/state/input-dragger-click-lock.ts
var clickLock = false;
var getClickLock = () => clickLock;
var setClickLock = (lock) => {
  clickLock = lock;
};

// src/state/z-index.tsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var ZIndexContext = createContext5({
  currentIndex: 0
});
var margin = {
  margin: "auto"
};
var EscapeHook = ({ onEscape }) => {
  const keybindings = useKeybinding();
  useEffect4(() => {
    const escape = keybindings.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escape.unregister();
    };
  }, [keybindings, onEscape]);
  return null;
};
var HigherZIndex = ({ children, onEscape, onOutsideClick, disabled }) => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const containerRef = useRef3(null);
  const currentIndex = disabled ? context.currentIndex : context.currentIndex + 1;
  useEffect4(() => {
    if (disabled) {
      return;
    }
    highestContext.registerZIndex(currentIndex);
    return () => highestContext.unregisterZIndex(currentIndex);
  }, [currentIndex, highestContext, disabled]);
  useEffect4(() => {
    if (disabled) {
      return;
    }
    let onUp = null;
    const listener = (downEvent) => {
      const outsideClick = !containerRef.current?.contains(downEvent.target);
      if (!outsideClick) {
        return;
      }
      onUp = (upEvent) => {
        if (highestContext.highestIndex === currentIndex && !getClickLock() && document.contains(upEvent.target)) {
          upEvent.stopPropagation();
          onOutsideClick(upEvent.target);
        }
      };
      window.addEventListener("pointerup", onUp, { once: true });
    };
    requestAnimationFrame(() => {
      window.addEventListener("pointerdown", listener);
    });
    return () => {
      if (onUp) {
        window.removeEventListener("pointerup", onUp, { once: true });
      }
      onUp = null;
      return window.removeEventListener("pointerdown", listener);
    };
  }, [currentIndex, disabled, highestContext.highestIndex, onOutsideClick]);
  const value = useMemo6(() => {
    return {
      currentIndex
    };
  }, [currentIndex]);
  return /* @__PURE__ */ jsxs2(ZIndexContext.Provider, {
    value,
    children: [
      disabled ? null : /* @__PURE__ */ jsx7(EscapeHook, {
        onEscape
      }),
      /* @__PURE__ */ jsx7("div", {
        ref: containerRef,
        style: margin,
        children
      })
    ]
  });
};
var useZIndex = () => {
  const context = useContext4(ZIndexContext);
  const highestContext = useContext4(HighestZIndexContext);
  const isHighestContext = highestContext.highestIndex === context.currentIndex;
  return useMemo6(() => ({
    currentZIndex: context.currentIndex,
    highestZIndex: highestContext.highestIndex,
    isHighestContext,
    tabIndex: isHighestContext ? 0 : -1
  }), [context.currentIndex, highestContext.highestIndex, isHighestContext]);
};

// src/components/EditorContent.tsx
import { useContext as useContext76 } from "react";
import { Internals as Internals58 } from "remotion";

// src/helpers/is-current-selected-still.ts
import { useContext as useContext5 } from "react";
import { Internals as Internals3 } from "remotion";

// src/helpers/is-composition-still.ts
var isCompositionStill = (comp) => {
  if (!comp) {
    return false;
  }
  return comp.durationInFrames === 1;
};

// src/helpers/is-current-selected-still.ts
var useIsStill = () => {
  const resolved = Internals3.useResolvedVideoConfig(null);
  if (!resolved || resolved.type !== "success") {
    return false;
  }
  return isCompositionStill(resolved.result);
};
var useIsVideoComposition = () => {
  const isStill = useIsStill();
  const { canvasContent } = useContext5(Internals3.CompositionManager);
  if (canvasContent === null) {
    return false;
  }
  if (isStill) {
    return false;
  }
  return canvasContent.type === "composition";
};

// src/components/InitialCompositionLoader.tsx
import { useCallback as useCallback23, useContext as useContext15, useEffect as useEffect15 } from "react";
import { Internals as Internals12 } from "remotion";

// src/helpers/mobile-layout.ts
import { useEffect as useEffect5, useRef as useRef4, useState as useState4 } from "react";
var breakpoint = 900;
function getIsMobile() {
  return window.innerWidth < breakpoint;
}
var useMobileLayout = () => {
  const [isMobile, setIsMobile] = useState4(getIsMobile());
  const isMobileRef = useRef4(isMobile);
  useEffect5(() => {
    function handleResize() {
      if (getIsMobile() !== isMobileRef.current) {
        setIsMobile(getIsMobile());
      }
      isMobileRef.current = getIsMobile();
    }
    window.addEventListener("resize", handleResize);
    return () => {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isMobile;
};

// src/state/folders.tsx
import { createContext as createContext7, useMemo as useMemo7, useState as useState5 } from "react";

// src/helpers/persist-open-folders.tsx
import { createContext as createContext6 } from "react";
var openFolderKey = ({
  folderName,
  parentName
}) => {
  return [parentName ?? "no-parent", folderName].join("/");
};
var localStorageKey = (type) => type === "compositions" ? "remotion.expandedFolders" : "remotion.expandedAssetFolders";
var persistExpandedFolders = (type, state) => {
  window.localStorage.setItem(localStorageKey(type), JSON.stringify(state));
};
var loadExpandedFolders = (type) => {
  const item = window.localStorage.getItem(localStorageKey(type));
  if (item === null) {
    return {};
  }
  return JSON.parse(item);
};
var ExpandedFoldersContext = createContext6({
  toggleFolder: () => {},
  foldersExpanded: {},
  setFoldersExpanded: () => {}
});

// src/state/folders.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var FolderContext = createContext7({
  compositionFoldersExpanded: {},
  setCompositionFoldersExpanded: () => {
    throw new Error("default state");
  },
  assetFoldersExpanded: {},
  setAssetFoldersExpanded: () => {
    throw new Error("default state");
  }
});
var FolderContextProvider = ({ children }) => {
  const [compositionFoldersExpanded, setCompositionFoldersExpanded] = useState5(() => loadExpandedFolders("compositions"));
  const [assetFoldersExpanded, setAssetFoldersExpanded] = useState5(() => loadExpandedFolders("assets"));
  const value = useMemo7(() => {
    return {
      compositionFoldersExpanded,
      setCompositionFoldersExpanded,
      assetFoldersExpanded,
      setAssetFoldersExpanded
    };
  }, [assetFoldersExpanded, compositionFoldersExpanded]);
  return /* @__PURE__ */ jsx8(FolderContext.Provider, {
    value,
    children
  });
};

// src/state/sidebar.tsx
import { createContext as createContext8, useMemo as useMemo8, useState as useState6 } from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var storageKey = (sidebar) => {
  if (sidebar === "right") {
    return "remotion.sidebarRightCollapsing";
  }
  return "remotion.sidebarCollapsing";
};
var getSavedCollapsedStateLeft = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("left"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "collapsed") {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "responsive";
};
var getSavedCollapsedStateRight = (isMobileLayout = false) => {
  const state = window.localStorage.getItem(storageKey("right"));
  if (isMobileLayout) {
    return "collapsed";
  }
  if (state === "expanded") {
    return "expanded";
  }
  return "collapsed";
};
var saveCollapsedState = (type, sidebar) => {
  window.localStorage.setItem(storageKey(sidebar), type);
};
var SidebarContext = createContext8({
  sidebarCollapsedStateLeft: "collapsed",
  setSidebarCollapsedState: () => {
    throw new Error("sidebar collapsed state");
  },
  sidebarCollapsedStateRight: "collapsed"
});
var SidebarContextProvider = ({ children }) => {
  const isMobileLayout = useMobileLayout();
  const [sidebarCollapsedState, setSidebarCollapsedState] = useState6(() => ({
    left: getSavedCollapsedStateLeft(isMobileLayout),
    right: getSavedCollapsedStateRight(isMobileLayout)
  }));
  const value = useMemo8(() => {
    return {
      sidebarCollapsedStateLeft: sidebarCollapsedState.left,
      sidebarCollapsedStateRight: sidebarCollapsedState.right,
      setSidebarCollapsedState: (options) => {
        const { left, right } = options;
        setSidebarCollapsedState((f) => {
          const copied = { ...f };
          if (left) {
            const updatedLeft = typeof left === "function" ? left(f.left) : left;
            saveCollapsedState(updatedLeft, "left");
            copied.left = updatedLeft;
          }
          if (right) {
            const updatedRight = typeof right === "function" ? right(f.right) : right;
            saveCollapsedState(updatedRight, "right");
            copied.right = updatedRight;
          }
          return copied;
        });
      }
    };
  }, [sidebarCollapsedState]);
  return /* @__PURE__ */ jsx9(SidebarContext.Provider, {
    value,
    children
  });
};

// src/components/CompositionSelector.tsx
import { useCallback as useCallback16, useContext as useContext9, useMemo as useMemo22 } from "react";
import { Internals as Internals7 } from "remotion";

// src/error-overlay/remotion-overlay/ShortcutHint.tsx
import { useMemo as useMemo9 } from "react";
import { jsx as jsx10, jsxs as jsxs3 } from "react/jsx-runtime";
var cmdOrCtrlCharacter = window.navigator.platform.startsWith("Mac") ? "⌘" : "Ctrl";
var container3 = {
  display: "inline-block",
  marginLeft: 6,
  opacity: 0.6,
  verticalAlign: "middle",
  fontSize: 14
};
var ShortcutHint = ({ keyToPress, cmdOrCtrl }) => {
  const style = useMemo9(() => {
    if (keyToPress === "↵") {
      return {
        display: "inline-block",
        transform: `translateY(2px)`,
        fontSize: 14
      };
    }
    return {};
  }, [keyToPress]);
  if (areKeyboardShortcutsDisabled()) {
    return null;
  }
  return /* @__PURE__ */ jsxs3("span", {
    style: container3,
    children: [
      cmdOrCtrl ? `${cmdOrCtrlCharacter}` : "",
      /* @__PURE__ */ jsx10("span", {
        style,
        children: keyToPress.toUpperCase()
      })
    ]
  });
};

// src/helpers/create-folder-tree.ts
var buildAssetFolderStructure = (files, parentFolderName, foldersExpanded) => {
  const notInFolder = files.filter((f) => !f.name.includes("/"));
  const inFolder = files.filter((f) => f.name.includes("/"));
  const groupedByFolder = {};
  for (const item of inFolder) {
    const folderName = item.name.split("/")[0];
    if (!groupedByFolder[folderName]) {
      groupedByFolder[folderName] = [];
    }
    groupedByFolder[folderName].push(item);
  }
  return {
    files: notInFolder,
    folders: Object.keys(groupedByFolder).map((folderName) => {
      const filesInFolder = groupedByFolder[folderName];
      const filesWithoutFolderName = filesInFolder.map((f) => {
        return {
          ...f,
          name: f.name.substring(folderName.length + 1)
        };
      });
      const key = [parentFolderName, folderName].filter(Boolean).join("/");
      const isExpanded = foldersExpanded[key] ?? false;
      return {
        name: folderName,
        items: buildAssetFolderStructure(filesWithoutFolderName, [parentFolderName, folderName].filter(Boolean).join("/"), foldersExpanded),
        expanded: isExpanded
      };
    })
  };
};
var splitParentIntoNameAndParent = (name) => {
  if (name === null) {
    return {
      name: null,
      parent: null
    };
  }
  const splitted = name.split("/");
  const lastName = splitted[splitted.length - 1];
  const parentParentArray = splitted.slice(0, splitted.length - 1);
  const parentParent = parentParentArray.length === 0 ? null : parentParentArray.join("/");
  return {
    name: lastName,
    parent: parentParent
  };
};
var doesFolderExist = (items, folderName, parentName) => {
  for (const item of items) {
    if (item.type === "folder") {
      if (item.folderName === folderName && item.parentName === parentName) {
        return item.items;
      }
      const found = doesFolderExist(item.items, folderName, parentName);
      if (found !== false) {
        return found;
      }
    }
  }
  return false;
};
var findItemListToPush = (items, folderName, parentName) => {
  if (folderName === null) {
    return items;
  }
  const folder = doesFolderExist(items, folderName, parentName);
  if (!folder) {
    console.log({ items, folderName, parentName });
    throw new Error("did not find folder " + folderName);
  }
  return folder;
};
var createFolderIfDoesNotExist = (items, availableFolders, folderItem, foldersExpanded) => {
  if (doesFolderExist(items, folderItem.name, folderItem.parent)) {
    return;
  }
  const splitted = splitParentIntoNameAndParent(folderItem.parent);
  if (folderItem.parent) {
    const parent = availableFolders.find((f) => f.name === splitted.name && f.parent === splitted.parent);
    if (!parent) {
      throw new Error("unexpectedly did not have parent");
    }
    createFolderIfDoesNotExist(items, availableFolders, parent, foldersExpanded);
  }
  const itemList = findItemListToPush(items, splitted.name, splitted.parent);
  if (!itemList) {
    throw new Error("why did folder not exist? " + folderItem.name);
  }
  itemList.push({
    type: "folder",
    folderName: folderItem.name,
    items: [],
    key: folderItem.name,
    expanded: foldersExpanded[openFolderKey({
      folderName: folderItem.name,
      parentName: folderItem.parent
    })] ?? false,
    parentName: folderItem.parent
  });
};
var createFolderTree = (comps, folders, foldersExpanded) => {
  const items = [];
  const uniqueFolderKeys = [];
  for (const folder of folders) {
    const folderKey = openFolderKey({
      folderName: folder.name,
      parentName: folder.parent
    });
    if (uniqueFolderKeys.includes(folderKey)) {
      if (folder.parent) {
        throw new Error(`Multiple folders with the name ${folder.name} inside the folder ${folder.parent} exist. Folder names must be unique.`);
      }
      throw new Error("Multiple folders with the name " + folder.name + " exist. Folder names must be unique.");
    }
    uniqueFolderKeys.push(folderKey);
    createFolderIfDoesNotExist(items, folders, folder, foldersExpanded);
  }
  for (const item of comps) {
    const toPush = {
      type: "composition",
      composition: item,
      key: item.id
    };
    const list = findItemListToPush(items, item.folderName, item.parentFolderName);
    list.push(toPush);
  }
  return items;
};

// src/helpers/sort-by-nonce-history.ts
var getSharedEpochOrder = (a, b) => {
  const aMap = new Map(a);
  const bMap = new Map(b);
  const allEpochs = [...new Set([...aMap.keys(), ...bMap.keys()])].sort((x, y) => y - x);
  for (const epoch of allEpochs) {
    const aNonce = aMap.get(epoch);
    const bNonce = bMap.get(epoch);
    if (aNonce !== undefined && bNonce !== undefined) {
      return aNonce - bNonce;
    }
  }
  return null;
};
var sortItemsByNonceHistory = (items) => {
  const n = items.length;
  if (n <= 1) {
    return items.slice();
  }
  const order = Array.from({ length: n }, () => Array(n).fill(null));
  for (let i = 0;i < n; i++) {
    for (let j = i + 1;j < n; j++) {
      const cmp = getSharedEpochOrder(items[i].nonce, items[j].nonce);
      order[i][j] = cmp;
      order[j][i] = cmp !== null ? -cmp : null;
    }
  }
  for (let k = 0;k < n; k++) {
    for (let i = 0;i < n; i++) {
      for (let j = 0;j < n; j++) {
        if (order[i][j] === null && order[i][k] !== null && order[k][j] !== null && order[i][k] < 0 && order[k][j] < 0) {
          order[i][j] = -1;
          order[j][i] = 1;
        }
      }
    }
  }
  const indexMap = new Map(items.map((item, i) => [item, i]));
  const result = items.slice();
  result.sort((a, b) => {
    const ai = indexMap.get(a);
    const bi = indexMap.get(b);
    const transitiveOrder = order[ai][bi];
    if (transitiveOrder !== null) {
      return transitiveOrder;
    }
    return a.nonce[a.nonce.length - 1][0] - b.nonce[b.nonce.length - 1][0];
  });
  return result;
};

// src/state/modals.ts
import { createContext as createContext9 } from "react";
var ModalsContext = createContext9({
  selectedModal: null,
  setSelectedModal: () => {
    return;
  }
});

// src/components/CompositionSelectorItem.tsx
import { useCallback as useCallback15, useContext as useContext8, useMemo as useMemo21, useState as useState14 } from "react";

// src/icons/folder.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var CollapsedFolderIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx11("svg", {
    viewBox: "0 0 512 512",
    ...props,
    children: /* @__PURE__ */ jsx11("path", {
      fill: color,
      d: "M447.1 96H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H63.1c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V160C511.1 124.7 483.3 96 447.1 96zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32V416z"
    })
  });
};
var ExpandedFolderIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx11("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx11("path", {
      fill: color,
      d: "M566.6 211.6C557.5 199.1 543.4 192 527.1 192H134.2C114.3 192 96.2 204.5 89.23 223.1L32 375.8V96c0-17.64 14.36-32 32-32h117.5c8.549 0 16.58 3.328 22.63 9.375L258.7 128H448c17.64 0 32 14.36 32 32h32c0-35.35-28.65-64-64-64H272L226.7 50.75C214.7 38.74 198.5 32 181.5 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h403.1c21.11 0 39.53-13.53 45.81-33.69l60-192C578.4 239.6 575.8 224 566.6 211.6zM543.2 244.8l-60 192C481.1 443.5 475 448 467.1 448H64c-3.322 0-6.357-.9551-9.373-1.898c-2.184-1.17-4.109-2.832-5.596-4.977c-3.031-4.375-3.703-9.75-1.828-14.73l72-192C121.5 228.2 127.5 224 134.2 224h393.8c5.141 0 9.844 2.375 12.89 6.516C543.9 234.7 544.8 239.9 543.2 244.8z"
    })
  });
};
var ExpandedFolderIconSolid = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx11("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx11("path", {
      fill: color,
      d: "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
    })
  });
};

// src/icons/still.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var StillIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx12("svg", {
    ...props,
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx12("path", {
      fill: color,
      d: "M144 288C144 226.1 194.1 176 256 176C317.9 176 368 226.1 368 288C368 349.9 317.9 400 256 400C194.1 400 144 349.9 144 288zM256 208C211.8 208 176 243.8 176 288C176 332.2 211.8 368 256 368C300.2 368 336 332.2 336 288C336 243.8 300.2 208 256 208zM362.9 64.82L373.3 96H448C483.3 96 512 124.7 512 160V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V160C0 124.7 28.65 96 64 96H138.7L149.1 64.82C155.6 45.22 173.9 32 194.6 32H317.4C338.1 32 356.4 45.22 362.9 64.82H362.9zM64 128C46.33 128 32 142.3 32 160V416C32 433.7 46.33 448 64 448H448C465.7 448 480 433.7 480 416V160C480 142.3 465.7 128 448 128H350.3L332.6 74.94C330.4 68.41 324.3 64 317.4 64H194.6C187.7 64 181.6 68.41 179.4 74.94L161.7 128H64z"
    })
  });
};

// src/icons/video.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var FilmIcon = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx13("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx13("path", {
      fill: color,
      d: "M448 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V96C512 60.65 483.3 32 448 32zM384 64v176H128V64H384zM32 96c0-17.64 14.36-32 32-32h32v80H32V96zM32 176h64v64H32V176zM32 272h64v64H32V272zM64 448c-17.64 0-32-14.36-32-32v-48h64V448H64zM128 448V272h256V448H128zM480 416c0 17.64-14.36 32-32 32h-32v-80h64V416zM480 336h-64v-64h64V336zM480 240h-64v-64h64V240zM480 144h-64V64h32c17.64 0 32 14.36 32 32V144z"
    })
  });
};

// src/components/CompositionContextButton.tsx
import { useCallback as useCallback12, useContext as useContext6, useMemo as useMemo18 } from "react";

// src/helpers/client-id.tsx
import React13, { useCallback as useCallback6, useEffect as useEffect8, useMemo as useMemo11, useRef as useRef6 } from "react";
import { Internals as Internals4 } from "remotion";

// src/components/Notifications/NotificationCenter.tsx
import {
  createRef as createRef3,
  useCallback as useCallback4,
  useImperativeHandle as useImperativeHandle2,
  useState as useState7
} from "react";

// src/components/Notifications/Notification.tsx
import { useEffect as useEffect6 } from "react";
import { jsx as jsx14 } from "react/jsx-runtime";
var notification = {
  backgroundColor: "#111111",
  color: "white",
  fontFamily: "Arial, Helvetica, sans-serif",
  display: "inline-flex",
  padding: "8px 14px",
  borderRadius: 4,
  fontSize: 15,
  border: "0.25px solid rgba(255, 255, 255, 0.1)",
  boxShadow: "0 2px 3px rgba(0, 0, 0, 1)",
  marginTop: 3,
  marginBottom: 3,
  alignItems: "center"
};
var Notification = ({ children, id, duration, created, onRemove }) => {
  useEffect6(() => {
    if (duration === null) {
      return;
    }
    const timeout = setTimeout(() => {
      onRemove(id);
    }, duration - (Date.now() - created));
    return () => {
      clearTimeout(timeout);
    };
  }, [created, duration, id, onRemove]);
  return /* @__PURE__ */ jsx14("div", {
    className: "css-reset",
    style: notification,
    children
  });
};

// src/components/Notifications/NotificationCenter.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var container4 = {
  position: "absolute",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  paddingTop: 20,
  pointerEvents: "none",
  backgroundColor: "transparent"
};
var notificationCenter = createRef3();
var showNotification = (content, durationInMs) => {
  return notificationCenter.current.addNotification({
    content,
    duration: durationInMs,
    created: Date.now(),
    id: String(Math.random()).replace("0.", "")
  });
};
var NotificationCenter = () => {
  const [notifications, setNotifications] = useState7([]);
  const onRemove = useCallback4((id) => {
    setNotifications((not) => {
      return not.filter((n) => n.id !== id);
    });
  }, []);
  const addNotification = useCallback4((notification2) => {
    setNotifications((previousNotifications) => {
      return [...previousNotifications, notification2];
    });
    return {
      replaceContent: (newContent, durationInMs) => {
        setNotifications((oldNotifications) => {
          return oldNotifications.map((notificationToMap) => {
            if (notificationToMap.id === notification2.id) {
              return {
                ...notificationToMap,
                duration: durationInMs,
                content: newContent,
                created: Date.now()
              };
            }
            return notificationToMap;
          });
        });
      }
    };
  }, []);
  useImperativeHandle2(notificationCenter, () => {
    return {
      addNotification
    };
  }, [addNotification]);
  return /* @__PURE__ */ jsx15("div", {
    style: container4,
    children: notifications.map((n) => {
      return /* @__PURE__ */ jsx15(Notification, {
        created: n.created,
        duration: n.duration,
        id: n.id,
        onRemove,
        children: n.content
      }, n.id);
    })
  });
};

// src/components/PlayBeepSound.tsx
var beeped = {};
var playBeepSound = async (renderId) => {
  if (beeped[renderId]) {
    return;
  }
  beeped[renderId] = true;
  const beepAudio = new Audio("/beep.wav");
  try {
    await beepAudio.play();
  } catch (error) {
    console.error("Error playing beep sound:", error);
    throw error;
  }
};
var PlayBeepSound_default = playBeepSound;

// src/components/RenderQueue/context.tsx
import React12, {
  createRef as createRef4,
  useCallback as useCallback5,
  useEffect as useEffect7,
  useImperativeHandle as useImperativeHandle3,
  useMemo as useMemo10,
  useRef as useRef5,
  useState as useState8
} from "react";

// src/components/RenderQueue/client-render-queue.ts
var compositionRegistry = new Map;
var registerCompositionForJob = (jobId, compositionRef) => {
  compositionRegistry.set(jobId, compositionRef);
};
var getCompositionForJob = (jobId) => {
  return compositionRegistry.get(jobId);
};
var cleanupCompositionForJob = (jobId) => {
  compositionRegistry.delete(jobId);
};
var generateJobId = () => {
  return `client-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
};
var clientJobAbortControllers = new Map;
var getAbortController = (jobId) => {
  let controller = clientJobAbortControllers.get(jobId);
  if (!controller) {
    controller = new AbortController;
    clientJobAbortControllers.set(jobId, controller);
  }
  return controller;
};
var deleteAbortController = (jobId) => {
  clientJobAbortControllers.delete(jobId);
};
var cancelAbortController = (jobId) => {
  const controller = clientJobAbortControllers.get(jobId);
  if (controller) {
    controller.abort();
  }
};

// src/components/RenderQueue/context.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var restorePersistedClientRenders = () => {
  const persisted = window.remotion_initialClientRenders ?? [];
  return persisted.map((r) => ({ ...r, status: "done" }));
};
var isClientRenderJob = (job) => {
  return job.type === "client-still" || job.type === "client-video";
};
var noopString = () => "";
var noop2 = () => {
  return;
};
var RenderQueueContext = React12.createContext({
  jobs: [],
  serverJobs: [],
  clientJobs: [],
  addClientStillJob: noopString,
  addClientVideoJob: noopString,
  updateClientJobProgress: noop2,
  markClientJobSaving: noop2,
  markClientJobDone: noop2,
  markClientJobFailed: noop2,
  markClientJobCancelled: noop2,
  removeClientJob: noop2,
  cancelClientJob: noop2,
  setProcessJobCallback: noop2,
  getAbortController: () => new AbortController,
  getCompositionForJob: () => {
    return;
  }
});
var renderJobsRef = createRef4();
var RenderQueueContextProvider = ({ children }) => {
  const [serverJobs, setServerJobs] = useState8(window.remotion_initialRenderQueue ?? []);
  const [clientJobs, setClientJobs] = useState8(restorePersistedClientRenders);
  const [currentlyProcessing, setCurrentlyProcessing] = useState8(null);
  const processJobCallbackRef = useRef5(null);
  useEffect7(() => {
    if (currentlyProcessing) {
      return;
    }
    const nextJob = clientJobs.find((job) => job.status === "idle");
    if (!nextJob || !processJobCallbackRef.current) {
      return;
    }
    setCurrentlyProcessing(nextJob.id);
    setClientJobs((prev) => prev.map((job) => job.id === nextJob.id ? {
      ...job,
      status: "running",
      progress: {
        encodedFrames: 0,
        totalFrames: 0,
        doneIn: null,
        renderEstimatedTime: 0,
        progress: 0
      }
    } : job));
    processJobCallbackRef.current(nextJob);
  }, [clientJobs, currentlyProcessing]);
  const addClientStillJob = useCallback5((params, compositionRef) => {
    const id = generateJobId();
    registerCompositionForJob(id, compositionRef);
    const newJob = {
      ...params,
      id,
      startedAt: Date.now(),
      status: "idle"
    };
    setClientJobs((prev) => [...prev, newJob]);
    return id;
  }, []);
  const addClientVideoJob = useCallback5((params, compositionRef) => {
    const id = generateJobId();
    registerCompositionForJob(id, compositionRef);
    const newJob = {
      ...params,
      id,
      startedAt: Date.now(),
      status: "idle"
    };
    setClientJobs((prev) => [...prev, newJob]);
    return id;
  }, []);
  const updateClientJobProgress = useCallback5((jobId, progress) => {
    setClientJobs((prev) => prev.map((job) => job.id === jobId ? { ...job, status: "running", progress } : job));
  }, []);
  const markClientJobSaving = useCallback5((jobId) => {
    setClientJobs((prev) => prev.map((job) => job.id === jobId ? { ...job, status: "saving" } : job));
  }, []);
  const markClientJobDone = useCallback5((jobId, metadata, getBlob) => {
    deleteAbortController(jobId);
    cleanupCompositionForJob(jobId);
    setClientJobs((prev) => prev.map((job) => job.id === jobId ? { ...job, status: "done", metadata, getBlob } : job));
    setCurrentlyProcessing(null);
  }, []);
  const markClientJobFailed = useCallback5((jobId, error) => {
    deleteAbortController(jobId);
    cleanupCompositionForJob(jobId);
    setClientJobs((prev) => prev.map((job) => job.id === jobId ? {
      ...job,
      status: "failed",
      error: { message: error.message, stack: error.stack }
    } : job));
    setCurrentlyProcessing(null);
  }, []);
  const markClientJobCancelled = useCallback5((jobId) => {
    deleteAbortController(jobId);
    cleanupCompositionForJob(jobId);
    setClientJobs((prev) => prev.map((job) => job.id === jobId ? {
      ...job,
      status: "cancelled"
    } : job));
    setCurrentlyProcessing(null);
  }, []);
  const removeClientJob = useCallback5((jobId) => {
    setClientJobs((prev) => {
      const jobToRemove = prev.find((j) => j.id === jobId);
      if (jobToRemove?.status === "running") {
        return prev;
      }
      deleteAbortController(jobId);
      cleanupCompositionForJob(jobId);
      return prev.filter((job) => job.id !== jobId);
    });
  }, []);
  const cancelClientJob = useCallback5((jobId) => {
    cancelAbortController(jobId);
  }, []);
  const setProcessJobCallback = useCallback5((callback) => {
    processJobCallbackRef.current = callback;
  }, []);
  useImperativeHandle3(renderJobsRef, () => ({
    updateRenderJobs: (newJobs) => {
      setServerJobs(newJobs);
    },
    updateClientRenders: (renders) => {
      setClientJobs((prev) => {
        const existingIds = new Set(prev.map((j) => j.id));
        const updatedPrev = prev.map((job) => {
          const updated = renders.find((r) => r.id === job.id);
          if (updated && job.status === "done") {
            return {
              ...job,
              deletedOutputLocation: updated.deletedOutputLocation,
              metadata: updated.metadata
            };
          }
          return job;
        });
        const newJobs = renders.filter((r) => !existingIds.has(r.id)).map((r) => ({ ...r, status: "done" }));
        return [...updatedPrev, ...newJobs];
      });
    }
  }), []);
  const value = useMemo10(() => {
    return {
      jobs: [...serverJobs, ...clientJobs].sort((a, b) => a.startedAt - b.startedAt),
      serverJobs,
      clientJobs,
      addClientStillJob,
      addClientVideoJob,
      updateClientJobProgress,
      markClientJobSaving,
      markClientJobDone,
      markClientJobFailed,
      markClientJobCancelled,
      removeClientJob,
      cancelClientJob,
      setProcessJobCallback,
      getAbortController,
      getCompositionForJob
    };
  }, [
    serverJobs,
    clientJobs,
    addClientStillJob,
    addClientVideoJob,
    updateClientJobProgress,
    markClientJobSaving,
    markClientJobDone,
    markClientJobFailed,
    markClientJobCancelled,
    removeClientJob,
    cancelClientJob,
    setProcessJobCallback
  ]);
  return /* @__PURE__ */ jsx16(RenderQueueContext.Provider, {
    value,
    children
  });
};

// src/helpers/client-id.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var StudioServerConnectionCtx = React13.createContext({
  previewServerState: {
    type: "init"
  },
  subscribeToEvent: () => {
    throw new Error("Context not initalized");
  }
});
var PreviewServerConnection = ({ children, readOnlyStudio }) => {
  const listeners = useRef6([]);
  const subscribeToEvent = useCallback6((type, listener) => {
    listeners.current.push({ type, listener });
    return () => {
      listeners.current = listeners.current.filter((l) => l.type !== type || l.listener !== listener);
    };
  }, []);
  const openEventSource = useCallback6(() => {
    const source = new EventSource("/events");
    source.addEventListener("message", (event) => {
      const newEvent = JSON.parse(event.data);
      if (newEvent.type === "new-input-props" || newEvent.type === "new-env-variables") {
        reloadUrl();
      }
      if (newEvent.type === "init") {
        setState({
          type: "connected",
          clientId: newEvent.clientId
        });
      }
      if (newEvent.type === "render-queue-updated") {
        renderJobsRef.current?.updateRenderJobs(newEvent.queue);
        for (const job of newEvent.queue) {
          if (job.status === "done" && job.beepOnFinish) {
            PlayBeepSound_default(job.id);
          }
        }
      }
      if (newEvent.type === "client-renders-updated") {
        renderJobsRef.current?.updateClientRenders(newEvent.renders);
      }
      if (newEvent.type === "render-job-failed") {
        showNotification(`Rendering "${newEvent.compositionId}" failed`, 2000);
      }
      if (newEvent.type === "new-public-folder") {
        const payload = {
          files: newEvent.files
        };
        window.remotion_staticFiles = newEvent.files;
        window.remotion_publicFolderExists = newEvent.folderExists;
        window.dispatchEvent(new CustomEvent(Internals4.WATCH_REMOTION_STATIC_FILES, {
          detail: payload
        }));
      }
      listeners.current.forEach((l) => {
        if (l.type === newEvent.type) {
          l.listener(newEvent);
        }
      });
    });
    source.addEventListener("open", () => {
      source.addEventListener("error", () => {
        setState({ type: "disconnected" });
        source?.close();
        setTimeout(() => {
          openEventSource();
        }, 1000);
      }, { once: true });
    });
    const close = () => {
      source.close();
    };
    return {
      close
    };
  }, []);
  useEffect8(() => {
    if (readOnlyStudio) {
      return;
    }
    const { close } = openEventSource();
    return () => {
      close();
    };
  }, [openEventSource, readOnlyStudio]);
  const [state, setState] = React13.useState({
    type: "init"
  });
  const context = useMemo11(() => {
    return {
      previewServerState: state,
      subscribeToEvent
    };
  }, [state, subscribeToEvent]);
  return /* @__PURE__ */ jsx17(StudioServerConnectionCtx.Provider, {
    value: context,
    children
  });
};

// src/icons/ellipsis.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var EllipsisIcon = (props) => {
  return /* @__PURE__ */ jsx18("svg", {
    ...props.svgProps,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx18("path", {
      fill: props.fill,
      d: "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    })
  });
};

// src/components/InlineDropdown.tsx
import { PlayerInternals as PlayerInternals3 } from "@remotion/player";
import { useCallback as useCallback11, useMemo as useMemo17, useRef as useRef9, useState as useState12 } from "react";
import ReactDOM2 from "react-dom";

// src/components/InlineAction.tsx
import { useCallback as useCallback7, useMemo as useMemo12, useState as useState9 } from "react";
import { jsx as jsx19 } from "react/jsx-runtime";
var InlineAction = ({
  renderAction,
  onClick,
  disabled,
  title
}) => {
  const { tabIndex } = useZIndex();
  const [hovered, setHovered] = useState9(false);
  const onPointerEnter = useCallback7(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback7(() => {
    setHovered(false);
  }, []);
  const style = useMemo12(() => {
    return {
      border: "none",
      background: disabled ? "transparent" : getBackgroundFromHoverState({ hovered, selected: false }),
      height: 24,
      width: 24,
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 3,
      pointerEvents: disabled ? "none" : "auto"
    };
  }, [disabled, hovered]);
  return /* @__PURE__ */ jsx19("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    onClick,
    style,
    tabIndex,
    title,
    children: renderAction(hovered ? "white" : LIGHT_TEXT)
  });
};

// src/components/Menu/portals.ts
var portals = [
  document.getElementById("menuportal-0"),
  document.getElementById("menuportal-1"),
  document.getElementById("menuportal-2"),
  document.getElementById("menuportal-3"),
  document.getElementById("menuportal-4"),
  document.getElementById("menuportal-5")
];
var getPortal = (i) => {
  return portals[i];
};

// src/components/Menu/styles.ts
var MENU_VERTICAL_PADDING = 4;
var SUBMENU_LEFT_INSET = -8;
var MAX_MENU_WIDTH = 400;
var MAX_MOBILE_MENU_WIDTH = 300;
var menuContainer = {
  backgroundColor: BACKGROUND,
  position: "fixed",
  color: "white",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var SHADOW_TOWARDS_BOTTOM = "0 2px 8px rgba(0, 0, 0, 0.5)";
var SHADOW_TOWARDS_TOP = "0 -2px 8px rgba(0, 0, 0, 0.5)";
var menuContainerTowardsBottom = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_BOTTOM
};
var menuContainerTowardsTop = {
  ...menuContainer,
  boxShadow: SHADOW_TOWARDS_TOP
};
var fullScreenOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
var outerPortal = {
  position: "fixed"
};
var inlineCodeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};

// src/components/NewComposition/MenuContent.tsx
import { useCallback as useCallback10, useEffect as useEffect10, useMemo as useMemo16, useRef as useRef8, useState as useState11 } from "react";

// src/components/Menu/is-menu-item.tsx
var MENU_INITIATOR_CLASSNAME = "__remotion-studio-menu-initiator";
var MENU_ITEM_CLASSNAME = "__remotion-studio-menu-item";
var HORIZONTAL_SCROLLBAR_CLASSNAME = "__remotion-horizontal-scrollbar";
var VERTICAL_SCROLLBAR_CLASSNAME = "__remotion-vertical-scrollbar";
var isMenuItem = (el) => {
  return Boolean(el.classList.contains(MENU_ITEM_CLASSNAME) || el.closest(`.${MENU_ITEM_CLASSNAME}`) || el.classList.contains(MENU_INITIATOR_CLASSNAME) || el.closest(`.${MENU_INITIATOR_CLASSNAME}`));
};

// src/components/Menu/MenuDivider.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var menuDivider = {
  marginTop: 4,
  marginBottom: 4,
  height: 1,
  backgroundColor: INPUT_BORDER_COLOR_HOVERED
};
var MenuDivider = () => {
  return /* @__PURE__ */ jsx20("div", {
    style: menuDivider
  });
};

// src/components/Menu/MenuSubItem.tsx
import { PlayerInternals as PlayerInternals2 } from "@remotion/player";
import { useCallback as useCallback9, useEffect as useEffect9, useMemo as useMemo15, useRef as useRef7, useState as useState10 } from "react";
import ReactDOM from "react-dom";

// src/icons/caret.tsx
import { useMemo as useMemo13 } from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var caret = {
  height: 12
};
var caretDown = {
  width: 10
};
var angleDown = {
  width: 10
};
var CaretRight = () => /* @__PURE__ */ jsx21("svg", {
  viewBox: "0 0 192 512",
  style: caret,
  children: /* @__PURE__ */ jsx21("path", {
    fill: "currentColor",
    d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
  })
});
var CaretDown = () => {
  return /* @__PURE__ */ jsx21("svg", {
    viewBox: "0 0 320 512",
    style: caretDown,
    children: /* @__PURE__ */ jsx21("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};
var AngleDown = ({ down }) => {
  const style = useMemo13(() => {
    return {
      ...angleDown,
      transform: down ? "rotate(180deg)" : "rotate(0deg)",
      marginTop: 1
    };
  }, [down]);
  return /* @__PURE__ */ jsx21("svg", {
    style,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx21("path", {
      fill: LIGHT_TEXT,
      d: "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    })
  });
};

// src/components/layout.tsx
import { useMemo as useMemo14 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var SPACING_UNIT = 8;
var Spacing = ({ x = 0, y = 0, block = false }) => {
  const style = useMemo14(() => {
    return {
      display: block ? "block" : "inline-block",
      width: x * SPACING_UNIT,
      height: y * SPACING_UNIT,
      flexShrink: 0
    };
  }, [block, x, y]);
  return /* @__PURE__ */ jsx22("div", {
    style
  });
};
var flexCss = { flex: 1 };
var Flex = ({ children }) => /* @__PURE__ */ jsx22("div", {
  style: flexCss,
  children
});
var Row = ({ children, justify, className, align, flex, style = {}, ...other }) => {
  const finalStyle = useMemo14(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "row",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start",
      flex: flex ?? undefined
    };
  }, [align, flex, justify, style]);
  return /* @__PURE__ */ jsx22("div", {
    className,
    style: finalStyle,
    ...other,
    children
  });
};
var Column = ({ children, justify, className, align, style = {} }) => {
  const finalStyle = useMemo14(() => {
    return {
      ...style,
      display: "flex",
      flexDirection: "column",
      justifyContent: justify ?? "flex-start",
      alignItems: align ?? "flex-start"
    };
  }, [align, justify, style]);
  return /* @__PURE__ */ jsx22("div", {
    className,
    style: finalStyle,
    children
  });
};

// src/components/Menu/SubMenu.tsx
import { useCallback as useCallback8 } from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var SubMenuComponent = ({
  portalStyle,
  subMenuActivated,
  subMenu,
  onQuitFullMenu,
  onQuitSubMenu
}) => {
  const mobileLayout = useMobileLayout();
  const onOutsideClick = useCallback8((e) => {
    if (portals.find((p) => p.contains(e)) || mobileLayout) {
      onQuitSubMenu();
    } else {
      onQuitFullMenu();
    }
  }, [mobileLayout, onQuitFullMenu, onQuitSubMenu]);
  return /* @__PURE__ */ jsx23(HigherZIndex, {
    onEscape: onQuitFullMenu,
    onOutsideClick,
    children: /* @__PURE__ */ jsx23("div", {
      style: portalStyle,
      className: "css-reset",
      children: /* @__PURE__ */ jsx23(MenuContent, {
        onNextMenu: noop,
        onPreviousMenu: onQuitSubMenu,
        values: subMenu.items,
        onHide: onQuitFullMenu,
        leaveLeftSpace: subMenu.leaveLeftSpace,
        preselectIndex: subMenuActivated === "without-mouse" && typeof subMenu.preselectIndex === "number" ? subMenu.preselectIndex : false,
        topItemCanBeUnselected: false,
        fixedHeight: null
      })
    })
  });
};

// src/components/Menu/MenuSubItem.tsx
import { jsx as jsx24, jsxs as jsxs4, Fragment } from "react/jsx-runtime";
var container5 = {
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 8,
  cursor: "default"
};
var labelStyle = {
  fontSize: 13,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1
};
var keyHintCss = {
  flexDirection: "row",
  color: LIGHT_TEXT,
  fontSize: 13
};
var leftSpace = {
  width: 24,
  marginLeft: -6,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var MenuSubItem = ({
  label,
  leaveLeftSpace,
  leftItem,
  onActionChosen,
  id,
  selected,
  onItemSelected,
  keyHint,
  subMenu,
  onQuitMenu,
  subMenuActivated,
  setSubMenuActivated,
  disabled
}) => {
  const [hovered, setHovered] = useState10(false);
  const ref = useRef7(null);
  const size = PlayerInternals2.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const mobileLayout = useMobileLayout();
  const { currentZIndex } = useZIndex();
  const style = useMemo15(() => {
    return {
      ...container5,
      backgroundColor: selected && !disabled ? CLEAR_HOVER : "transparent",
      opacity: disabled ? 0.5 : 1,
      cursor: disabled ? "not-allowed" : "default"
    };
  }, [selected, disabled]);
  const onPointerUp = useCallback9((e) => {
    if (disabled) {
      return;
    }
    if (subMenu) {
      setSubMenuActivated("with-mouse");
      setHovered(true);
      return;
    }
    onActionChosen(id, e);
  }, [disabled, id, onActionChosen, setSubMenuActivated, subMenu]);
  const onPointerEnter = useCallback9(() => {
    if (disabled) {
      return;
    }
    onItemSelected(id);
    setHovered(true);
  }, [disabled, id, onItemSelected]);
  const onPointerLeave = useCallback9(() => {
    setHovered(false);
  }, []);
  const onQuitSubmenu = useCallback9(() => {
    setSubMenuActivated(false);
  }, [setSubMenuActivated]);
  const portalStyle = useMemo15(() => {
    if (!selected || !size || !subMenu || !subMenuActivated) {
      return null;
    }
    const left = size.left + size.width + SUBMENU_LEFT_INSET;
    return {
      ...menuContainerTowardsBottom,
      left: mobileLayout ? left * 0.7 : left,
      top: size.top - MENU_VERTICAL_PADDING
    };
  }, [mobileLayout, selected, size, subMenu, subMenuActivated]);
  useEffect9(() => {
    if (!hovered || !subMenu) {
      return;
    }
    const hi = setTimeout(() => {
      setSubMenuActivated("with-mouse");
    }, 100);
    return () => clearTimeout(hi);
  }, [hovered, selected, setSubMenuActivated, subMenu]);
  useEffect9(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest"
      });
    }
  }, [selected]);
  return /* @__PURE__ */ jsx24("div", {
    ref,
    onPointerEnter,
    onPointerLeave,
    style,
    onPointerUp,
    role: "button",
    className: MENU_ITEM_CLASSNAME,
    children: /* @__PURE__ */ jsxs4(Row, {
      align: "center",
      children: [
        leaveLeftSpace ? /* @__PURE__ */ jsxs4(Fragment, {
          children: [
            /* @__PURE__ */ jsx24("div", {
              style: leftSpace,
              children: leftItem
            }),
            /* @__PURE__ */ jsx24(Spacing, {
              x: 1
            })
          ]
        }) : null,
        /* @__PURE__ */ jsx24("div", {
          style: labelStyle,
          ...{ title: typeof label === "string" ? label : undefined },
          children: label
        }),
        " ",
        /* @__PURE__ */ jsx24(Spacing, {
          x: 2
        }),
        subMenu ? /* @__PURE__ */ jsx24(CaretRight, {}) : null,
        keyHint && !areKeyboardShortcutsDisabled() ? /* @__PURE__ */ jsx24("span", {
          style: keyHintCss,
          children: keyHint
        }) : null,
        portalStyle && subMenu ? ReactDOM.createPortal(/* @__PURE__ */ jsx24(SubMenuComponent, {
          onQuitFullMenu: onQuitMenu,
          subMenu,
          onQuitSubMenu: onQuitSubmenu,
          portalStyle,
          subMenuActivated
        }), getPortal(currentZIndex)) : null
      ]
    })
  });
};

// src/components/NewComposition/MenuContent.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var BORDER_SIZE = 1;
var container6 = {
  paddingTop: MENU_VERTICAL_PADDING,
  paddingBottom: MENU_VERTICAL_PADDING,
  border: `${BORDER_SIZE}px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginLeft: 0 - BORDER_SIZE,
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: 200,
  maxWidth: MAX_MENU_WIDTH
};
var MenuContent = ({
  onHide,
  values,
  preselectIndex,
  onNextMenu,
  onPreviousMenu,
  leaveLeftSpace,
  topItemCanBeUnselected,
  fixedHeight
}) => {
  const keybindings = useKeybinding();
  const containerRef = useRef8(null);
  const isMobileLayout = useMobileLayout();
  const [subMenuActivated, setSubMenuActivated] = useState11(false);
  if (values[0].type === "divider") {
    throw new Error("first value cant be divide");
  }
  const [selectedItem, setSelectedItem] = useState11(typeof preselectIndex === "number" && preselectIndex >= 0 ? values[preselectIndex].id : null);
  const onEscape = useCallback10(() => {
    onHide();
  }, [onHide]);
  const onItemSelected = useCallback10((id) => {
    setSelectedItem(id);
  }, []);
  const isItemSelectable = useCallback10((v) => {
    return v.type !== "divider" && !v.disabled;
  }, []);
  const onArrowUp = useCallback10(() => {
    setSelectedItem((prevItem) => {
      if (prevItem === null) {
        return null;
      }
      const index = values.findIndex((val) => val.id === prevItem);
      if (topItemCanBeUnselected && index === 0 || prevItem === null) {
        return null;
      }
      const previousItems = values.filter((v, i) => i < index && isItemSelectable(v));
      if (previousItems.length > 0) {
        return previousItems[previousItems.length - 1].id;
      }
      const firstSelectable = values.find((v) => isItemSelectable(v));
      if (firstSelectable) {
        return firstSelectable.id;
      }
      throw new Error("could not find previous item");
    });
  }, [topItemCanBeUnselected, values, isItemSelectable]);
  const onArrowDown = useCallback10(() => {
    setSelectedItem((prevItem) => {
      const index = values.findIndex((val) => val.id === prevItem);
      const nextItem = values.find((v, i) => i > index && isItemSelectable(v));
      if (nextItem) {
        return nextItem.id;
      }
      const lastSelectable = values.slice().reverse().find((v) => isItemSelectable(v));
      if (lastSelectable) {
        return lastSelectable.id;
      }
      throw new Error("could not find next item");
    });
  }, [values, isItemSelectable]);
  const onEnter = useCallback10(() => {
    if (selectedItem === null) {
      return onHide();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (item.disabled) {
      return;
    }
    if (item.subMenu) {
      return setSubMenuActivated("without-mouse");
    }
    onHide();
    item.onClick(item.id, null);
  }, [onHide, selectedItem, values]);
  const onArrowRight = useCallback10(() => {
    if (selectedItem === null) {
      return onNextMenu();
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      throw new Error("cannot find item");
    }
    if (item.type === "divider") {
      throw new Error("cannot find divider");
    }
    if (!item.subMenu) {
      return onNextMenu();
    }
    setSubMenuActivated("without-mouse");
  }, [onNextMenu, selectedItem, values]);
  const containerWithHeight = useMemo16(() => {
    const containerStyles = { ...container6 };
    if (fixedHeight === null) {
      containerStyles.maxHeight = 600;
    } else {
      containerStyles.maxHeight = fixedHeight;
    }
    if (isMobileLayout) {
      containerStyles.maxWidth = MAX_MOBILE_MENU_WIDTH;
    }
    return containerStyles;
  }, [fixedHeight, isMobileLayout]);
  useEffect10(() => {
    const escapeBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const rightBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      commandCtrlKey: false,
      callback: onArrowRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const leftBinding = keybindings.registerKeybinding({
      event: "keydown",
      commandCtrlKey: false,
      key: "ArrowLeft",
      callback: onPreviousMenu,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const downBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowDown",
      commandCtrlKey: false,
      callback: onArrowDown,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const upBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enterBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "Enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const spaceBinding = keybindings.registerKeybinding({
      event: "keyup",
      key: " ",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escapeBinding.unregister();
      leftBinding.unregister();
      rightBinding.unregister();
      downBinding.unregister();
      upBinding.unregister();
      enterBinding.unregister();
      spaceBinding.unregister();
    };
  }, [
    keybindings,
    onEscape,
    onNextMenu,
    onPreviousMenu,
    onArrowDown,
    onArrowUp,
    onEnter,
    onArrowRight
  ]);
  useEffect10(() => {
    if (!subMenuActivated) {
      return;
    }
    if (selectedItem === null) {
      return setSubMenuActivated(false);
    }
    const item = values.find((i) => i.id === selectedItem);
    if (!item) {
      return;
    }
    if (item.type === "divider") {
      throw new Error("should not select divider");
    }
    if (!item.subMenu && subMenuActivated) {
      setSubMenuActivated(false);
    }
  }, [selectedItem, subMenuActivated, values]);
  useEffect10(() => {
    const { current } = containerRef;
    if (!current) {
      return;
    }
    const onPointerLeave = () => {
      if (subMenuActivated) {
        return;
      }
      setSelectedItem(null);
    };
    current.addEventListener("pointerleave", onPointerLeave);
    return () => current.removeEventListener("pointerleave", onPointerLeave);
  }, [onHide, subMenuActivated]);
  return /* @__PURE__ */ jsx25("div", {
    ref: containerRef,
    style: containerWithHeight,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: values.map((item) => {
      if (item.type === "divider") {
        return /* @__PURE__ */ jsx25(MenuDivider, {}, item.id);
      }
      const onClick = (id, e) => {
        item.onClick(id, e);
        if (item.subMenu) {
          return null;
        }
        onHide();
      };
      return /* @__PURE__ */ jsx25(MenuSubItem, {
        selected: item.id === selectedItem,
        onActionChosen: onClick,
        onItemSelected,
        label: item.label,
        id: item.id,
        keyHint: item.keyHint,
        leaveLeftSpace,
        leftItem: item.leftItem,
        subMenu: item.subMenu,
        onQuitMenu: onHide,
        onNextMenu,
        subMenuActivated,
        setSubMenuActivated,
        disabled: item.disabled
      }, item.id);
    })
  });
};

// src/components/InlineDropdown.tsx
import { jsx as jsx26, jsxs as jsxs5, Fragment as Fragment2 } from "react/jsx-runtime";
var InlineDropdown = ({
  values,
  ...props
}) => {
  const ref = useRef9(null);
  const [opened, setOpened] = useState12({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const size = PlayerInternals3.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  const onClick = useCallback11((e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpened({ type: "open", left: e.clientX, top: e.clientY });
  }, []);
  const spaceToBottom = useMemo17(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo17(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo17(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback11(() => {
    setOpened({ type: "not-open" });
  }, []);
  return /* @__PURE__ */ jsxs5(Fragment2, {
    children: [
      /* @__PURE__ */ jsx26("div", {
        ref,
        children: /* @__PURE__ */ jsx26(InlineAction, {
          onClick,
          ...props
        })
      }),
      portalStyle ? ReactDOM2.createPortal(/* @__PURE__ */ jsx26("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx26("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx26(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx26("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx26(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/CompositionContextButton.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var CompositionContextButton = ({ visible, values }) => {
  const iconStyle = useMemo18(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext6(StudioServerConnectionCtx).previewServerState.type;
  const renderAction = useCallback12((color) => {
    return /* @__PURE__ */ jsx27(EllipsisIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return /* @__PURE__ */ jsx27(InlineDropdown, {
    renderAction,
    values
  });
};

// src/components/ContextMenu.tsx
import { PlayerInternals as PlayerInternals4 } from "@remotion/player";
import { useCallback as useCallback13, useEffect as useEffect11, useMemo as useMemo19, useRef as useRef10, useState as useState13 } from "react";
import ReactDOM3 from "react-dom";
import { jsx as jsx28, jsxs as jsxs6, Fragment as Fragment3 } from "react/jsx-runtime";
var ContextMenu = ({ children, values }) => {
  const ref = useRef10(null);
  const [opened, setOpened] = useState13({ type: "not-open" });
  const { currentZIndex } = useZIndex();
  const style = useMemo19(() => {
    return {};
  }, []);
  const size = PlayerInternals4.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const isMobileLayout = useMobileLayout();
  useEffect11(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpened({ type: "open", left: e.clientX, top: e.clientY });
      return false;
    };
    current.addEventListener("contextmenu", onClick);
    return () => {
      current.removeEventListener("contextmenu", onClick);
    };
  }, [size]);
  const spaceToBottom = useMemo19(() => {
    if (size && opened.type === "open") {
      return size.windowSize.height - opened.top;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo19(() => {
    if (size && opened.type === "open") {
      return opened.top;
    }
    return 0;
  }, [opened, size]);
  const portalStyle = useMemo19(() => {
    if (opened.type === "not-open") {
      return;
    }
    if (!size) {
      return;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...menuContainerTowardsTop,
      ...verticalLayout === "top" ? {
        top: opened.top
      } : {
        bottom: size.windowSize.height - opened.top
      },
      ...horizontalLayout === "left" ? {
        left: opened.left
      } : {
        right: canOpenOnLeft ? size.windowSize.width - opened.left : 0
      }
    };
  }, [opened, size, isMobileLayout, spaceToTop, spaceToBottom]);
  const onHide = useCallback13(() => {
    setOpened({ type: "not-open" });
  }, []);
  return /* @__PURE__ */ jsxs6(Fragment3, {
    children: [
      /* @__PURE__ */ jsx28("div", {
        ref,
        onContextMenu: () => false,
        style,
        children
      }),
      portalStyle ? ReactDOM3.createPortal(/* @__PURE__ */ jsx28("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx28("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx28(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx28("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx28(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: false,
                topItemCanBeUnselected: false,
                fixedHeight: null
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/SidebarRenderButton.tsx
import { useCallback as useCallback14, useContext as useContext7, useMemo as useMemo20 } from "react";
import { Internals as Internals5 } from "remotion";

// src/icons/render.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var ThinRenderIcon = (props) => {
  return /* @__PURE__ */ jsx29("svg", {
    ...props.svgProps,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx29("path", {
      fill: props.fill,
      d: "M188.9 372l-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187C304.6 30.1 409 24.6 475.7 36.3c11.7 66.7 6.2 171.1-98.4 242c-49.4 33.5-145.5 75.6-188.4 93.7zm-79.9-62.8c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6 .7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2V312.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-90.2 0c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8 .7 15.6s8.1 7.6 13.6 7.6H118.5c-3.6 8-6.8 15.2-9.4 21.2zM256 470.1l0-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
    })
  });
};

// src/components/SidebarRenderButton.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var SidebarRenderButton = ({ composition, visible }) => {
  const { setSelectedModal } = useContext7(ModalsContext);
  const { setSidebarCollapsedState } = useContext7(SidebarContext);
  const isMobileLayout = useMobileLayout();
  const iconStyle = useMemo20(() => {
    return {
      style: {
        height: 12
      }
    };
  }, []);
  const connectionStatus = useContext7(StudioServerConnectionCtx).previewServerState.type;
  const { props } = useContext7(Internals5.EditorPropsContext);
  const onClick = useCallback14((e) => {
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new Error("expected defaults");
    }
    e.stopPropagation();
    setSelectedModal({
      type: "server-render",
      compositionId: composition.id,
      initialFrame: 0,
      initialVideoImageFormat: defaults.videoImageFormat,
      initialStillImageFormat: defaults.stillImageFormat,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: defaults.scale,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: null,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: defaults.offthreadVideoThreads,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      defaultProps: props[composition.id] ?? composition.defaultProps,
      inFrameMark: null,
      outFrameMark: null,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null,
      defaulMetadata: defaults.metadata,
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: defaults.chromeMode,
      initialMediaCacheSizeInBytes: defaults.mediaCacheSizeInBytes,
      renderDefaults: defaults,
      initialDarkMode: defaults.darkMode,
      readOnlyStudio: false
    });
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    composition.defaultProps,
    composition.id,
    isMobileLayout,
    props,
    setSelectedModal,
    setSidebarCollapsedState
  ]);
  const renderAction = useCallback14((color) => {
    return /* @__PURE__ */ jsx30(ThinRenderIcon, {
      fill: color,
      svgProps: iconStyle
    });
  }, [iconStyle]);
  if (!visible || connectionStatus !== "connected") {
    return null;
  }
  return /* @__PURE__ */ jsx30(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/CompositionSelectorItem.tsx
import { jsx as jsx31, jsxs as jsxs7, Fragment as Fragment4 } from "react/jsx-runtime";
var COMPOSITION_ITEM_HEIGHT = 32;
var itemStyle = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: COMPOSITION_ITEM_HEIGHT,
  userSelect: "none"
};
var labelStyle2 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: 1,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var iconStyle = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var CompositionSelectorItem = ({
  item,
  level,
  currentComposition,
  tabIndex,
  selectComposition,
  toggleFolder
}) => {
  const selected = useMemo21(() => {
    if (item.type === "composition") {
      return currentComposition === item.composition.id;
    }
    return false;
  }, [item, currentComposition]);
  const [hovered, setHovered] = useState14(false);
  const onPointerEnter = useCallback15(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback15(() => {
    setHovered(false);
  }, []);
  const style = useMemo21(() => {
    return {
      ...itemStyle,
      backgroundColor: getBackgroundFromHoverState({ hovered, selected }),
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo21(() => {
    return {
      ...labelStyle2,
      color: selected || hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const onClick = useCallback15((evt) => {
    evt.preventDefault();
    if (item.type === "composition") {
      selectComposition(item.composition, true);
    } else {
      toggleFolder(item.folderName, item.parentName);
    }
  }, [item, selectComposition, toggleFolder]);
  const onKeyPress = useCallback15((evt) => {
    if (evt.key === "Enter") {
      onClick(evt);
    }
  }, [onClick]);
  const { setSelectedModal } = useContext8(ModalsContext);
  const contextMenu = useMemo21(() => {
    if (item.type === "composition") {
      return [
        {
          id: "duplicate",
          keyHint: null,
          label: `Duplicate...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "duplicate-comp",
              compositionId: item.composition.id,
              compositionType: item.composition.durationInFrames === 1 ? "still" : "composition"
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "duplicate"
        },
        {
          id: "rename",
          keyHint: null,
          label: `Rename...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "rename-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "rename"
        },
        {
          id: "delete",
          keyHint: null,
          label: `Delete...`,
          leftItem: null,
          onClick: () => {
            setSelectedModal({
              type: "delete-comp",
              compositionId: item.composition.id
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "delete"
        },
        {
          type: "divider",
          id: "copy-id-divider"
        },
        {
          id: "copy-id",
          keyHint: null,
          label: `Copy ID`,
          leftItem: null,
          onClick: () => {
            navigator.clipboard.writeText(item.composition.id).catch((err) => {
              showNotification(`Could not copy to clipboard: ${err.message}`, 1000);
            }).then(() => {
              showNotification("Copied to clipboard", 1000);
            });
          },
          quickSwitcherLabel: null,
          subMenu: null,
          type: "item",
          value: "remove"
        }
      ];
    }
    return [];
  }, [item, setSelectedModal]);
  if (item.type === "folder") {
    return /* @__PURE__ */ jsxs7(Fragment4, {
      children: [
        /* @__PURE__ */ jsxs7("button", {
          style,
          onPointerEnter,
          onPointerLeave,
          tabIndex,
          onClick,
          type: "button",
          title: item.folderName,
          children: [
            item.expanded ? /* @__PURE__ */ jsx31(ExpandedFolderIcon, {
              style: iconStyle,
              color: hovered || selected ? "white" : LIGHT_TEXT
            }) : /* @__PURE__ */ jsx31(CollapsedFolderIcon, {
              color: hovered || selected ? "white" : LIGHT_TEXT,
              style: iconStyle
            }),
            /* @__PURE__ */ jsx31(Spacing, {
              x: 1
            }),
            /* @__PURE__ */ jsx31("div", {
              style: label,
              children: item.folderName
            })
          ]
        }),
        item.expanded ? item.items.map((childItem) => {
          return /* @__PURE__ */ jsx31(CompositionSelectorItem, {
            currentComposition,
            selectComposition,
            item: childItem,
            tabIndex,
            level: level + 1,
            toggleFolder
          }, childItem.key + childItem.type);
        }) : null
      ]
    });
  }
  return /* @__PURE__ */ jsx31(ContextMenu, {
    values: contextMenu,
    children: /* @__PURE__ */ jsx31(Row, {
      align: "center",
      children: /* @__PURE__ */ jsxs7("a", {
        style,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        onClick,
        onKeyPress,
        type: "button",
        title: item.composition.id,
        className: "__remotion-composition",
        "data-compname": item.composition.id,
        children: [
          isCompositionStill(item.composition) ? /* @__PURE__ */ jsx31(StillIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }) : /* @__PURE__ */ jsx31(FilmIcon, {
            color: hovered || selected ? "white" : LIGHT_TEXT,
            style: iconStyle
          }),
          /* @__PURE__ */ jsx31(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx31("div", {
            style: label,
            children: item.composition.id
          }),
          /* @__PURE__ */ jsx31(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx31(CompositionContextButton, {
            values: contextMenu,
            visible: hovered
          }),
          /* @__PURE__ */ jsx31(SidebarRenderButton, {
            visible: hovered,
            composition: item.composition
          })
        ]
      })
    })
  });
};

// src/components/CurrentComposition.tsx
import { Internals as Internals6 } from "remotion";

// src/state/render-frame.ts
var renderFrame = (frame, fps) => {
  const hours = Math.floor(frame / fps / 3600);
  const remainingMinutes = frame - hours * fps * 3600;
  const minutes = Math.floor(remainingMinutes / 60 / fps);
  const remainingSec = frame - hours * fps * 3600 - minutes * fps * 60;
  const seconds = Math.floor(remainingSec / fps);
  const frameAfterSec = Math.round(frame % fps);
  const hoursStr = String(hours);
  const minutesStr = String(minutes).padStart(2, "0");
  const secondsStr = String(seconds).padStart(2, "0");
  const frameStr = String(frameAfterSec).padStart(2, "0");
  if (hours > 0) {
    return `${hoursStr}:${minutesStr}:${secondsStr}.${frameStr}`;
  }
  return `${minutesStr}:${secondsStr}.${frameStr}`;
};

// src/components/CurrentComposition.tsx
import { jsx as jsx32, jsxs as jsxs8 } from "react/jsx-runtime";
var CURRENT_COMPOSITION_HEIGHT = 64;
var container7 = {
  height: CURRENT_COMPOSITION_HEIGHT,
  display: "block",
  padding: "6px 12px",
  color: "white",
  backgroundColor: BACKGROUND
};
var title = {
  fontWeight: "bold",
  fontSize: 12,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var subtitle = {
  fontSize: 12,
  opacity: 0.8,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var row = {
  display: "flex",
  flexDirection: "row",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var CurrentComposition = () => {
  const video = Internals6.useVideo();
  return /* @__PURE__ */ jsx32("div", {
    style: container7,
    children: video ? /* @__PURE__ */ jsx32("div", {
      style: row,
      children: /* @__PURE__ */ jsxs8("div", {
        children: [
          /* @__PURE__ */ jsx32("div", {
            style: title,
            children: video.id
          }),
          /* @__PURE__ */ jsxs8("div", {
            style: subtitle,
            children: [
              video.width,
              "x",
              video.height,
              isCompositionStill(video) ? null : `, ${video.fps} FPS`
            ]
          }),
          isCompositionStill(video) ? /* @__PURE__ */ jsx32("div", {
            style: subtitle,
            children: "Still"
          }) : /* @__PURE__ */ jsxs8("div", {
            style: subtitle,
            children: [
              "Duration ",
              renderFrame(video.durationInFrames, video.fps)
            ]
          })
        ]
      })
    }) : null
  });
};

// src/components/CompositionSelector.tsx
import { jsx as jsx33, jsxs as jsxs9 } from "react/jsx-runtime";
var useCompositionNavigation = () => {
  const { compositions, canvasContent } = useContext9(Internals7.CompositionManager);
  const selectComposition = useSelectComposition();
  const navigateToNextComposition = useCallback16(() => {
    if (!canvasContent || canvasContent.type !== "composition" || compositions.length <= 1) {
      return;
    }
    const currentIndex = compositions.findIndex((c) => c.id === canvasContent.compositionId);
    if (currentIndex === -1) {
      return;
    }
    const nextIndex = (currentIndex + 1) % compositions.length;
    const nextComposition = compositions[nextIndex];
    selectComposition(nextComposition, true);
  }, [canvasContent, compositions, selectComposition]);
  const navigateToPreviousComposition = useCallback16(() => {
    if (!canvasContent || canvasContent.type !== "composition" || compositions.length <= 1) {
      return;
    }
    const currentIndex = compositions.findIndex((c) => c.id === canvasContent.compositionId);
    if (currentIndex === -1) {
      return;
    }
    const previousIndex = (currentIndex - 1 + compositions.length) % compositions.length;
    const previousComposition = compositions[previousIndex];
    selectComposition(previousComposition, true);
  }, [canvasContent, compositions, selectComposition]);
  return useMemo22(() => ({
    navigateToNextComposition,
    navigateToPreviousComposition
  }), [navigateToNextComposition, navigateToPreviousComposition]);
};
var container8 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var QUICK_SWITCHER_TRIGGER_HEIGHT = 38;
var quickSwitcherArea = {
  padding: "4px 12px",
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var quickSwitcherTrigger = {
  backgroundColor: "rgba(255, 255, 255, 0.06)",
  borderRadius: 5,
  padding: "4px 10px",
  color: LIGHT_TEXT,
  fontSize: 12,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "none",
  width: "100%",
  appearance: "none"
};
var shortcutLabel = {
  fontSize: 11,
  opacity: 0.6
};
var getKeysToExpand = (initialFolderName, parentFolderName, initial = []) => {
  initial.push(openFolderKey({
    folderName: initialFolderName,
    parentName: parentFolderName
  }));
  const { name, parent } = splitParentIntoNameAndParent(parentFolderName);
  if (!name) {
    return initial;
  }
  return getKeysToExpand(name, parent, initial);
};
var CompositionSelector = () => {
  const { compositions, canvasContent, folders } = useContext9(Internals7.CompositionManager);
  const { foldersExpanded } = useContext9(ExpandedFoldersContext);
  const { setSelectedModal } = useContext9(ModalsContext);
  const { tabIndex } = useZIndex();
  const selectComposition = useSelectComposition();
  const sortedCompositions = useMemo22(() => {
    return sortItemsByNonceHistory(compositions);
  }, [compositions]);
  const sortedFolders = useMemo22(() => {
    return sortItemsByNonceHistory(folders);
  }, [folders]);
  const items = useMemo22(() => {
    return createFolderTree(sortedCompositions, sortedFolders, foldersExpanded);
  }, [sortedCompositions, sortedFolders, foldersExpanded]);
  const list = useMemo22(() => {
    return {
      height: `calc(100% - ${CURRENT_COMPOSITION_HEIGHT}px - ${QUICK_SWITCHER_TRIGGER_HEIGHT}px)`,
      overflowY: "auto"
    };
  }, []);
  const toggleFolder = useCallback16((folderName, parentName) => {
    Internals7.compositionSelectorRef.current?.toggleFolder(folderName, parentName);
  }, []);
  const openQuickSwitcher = useCallback16(() => {
    setSelectedModal({
      type: "quick-switcher",
      mode: "compositions",
      invocationTimestamp: Date.now()
    });
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsxs9("div", {
    style: container8,
    children: [
      /* @__PURE__ */ jsx33(CurrentComposition, {}),
      /* @__PURE__ */ jsx33("div", {
        style: quickSwitcherArea,
        children: /* @__PURE__ */ jsxs9("button", {
          type: "button",
          style: quickSwitcherTrigger,
          onClick: openQuickSwitcher,
          tabIndex,
          children: [
            "Search...",
            areKeyboardShortcutsDisabled() ? null : /* @__PURE__ */ jsxs9("span", {
              style: shortcutLabel,
              children: [
                cmdOrCtrlCharacter,
                "+K"
              ]
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx33("div", {
        className: "__remotion-vertical-scrollbar",
        style: list,
        children: items.map((c) => {
          return /* @__PURE__ */ jsx33(CompositionSelectorItem, {
            level: 0,
            currentComposition: canvasContent && canvasContent.type === "composition" ? canvasContent.compositionId : null,
            selectComposition,
            toggleFolder,
            tabIndex,
            item: c
          }, c.key + c.type);
        })
      })
    ]
  });
};

// src/components/ExplorerPanel.tsx
import { createRef as createRef5, useCallback as useCallback22, useImperativeHandle as useImperativeHandle5, useState as useState21 } from "react";

// src/components/AssetSelector.tsx
import { useCallback as useCallback19, useContext as useContext13, useMemo as useMemo26, useState as useState18 } from "react";
import { Internals as Internals10 } from "remotion";

// src/api/write-static-file.ts
var writeStaticFile = async ({
  contents,
  filePath
}) => {
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("writeStaticFile() is not available in read-only Studio");
  }
  const url = new URL(`${window.remotion_staticBase}/api/add-asset`, window.location.origin);
  if (filePath.includes("\\")) {
    return Promise.reject(new Error("File path cannot contain backslashes"));
  }
  url.search = new URLSearchParams({
    filePath
  }).toString();
  const response = await fetch(url, {
    method: "POST",
    body: contents
  });
  if (!response.ok) {
    const jsonResponse = await response.json();
    throw new Error(jsonResponse.error);
  }
};

// src/helpers/use-asset-drag-events.ts
import { useCallback as useCallback17, useEffect as useEffect12, useMemo as useMemo23, useRef as useRef11 } from "react";
import { NoReactInternals } from "remotion/no-react";
function useAssetDragEvents({
  name,
  parentFolder,
  dropLocation,
  setDropLocation
}) {
  const dragDepthRef = useRef11(0);
  const combinedParents = useMemo23(() => {
    return [parentFolder, name].filter(NoReactInternals.truthy).join("/");
  }, [name, parentFolder]);
  const isDropDiv = useMemo23(() => {
    return dropLocation === combinedParents;
  }, [combinedParents, dropLocation]);
  const onDragEnter = useCallback17(() => {
    if (dragDepthRef.current === 0) {
      setDropLocation((currentDropLocation) => currentDropLocation?.includes(combinedParents) ? currentDropLocation : combinedParents);
    }
    dragDepthRef.current++;
  }, [combinedParents, dragDepthRef, setDropLocation]);
  const onDragLeave = useCallback17(() => {
    dragDepthRef.current--;
    if (dragDepthRef.current === 0) {
      setDropLocation((currentPath) => currentPath === combinedParents ? parentFolder : currentPath);
    }
  }, [combinedParents, dragDepthRef, parentFolder, setDropLocation]);
  useEffect12(() => {
    if (dropLocation === null) {
      dragDepthRef.current = 0;
    }
  }, [dropLocation]);
  return {
    isDropDiv,
    onDragEnter,
    onDragLeave
  };
}
var use_asset_drag_events_default = useAssetDragEvents;

// src/components/AssetSelectorItem.tsx
import React25, { useCallback as useCallback18, useContext as useContext10, useMemo as useMemo24, useRef as useRef12, useState as useState15 } from "react";
import { Internals as Internals8 } from "remotion";
import { NoReactInternals as NoReactInternals3 } from "remotion/no-react";

// src/helpers/copy-text.ts
var copyText = (cmd) => {
  const permissionName = "clipboard-write";
  return new Promise((resolve, reject) => {
    navigator.permissions.query({ name: permissionName }).then((result) => {
      if (result.state === "granted" || result.state === "prompt") {
        navigator.clipboard.writeText(cmd);
        resolve();
      } else {
        reject(new Error("Permission to copy not granted"));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/icons/clipboard.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var ClipboardIcon = ({ color, ...props }) => /* @__PURE__ */ jsx34("svg", {
  viewBox: "0 0 384 512",
  ...props,
  children: /* @__PURE__ */ jsx34("path", {
    fill: color,
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});

// src/icons/file.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var FileIcon = ({
  color,
  ...props
}) => /* @__PURE__ */ jsx35("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  ...props,
  children: /* @__PURE__ */ jsx35("path", {
    fill: color ?? "currentColor",
    d: "M0 64C0 28.65 28.65 0 64 0h156.1c12.7 0 25 5.057 34 14.06L369.9 129.9c9 9 14.1 21.3 14.1 34V448c0 35.3-28.7 64-64 64H64c-35.35 0-64-28.7-64-64V64zm352 128H240c-26.5 0-48-21.5-48-48V32H64c-17.67 0-32 14.33-32 32v384c0 17.7 14.33 32 32 32h256c17.7 0 32-14.3 32-32V192zm-4.7-39.4L231.4 36.69c-2-2.07-4.6-3.51-7.4-4.21V144c0 8.8 7.2 16 16 16h111.5c-.7-2.8-2.1-5.4-4.2-7.4z"
  })
});

// src/components/RenderQueue/actions.ts
import { NoReactInternals as NoReactInternals2 } from "remotion/no-react";

// src/components/call-api.ts
var callApi = (endpoint, body, signal) => {
  return new Promise((resolve, reject) => {
    fetch(endpoint, {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      signal,
      body: JSON.stringify(body)
    }).then((res) => res.json()).then((data) => {
      if (data.success) {
        resolve(data.data);
      } else {
        reject(new Error(data.error));
      }
    }).catch((err) => {
      reject(err);
    });
  });
};

// src/components/RenderQueue/actions.ts
var addStillRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  frame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  multiProcessOnLinux,
  beepOnFinish,
  metadata,
  chromeMode,
  mediaCacheSizeInBytes
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "still",
    outName,
    imageFormat,
    jpegQuality,
    frame,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    multiProcessOnLinux,
    beepOnFinish,
    metadata,
    chromeMode,
    mediaCacheSizeInBytes
  });
};
var addSequenceRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  startFrame,
  endFrame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  concurrency,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  jpegQuality,
  disallowParallelEncoding,
  multiProcessOnLinux,
  beepOnFinish,
  repro,
  metadata,
  chromeMode,
  mediaCacheSizeInBytes
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "sequence",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    startFrame,
    endFrame,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    concurrency,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    metadata,
    chromeMode,
    mediaCacheSizeInBytes
  });
};
var addVideoRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  scale,
  logLevel,
  codec,
  concurrency,
  crf,
  startFrame,
  endFrame,
  muted,
  enforceAudioTrack,
  proResProfile,
  x264Preset,
  pixelFormat,
  audioBitrate,
  videoBitrate,
  everyNthFrame,
  numberOfGifLoops,
  delayRenderTimeout,
  audioCodec,
  disallowParallelEncoding,
  chromiumOptions,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  colorSpace,
  multiProcessOnLinux,
  encodingMaxRate,
  encodingBufferSize,
  beepOnFinish,
  repro,
  forSeamlessAacConcatenation,
  separateAudioTo,
  metadata,
  hardwareAcceleration,
  chromeMode,
  mediaCacheSizeInBytes
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "video",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    metadata,
    hardwareAcceleration,
    chromeMode,
    mediaCacheSizeInBytes
  });
};
var unsubscribeFromFileExistenceWatcher = ({
  file,
  clientId
}) => {
  return callApi("/api/unsubscribe-from-file-existence", { file, clientId });
};
var subscribeToFileExistenceWatcher = async ({
  file,
  clientId
}) => {
  const { exists } = await callApi("/api/subscribe-to-file-existence", {
    file,
    clientId
  });
  return exists;
};
var openInFileExplorer = ({ directory }) => {
  const body = {
    directory
  };
  return callApi("/api/open-in-file-explorer", body);
};
var applyCodemod = ({
  codemod,
  dryRun,
  signal
}) => {
  const body = {
    codemod,
    dryRun
  };
  return callApi("/api/apply-codemod", body, signal);
};
var removeRenderJob = (job) => {
  return callApi("/api/remove-render", {
    jobId: job.id
  });
};
var cancelRenderJob = (job) => {
  return callApi("/api/cancel", {
    jobId: job.id
  });
};
var updateAvailable = (signal) => {
  return callApi("/api/update-available", {}, signal);
};
var getProjectInfo = (signal) => {
  return callApi("/api/project-info", {}, signal);
};
var callUpdateDefaultPropsApi = (compositionId, defaultProps, enumPaths) => {
  return callApi("/api/update-default-props", {
    compositionId,
    defaultProps: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: defaultProps,
      indent: undefined,
      staticBase: window.remotion_staticBase
    }).serializedString,
    enumPaths
  });
};
var canUpdateDefaultProps = (compositionId, readOnlyStudio) => {
  if (readOnlyStudio) {
    return Promise.resolve({
      canUpdate: false,
      reason: "Read-only studio"
    });
  }
  return callApi("/api/can-update-default-props", {
    compositionId
  });
};
var applyVisualControlChange = ({
  fileName,
  changes
}) => {
  return callApi("/api/apply-visual-control-change", {
    fileName,
    changes
  });
};

// src/components/AssetSelectorItem.tsx
import { jsx as jsx36, jsxs as jsxs10, Fragment as Fragment5 } from "react/jsx-runtime";
var ASSET_ITEM_HEIGHT = 32;
var iconStyle2 = {
  width: 18,
  height: 18,
  flexShrink: 0
};
var itemStyle2 = {
  paddingRight: 10,
  paddingTop: 6,
  paddingBottom: 6,
  fontSize: 13,
  display: "flex",
  textDecoration: "none",
  cursor: "default",
  alignItems: "center",
  marginBottom: 1,
  appearance: "none",
  border: "none",
  width: "100%",
  textAlign: "left",
  backgroundColor: BACKGROUND,
  height: ASSET_ITEM_HEIGHT,
  userSelect: "none",
  WebkitUserSelect: "none"
};
var labelStyle3 = {
  textAlign: "left",
  textDecoration: "none",
  fontSize: 13,
  flex: "1 1 0%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
var revealIconStyle = {
  height: 12,
  color: "currentColor"
};
var AssetFolderItem = ({
  tabIndex,
  item,
  level,
  parentFolder,
  toggleFolder,
  dropLocation,
  setDropLocation,
  readOnlyStudio
}) => {
  const [hovered, setHovered] = useState15(false);
  const openFolderTimerRef = useRef12(null);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: item.name,
    parentFolder,
    dropLocation,
    setDropLocation
  });
  const onPointerEnter = useCallback18(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback18(() => {
    setHovered(false);
  }, []);
  const folderStyle = useMemo24(() => {
    return {
      ...itemStyle2,
      paddingLeft: 4 + level * 8,
      backgroundColor: hovered ? CLEAR_HOVER : "transparent"
    };
  }, [hovered, level]);
  const label = useMemo24(() => {
    return {
      ...labelStyle3,
      color: hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered]);
  const onClick = useCallback18(() => {
    toggleFolder(item.name, parentFolder);
  }, [item.name, parentFolder, toggleFolder]);
  const Icon = item.expanded ? ExpandedFolderIcon : CollapsedFolderIcon;
  return /* @__PURE__ */ jsxs10("div", {
    onDragEnter,
    onDragLeave,
    style: {
      backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
    },
    children: [
      /* @__PURE__ */ jsx36("div", {
        style: folderStyle,
        onPointerEnter,
        onPointerLeave,
        tabIndex,
        title: item.name,
        onClick,
        onDragEnter: () => {
          if (!item.expanded) {
            openFolderTimerRef.current = window.setTimeout(() => {
              toggleFolder(item.name, parentFolder);
            }, 1000);
          }
        },
        onDragLeave: () => {
          if (openFolderTimerRef.current) {
            clearTimeout(openFolderTimerRef.current);
          }
        },
        children: /* @__PURE__ */ jsxs10(Row, {
          children: [
            /* @__PURE__ */ jsx36(Icon, {
              style: iconStyle2,
              color: hovered ? "white" : LIGHT_TEXT
            }),
            /* @__PURE__ */ jsx36(Spacing, {
              x: 1
            }),
            /* @__PURE__ */ jsx36("div", {
              style: label,
              children: item.name
            })
          ]
        })
      }),
      item.expanded ? /* @__PURE__ */ jsx36(AssetFolderTree, {
        item: item.items,
        name: item.name,
        level,
        parentFolder,
        tabIndex,
        toggleFolder,
        dropLocation,
        setDropLocation,
        readOnlyStudio
      }, item.name) : null
    ]
  });
};
var AssetFolderTree = ({
  item,
  level,
  name,
  parentFolder,
  toggleFolder,
  tabIndex,
  dropLocation,
  setDropLocation,
  readOnlyStudio
}) => {
  const combinedParents = useMemo24(() => {
    return [parentFolder, name].filter(NoReactInternals3.truthy).join("/");
  }, [name, parentFolder]);
  return /* @__PURE__ */ jsxs10("div", {
    children: [
      item.folders.map((folder) => {
        return /* @__PURE__ */ jsx36(AssetFolderItem, {
          item: folder,
          tabIndex,
          level: level + 1,
          parentFolder: combinedParents,
          toggleFolder,
          dropLocation,
          setDropLocation,
          readOnlyStudio
        }, folder.name);
      }),
      item.files.map((file) => {
        return /* @__PURE__ */ jsx36(AssetSelectorItem, {
          item: file,
          tabIndex,
          level,
          parentFolder: combinedParents,
          readOnlyStudio
        }, file.src);
      })
    ]
  });
};
var AssetSelectorItem = ({ item, tabIndex, level, parentFolder, readOnlyStudio }) => {
  const isMobileLayout = useMobileLayout();
  const [hovered, setHovered] = useState15(false);
  const { setSidebarCollapsedState } = useContext10(SidebarContext);
  const onPointerEnter = useCallback18(() => {
    setHovered(true);
  }, []);
  const { setCanvasContent } = useContext10(Internals8.CompositionSetters);
  const { canvasContent } = useContext10(Internals8.CompositionManager);
  const relativePath = useMemo24(() => {
    return parentFolder ? parentFolder + "/" + item.name : item.name;
  }, [parentFolder, item.name]);
  const selected = useMemo24(() => {
    if (canvasContent && canvasContent.type === "asset") {
      return canvasContent.asset === relativePath;
    }
    return false;
  }, [canvasContent, relativePath]);
  const onPointerLeave = useCallback18(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback18(() => {
    setCanvasContent({ type: "asset", asset: relativePath });
    pushUrl(`/assets/${relativePath}`);
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    isMobileLayout,
    relativePath,
    setCanvasContent,
    setSidebarCollapsedState
  ]);
  const style = useMemo24(() => {
    return {
      ...itemStyle2,
      color: hovered || selected ? "white" : LIGHT_TEXT,
      backgroundColor: hovered ? selected ? SELECTED_BACKGROUND : CLEAR_HOVER : selected ? SELECTED_BACKGROUND : "transparent",
      paddingLeft: 12 + level * 8
    };
  }, [hovered, level, selected]);
  const label = useMemo24(() => {
    return {
      ...labelStyle3,
      color: hovered || selected ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  const renderFileExplorerAction = useCallback18((color) => {
    return /* @__PURE__ */ jsx36(ExpandedFolderIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const renderCopyAction = useCallback18((color) => {
    return /* @__PURE__ */ jsx36(ClipboardIcon, {
      style: revealIconStyle,
      color
    });
  }, []);
  const revealInExplorer = React25.useCallback((e) => {
    e.stopPropagation();
    openInFileExplorer({
      directory: window.remotion_publicFolderExists + "/" + parentFolder + "/" + item.name
    }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  const copyToClipboard = useCallback18((e) => {
    e.stopPropagation();
    const content = `staticFile("${[parentFolder, item.name].join("/")}")`;
    copyText(content).then(() => {
      showNotification(`Copied '${content}' to clipboard`, 1000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [item.name, parentFolder]);
  return /* @__PURE__ */ jsx36(Row, {
    align: "center",
    children: /* @__PURE__ */ jsxs10("div", {
      style,
      onPointerEnter,
      onPointerLeave,
      onClick,
      tabIndex,
      title: item.name,
      children: [
        /* @__PURE__ */ jsx36(FileIcon, {
          style: iconStyle2,
          color: LIGHT_TEXT
        }),
        /* @__PURE__ */ jsx36(Spacing, {
          x: 1
        }),
        /* @__PURE__ */ jsx36("div", {
          style: label,
          children: item.name
        }),
        hovered ? /* @__PURE__ */ jsxs10(Fragment5, {
          children: [
            /* @__PURE__ */ jsx36(Spacing, {
              x: 0.5
            }),
            /* @__PURE__ */ jsx36(InlineAction, {
              title: "Copy staticFile() name",
              renderAction: renderCopyAction,
              onClick: copyToClipboard
            }),
            readOnlyStudio ? null : /* @__PURE__ */ jsxs10(Fragment5, {
              children: [
                /* @__PURE__ */ jsx36(Spacing, {
                  x: 0.5
                }),
                /* @__PURE__ */ jsx36(InlineAction, {
                  title: "Open in Explorer",
                  renderAction: renderFileExplorerAction,
                  onClick: revealInExplorer
                })
              ]
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/CurrentAsset.tsx
import { formatBytes } from "@remotion/studio-shared";
import { ALL_FORMATS, Input, UrlSource } from "mediabunny";
import { useContext as useContext12, useEffect as useEffect14, useMemo as useMemo25, useState as useState17 } from "react";
import { Internals as Internals9, staticFile } from "remotion";

// src/components/use-static-files.ts
import React26, { createContext as createContext10, useContext as useContext11, useEffect as useEffect13, useState as useState16 } from "react";
import { useRemotionEnvironment } from "remotion";

// src/api/get-static-files.ts
var warnedServer = false;
var warnedPlayer = false;
var warnServerOnce = () => {
  if (warnedServer) {
    return;
  }
  warnedServer = true;
  console.warn("Called getStaticFiles() on the server. The API is only available in the browser. An empty array was returned.");
};
var warnPlayerOnce = () => {
  if (warnedPlayer) {
    return;
  }
  warnedPlayer = true;
  console.warn("Called getStaticFiles() while using the Remotion Player. The API is only available while using the Remotion Studio. An empty array was returned.");
};
var getStaticFiles = () => {
  if (typeof document === "undefined") {
    warnServerOnce();
    return [];
  }
  if (window.remotion_isPlayer) {
    warnPlayerOnce();
    return [];
  }
  return window.remotion_staticFiles;
};

// src/api/watch-public-folder.ts
import { getRemotionEnvironment } from "remotion";
var WATCH_REMOTION_STATIC_FILES = "remotion_staticFilesChanged";
var watchPublicFolder = (callback) => {
  if (!getRemotionEnvironment().isStudio) {
    console.warn("The watchPublicFolder() API is only available while using the Remotion Studio.");
    return { cancel: () => {
      return;
    } };
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("watchPublicFolder() is not available in read-only Studio");
  }
  const emitUpdate = () => {
    callback(getStaticFiles());
  };
  window.addEventListener(WATCH_REMOTION_STATIC_FILES, emitUpdate);
  const cancel = () => {
    return window.removeEventListener(WATCH_REMOTION_STATIC_FILES, emitUpdate);
  };
  return { cancel };
};

// src/components/use-static-files.ts
var StaticFilesContext = createContext10([]);
var StaticFilesProvider = ({ children }) => {
  const [files, setFiles] = useState16(() => getStaticFiles());
  const env = useRemotionEnvironment();
  useEffect13(() => {
    if (!env.isStudio) {
      return;
    }
    if (env.isReadOnlyStudio) {
      return;
    }
    const { cancel } = watchPublicFolder((newFiles) => {
      setFiles(newFiles);
    });
    return cancel;
  }, [env.isStudio, env.isReadOnlyStudio]);
  return React26.createElement(StaticFilesContext.Provider, { value: files }, children);
};
var useStaticFiles = () => {
  return useContext11(StaticFilesContext);
};

// src/components/CurrentAsset.tsx
import { jsx as jsx37, jsxs as jsxs11 } from "react/jsx-runtime";
var CURRENT_ASSET_HEIGHT = 80;
var container9 = {
  height: CURRENT_ASSET_HEIGHT,
  display: "block",
  borderBottom: `1px solid ${BORDER_COLOR}`,
  padding: 12,
  color: "white",
  backgroundColor: BACKGROUND
};
var title2 = {
  fontWeight: "bold",
  fontSize: 12,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var subtitle2 = {
  fontSize: 12,
  opacity: 0.8,
  whiteSpace: "nowrap",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var row2 = {
  display: "flex",
  flexDirection: "row",
  lineHeight: "18px",
  backgroundColor: BACKGROUND
};
var formatDuration = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const sFixed = s.toFixed(2).padStart(5, "0");
  if (h > 0) {
    return `${h}:${String(m).padStart(2, "0")}:${sFixed}`;
  }
  return `${String(m).padStart(2, "0")}:${sFixed}`;
};
var CurrentAsset = () => {
  const { canvasContent } = useContext12(Internals9.CompositionManager);
  const assetName = canvasContent?.type === "asset" ? canvasContent.asset : null;
  const staticFiles = useStaticFiles();
  const sizeInBytes = useMemo25(() => {
    if (!assetName) {
      return null;
    }
    const file = staticFiles.find((f) => f.name === assetName);
    return file?.sizeInBytes ?? null;
  }, [assetName, staticFiles]);
  const [mediaMetadata, setMediaMetadata] = useState17(null);
  useEffect14(() => {
    setMediaMetadata(null);
    if (!assetName) {
      return;
    }
    const url = staticFile(assetName);
    const input = new Input({
      formats: ALL_FORMATS,
      source: new UrlSource(url)
    });
    Promise.all([
      input.computeDuration(),
      input.getFormat(),
      input.getPrimaryVideoTrack()
    ]).then(([duration, format, videoTrack]) => {
      setMediaMetadata({
        duration,
        format: format.name,
        width: videoTrack?.displayWidth ?? null,
        height: videoTrack?.displayHeight ?? null
      });
    }).catch(() => {});
    return () => {
      input.dispose();
    };
  }, [assetName]);
  if (!assetName) {
    return /* @__PURE__ */ jsx37("div", {
      style: container9
    });
  }
  const fileName = assetName.split("/").pop() ?? assetName;
  const subtitleParts = [];
  if (sizeInBytes !== null) {
    subtitleParts.push(formatBytes(sizeInBytes));
  }
  if (mediaMetadata) {
    subtitleParts.push(mediaMetadata.format);
    if (mediaMetadata.width !== null && mediaMetadata.height !== null) {
      subtitleParts.push(`${mediaMetadata.width}x${mediaMetadata.height}`);
    }
  }
  return /* @__PURE__ */ jsx37("div", {
    style: container9,
    children: /* @__PURE__ */ jsx37("div", {
      style: row2,
      children: /* @__PURE__ */ jsxs11("div", {
        children: [
          /* @__PURE__ */ jsx37("div", {
            style: title2,
            children: fileName
          }),
          subtitleParts.length > 0 ? /* @__PURE__ */ jsx37("div", {
            style: subtitle2,
            children: subtitleParts.join(" · ")
          }) : null,
          mediaMetadata ? /* @__PURE__ */ jsx37("div", {
            style: subtitle2,
            children: formatDuration(mediaMetadata.duration)
          }) : null
        ]
      })
    })
  });
};

// src/components/AssetSelector.tsx
import { jsx as jsx38, jsxs as jsxs12 } from "react/jsx-runtime";
var container10 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var emptyState = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "0 12px"
};
var label = {
  color: LIGHT_TEXT,
  lineHeight: 1.5,
  fontSize: 14
};
var baseList = {
  overflowY: "auto"
};
var AssetSelector = ({ readOnlyStudio }) => {
  const { tabIndex } = useZIndex();
  const { canvasContent } = useContext13(Internals10.CompositionManager);
  const { assetFoldersExpanded, setAssetFoldersExpanded } = useContext13(FolderContext);
  const [dropLocation, setDropLocation] = useState18(null);
  const connectionStatus = useContext13(StudioServerConnectionCtx).previewServerState.type;
  const shouldAllowUpload = connectionStatus === "connected" && !readOnlyStudio;
  const showCurrentAsset = canvasContent?.type === "asset";
  const list = useMemo26(() => {
    return {
      ...baseList,
      height: showCurrentAsset ? `calc(100% - ${CURRENT_ASSET_HEIGHT}px)` : "100%"
    };
  }, [showCurrentAsset]);
  const staticFiles = useStaticFiles();
  const publicFolderExists = window.remotion_publicFolderExists;
  const assetTree = useMemo26(() => {
    return buildAssetFolderStructure(staticFiles, null, assetFoldersExpanded);
  }, [assetFoldersExpanded, staticFiles]);
  const toggleFolder = useCallback19((folderName, parentName) => {
    setAssetFoldersExpanded((p) => {
      const key = [parentName, folderName].filter(Boolean).join("/");
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("assets", foldersExpandedState);
      return foldersExpandedState;
    });
  }, [setAssetFoldersExpanded]);
  const { isDropDiv, onDragEnter, onDragLeave } = use_asset_drag_events_default({
    name: null,
    parentFolder: null,
    dropLocation,
    setDropLocation
  });
  const onDragOver = useCallback19((e) => {
    e.preventDefault();
  }, []);
  const onDrop = useCallback19(async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      const { files } = e.dataTransfer;
      const assetPath = dropLocation ?? null;
      const makePath = (file) => {
        return [assetPath, file.name].filter(Boolean).join("/");
      };
      for (const file of files) {
        const body = await file.arrayBuffer();
        await writeStaticFile({
          contents: body,
          filePath: makePath(file)
        });
      }
      if (files.length === 1) {
        showNotification(`Created ${makePath(files[0])}`, 3000);
      } else {
        showNotification(`Added ${files.length} files to ${assetPath}`, 3000);
      }
    } catch (error) {
      showNotification(`Error during upload: ${error}`, 3000);
    } finally {
      setDropLocation(null);
    }
  }, [dropLocation]);
  return /* @__PURE__ */ jsxs12("div", {
    style: container10,
    onDragOver: shouldAllowUpload ? onDragOver : undefined,
    onDrop: shouldAllowUpload ? onDrop : undefined,
    children: [
      showCurrentAsset ? /* @__PURE__ */ jsx38(CurrentAsset, {}) : null,
      staticFiles.length === 0 ? publicFolderExists ? /* @__PURE__ */ jsx38("div", {
        style: emptyState,
        children: /* @__PURE__ */ jsxs12("div", {
          style: label,
          children: [
            "To add assets, place a file in the",
            " ",
            /* @__PURE__ */ jsx38("code", {
              style: inlineCodeSnippet,
              children: "public"
            }),
            " folder of your project or drag and drop a file here."
          ]
        })
      }) : /* @__PURE__ */ jsx38("div", {
        style: emptyState,
        children: /* @__PURE__ */ jsxs12("div", {
          style: label,
          children: [
            "To add assets, create a folder called",
            " ",
            /* @__PURE__ */ jsx38("code", {
              style: inlineCodeSnippet,
              children: "public"
            }),
            " in the root of your project and place a file in it."
          ]
        })
      }) : /* @__PURE__ */ jsx38("div", {
        className: "__remotion-vertical-scrollbar",
        style: {
          ...list,
          backgroundColor: isDropDiv ? CLEAR_HOVER : BACKGROUND
        },
        onDragEnter,
        onDragLeave,
        children: /* @__PURE__ */ jsx38(AssetFolderTree, {
          item: assetTree,
          level: 0,
          parentFolder: null,
          name: null,
          tabIndex,
          toggleFolder,
          dropLocation,
          setDropLocation,
          readOnlyStudio
        })
      })
    ]
  });
};

// src/components/CompSelectorRef.tsx
import {
  useCallback as useCallback20,
  useContext as useContext14,
  useImperativeHandle as useImperativeHandle4,
  useMemo as useMemo27,
  useState as useState19
} from "react";
import { Internals as Internals11 } from "remotion";
import { jsx as jsx39 } from "react/jsx-runtime";
var CompSelectorRef = ({ children }) => {
  const { compositions } = useContext14(Internals11.CompositionManager);
  const [foldersExpanded, setFoldersExpanded] = useState19(loadExpandedFolders("compositions"));
  const selectComposition = useSelectComposition();
  const toggleFolder = useCallback20((folderName, parentName) => {
    setFoldersExpanded((p) => {
      const key = openFolderKey({ folderName, parentName });
      const prev = p[key] ?? false;
      const foldersExpandedState = {
        ...p,
        [key]: !prev
      };
      persistExpandedFolders("compositions", foldersExpandedState);
      return foldersExpandedState;
    });
  }, []);
  useImperativeHandle4(Internals11.compositionSelectorRef, () => {
    return {
      expandComposition: (compName) => {
        const compositionToExpand = compositions.find((c) => c.id === compName);
        if (!compositionToExpand) {
          return;
        }
        const { folderName, parentFolderName } = compositionToExpand;
        if (folderName === null) {
          return;
        }
        setFoldersExpanded((previousState) => {
          const foldersExpandedState = {
            ...previousState
          };
          const currentFolder = folderName;
          const currentParentName = parentFolderName;
          const key = openFolderKey({
            folderName: currentFolder,
            parentName: currentParentName
          });
          const splitted = key.split("/");
          for (let i = 0;i < splitted.length - 1; i++) {
            const allExceptLast = i === 0 ? openFolderKey({
              folderName: splitted.filter((s) => s !== "no-parent")[0],
              parentName: null
            }) : splitted.slice(0, i + 1).join("/");
            foldersExpandedState[allExceptLast] = true;
          }
          persistExpandedFolders("compositions", foldersExpandedState);
          return foldersExpandedState;
        });
      },
      selectComposition: (compName) => {
        const comp = compositions.find((c) => c.id === compName);
        if (!comp) {
          throw new Error(`Composition ${compName} not found`);
        }
        selectComposition(comp, true);
      },
      toggleFolder: (folderName, parentName) => {
        toggleFolder(folderName, parentName);
      }
    };
  }, [compositions, selectComposition, toggleFolder]);
  const contextValue = useMemo27(() => {
    return {
      foldersExpanded,
      setFoldersExpanded,
      toggleFolder
    };
  }, [foldersExpanded, setFoldersExpanded, toggleFolder]);
  return /* @__PURE__ */ jsx39(ExpandedFoldersContext.Provider, {
    value: contextValue,
    children
  });
};

// src/components/Tabs/index.tsx
import { useCallback as useCallback21, useMemo as useMemo28, useState as useState20 } from "react";
import { jsx as jsx40 } from "react/jsx-runtime";
var tabsContainer = {
  display: "flex",
  flexDirection: "row"
};
var Tabs = ({ children, style }) => {
  const definiteStyle = useMemo28(() => {
    return {
      ...tabsContainer,
      ...style
    };
  }, [style]);
  return /* @__PURE__ */ jsx40("div", {
    style: definiteStyle,
    children
  });
};
var selectorButton = {
  border: "none",
  flex: 1,
  padding: 4,
  height: 40,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  cursor: "default",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var Tab = ({ children, onClick, style, selected }) => {
  const [hovered, setHovered] = useState20(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback21(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback21(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo28(() => ({
    ...selectorButton,
    backgroundColor: selected ? BACKGROUND : hovered ? CLEAR_HOVER : INPUT_BACKGROUND,
    color: selected ? "white" : LIGHT_TEXT,
    borderTop: selected ? "2px solid " + BLUE : "2px solid transparent",
    boxShadow: selected ? "none" : undefined,
    ...style
  }), [hovered, selected, style]);
  return /* @__PURE__ */ jsx40("div", {
    style: definiteStyle,
    role: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/ExplorerPanel.tsx
import { jsx as jsx41, jsxs as jsxs13 } from "react/jsx-runtime";
var container11 = {
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var localStorageKey2 = "remotion.sidebarPanel";
var getSelectedPanel = () => {
  const panel = localStorage.getItem(localStorageKey2);
  if (panel === "assets") {
    return "assets";
  }
  return "compositions";
};
var tabsContainer2 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel = (panel) => {
  localStorage.setItem(localStorageKey2, panel);
};
var explorerSidebarTabs = createRef5();
var ExplorerPanel = ({ readOnlyStudio }) => {
  const [panel, setPanel] = useState21(() => getSelectedPanel());
  const onCompositionsSelected = useCallback22(() => {
    setPanel("compositions");
    persistSelectedOptionsSidebarPanel("compositions");
  }, []);
  const onAssetsSelected = useCallback22(() => {
    setPanel("assets");
    persistSelectedOptionsSidebarPanel("assets");
  }, []);
  useImperativeHandle5(explorerSidebarTabs, () => {
    return {
      selectAssetsPanel: () => {
        setPanel("assets");
        persistSelectedOptionsSidebarPanel("assets");
      },
      selectCompositionPanel: () => {
        setPanel("compositions");
        persistSelectedOptionsSidebarPanel("compositions");
      }
    };
  }, []);
  return /* @__PURE__ */ jsx41(CompSelectorRef, {
    children: /* @__PURE__ */ jsxs13("div", {
      style: container11,
      className: "css-reset",
      children: [
        /* @__PURE__ */ jsx41("div", {
          style: tabsContainer2,
          children: /* @__PURE__ */ jsxs13(Tabs, {
            children: [
              /* @__PURE__ */ jsx41(Tab, {
                selected: panel === "compositions",
                onClick: onCompositionsSelected,
                children: "Compositions"
              }),
              /* @__PURE__ */ jsx41(Tab, {
                selected: panel === "assets",
                onClick: onAssetsSelected,
                children: "Assets"
              })
            ]
          })
        }),
        panel === "compositions" ? /* @__PURE__ */ jsx41(CompositionSelector, {}) : /* @__PURE__ */ jsx41(AssetSelector, {
          readOnlyStudio
        })
      ]
    })
  });
};

// src/components/InitialCompositionLoader.tsx
var useSelectAsset = () => {
  const { setCanvasContent } = useContext15(Internals12.CompositionSetters);
  const { setAssetFoldersExpanded } = useContext15(FolderContext);
  return (asset) => {
    setCanvasContent({ type: "asset", asset });
    explorerSidebarTabs.current?.selectAssetsPanel();
    setAssetFoldersExpanded((ex) => {
      const split = asset.split("/");
      const keysToExpand = split.map((_, i) => {
        return split.slice(0, i).join("/");
      });
      const newState = {
        ...ex
      };
      for (const key of keysToExpand) {
        newState[key] = true;
      }
      return newState;
    });
  };
};
var useSelectComposition = () => {
  const { setCompositionFoldersExpanded } = useContext15(FolderContext);
  const { setCanvasContent } = useContext15(Internals12.CompositionSetters);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext15(SidebarContext);
  return useCallback23((c, push) => {
    if (push) {
      pushUrl(`/${c.id}`);
    }
    explorerSidebarTabs.current?.selectCompositionPanel();
    setCanvasContent({ type: "composition", compositionId: c.id });
    const { folderName, parentFolderName } = c;
    if (folderName !== null) {
      setCompositionFoldersExpanded((ex) => {
        const keysToExpand = getKeysToExpand(folderName, parentFolderName);
        const newState = {
          ...ex
        };
        for (const key of keysToExpand) {
          newState[key] = true;
        }
        return newState;
      });
      if (isMobileLayout) {
        setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
      }
    }
  }, [
    isMobileLayout,
    setCanvasContent,
    setCompositionFoldersExpanded,
    setSidebarCollapsedState
  ]);
};
var InitialCompositionLoader = () => {
  const { compositions, canvasContent } = useContext15(Internals12.CompositionManager);
  const { setCanvasContent } = useContext15(Internals12.CompositionSetters);
  const selectComposition = useSelectComposition();
  const selectAsset = useSelectAsset();
  const staticFiles = useStaticFiles();
  useEffect15(() => {
    const canvasContentFromUrl = deriveCanvasContentFromUrl();
    if (canvasContent) {
      if (canvasContentFromUrl && canvasContentFromUrl.type === "composition" && canvasContent.type === "composition" && canvasContentFromUrl.compositionId !== canvasContent.compositionId) {
        const exists = compositions.find((c) => c.id === canvasContentFromUrl.compositionId);
        if (exists) {
          selectComposition(exists, false);
        }
      }
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "composition") {
      const exists = compositions.find((c) => c.id === canvasContentFromUrl.compositionId);
      if (exists) {
        selectComposition(exists, false);
      }
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "asset") {
      selectAsset(canvasContentFromUrl.asset);
      return;
    }
    if (canvasContentFromUrl && canvasContentFromUrl.type === "output") {
      setCanvasContent(canvasContentFromUrl);
      return;
    }
    if (compositions.length > 0) {
      selectComposition(compositions[0], true);
    }
  }, [
    compositions,
    canvasContent,
    selectComposition,
    setCanvasContent,
    selectAsset
  ]);
  useEffect15(() => {
    const onchange = () => {
      const newCanvas = deriveCanvasContentFromUrl();
      if (newCanvas && newCanvas.type === "composition") {
        const newComp = getRoute().substring(1);
        const exists = compositions.find((c) => c.id === newComp);
        if (exists) {
          selectComposition(exists, false);
        }
        return;
      }
      if (newCanvas && newCanvas.type === "asset") {
        const exists = staticFiles.find((file) => {
          return file.name === newCanvas.asset;
        });
        if (exists) {
          setCanvasContent(newCanvas);
        }
        return;
      }
      setCanvasContent(newCanvas);
    };
    window.addEventListener("popstate", onchange);
    return () => window.removeEventListener("popstate", onchange);
  }, [compositions, selectComposition, setCanvasContent, staticFiles]);
  return null;
};

// src/components/MenuToolbar.tsx
import { useCallback as useCallback95, useMemo as useMemo100, useState as useState66 } from "react";

// src/helpers/use-menu-structure.tsx
import { useContext as useContext22, useMemo as useMemo38 } from "react";
import { Internals as Internals17 } from "remotion";
import { NoReactInternals as NoReactInternals5 } from "remotion/no-react";

// src/api/restart-studio.ts
import { getRemotionEnvironment as getRemotionEnvironment2 } from "remotion";
var restartStudio = () => {
  if (!getRemotionEnvironment2().isStudio) {
    throw new Error("restartStudio() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("restartStudio() is not available in read-only Studio");
  }
  return callApi("/api/restart-studio", {});
};

// src/components/AskAiModal.tsx
import {
  createRef as createRef6,
  useCallback as useCallback25,
  useEffect as useEffect16,
  useImperativeHandle as useImperativeHandle6,
  useRef as useRef13,
  useState as useState22
} from "react";
import { AbsoluteFill } from "remotion";

// src/components/ModalContainer.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var padding = 20;
var getMaxModalWidth = (width) => {
  return `min(calc(100vw - ${padding * 2}px), calc(${width}px - ${padding * 2}px))`;
};
var getMaxModalHeight = (height) => {
  return `min(calc(100vh - ${padding * 2}px), calc(${height}px - ${padding * 2}px))`;
};
var backgroundOverlay = {
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  backdropFilter: `blur(1px)`,
  position: "fixed",
  height: "100%",
  width: "100%",
  display: "flex",
  padding
};
var panel = {
  backgroundColor: BACKGROUND,
  boxShadow: "0 0 4px black",
  color: "white",
  margin: "auto"
};
var ModalContainer = ({ children, onEscape, onOutsideClick, noZIndex }) => {
  return /* @__PURE__ */ jsx42("div", {
    className: "css-reset",
    style: backgroundOverlay,
    role: "dialog",
    "aria-modal": "true",
    children: /* @__PURE__ */ jsx42(HigherZIndex, {
      disabled: noZIndex,
      onOutsideClick,
      onEscape,
      children: /* @__PURE__ */ jsx42("div", {
        style: panel,
        children
      })
    })
  });
};

// src/components/ModalHeader.tsx
import { useCallback as useCallback24, useContext as useContext16 } from "react";

// src/components/NewComposition/CancelButton.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var style = {
  appearance: "none",
  border: "none",
  backgroundColor: "transparent",
  color: "white",
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var CancelButton = ({ onPress, ...props }) => {
  const { tabIndex } = useZIndex();
  return /* @__PURE__ */ jsx43("button", {
    tabIndex,
    style,
    type: "button",
    onClick: onPress,
    children: /* @__PURE__ */ jsx43("svg", {
      viewBox: "0 0 320 512",
      ...props,
      children: /* @__PURE__ */ jsx43("path", {
        fill: "currentColor",
        d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
      })
    })
  });
};

// src/components/ModalHeader.tsx
import { jsx as jsx44, jsxs as jsxs14 } from "react/jsx-runtime";
var container12 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  width: "100%",
  borderBottom: "1px solid black"
};
var titleStyle = {
  fontSize: 14,
  color: "white"
};
var icon = {
  height: 20,
  width: 20
};
var ModalHeader = ({ title: title3, onClose }) => {
  const { setSelectedModal } = useContext16(ModalsContext);
  const onPress = useCallback24(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsxs14("div", {
    style: container12,
    children: [
      /* @__PURE__ */ jsx44("div", {
        style: titleStyle,
        children: title3
      }),
      /* @__PURE__ */ jsx44(Flex, {}),
      /* @__PURE__ */ jsx44(CancelButton, {
        style: icon,
        onPress: onClose ?? onPress
      })
    ]
  });
};

// src/components/AskAiModal.tsx
import { jsx as jsx45, jsxs as jsxs15 } from "react/jsx-runtime";
var container13 = {
  height: "calc(100vh - 100px)",
  width: "calc(100vw - 160px)",
  maxWidth: 800,
  maxHeight: 900,
  display: "block"
};
var askAiModalRef = createRef6();
var AskAiModal = () => {
  const [state, setState] = useState22("never-opened");
  const iframe = useRef13(null);
  useImperativeHandle6(askAiModalRef, () => ({
    toggle: () => {
      setState((s) => {
        if (s === "visible") {
          iframe.current?.blur();
          iframe.current?.contentWindow?.blur();
        }
        return s === "visible" ? "hidden" : "visible";
      });
    }
  }), []);
  useEffect16(() => {
    const onMessage = (event) => {
      try {
        const json = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (json.type === "cmd-i") {
          askAiModalRef.current?.toggle();
        }
      } catch {}
    };
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);
  const onQuit = useCallback25(() => {
    setState("hidden");
  }, [setState]);
  useEffect16(() => {
    if (!iframe.current) {
      return;
    }
    if (state === "visible") {
      iframe.current.contentWindow?.postMessage({
        type: "focus"
      }, "*");
    }
  }, [state]);
  if (state === "never-opened") {
    return null;
  }
  return /* @__PURE__ */ jsx45(AbsoluteFill, {
    style: { display: state === "visible" ? "block" : "none" },
    children: /* @__PURE__ */ jsxs15(ModalContainer, {
      noZIndex: state === "hidden",
      onOutsideClick: onQuit,
      onEscape: onQuit,
      children: [
        /* @__PURE__ */ jsx45(ModalHeader, {
          title: "Ask AI",
          onClose: onQuit
        }),
        /* @__PURE__ */ jsx45("iframe", {
          ref: iframe,
          frameBorder: 0,
          style: container13,
          src: "https://www.remotion.dev/ai-embed",
          allow: "clipboard-read; clipboard-write"
        })
      ]
    })
  });
};

// src/components/SizeSelector.tsx
import { useContext as useContext20, useMemo as useMemo35 } from "react";
import { Internals as Internals14 } from "remotion";

// src/icons/Checkmark.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var style2 = {
  width: 14,
  height: 14
};
var Checkmark = () => /* @__PURE__ */ jsx46("svg", {
  focusable: "false",
  role: "img",
  viewBox: "0 0 512 512",
  style: style2,
  children: /* @__PURE__ */ jsx46("path", {
    fill: "currentColor",
    d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
  })
});

// src/components/ControlButton.tsx
import { useMemo as useMemo29 } from "react";
import { jsx as jsx47 } from "react/jsx-runtime";
var CONTROL_BUTTON_PADDING = 6;
var ControlButton = (props) => {
  const style3 = useMemo29(() => {
    return {
      opacity: props.disabled ? 0.5 : 1,
      display: "inline-flex",
      background: "none",
      border: "none",
      padding: CONTROL_BUTTON_PADDING
    };
  }, [props.disabled]);
  const { tabIndex } = useZIndex();
  return /* @__PURE__ */ jsx47("button", {
    type: "button",
    tabIndex,
    ...props,
    style: style3
  });
};

// src/components/NewComposition/ComboBox.tsx
import { PlayerInternals as PlayerInternals5 } from "@remotion/player";
import { useCallback as useCallback26, useEffect as useEffect17, useMemo as useMemo30, useRef as useRef14, useState as useState23 } from "react";
import ReactDOM4 from "react-dom";
import { jsx as jsx48, jsxs as jsxs16, Fragment as Fragment6 } from "react/jsx-runtime";
var container14 = {
  padding: "8px 10px",
  display: "inline-block",
  backgroundColor: INPUT_BACKGROUND,
  borderWidth: 1,
  borderStyle: "solid",
  maxWidth: "100%"
};
var label2 = {
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  fontSize: 14,
  textAlign: "left"
};
var Combobox = ({ values, selectedId, style: customStyle, title: title3 }) => {
  const [hovered, setIsHovered] = useState23(false);
  const [opened, setOpened] = useState23(false);
  const ref = useRef14(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size = PlayerInternals5.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size?.refresh;
  const onHide = useCallback26(() => {
    setOpened(false);
  }, []);
  useEffect17(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerDown = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        if (!o) {
          refresh?.();
          window.addEventListener("pointerup", (evt) => {
            if (!isMenuItem(evt.target)) {
              setOpened(false);
            }
          }, {
            once: true
          });
        }
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerdown", onPointerDown);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerdown", onPointerDown);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const spaceToBottom = useMemo30(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.windowSize.height - (size.top + size.height) - margin2;
    }
    return 0;
  }, [opened, size]);
  const spaceToTop = useMemo30(() => {
    const margin2 = 10;
    if (size && opened) {
      return size.top - margin2;
    }
    return 0;
  }, [opened, size]);
  const derivedMaxHeight = useMemo30(() => {
    return spaceToTop > spaceToBottom ? spaceToTop : spaceToBottom;
  }, [spaceToBottom, spaceToTop]);
  const isMobileLayout = useMobileLayout();
  const portalStyle = useMemo30(() => {
    if (!opened || !size) {
      return null;
    }
    const spaceToRight = size.windowSize.width - size.left;
    const spaceToLeft = size.left + size.width;
    const minSpaceRequired = isMobileLayout ? MAX_MOBILE_MENU_WIDTH : MAX_MENU_WIDTH;
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    const canOpenOnLeft = spaceToLeft >= minSpaceRequired;
    const canOpenOnRight = spaceToRight >= minSpaceRequired;
    const horizontalLayout = canOpenOnRight ? "left" : "right";
    return {
      ...verticalLayout === "top" ? {
        ...menuContainerTowardsBottom,
        top: size.top + size.height
      } : {
        ...menuContainerTowardsTop,
        bottom: size.windowSize.height - size.top
      },
      ...horizontalLayout === "left" ? {
        left: size.left
      } : canOpenOnLeft ? {
        right: size.windowSize.width - size.left - size.width
      } : { left: 0 }
    };
  }, [isMobileLayout, opened, size, spaceToBottom, spaceToTop]);
  const selected = values.find((v) => v.id === selectedId);
  const style3 = useMemo30(() => {
    return {
      ...container14,
      ...customStyle ?? {},
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      borderColor: opened ? SELECTED_BACKGROUND : hovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED
    };
  }, [customStyle, hovered, opened]);
  return /* @__PURE__ */ jsxs16(Fragment6, {
    children: [
      /* @__PURE__ */ jsxs16("button", {
        ref,
        title: title3,
        tabIndex,
        type: "button",
        style: style3,
        className: MENU_INITIATOR_CLASSNAME,
        children: [
          selected ? /* @__PURE__ */ jsx48("div", {
            title: typeof selected.label === "string" ? selected.label : undefined,
            style: label2,
            children: selected?.label
          }) : null,
          /* @__PURE__ */ jsx48(Spacing, {
            x: 1
          }),
          " ",
          /* @__PURE__ */ jsx48(CaretDown, {})
        ]
      }),
      portalStyle ? ReactDOM4.createPortal(/* @__PURE__ */ jsx48("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx48("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx48(HigherZIndex, {
            onOutsideClick: onHide,
            onEscape: onHide,
            children: /* @__PURE__ */ jsx48("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx48(MenuContent, {
                onNextMenu: noop,
                onPreviousMenu: noop,
                values,
                onHide,
                leaveLeftSpace: true,
                preselectIndex: values.findIndex((v) => selected && v.id === selected.id),
                topItemCanBeUnselected: false,
                fixedHeight: derivedMaxHeight
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/Preview.tsx
import { PlayerInternals as PlayerInternals6 } from "@remotion/player";
import { useContext as useContext19, useEffect as useEffect23, useMemo as useMemo34, useRef as useRef17 } from "react";
import { Internals as Internals13 } from "remotion";

// src/helpers/checkerboard-background.ts
var getCheckerboardBackgroundSize = (size) => `${size}px ${size}px`;
var getCheckerboardBackgroundPos = (size) => `0 0, ${size / 2}px 0, ${size / 2}px -${size / 2}px, 0px ${size / 2}px`;
var checkerboardBackgroundColor = (checkerboard) => {
  if (checkerboard) {
    return "white";
  }
  return "black";
};
var checkerboardBackgroundImage = (checkerboard) => {
  if (checkerboard) {
    return `
     linear-gradient(
        45deg,
        rgba(0, 0, 0, 0.1) 25%,
        transparent 25%
      ),
      linear-gradient(135deg, rgba(0, 0, 0, 0.1) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%),
      linear-gradient(135deg, transparent 75%, rgba(0, 0, 0, 0.1) 75%)
    `;
  }
  return;
};

// src/state/checkerboard.ts
import { createContext as createContext11 } from "react";
var persistCheckerboardOption = (option) => {
  localStorage.setItem("option", String(option));
};
var loadCheckerboardOption = () => {
  const item = localStorage.getItem("option");
  return item !== "false";
};
var CheckerboardContext = createContext11({
  checkerboard: loadCheckerboardOption(),
  setCheckerboard: () => {
    return;
  }
});

// src/components/RenderPreview.tsx
import { useContext as useContext17, useEffect as useEffect22, useState as useState28 } from "react";

// src/helpers/get-asset-metadata.ts
import { getVideoMetadata } from "@remotion/media-utils";
import { staticFile as staticFile2 } from "remotion";
var remotion_outputsBase = window.remotion_staticBase.replace("static", "outputs");
var getSrcFromCanvasContent = (canvasContent) => {
  if (canvasContent.type === "asset") {
    return staticFile2(canvasContent.asset);
  }
  return remotion_outputsBase + canvasContent.path;
};
var getAssetMetadata = async (canvasContent, addTime) => {
  if (canvasContent.type === "output-blob") {
    return {
      type: "found",
      size: canvasContent.sizeInBytes,
      dimensions: { width: canvasContent.width, height: canvasContent.height },
      fetchedAt: Date.now()
    };
  }
  if (canvasContent.type === "composition") {
    throw new Error("cannot get dimensions for composition");
  }
  const src = getSrcFromCanvasContent(canvasContent);
  const file = await fetch(src, {
    method: "HEAD"
  });
  if (file.status === 404) {
    return { type: "not-found" };
  }
  if (file.status !== 200) {
    throw new Error(`Expected status code 200 or 404 for file, got ${file.status}`);
  }
  const size = file.headers.get("content-length");
  if (!size) {
    throw new Error("Unexpected error: content-length is null");
  }
  const fetchedAt = Date.now();
  const srcWithTime = addTime ? `${src}?date=${fetchedAt}` : src;
  const fileType = getPreviewFileType(src);
  if (fileType === "video") {
    const resolution = await getVideoMetadata(srcWithTime);
    return {
      type: "found",
      size: Number(size),
      dimensions: { width: resolution.width, height: resolution.height },
      fetchedAt
    };
  }
  if (fileType === "image") {
    const resolution = await new Promise((resolve, reject) => {
      const img = new Image;
      img.onload = () => {
        resolve({
          type: "found",
          size: Number(size),
          dimensions: { width: img.width, height: img.height },
          fetchedAt
        });
      };
      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };
      img.src = srcWithTime;
    });
    return resolution;
  }
  return {
    type: "found",
    dimensions: "none",
    size: Number(size),
    fetchedAt
  };
};

// src/components/FilePreview.tsx
import { formatBytes as formatBytes2 } from "@remotion/studio-shared";

// src/components/JSONViewer.tsx
import { useEffect as useEffect20, useState as useState26 } from "react";

// src/components/NewComposition/RemTextarea.tsx
import {
  forwardRef as forwardRef2,
  useEffect as useEffect19,
  useImperativeHandle as useImperativeHandle8,
  useMemo as useMemo32,
  useRef as useRef16,
  useState as useState25
} from "react";

// src/components/NewComposition/RemInput.tsx
import {
  forwardRef,
  useEffect as useEffect18,
  useImperativeHandle as useImperativeHandle7,
  useMemo as useMemo31,
  useRef as useRef15,
  useState as useState24
} from "react";
import { jsx as jsx49 } from "react/jsx-runtime";
var INPUT_HORIZONTAL_PADDING = 8;
var aligner = {
  marginRight: -INPUT_HORIZONTAL_PADDING
};
var RightAlignInput = ({ children }) => {
  return /* @__PURE__ */ jsx49("div", {
    style: aligner,
    children
  });
};
var inputBaseStyle = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14
};
var getInputBorderColor = ({
  status,
  isFocused,
  isHovered
}) => status === "warning" ? WARNING_COLOR : status === "error" ? FAIL_COLOR : isFocused ? SELECTED_BACKGROUND : isHovered ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED;
var RemInputForwardRef = ({ status, rightAlign, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState24(false);
  const [isHovered, setIsHovered] = useState24(false);
  const inputRef = useRef15(null);
  const { tabIndex } = useZIndex();
  const style3 = useMemo31(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      textAlign: rightAlign ? "right" : "left",
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, rightAlign, props.style, status]);
  useImperativeHandle7(ref, () => {
    return inputRef.current;
  }, []);
  useEffect18(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx49("input", {
    ref: inputRef,
    tabIndex,
    ...props,
    style: style3
  });
};
var RemotionInput = forwardRef(RemInputForwardRef);

// src/components/NewComposition/RemTextarea.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var inputBaseStyle2 = {
  padding: `${INPUT_HORIZONTAL_PADDING}px 10px`,
  color: "white",
  borderStyle: "solid",
  borderWidth: 1,
  fontSize: 14,
  resize: "none",
  overflowX: "hidden"
};
var RemTextareaFRFunction = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState25(false);
  const [isHovered, setIsHovered] = useState25(false);
  const inputRef = useRef16(null);
  const { tabIndex } = useZIndex();
  useImperativeHandle8(ref, () => {
    return inputRef.current;
  }, []);
  const style3 = useMemo32(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle2,
      width: "100%",
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useEffect19(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onKeyDown = (e) => {
      if (!inputRef.current) {
        return;
      }
      if (inputRef.current !== document.activeElement) {
        return;
      }
      if (e.code === "Tab") {
        e.preventDefault();
        document.execCommand("insertText", false, " ".repeat(2));
      }
      if (e.code === "Enter") {
        e.preventDefault();
        const { selectionStart, selectionEnd, value } = inputRef.current;
        if (selectionStart !== selectionEnd) {
          return;
        }
        let prevNewline = selectionStart;
        for (let i = selectionStart - 1;i >= 0; i--) {
          if (value[i] === `
`) {
            break;
          }
          prevNewline = i;
        }
        const currentLine = value.substring(prevNewline, selectionStart);
        const trimmed = currentLine.trim();
        const difference = currentLine.length - trimmed.length;
        document.execCommand("insertText", false, `
` + " ".repeat(difference));
      }
    };
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("keydown", onKeyDown);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("keydown", onKeyDown);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx50("textarea", {
    ref: inputRef,
    tabIndex,
    ...props,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    style: style3
  });
};
var RemTextarea = forwardRef2(RemTextareaFRFunction);

// src/components/JSONViewer.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var jsonStyle = {
  marginTop: 14,
  marginBottom: 14,
  fontFamily: "monospace",
  flex: 1
};
var JSONViewer = ({ src }) => {
  const [json, setJson] = useState26(null);
  useEffect20(() => {
    fetch(src).then((res) => res.json()).then((jsonRes) => {
      setJson(JSON.stringify(jsonRes, null, 2));
    });
  }, [src]);
  return /* @__PURE__ */ jsx51(RemTextarea, {
    value: json ?? undefined,
    status: "ok",
    onChange: () => {
      return null;
    },
    style: jsonStyle
  });
};

// src/components/TextViewer.tsx
import { useEffect as useEffect21, useState as useState27 } from "react";
import { jsxs as jsxs17 } from "react/jsx-runtime";
var textStyle = {
  margin: 14,
  fontFamily: "monospace",
  flex: 1,
  color: "white",
  whiteSpace: "pre-wrap"
};
var TextViewer = ({ src }) => {
  const [txt, setTxt] = useState27("");
  useEffect21(() => {
    fetch(src).then(async (res) => {
      if (!res.ok || !res.body) {
        return;
      }
      const text = await res.text();
      setTxt(text);
    });
  }, [src]);
  return /* @__PURE__ */ jsxs17("div", {
    style: textStyle,
    children: [
      txt,
      " "
    ]
  });
};

// src/components/FilePreview.tsx
import { jsx as jsx52, jsxs as jsxs18, Fragment as Fragment7 } from "react/jsx-runtime";
var msgStyle = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var FilePreview = ({ fileType, src, currentAsset, assetMetadata }) => {
  if (!assetMetadata) {
    throw new Error("expected to have assetMetadata");
  }
  if (assetMetadata.type === "not-found") {
    throw new Error('expected to have assetMetadata, got "not-found"');
  }
  if (fileType === "audio") {
    return /* @__PURE__ */ jsx52("audio", {
      src,
      controls: true
    });
  }
  if (fileType === "video") {
    return /* @__PURE__ */ jsx52("video", {
      src,
      controls: true
    });
  }
  if (fileType === "image") {
    return /* @__PURE__ */ jsx52("img", {
      src
    });
  }
  if (fileType === "json") {
    return /* @__PURE__ */ jsx52(JSONViewer, {
      src
    });
  }
  if (fileType === "txt") {
    return /* @__PURE__ */ jsx52(TextViewer, {
      src
    });
  }
  return /* @__PURE__ */ jsxs18(Fragment7, {
    children: [
      /* @__PURE__ */ jsx52("div", {
        style: msgStyle,
        children: currentAsset
      }),
      /* @__PURE__ */ jsx52(Spacing, {
        y: 0.5
      }),
      /* @__PURE__ */ jsxs18("div", {
        style: msgStyle,
        children: [
          "Size: ",
          formatBytes2(assetMetadata.size),
          " "
        ]
      })
    ]
  });
};

// src/components/RenderPreview.tsx
import { jsx as jsx53, jsxs as jsxs19 } from "react/jsx-runtime";
var msgStyle2 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle = {
  ...msgStyle2,
  color: LIGHT_TEXT
};
var RenderPreview = ({ path, assetMetadata, getBlob }) => {
  const fileType = getPreviewFileType(path);
  const connectionStatus = useContext17(StudioServerConnectionCtx).previewServerState.type;
  const [blobUrl, setBlobUrl] = useState28(null);
  const [blobError, setBlobError] = useState28(null);
  useEffect22(() => {
    if (!getBlob) {
      setBlobUrl(null);
      setBlobError(null);
      return;
    }
    let cancelled = false;
    let blobUrlToRevoke = null;
    setBlobError(null);
    getBlob().then((blob) => {
      const url = URL.createObjectURL(blob);
      if (cancelled) {
        URL.revokeObjectURL(url);
        return;
      }
      blobUrlToRevoke = url;
      setBlobUrl(url);
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      setBlobError(err instanceof Error ? err : new Error(String(err)));
    });
    return () => {
      cancelled = true;
      if (blobUrlToRevoke) {
        URL.revokeObjectURL(blobUrlToRevoke);
      }
    };
  }, [getBlob]);
  const src = blobUrl ?? remotion_outputsBase + path;
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsx53("div", {
      style: errMsgStyle,
      children: "Studio server disconnected"
    });
  }
  if (getBlob && blobError) {
    return /* @__PURE__ */ jsxs19("div", {
      style: errMsgStyle,
      children: [
        "Failed to load preview: ",
        blobError.message
      ]
    });
  }
  if (getBlob && !blobUrl) {
    return /* @__PURE__ */ jsx53("div", {
      style: msgStyle2,
      children: "Loading preview..."
    });
  }
  return /* @__PURE__ */ jsx53(FilePreview, {
    assetMetadata,
    currentAsset: path,
    fileType,
    src
  });
};

// src/components/Spinner.tsx
import { useMemo as useMemo33 } from "react";
import { jsx as jsx54, jsxs as jsxs20, Fragment as Fragment8 } from "react/jsx-runtime";
var viewBox = 100;
var lines = 8;
var className = "__remotion_spinner_line";
var remotionSpinnerAnimation = "__remotion_spinner_animation";
var translated = "M 44 0 L 50 0 a 6 6 0 0 1 6 6 L 56 26 a 6 6 0 0 1 -6 6 L 50 32 a 6 6 0 0 1 -6 -6 L 44 6 a 6 6 0 0 1 6 -6 Z";
var Spinner = ({ size, duration }) => {
  const style3 = useMemo33(() => {
    return {
      width: size,
      height: size
    };
  }, [size]);
  return /* @__PURE__ */ jsxs20(Fragment8, {
    children: [
      /* @__PURE__ */ jsx54("style", {
        type: "text/css",
        children: `
				@keyframes ${remotionSpinnerAnimation} {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0.15;
          }
        }
        
        .${className} {
            animation: ${remotionSpinnerAnimation} ${duration}s linear infinite;
        }        
			`
      }),
      /* @__PURE__ */ jsx54("svg", {
        style: style3,
        viewBox: `0 0 ${viewBox} ${viewBox}`,
        children: new Array(lines).fill(true).map((_, index) => {
          return /* @__PURE__ */ jsx54("path", {
            className,
            style: {
              rotate: `${index * Math.PI * 2 / lines}rad`,
              transformOrigin: "center center",
              animationDelay: `${index * (duration / lines) - duration}s`
            },
            d: translated,
            fill: LIGHT_TEXT
          }, index);
        })
      })
    ]
  });
};

// src/components/StaticFilePreview.tsx
import { useContext as useContext18 } from "react";
import { staticFile as staticFile3 } from "remotion";
import { jsx as jsx55, jsxs as jsxs21 } from "react/jsx-runtime";
var msgStyle3 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif",
  display: "flex",
  justifyContent: "center"
};
var errMsgStyle2 = {
  ...msgStyle3,
  color: LIGHT_TEXT
};
var StaticFilePreview = ({ currentAsset, assetMetadata }) => {
  const fileType = getPreviewFileType(currentAsset);
  const staticFileSrc = staticFile3(currentAsset);
  const staticFiles = useStaticFiles();
  const connectionStatus = useContext18(StudioServerConnectionCtx).previewServerState.type;
  const exists = staticFiles.find((file) => file.name === currentAsset);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsx55("div", {
      style: errMsgStyle2,
      children: "Studio server disconnected"
    });
  }
  if (!exists) {
    return /* @__PURE__ */ jsxs21("div", {
      style: errMsgStyle2,
      children: [
        currentAsset,
        " does not exist in your public folder."
      ]
    });
  }
  if (!currentAsset) {
    return null;
  }
  return /* @__PURE__ */ jsx55(FilePreview, {
    currentAsset,
    fileType,
    src: `${staticFileSrc}?date=${assetMetadata && assetMetadata.type === "found" ? assetMetadata.fetchedAt : 0}`,
    assetMetadata
  });
};

// src/components/Preview.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var centeredContainer = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center"
};
var label3 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var getPreviewFileType = (fileName) => {
  if (!fileName) {
    return "other";
  }
  const audioExtensions = ["mp3", "wav", "ogg", "aac"];
  const videoExtensions = ["mp4", "avi", "mkv", "mov", "webm"];
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const fileExtension = fileName.split(".").pop()?.toLowerCase();
  if (fileExtension === undefined) {
    throw new Error("File extension is undefined");
  }
  if (audioExtensions.includes(fileExtension)) {
    return "audio";
  }
  if (videoExtensions.includes(fileExtension)) {
    return "video";
  }
  if (imageExtensions.includes(fileExtension)) {
    return "image";
  }
  if (fileExtension === "json") {
    return "json";
  }
  if (fileExtension === "txt") {
    return "txt";
  }
  return "other";
};
var checkerboardSize = 49;
var containerStyle = (options) => {
  return {
    transform: `scale(${options.scale})`,
    marginLeft: options.xCorrection,
    marginTop: options.yCorrection,
    width: options.width,
    height: options.height,
    display: "flex",
    position: "absolute",
    backgroundColor: checkerboardBackgroundColor(options.checkerboard),
    backgroundImage: checkerboardBackgroundImage(options.checkerboard),
    backgroundSize: getCheckerboardBackgroundSize(checkerboardSize),
    backgroundPosition: getCheckerboardBackgroundPos(checkerboardSize)
  };
};
var VideoPreview = ({ canvasSize, contentDimensions, canvasContent, assetMetadata }) => {
  if (assetMetadata && assetMetadata.type === "not-found") {
    return /* @__PURE__ */ jsx56("div", {
      style: centeredContainer,
      children: /* @__PURE__ */ jsx56("div", {
        style: label3,
        children: "File does not exist"
      })
    });
  }
  if (contentDimensions === null) {
    return /* @__PURE__ */ jsx56("div", {
      style: centeredContainer,
      children: /* @__PURE__ */ jsx56(Spinner, {
        duration: 0.5,
        size: 24
      })
    });
  }
  return /* @__PURE__ */ jsx56(CompWhenItHasDimensions, {
    contentDimensions,
    canvasSize,
    canvasContent,
    assetMetadata
  });
};
var CompWhenItHasDimensions = ({ contentDimensions, canvasSize, canvasContent, assetMetadata }) => {
  const { size: previewSize } = useContext19(Internals13.PreviewSizeContext);
  const { centerX, centerY, yCorrection, xCorrection, scale } = useMemo34(() => {
    if (contentDimensions === "none") {
      return {
        centerX: 0,
        centerY: 0,
        yCorrection: 0,
        xCorrection: 0,
        scale: 1
      };
    }
    return PlayerInternals6.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [canvasSize, contentDimensions, previewSize.size]);
  const outer = useMemo34(() => {
    return {
      width: contentDimensions === "none" ? "100%" : contentDimensions.width * scale,
      height: contentDimensions === "none" ? "100%" : contentDimensions.height * scale,
      display: "flex",
      flexDirection: "column",
      position: "absolute",
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      overflow: "hidden",
      justifyContent: canvasContent.type === "asset" ? "center" : "flex-start",
      alignItems: canvasContent.type === "asset" && getPreviewFileType(canvasContent.asset) === "audio" ? "center" : "normal"
    };
  }, [
    contentDimensions,
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasContent
  ]);
  if (canvasContent.type === "asset") {
    return /* @__PURE__ */ jsx56("div", {
      style: outer,
      children: /* @__PURE__ */ jsx56(StaticFilePreview, {
        assetMetadata,
        currentAsset: canvasContent.asset
      })
    });
  }
  if (canvasContent.type === "output") {
    return /* @__PURE__ */ jsx56("div", {
      style: outer,
      children: /* @__PURE__ */ jsx56(RenderPreview, {
        path: canvasContent.path,
        assetMetadata
      })
    });
  }
  if (canvasContent.type === "output-blob") {
    return /* @__PURE__ */ jsx56("div", {
      style: outer,
      children: /* @__PURE__ */ jsx56(RenderPreview, {
        path: canvasContent.displayName,
        assetMetadata,
        getBlob: canvasContent.getBlob
      })
    });
  }
  return /* @__PURE__ */ jsx56("div", {
    style: outer,
    children: /* @__PURE__ */ jsx56(PortalContainer, {
      contentDimensions,
      scale,
      xCorrection,
      yCorrection
    })
  });
};
var PortalContainer = ({ scale, xCorrection, yCorrection, contentDimensions }) => {
  const { checkerboard } = useContext19(CheckerboardContext);
  const style3 = useMemo34(() => {
    return containerStyle({
      checkerboard,
      scale,
      xCorrection,
      yCorrection,
      width: contentDimensions.width,
      height: contentDimensions.height
    });
  }, [
    checkerboard,
    contentDimensions.height,
    contentDimensions.width,
    scale,
    xCorrection,
    yCorrection
  ]);
  useEffect23(() => {
    const { current } = portalContainer;
    current?.appendChild(Internals13.portalNode());
    return () => {
      current?.removeChild(Internals13.portalNode());
    };
  }, []);
  const portalContainer = useRef17(null);
  return /* @__PURE__ */ jsx56("div", {
    ref: portalContainer,
    style: style3
  });
};

// src/components/SizeSelector.tsx
import { jsx as jsx57 } from "react/jsx-runtime";
var commonPreviewSizes = [
  {
    size: "auto",
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.25,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 0.5,
    translation: {
      x: 0,
      y: 0
    }
  },
  {
    size: 1,
    translation: {
      x: 0,
      y: 0
    }
  }
];
var getPreviewSizeLabel = (previewSize) => {
  if (previewSize.size === "auto") {
    return "Fit";
  }
  return `${(previewSize.size * 100).toFixed(0)}%`;
};
var accessibilityLabel = "Preview Size";
var comboStyle = { width: 80 };
var getUniqueSizes = (size) => {
  const customPreviewSizes = [size, ...commonPreviewSizes];
  const uniqueSizes = [];
  customPreviewSizes.forEach((p) => {
    if (!uniqueSizes.find((s) => s.size === p.size)) {
      uniqueSizes.push(p);
    }
  });
  return uniqueSizes.sort((a, b) => {
    if (a.size === "auto") {
      return -1;
    }
    if (b.size === "auto") {
      return 1;
    }
    return a.size - b.size;
  });
};
var zoomableFileTypes = ["video", "image"];
var SizeSelector = () => {
  const { size, setSize } = useContext20(Internals14.PreviewSizeContext);
  const { canvasContent } = useContext20(Internals14.CompositionManager);
  const style3 = useMemo35(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const zoomable = useMemo35(() => {
    if (!canvasContent) {
      return null;
    }
    if (canvasContent.type === "composition") {
      return true;
    }
    if (canvasContent.type === "asset" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.asset))) {
      return true;
    }
    if (canvasContent.type === "output" && zoomableFileTypes.includes(getPreviewFileType(canvasContent.path))) {
      return true;
    }
    return false;
  }, [canvasContent]);
  const items = useMemo35(() => {
    return getUniqueSizes(size).map((newSize) => {
      return {
        id: String(newSize.size),
        label: getPreviewSizeLabel(newSize),
        onClick: () => {
          return setSize(() => {
            return newSize;
          });
        },
        type: "item",
        value: newSize.size,
        keyHint: newSize.size === "auto" ? "0" : null,
        leftItem: String(size.size) === String(newSize.size) ? /* @__PURE__ */ jsx57(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
  }, [setSize, size]);
  if (!zoomable) {
    return null;
  }
  return /* @__PURE__ */ jsx57("div", {
    style: style3,
    "aria-label": accessibilityLabel,
    children: /* @__PURE__ */ jsx57(Combobox, {
      title: accessibilityLabel,
      style: comboStyle,
      selectedId: String(size.size),
      values: items
    })
  });
};

// src/components/TimelineInOutToggle.tsx
import { PlayerInternals as PlayerInternals7 } from "@remotion/player";
import {
  createRef as createRef7,
  useCallback as useCallback27,
  useEffect as useEffect24,
  useImperativeHandle as useImperativeHandle9
} from "react";
import { Internals as Internals16 } from "remotion";
import { NoReactInternals as NoReactInternals4 } from "remotion/no-react";

// src/icons/timelineInOutPointer.tsx
import { jsx as jsx58 } from "react/jsx-runtime";
var TimelineInPointer = (props) => {
  return /* @__PURE__ */ jsx58("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx58("path", {
      d: "M158 25H99V230.5H158",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var TimelineOutPointer = (props) => {
  return /* @__PURE__ */ jsx58("svg", {
    viewBox: "0 0 256 256",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx58("path", {
      d: "M98 25H157V230.5H98",
      stroke: props.color,
      strokeWidth: "42",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

// src/state/in-out.ts
import { createContext as createContext12, useContext as useContext21, useMemo as useMemo36 } from "react";
import { Internals as Internals15 } from "remotion";
var TimelineInOutContext = createContext12({});
var SetTimelineInOutContext = createContext12({
  setInAndOutFrames: () => {
    throw new Error("default");
  }
});
var useTimelineInOutFramePosition = () => {
  const videoConfig = Internals15.useUnsafeVideoConfig();
  const state = useContext21(TimelineInOutContext);
  const id = videoConfig?.id;
  const durationInFrames = videoConfig?.durationInFrames;
  return useMemo36(() => {
    if (!id || !durationInFrames) {
      return { inFrame: null, outFrame: null };
    }
    const maxFrame = durationInFrames - 1;
    const actualInFrame = state[id]?.inFrame ?? null;
    const actualOutFrame = state[id]?.outFrame ?? null;
    return {
      inFrame: actualInFrame === null ? null : actualInFrame >= maxFrame ? null : actualInFrame,
      outFrame: actualOutFrame === null ? null : actualOutFrame >= maxFrame ? null : actualOutFrame
    };
  }, [durationInFrames, id, state]);
};
var useTimelineSetInOutFramePosition = () => {
  const { setInAndOutFrames } = useContext21(SetTimelineInOutContext);
  return { setInAndOutFrames };
};

// src/components/TimelineInOutToggle.tsx
import { jsx as jsx59, jsxs as jsxs22, Fragment as Fragment9 } from "react/jsx-runtime";
var getTooltipText = (pointType, key) => [
  `Mark ${pointType}`,
  areKeyboardShortcutsDisabled() ? null : `(${key})`,
  "- right click to clear"
].filter(NoReactInternals4.truthy).join(" ");
var style3 = {
  width: 16,
  height: 16
};
var inOutHandles = createRef7();
var defaultInOutValue = { inFrame: null, outFrame: null };
var TimelineInOutPointToggle = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const videoConfig = Internals16.useUnsafeVideoConfig();
  const keybindings = useKeybinding();
  const { getCurrentFrame: getCurrentFrame2, isFirstFrame, isLastFrame } = PlayerInternals7.usePlayer();
  const onInOutClear = useCallback27((composition) => {
    setInAndOutFrames((prev) => {
      return {
        ...prev,
        [composition]: {
          inFrame: null,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames]);
  const onInMark = useCallback27((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((prev) => {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      });
      return null;
    }
    setInAndOutFrames((prev) => {
      const prevOut = prev[videoConfig.id]?.outFrame;
      const biggestPossible = prevOut === undefined || prevOut === null ? Infinity : prevOut - 1;
      const selected = Math.min(getCurrentFrame2(), biggestPossible);
      if (selected === 0) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        };
      }
      const prevIn = prev[videoConfig.id]?.inFrame;
      if (prevIn !== null && prevIn !== undefined) {
        if (prevIn === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: selected
        }
      };
    });
  }, [getCurrentFrame2, setInAndOutFrames, videoConfig]);
  const clearInMark = useCallback27((e) => {
    if (!videoConfig) {
      return null;
    }
    e.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          inFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const clearOutMark = useCallback27((e) => {
    if (!videoConfig) {
      return null;
    }
    e?.preventDefault();
    setInAndOutFrames((f) => {
      return {
        ...f,
        [videoConfig.id]: {
          ...f[videoConfig.id] ?? defaultInOutValue,
          outFrame: null
        }
      };
    });
  }, [setInAndOutFrames, videoConfig]);
  const onOutMark = useCallback27((e) => {
    if (!videoConfig) {
      return null;
    }
    if (e?.shiftKey) {
      setInAndOutFrames((f) => {
        return {
          ...f,
          [videoConfig.id]: {
            ...f[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      });
      return;
    }
    setInAndOutFrames((prev) => {
      const prevInFrame = prev[videoConfig.id]?.inFrame;
      const smallestPossible = prevInFrame === null || prevInFrame === undefined ? -Infinity : prevInFrame + 1;
      const selected = Math.max(getCurrentFrame2(), smallestPossible);
      if (selected === videoConfig.durationInFrames - 1) {
        return {
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        };
      }
      const prevOut = prev[videoConfig.id]?.outFrame;
      if (prevOut !== null && prevOut !== undefined) {
        if (prevOut === selected) {
          return {
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          };
        }
      }
      return {
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: selected
        }
      };
    });
  }, [getCurrentFrame2, setInAndOutFrames, videoConfig]);
  const confId = videoConfig?.id;
  useEffect24(() => {
    if (!confId) {
      return;
    }
    const iKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "i",
      callback: (e) => {
        onInMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const oKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "o",
      callback: (e) => {
        onOutMark(e);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const xKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "x",
      callback: () => {
        onInOutClear(confId);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      oKey.unregister();
      iKey.unregister();
      xKey.unregister();
    };
  }, [confId, keybindings, onInMark, onInOutClear, onOutMark]);
  useImperativeHandle9(inOutHandles, () => {
    return {
      clearMarks: () => {
        if (!confId) {
          return;
        }
        onInOutClear(confId);
      },
      inMarkClick: onInMark,
      outMarkClick: onOutMark
    };
  }, [confId, onInMark, onInOutClear, onOutMark]);
  return /* @__PURE__ */ jsxs22(Fragment9, {
    children: [
      /* @__PURE__ */ jsx59(ControlButton, {
        title: getTooltipText("In", "I"),
        "aria-label": getTooltipText("In", "I"),
        onClick: onInMark,
        onContextMenu: clearInMark,
        disabled: !videoConfig || isFirstFrame,
        children: /* @__PURE__ */ jsx59(TimelineInPointer, {
          color: inFrame === null ? "white" : BLUE,
          style: style3
        })
      }),
      /* @__PURE__ */ jsx59(ControlButton, {
        title: getTooltipText("Out", "O"),
        "aria-label": getTooltipText("Out", "O"),
        onClick: onOutMark,
        onContextMenu: clearOutMark,
        disabled: !videoConfig || isLastFrame,
        children: /* @__PURE__ */ jsx59(TimelineOutPointer, {
          color: outFrame === null ? "white" : BLUE,
          style: style3
        })
      })
    ]
  });
};

// src/state/editor-guides.ts
import { createContext as createContext13 } from "react";
var persistEditorShowGuidesOption = (option) => {
  localStorage.setItem("remotion.editorShowGuides", String(option));
};
var loadEditorShowGuidesOption = () => {
  const item = localStorage.getItem("remotion.editorShowGuides");
  return item === "true";
};
var persistGuidesList = (guides) => {
  localStorage.setItem("remotion.guidesList", JSON.stringify(guides));
};
var loadGuidesList = () => {
  const item = localStorage.getItem("remotion.guidesList");
  return item ? JSON.parse(item) : [];
};
var EditorShowGuidesContext = createContext13({
  editorShowGuides: false,
  setEditorShowGuides: () => {
    return;
  },
  guidesList: [],
  setGuidesList: () => {
    return;
  },
  selectedGuideId: null,
  setSelectedGuideId: () => {
    return;
  },
  shouldCreateGuideRef: { current: false },
  shouldDeleteGuideRef: { current: false },
  hoveredGuideId: null,
  setHoveredGuideId: () => {
    return;
  }
});

// src/state/editor-rulers.ts
import { createContext as createContext14 } from "react";
var persistEditorShowRulersOption = (option) => {
  localStorage.setItem("remotion.editorShowRulers", String(option));
};
var loadEditorShowRulersOption = () => {
  const item = localStorage.getItem("remotion.editorShowRulers");
  return item === "true";
};
var EditorShowRulersContext = createContext14({
  editorShowRulers: loadEditorShowRulersOption(),
  setEditorShowRulers: () => {
    return;
  }
});
var RULER_WIDTH = 20;
var MINIMUM_VISIBLE_CANVAS_SIZE = 50;
var PREDEFINED_RULER_SCALE_GAPS = [
  1,
  2,
  5,
  10,
  20,
  50,
  100,
  250,
  500,
  1000,
  2000,
  5000
];
var MAXIMUM_PREDEFINED_RULER_SCALE_GAP = 5000;
var MINIMUM_RULER_MARKING_GAP_PX = 50;

// src/state/editor-zoom-gestures.ts
import { createContext as createContext15 } from "react";
var persistEditorZoomGesturesOption = (option) => {
  localStorage.setItem("remotion.editorZoomGestures", String(option));
};
var loadEditorZoomGesturesOption = () => {
  const item = localStorage.getItem("remotion.editorZoomGestures");
  return item !== "false";
};
var EditorZoomGesturesContext = createContext15({
  editorZoomGestures: loadEditorZoomGesturesOption(),
  setEditorZoomGestures: () => {
    return;
  }
});

// src/helpers/check-fullscreen-support.ts
var checkFullscreenSupport = () => {
  return document.fullscreenEnabled || document.webkitFullscreenEnabled;
};

// src/helpers/get-git-menu-item.ts
var getGitSourceName = (gitSource) => {
  if (gitSource.type === "github") {
    return "GitHub";
  }
  throw new Error("Unknown git source type");
};
var getGitSourceBranchUrl = (gitSource) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}${gitSource.relativeFromGitRoot ? `/${gitSource.relativeFromGitRoot}` : ""}`;
  }
  throw new Error("Unknown git source type");
};
var getGitRefUrl = (gitSource, originalLocation) => {
  if (gitSource.type === "github") {
    return `https://github.com/${gitSource.org}/${gitSource.name}/tree/${gitSource.ref}/${gitSource.relativeFromGitRoot ? `${gitSource.relativeFromGitRoot}/` : ""}${originalLocation.source}#L${originalLocation.line}`;
  }
  throw new Error("Unknown git source type");
};
var getGitMenuItem = () => {
  if (!window.remotion_gitSource) {
    return null;
  }
  return {
    id: "open-git-source",
    value: "open-git-source",
    label: `Open ${getGitSourceName(window.remotion_gitSource)} Repo`,
    onClick: () => {
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    },
    type: "item",
    keyHint: null,
    leftItem: null,
    subMenu: null,
    quickSwitcherLabel: `Open ${getGitSourceName(window.remotion_gitSource)} repo`
  };
};

// src/helpers/open-in-editor.ts
var openInEditor = (stack) => {
  const {
    originalFileName,
    originalLineNumber,
    originalColumnNumber,
    originalFunctionName,
    originalScriptCode
  } = stack;
  return fetch(`/api/open-in-editor`, {
    method: "post",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      stack: {
        originalFileName,
        originalLineNumber,
        originalColumnNumber,
        originalFunctionName,
        originalScriptCode
      }
    })
  });
};
var openOriginalPositionInEditor = async (originalPosition) => {
  await openInEditor({
    originalColumnNumber: originalPosition.column,
    originalFileName: originalPosition.source,
    originalFunctionName: null,
    originalLineNumber: originalPosition.line,
    originalScriptCode: null
  });
};

// src/components/Notifications/ColorDot.tsx
import { useMemo as useMemo37 } from "react";
import { jsx as jsx60 } from "react/jsx-runtime";
var container15 = {
  height: 16,
  width: 16,
  backgroundColor: "red",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: 8
};
var ColorDot = ({ color }) => {
  const style4 = useMemo37(() => {
    return {
      ...container15,
      backgroundColor: color
    };
  }, [color]);
  return /* @__PURE__ */ jsx60("div", {
    style: style4
  });
};

// src/helpers/pick-color.tsx
import { jsx as jsx61, jsxs as jsxs23, Fragment as Fragment10 } from "react/jsx-runtime";
var pickColor = () => {
  const open = new EyeDropper().open();
  open.then((color) => {
    copyText(color.sRGBHex).then(() => {
      showNotification(/* @__PURE__ */ jsxs23(Fragment10, {
        children: [
          /* @__PURE__ */ jsx61(ColorDot, {
            color: color.sRGBHex
          }),
          " ",
          /* @__PURE__ */ jsx61(Spacing, {
            x: 1
          }),
          " Copied",
          " ",
          color.sRGBHex
        ]
      }), 2000);
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }).catch((err) => {
    if (err.message.includes("canceled")) {
      return;
    }
    showNotification(`Could not pick color.`, 2000);
  });
};

// src/helpers/show-browser-rendering.ts
var SHOW_BROWSER_RENDERING = Boolean(process.env.EXPERIMENTAL_CLIENT_SIDE_RENDERING_ENABLED);

// src/helpers/use-menu-structure.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
var openExternal = (link) => {
  window.open(link, "_blank");
};
var rotate = {
  transform: `rotate(90deg)`
};
var ICON_SIZE = 16;
var getFileMenu = ({
  readOnlyStudio,
  closeMenu,
  previewServerState,
  setSelectedModal
}) => {
  const items = [
    window.remotion_isReadOnlyStudio ? {
      id: "input-props-override",
      value: "input-props-override",
      label: "Set input props...",
      onClick: () => {
        closeMenu();
        setSelectedModal({
          type: "input-props-override"
        });
      },
      type: "item",
      keyHint: null,
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Override input props"
    } : null,
    readOnlyStudio ? null : {
      id: "render",
      value: "render",
      label: "Render...",
      onClick: () => {
        closeMenu();
        if (previewServerState !== "connected") {
          showNotification("Restart the studio to render", 2000);
          return;
        }
        const renderButton = document.getElementById("render-modal-button-server");
        renderButton.click();
      },
      type: "item",
      keyHint: "R",
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Render..."
    },
    SHOW_BROWSER_RENDERING && !readOnlyStudio ? {
      id: "render-on-web",
      value: "render-on-web",
      label: "Render on web...",
      onClick: () => {
        closeMenu();
        const renderButton = document.getElementById("render-modal-button-client");
        renderButton.click();
      },
      type: "item",
      keyHint: null,
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Render on web..."
    } : null,
    window.remotion_editorName && !readOnlyStudio ? {
      type: "divider",
      id: "open-in-editor-divider"
    } : null,
    window.remotion_editorName && !readOnlyStudio ? {
      id: "open-in-editor",
      value: "open-in-editor",
      label: `Open in ${window.remotion_editorName}`,
      onClick: async () => {
        await openInEditor({
          originalFileName: `${window.remotion_cwd}`,
          originalLineNumber: 1,
          originalColumnNumber: 1,
          originalFunctionName: null,
          originalScriptCode: null
        }).then((res) => res.json()).then(({ success }) => {
          if (!success) {
            showNotification(`Could not open ${window.remotion_editorName}`, 2000);
          }
        }).catch((err) => {
          console.error(err);
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        });
      },
      type: "item",
      keyHint: null,
      leftItem: null,
      subMenu: null,
      quickSwitcherLabel: "Open in editor..."
    } : null,
    getGitMenuItem()
  ].filter(NoReactInternals5.truthy);
  if (items.length === 0) {
    return null;
  }
  return {
    id: "file",
    label: "File",
    leaveLeftPadding: false,
    items,
    quickSwitcherLabel: null
  };
};
var useMenuStructure = (closeMenu, readOnlyStudio) => {
  const { setSelectedModal } = useContext22(ModalsContext);
  const { checkerboard, setCheckerboard } = useContext22(CheckerboardContext);
  const { editorZoomGestures, setEditorZoomGestures } = useContext22(EditorZoomGesturesContext);
  const { editorShowRulers, setEditorShowRulers } = useContext22(EditorShowRulersContext);
  const { editorShowGuides, setEditorShowGuides } = useContext22(EditorShowGuidesContext);
  const { size, setSize } = useContext22(Internals17.PreviewSizeContext);
  const { type } = useContext22(StudioServerConnectionCtx).previewServerState;
  const {
    setSidebarCollapsedState,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight
  } = useContext22(SidebarContext);
  const sizes = useMemo38(() => getUniqueSizes(size), [size]);
  const isFullscreenSupported = checkFullscreenSupport();
  const { remotion_packageManager } = window;
  const sizePreselectIndex = sizes.findIndex((s) => String(size.size) === String(s.size));
  const mobileLayout = useMobileLayout();
  const structure = useMemo38(() => {
    let struct = [
      {
        id: "remotion",
        label: /* @__PURE__ */ jsx62(Row, {
          align: "center",
          justify: "center",
          children: /* @__PURE__ */ jsx62("svg", {
            width: ICON_SIZE,
            height: ICON_SIZE,
            viewBox: "-100 -100 400 400",
            style: rotate,
            children: /* @__PURE__ */ jsx62("path", {
              fill: "#fff",
              stroke: "#fff",
              strokeWidth: "100",
              strokeLinejoin: "round",
              d: "M 2 172 a 196 100 0 0 0 195 5 A 196 240 0 0 0 100 2.259 A 196 240 0 0 0 2 172 z"
            })
          })
        }),
        leaveLeftPadding: false,
        items: [
          {
            id: "about",
            value: "about",
            label: "About Remotion",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: About Remotion"
          },
          {
            id: "changelog",
            value: "changelog",
            label: "Changelog",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/releases");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Changelog"
          },
          {
            id: "license",
            value: "license",
            label: "License",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/blob/main/LICENSE.md");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: License"
          },
          {
            id: "acknowledgements",
            value: "acknowledgements",
            label: "Acknowledgements",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/acknowledgements");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Help: Acknowledgements"
          },
          {
            type: "divider",
            id: "timeline-divider-1"
          },
          {
            id: "restart-studio",
            value: "restart-studio",
            label: "Restart Studio Server",
            onClick: () => {
              closeMenu();
              restartStudio();
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Restart Studio Server"
          }
        ],
        quickSwitcherLabel: null
      },
      getFileMenu({
        readOnlyStudio,
        closeMenu,
        previewServerState: type,
        setSelectedModal
      }),
      {
        id: "view",
        label: "View",
        leaveLeftPadding: true,
        items: [
          {
            id: "preview-size",
            keyHint: null,
            label: "Preview size",
            onClick: () => {
              return;
            },
            type: "item",
            value: "preview-size",
            leftItem: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: sizePreselectIndex,
              items: sizes.map((newSize) => ({
                id: String(newSize.size),
                keyHint: newSize.size === 1 ? "0" : null,
                label: getPreviewSizeLabel(newSize),
                leftItem: String(newSize.size) === String(size.size) ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                onClick: () => {
                  closeMenu();
                  setSize(() => newSize);
                },
                subMenu: null,
                type: "item",
                value: newSize.size,
                quickSwitcherLabel: null
              })),
              quickSwitcherLabel: null
            },
            quickSwitcherLabel: null
          },
          {
            id: "editor-zoom-gestures",
            keyHint: null,
            label: "Zoom and Pan Gestures",
            onClick: () => {
              closeMenu();
              setEditorZoomGestures((c) => !c);
            },
            type: "item",
            value: "editor-zoom-gestures",
            leftItem: editorZoomGestures ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorZoomGestures ? "Disable Zoom and Pan Gestures" : "Enable Zoom and Pan Gestures"
          },
          {
            id: "show-rulers",
            keyHint: null,
            label: "Show Rulers",
            onClick: () => {
              closeMenu();
              setEditorShowRulers((c) => !c);
            },
            type: "item",
            value: "show-ruler",
            leftItem: editorShowRulers ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowRulers ? "Hide Rulers" : "Show Rulers"
          },
          {
            id: "show-guides",
            keyHint: null,
            label: "Show Guides",
            onClick: () => {
              closeMenu();
              setEditorShowGuides((c) => !c);
            },
            type: "item",
            value: "show-guides",
            leftItem: editorShowGuides ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: editorShowGuides ? "Hide Guides" : "Show Guides"
          },
          {
            id: "timeline-divider-1",
            type: "divider"
          },
          {
            id: "left-sidebar",
            label: "Left Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "left-sidebar-responsive",
                  keyHint: null,
                  label: "Responsive",
                  leftItem: sidebarCollapsedStateLeft === "responsive" ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "responsive",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "responsive",
                  quickSwitcherLabel: null
                },
                {
                  id: "left-sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateLeft === "expanded" ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: "expanded", right: null });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "left-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateLeft === "collapsed" ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: "collapsed",
                      right: null
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "right-sidebar",
            label: "Right Sidebar",
            keyHint: null,
            type: "item",
            value: "preview-size",
            leftItem: null,
            quickSwitcherLabel: null,
            subMenu: {
              leaveLeftSpace: true,
              preselectIndex: 0,
              items: [
                {
                  id: "sidebar-expanded",
                  keyHint: null,
                  label: "Expanded",
                  leftItem: sidebarCollapsedStateRight === "expanded" ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({ left: null, right: "expanded" });
                  },
                  subMenu: null,
                  type: "item",
                  value: "expanded",
                  quickSwitcherLabel: "Expand"
                },
                {
                  id: "right-sidebar-collapsed",
                  keyHint: null,
                  label: "Collapsed",
                  leftItem: sidebarCollapsedStateRight === "collapsed" ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
                  onClick: () => {
                    closeMenu();
                    setSidebarCollapsedState({
                      left: null,
                      right: "collapsed"
                    });
                  },
                  subMenu: null,
                  type: "item",
                  value: "collapsed",
                  quickSwitcherLabel: "Collapse"
                }
              ]
            },
            onClick: () => {
              return;
            }
          },
          {
            id: "timeline-divider-2",
            type: "divider"
          },
          {
            id: "checkerboard",
            keyHint: "T",
            label: "Transparency as checkerboard",
            onClick: () => {
              closeMenu();
              setCheckerboard((c) => !c);
            },
            type: "item",
            value: "checkerboard",
            leftItem: checkerboard ? /* @__PURE__ */ jsx62(Checkmark, {}) : null,
            subMenu: null,
            quickSwitcherLabel: checkerboard ? "Disable Checkerboard Transparency" : "Enable Checkerboard Transparency"
          },
          {
            id: "timeline-divider-3",
            type: "divider"
          },
          {
            id: "quick-switcher",
            keyHint: `${cmdOrCtrlCharacter}+K`,
            label: "Quick Switcher",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "compositions",
                invocationTimestamp: Date.now()
              });
            },
            type: "item",
            value: "quick-switcher",
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Switch composition"
          },
          {
            id: "in-out-divider-5",
            type: "divider"
          },
          {
            id: "in-mark",
            keyHint: "I",
            label: "In Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.inMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "in-mark",
            quickSwitcherLabel: "Timeline: Set In Mark"
          },
          {
            id: "out-mark",
            keyHint: "O",
            label: "Out Mark",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.outMarkClick(null);
            },
            subMenu: null,
            type: "item",
            value: "out-mark",
            quickSwitcherLabel: "Timeline: Set Out Mark"
          },
          {
            id: "x-mark",
            keyHint: "X",
            label: "Clear In/Out Marks",
            leftItem: null,
            onClick: () => {
              closeMenu();
              inOutHandles.current?.clearMarks();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Clear In and Out Mark"
          },
          {
            id: "goto-time",
            keyHint: "G",
            label: "Go to frame",
            leftItem: null,
            onClick: () => {
              closeMenu();
              Internals17.timeValueRef.current?.goToFrame();
            },
            subMenu: null,
            type: "item",
            value: "clear-marks",
            quickSwitcherLabel: "Timeline: Go to frame"
          },
          {
            id: "fullscreen-divider",
            type: "divider"
          },
          isFullscreenSupported ? {
            id: "fullscreen",
            keyHint: null,
            label: "Fullscreen",
            leftItem: null,
            onClick: () => {
              closeMenu();
              drawRef.current?.requestFullscreen();
            },
            subMenu: null,
            type: "item",
            value: "fullscreen",
            quickSwitcherLabel: "Go Fullscreen"
          } : null
        ].filter(Internals17.truthy)
      },
      {
        id: "tools",
        label: "Tools",
        leaveLeftPadding: false,
        items: [
          process.env.ASK_AI_ENABLED ? {
            id: "ask-ai",
            value: "ask-ai",
            label: "Ask AI",
            onClick: () => {
              closeMenu();
              askAiModalRef.current?.toggle();
            },
            leftItem: null,
            keyHint: `${cmdOrCtrlCharacter}+I`,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Ask AI"
          } : null,
          "EyeDropper" in window ? {
            id: "color-picker",
            value: "color-picker",
            label: "Color Picker",
            onClick: () => {
              closeMenu();
              pickColor();
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Show Color Picker"
          } : null,
          {
            id: "spring-editor",
            value: "spring-editor",
            label: "Timing Editor",
            onClick: () => {
              closeMenu();
              window.open("https://www.remotion.dev/timing-editor", "_blank");
            },
            leftItem: null,
            keyHint: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: "Open spring() Editor"
          }
        ].filter(Internals17.truthy),
        quickSwitcherLabel: null
      },
      readOnlyStudio || remotion_packageManager === "unknown" ? null : {
        id: "install",
        label: "Packages",
        leaveLeftPadding: false,
        items: [
          {
            id: "install-packages",
            value: "install-packages",
            label: "Install...",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "install-packages",
                packageManager: remotion_packageManager
              });
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: `Install packages`
          }
        ]
      },
      {
        id: "help",
        label: "Help",
        leaveLeftPadding: false,
        items: [
          {
            id: "shortcuts",
            value: "shortcuts",
            label: areKeyboardShortcutsDisabled() ? "Shortcuts (disabled)" : "Shortcuts",
            onClick: () => {
              closeMenu();
              setSelectedModal({
                type: "quick-switcher",
                mode: "docs",
                invocationTimestamp: Date.now()
              });
            },
            keyHint: "?",
            leftItem: null,
            subMenu: null,
            type: "item",
            quickSwitcherLabel: areKeyboardShortcutsDisabled() ? "Show all Keyboard Shortcuts (disabled)" : "Show all Keyboard Shortcuts"
          },
          {
            id: "docs",
            value: "docs",
            label: "Docs",
            onClick: () => {
              closeMenu();
              openExternal("https://remotion.dev/docs");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Visit Documentation"
          },
          {
            id: "file-issue",
            value: "file-issue",
            label: "File an issue",
            onClick: () => {
              closeMenu();
              openExternal("https://github.com/remotion-dev/remotion/issues/new/choose");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "File GitHub issue"
          },
          {
            id: "discord",
            value: "discord",
            label: "Join Discord community",
            onClick: () => {
              closeMenu();
              openExternal("https://discord.com/invite/6VzzNDwUwV");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: null
          },
          {
            id: "help-divider-6",
            type: "divider"
          },
          {
            id: "insta",
            value: "insta",
            label: "Instagram",
            onClick: () => {
              closeMenu();
              openExternal("https://instagram.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on Instagram"
          },
          {
            id: "x",
            value: "x",
            label: "X",
            onClick: () => {
              closeMenu();
              openExternal("https://x.com/remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on X"
          },
          {
            id: "youtube",
            value: "youtube",
            label: "YouTube",
            onClick: () => {
              closeMenu();
              openExternal("https://www.youtube.com/@remotion_dev");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Watch Remotion on YouTube"
          },
          {
            id: "linkedin",
            value: "linkedin",
            label: "LinkedIn",
            onClick: () => {
              closeMenu();
              openExternal("https://www.linkedin.com/company/remotion-dev/");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on LinkedIn"
          },
          {
            id: "tiktok",
            value: "tiktok",
            label: "TikTok",
            onClick: () => {
              closeMenu();
              openExternal("https://www.tiktok.com/@remotion");
            },
            type: "item",
            keyHint: null,
            leftItem: null,
            subMenu: null,
            quickSwitcherLabel: "Follow Remotion on TikTok"
          }
        ]
      }
    ].filter(Internals17.truthy);
    if (mobileLayout) {
      struct = [
        {
          ...struct[0],
          items: [
            ...struct.slice(1).map((s) => {
              return {
                ...s,
                keyHint: null,
                onClick: () => {
                  return;
                },
                type: "item",
                value: s.id,
                leftItem: null,
                subMenu: {
                  items: s.items,
                  leaveLeftSpace: true,
                  preselectIndex: 0
                },
                quickSwitcherLabel: null
              };
            }),
            ...struct[0].items
          ]
        }
      ];
    }
    return struct;
  }, [
    readOnlyStudio,
    closeMenu,
    type,
    sizePreselectIndex,
    sizes,
    editorZoomGestures,
    editorShowRulers,
    editorShowGuides,
    sidebarCollapsedStateLeft,
    sidebarCollapsedStateRight,
    checkerboard,
    isFullscreenSupported,
    remotion_packageManager,
    mobileLayout,
    size.size,
    setSize,
    setEditorZoomGestures,
    setEditorShowRulers,
    setEditorShowGuides,
    setSidebarCollapsedState,
    setCheckerboard,
    setSelectedModal
  ]);
  return structure;
};
var getItemLabel = (item) => {
  if (item.quickSwitcherLabel !== null) {
    return item.quickSwitcherLabel;
  }
  if (typeof item.label === "string") {
    return item.label;
  }
  return item.label?.toString();
};
var itemToSearchResult = (item, setSelectedModal, prefixes) => {
  if (item.subMenu) {
    return item.subMenu.items.map((subItem) => {
      if (subItem.type === "divider") {
        return null;
      }
      return itemToSearchResult(subItem, setSelectedModal, [
        ...prefixes,
        getItemLabel(item)
      ]);
    }).flat(1).filter(NoReactInternals5.truthy);
  }
  return [
    {
      type: "menu-item",
      id: item.id,
      onSelected: () => {
        setSelectedModal(null);
        item.onClick(item.id, null);
      },
      title: [...prefixes, getItemLabel(item)].join(": ")
    }
  ];
};
var makeSearchResults = (actions, setSelectedModal) => {
  const items = actions.map((menu) => {
    return menu.items.map((item) => {
      if (item.type === "divider") {
        return null;
      }
      return itemToSearchResult(item, setSelectedModal, []);
    });
  }).flat(Infinity).filter(NoReactInternals5.truthy);
  return items;
};

// src/components/Menu/MenuItem.tsx
import { PlayerInternals as PlayerInternals8 } from "@remotion/player";
import { useCallback as useCallback28, useMemo as useMemo39, useRef as useRef18, useState as useState29 } from "react";
import ReactDOM5 from "react-dom";
import { jsx as jsx63, jsxs as jsxs24, Fragment as Fragment11 } from "react/jsx-runtime";
var container16 = {
  fontSize: 13,
  color: "white",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "default",
  paddingTop: 8,
  paddingBottom: 8,
  userSelect: "none",
  WebkitUserSelect: "none",
  border: "none"
};
var MenuItem = ({
  label: itemName,
  selected,
  id,
  onItemSelected,
  onItemHovered,
  onItemQuit,
  onPreviousMenu,
  onNextMenu,
  menu
}) => {
  const [hovered, setHovered] = useState29(false);
  const ref = useRef18(null);
  const size = PlayerInternals8.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { tabIndex, currentZIndex } = useZIndex();
  const containerStyle2 = useMemo39(() => {
    return {
      ...container16,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const portalStyle = useMemo39(() => {
    if (!selected || !size) {
      return null;
    }
    return {
      ...menuContainerTowardsBottom,
      left: size.left,
      top: size.top + size.height
    };
  }, [selected, size]);
  const onPointerEnter = useCallback28(() => {
    onItemHovered(id);
    setHovered(true);
  }, [id, onItemHovered]);
  const onPointerLeave = useCallback28(() => {
    setHovered(false);
  }, []);
  const onPointerDown = useCallback28((e) => {
    if (e.button !== 0) {
      return;
    }
    onItemSelected(id);
    window.addEventListener("pointerup", (evt) => {
      if (!isMenuItem(evt.target)) {
        onItemQuit();
      }
    }, {
      once: true
    });
  }, [id, onItemQuit, onItemSelected]);
  const onClick = useCallback28((e) => {
    e.stopPropagation();
    const isKeyboardInitiated = e.detail === 0;
    if (!isKeyboardInitiated) {
      return;
    }
    onItemSelected((p) => {
      return p === null ? id : null;
    });
  }, [id, onItemSelected]);
  const outerStyle = useMemo39(() => {
    return {
      ...outerPortal,
      top: (size?.top ?? 0) + (size?.height ?? 0)
    };
  }, [size]);
  return /* @__PURE__ */ jsxs24(Fragment11, {
    children: [
      /* @__PURE__ */ jsx63("button", {
        ref,
        role: "button",
        tabIndex,
        onPointerEnter,
        onPointerLeave,
        onPointerDown,
        onClick,
        style: containerStyle2,
        type: "button",
        className: MENU_INITIATOR_CLASSNAME,
        children: itemName
      }),
      portalStyle ? ReactDOM5.createPortal(/* @__PURE__ */ jsx63("div", {
        className: "css-reset",
        style: outerStyle,
        children: /* @__PURE__ */ jsx63(HigherZIndex, {
          onEscape: onItemQuit,
          onOutsideClick: onItemQuit,
          children: /* @__PURE__ */ jsx63("div", {
            style: portalStyle,
            children: /* @__PURE__ */ jsx63(MenuContent, {
              onNextMenu: onPreviousMenu,
              onPreviousMenu: onNextMenu,
              values: menu.items,
              onHide: onItemQuit,
              leaveLeftSpace: menu.leaveLeftPadding,
              preselectIndex: false,
              topItemCanBeUnselected: true,
              fixedHeight: null
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/MenuBuildIndicator.tsx
import { useContext as useContext23, useEffect as useEffect25, useState as useState31 } from "react";

// src/components/OpenEditorButton.tsx
import { useCallback as useCallback29, useMemo as useMemo40, useState as useState30 } from "react";
import { jsx as jsx64 } from "react/jsx-runtime";
var svgStyle = {
  width: 11,
  height: 11
};
var buttonStyle = {
  border: "none",
  height: "20px",
  display: "flex",
  paddingInline: "6px",
  justifyContent: "center",
  alignItems: "center"
};
var OpenEditorButton = ({ type }) => {
  const [hovered, setHovered] = useState30(false);
  const svgFillColor = useMemo40(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const handleClick = useCallback29(async () => {
    if (type === "editor") {
      await openInEditor({
        originalFileName: `${window.remotion_cwd}`,
        originalLineNumber: 1,
        originalColumnNumber: 1,
        originalFunctionName: null,
        originalScriptCode: null
      }).then((res) => res.json()).then(({ success }) => {
        if (!success) {
          showNotification(`Could not open ${window.remotion_editorName}`, 2000);
        }
      }).catch((err) => {
        console.error(err);
        showNotification(`Could not open ${window.remotion_editorName}`, 2000);
      });
    }
    if (type === "git") {
      if (!window.remotion_gitSource) {
        throw new Error("No git source");
      }
      window.open(getGitSourceBranchUrl(window.remotion_gitSource), "_blank");
    }
  }, [type]);
  const buttonTooltip = type === "git" ? `Open ${getGitSourceName(window.remotion_gitSource)} Repo` : `Open in ${window.remotion_editorName}`;
  const openInEditorSvg = /* @__PURE__ */ jsx64("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle,
    children: /* @__PURE__ */ jsx64("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback29(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback29(() => {
    setHovered(false);
  }, []);
  return /* @__PURE__ */ jsx64("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/MenuBuildIndicator.tsx
import { jsx as jsx65, jsxs as jsxs25 } from "react/jsx-runtime";
var cwd = {
  fontSize: 13,
  opacity: 0.8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var spinnerSize = 14;
var spinner = {
  position: "relative",
  width: spinnerSize,
  marginTop: 4
};
var noSpinner = {
  position: "relative",
  width: spinnerSize
};
var MenuBuildIndicator = () => {
  const [isBuilding, setIsBuilding] = useState31(false);
  const ctx = useContext23(StudioServerConnectionCtx).previewServerState;
  const showButton = window.remotion_editorName && ctx.type === "connected";
  useEffect25(() => {
    window.remotion_isBuilding = () => {
      setIsBuilding(true);
    };
    window.remotion_finishedBuilding = () => {
      setIsBuilding(false);
    };
    return () => {
      window.remotion_isBuilding = undefined;
      window.remotion_finishedBuilding = undefined;
    };
  }, []);
  return /* @__PURE__ */ jsxs25("div", {
    style: cwd,
    title: window.remotion_cwd,
    children: [
      showButton ? /* @__PURE__ */ jsx65(Spacing, {
        x: 2
      }) : null,
      isBuilding ? /* @__PURE__ */ jsx65("div", {
        style: spinner,
        children: /* @__PURE__ */ jsx65(Spinner, {
          duration: 0.5,
          size: spinnerSize
        })
      }) : /* @__PURE__ */ jsx65("div", {
        style: noSpinner
      }),
      showButton ? /* @__PURE__ */ jsx65(Spacing, {
        x: 0.5
      }) : null,
      window.remotion_projectName,
      showButton ? /* @__PURE__ */ jsx65(Spacing, {
        x: 0.25
      }) : null,
      showButton ? /* @__PURE__ */ jsx65(OpenEditorButton, {
        type: "editor"
      }) : window.remotion_gitSource ? /* @__PURE__ */ jsx65(OpenEditorButton, {
        type: "git"
      }) : null
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import { useCallback as useCallback93, useContext as useContext61, useEffect as useEffect63 } from "react";

// src/components/TopPanel.tsx
import { useCallback as useCallback92, useContext as useContext60, useEffect as useEffect62, useMemo as useMemo98 } from "react";

// src/helpers/use-breakpoint.ts
import { useEffect as useEffect26, useState as useState32 } from "react";
function useBreakpoint(breakpoint2) {
  const [compactUI, setCompactUI] = useState32(window.innerWidth < breakpoint2);
  useEffect26(() => {
    function handleResize() {
      setCompactUI(window.innerWidth < breakpoint2);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint2]);
  return compactUI;
}

// src/components/CanvasIfSizeIsAvailable.tsx
import { useContext as useContext32, useMemo as useMemo52 } from "react";
import { Internals as Internals27 } from "remotion";

// src/components/CanvasOrLoading.tsx
import { useContext as useContext31, useEffect as useEffect37 } from "react";
import { Internals as Internals26 } from "remotion";

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import { useEffect as useEffect32, useState as useState36 } from "react";

// src/error-overlay/react-overlay/utils/parser.ts
import { getLocationFromBuildError } from "@remotion/studio-shared";

// src/error-overlay/react-overlay/effects/resolve-file-source.ts
var resolveFileSource = async (location, contextLines) => {
  const res = await fetch(`/api/file-source?f=${encodeURIComponent(location.fileName)}`);
  const text = await res.text();
  const lines2 = text.split(`
`).map((l, i) => {
    const oneIndexedLineNumber = i + 1;
    return [oneIndexedLineNumber, l];
  }).filter(([oneIndexedLineNumber]) => {
    return Math.abs(oneIndexedLineNumber - location.lineNumber) <= contextLines;
  });
  const scriptCode = lines2.map(([num, line2]) => {
    return {
      content: line2,
      highlight: location.lineNumber === num,
      lineNumber: num
    };
  });
  return {
    originalColumnNumber: location.columnNumber,
    originalFunctionName: null,
    originalFileName: location.fileName,
    originalLineNumber: location.lineNumber,
    originalScriptCode: scriptCode
  };
};

// src/error-overlay/react-overlay/utils/make-stack-frame.ts
var makeStackFrame = ({
  functionName,
  fileName,
  lineNumber,
  columnNumber
}) => {
  if (functionName && functionName.indexOf("Object.") === 0) {
    functionName = functionName.slice("Object.".length);
  }
  if (functionName === "friendlySyntaxErrorLabel" || functionName === "exports.__esModule" || functionName === "<anonymous>" || !functionName) {
    functionName = null;
  }
  return {
    columnNumber,
    fileName,
    functionName,
    lineNumber
  };
};

// src/error-overlay/react-overlay/utils/parser.ts
var regexExtractLocation = /\(?(.+?)(?::(\d+))?(?::(\d+))?\)?$/;
function extractLocation(token) {
  const execed = regexExtractLocation.exec(token);
  if (!execed) {
    throw new Error("Could not match in extractLocation");
  }
  return execed.slice(1).map((v) => {
    const p = Number(v);
    if (!isNaN(p)) {
      return p;
    }
    return v;
  });
}
var regexValidFrame_Chrome = /^\s*(at|in)\s.+(:\d+)/;
var regexValidFrame_FireFox = /(^|@)\S+:\d+|.+line\s+\d+\s+>\s+(eval|Function).+/;
function parseStack(stack) {
  const frames = stack.filter((e) => regexValidFrame_Chrome.test(e) || regexValidFrame_FireFox.test(e)).map((e) => {
    if (regexValidFrame_FireFox.test(e)) {
      let isEval = false;
      if (/ > (eval|Function)/.test(e)) {
        e = e.replace(/ line (\d+)(?: > eval line \d+)* > (eval|Function):\d+:\d+/g, ":$1");
        isEval = true;
      }
      const _data = e.split(/[@]/g);
      const _last = _data.pop();
      if (!_last) {
        throw new Error("could not get last");
      }
      const [_fileName, _lineNumber, _columnNumber] = extractLocation(_last);
      return makeStackFrame({
        functionName: _data.join("@") || (isEval ? "eval" : null),
        fileName: _fileName,
        lineNumber: _lineNumber,
        columnNumber: _columnNumber
      });
    }
    if (e.indexOf("(eval ") !== -1) {
      e = e.replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
    }
    if (e.indexOf("(at ") !== -1) {
      e = e.replace(/\(at /, "(");
    }
    const data = e.trim().split(/\s+/g).slice(1);
    const last = data.pop();
    if (!last) {
      throw new Error("could not get last");
    }
    const [fileName, lineNumber, columnNumber] = extractLocation(last);
    return makeStackFrame({
      functionName: data.join(" ") || null,
      fileName,
      lineNumber,
      columnNumber
    });
  });
  return frames;
}
var parseError = async (error, contextLines) => {
  if (error === null) {
    throw new Error("You cannot pass a null object.");
  }
  if (typeof error === "string") {
    return parseStack(error.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  if (Array.isArray(error)) {
    return parseStack(error).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  const errorLocation = getLocationFromBuildError(error);
  if (errorLocation) {
    return [
      {
        type: "symbolicated",
        frame: await resolveFileSource(errorLocation, contextLines)
      }
    ];
  }
  if (typeof error.stack === "string") {
    return parseStack(error.stack.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  return [];
};

// src/error-overlay/react-overlay/utils/unmapper.ts
import { Internals as Internals18 } from "remotion";

// src/error-overlay/react-overlay/utils/get-lines-around.ts
function getLinesAround(line2, count, lines2) {
  const result = [];
  for (let index = Math.max(0, line2 - 1 - count);index <= Math.min(lines2.length - 1, line2 - 1 + count); ++index) {
    result.push({
      lineNumber: index + 1,
      content: lines2[index],
      highlight: index === line2 - 1
    });
  }
  return result;
}

// src/error-overlay/react-overlay/utils/get-source-map.ts
import { SourceMapConsumer } from "source-map";
var getOriginalPosition = (source_map, line2, column) => {
  const result = source_map.originalPositionFor({
    line: line2,
    column
  });
  return { line: result.line, column: result.column, source: result.source };
};
function extractSourceMapUrl(fileContents) {
  const regex = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
  let match = null;
  for (;; ) {
    const next = regex.exec(fileContents);
    if (next == null) {
      break;
    }
    match = next;
  }
  if (!match?.[1]) {
    return null;
  }
  return match[1].toString();
}
async function getSourceMap(fileUri, fileContents) {
  const sm = extractSourceMapUrl(fileContents);
  if (sm === null) {
    return null;
  }
  if (sm.indexOf("data:") === 0) {
    const base64 = /^data:application\/json;([\w=:"-]+;)*base64,/;
    const match2 = sm.match(base64);
    if (!match2) {
      throw new Error("Sorry, non-base64 inline source-map encoding is not supported.");
    }
    const converted = window.atob(sm.substring(match2[0].length));
    return new SourceMapConsumer(JSON.parse(converted));
  }
  const index = fileUri.lastIndexOf("/");
  const url = fileUri.substring(0, index + 1) + sm;
  const obj = await fetch(url).then((res) => res.json());
  return new SourceMapConsumer(obj);
}

// src/error-overlay/react-overlay/utils/unmapper.ts
var getFileContents = async (fileName) => {
  const res = await fetch(fileName);
  const fileContents = await res.text();
  return fileContents;
};
var unmap = async (frames, contextLines) => {
  const transpiled = frames.filter((s) => s.type === "transpiled").map((s) => s.frame);
  const uniqueFileNames = [
    ...new Set(transpiled.map((f) => f.fileName).filter(Internals18.truthy))
  ];
  const maps = await Promise.all(uniqueFileNames.map(async (fileName) => {
    const fileContents = await getFileContents(fileName);
    return getSourceMap(fileName, fileContents);
  }));
  const mapValues = {};
  for (let i = 0;i < uniqueFileNames.length; i++) {
    mapValues[uniqueFileNames[i]] = maps[i];
  }
  return frames.map((frame) => {
    if (frame.type === "symbolicated") {
      return frame.frame;
    }
    const map = mapValues[frame.frame.fileName];
    if (!map) {
      return null;
    }
    const pos = getOriginalPosition(map, frame.frame.lineNumber, frame.frame.columnNumber);
    const { functionName } = frame.frame;
    let hasSource = null;
    hasSource = pos.source ? map.sourceContentFor(pos.source, false) : null;
    const scriptCode = hasSource && pos.line ? getLinesAround(pos.line, contextLines, hasSource.split(`
`)) : null;
    return {
      originalColumnNumber: pos.column,
      originalFileName: pos.source,
      originalFunctionName: functionName,
      originalLineNumber: pos.line,
      originalScriptCode: scriptCode
    };
  }).filter(Internals18.truthy);
};

// src/error-overlay/react-overlay/utils/get-stack-frames.ts
var getStackFrames = async (error, contextSize) => {
  const parsedFrames = await parseError(error, contextSize);
  const enhancedFrames = await unmap(parsedFrames, contextSize);
  if (enhancedFrames.map((f) => f.originalFileName).filter((f_1) => f_1 !== null && f_1 !== undefined).length === 0) {
    return null;
  }
  return enhancedFrames;
};

// src/error-overlay/react-overlay/listen-to-runtime-errors.ts
var CONTEXT_SIZE = 3;
var getErrorRecord = async (error) => {
  const stackFrames = await getStackFrames(error, CONTEXT_SIZE);
  if (stackFrames === null || stackFrames === undefined) {
    return null;
  }
  return {
    error,
    contextSize: CONTEXT_SIZE,
    stackFrames
  };
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import { getLocationFromBuildError as getLocationFromBuildError2 } from "@remotion/studio-shared";
import { useMemo as useMemo45 } from "react";

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import { useCallback as useCallback30, useEffect as useEffect27 } from "react";

// src/components/Button.tsx
import { forwardRef as forwardRef3, useMemo as useMemo41 } from "react";
import { jsx as jsx66 } from "react/jsx-runtime";
var button = {
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  borderRadius: 4,
  backgroundColor: INPUT_BACKGROUND,
  appearance: "none",
  fontFamily: "inherit",
  fontSize: 14,
  color: "white",
  flexDirection: "row"
};
var ButtonRefForwardFunction = ({
  children,
  onClick,
  title: title3,
  disabled,
  style: style4,
  id,
  autoFocus,
  buttonContainerStyle
}, ref) => {
  const combined = useMemo41(() => {
    return {
      ...button,
      ...style4 ?? {}
    };
  }, [style4]);
  const buttonContainer = useMemo41(() => {
    return {
      padding: 10,
      cursor: disabled ? "inherit" : "pointer",
      fontSize: 14,
      opacity: disabled ? 0.7 : 1,
      ...buttonContainerStyle ?? {}
    };
  }, [buttonContainerStyle, disabled]);
  return /* @__PURE__ */ jsx66("button", {
    ref,
    id,
    style: combined,
    type: "button",
    disabled,
    onClick,
    autoFocus,
    title: title3,
    children: /* @__PURE__ */ jsx66("div", {
      className: "css-reset",
      style: buttonContainer,
      children
    })
  });
};
var Button = forwardRef3(ButtonRefForwardFunction);

// src/error-overlay/remotion-overlay/AskOnDiscord.tsx
import { jsx as jsx67, jsxs as jsxs26 } from "react/jsx-runtime";
var DISCORD_LINK = "https://remotion.dev/discord";
var AskOnDiscord = ({ canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback30(() => {
    window.open(DISCORD_LINK, "_blank");
  }, []);
  const { registerKeybinding } = useKeybinding();
  useEffect27(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "d",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return /* @__PURE__ */ jsxs26(Button, {
    onClick: openInBrowser,
    children: [
      "Ask on Discord",
      " ",
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx67(ShortcutHint, {
        keyToPress: "d",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/CalculateMetadataErrorExplainer.tsx
import { jsx as jsx68, jsxs as jsxs27 } from "react/jsx-runtime";
var CalculateMetadataErrorExplainer = () => {
  return /* @__PURE__ */ jsxs27("div", {
    style: style4,
    children: [
      "This error occured while calling",
      " ",
      /* @__PURE__ */ jsx68("code", {
        style: inlineCodeSnippet,
        children: "calculateMetadata()"
      }),
      "."
    ]
  });
};
var style4 = {
  borderRadius: 3,
  color: "white",
  padding: 12,
  backgroundColor: BORDER_COLOR,
  fontSize: 14,
  fontFamily: "sans-serif"
};

// src/error-overlay/remotion-overlay/CompositionIdsDropdown.tsx
import { useEffect as useEffect28, useMemo as useMemo42, useRef as useRef19, useState as useState33 } from "react";

// src/error-overlay/remotion-overlay/carets.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
var CaretRight2 = ({ size }) => {
  return /* @__PURE__ */ jsx69("svg", {
    style: { height: size ?? 20 },
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    viewBox: "0 0 192 512",
    children: /* @__PURE__ */ jsx69("path", {
      fill: "currentColor",
      d: "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    })
  });
};
var CaretDown2 = ({ invert, size }) => {
  return /* @__PURE__ */ jsx69("svg", {
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    style: { height: size ?? 20, transform: invert ? `rotate(180deg)` : "" },
    children: /* @__PURE__ */ jsx69("path", {
      fill: "currentColor",
      d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    })
  });
};

// src/error-overlay/remotion-overlay/CompositionIdListItem.tsx
import React47 from "react";
import { jsx as jsx70 } from "react/jsx-runtime";
var listItemStyle = {
  padding: 8,
  cursor: "pointer",
  borderRadius: 4,
  lineHeight: 1.4,
  color: TEXT_COLOR,
  fontFamily: "inherit",
  fontSize: 14
};
var listItemActiveStyle = {
  backgroundColor: SELECTED_BACKGROUND
};
var listItemHoverStyle = {
  backgroundColor: CLEAR_HOVER
};
var CompositionIdListItem = ({ id, isActive, onSelect }) => {
  const [hover, setHover] = React47.useState(false);
  return /* @__PURE__ */ jsx70("div", {
    role: "button",
    onPointerEnter: () => setHover(true),
    onPointerLeave: () => setHover(false),
    onClick: () => onSelect(id),
    style: {
      ...listItemStyle,
      ...hover ? listItemHoverStyle : {},
      ...isActive ? listItemActiveStyle : {}
    },
    title: id,
    children: id
  });
};

// src/error-overlay/remotion-overlay/CompositionIdsDropdown.tsx
import { jsx as jsx71, jsxs as jsxs28 } from "react/jsx-runtime";
var containerStyle2 = {
  display: "inline-block",
  position: "relative"
};
var dropdownStyle = {
  position: "absolute",
  top: "110%",
  left: 0,
  width: 320,
  maxHeight: 300,
  overflowY: "auto",
  backgroundColor: INPUT_BACKGROUND,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  borderRadius: 8,
  padding: 8,
  boxShadow: "0 6px 24px rgba(0,0,0,0.35)",
  zIndex: 1000,
  fontFamily: "inherit",
  fontSize: 14
};
var searchStyle = {
  width: "100%",
  padding: "6px 8px",
  borderRadius: 6,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  background: INPUT_BACKGROUND,
  color: TEXT_COLOR,
  marginBottom: 8,
  outline: "none",
  fontFamily: "inherit",
  fontSize: 14
};
var CompositionIdsDropdown = ({ compositionIds, currentId }) => {
  const [open, setOpen] = useState33(false);
  const [query, setQuery] = useState33("");
  const containerRef = useRef19(null);
  const filtered = useMemo42(() => {
    const q = query.trim().toLowerCase();
    if (!q) {
      return compositionIds;
    }
    return compositionIds.filter((id) => id.toLowerCase().includes(q));
  }, [compositionIds, query]);
  const onSelect = (id) => {
    const isQuery = window.remotion_isReadOnlyStudio;
    if (isQuery) {
      window.location.href = `${window.location.pathname}?/${id}`;
    } else {
      window.location.href = `/${id}`;
    }
  };
  useEffect28(() => {
    if (!open) {
      return;
    }
    const onClickAway = (e) => {
      if (!containerRef.current) {
        return;
      }
      if (!containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickAway);
    document.addEventListener("touchstart", onClickAway, { passive: true });
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClickAway);
      document.removeEventListener("touchstart", onClickAway);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, containerRef]);
  return /* @__PURE__ */ jsxs28("div", {
    ref: containerRef,
    style: containerStyle2,
    children: [
      /* @__PURE__ */ jsxs28(Button, {
        onClick: () => setOpen((p) => !p),
        buttonContainerStyle: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          minWidth: 180
        },
        children: [
          /* @__PURE__ */ jsx71("span", {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "14px",
              lineHeight: "24px"
            },
            children: currentId ?? "Select composition"
          }),
          /* @__PURE__ */ jsx71(CaretDown2, {
            size: 20,
            invert: open
          })
        ]
      }),
      open ? /* @__PURE__ */ jsxs28("div", {
        style: dropdownStyle,
        children: [
          /* @__PURE__ */ jsx71("input", {
            value: query,
            onChange: (e) => setQuery(e.target.value),
            placeholder: "Search compositions...",
            style: searchStyle,
            "aria-label": "Search compositions"
          }),
          /* @__PURE__ */ jsx71("div", {
            children: filtered.length === 0 ? /* @__PURE__ */ jsx71("div", {
              style: { opacity: 0.7, padding: 8, textAlign: "center" },
              children: "No compositions found"
            }) : filtered.map((id) => /* @__PURE__ */ jsx71(CompositionIdListItem, {
              id,
              isActive: id === currentId,
              onSelect
            }, id))
          })
        ]
      }) : null
    ]
  });
};

// src/error-overlay/react-overlay/index.ts
import { Internals as Internals19 } from "remotion";
var didUnmountReactApp = () => {
  return !Internals19.getPreviewDomElement()?.hasChildNodes();
};

// src/error-overlay/remotion-overlay/DismissButton.tsx
import { useCallback as useCallback31 } from "react";
import { jsx as jsx72 } from "react/jsx-runtime";
var size = {
  height: 20,
  width: 20
};
var style5 = {
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer"
};
var DismissButton = () => {
  const dismiss = useCallback31(() => {
    clearUrl();
  }, []);
  return /* @__PURE__ */ jsx72("button", {
    type: "button",
    style: style5,
    onClick: dismiss,
    children: /* @__PURE__ */ jsx72("svg", {
      focusable: "false",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 352 512",
      style: size,
      children: /* @__PURE__ */ jsx72("path", {
        fill: "white",
        d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
      })
    })
  });
};

// src/error-overlay/remotion-overlay/ErrorMessage.tsx
import { PlayerInternals as PlayerInternals9 } from "@remotion/player";
import { useCallback as useCallback32, useMemo as useMemo43, useRef as useRef20, useState as useState34 } from "react";
import { jsx as jsx73, jsxs as jsxs29 } from "react/jsx-runtime";
var fontSize = 24;
var lineHeight = 1.5;
var maxLines = 2;
var buttonSize = 32;
var maskImage = "linear-gradient(to bottom, white 60%, transparent)";
var container17 = {
  position: "relative",
  marginBottom: 15
};
var messageContainer = {
  overflow: "hidden"
};
var textContainer = {
  fontSize,
  lineHeight
};
var moreLine = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  border: `1px solid ${INPUT_BORDER_COLOR_HOVERED}`,
  height: 0,
  marginTop: 4
};
var moreButton = {
  height: buttonSize,
  width: buttonSize,
  borderRadius: buttonSize / 2,
  backgroundColor: INPUT_BACKGROUND,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  marginTop: -buttonSize / 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  color: "white"
};
var ErrorMessage = ({ message }) => {
  const [expanded, setExpanded] = useState34(false);
  const ref = useRef20(null);
  const size2 = PlayerInternals9.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: true
  });
  const errorLines = size2 ? size2.height / (lineHeight * fontSize) : null;
  const style6 = useMemo43(() => {
    const isExpanded = expanded || errorLines !== null && errorLines <= maxLines;
    return {
      ...messageContainer,
      maxHeight: isExpanded ? undefined : fontSize * lineHeight * maxLines,
      maskImage: isExpanded ? undefined : maskImage,
      WebkitMaskImage: isExpanded ? undefined : maskImage
    };
  }, [errorLines, expanded]);
  const toggle = useCallback32(() => {
    setExpanded((e) => !e);
  }, []);
  return /* @__PURE__ */ jsxs29("div", {
    style: container17,
    children: [
      /* @__PURE__ */ jsx73("div", {
        style: style6,
        children: /* @__PURE__ */ jsx73("div", {
          ref,
          style: textContainer,
          children: message
        })
      }),
      errorLines !== null && errorLines > maxLines ? /* @__PURE__ */ jsx73("div", {
        style: moreLine,
        children: /* @__PURE__ */ jsx73("button", {
          type: "button",
          onClick: toggle,
          style: moreButton,
          children: /* @__PURE__ */ jsx73(CaretDown2, {
            invert: expanded
          })
        })
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Symbolicating.tsx
import { jsx as jsx74, jsxs as jsxs30 } from "react/jsx-runtime";
var Symbolicating = (props) => {
  return /* @__PURE__ */ jsxs30("svg", {
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "16",
    height: "16",
    fill: "white",
    ...props,
    children: [
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(0 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(45 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.125s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(90 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.25s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(135 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.375s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(180 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.5s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(225 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.675s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(270 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.75s"
        })
      }),
      /* @__PURE__ */ jsx74("path", {
        opacity: ".1",
        d: "M14 0 H18 V8 H14 z",
        transform: "rotate(315 16 16)",
        children: /* @__PURE__ */ jsx74("animate", {
          attributeName: "opacity",
          from: "1",
          to: ".1",
          dur: "1s",
          repeatCount: "indefinite",
          begin: "0.875s"
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorTitle.tsx
import { jsx as jsx75, jsxs as jsxs31, Fragment as Fragment12 } from "react/jsx-runtime";
var title3 = {
  marginBottom: 8,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center"
};
var left = {
  flex: 1,
  paddingRight: 14,
  fontWeight: "bold",
  maxWidth: "100%"
};
var errName = {
  fontSize: 18,
  color: BLUE,
  display: "inline-block"
};
var row3 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var spacer = {
  width: 5
};
var ErrorTitle = ({ name, message, symbolicating, canHaveDismissButton }) => {
  return /* @__PURE__ */ jsxs31("div", {
    style: title3,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsxs31("div", {
        style: left,
        children: [
          /* @__PURE__ */ jsx75("span", {
            style: errName,
            children: name
          }),
          /* @__PURE__ */ jsx75("br", {}),
          /* @__PURE__ */ jsxs31("div", {
            style: row3,
            children: [
              symbolicating ? /* @__PURE__ */ jsxs31(Fragment12, {
                children: [
                  /* @__PURE__ */ jsx75(Symbolicating, {}),
                  /* @__PURE__ */ jsx75("div", {
                    style: spacer
                  })
                ]
              }) : null,
              /* @__PURE__ */ jsx75(ErrorMessage, {
                message
              })
            ]
          })
        ]
      }),
      didUnmountReactApp() ? null : canHaveDismissButton ? /* @__PURE__ */ jsx75(DismissButton, {}) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/get-help-link.ts
var getHelpLink = (message) => {
  if (message.includes("See https://www.remotion.dev/docs/the-fundamentals#defining-compositions")) {
    return {
      title: "Defining compositions",
      url: "See https://www.remotion.dev/docs/the-fundamentals#defining-compositions"
    };
  }
  if (message.includes("https://remotion.dev/docs/wrong-composition-mount")) {
    return {
      title: "Wrongly mounted <Composition>",
      url: "https://remotion.dev/docs/wrong-composition-mount"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-relative-paths")) {
    return {
      title: "staticFile() relative paths",
      url: "https://remotion.dev/docs/staticfile-relative-paths"
    };
  }
  if (message.includes("https://remotion.dev/docs/staticfile-remote-urls")) {
    return {
      title: "staticFile() remote URLs",
      url: "https://remotion.dev/docs/staticfile-remote-urls"
    };
  }
  if (message.includes("https://remotion.dev/docs/non-seekable-media")) {
    return {
      title: "Non-seekable media",
      url: "https://remotion.dev/docs/non-seekable-media"
    };
  }
  if (message.includes("https://remotion.dev/docs/media-playback-error")) {
    return {
      title: "Media playback error",
      url: "https://remotion.dev/docs/media-playback-error"
    };
  }
  if (message.includes("Div is not part of the THREE")) {
    return {
      title: "<Sequence> inside <ThreeCanvas>",
      url: "https://remotion.dev/docs/sequence#note-for-remotionthree"
    };
  }
  return null;
};

// src/error-overlay/remotion-overlay/HelpLink.tsx
import { useCallback as useCallback33, useEffect as useEffect29 } from "react";
import { jsx as jsx76, jsxs as jsxs32 } from "react/jsx-runtime";
var buttonStyle2 = {
  backgroundColor: BLUE,
  color: "white"
};
var HelpLink = ({ canHaveKeyboardShortcuts, link }) => {
  const openLink = useCallback33(() => {
    window.open(link.url, "_blank");
  }, [link]);
  const { registerKeybinding } = useKeybinding();
  useEffect29(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openLink();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "h",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openLink, registerKeybinding]);
  return /* @__PURE__ */ jsxs32(Button, {
    style: buttonStyle2,
    onClick: openLink,
    children: [
      "Help: ",
      '"',
      link.title,
      '"',
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx76(ShortcutHint, {
        keyToPress: "h",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/OpenInEditor.tsx
import {
  useCallback as useCallback34,
  useEffect as useEffect30,
  useMemo as useMemo44,
  useReducer,
  useRef as useRef21
} from "react";
import { jsx as jsx77, jsxs as jsxs33 } from "react/jsx-runtime";
var initialState = { type: "idle" };
var reducer = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "reset") {
    return {
      type: "idle"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var OpenInEditor = ({ stack, canHaveKeyboardShortcuts }) => {
  const isMounted = useRef21(true);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { registerKeybinding } = useKeybinding();
  const dispatchIfMounted = useCallback34((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const openInBrowser = useCallback34(() => {
    dispatch({ type: "start" });
    openInEditor(stack).then((res) => res.json()).then((data) => {
      if (data.success) {
        dispatchIfMounted({ type: "succeed" });
      } else {
        dispatchIfMounted({ type: "fail" });
      }
    }).catch((err) => {
      dispatchIfMounted({ type: "fail" });
      console.log("Could not open browser", err);
    }).finally(() => {
      setTimeout(() => {
        dispatchIfMounted({ type: "reset" });
      }, 2000);
    });
  }, [dispatchIfMounted, stack]);
  useEffect30(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  useEffect30(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "o",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  const label4 = useMemo44(() => {
    switch (state.type) {
      case "error":
        return "Failed to open";
      case "idle":
        return `Open in ${window.remotion_editorName}`;
      case "success":
        return `Opened in ${window.remotion_editorName}`;
      case "load":
        return `Opening...`;
      default:
        throw new Error("invalid state");
    }
  }, [state.type]);
  return /* @__PURE__ */ jsxs33(Button, {
    onClick: openInBrowser,
    disabled: state.type !== "idle",
    children: [
      label4,
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx77(ShortcutHint, {
        keyToPress: "o",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/Retry.tsx
import { jsx as jsx78 } from "react/jsx-runtime";
var RetryButton = ({ onClick }) => {
  return /* @__PURE__ */ jsx78(Button, {
    onClick,
    children: "Retry calculateMetadata()"
  });
};

// src/error-overlay/remotion-overlay/SearchGitHubIssues.tsx
import { useCallback as useCallback35, useEffect as useEffect31 } from "react";
import { jsx as jsx79, jsxs as jsxs34 } from "react/jsx-runtime";
var SearchGithubIssues = ({ message, canHaveKeyboardShortcuts }) => {
  const openInBrowser = useCallback35(() => {
    window.open(`https://github.com/remotion-dev/remotion/issues?q=${encodeURIComponent(message)}`, "_blank");
  }, [message]);
  const { registerKeybinding } = useKeybinding();
  useEffect31(() => {
    if (!canHaveKeyboardShortcuts) {
      return;
    }
    const onEditor = () => {
      openInBrowser();
    };
    const { unregister } = registerKeybinding({
      event: "keydown",
      key: "g",
      callback: onEditor,
      commandCtrlKey: true,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => unregister();
  }, [canHaveKeyboardShortcuts, openInBrowser, registerKeybinding]);
  return /* @__PURE__ */ jsxs34(Button, {
    onClick: openInBrowser,
    children: [
      "Search GitHub Issues",
      " ",
      canHaveKeyboardShortcuts ? /* @__PURE__ */ jsx79(ShortcutHint, {
        keyToPress: "g",
        cmdOrCtrl: true
      }) : null
    ]
  });
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import { useCallback as useCallback36, useState as useState35 } from "react";

// src/error-overlay/remotion-overlay/CodeFrame.tsx
import { jsx as jsx80, jsxs as jsxs35 } from "react/jsx-runtime";
var container18 = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};
var frame = {
  backgroundColor: "#070707",
  marginBottom: 20,
  overflowY: "auto"
};
var lineNumber = {
  whiteSpace: "pre",
  paddingRight: 12,
  color: "inherit",
  fontSize: 14,
  lineHeight: 1.7,
  width: 60,
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "flex-end",
  fontFamily: "monospace"
};
var CodeFrame = ({ source, lineNumberWidth }) => {
  return /* @__PURE__ */ jsx80("div", {
    style: frame,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: source.map((s, j) => {
      return /* @__PURE__ */ jsxs35("div", {
        style: container18,
        children: [
          /* @__PURE__ */ jsx80("div", {
            style: {
              ...lineNumber,
              backgroundColor: s.highlight ? "white" : "#121212",
              color: s.highlight ? "black" : "rgba(255, 255, 255, 0.6)"
            },
            children: String(s.lineNumber).padStart(lineNumberWidth, " ")
          }),
          /* @__PURE__ */ jsx80("div", {
            style: {
              fontFamily: "monospace",
              whiteSpace: "pre",
              tabSize: 2,
              color: s.highlight ? "white" : "rgba(255, 255, 255, 0.6)",
              backgroundColor: s.highlight ? BLUE : "transparent",
              lineHeight: 1.7,
              paddingRight: 12,
              paddingLeft: 12
            },
            children: s.content
          })
        ]
      }, j);
    })
  });
};

// src/error-overlay/remotion-overlay/format-location.ts
var formatLocation = (location) => {
  if (location.startsWith("webpack://")) {
    return location.replace("webpack://", "");
  }
  return location;
};

// src/error-overlay/remotion-overlay/StackFrame.tsx
import { jsx as jsx81, jsxs as jsxs36 } from "react/jsx-runtime";
var location = {
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "monospace",
  fontSize: 14
};
var header = {
  paddingLeft: 14,
  paddingTop: 10,
  paddingBottom: 10,
  paddingRight: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderBottom: "1px solid rgb(66, 144, 245)",
  backgroundColor: "black"
};
var left2 = {
  paddingRight: 14,
  flex: 1
};
var fnName = {
  fontSize: 14,
  lineHeight: 1.5,
  marginBottom: 3
};
var StackElement = ({ s, lineNumberWidth, isFirst, defaultFunctionName }) => {
  const [showCodeFrame, setShowCodeFrame] = useState35(() => !s.originalFileName?.includes("node_modules") && !s.originalFileName?.startsWith("webpack/") || isFirst);
  const toggleCodeFrame = useCallback36(() => {
    setShowCodeFrame((f) => !f);
  }, []);
  return /* @__PURE__ */ jsxs36("div", {
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsxs36("div", {
        style: header,
        children: [
          /* @__PURE__ */ jsxs36("div", {
            style: left2,
            children: [
              /* @__PURE__ */ jsx81("div", {
                style: fnName,
                children: s.originalFunctionName ?? defaultFunctionName
              }),
              s.originalFileName ? /* @__PURE__ */ jsxs36("div", {
                style: location,
                children: [
                  formatLocation(s.originalFileName),
                  ":",
                  s.originalLineNumber
                ]
              }) : null
            ]
          }),
          s.originalScriptCode && s.originalScriptCode.length > 0 ? /* @__PURE__ */ jsx81(Button, {
            onClick: toggleCodeFrame,
            children: showCodeFrame ? /* @__PURE__ */ jsx81(CaretDown2, {
              invert: false
            }) : /* @__PURE__ */ jsx81(CaretRight2, {})
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx81("div", {
        children: s.originalScriptCode && s.originalScriptCode.length > 0 && showCodeFrame ? /* @__PURE__ */ jsx81(CodeFrame, {
          lineNumberWidth,
          source: s.originalScriptCode
        }) : null
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorDisplay.tsx
import { jsx as jsx82, jsxs as jsxs37, Fragment as Fragment13 } from "react/jsx-runtime";
var stack = {
  marginTop: 17,
  overflowX: "scroll",
  marginBottom: "10vh"
};
var spacer2 = {
  width: 5,
  display: "inline-block"
};
var ErrorDisplay = ({
  display,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const compositionIds = window?.remotion_seenCompositionIds ?? [];
  const highestLineNumber = Math.max(...display.stackFrames.map((s) => s.originalScriptCode).flat(1).map((s) => s?.lineNumber ?? 0));
  const message = useMemo45(() => {
    const location2 = getLocationFromBuildError2(display.error);
    if (!location2) {
      return display.error.message;
    }
    return location2.message.replace(/\\n/g, `
`).replace(/\\t/g, "  ").replace(/^error:/, "").trim();
  }, [display.error]);
  const lineNumberWidth = String(highestLineNumber).length;
  const helpLink = getHelpLink(message);
  const getCurrentCompositionId = () => {
    const route = getRoute();
    const id = route.startsWith("/") ? route.slice(1) : route;
    return compositionIds.includes(id) ? id : compositionIds[0] ?? null;
  };
  return /* @__PURE__ */ jsxs37("div", {
    children: [
      /* @__PURE__ */ jsx82(ErrorTitle, {
        symbolicating: false,
        name: display.error.name,
        message,
        canHaveDismissButton
      }),
      helpLink ? /* @__PURE__ */ jsxs37(Fragment13, {
        children: [
          /* @__PURE__ */ jsx82(HelpLink, {
            link: helpLink,
            canHaveKeyboardShortcuts: keyboardShortcuts
          }),
          /* @__PURE__ */ jsx82("div", {
            style: spacer2
          })
        ]
      }) : null,
      display.stackFrames.length > 0 && window.remotion_editorName ? /* @__PURE__ */ jsxs37(Fragment13, {
        children: [
          /* @__PURE__ */ jsx82(OpenInEditor, {
            canHaveKeyboardShortcuts: keyboardShortcuts,
            stack: display.stackFrames[0]
          }),
          /* @__PURE__ */ jsx82("div", {
            style: spacer2
          })
        ]
      }) : null,
      compositionIds.length > 0 ? /* @__PURE__ */ jsxs37(Fragment13, {
        children: [
          /* @__PURE__ */ jsx82(CompositionIdsDropdown, {
            compositionIds,
            currentId: getCurrentCompositionId()
          }),
          /* @__PURE__ */ jsx82("div", {
            style: spacer2
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx82(SearchGithubIssues, {
        canHaveKeyboardShortcuts: keyboardShortcuts,
        message: display.error.message
      }),
      /* @__PURE__ */ jsx82("div", {
        style: spacer2
      }),
      /* @__PURE__ */ jsx82(AskOnDiscord, {
        canHaveKeyboardShortcuts: keyboardShortcuts
      }),
      onRetry ? /* @__PURE__ */ jsxs37(Fragment13, {
        children: [
          /* @__PURE__ */ jsx82("div", {
            style: spacer2
          }),
          /* @__PURE__ */ jsx82(RetryButton, {
            onClick: onRetry
          })
        ]
      }) : null,
      calculateMetadata ? /* @__PURE__ */ jsxs37(Fragment13, {
        children: [
          /* @__PURE__ */ jsx82("br", {}),
          /* @__PURE__ */ jsx82(Spacing, {
            y: 0.5
          }),
          /* @__PURE__ */ jsx82(CalculateMetadataErrorExplainer, {})
        ]
      }) : null,
      /* @__PURE__ */ jsx82("div", {
        style: stack,
        className: HORIZONTAL_SCROLLBAR_CLASSNAME,
        children: display.stackFrames.map((s, i) => {
          return /* @__PURE__ */ jsx82(StackElement, {
            isFirst: i === 0,
            s,
            lineNumberWidth,
            defaultFunctionName: "(anonymous function)"
          }, i);
        })
      })
    ]
  });
};

// src/error-overlay/remotion-overlay/ErrorLoader.tsx
import { jsx as jsx83, jsxs as jsxs38 } from "react/jsx-runtime";
var container19 = {
  width: "100%",
  maxWidth: 1000,
  paddingLeft: 14,
  paddingRight: 14,
  marginLeft: "auto",
  marginRight: "auto",
  fontFamily: "SF Pro Text, sans-serif",
  paddingTop: "5vh"
};
var errorWhileErrorStyle = {
  color: "white",
  lineHeight: 1.5,
  whiteSpace: "pre"
};
var ErrorLoader = ({
  error,
  keyboardShortcuts,
  onRetry,
  canHaveDismissButton,
  calculateMetadata
}) => {
  const [state, setState] = useState36({
    type: "loading"
  });
  useEffect32(() => {
    getErrorRecord(error).then((record) => {
      if (record) {
        setState({
          type: "symbolicated",
          record
        });
      } else {
        setState({
          type: "no-record"
        });
      }
    }).catch((err) => {
      setState({
        err,
        type: "error"
      });
    });
  }, [error]);
  if (state.type === "loading") {
    return /* @__PURE__ */ jsx83("div", {
      style: container19,
      children: /* @__PURE__ */ jsx83(ErrorTitle, {
        symbolicating: true,
        name: error.name,
        message: error.message,
        canHaveDismissButton
      })
    });
  }
  if (state.type === "error") {
    return /* @__PURE__ */ jsxs38("div", {
      style: container19,
      children: [
        /* @__PURE__ */ jsx83(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        /* @__PURE__ */ jsx83("div", {
          style: errorWhileErrorStyle,
          children: "Error while getting stack trace:"
        }),
        /* @__PURE__ */ jsx83("div", {
          style: errorWhileErrorStyle,
          children: state.err.stack
        }),
        /* @__PURE__ */ jsx83("div", {
          style: errorWhileErrorStyle,
          children: "Report this in the Remotion repo."
        })
      ]
    });
  }
  if (state.type === "no-record") {
    return /* @__PURE__ */ jsxs38("div", {
      style: container19,
      children: [
        /* @__PURE__ */ jsx83(ErrorTitle, {
          symbolicating: false,
          name: error.name,
          message: error.message,
          canHaveDismissButton
        }),
        /* @__PURE__ */ jsx83("div", {
          style: errorWhileErrorStyle,
          children: "Check the Terminal and browser console for error messages."
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx83("div", {
    style: container19,
    children: /* @__PURE__ */ jsx83(ErrorDisplay, {
      keyboardShortcuts,
      display: state.record,
      onRetry,
      canHaveDismissButton,
      calculateMetadata
    })
  });
};

// src/components/Canvas.tsx
import {
  useCallback as useCallback40,
  useContext as useContext30,
  useEffect as useEffect35,
  useMemo as useMemo51,
  useState as useState38
} from "react";
import { Internals as Internals24, watchStaticFile } from "remotion";

// src/helpers/get-effective-translation.ts
var getEffectiveXTranslation = ({
  canvasSize,
  scale,
  compositionWidth,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.width / 2 + scale * compositionWidth / 2 - MUST_BE_INSIDE_CANVAS);
  return Math.max(-maxTranslation, Math.min(translation.x, maxTranslation));
};
var MUST_BE_INSIDE_CANVAS = 50;
var getEffectiveYTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  translation
}) => {
  const maxTranslation = Math.abs(canvasSize.height / 2 + scale * compositionHeight / 2) - MUST_BE_INSIDE_CANVAS;
  return Math.max(-maxTranslation, Math.min(translation.y, maxTranslation));
};
var getEffectiveTranslation = ({
  canvasSize,
  scale,
  compositionHeight,
  compositionWidth,
  translation
}) => {
  return {
    x: getEffectiveXTranslation({
      canvasSize,
      compositionWidth,
      scale,
      translation
    }),
    y: getEffectiveYTranslation({
      canvasSize,
      compositionHeight,
      scale,
      translation
    })
  };
};
var getCenterPointWhileScrolling = ({
  size: size2,
  clientX,
  clientY,
  compositionWidth,
  compositionHeight,
  scale,
  translation
}) => {
  const mouseLeft = clientX - size2.left;
  const mouseTop = clientY - size2.top;
  const contentLeftPoint = size2.width / 2 - compositionWidth * scale / 2 - translation.x;
  const contentTopPoint = size2.height / 2 - compositionHeight * scale / 2 - translation.y;
  const offsetFromVideoLeft = Math.min(compositionWidth, Math.max(0, (mouseLeft - contentLeftPoint) / scale));
  const offsetFromVideoTop = Math.min(compositionHeight, Math.max(0, (mouseTop - contentTopPoint) / scale));
  return {
    centerX: offsetFromVideoLeft,
    centerY: offsetFromVideoTop
  };
};

// src/helpers/smooth-zoom.ts
var BASE = Math.E / 4;
var MIN_ZOOM = 0.05;
var MAX_ZOOM = 10;
function logN(val) {
  return Math.log(val) / Math.log(BASE);
}
var smoothenZoom = (input) => {
  return BASE ** (input - 1);
};
var unsmoothenZoom = (input) => {
  if (input < 0) {
    return MAX_ZOOM;
  }
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, logN(input) + 1));
};

// src/components/EditorGuides/index.tsx
import { useContext as useContext26, useMemo as useMemo48 } from "react";
import { Internals as Internals21 } from "remotion";

// src/helpers/use-studio-canvas-dimensions.ts
import { PlayerInternals as PlayerInternals10 } from "@remotion/player";
import { useContext as useContext24, useMemo as useMemo46 } from "react";
import { Internals as Internals20 } from "remotion";
var useStudioCanvasDimensions = ({
  canvasSize,
  contentDimensions,
  assetMetadata
}) => {
  const { size: previewSize } = useContext24(Internals20.PreviewSizeContext);
  const { centerX, centerY, scale } = useMemo46(() => {
    if (contentDimensions === "none" || contentDimensions === null || assetMetadata && assetMetadata.type === "not-found" || !canvasSize) {
      return {
        centerX: previewSize.translation.x,
        centerY: previewSize.translation.y,
        scale: 1
      };
    }
    return PlayerInternals10.calculateCanvasTransformation({
      canvasSize,
      compositionHeight: contentDimensions.height,
      compositionWidth: contentDimensions.width,
      previewSize: previewSize.size
    });
  }, [
    canvasSize,
    contentDimensions,
    previewSize.size,
    previewSize.translation.y,
    previewSize.translation.x,
    assetMetadata
  ]);
  const canvasPosition = useMemo46(() => {
    return {
      left: centerX - previewSize.translation.x,
      top: centerY - previewSize.translation.y,
      width: contentDimensions === "none" || !contentDimensions ? canvasSize?.width || 0 : contentDimensions.width * scale,
      height: contentDimensions === "none" || !contentDimensions ? canvasSize?.height || 0 : contentDimensions.height * scale
    };
  }, [
    scale,
    centerX,
    previewSize.translation.x,
    previewSize.translation.y,
    centerY,
    canvasSize,
    contentDimensions
  ]);
  return {
    canvasPosition,
    scale
  };
};

// src/components/EditorGuides/Guide.tsx
import { memo, useCallback as useCallback37, useContext as useContext25, useMemo as useMemo47 } from "react";
import { NoReactInternals as NoReactInternals6 } from "remotion/no-react";
import { jsx as jsx84 } from "react/jsx-runtime";
var PADDING_FOR_EASY_DRAG = 4;
var GuideComp = ({ guide, canvasDimensions, scale }) => {
  const {
    shouldCreateGuideRef,
    setGuidesList,
    setSelectedGuideId,
    selectedGuideId,
    setHoveredGuideId,
    hoveredGuideId
  } = useContext25(EditorShowGuidesContext);
  const onPointerEnter = useCallback37(() => {
    setHoveredGuideId(() => guide.id);
  }, [guide.id, setHoveredGuideId]);
  const onPointerLeave = useCallback37(() => {
    setHoveredGuideId(() => null);
  }, [setHoveredGuideId]);
  const isVerticalGuide = guide.orientation === "vertical";
  const guideStyle = useMemo47(() => {
    const canvasPosition = isVerticalGuide ? canvasDimensions.left : canvasDimensions.top;
    const guidePosition = guide.position * scale + canvasPosition;
    return {
      position: "absolute",
      width: `${isVerticalGuide ? "1px" : "100%"}`,
      height: `${isVerticalGuide ? "100%" : "1px"}`,
      left: `${isVerticalGuide ? guidePosition - PADDING_FOR_EASY_DRAG : 0}px`,
      top: `${isVerticalGuide ? 0 : guidePosition - PADDING_FOR_EASY_DRAG}px`,
      cursor: `${isVerticalGuide ? "ew-resize" : "ns-resize"}`,
      padding: isVerticalGuide ? `0 ${PADDING_FOR_EASY_DRAG}px` : `${PADDING_FOR_EASY_DRAG}px 0`
    };
  }, [guide, scale, canvasDimensions, isVerticalGuide]);
  const guideContentStyle = useMemo47(() => {
    return {
      position: "relative",
      minWidth: `${isVerticalGuide ? "1px" : `calc(100% + ${RULER_WIDTH}px`}`,
      minHeight: `${isVerticalGuide ? `calc(100% + ${RULER_WIDTH}px` : "1px"}`,
      top: `${isVerticalGuide ? `-${RULER_WIDTH}px` : "0px"}`,
      left: `${isVerticalGuide ? "0px" : `-${RULER_WIDTH}px`}`,
      display: guide.show ? "block" : "none",
      backgroundColor: selectedGuideId === guide.id || hoveredGuideId === guide.id ? SELECTED_GUIDE : UNSELECTED_GUIDE
    };
  }, [isVerticalGuide, guide.show, guide.id, selectedGuideId, hoveredGuideId]);
  const onMouseDown = useCallback37((e) => {
    e.preventDefault();
    if (e.button !== 0) {
      return;
    }
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    setSelectedGuideId(() => guide.id);
  }, [shouldCreateGuideRef, setSelectedGuideId, guide.id]);
  const values = useMemo47(() => {
    return [
      {
        id: "1",
        keyHint: null,
        label: "Remove guide",
        leftItem: null,
        onClick: () => {
          setGuidesList((prevState) => {
            const newGuides = prevState.filter((selected) => {
              return selected.id !== guide.id;
            });
            persistGuidesList(newGuides);
            return newGuides;
          });
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "remove"
      }
    ];
  }, [guide.id, setGuidesList]);
  return /* @__PURE__ */ jsx84(ContextMenu, {
    values,
    children: /* @__PURE__ */ jsx84("div", {
      style: guideStyle,
      onMouseDown,
      className: "__remotion_editor_guide",
      onPointerEnter,
      onPointerLeave,
      children: /* @__PURE__ */ jsx84("div", {
        style: guideContentStyle,
        className: [
          "__remotion_editor_guide_content",
          selectedGuideId === guide.id || hoveredGuideId === guide.id ? "__remotion_editor_guide_selected" : null
        ].filter(NoReactInternals6.truthy).join(" ")
      })
    })
  });
};
var Guide_default = memo(GuideComp);

// src/components/EditorGuides/index.tsx
import { jsx as jsx85, Fragment as Fragment14 } from "react/jsx-runtime";
var EditorGuides = ({ canvasSize, contentDimensions, assetMetadata }) => {
  const { canvasPosition: canvasDimensions, scale } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const { canvasContent } = useContext26(Internals21.CompositionManager);
  if (canvasContent === null || canvasContent.type !== "composition") {
    throw new Error("Expected to be in a composition");
  }
  const { guidesList } = useContext26(EditorShowGuidesContext);
  const guidesForThisComposition = useMemo48(() => {
    return guidesList.filter((guide) => {
      return guide.compositionId === canvasContent.compositionId;
    });
  }, [canvasContent.compositionId, guidesList]);
  return /* @__PURE__ */ jsx85(Fragment14, {
    children: guidesForThisComposition.map((guide) => {
      return /* @__PURE__ */ jsx85(Guide_default, {
        guide,
        canvasDimensions,
        scale
      }, guide.id);
    })
  });
};
var EditorGuides_default = EditorGuides;

// src/components/EditorRuler/index.tsx
import {
  useCallback as useCallback39,
  useContext as useContext28,
  useEffect as useEffect34,
  useMemo as useMemo50,
  useRef as useRef23
} from "react";

// src/helpers/editor-ruler.ts
var drawLabel = ({
  orientation,
  context,
  label: label4,
  originDistance,
  color
}) => {
  context.fillStyle = color;
  if (orientation === "horizontal") {
    context.fillText(label4, originDistance + 4, 16);
  } else {
    context.rotate(-Math.PI / 2);
    context.fillText(label4, -originDistance + 4, 16);
    context.rotate(Math.PI / 2);
  }
};
var drawGradient = ({
  orientation,
  context,
  originDistance,
  canvasHeight,
  canvasWidth
}) => {
  const size2 = 250;
  const startX = orientation === "horizontal" ? originDistance - size2 / 2 : 0;
  const startY = orientation === "horizontal" ? 0 : originDistance - size2 / 2;
  const endX = orientation === "horizontal" ? originDistance + size2 / 2 : canvasWidth;
  const endY = orientation === "horizontal" ? canvasHeight : originDistance + size2 / 2;
  const grd = context.createLinearGradient(startX, startY, endX, endY);
  grd.addColorStop(0, BACKGROUND__TRANSPARENT);
  grd.addColorStop(0.25, BACKGROUND);
  grd.addColorStop(0.75, BACKGROUND);
  grd.addColorStop(1, BACKGROUND__TRANSPARENT);
  context.fillStyle = grd;
  context.fillRect(startX, startY, endX - startX, endY - startY);
};
var drawGuide = ({
  selectedGuide,
  scale,
  startMarking,
  context,
  canvasHeight,
  canvasWidth,
  orientation,
  originOffset
}) => {
  const originDistance = rulerValueToPosition({
    value: selectedGuide.position,
    startMarking,
    scale
  }) + originOffset - startMarking * scale;
  drawGradient({
    canvasHeight,
    context,
    orientation,
    originDistance,
    canvasWidth
  });
  context.strokeStyle = SELECTED_GUIDE;
  context.lineWidth = 1;
  context.beginPath();
  if (orientation === "horizontal" && selectedGuide.orientation === "horizontal") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "vertical") {
    return;
  }
  if (orientation === "vertical" && selectedGuide.orientation === "horizontal") {
    context.moveTo(0, originDistance);
    context.lineTo(canvasWidth, originDistance);
    drawLabel({
      context,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  } else if (orientation === "horizontal" && selectedGuide.orientation === "vertical") {
    context.moveTo(originDistance, 0);
    context.lineTo(originDistance, canvasHeight);
    drawLabel({
      context,
      label: selectedGuide.position.toString(),
      originDistance,
      orientation,
      color: SELECTED_GUIDE
    });
  }
  context.stroke();
};
var drawMarkingOnRulerCanvas = ({
  scale,
  points,
  startMarking,
  originOffset,
  markingGaps,
  orientation,
  rulerCanvasRef,
  selectedGuide,
  canvasHeight,
  canvasWidth
}) => {
  const canvas = rulerCanvasRef.current;
  if (!canvas)
    return;
  const context = canvas.getContext("2d");
  if (!context)
    return;
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  context.scale(window.devicePixelRatio, window.devicePixelRatio);
  context.clearRect(0, 0, canvasWidth, canvasHeight);
  context.strokeStyle = RULER_COLOR;
  context.lineWidth = 1;
  context.beginPath();
  points.forEach((point) => {
    context.strokeStyle = RULER_COLOR;
    context.lineWidth = 1;
    const originDistance = point.position + originOffset - startMarking * scale;
    context.beginPath();
    if (orientation === "horizontal") {
      context.moveTo(originDistance, 0);
      context.lineTo(originDistance, canvasHeight);
    } else {
      context.moveTo(0, originDistance);
      context.lineTo(canvasWidth, originDistance);
    }
    for (let i = 1;i < 5; i++) {
      const markingOffsetXY = i * markingGaps * scale;
      if (orientation === "horizontal") {
        context.moveTo(originDistance + markingOffsetXY / 5, 0);
        context.lineTo(originDistance + markingOffsetXY / 5, 4);
      } else {
        context.moveTo(0, originDistance + markingOffsetXY / 5);
        context.lineTo(4, originDistance + markingOffsetXY / 5);
      }
    }
    context.stroke();
    context.font = "10px Arial, Helvetica, sans-serif";
    context.textAlign = "left";
    context.fillStyle = RULER_COLOR;
    drawLabel({
      orientation,
      context,
      label: point.value.toString(),
      originDistance,
      color: RULER_COLOR
    });
  });
  if (selectedGuide && orientation !== selectedGuide.orientation) {
    drawGuide({
      canvasHeight,
      canvasWidth,
      context,
      orientation,
      originOffset,
      scale,
      selectedGuide,
      startMarking
    });
  }
};
var getRulerPoints = ({
  rulerScaleRange,
  rulerMarkingGaps,
  scale
}) => {
  const points = [];
  const startPoint = Math.ceil(rulerScaleRange.start / rulerMarkingGaps);
  const endPoint = Math.floor(rulerScaleRange.end / rulerMarkingGaps);
  const startMarking = startPoint * rulerMarkingGaps;
  for (let i = startPoint;i <= endPoint; i++) {
    points.push({
      value: i * rulerMarkingGaps,
      position: rulerValueToPosition({
        scale,
        startMarking,
        value: i * rulerMarkingGaps
      })
    });
  }
  return {
    points,
    startMarking
  };
};
var rulerValueToPosition = ({
  value,
  startMarking,
  scale
}) => {
  return (value + startMarking) * scale;
};
var getRulerScaleRange = ({
  canvasLength,
  scale,
  canvasSize
}) => {
  const scaleRangeBeyondCanvas = (canvasSize.width || MINIMUM_VISIBLE_CANVAS_SIZE - MINIMUM_VISIBLE_CANVAS_SIZE) / scale;
  return {
    start: -scaleRangeBeyondCanvas,
    end: scaleRangeBeyondCanvas + canvasLength
  };
};

// src/components/EditorRuler/Ruler.tsx
import {
  useCallback as useCallback38,
  useContext as useContext27,
  useEffect as useEffect33,
  useMemo as useMemo49,
  useRef as useRef22,
  useState as useState37
} from "react";
import { Internals as Internals22 } from "remotion";
import { jsx as jsx86 } from "react/jsx-runtime";
var makeGuideId = () => {
  return Math.random().toString(36).substring(7);
};
var Ruler = ({
  scale,
  points,
  originOffset,
  startMarking,
  size: size2,
  markingGaps,
  orientation
}) => {
  const rulerCanvasRef = useRef22(null);
  const isVerticalRuler = orientation === "vertical";
  const {
    shouldCreateGuideRef,
    setGuidesList,
    selectedGuideId,
    hoveredGuideId,
    setSelectedGuideId,
    guidesList,
    setEditorShowGuides
  } = useContext27(EditorShowGuidesContext);
  const unsafeVideoConfig = Internals22.useUnsafeVideoConfig();
  if (!unsafeVideoConfig) {
    throw new Error("Video config not set");
  }
  const [cursor, setCursor] = useState37(isVerticalRuler ? "ew-resize" : "ns-resize");
  const selectedOrHoveredGuide = useMemo49(() => {
    return guidesList.find((guide) => guide.id === selectedGuideId) ?? guidesList.find((guide) => guide.id === hoveredGuideId) ?? null;
  }, [guidesList, hoveredGuideId, selectedGuideId]);
  const rulerWidth = isVerticalRuler ? RULER_WIDTH : size2.width - RULER_WIDTH;
  const rulerHeight = isVerticalRuler ? size2.height - RULER_WIDTH : RULER_WIDTH;
  useEffect33(() => {
    drawMarkingOnRulerCanvas({
      scale,
      points,
      startMarking,
      originOffset,
      markingGaps,
      orientation,
      rulerCanvasRef,
      selectedGuide: selectedOrHoveredGuide,
      canvasHeight: rulerHeight * window.devicePixelRatio,
      canvasWidth: rulerWidth * window.devicePixelRatio
    });
  }, [
    scale,
    points,
    startMarking,
    originOffset,
    markingGaps,
    orientation,
    selectedOrHoveredGuide,
    size2,
    rulerHeight,
    rulerWidth
  ]);
  const rulerStyle = useMemo49(() => ({
    position: "absolute",
    background: BACKGROUND,
    width: rulerWidth,
    height: rulerHeight,
    left: isVerticalRuler ? 0 : "unset",
    top: isVerticalRuler ? "unset" : 0,
    borderBottom: isVerticalRuler ? undefined : "1px solid " + RULER_COLOR,
    borderRight: isVerticalRuler ? "1px solid " + RULER_COLOR : undefined,
    cursor
  }), [rulerWidth, rulerHeight, cursor, isVerticalRuler]);
  const onMouseDown = useCallback38((e) => {
    if (e.button !== 0) {
      return;
    }
    e.preventDefault();
    shouldCreateGuideRef.current = true;
    document.body.style.cursor = "no-drop";
    const guideId = makeGuideId();
    setEditorShowGuides(() => true);
    setSelectedGuideId(() => guideId);
    setGuidesList((prevState) => {
      return [
        ...prevState,
        {
          orientation,
          position: -originOffset,
          show: false,
          id: guideId,
          compositionId: unsafeVideoConfig.id
        }
      ];
    });
  }, [
    shouldCreateGuideRef,
    setEditorShowGuides,
    setSelectedGuideId,
    setGuidesList,
    orientation,
    originOffset,
    unsafeVideoConfig.id
  ]);
  const changeCursor = useCallback38((e) => {
    e.preventDefault();
    if (selectedGuideId !== null) {
      setCursor("no-drop");
    }
  }, [setCursor, selectedGuideId]);
  useEffect33(() => {
    if (selectedGuideId === null) {
      setCursor(isVerticalRuler ? "ew-resize" : "ns-resize");
    }
  }, [selectedGuideId, isVerticalRuler]);
  return /* @__PURE__ */ jsx86("canvas", {
    ref: rulerCanvasRef,
    width: rulerWidth * window.devicePixelRatio,
    height: rulerHeight * window.devicePixelRatio,
    style: rulerStyle,
    onPointerDown: onMouseDown,
    onPointerEnter: changeCursor,
    onPointerLeave: changeCursor
  });
};
var Ruler_default = Ruler;

// src/components/EditorRuler/index.tsx
import { jsx as jsx87, jsxs as jsxs39, Fragment as Fragment15 } from "react/jsx-runtime";
var originBlockStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  borderBottom: "1px solid " + RULER_COLOR,
  borderRight: "1px solid " + RULER_COLOR,
  width: `${RULER_WIDTH}px`,
  height: `${RULER_WIDTH}px`,
  background: BACKGROUND
};
var EditorRulers = ({ contentDimensions, canvasSize, assetMetadata, containerRef }) => {
  const { scale, canvasPosition } = useStudioCanvasDimensions({
    canvasSize,
    contentDimensions,
    assetMetadata
  });
  const {
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    setSelectedGuideId
  } = useContext28(EditorShowGuidesContext);
  const rulerMarkingGaps = useMemo50(() => {
    const minimumGap = MINIMUM_RULER_MARKING_GAP_PX;
    const predefinedGap = PREDEFINED_RULER_SCALE_GAPS.find((gap) => gap * scale > minimumGap);
    return predefinedGap || MAXIMUM_PREDEFINED_RULER_SCALE_GAP;
  }, [scale]);
  const horizontalRulerScaleRange = useMemo50(() => getRulerScaleRange({
    canvasLength: canvasPosition.width,
    scale,
    canvasSize
  }), [canvasPosition.width, canvasSize, scale]);
  const verticalRulerScaleRange = useMemo50(() => getRulerScaleRange({
    canvasLength: canvasPosition.height,
    scale,
    canvasSize
  }), [canvasPosition.height, canvasSize, scale]);
  const {
    points: horizontalRulerPoints,
    startMarking: horizontalRulerStartMarking
  } = useMemo50(() => getRulerPoints({
    rulerScaleRange: horizontalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [horizontalRulerScaleRange, rulerMarkingGaps, scale]);
  const { points: verticalRulerPoints, startMarking: verticalRulerStartMarking } = useMemo50(() => getRulerPoints({
    rulerScaleRange: verticalRulerScaleRange,
    rulerMarkingGaps,
    scale
  }), [verticalRulerScaleRange, rulerMarkingGaps, scale]);
  const requestAnimationFrameRef = useRef23(null);
  const onMouseMove = useCallback39((e) => {
    if (requestAnimationFrameRef.current) {
      cancelAnimationFrame(requestAnimationFrameRef.current);
    }
    requestAnimationFrameRef.current = requestAnimationFrame(() => {
      const { clientX: mouseX, clientY: mouseY } = e;
      const {
        left: containerLeft = 0,
        top: containerTop = 0,
        right: containerRight = 0,
        bottom: containerBottom = 0
      } = containerRef.current?.getBoundingClientRect() || {};
      if (mouseX < containerLeft || mouseX > containerRight || mouseY < containerTop || mouseY > containerBottom) {
        if (!shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = true;
        }
        if (document.body.style.cursor !== "no-drop") {
          document.body.style.cursor = "no-drop";
        }
        setGuidesList((prevState) => {
          const newGuides = prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            return {
              ...guide,
              show: false
            };
          });
          persistGuidesList(newGuides);
          return newGuides;
        });
      } else {
        if (shouldDeleteGuideRef.current) {
          shouldDeleteGuideRef.current = false;
        }
        setGuidesList((prevState) => {
          return prevState.map((guide) => {
            if (guide.id !== selectedGuideId) {
              return guide;
            }
            const position = guide.orientation === "vertical" ? (mouseX - containerLeft) / scale - canvasPosition.left / scale : (mouseY - containerTop) / scale - canvasPosition.top / scale;
            const desiredCursor = guide.orientation === "vertical" ? "ew-resize" : "ns-resize";
            if (document.body.style.cursor !== desiredCursor) {
              document.body.style.cursor = desiredCursor;
            }
            return {
              ...guide,
              position: Math.floor(position / 1),
              show: true
            };
          });
        });
      }
    });
  }, [
    containerRef,
    shouldDeleteGuideRef,
    setGuidesList,
    selectedGuideId,
    scale,
    canvasPosition.left,
    canvasPosition.top
  ]);
  const onMouseUp = useCallback39(() => {
    setGuidesList((prevState) => {
      const newGuides = prevState.filter((selected) => {
        if (!shouldDeleteGuideRef.current) {
          return true;
        }
        return selected.id !== selectedGuideId;
      });
      persistGuidesList(newGuides);
      return newGuides;
    });
    shouldDeleteGuideRef.current = false;
    document.body.style.cursor = "auto";
    shouldCreateGuideRef.current = false;
    setSelectedGuideId(() => null);
    document.removeEventListener("pointerup", onMouseUp);
    document.removeEventListener("pointermove", onMouseMove);
  }, [
    selectedGuideId,
    shouldCreateGuideRef,
    shouldDeleteGuideRef,
    setSelectedGuideId,
    setGuidesList,
    onMouseMove
  ]);
  useEffect34(() => {
    if (selectedGuideId !== null) {
      document.addEventListener("pointermove", onMouseMove);
      document.addEventListener("pointerup", onMouseUp);
    }
    return () => {
      document.removeEventListener("pointermove", onMouseMove);
      document.removeEventListener("pointerup", onMouseUp);
      if (requestAnimationFrameRef.current) {
        cancelAnimationFrame(requestAnimationFrameRef.current);
      }
    };
  }, [selectedGuideId, onMouseMove, onMouseUp]);
  return /* @__PURE__ */ jsxs39(Fragment15, {
    children: [
      /* @__PURE__ */ jsx87("div", {
        style: originBlockStyles
      }),
      /* @__PURE__ */ jsx87(Ruler_default, {
        orientation: "horizontal",
        scale,
        points: horizontalRulerPoints,
        startMarking: horizontalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.left,
        size: canvasSize
      }),
      /* @__PURE__ */ jsx87(Ruler_default, {
        orientation: "vertical",
        scale,
        points: verticalRulerPoints,
        startMarking: verticalRulerStartMarking,
        markingGaps: rulerMarkingGaps,
        originOffset: canvasPosition.top,
        size: canvasSize
      })
    ]
  });
};

// src/components/EditorRuler/use-is-ruler-visible.ts
import { useContext as useContext29 } from "react";
import { Internals as Internals23 } from "remotion";
var useIsRulerVisible = () => {
  const { canvasContent } = useContext29(Internals23.CompositionManager);
  const { editorShowRulers } = useContext29(EditorShowRulersContext);
  return editorShowRulers && canvasContent && canvasContent.type === "composition";
};

// src/components/ResetZoomButton.tsx
import { jsx as jsx88 } from "react/jsx-runtime";
var ResetZoomButton = ({ onClick }) => {
  return /* @__PURE__ */ jsx88(Button, {
    onClick,
    children: "Reset zoom"
  });
};

// src/components/Canvas.tsx
import { jsx as jsx89, jsxs as jsxs40, Fragment as Fragment16 } from "react/jsx-runtime";
var container20 = {
  flex: 1,
  display: "flex",
  overflow: "hidden",
  position: "relative",
  backgroundColor: BACKGROUND
};
var resetZoom = {
  position: "absolute",
  top: SPACING_UNIT * 2,
  right: SPACING_UNIT * 2
};
var ZOOM_PX_FACTOR = 0.003;
var Canvas = ({ canvasContent, size: size2 }) => {
  const { setSize, size: previewSize } = useContext30(Internals24.PreviewSizeContext);
  const { editorZoomGestures } = useContext30(EditorZoomGesturesContext);
  const keybindings = useKeybinding();
  const config = Internals24.useUnsafeVideoConfig();
  const areRulersVisible = useIsRulerVisible();
  const { editorShowGuides } = useContext30(EditorShowGuidesContext);
  const [assetResolution, setAssetResolution] = useState38(null);
  const contentDimensions = useMemo51(() => {
    if ((canvasContent.type === "asset" || canvasContent.type === "output" || canvasContent.type === "output-blob") && assetResolution && assetResolution.type === "found") {
      return assetResolution.dimensions;
    }
    if (config) {
      return { width: config.width, height: config.height };
    }
    return null;
  }, [assetResolution, config, canvasContent]);
  const isFit = previewSize.size === "auto";
  const onWheel = useCallback40((e) => {
    if (!editorZoomGestures) {
      return;
    }
    if (!size2) {
      return;
    }
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    const wantsToZoom = e.ctrlKey || e.metaKey;
    if (!wantsToZoom && isFit) {
      return;
    }
    e.preventDefault();
    setSize((prevSize) => {
      const scale = Internals24.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      if (wantsToZoom) {
        const oldSize = prevSize.size === "auto" ? scale : prevSize.size;
        const smoothened = smoothenZoom(oldSize);
        const added = smoothened + e.deltaY * ZOOM_PX_FACTOR;
        const unsmoothened = unsmoothenZoom(added);
        const { centerX, centerY } = getCenterPointWhileScrolling({
          size: size2,
          clientX: e.clientX,
          clientY: e.clientY,
          compositionWidth: contentDimensions.width,
          compositionHeight: contentDimensions.height,
          scale,
          translation: prevSize.translation
        });
        const zoomDifference = unsmoothened - oldSize;
        const uvCoordinatesX = centerX / contentDimensions.width;
        const uvCoordinatesY = centerY / contentDimensions.height;
        const correctionLeft = -uvCoordinatesX * (zoomDifference * contentDimensions.width) + (1 - uvCoordinatesX) * zoomDifference * contentDimensions.width;
        const correctionTop = -uvCoordinatesY * (zoomDifference * contentDimensions.height) + (1 - uvCoordinatesY) * zoomDifference * contentDimensions.height;
        return {
          translation: getEffectiveTranslation({
            translation: {
              x: prevSize.translation.x - correctionLeft / 2,
              y: prevSize.translation.y - correctionTop / 2
            },
            canvasSize: size2,
            compositionHeight: contentDimensions.height,
            compositionWidth: contentDimensions.width,
            scale
          }),
          size: unsmoothened
        };
      }
      const effectiveTranslation = getEffectiveTranslation({
        translation: prevSize.translation,
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        scale
      });
      return {
        ...prevSize,
        translation: getEffectiveTranslation({
          translation: {
            x: effectiveTranslation.x + e.deltaX,
            y: effectiveTranslation.y + e.deltaY
          },
          canvasSize: size2,
          compositionHeight: contentDimensions.height,
          compositionWidth: contentDimensions.width,
          scale
        })
      };
    });
  }, [editorZoomGestures, contentDimensions, isFit, setSize, size2]);
  useEffect35(() => {
    const { current } = canvasRef;
    if (!current) {
      return;
    }
    current.addEventListener("wheel", onWheel, { passive: false });
    return () => current.removeEventListener("wheel", onWheel, {
      passive: false
    });
  }, [onWheel]);
  const onReset = useCallback40(() => {
    setSize(() => {
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: "auto"
      };
    });
  }, [setSize]);
  const onZoomIn = useCallback40(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals24.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.min(MAX_ZOOM, scale * 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  const onZoomOut = useCallback40(() => {
    if (!contentDimensions || contentDimensions === "none") {
      return;
    }
    if (!size2) {
      return;
    }
    setSize((prevSize) => {
      const scale = Internals24.calculateScale({
        canvasSize: size2,
        compositionHeight: contentDimensions.height,
        compositionWidth: contentDimensions.width,
        previewSize: prevSize.size
      });
      return {
        translation: {
          x: 0,
          y: 0
        },
        size: Math.max(MIN_ZOOM, scale / 2)
      };
    });
  }, [contentDimensions, setSize, size2]);
  useEffect35(() => {
    const resetBinding = keybindings.registerKeybinding({
      event: "keydown",
      key: "0",
      commandCtrlKey: false,
      callback: onReset,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomIn = keybindings.registerKeybinding({
      event: "keydown",
      key: "+",
      commandCtrlKey: false,
      callback: onZoomIn,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zoomOut = keybindings.registerKeybinding({
      event: "keydown",
      key: "-",
      commandCtrlKey: false,
      callback: onZoomOut,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      resetBinding.unregister();
      zoomIn.unregister();
      zoomOut.unregister();
    };
  }, [keybindings, onReset, onZoomIn, onZoomOut]);
  const fetchMetadata = useCallback40(async () => {
    setAssetResolution(null);
    if (canvasContent.type === "composition") {
      return;
    }
    const metadata = await getAssetMetadata(canvasContent, canvasContent.type === "asset");
    setAssetResolution(metadata);
  }, [canvasContent]);
  useEffect35(() => {
    if (canvasContent.type !== "asset") {
      return;
    }
    const file = watchStaticFile(canvasContent.asset, () => {
      fetchMetadata();
    });
    return () => {
      file.cancel();
    };
  }, [canvasContent, fetchMetadata]);
  useEffect35(() => {
    fetchMetadata();
  }, [fetchMetadata]);
  return /* @__PURE__ */ jsxs40(Fragment16, {
    children: [
      /* @__PURE__ */ jsxs40("div", {
        ref: canvasRef,
        style: container20,
        children: [
          size2 ? /* @__PURE__ */ jsx89(VideoPreview, {
            canvasContent,
            contentDimensions,
            canvasSize: size2,
            assetMetadata: assetResolution
          }) : null,
          isFit ? null : /* @__PURE__ */ jsx89("div", {
            style: resetZoom,
            className: "css-reset",
            children: /* @__PURE__ */ jsx89(ResetZoomButton, {
              onClick: onReset
            })
          }),
          editorShowGuides && canvasContent.type === "composition" && /* @__PURE__ */ jsx89(EditorGuides_default, {
            canvasSize: size2,
            contentDimensions,
            assetMetadata: assetResolution
          })
        ]
      }),
      areRulersVisible && /* @__PURE__ */ jsx89(EditorRulers, {
        contentDimensions,
        canvasSize: size2,
        assetMetadata: assetResolution,
        containerRef: canvasRef
      })
    ]
  });
};

// src/components/FramePersistor.tsx
import { useEffect as useEffect36 } from "react";
import { Internals as Internals25, useVideoConfig as useVideoConfig2 } from "remotion";
var FramePersistor = () => {
  const [playing] = Internals25.Timeline.usePlayingState();
  const config = useVideoConfig2();
  const frame2 = Internals25.Timeline.useTimelinePosition();
  const setFrame = Internals25.useTimelineSetFrame();
  useEffect36(() => {
    if (!playing) {
      setFrame((f) => {
        const newObj = { ...f, [config.id]: frame2 };
        Internals25.persistCurrentFrame(newObj);
        return newObj;
      });
    }
  }, [config.id, frame2, playing, setFrame]);
  return null;
};

// src/components/RefreshCompositionOverlay.tsx
import { AbsoluteFill as AbsoluteFill2 } from "remotion";

// src/components/RunningCalculateMetadata.tsx
import { jsx as jsx90, jsxs as jsxs41 } from "react/jsx-runtime";
var loaderLabel = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var container21 = {
  backgroundColor: BACKGROUND,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  padding: 20
};
var RunningCalculateMetadata = () => {
  return /* @__PURE__ */ jsxs41("div", {
    style: container21,
    children: [
      /* @__PURE__ */ jsx90(Spinner, {
        size: 24,
        duration: 1
      }),
      /* @__PURE__ */ jsx90(Spacing, {
        x: 2
      }),
      /* @__PURE__ */ jsxs41("div", {
        style: loaderLabel,
        children: [
          "Running ",
          /* @__PURE__ */ jsx90("code", {
            style: inlineCodeSnippet,
            children: "calculateMetadata()"
          }),
          "..."
        ]
      })
    ]
  });
};

// src/components/RefreshCompositionOverlay.tsx
import { jsx as jsx91 } from "react/jsx-runtime";
var container22 = {
  justifyContent: "flex-end",
  alignItems: "flex-start",
  padding: 20,
  pointerEvents: "none"
};
var shadow = {
  boxShadow: "0 0 4px black"
};
var RefreshCompositionOverlay = () => {
  return /* @__PURE__ */ jsx91(AbsoluteFill2, {
    style: container22,
    children: /* @__PURE__ */ jsx91("div", {
      style: shadow,
      children: /* @__PURE__ */ jsx91(RunningCalculateMetadata, {})
    })
  });
};

// src/components/CanvasOrLoading.tsx
import { jsx as jsx92, jsxs as jsxs42, Fragment as Fragment17 } from "react/jsx-runtime";
var container23 = {
  color: "white",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  backgroundColor: BACKGROUND,
  flexDirection: "column"
};
var CanvasOrLoading = ({ size: size2 }) => {
  const resolved = Internals26.useResolvedVideoConfig(null);
  const { setZoom } = useContext31(TimelineZoomCtx);
  const { canvasContent } = useContext31(Internals26.CompositionManager);
  useEffect37(() => {
    if (resolved?.type !== "success" && resolved?.type !== "success-and-refreshing") {
      return;
    }
    const c = resolved.result;
    setTimeout(() => {
      ensureFrameIsInViewport({
        direction: "center",
        frame: getCurrentFrame(),
        durationInFrames: c.durationInFrames
      });
    });
  }, [resolved, setZoom]);
  if (!canvasContent) {
    const compname = window.location.pathname.replace("/", "");
    return /* @__PURE__ */ jsx92("div", {
      style: container23,
      className: "css-reset",
      children: /* @__PURE__ */ jsxs42("div", {
        style: loaderLabel,
        children: [
          "Composition with ID ",
          compname,
          " not found."
        ]
      })
    });
  }
  const content = /* @__PURE__ */ jsxs42(Fragment17, {
    children: [
      /* @__PURE__ */ jsx92(ZoomPersistor, {}),
      /* @__PURE__ */ jsx92(Canvas, {
        size: size2,
        canvasContent
      }),
      resolved?.type === "success-and-refreshing" ? /* @__PURE__ */ jsx92(RefreshCompositionOverlay, {}) : null
    ]
  });
  if (canvasContent.type === "asset" || canvasContent.type === "output" || canvasContent.type === "output-blob") {
    return content;
  }
  if (!resolved) {
    return null;
  }
  if (resolved.type === "loading") {
    return /* @__PURE__ */ jsx92("div", {
      style: container23,
      className: "css-reset",
      children: /* @__PURE__ */ jsx92(RunningCalculateMetadata, {})
    });
  }
  if (resolved.type === "error") {
    return /* @__PURE__ */ jsx92(ErrorLoading, {
      error: resolved.error
    });
  }
  return /* @__PURE__ */ jsxs42(Fragment17, {
    children: [
      /* @__PURE__ */ jsx92(FramePersistor, {}),
      " ",
      content
    ]
  });
};
var loaderContainer = {
  marginLeft: "auto",
  marginRight: "auto",
  width: "100%",
  position: "absolute",
  height: "100%",
  overflowY: "auto"
};
var ErrorLoading = ({ error }) => {
  return /* @__PURE__ */ jsx92("div", {
    style: loaderContainer,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx92(ErrorLoader, {
      canHaveDismissButton: false,
      keyboardShortcuts: false,
      error,
      onRetry: () => Internals26.resolveCompositionsRef.current?.reloadCurrentlySelectedComposition(),
      calculateMetadata: true
    }, error.stack)
  });
};

// src/components/CanvasIfSizeIsAvailable.tsx
import { jsx as jsx93 } from "react/jsx-runtime";
var CanvasIfSizeIsAvailable = () => {
  const rulersAreVisible = useIsRulerVisible();
  const context = useContext32(Internals27.CurrentScaleContext);
  const sizeWithRulersApplied = useMemo52(() => {
    const size2 = context && context.type === "canvas-size" ? context.canvasSize : null;
    if (!rulersAreVisible) {
      return size2;
    }
    if (!size2) {
      return null;
    }
    return {
      ...size2,
      width: size2.width - RULER_WIDTH,
      height: size2.height - RULER_WIDTH
    };
  }, [context, rulersAreVisible]);
  if (!sizeWithRulersApplied) {
    return null;
  }
  return /* @__PURE__ */ jsx93(CanvasOrLoading, {
    size: sizeWithRulersApplied
  });
};

// src/components/CurrentCompositionSideEffects.tsx
import { useCallback as useCallback41, useContext as useContext33, useEffect as useEffect38 } from "react";
import { Internals as Internals28 } from "remotion";

// src/helpers/document-title.ts
import { NoReactInternals as NoReactInternals7 } from "remotion/no-react";
var currentItemName = null;
var unsavedProps = false;
var tabInactive = false;
var renderJobs = [];
var setCurrentCanvasContentId = (id) => {
  if (!id) {
    currentItemName = id;
    updateTitle();
    return;
  }
  const idWithoutFolder = id.split("/").pop();
  currentItemName = idWithoutFolder;
  updateTitle();
};
var setUnsavedProps = (unsaved) => {
  window.remotion_unsavedProps = unsaved;
  unsavedProps = unsaved;
};
var setRenderJobs = (jobs) => {
  renderJobs = jobs;
  updateTitle();
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});
var productName = "Remotion Studio";
var suffix = `- ${productName}`;
var updateTitle = () => {
  if (!currentItemName) {
    document.title = productName;
    return;
  }
  const currentCompTitle = `${currentItemName} / ${window.remotion_projectName}`;
  document.title = [
    getProgressInBrackets(currentItemName, renderJobs),
    unsavedProps && tabInactive ? "✏️" : null,
    `${currentCompTitle} ${suffix}`
  ].filter(NoReactInternals7.truthy).join(" ");
};
var getProgressInBrackets = (selectedCompositionId, jobs) => {
  const currentRender = jobs.find((job) => job.status === "running");
  if (!currentRender) {
    return null;
  }
  if (currentRender.status !== "running") {
    throw new Error("expected running job");
  }
  let progInPercent;
  if (isClientRenderJob(currentRender)) {
    const { encodedFrames, totalFrames } = currentRender.progress;
    progInPercent = totalFrames > 0 ? Math.ceil(encodedFrames / totalFrames * 100) : 0;
  } else {
    progInPercent = Math.ceil(currentRender.progress.value * 100);
  }
  const progressInBrackets = currentRender.compositionId === selectedCompositionId ? `[${progInPercent}%]` : `[${progInPercent}% ${currentRender.compositionId}]`;
  return progressInBrackets;
};
document.addEventListener("visibilitychange", () => {
  tabInactive = document.visibilityState === "hidden";
  updateTitle();
});

// src/components/CurrentCompositionSideEffects.tsx
var TitleUpdater = () => {
  const renderQueue = useContext33(RenderQueueContext);
  const { canvasContent } = useContext33(Internals28.CompositionManager);
  const { jobs } = renderQueue;
  useEffect38(() => {
    if (!canvasContent) {
      setCurrentCanvasContentId(null);
      return;
    }
    if (canvasContent.type === "composition") {
      setCurrentCanvasContentId(canvasContent.compositionId);
      return;
    }
    if (canvasContent.type === "output") {
      setCurrentCanvasContentId(canvasContent.path);
      return;
    }
    if (canvasContent.type === "output-blob") {
      setCurrentCanvasContentId(canvasContent.displayName);
      return;
    }
    setCurrentCanvasContentId(canvasContent.asset);
  }, [canvasContent]);
  useEffect38(() => {
    setRenderJobs(jobs);
  }, [jobs]);
  return null;
};
var CurrentCompositionKeybindings = ({ readOnlyStudio }) => {
  const keybindings = useKeybinding();
  const video = Internals28.useVideo();
  const { type } = useContext33(StudioServerConnectionCtx).previewServerState;
  const openRenderModal = useCallback41(() => {
    if (!video) {
      return;
    }
    if (type !== "connected" && !SHOW_BROWSER_RENDERING && !readOnlyStudio) {
      showNotification("Studio server is offline", 2000);
      return;
    }
    const renderButton = document.getElementById("render-modal-button");
    renderButton.click();
  }, [readOnlyStudio, type, video]);
  useEffect38(() => {
    const binding = keybindings.registerKeybinding({
      event: "keydown",
      key: "r",
      commandCtrlKey: false,
      callback: openRenderModal,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, openRenderModal]);
  return null;
};

// src/components/MobilePanel.tsx
import ReactDOM6 from "react-dom";
import { jsx as jsx94, jsxs as jsxs43 } from "react/jsx-runtime";
var container24 = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  padding: "0 0px 50px 0px",
  background: BACKGROUND
};
var buttonContainer = {
  height: "40px",
  width: "100%",
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end"
};
var button2 = {
  height: 20,
  width: 20
};
function MobilePanel({
  children,
  onClose
}) {
  const { currentZIndex } = useZIndex();
  return ReactDOM6.createPortal(/* @__PURE__ */ jsxs43("div", {
    style: container24,
    children: [
      /* @__PURE__ */ jsx94("div", {
        style: buttonContainer,
        children: /* @__PURE__ */ jsx94(CancelButton, {
          style: button2,
          onPress: onClose
        })
      }),
      children
    ]
  }), getPortal(currentZIndex));
}

// src/components/OptionsPanel.tsx
import {
  createRef as createRef9,
  useCallback as useCallback83,
  useContext as useContext51,
  useEffect as useEffect54,
  useImperativeHandle as useImperativeHandle12,
  useMemo as useMemo92,
  useState as useState58
} from "react";
import { Internals as Internals37 } from "remotion";

// src/visual-controls/VisualControls.tsx
import {
  createContext as createContext17,
  createRef as createRef8,
  useCallback as useCallback42,
  useEffect as useEffect40,
  useImperativeHandle as useImperativeHandle10,
  useMemo as useMemo54,
  useRef as useRef24,
  useState as useState40
} from "react";
import { useRemotionEnvironment as useRemotionEnvironment2 } from "remotion";

// src/api/get-zod-schema-from-primitive.ts
function getZodSchemaFromPrimitive(value, z) {
  if (typeof value === "string") {
    return z.string();
  }
  if (typeof value === "number") {
    return z.number();
  }
  let stringified;
  try {
    stringified = JSON.stringify(value);
  } catch {}
  throw new Error(`visualControl(): Specify a schema for this value: ${stringified ?? "[non-serializable value]"}. See https://remotion.dev/docs/studio/visual-control`);
}

// src/components/get-zod-if-possible.tsx
import {
  createContext as createContext16,
  useContext as useContext34,
  useEffect as useEffect39,
  useMemo as useMemo53,
  useState as useState39
} from "react";
import { jsx as jsx95 } from "react/jsx-runtime";
async function getZodIfPossible() {
  try {
    const { z } = await import("zod");
    return z;
  } catch {
    return null;
  }
}
var getZodV3IfPossible = async () => {
  try {
    const mod = await import("zod/v3");
    return mod;
  } catch {
    return null;
  }
};
var getZTypesIfPossible = async () => {
  try {
    const mod = await import("@remotion/zod-types");
    return mod;
  } catch {
    return null;
  }
};
function useZodIfPossible() {
  const context = useContext34(ZodContext);
  return context?.zod ?? null;
}
var useZodTypesIfPossible = () => {
  const context = useContext34(ZodContext);
  return context?.zodTypes ?? null;
};
var ZodContext = createContext16(null);
var ZodProvider = ({ children }) => {
  const [zod, setZod] = useState39(null);
  const [zodV3, setZodV3] = useState39(null);
  const [zodTypes, setZodTypes] = useState39(null);
  useEffect39(() => {
    getZodIfPossible().then((z) => setZod(z));
  }, []);
  useEffect39(() => {
    getZodV3IfPossible().then((z) => setZodV3(z));
  }, []);
  useEffect39(() => {
    getZTypesIfPossible().then((z) => setZodTypes(z));
  }, []);
  const contextValue = useMemo53(() => {
    return {
      zod,
      zodV3,
      zodTypes
    };
  }, [zod, zodV3, zodTypes]);
  return /* @__PURE__ */ jsx95(ZodContext.Provider, {
    value: contextValue,
    children
  });
};

// src/visual-controls/get-current-edited-value.ts
var getVisualControlEditedValue = ({
  handles,
  key
}) => {
  return handles?.[key]?.unsavedValue ?? null;
};

// src/visual-controls/VisualControls.tsx
import { jsx as jsx96 } from "react/jsx-runtime";
var VisualControlsTabActivatedContext = createContext17(false);
var VisualControlsContext = createContext17({
  handles: {}
});
var visualControlRef = createRef8();
var SetVisualControlsContext = createContext17({
  updateHandles: () => {
    throw new Error("updateHandles is not implemented");
  },
  updateValue: () => {
    throw new Error("updateValue is not implemented");
  },
  visualControl: () => {
    throw new Error("visualControl is not implemented");
  }
});
var VisualControlsProvider = ({ children }) => {
  const imperativeHandles = useRef24({});
  const [handles, setHandles] = useState40({});
  const state = useMemo54(() => {
    return {
      handles
    };
  }, [handles]);
  const setControl = useCallback42((key, value) => {
    const currentUnsaved = imperativeHandles.current?.[key]?.unsavedValue;
    const currentSavedState = imperativeHandles.current?.[key]?.valueInCode;
    const changedSavedValue = value.valueInCode !== currentSavedState;
    const changedUnsavedValue = currentUnsaved === undefined && value.valueInCode !== undefined;
    imperativeHandles.current = {
      ...imperativeHandles.current,
      [key]: {
        ...value,
        unsavedValue: currentUnsaved ?? value.valueInCode,
        valueInCode: value.valueInCode
      }
    };
    return {
      changed: changedSavedValue || changedUnsavedValue,
      currentValue: getVisualControlEditedValue({
        key,
        handles: imperativeHandles.current
      })
    };
  }, []);
  const z = useZodIfPossible();
  const changedRef = useRef24(false);
  const env = useRemotionEnvironment2();
  const visualControl = useCallback42(function(key, value, schema) {
    if (handles && false) {}
    if (!env.isStudio) {
      return value;
    }
    if (!z) {
      return value;
    }
    const { changed, currentValue } = setControl(key, {
      valueInCode: value,
      schema: schema ?? getZodSchemaFromPrimitive(value, z),
      stack: new Error().stack
    });
    if (changed) {
      changedRef.current = true;
    }
    return currentValue;
  }, [setControl, handles, z, env.isStudio]);
  const updateHandles = useCallback42(() => {
    setHandles(() => {
      return imperativeHandles.current;
    });
  }, []);
  const updateValue = useCallback42((key, value) => {
    imperativeHandles.current = {
      ...imperativeHandles.current,
      [key]: {
        ...imperativeHandles.current[key],
        unsavedValue: value
      }
    };
    updateHandles();
  }, [updateHandles]);
  useImperativeHandle10(visualControlRef, () => {
    return {
      globalVisualControl: visualControl
    };
  }, [visualControl]);
  useEffect40(() => {
    const callback = () => {
      if (imperativeHandles.current) {
        updateHandles();
        changedRef.current = false;
      }
    };
    const interval = setInterval(callback, 100);
    return () => {
      clearInterval(interval);
    };
  }, [updateHandles]);
  const setState = useMemo54(() => {
    return {
      setControl,
      updateHandles,
      updateValue,
      visualControl
    };
  }, [setControl, updateHandles, updateValue, visualControl]);
  return /* @__PURE__ */ jsx96(VisualControlsTabActivatedContext.Provider, {
    value: Object.keys(state.handles).length > 0,
    children: /* @__PURE__ */ jsx96(VisualControlsContext.Provider, {
      value: state,
      children: /* @__PURE__ */ jsx96(SetVisualControlsContext.Provider, {
        value: setState,
        children
      })
    })
  });
};

// src/components/GlobalPropsEditorUpdateButton.tsx
import React65, { useCallback as useCallback45, useContext as useContext35 } from "react";
import { Internals as Internals30 } from "remotion";

// src/api/save-default-props.ts
import { getRemotionEnvironment as getRemotionEnvironment4 } from "remotion";

// src/components/RenderModal/SchemaEditor/zod-schema-type.ts
var zodSafeParse = (schema, data) => {
  return schema.safeParse(data);
};
var getZodDef = (schema) => {
  if (schema._def)
    return schema._def;
  if (schema._zod)
    return schema._zod.def;
  throw new Error("Invalid zod schema: missing _def and _zod");
};
var v3TypeNameMap = {
  ZodString: "string",
  ZodNumber: "number",
  ZodBoolean: "boolean",
  ZodObject: "object",
  ZodArray: "array",
  ZodEnum: "enum",
  ZodUnion: "union",
  ZodDiscriminatedUnion: "discriminatedUnion",
  ZodOptional: "optional",
  ZodNullable: "nullable",
  ZodDefault: "default",
  ZodTuple: "tuple",
  ZodDate: "date",
  ZodAny: "any",
  ZodUnknown: "unknown",
  ZodBigInt: "bigint",
  ZodNull: "null",
  ZodUndefined: "undefined",
  ZodEffects: "effects",
  ZodLiteral: "literal",
  ZodRecord: "record",
  ZodNever: "never",
  ZodVoid: "void",
  ZodNaN: "nan",
  ZodSymbol: "symbol",
  ZodIntersection: "intersection",
  ZodMap: "map",
  ZodSet: "set",
  ZodLazy: "lazy",
  ZodFunction: "function",
  ZodNativeEnum: "nativeEnum",
  ZodCatch: "catch",
  ZodPromise: "promise",
  ZodBranded: "branded",
  ZodPipeline: "pipeline"
};
var isZodV3Schema = (schema) => {
  const def = getZodDef(schema);
  return "typeName" in def;
};
var getZodSchemaType = (schema) => {
  const def = getZodDef(schema);
  if ("typeName" in def) {
    const { typeName } = def;
    return v3TypeNameMap[typeName] ?? typeName;
  }
  const { type } = def;
  if (type === "union" && def.discriminator !== undefined) {
    return "discriminatedUnion";
  }
  return type;
};
var getZodSchemaDescription = (schema) => {
  if (isZodV3Schema(schema)) {
    return getZodDef(schema).description;
  }
  return schema.description;
};
var getObjectShape = (schema) => {
  const { shape } = getZodDef(schema);
  return typeof shape === "function" ? shape() : shape;
};
var getArrayElement = (schema) => {
  const def = getZodDef(schema);
  return isZodV3Schema(schema) ? def.type : def.element;
};
var getInnerType = (schema) => {
  return getZodDef(schema).innerType;
};
var getEffectsInner = (schema) => {
  return getZodDef(schema).schema;
};
var getLiteralValue = (schema) => {
  const def = getZodDef(schema);
  if (isZodV3Schema(schema)) {
    return def.value;
  }
  return def.values?.[0];
};
var getEnumValues = (schema) => {
  const def = getZodDef(schema);
  if (isZodV3Schema(schema)) {
    return def.values;
  }
  const { entries } = def;
  return Object.values(entries);
};
var getFirstEnumValue = (schema) => {
  const def = getZodDef(schema);
  if (isZodV3Schema(schema)) {
    if (def.typeName === "ZodNativeEnum") {
      const vals = Object.values(def.values);
      return vals[0];
    }
    return def.values[0];
  }
  const { entries } = def;
  const pairs = Object.entries(entries);
  const hasReverseMapping = pairs.some(([key, value]) => key !== String(value));
  if (hasReverseMapping) {
    const forwardPairs = pairs.filter(([key]) => Number.isNaN(Number(key)));
    if (forwardPairs.length > 0) {
      return forwardPairs[0][1];
    }
  }
  return Object.values(entries)[0];
};
var getUnionOptions = (schema) => {
  return getZodDef(schema).options;
};
var getDefaultValue = (schema) => {
  const dv = getZodDef(schema).defaultValue;
  return typeof dv === "function" ? dv() : dv;
};
var getDiscriminator = (schema) => {
  return getZodDef(schema).discriminator;
};
var getDiscriminatedOptionKeys = (schema) => {
  const def = getZodDef(schema);
  const discriminator = getDiscriminator(schema);
  if (isZodV3Schema(schema) && def.optionsMap) {
    return [...def.optionsMap.keys()];
  }
  const options = getUnionOptions(schema);
  return options.map((option) => {
    const shape = getObjectShape(option);
    const discriminatorSchema = shape[discriminator];
    return getLiteralValue(discriminatorSchema);
  });
};
var getDiscriminatedOption = (schema, discriminatorValue) => {
  const def = getZodDef(schema);
  const discriminator = getDiscriminator(schema);
  if (isZodV3Schema(schema) && def.optionsMap) {
    return def.optionsMap.get(discriminatorValue);
  }
  const options = getUnionOptions(schema);
  return options.find((option) => {
    const shape = getObjectShape(option);
    const discriminatorSchema = shape[discriminator];
    return getLiteralValue(discriminatorSchema) === discriminatorValue;
  });
};
var getIntersectionSchemas = (schema) => {
  const def = getZodDef(schema);
  return { left: def.left, right: def.right };
};
var getTupleItems = (schema) => {
  return getZodDef(schema).items;
};
var getRecordValueType = (schema) => {
  return getZodDef(schema).valueType;
};
var getRecordKeyType = (schema) => {
  return getZodDef(schema).keyType;
};
var getPipelineOutput = (schema) => {
  return getZodDef(schema).out;
};
var getPipelineInput = (schema) => {
  return getZodDef(schema).in;
};
var getBrandedInner = (schema) => {
  return isZodV3Schema(schema) ? getZodDef(schema).type : schema;
};

// src/components/RenderModal/SchemaEditor/extract-enum-json-paths.ts
var extractEnumJsonPaths = ({
  schema,
  zodRuntime,
  currentPath,
  zodTypes
}) => {
  const description = getZodSchemaDescription(schema);
  if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
    return [currentPath];
  }
  const typeName = getZodSchemaType(schema);
  switch (typeName) {
    case "object": {
      const shape = getObjectShape(schema);
      const keys = Object.keys(shape);
      return keys.map((key) => {
        return extractEnumJsonPaths({
          schema: shape[key],
          zodRuntime,
          currentPath: [...currentPath, key],
          zodTypes
        });
      }).flat(1);
    }
    case "array": {
      return extractEnumJsonPaths({
        schema: getArrayElement(schema),
        zodRuntime,
        currentPath: [...currentPath, "[]"],
        zodTypes
      });
    }
    case "union": {
      return getUnionOptions(schema).map((option) => {
        return extractEnumJsonPaths({
          schema: option,
          zodRuntime,
          currentPath,
          zodTypes
        });
      }).flat(1);
    }
    case "discriminatedUnion": {
      return getUnionOptions(schema).map((op) => {
        return extractEnumJsonPaths({
          schema: op,
          zodRuntime,
          currentPath,
          zodTypes
        });
      }).flat(1);
    }
    case "literal": {
      return [currentPath];
    }
    case "effects": {
      return extractEnumJsonPaths({
        schema: getEffectsInner(schema),
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case "intersection": {
      const { left: left3, right } = getIntersectionSchemas(schema);
      const leftValue = extractEnumJsonPaths({
        schema: left3,
        zodRuntime,
        currentPath,
        zodTypes
      });
      const rightValue = extractEnumJsonPaths({
        schema: right,
        zodRuntime,
        currentPath,
        zodTypes
      });
      return [...leftValue, ...rightValue];
    }
    case "tuple": {
      return getTupleItems(schema).map((item, i) => extractEnumJsonPaths({
        schema: item,
        zodRuntime,
        currentPath: [...currentPath, i],
        zodTypes
      })).flat(1);
    }
    case "record": {
      const recordPath = [...currentPath, "{}"];
      const keyResults = extractEnumJsonPaths({
        schema: getRecordKeyType(schema),
        zodRuntime,
        currentPath: recordPath,
        zodTypes
      });
      const valueResults = extractEnumJsonPaths({
        schema: getRecordValueType(schema),
        zodRuntime,
        currentPath: recordPath,
        zodTypes
      });
      return [...keyResults, ...valueResults];
    }
    case "function": {
      throw new Error("Cannot create a value for type function");
    }
    case "enum": {
      return [currentPath];
    }
    case "nativeEnum": {
      return [];
    }
    case "optional":
    case "nullable":
    case "catch": {
      return extractEnumJsonPaths({
        schema: getInnerType(schema),
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case "default": {
      return extractEnumJsonPaths({
        schema: getInnerType(schema),
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case "promise": {
      return [];
    }
    case "branded": {
      return extractEnumJsonPaths({
        schema: getBrandedInner(schema),
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case "pipeline":
    case "pipe": {
      return extractEnumJsonPaths({
        schema: getPipelineOutput(schema),
        zodRuntime,
        currentPath,
        zodTypes
      });
    }
    case "string":
    case "number":
    case "bigint":
    case "boolean":
    case "nan":
    case "date":
    case "symbol":
    case "undefined":
    case "null":
    case "any":
    case "unknown":
    case "never":
    case "void":
    case "map":
    case "lazy":
    case "set":
    case "custom": {
      return [];
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/api/helpers/calc-new-props.ts
import { Internals as Internals29, getRemotionEnvironment as getRemotionEnvironment3 } from "remotion";
var calcNewProps = (compositionId, defaultProps) => {
  if (!getRemotionEnvironment3().isStudio) {
    throw new Error("saveDefaultProps can only be called in the Remotion Studio.");
  }
  const { compositionsRef, editorPropsProviderRef } = Internals29;
  const compositionsStore = compositionsRef.current;
  if (!compositionsStore) {
    throw new Error("No compositions ref found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const compositions = compositionsStore.getCompositions();
  const composition = compositions.find((c) => c.id === compositionId);
  if (!composition) {
    throw new Error(`No composition with the ID ${compositionId} found. Available compositions: ${compositions.map((c) => c.id).join(", ")}`);
  }
  const propsStore = editorPropsProviderRef.current;
  if (!propsStore) {
    throw new Error("No props store found. Are you in the Remotion Studio and are the Remotion versions aligned?");
  }
  const savedDefaultProps = composition.defaultProps ?? {};
  const unsavedDefaultProps = propsStore.getProps()[compositionId] ?? savedDefaultProps;
  const generatedDefaultProps = defaultProps({
    schema: composition.schema,
    savedDefaultProps,
    unsavedDefaultProps
  });
  return {
    composition,
    generatedDefaultProps
  };
};

// src/api/save-default-props.ts
var saveDefaultProps = async ({
  compositionId,
  defaultProps
}) => {
  if (!getRemotionEnvironment4().isStudio) {
    throw new Error("saveDefaultProps() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("saveDefaultProps() is not available in read-only Studio");
  }
  try {
    await import("zod");
  } catch {
    throw new Error('"zod" is required to use saveDefaultProps(), but is not installed.');
  }
  const z = await import("zod");
  let zodTypes = null;
  try {
    zodTypes = await import("@remotion/zod-types");
  } catch {}
  const { generatedDefaultProps, composition } = calcNewProps(compositionId, defaultProps);
  const res = await callUpdateDefaultPropsApi(compositionId, generatedDefaultProps, composition.schema ? extractEnumJsonPaths({
    schema: composition.schema,
    zodRuntime: z,
    currentPath: [],
    zodTypes
  }) : []);
  if (res.success) {
    return Promise.resolve();
  }
  const err = new Error(res.reason);
  err.stack = res.stack;
  return Promise.reject(err);
};

// src/fast-refresh-context.ts
import { createContext as createContext18 } from "react";
var FastRefreshContext = createContext18({
  fastRefreshes: 0,
  manualRefreshes: 0,
  increaseManualRefreshes: () => {}
});

// src/components/RenderModal/SchemaEditor/SchemaResetButton.tsx
import { useCallback as useCallback43 } from "react";
import { jsx as jsx97 } from "react/jsx-runtime";
var icon2 = {
  height: 14,
  color: "currentColor"
};
var SchemaResetButton = ({ onClick }) => {
  const renderAction = useCallback43((color) => {
    return /* @__PURE__ */ jsx97("svg", {
      style: icon2,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx97("path", {
        fill: color,
        d: "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
      })
    });
  }, []);
  return /* @__PURE__ */ jsx97(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSaveButton.tsx
import { useCallback as useCallback44 } from "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var icon3 = {
  height: 14,
  color: "currentColor"
};
var SchemaSaveButton = ({ onClick, disabled }) => {
  const renderAction = useCallback44((color) => {
    return /* @__PURE__ */ jsx98("svg", {
      style: icon3,
      viewBox: "0 0 448 512",
      children: /* @__PURE__ */ jsx98("path", {
        fill: disabled ? LIGHT_TEXT : color,
        d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
      })
    });
  }, [disabled]);
  return /* @__PURE__ */ jsx98(InlineAction, {
    renderAction,
    onClick,
    disabled
  });
};

// src/components/GlobalPropsEditorUpdateButton.tsx
import { jsx as jsx99, jsxs as jsxs44 } from "react/jsx-runtime";
var container25 = {
  display: "inline-block",
  flexDirection: "row"
};
var GlobalPropsEditorUpdateButton = ({ compositionId, currentDefaultProps }) => {
  const { fastRefreshes } = useContext35(FastRefreshContext);
  const [disabled, setDisabled] = React65.useState(false);
  const onClicked = useCallback45(() => {
    setDisabled(true);
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    saveDefaultProps({
      compositionId,
      defaultProps: () => currentDefaultProps
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.stack}`, 2000);
    }).finally(() => {
      setDisabled(true);
    });
  }, [compositionId, currentDefaultProps, fastRefreshes]);
  const onReset = useCallback45(() => {
    window.remotion_ignoreFastRefreshUpdate = null;
    window.dispatchEvent(new CustomEvent(Internals30.PROPS_UPDATED_EXTERNALLY, {
      detail: {
        resetUnsaved: compositionId
      }
    }));
  }, [compositionId]);
  return /* @__PURE__ */ jsxs44("div", {
    style: container25,
    children: [
      /* @__PURE__ */ jsx99(SchemaResetButton, {
        onClick: onReset
      }),
      /* @__PURE__ */ jsx99(SchemaSaveButton, {
        disabled,
        onClick: onClicked
      })
    ]
  });
};

// src/components/RenderModal/DataEditor.tsx
import React96, {
  useCallback as useCallback69,
  useContext as useContext38,
  useEffect as useEffect48,
  useMemo as useMemo81,
  useState as useState53
} from "react";
import { getInputProps, Internals as Internals33 } from "remotion";
import { NoReactInternals as NoReactInternals10 } from "remotion/no-react";

// src/components/NewComposition/ValidationMessage.tsx
import { useMemo as useMemo55 } from "react";
import { jsx as jsx100, jsxs as jsxs45 } from "react/jsx-runtime";
var WarningTriangle = (props) => {
  return /* @__PURE__ */ jsx100("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx100("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var style6 = {
  width: 12,
  height: 12,
  flexShrink: 0
};
var container26 = {
  maxWidth: 500
};
var label4 = {
  fontSize: 13,
  color: "white",
  fontFamily: "sans-serif"
};
var ValidationMessage = ({ message, align, type }) => {
  const finalStyle = useMemo55(() => {
    return {
      ...style6,
      fill: type === "warning" ? WARNING_COLOR : FAIL_COLOR
    };
  }, [type]);
  return /* @__PURE__ */ jsx100("div", {
    style: container26,
    children: /* @__PURE__ */ jsxs45(Row, {
      align: "center",
      justify: align,
      children: [
        /* @__PURE__ */ jsx100(WarningTriangle, {
          style: finalStyle
        }),
        /* @__PURE__ */ jsx100(Spacing, {
          x: 1
        }),
        /* @__PURE__ */ jsx100("div", {
          style: label4,
          children: message
        })
      ]
    })
  });
};

// src/components/SegmentedControl.tsx
import { useCallback as useCallback46, useMemo as useMemo56, useState as useState41 } from "react";
import { jsx as jsx101 } from "react/jsx-runtime";
var container27 = {
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  flexWrap: "wrap",
  maxWidth: 350,
  justifyContent: "flex-end"
};
var item = {
  display: "flex",
  fontSize: 15,
  padding: "4px 12px",
  cursor: "pointer",
  appearance: "none",
  border: "none",
  flex: 1,
  justifyContent: "center",
  whiteSpace: "nowrap"
};
var SegmentedControl = ({ items, needsWrapping }) => {
  const controlStyle = useMemo56(() => {
    if (needsWrapping) {
      return {
        ...container27,
        flexWrap: "wrap",
        maxWidth: "248px",
        justifyContent: "flex-end",
        marginBottom: "8px"
      };
    }
    return {
      ...container27
    };
  }, [needsWrapping]);
  return /* @__PURE__ */ jsx101("div", {
    style: controlStyle,
    children: items.map((i) => {
      return /* @__PURE__ */ jsx101(Item, {
        onClick: i.onClick,
        selected: i.selected,
        children: i.label
      }, i.key);
    })
  });
};
var Item = ({ selected, onClick, children }) => {
  const [hovered, setHovered] = useState41(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback46(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback46(() => {
    setHovered(false);
  }, []);
  const itemStyle3 = useMemo56(() => {
    return {
      ...item,
      backgroundColor: selected ? INPUT_BACKGROUND : "transparent",
      color: selected ? "white" : hovered ? "white" : LIGHT_TEXT
    };
  }, [hovered, selected]);
  return /* @__PURE__ */ jsx101("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: itemStyle3,
    tabIndex,
    onClick,
    children
  });
};

// src/components/RenderModal/get-render-modal-warnings.ts
import { NoReactInternals as NoReactInternals8 } from "remotion/no-react";
var defaultTypeCanSaveState = {
  canUpdate: false,
  reason: "Loading...",
  determined: false
};
var getInputPropsWarning = ({
  cliProps,
  propsEditType
}) => {
  if (Object.keys(cliProps).length > 0 && propsEditType === "default-props") {
    return "The data that was passed using --props takes priority over the data you enter here.";
  }
  return null;
};
var getCannotSaveDefaultProps = (canSaveDefaultProps) => {
  if (canSaveDefaultProps.canUpdate) {
    return null;
  }
  if (!canSaveDefaultProps.determined) {
    return null;
  }
  return `Can't save default props: ${canSaveDefaultProps.reason}.`;
};
var customDateUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a Date in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var staticFileUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "There is a staticFile() in the schema which was serialized. Note the custom syntax.";
  }
  return null;
};
var mapUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Map` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var setUsed = (used, inJSONEditor) => {
  if (used && inJSONEditor) {
    return "A `Set` was used in the schema which can not be serialized to JSON.";
  }
  return null;
};
var getRenderModalWarnings = ({
  cliProps,
  canSaveDefaultProps,
  isCustomDateUsed,
  customFileUsed,
  jsMapUsed,
  jsSetUsed,
  inJSONEditor,
  propsEditType
}) => {
  return [
    getInputPropsWarning({ cliProps, propsEditType }),
    getCannotSaveDefaultProps(canSaveDefaultProps),
    customDateUsed(isCustomDateUsed, inJSONEditor),
    staticFileUsed(customFileUsed, inJSONEditor),
    mapUsed(jsMapUsed, inJSONEditor),
    setUsed(jsSetUsed, inJSONEditor)
  ].filter(NoReactInternals8.truthy);
};

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import React69, { useCallback as useCallback47, useEffect as useEffect41, useMemo as useMemo58 } from "react";
import { NoReactInternals as NoReactInternals9 } from "remotion/no-react";

// src/components/RenderModal/SchemaEditor/deep-equal.ts
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) {
    return false;
  }
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) {
      return false;
    }
  }
  return true;
}

// src/components/RenderModal/SchemaEditor/ZodErrorMessages.tsx
import { useMemo as useMemo57 } from "react";
import { jsx as jsx102, jsxs as jsxs46 } from "react/jsx-runtime";
var schemaLabel = {
  fontSize: 14,
  color: LIGHT_TEXT
};
var jsonLabel = {
  color: "white",
  fontSize: 13,
  fontFamily: "sans-serif",
  display: "flex",
  alignItems: "center"
};
var triangleStyle = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: FAIL_COLOR
};
var ZodErrorMessages = ({ zodValidationResult, viewTab }) => {
  if (zodValidationResult.success) {
    throw new Error("Expected error");
  }
  const style7 = useMemo57(() => {
    return viewTab === "json" ? jsonLabel : schemaLabel;
  }, [viewTab]);
  const code = useMemo57(() => {
    return {
      ...schemaLabel,
      fontFamily: "monospace"
    };
  }, []);
  if (viewTab === "json") {
    return /* @__PURE__ */ jsx102("div", {
      children: zodValidationResult.error.issues.map((error) => {
        return /* @__PURE__ */ jsxs46("div", {
          style: style7,
          children: [
            /* @__PURE__ */ jsx102(WarningTriangle, {
              style: triangleStyle
            }),
            /* @__PURE__ */ jsx102(Spacing, {
              x: 1
            }),
            error.path.length === 0 ? "Root" : error.path.join("."),
            ":",
            " ",
            error.message
          ]
        }, error.path.join("."));
      })
    });
  }
  return /* @__PURE__ */ jsx102("div", {
    children: zodValidationResult.error.issues.map((error) => {
      return /* @__PURE__ */ jsxs46("div", {
        style: style7,
        children: [
          "-",
          " ",
          /* @__PURE__ */ jsx102("code", {
            style: code,
            children: error.path.length === 0 ? "Root" : error.path.join(".")
          }),
          ": ",
          error.message
        ]
      }, error.path.join("."));
    })
  });
};

// src/components/RenderModal/RenderModalJSONPropsEditor.tsx
import { jsx as jsx103, jsxs as jsxs47 } from "react/jsx-runtime";
var style7 = {
  fontFamily: "monospace",
  flex: 1
};
var scrollable = {
  padding: "8px 12px",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var parseJSON = (str, schema) => {
  try {
    const value = NoReactInternals9.deserializeJSONWithSpecialTypes(str);
    const zodValidation = zodSafeParse(schema, value);
    return { str, value, validJSON: true, zodValidation };
  } catch (e) {
    return { str, validJSON: false, error: e.message };
  }
};
var RenderModalJSONPropsEditor = ({
  setValue,
  value,
  defaultProps,
  onSave,
  showSaveButton,
  serializedJSON,
  schema
}) => {
  if (serializedJSON === null) {
    throw new Error("expecting serializedJSON to be defined");
  }
  const keybindings = useKeybinding();
  const [localValue, setLocalValue] = React69.useState(() => {
    return parseJSON(serializedJSON.serializedString, schema);
  });
  const onPretty = useCallback47(() => {
    if (!localValue.validJSON) {
      return;
    }
    const parsed = JSON.parse(localValue.str);
    setLocalValue({ ...localValue, str: JSON.stringify(parsed, null, 2) });
  }, [localValue, setLocalValue]);
  const onChange = useCallback47((e) => {
    const parsed = parseJSON(e.target.value, schema);
    if (parsed.validJSON) {
      const validationResult = zodSafeParse(schema, parsed.value);
      setLocalValue({
        str: e.target.value,
        value: parsed.value,
        validJSON: parsed.validJSON,
        zodValidation: validationResult
      });
      if (validationResult.success) {
        setValue(parsed.value);
      }
    } else {
      setLocalValue({
        str: e.target.value,
        validJSON: parsed.validJSON,
        error: parsed.error
      });
    }
  }, [schema, setValue]);
  const hasChanged = useMemo58(() => {
    return !deepEqual(value, defaultProps);
  }, [defaultProps, value]);
  useEffect41(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback47(() => {
    if (hasChanged) {
      onSave();
    }
  }, [hasChanged, onSave]);
  useEffect41(() => {
    setLocalValue(parseJSON(localValue.str, schema));
  }, [localValue.str, schema]);
  useEffect41(() => {
    const save = keybindings.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      save.unregister();
    };
  }, [keybindings, onQuickSave, onSave]);
  const reset = useCallback47(() => {
    setValue(defaultProps);
    setLocalValue(parseJSON(JSON.stringify(defaultProps, null, 2), schema));
  }, [defaultProps, schema, setValue]);
  const textAreaStyle = useMemo58(() => {
    const fail = !localValue.validJSON || !localValue.zodValidation.success;
    if (!fail) {
      return style7;
    }
    return {
      ...style7,
      borderColor: FAIL_COLOR
    };
  }, [localValue]);
  return /* @__PURE__ */ jsxs47("div", {
    style: scrollable,
    children: [
      /* @__PURE__ */ jsx103(RemTextarea, {
        onChange,
        value: localValue.str,
        status: localValue.validJSON ? "ok" : "error",
        style: textAreaStyle
      }),
      /* @__PURE__ */ jsx103(Spacing, {
        y: 1
      }),
      localValue.validJSON === false ? /* @__PURE__ */ jsx103(ValidationMessage, {
        align: "flex-start",
        message: localValue.error,
        type: "error"
      }) : localValue.zodValidation.success === false ? /* @__PURE__ */ jsx103(ZodErrorMessages, {
        zodValidationResult: localValue.zodValidation,
        viewTab: "json"
      }) : null,
      /* @__PURE__ */ jsx103(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsxs47(Row, {
        children: [
          /* @__PURE__ */ jsx103(Button, {
            disabled: !(hasChanged || !localValue.validJSON),
            onClick: reset,
            children: "Reset"
          }),
          /* @__PURE__ */ jsx103(Flex, {}),
          /* @__PURE__ */ jsx103(Button, {
            disabled: !localValue.validJSON,
            onClick: onPretty,
            children: "Format"
          }),
          /* @__PURE__ */ jsx103(Spacing, {
            x: 1
          }),
          showSaveButton ? /* @__PURE__ */ jsx103(Button, {
            onClick: onSave,
            disabled: !(localValue.validJSON && localValue.zodValidation.success) || !localValue.validJSON || !hasChanged,
            children: "Save"
          }) : null
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import { useCallback as useCallback67, useEffect as useEffect47, useMemo as useMemo79, useState as useState52 } from "react";
import { Internals as Internals32 } from "remotion";

// src/components/RenderModal/SchemaEditor/local-state.tsx
import {
  createContext as createContext19,
  useCallback as useCallback48,
  useContext as useContext36,
  useEffect as useEffect42,
  useMemo as useMemo59,
  useRef as useRef25,
  useState as useState42
} from "react";
import { Internals as Internals31 } from "remotion";
import { jsx as jsx104 } from "react/jsx-runtime";
var RevisionContext = createContext19({
  childResetRevision: 0
});
var useLocalState = ({
  unsavedValue,
  schema,
  setValue,
  savedValue
}) => {
  const parentRevision = useContext36(RevisionContext).childResetRevision;
  const [resetRevision, setResetRevision] = useState42(0);
  const [localValueOrNull, setLocalValue] = useState42(() => {
    return {
      [parentRevision]: {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: zodSafeParse(schema, unsavedValue)
      }
    };
  });
  const localUnsavedValue = useMemo59(() => {
    if ((localValueOrNull[parentRevision] ?? null) === null) {
      return {
        value: unsavedValue,
        keyStabilityRevision: 0,
        zodValidation: zodSafeParse(schema, unsavedValue)
      };
    }
    return localValueOrNull[parentRevision];
  }, [localValueOrNull, parentRevision, schema, unsavedValue]);
  useEffect42(() => {
    const checkFile = () => {
      setResetRevision((old) => old + 1);
      setLocalValue({});
    };
    window.addEventListener(Internals31.PROPS_UPDATED_EXTERNALLY, checkFile);
    return () => {
      window.removeEventListener(Internals31.PROPS_UPDATED_EXTERNALLY, checkFile);
    };
  }, []);
  const currentLocalValue = useMemo59(() => {
    return localUnsavedValue ?? {
      value: savedValue,
      keyStabilityRevision: 0,
      zodValidation: zodSafeParse(schema, savedValue)
    };
  }, [localUnsavedValue, savedValue, schema]);
  const stateRef = useRef25(currentLocalValue);
  stateRef.current = currentLocalValue;
  const onChange = useCallback48((updater, forceApply, increment) => {
    const newValue = updater(stateRef.current.value);
    const isSame = deepEqual(newValue, stateRef.current.value);
    if (isSame) {
      return;
    }
    const safeParse = zodSafeParse(schema, newValue);
    if (safeParse.success || forceApply) {
      setValue(updater, forceApply, increment);
    }
    setLocalValue(() => {
      const newState = {
        keyStabilityRevision: currentLocalValue.keyStabilityRevision + (increment ? 1 : 0),
        value: newValue,
        zodValidation: safeParse
      };
      stateRef.current = newState;
      return {
        ...localUnsavedValue,
        [parentRevision]: newState
      };
    });
  }, [
    currentLocalValue.keyStabilityRevision,
    localUnsavedValue,
    parentRevision,
    schema,
    setValue
  ]);
  const contextValue = useMemo59(() => {
    return {
      childResetRevision: resetRevision
    };
  }, [resetRevision]);
  const reset = useCallback48(() => {
    onChange(() => savedValue, true, true);
    setResetRevision((old) => old + 1);
  }, [savedValue, onChange]);
  const RevisionContextProvider = useCallback48(({ children }) => {
    return /* @__PURE__ */ jsx104(RevisionContext.Provider, {
      value: contextValue,
      children
    });
  }, [contextValue]);
  return useMemo59(() => ({
    localValue: currentLocalValue,
    onChange,
    reset,
    RevisionContextProvider
  }), [RevisionContextProvider, currentLocalValue, onChange, reset]);
};

// src/components/RenderModal/SchemaEditor/SchemaErrorMessages.tsx
import { jsx as jsx105, jsxs as jsxs48 } from "react/jsx-runtime";
var explainer = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  background: BACKGROUND
};
var errorExplanation = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var codeSnippet = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};
var errorContainer = {
  padding: "8px 12px",
  overflowY: "auto"
};
var openDocs = () => {
  window.open("https://www.remotion.dev/docs/schemas");
};
var ZodNotInstalled = () => {
  return /* @__PURE__ */ jsxs48("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "Install ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "zod"
          }),
          " as a dependency to interactively control the props of the composition."
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx105(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoSchemaDefined = () => {
  return /* @__PURE__ */ jsxs48("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "Make the props of this composition interactively editable by adding a",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "schema"
          }),
          " prop to the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " component."
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx105(Button, {
        onClick: openDocs,
        children: "Learn how"
      })
    ]
  });
};
var NoDefaultProps = () => {
  return /* @__PURE__ */ jsxs48("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " does not exist."
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by adding a",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop to your composition."
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx105(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};
var InvalidDefaultProps = ({ zodValidationResult }) => {
  return /* @__PURE__ */ jsxs48("div", {
    style: errorContainer,
    children: [
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "The schema can not be edited because the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "<Composition>"
          }),
          " is not valid:"
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx105(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "Fix the schema by changing the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " prop in your composition so it does not give a type error."
        ]
      })
    ]
  });
};
var InvalidSchema = ({ zodValidationResult, reset }) => {
  return /* @__PURE__ */ jsxs48("div", {
    style: errorContainer,
    children: [
      /* @__PURE__ */ jsx105("div", {
        style: errorExplanation,
        children: "The data does not satisfy the schema:"
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx105(ZodErrorMessages, {
        zodValidationResult,
        viewTab: "schema"
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx105("div", {
        style: errorExplanation,
        children: "Fix the schema using the JSON editor."
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "Alternatively, reset the data to the",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: inlineCodeSnippet,
            children: "defaultProps"
          }),
          " that you have defined."
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx105(Button, {
        onClick: reset,
        children: "Reset props"
      })
    ]
  });
};
var TopLevelZodValue = ({ typeReceived }) => {
  return /* @__PURE__ */ jsxs48("div", {
    style: explainer,
    children: [
      /* @__PURE__ */ jsxs48("div", {
        style: errorExplanation,
        children: [
          "The top-level type of the schema must be a pure",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: codeSnippet,
            children: "z.object"
          }),
          ". Instead got a schema of type",
          " ",
          /* @__PURE__ */ jsx105("code", {
            style: codeSnippet,
            children: typeReceived
          })
        ]
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 1
      }),
      /* @__PURE__ */ jsx105("div", {
        style: errorExplanation,
        children: "Fix the schema by changing the top-level Zod type to an object."
      }),
      /* @__PURE__ */ jsx105(Spacing, {
        y: 2,
        block: true
      }),
      /* @__PURE__ */ jsx105(Button, {
        onClick: openDocs,
        children: "Learn more"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/scroll-to-default-props-path.ts
import React71 from "react";
var DEFAULT_PROPS_PATH_CLASSNAME = "__remotion-default-props-editor-label";
var DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME = "__remotion-default-props-editor-label-active";
var defaultPropsEditorScrollableAreaRef = React71.createRef();

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import React93, { useMemo as useMemo78, useState as useState51 } from "react";

// src/components/RenderModal/layout.ts
var optionRow = {
  display: "flex",
  flexDirection: "row",
  minHeight: 40,
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 8,
  paddingBottom: 8
};
var label5 = {
  width: 290,
  fontSize: 15,
  lineHeight: "40px",
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var rightRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignSelf: "center",
  flex: 1
};
var input = {
  minWidth: 250
};
var fieldSetText = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "monospace"
};
var fieldsetLabel = {
  ...fieldSetText,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%"
};

// src/components/RenderModal/SchemaEditor/Fieldset.tsx
import { createContext as createContext20, useContext as useContext37, useMemo as useMemo60 } from "react";
import { jsx as jsx106 } from "react/jsx-runtime";
var SCHEMA_EDITOR_FIELDSET_PADDING = 10;
var AlreadyPaddedRightContext = createContext20(false);
var Fieldset = ({ children, shouldPad }) => {
  const alreadyPadded = useContext37(AlreadyPaddedRightContext);
  const style8 = useMemo60(() => {
    if (shouldPad) {
      return {
        padding: SCHEMA_EDITOR_FIELDSET_PADDING,
        paddingTop: SCHEMA_EDITOR_FIELDSET_PADDING / 2,
        paddingRight: alreadyPadded ? 0 : SCHEMA_EDITOR_FIELDSET_PADDING
      };
    }
    return {};
  }, [alreadyPadded, shouldPad]);
  const content = /* @__PURE__ */ jsx106("div", {
    style: style8,
    children
  });
  if (shouldPad) {
    return /* @__PURE__ */ jsx106(AlreadyPaddedRightContext.Provider, {
      value: true,
      children: content
    });
  }
  return content;
};

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import { useCallback as useCallback50, useMemo as useMemo61, useState as useState43 } from "react";

// src/components/RenderModal/InlineRemoveButton.tsx
import { useCallback as useCallback49 } from "react";
import { jsx as jsx107 } from "react/jsx-runtime";
var clearIcon = {
  height: 14,
  color: "currentColor"
};
var InlineRemoveButton = ({ onClick }) => {
  const renderAction = useCallback49((color) => {
    return /* @__PURE__ */ jsx107("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      style: clearIcon,
      children: /* @__PURE__ */ jsx107("path", {
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z",
        fill: color
      })
    });
  }, []);
  return /* @__PURE__ */ jsx107(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/SchemaEditor/get-schema-label.ts
var getSchemaLabel = (jsonPath) => {
  const lastKey = jsonPath[jsonPath.length - 1];
  if (typeof lastKey === "number") {
    const secondLastKey = jsonPath[jsonPath.length - 2];
    if (typeof secondLastKey === "undefined") {
      return `[${lastKey}]:`;
    }
    return `${lastKey}:`;
  }
  return `${lastKey}:`;
};

// src/components/RenderModal/SchemaEditor/SchemaLabel.tsx
import { jsx as jsx108, jsxs as jsxs49 } from "react/jsx-runtime";
var compactStyles = {
  fontSize: 15,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1
};
var SchemaLabel = ({
  jsonPath,
  isDefaultValue,
  onReset,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  valid,
  saveDisabledByParent,
  suffix: suffix2,
  handleClick
}) => {
  const [clickableButtonHovered, setClickableButtonHovered] = useState43(false);
  const disableSave = saving || !valid || saveDisabledByParent;
  const labelStyle4 = useMemo61(() => {
    return {
      fontFamily: "monospace",
      fontSize: 14,
      color: valid ? clickableButtonHovered ? "white" : LIGHT_TEXT : FAIL_COLOR,
      lineHeight: "24px"
    };
  }, [clickableButtonHovered, valid]);
  const onClickablePointerEnter = useCallback50(() => {
    setClickableButtonHovered(true);
  }, []);
  const onClickablePointerLeave = useCallback50(() => {
    setClickableButtonHovered(false);
  }, []);
  const labelContent = /* @__PURE__ */ jsxs49("span", {
    style: labelStyle4,
    children: [
      getSchemaLabel(jsonPath),
      " ",
      suffix2 ? suffix2 : null
    ]
  });
  return /* @__PURE__ */ jsxs49("div", {
    style: compactStyles,
    className: DEFAULT_PROPS_PATH_CLASSNAME,
    "data-json-path": jsonPath.join("."),
    children: [
      handleClick ? /* @__PURE__ */ jsx108("button", {
        onPointerEnter: onClickablePointerEnter,
        onPointerLeave: onClickablePointerLeave,
        type: "button",
        onClick: handleClick,
        style: { border: "none", padding: 0 },
        children: labelContent
      }) : labelContent,
      /* @__PURE__ */ jsx108(Flex, {}),
      isDefaultValue ? null : /* @__PURE__ */ jsx108(SchemaResetButton, {
        onClick: onReset
      }),
      isDefaultValue ? null : showSaveButton ? /* @__PURE__ */ jsx108(SchemaSaveButton, {
        onClick: onSave,
        disabled: disableSave
      }) : null,
      onRemove ? /* @__PURE__ */ jsx108(InlineRemoveButton, {
        onClick: onRemove
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import { useCallback as useCallback51, useMemo as useMemo62, useState as useState44 } from "react";

// src/icons/plus.tsx
import { jsx as jsx109 } from "react/jsx-runtime";
var Plus = ({ color, ...props }) => {
  return /* @__PURE__ */ jsx109("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx109("path", {
      fill: color,
      d: "M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"
    })
  });
};

// src/components/RenderModal/SchemaEditor/create-zod-values.ts
var createZodValues = (schema, zodRuntime, zodTypes) => {
  if (!schema) {
    throw new Error("Invalid zod schema");
  }
  const description = getZodSchemaDescription(schema);
  if (zodTypes) {
    if (description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
      return "#ffffff";
    }
    if (description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
      return "";
    }
    if (description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
      return [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1]
      ];
    }
  }
  const typeName = getZodSchemaType(schema);
  switch (typeName) {
    case "string":
      return "";
    case "number": {
      const { checks } = getZodDef(schema);
      if (checks) {
        if (isZodV3Schema(schema)) {
          for (const check of checks) {
            if (check.kind === "min")
              return check.value;
            if (check.kind === "max" && check.value < 0)
              return check.value;
          }
        } else {
          for (const check of checks) {
            const cd = check._zod?.def;
            if (cd?.check === "greater_than")
              return cd.value;
            if (cd?.check === "less_than" && cd.value < 0)
              return cd.value;
          }
        }
      }
      return 0;
    }
    case "bigint":
      return BigInt(0);
    case "boolean":
      return false;
    case "nan":
      return NaN;
    case "date":
      return new Date;
    case "symbol":
      return Symbol("remotion");
    case "undefined":
    case "void":
      return;
    case "null":
      return null;
    case "any":
    case "custom":
      throw new Error("Cannot create a value for type z.any()");
    case "unknown":
      throw new Error("Cannot create a value for type z.unknown()");
    case "never":
      throw new Error("Cannot create a value for type z.never()");
    case "object": {
      const shape = getObjectShape(schema);
      const keys = Object.keys(shape);
      const returnValue = keys.reduce((existing, key) => {
        existing[key] = createZodValues(shape[key], zodRuntime, zodTypes);
        return existing;
      }, {});
      return returnValue;
    }
    case "array": {
      return [createZodValues(getArrayElement(schema), zodRuntime, zodTypes)];
    }
    case "union": {
      const firstOption = getUnionOptions(schema)[0];
      return firstOption ? createZodValues(firstOption, zodRuntime, zodTypes) : undefined;
    }
    case "discriminatedUnion": {
      const firstOption = getUnionOptions(schema)[0];
      return createZodValues(firstOption, zodRuntime, zodTypes);
    }
    case "literal": {
      return getLiteralValue(schema);
    }
    case "effects": {
      return createZodValues(getEffectsInner(schema), zodRuntime, zodTypes);
    }
    case "intersection": {
      const { left: left3, right } = getIntersectionSchemas(schema);
      const leftValue = createZodValues(left3, zodRuntime, zodTypes);
      if (typeof leftValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Left side is not an object");
      }
      const rightValue = createZodValues(right, zodRuntime, zodTypes);
      if (typeof rightValue !== "object") {
        throw new Error("Cannot create value for type z.intersection: Right side is not an object");
      }
      return { ...leftValue, ...rightValue };
    }
    case "tuple": {
      return getTupleItems(schema).map((item2) => createZodValues(item2, zodRuntime, zodTypes));
    }
    case "record": {
      const values = createZodValues(getRecordValueType(schema), zodRuntime, zodTypes);
      return { key: values };
    }
    case "map": {
      const values = createZodValues(getRecordValueType(schema), zodRuntime, zodTypes);
      const key = createZodValues(getRecordKeyType(schema), zodRuntime, zodTypes);
      return new Map([[key, values]]);
    }
    case "lazy": {
      const type = getZodDef(schema).getter();
      return createZodValues(type, zodRuntime, zodTypes);
    }
    case "set": {
      const values = createZodValues(getZodDef(schema).valueType, zodRuntime, zodTypes);
      return new Set([values]);
    }
    case "function": {
      throw new Error("Cannot create a value for type function");
    }
    case "enum": {
      return getFirstEnumValue(schema);
    }
    case "nativeEnum": {
      return 0;
    }
    case "optional":
    case "nullable":
    case "catch": {
      return createZodValues(getInnerType(schema), zodRuntime, zodTypes);
    }
    case "default": {
      return getDefaultValue(schema);
    }
    case "promise": {
      const def = getZodDef(schema);
      const inner = isZodV3Schema(schema) ? def.type : def.innerType;
      const value = createZodValues(inner, zodRuntime, zodTypes);
      return Promise.resolve(value);
    }
    case "branded": {
      return createZodValues(getBrandedInner(schema), zodRuntime, zodTypes);
    }
    case "pipeline":
    case "pipe": {
      const out = getPipelineOutput(schema);
      if (getZodSchemaType(out) === "transform") {
        return createZodValues(getPipelineInput(schema), zodRuntime, zodTypes);
      }
      return createZodValues(out, zodRuntime, zodTypes);
    }
    default:
      throw new Error("Not implemented: " + typeName);
  }
};

// src/components/RenderModal/SchemaEditor/SchemaSeparationLine.tsx
import { jsx as jsx110, jsxs as jsxs50, Fragment as Fragment18 } from "react/jsx-runtime";
var VERTICAL_GUIDE_HEIGHT = 24;
var line2 = {
  borderBottom: "1px solid " + LINE_COLOR
};
var SchemaSeparationLine = () => {
  return /* @__PURE__ */ jsx110("div", {
    style: line2
  });
};
var arraySeparationLine = {
  borderBottom: "1px solid " + LINE_COLOR,
  marginTop: -VERTICAL_GUIDE_HEIGHT / 2,
  pointerEvents: "none",
  width: "100%",
  flexBasis: "100%"
};
var SchemaArrayItemSeparationLine = ({ onChange, index, schema, isLast, showAddButton }) => {
  const [outerHovered, setOuterHovered] = useState44(false);
  const [innerHovered, setInnerHovered] = useState44(false);
  const zodTypes = useZodTypesIfPossible();
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const arrayElement = getArrayElement(schema);
  const onAdd = useCallback51(() => {
    onChange((oldV) => {
      return [
        ...oldV.slice(0, index + 1),
        createZodValues(arrayElement, z, zodTypes),
        ...oldV.slice(index + 1)
      ];
    }, false, true);
  }, [arrayElement, index, onChange, z, zodTypes]);
  const dynamicAddButtonStyle = useMemo62(() => {
    return {
      display: "flex",
      justifyContent: "center",
      height: VERTICAL_GUIDE_HEIGHT,
      opacity: outerHovered || isLast ? 1 : 0,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    };
  }, [isLast, outerHovered]);
  const inner = useMemo62(() => {
    return {
      background: BACKGROUND,
      paddingLeft: 10,
      paddingRight: 10
    };
  }, []);
  const onOuterMouseEnter = useCallback51(() => {
    setOuterHovered(true);
  }, []);
  const onOuterMouseLeave = useCallback51(() => {
    setOuterHovered(false);
  }, []);
  const onInnerMouseEnter = useCallback51(() => {
    setInnerHovered(true);
  }, []);
  const onInnerMouseLeave = useCallback51(() => {
    setInnerHovered(false);
  }, []);
  return /* @__PURE__ */ jsxs50("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      height: VERTICAL_GUIDE_HEIGHT
    },
    children: [
      /* @__PURE__ */ jsxs50("div", {
        style: {
          flex: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end"
        },
        children: [
          showAddButton && /* @__PURE__ */ jsx110("div", {
            style: dynamicAddButtonStyle,
            onPointerEnter: onOuterMouseEnter,
            onPointerLeave: onOuterMouseLeave,
            children: /* @__PURE__ */ jsx110("div", {
              onClick: onAdd,
              style: inner,
              onPointerEnter: onInnerMouseEnter,
              onPointerLeave: onInnerMouseLeave,
              children: /* @__PURE__ */ jsx110(Plus, {
                color: innerHovered ? "white" : LIGHT_TEXT,
                style: { height: VERTICAL_GUIDE_HEIGHT / 2 }
              })
            })
          }),
          /* @__PURE__ */ jsx110("div", {
            style: arraySeparationLine
          })
        ]
      }),
      isLast ? /* @__PURE__ */ jsxs50(Fragment18, {
        children: [
          /* @__PURE__ */ jsx110(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx110("div", {
            style: {
              ...fieldSetText,
              alignItems: "center",
              display: "flex"
            },
            children: "]"
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaVerticalGuide.tsx
import { useMemo as useMemo63 } from "react";
import { jsx as jsx111, jsxs as jsxs51 } from "react/jsx-runtime";
var flex = {
  flex: 1
};
var SchemaVerticalGuide = ({ isRoot, children }) => {
  const outer = useMemo63(() => {
    return {
      display: "flex",
      flexDirection: "row",
      position: "relative",
      marginLeft: isRoot ? 0 : 4
    };
  }, [isRoot]);
  const inner = useMemo63(() => {
    return isRoot ? {} : {
      height: `calc(100% - ${VERTICAL_GUIDE_HEIGHT / 2}px)`,
      width: 1,
      background: "#363A3E",
      position: "absolute"
    };
  }, [isRoot]);
  return /* @__PURE__ */ jsxs51("div", {
    style: outer,
    children: [
      /* @__PURE__ */ jsx111("div", {
        style: inner
      }),
      /* @__PURE__ */ jsx111("div", {
        style: flex,
        children
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import React78, { useMemo as useMemo67, useState as useState46 } from "react";

// src/components/RenderModal/SchemaEditor/ZodArrayItemEditor.tsx
import { useCallback as useCallback52, useMemo as useMemo64 } from "react";
import { jsx as jsx112 } from "react/jsx-runtime";
var ZodArrayItemEditor = ({
  elementSchema,
  onChange,
  jsonPath,
  index,
  value,
  defaultValue,
  onSave: onSaveObject,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad,
  mayRemove
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const onRemove = useCallback52(() => {
    onChange((oldV) => [...oldV.slice(0, index), ...oldV.slice(index + 1)], false, true);
  }, [index, onChange]);
  const setValue = useCallback52((val) => {
    onChange((oldV) => [
      ...oldV.slice(0, index),
      typeof val === "function" ? val(oldV[index]) : val,
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onChange]);
  const newJsonPath = useMemo64(() => [...jsonPath, index], [index, jsonPath]);
  const onSave = useCallback52((updater) => {
    onSaveObject((oldV) => [
      ...oldV.slice(0, index),
      updater(oldV[index]),
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onSaveObject]);
  return /* @__PURE__ */ jsx112("div", {
    children: /* @__PURE__ */ jsx112(ZodSwitch, {
      jsonPath: newJsonPath,
      schema: elementSchema,
      value,
      setValue,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove: mayRemove ? onRemove : null,
      saving,
      saveDisabledByParent,
      mayPad
    })
  });
};

// src/components/RenderModal/InfoBubble.tsx
import { PlayerInternals as PlayerInternals11 } from "@remotion/player";
import { useCallback as useCallback53, useEffect as useEffect43, useMemo as useMemo66, useRef as useRef26, useState as useState45 } from "react";
import ReactDOM7 from "react-dom";

// src/components/RenderModal/InfoTooltip.tsx
import { useMemo as useMemo65 } from "react";
import { jsx as jsx113, jsxs as jsxs52 } from "react/jsx-runtime";
var arrow = {
  height: 7,
  display: "block",
  overflow: "visible",
  marginLeft: 7
};
var arrowUp = {
  ...arrow,
  transform: `translateY(1px)`
};
var arrowDown = {
  ...arrow,
  marginTop: -1
};
var InfoTooltip = ({ children, arrowDirection, backgroundColor }) => {
  const container28 = useMemo65(() => {
    return {
      boxShadow: arrowDirection === "down" ? SHADOW_TOWARDS_TOP : SHADOW_TOWARDS_BOTTOM,
      background: backgroundColor,
      color: "white",
      border: "0.5px solid " + BORDER_COLOR,
      maxHeight: 200,
      overflow: "auto",
      borderRadius: "4px"
    };
  }, [arrowDirection, backgroundColor]);
  return /* @__PURE__ */ jsxs52("div", {
    style: {
      display: "flex",
      flexDirection: arrowDirection === "up" ? "column-reverse" : "column",
      alignItems: "flex-start"
    },
    children: [
      /* @__PURE__ */ jsx113("div", {
        style: container28,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children
      }),
      arrowDirection === "down" ? /* @__PURE__ */ jsx113("svg", {
        viewBox: "0 0 14 7",
        style: arrowDown,
        children: /* @__PURE__ */ jsx113("path", {
          d: `M 14 0 L 7 7 L 0 0`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null,
      arrowDirection === "up" ? /* @__PURE__ */ jsx113("svg", {
        viewBox: "0 0 14 7",
        style: arrowUp,
        children: /* @__PURE__ */ jsx113("path", {
          d: `M 0 7 L 7 0 L 14 7`,
          fill: backgroundColor,
          strokeLinecap: "butt",
          stroke: BORDER_COLOR,
          strokeWidth: 0.5
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/InfoBubble.tsx
import { jsx as jsx114, jsxs as jsxs53, Fragment as Fragment19 } from "react/jsx-runtime";
var icon4 = {
  color: LIGHT_TEXT,
  height: 15
};
var container28 = {
  display: "inline-block",
  border: "none",
  fontSize: 14,
  verticalAlign: "text-bottom"
};
var InfoBubble = ({ title: title4, children }) => {
  const [hovered, setIsHovered] = useState45(false);
  const [opened, setOpened] = useState45(false);
  const ref = useRef26(null);
  const { tabIndex, currentZIndex } = useZIndex();
  const size2 = PlayerInternals11.useElementSize(ref, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size2?.refresh;
  const onHide = useCallback53(() => {
    setOpened(false);
  }, []);
  useEffect43(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    const onPointerUp = () => {
      return setOpened((o) => {
        if (!o) {
          refresh?.();
        }
        return !o;
      });
    };
    const onClick = (e) => {
      e.stopPropagation();
      const isKeyboardInitiated = e.detail === 0;
      if (!isKeyboardInitiated) {
        return;
      }
      return setOpened((o) => {
        return !o;
      });
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    current.addEventListener("pointerup", onPointerUp);
    current.addEventListener("click", onClick);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      current.removeEventListener("pointerup", onPointerUp);
      current.removeEventListener("click", onClick);
    };
  }, [refresh]);
  const layout = useMemo66(() => {
    if (!size2) {
      return "down";
    }
    const spaceToBottom = size2.windowSize.height - (size2.top + size2.height);
    const spaceToTop = size2.top;
    const l = spaceToTop > spaceToBottom ? "down" : "up";
    return l;
  }, [size2]);
  const portalStyle = useMemo66(() => {
    if (!size2 || !opened) {
      return null;
    }
    return {
      ...layout === "up" ? {
        position: "fixed",
        top: size2.top + size2.height
      } : {
        position: "fixed",
        bottom: size2.windowSize.height - size2.top
      },
      left: size2.left
    };
  }, [layout, opened, size2]);
  const style8 = useMemo66(() => {
    return {
      ...container28,
      userSelect: "none",
      WebkitUserSelect: "none",
      color: "white",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      padding: 6
    };
  }, []);
  return /* @__PURE__ */ jsxs53(Fragment19, {
    children: [
      /* @__PURE__ */ jsx114("button", {
        ref,
        tabIndex,
        style: style8,
        title: title4,
        type: "button",
        children: /* @__PURE__ */ jsx114("svg", {
          style: icon4,
          viewBox: "0 0 512 512",
          children: /* @__PURE__ */ jsx114("path", {
            fill: hovered ? "white" : LIGHT_TEXT,
            d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
          })
        })
      }),
      portalStyle ? ReactDOM7.createPortal(/* @__PURE__ */ jsx114("div", {
        style: outerPortal,
        className: "css-reset",
        children: /* @__PURE__ */ jsx114(HigherZIndex, {
          onOutsideClick: onHide,
          onEscape: onHide,
          children: /* @__PURE__ */ jsx114("div", {
            style: portalStyle,
            children: /* @__PURE__ */ jsx114(InfoTooltip, {
              backgroundColor: INPUT_BACKGROUND,
              arrowDirection: layout,
              children
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodFieldValidation.tsx
import { jsx as jsx115, jsxs as jsxs54 } from "react/jsx-runtime";
var legend = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var stackTrace = {
  padding: 10
};
var stackTraceLabel = {
  fontSize: 14
};
var ZodFieldValidation = ({ localValue, path }) => {
  const { zodValidation } = localValue;
  if (zodValidation.success) {
    return null;
  }
  return /* @__PURE__ */ jsxs54("div", {
    style: legend,
    children: [
      /* @__PURE__ */ jsx115(ValidationMessage, {
        align: "flex-start",
        message: zodValidation.error.format()._errors[0],
        type: "error"
      }),
      /* @__PURE__ */ jsx115(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx115(InfoBubble, {
        title: "Zod validation failure",
        children: /* @__PURE__ */ jsxs54("div", {
          style: stackTrace,
          children: [
            /* @__PURE__ */ jsx115("div", {
              style: stackTraceLabel,
              children: "Zod Validation has failed:"
            }),
            zodValidation.error.issues.map((error, index) => /* @__PURE__ */ jsxs54("div", {
              style: stackTraceLabel,
              children: [
                "Type: ",
                error.code,
                " ",
                /* @__PURE__ */ jsx115("br", {}),
                "Message: ",
                error.message,
                /* @__PURE__ */ jsx115("br", {}),
                "Path: ",
                path.join(".")
              ]
            }, index))
          ]
        })
      }),
      /* @__PURE__ */ jsx115(Spacing, {
        x: 0.5
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodArrayEditor.tsx
import { jsx as jsx116, jsxs as jsxs55 } from "react/jsx-runtime";
var ZodArrayEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState46(true);
  const arrayElement = getArrayElement(schema);
  const suffix2 = useMemo67(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isDefaultValue = useMemo67(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  return /* @__PURE__ */ jsxs55(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx116("div", {
        style: {
          display: "flex",
          flexDirection: "row"
        },
        children: /* @__PURE__ */ jsx116(SchemaLabel, {
          onReset: reset,
          isDefaultValue,
          jsonPath,
          onRemove,
          suffix: suffix2,
          onSave: () => {
            onSave(() => localValue.value, false, false);
          },
          saveDisabledByParent,
          saving,
          showSaveButton,
          valid: localValue.zodValidation.success,
          handleClick: () => setExpanded(!expanded)
        })
      }),
      expanded ? /* @__PURE__ */ jsx116(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs55(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            localValue.value.map((child, i) => {
              return /* @__PURE__ */ jsxs55(React78.Fragment, {
                children: [
                  /* @__PURE__ */ jsx116(ZodArrayItemEditor, {
                    onChange,
                    value: child,
                    elementSchema: arrayElement,
                    index: i,
                    jsonPath,
                    defaultValue: defaultValue?.[i] ?? createZodValues(arrayElement, z, zodTypes),
                    onSave,
                    showSaveButton,
                    saving,
                    saveDisabledByParent,
                    mayPad,
                    mayRemove: true
                  }),
                  /* @__PURE__ */ jsx116(SchemaArrayItemSeparationLine, {
                    schema,
                    index: i,
                    onChange,
                    isLast: i === localValue.value.length - 1,
                    showAddButton: true
                  })
                ]
              }, `${i}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx116(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: true
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx116(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import { useCallback as useCallback54 } from "react";

// src/components/Checkbox.tsx
import { useEffect as useEffect44, useMemo as useMemo68, useRef as useRef27 } from "react";
import { jsx as jsx117, jsxs as jsxs56 } from "react/jsx-runtime";
var size2 = 20;
var background = {
  height: size2,
  width: size2,
  position: "relative"
};
var bullet = {
  width: 10,
  height: 10,
  backgroundColor: LIGHT_TEXT,
  borderRadius: "50%"
};
var box = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  height: size2,
  width: size2,
  top: 0,
  left: 0,
  pointerEvents: "none",
  color: "white"
};
var Checkbox = ({ checked, onChange, disabled, name, rounded }) => {
  const ref = useRef27(null);
  const input2 = useMemo68(() => {
    return {
      appearance: "none",
      background: disabled ? "transparent" : INPUT_BACKGROUND,
      border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
      height: size2,
      width: size2,
      top: 0,
      left: 0,
      position: "absolute",
      margin: 0
    };
  }, [disabled]);
  useEffect44(() => {
    if (ref.current) {
      ref.current.style.setProperty("border-radius", rounded ? "50%" : "0%", "important");
    }
  }, [rounded]);
  return /* @__PURE__ */ jsxs56("div", {
    style: background,
    children: [
      /* @__PURE__ */ jsx117("input", {
        ref,
        style: input2,
        type: "checkbox",
        checked,
        onChange,
        disabled,
        name
      }),
      /* @__PURE__ */ jsx117("div", {
        style: box,
        children: checked ? rounded ? /* @__PURE__ */ jsx117("div", {
          style: bullet
        }) : /* @__PURE__ */ jsx117(Checkmark, {}) : null
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodBooleanEditor.tsx
import { jsx as jsx118, jsxs as jsxs57 } from "react/jsx-runtime";
var fullWidth = {
  width: "100%"
};
var ZodBooleanEditor = ({
  schema,
  jsonPath,
  value,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onToggle = useCallback54((e) => {
    onChange(() => e.target.checked, false, false);
  }, [onChange]);
  const save = useCallback54(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs57(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx118(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: true,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsx118("div", {
        style: fullWidth,
        children: /* @__PURE__ */ jsx118(Checkbox, {
          name: jsonPath.join("."),
          checked: localValue.value,
          onChange: onToggle,
          disabled: false
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import { useCallback as useCallback56, useMemo as useMemo71 } from "react";

// src/helpers/color-math.ts
var colorWithNewOpacity = (color, opacity, zodTypes) => {
  const { r, g, b } = zodTypes.ZodZypesInternals.parseColor(color);
  if (opacity >= 255) {
    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }
  return `rgba(${r}, ${g}, ${b}, ${(opacity / 255).toFixed(2)})`;
};

// src/components/NewComposition/InputDragger.tsx
import React81, { useCallback as useCallback55, useEffect as useEffect45, useMemo as useMemo69, useRef as useRef28, useState as useState47 } from "react";
import { interpolate as interpolate2 } from "remotion";
import { jsx as jsx119 } from "react/jsx-runtime";
var isInt = (num) => {
  return num % 1 === 0;
};
var InputDraggerForwardRefFn = ({
  onValueChange,
  onValueChangeEnd,
  min: _min,
  max: _max,
  step: _step,
  value,
  onTextChange,
  formatter = (q) => String(q),
  status,
  rightAlign,
  small,
  ...props
}, ref) => {
  const [inputFallback, setInputFallback] = useState47(false);
  const [dragging, setDragging] = useState47(false);
  const fallbackRef = useRef28(null);
  const pointerDownRef = useRef28(false);
  const style8 = useMemo69(() => {
    return {
      ...inputBaseStyle,
      backgroundColor: "transparent",
      borderColor: "transparent",
      padding: "4px 6px",
      ...{ outline: "none" }
    };
  }, []);
  const span = useMemo69(() => ({
    color: dragging ? "var(--remotion-cli-internals-blue-hovered)" : BLUE,
    cursor: "ew-resize",
    userSelect: "none",
    WebkitUserSelect: "none",
    fontSize: small ? 12 : 14,
    fontVariantNumeric: "tabular-nums"
  }), [dragging, small]);
  const onFocus = useCallback55(() => {
    if (!small || pointerDownRef.current) {
      return;
    }
    setInputFallback(true);
  }, [small]);
  const onClick = useCallback55((e) => {
    if (!getClickLock()) {
      e.stopPropagation();
    }
    if (getClickLock()) {
      return;
    }
    setInputFallback(true);
  }, []);
  const onEscape = useCallback55(() => {
    setInputFallback(false);
  }, []);
  const onInputChange = useCallback55((e) => {
    const parsed = Number(e.target.value);
    if (e.target.value !== "" && !Number.isNaN(parsed)) {
      onValueChange(parsed);
    }
  }, [onValueChange]);
  const onBlur = useCallback55(() => {
    if (!fallbackRef.current) {
      return;
    }
    const newValue = fallbackRef.current.value;
    if (newValue.trim() === "") {
      onEscape();
      return;
    }
    if (fallbackRef.current.checkValidity()) {
      onTextChange?.(newValue);
      setInputFallback(false);
    } else {
      fallbackRef.current.reportValidity();
    }
  }, [onEscape, onTextChange]);
  const onKeyPress = useCallback55((e) => {
    if (e.key === "Enter") {
      fallbackRef.current?.blur();
    }
  }, []);
  const roundToStep = (val, stepSize) => {
    const factor = 1 / stepSize;
    return Math.ceil(val * factor) / factor;
  };
  const onPointerDown = useCallback55((e) => {
    pointerDownRef.current = true;
    const target = e.currentTarget;
    const { pageX, pageY, button: button3 } = e;
    if (button3 !== 0) {
      return;
    }
    let lastDragValue = null;
    const moveListener = (ev) => {
      const xDistance = ev.pageX - pageX;
      const distanceFromStart = Math.sqrt(xDistance ** 2 + (ev.pageY - pageY) ** 2);
      const step = Number(_step ?? 1);
      const min = Number(_min ?? 0);
      const max = Number(_max ?? Infinity);
      if (distanceFromStart > 4) {
        setClickLock(true);
        setDragging(true);
        target.blur();
      }
      const diff = interpolate2(xDistance, [-5, -4, 0, 4, 5], [-step, 0, 0, 0, step]);
      const newValue = Math.min(max, Math.max(min, Number(value) + diff));
      const roundedToStep = roundToStep(newValue, step);
      lastDragValue = roundedToStep;
      onValueChange(roundedToStep);
    };
    window.addEventListener("mousemove", moveListener);
    window.addEventListener("pointerup", () => {
      window.removeEventListener("mousemove", moveListener);
      pointerDownRef.current = false;
      setDragging(false);
      if (lastDragValue !== null && onValueChangeEnd) {
        onValueChangeEnd(lastDragValue);
      }
      setTimeout(() => {
        setClickLock(false);
      }, 2);
    }, {
      once: true
    });
  }, [_step, _min, _max, value, onValueChange, onValueChangeEnd]);
  useEffect45(() => {
    if (inputFallback) {
      fallbackRef.current?.select();
    }
  }, [inputFallback]);
  const deriveStep = useMemo69(() => {
    if (_step !== undefined) {
      return _step;
    }
    if (typeof _min === "number" && isInt(_min)) {
      return 1;
    }
    return 0.0001;
  }, [_min, _step]);
  if (inputFallback) {
    return /* @__PURE__ */ jsx119(HigherZIndex, {
      onEscape,
      onOutsideClick: noop,
      children: /* @__PURE__ */ jsx119(RemotionInput, {
        ref: fallbackRef,
        autoFocus: true,
        onKeyPress,
        onBlur,
        onChange: onInputChange,
        min: _min,
        max: _max,
        step: deriveStep,
        defaultValue: value,
        status,
        pattern: "[0-9]*[.]?[0-9]*",
        rightAlign,
        ...props,
        ...small ? { style: { padding: "4px 6px", fontSize: 12 } } : {}
      })
    });
  }
  return /* @__PURE__ */ jsx119("button", {
    ref,
    type: "button",
    className: "__remotion_input_dragger",
    style: style8,
    onClick,
    onFocus,
    onPointerDown,
    children: /* @__PURE__ */ jsx119("span", {
      style: span,
      children: formatter(value)
    })
  });
};
var InputDragger = React81.forwardRef(InputDraggerForwardRefFn);

// src/components/NewComposition/RemInputTypeColor.tsx
import {
  forwardRef as forwardRef4,
  useEffect as useEffect46,
  useImperativeHandle as useImperativeHandle11,
  useMemo as useMemo70,
  useRef as useRef29,
  useState as useState48
} from "react";
import { jsx as jsx120 } from "react/jsx-runtime";
var inputBaseStyle3 = {
  padding: 0,
  borderStyle: "solid",
  borderWidth: 1
};
var RemInputTypeColorForwardRef = ({ status, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState48(false);
  const [isHovered, setIsHovered] = useState48(false);
  const inputRef = useRef29(null);
  const { tabIndex } = useZIndex();
  const style8 = useMemo70(() => {
    return {
      backgroundColor: INPUT_BACKGROUND,
      ...inputBaseStyle3,
      borderColor: getInputBorderColor({ isFocused, isHovered, status }),
      ...props.style ?? {}
    };
  }, [isFocused, isHovered, props.style, status]);
  useImperativeHandle11(ref, () => {
    return inputRef.current;
  }, []);
  useEffect46(() => {
    if (!inputRef.current) {
      return;
    }
    const { current } = inputRef;
    const onFocus = () => setIsFocused(true);
    const onBlur = () => setIsFocused(false);
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("focus", onFocus);
    current.addEventListener("blur", onBlur);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("focus", onFocus);
      current.removeEventListener("blur", onBlur);
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [inputRef]);
  return /* @__PURE__ */ jsx120("input", {
    ref: inputRef,
    type: "color",
    tabIndex,
    ...props,
    name: props.name,
    style: style8
  });
};
var RemInputTypeColor = forwardRef4(RemInputTypeColorForwardRef);

// src/components/RenderModal/SchemaEditor/ZodColorEditor.tsx
import { jsx as jsx121, jsxs as jsxs58 } from "react/jsx-runtime";
var fullWidth2 = {
  width: "100%"
};
var ZodColorEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod color");
  }
  const {
    localValue,
    onChange: onValueChange,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const { a, b, g, r } = localValue.zodValidation.success ? zodTypes.ZodZypesInternals.parseColor(localValue.value) : { a: 1, b: 0, g: 0, r: 0 };
  const onChange = useCallback56((e) => {
    const newColor = colorWithNewOpacity(e.target.value, Math.round(a), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [a, onValueChange, zodTypes]);
  const onTextChange = useCallback56((e) => {
    const newValue = e.target.value;
    onValueChange(() => newValue, false, false);
  }, [onValueChange]);
  const save = useCallback56(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const rgb = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  const status = localValue.zodValidation.success ? "ok" : "error";
  const colorPicker = useMemo71(() => {
    return {
      height: 39,
      width: 45,
      display: "inline-block"
    };
  }, []);
  const onOpacityChange = useCallback56((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  const onOpacityValueChange = useCallback56((newValue) => {
    const newColor = colorWithNewOpacity(localValue.value, Math.round(Number(newValue) / 100 * 255), zodTypes);
    onValueChange(() => newColor, false, false);
  }, [localValue.value, onValueChange, zodTypes]);
  return /* @__PURE__ */ jsxs58(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx121(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs58("div", {
        style: fullWidth2,
        children: [
          /* @__PURE__ */ jsxs58(Row, {
            align: "center",
            children: [
              /* @__PURE__ */ jsx121("div", {
                style: colorPicker,
                children: /* @__PURE__ */ jsx121(RemInputTypeColor, {
                  type: "color",
                  style: {
                    height: 39
                  },
                  value: rgb,
                  onChange,
                  className: "__remotion_color_picker",
                  status,
                  name: jsonPath.join(".")
                })
              }),
              /* @__PURE__ */ jsx121(Spacing, {
                x: 1,
                block: true
              }),
              /* @__PURE__ */ jsx121(RemotionInput, {
                value: localValue.value,
                status,
                placeholder: jsonPath.join("."),
                onChange: onTextChange,
                rightAlign: false
              }),
              /* @__PURE__ */ jsx121(Spacing, {
                x: 1
              }),
              /* @__PURE__ */ jsx121(InputDragger, {
                onTextChange: onOpacityChange,
                onValueChange: onOpacityValueChange,
                status,
                value: a / 255 * 100,
                min: 0,
                max: 100,
                step: 1,
                formatter: (v) => `${Math.round(Number(v))}%`,
                rightAlign: false
              })
            ]
          }),
          /* @__PURE__ */ jsx121(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDateEditor.tsx
import { useCallback as useCallback57 } from "react";
import { jsx as jsx122, jsxs as jsxs59 } from "react/jsx-runtime";
var fullWidth3 = {
  width: "100%"
};
var explainer2 = {
  fontFamily: "sans-serif",
  fontSize: 12,
  color: VERY_LIGHT_TEXT
};
var inputStyle = {
  colorScheme: "dark"
};
var formatDate = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const milliseconds = date.getMilliseconds();
  const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds.toString().padStart(3, "0")}`;
  return formattedDate;
};
var ZodDateEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback57((e) => {
    setLocalValue(() => new Date(e.target.value), false, false);
  }, [setLocalValue]);
  const save = useCallback57(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs59(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx122(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value.getTime() === defaultValue.getTime(),
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs59("div", {
        style: fullWidth3,
        children: [
          /* @__PURE__ */ jsx122(RemotionInput, {
            value: formatDate(localValue.value),
            type: "datetime-local",
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            style: inputStyle,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx122(Spacing, {
            y: 1,
            block: true
          }),
          /* @__PURE__ */ jsx122("div", {
            style: explainer2,
            children: "Date is in local format"
          }),
          /* @__PURE__ */ jsx122(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodDefaultEditor.tsx
import { jsx as jsx123 } from "react/jsx-runtime";
var ZodDefaultEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const innerType = getInnerType(schema);
  return /* @__PURE__ */ jsx123(ZodSwitch, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema: innerType,
    setValue,
    showSaveButton,
    value,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodDiscriminatedUnionEditor.tsx
import { useCallback as useCallback58, useMemo as useMemo72 } from "react";
import { jsx as jsx124, jsxs as jsxs60 } from "react/jsx-runtime";
var ZodDiscriminatedUnionEditor = ({
  schema,
  setValue,
  showSaveButton,
  saving,
  value,
  defaultValue,
  saveDisabledByParent,
  onSave,
  mayPad,
  jsonPath,
  onRemove
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const discriminator = getDiscriminator(schema);
  const options = useMemo72(() => getDiscriminatedOptionKeys(schema), [schema]);
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const comboBoxValues = useMemo72(() => {
    return options.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value[discriminator] ? /* @__PURE__ */ jsx124(Checkmark, {}) : null,
        onClick: () => {
          const optionSchema = getDiscriminatedOption(schema, option);
          if (!optionSchema) {
            throw new Error(`No schema found for discriminator value: ${option}`);
          }
          const val = createZodValues(optionSchema, z, zodTypes);
          setLocalValue(() => val, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [options, setLocalValue, discriminator, schema, value, z, zodTypes]);
  const save = useCallback58(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  const discriminatedUnionReplacement = useMemo72(() => {
    return {
      discriminator,
      markup: /* @__PURE__ */ jsxs60(Fieldset, {
        shouldPad: mayPad,
        success: true,
        children: [
          /* @__PURE__ */ jsx124(SchemaLabel, {
            handleClick: null,
            isDefaultValue: localValue.value[discriminator] === defaultValue[discriminator],
            jsonPath: [...jsonPath, discriminator],
            onRemove,
            onReset: reset,
            onSave: save,
            saveDisabledByParent,
            saving,
            showSaveButton,
            suffix: null,
            valid: localValue.zodValidation.success
          }),
          /* @__PURE__ */ jsx124(Combobox, {
            title: "Select type",
            values: comboBoxValues,
            selectedId: value[discriminator]
          })
        ]
      }, "replacement")
    };
  }, [
    comboBoxValues,
    defaultValue,
    jsonPath,
    localValue.value,
    localValue.zodValidation.success,
    mayPad,
    onRemove,
    reset,
    save,
    saveDisabledByParent,
    saving,
    showSaveButton,
    discriminator,
    value
  ]);
  const currentOptionSchema = getDiscriminatedOption(schema, value[discriminator]);
  if (!currentOptionSchema) {
    throw new Error("No matching option found for discriminated union");
  }
  return /* @__PURE__ */ jsx124(ZodObjectEditor, {
    jsonPath,
    mayPad,
    savedValue: defaultValue,
    onRemove,
    onSave,
    saveDisabledByParent,
    saving,
    schema: currentOptionSchema,
    setValue: setLocalValue,
    showSaveButton,
    unsavedValue: value,
    discriminatedUnionReplacement
  }, value[discriminator]);
};

// src/components/RenderModal/SchemaEditor/ZodEffectEditor.tsx
import { jsx as jsx125, jsxs as jsxs61 } from "react/jsx-runtime";
var fullWidth4 = {
  width: "100%"
};
var ZodEffectEditor = ({
  schema,
  jsonPath,
  value,
  setValue: updateValue,
  defaultValue,
  onSave,
  onRemove,
  showSaveButton,
  saving,
  mayPad
}) => {
  const typeName = getZodSchemaType(schema);
  if (typeName !== "effects") {
    throw new Error("expected effect");
  }
  const { localValue, onChange } = useLocalState({
    unsavedValue: value,
    schema,
    setValue: updateValue,
    savedValue: defaultValue
  });
  const innerSchema = getEffectsInner(schema);
  return /* @__PURE__ */ jsxs61(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx125("div", {
        style: fullWidth4,
        children: /* @__PURE__ */ jsx125(ZodSwitch, {
          value,
          setValue: onChange,
          jsonPath,
          schema: innerSchema,
          defaultValue,
          onSave,
          showSaveButton,
          onRemove,
          saving,
          saveDisabledByParent: !localValue.zodValidation.success,
          mayPad: false
        })
      }),
      /* @__PURE__ */ jsx125(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodEnumEditor.tsx
import { useCallback as useCallback59, useMemo as useMemo73 } from "react";
import { jsx as jsx126, jsxs as jsxs62 } from "react/jsx-runtime";
var container29 = {
  width: "100%"
};
var ZodEnumEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const enumValues = getEnumValues(schema);
  const isRoot = jsonPath.length === 0;
  const comboBoxValues = useMemo73(() => {
    return enumValues.map((option) => {
      return {
        value: option,
        label: option,
        id: option,
        keyHint: null,
        leftItem: option === value ? /* @__PURE__ */ jsx126(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [enumValues, setLocalValue, value]);
  const save = useCallback59(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs62(Fieldset, {
    shouldPad: true,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx126(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent: !localValue.zodValidation.success,
        suffix: null
      }),
      /* @__PURE__ */ jsx126("div", {
        style: isRoot ? undefined : container29,
        children: /* @__PURE__ */ jsx126(Combobox, {
          values: comboBoxValues,
          selectedId: value,
          title: value
        })
      }),
      /* @__PURE__ */ jsx126(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodMatrixEditor.tsx
import React86, { useMemo as useMemo74, useState as useState49 } from "react";
import { jsx as jsx127, jsxs as jsxs63 } from "react/jsx-runtime";
var rowStyle = {
  display: "flex",
  flexDirection: "row",
  width: "100%"
};
var ZodMatrixEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState49(true);
  const arrayElement = getArrayElement(schema);
  const suffix2 = useMemo74(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isDefaultValue = useMemo74(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  const dimensions = Math.sqrt(localValue.value.length);
  if (!Number.isInteger(dimensions)) {
    throw new Error("Invalid matrix");
  }
  const chunkedItems = useMemo74(() => {
    return localValue.value.reduce((acc, item2, index) => {
      const chunkIndex = Math.floor(index / dimensions);
      acc[chunkIndex] = acc[chunkIndex] || [];
      acc[chunkIndex].push(item2);
      return acc;
    }, []);
  }, [localValue.value, dimensions]);
  return /* @__PURE__ */ jsxs63(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx127(SchemaLabel, {
        onReset: reset,
        isDefaultValue,
        jsonPath,
        onRemove,
        suffix: suffix2,
        onSave: () => {
          onSave(() => localValue.value, false, false);
        },
        saveDisabledByParent,
        saving,
        showSaveButton,
        valid: localValue.zodValidation.success,
        handleClick: () => setExpanded(!expanded)
      }),
      expanded ? /* @__PURE__ */ jsx127(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs63(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            chunkedItems.map((row4, rowIndex) => {
              return /* @__PURE__ */ jsx127(React86.Fragment, {
                children: /* @__PURE__ */ jsx127("div", {
                  style: rowStyle,
                  children: row4.map((item2, _index) => {
                    const actualIndex = rowIndex * dimensions + _index;
                    return /* @__PURE__ */ jsx127("div", {
                      style: { flex: 1 },
                      children: /* @__PURE__ */ jsx127(ZodArrayItemEditor, {
                        onChange,
                        value: item2,
                        elementSchema: arrayElement,
                        index: actualIndex,
                        jsonPath,
                        defaultValue: defaultValue?.[actualIndex] ?? createZodValues(arrayElement, z, zodTypes),
                        onSave,
                        showSaveButton,
                        saving,
                        saveDisabledByParent,
                        mayPad,
                        mayRemove: false
                      })
                    }, `${_index}${localValue.keyStabilityRevision}`);
                  })
                })
              }, `${rowIndex}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx127(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: true
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx127(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNonEditableValue.tsx
import { useCallback as useCallback60 } from "react";
import { jsx as jsx128, jsxs as jsxs64 } from "react/jsx-runtime";
var fullWidth5 = {
  width: "100%"
};
var emptyLabel = {
  width: "100%",
  color: VERY_LIGHT_TEXT,
  fontFamily: "sans-serif",
  fontSize: 14
};
var wideEmptyLabel = {
  ...emptyLabel,
  lineHeight: "37px"
};
var ZonNonEditableValue = ({ jsonPath, label: label6, showSaveButton, saving, mayPad }) => {
  const save = useCallback60(() => {
    return;
  }, []);
  const reset = useCallback60(() => {
    return;
  }, []);
  return /* @__PURE__ */ jsxs64(Fieldset, {
    shouldPad: mayPad,
    success: true,
    children: [
      /* @__PURE__ */ jsx128(SchemaLabel, {
        handleClick: null,
        isDefaultValue: true,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove: null,
        saving,
        valid: true,
        saveDisabledByParent: true,
        suffix: null
      }),
      /* @__PURE__ */ jsx128("div", {
        style: fullWidth5,
        children: /* @__PURE__ */ jsx128("em", {
          style: wideEmptyLabel,
          children: label6
        })
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOrNullishEditor.tsx
import { useCallback as useCallback61 } from "react";
import { jsx as jsx129, jsxs as jsxs65 } from "react/jsx-runtime";
var labelStyle4 = {
  fontFamily: "sans-serif",
  fontSize: 14,
  color: LIGHT_TEXT
};
var checkBoxWrapper = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginTop: "5px"
};
var ZodOrNullishEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  nullishValue,
  saving,
  saveDisabledByParent,
  mayPad,
  innerSchema
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isChecked = value === nullishValue;
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onCheckBoxChange = useCallback61((e) => {
    const val = e.target.checked ? nullishValue : createZodValues(innerSchema, z, zodTypes);
    setLocalValue(() => val, false, false);
  }, [innerSchema, nullishValue, setLocalValue, z, zodTypes]);
  const save = useCallback61(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs65(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      localValue.value === nullishValue ? /* @__PURE__ */ jsx129(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }) : /* @__PURE__ */ jsx129(ZodSwitch, {
        value: localValue.value,
        setValue: setLocalValue,
        jsonPath,
        schema: innerSchema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad: false
      }),
      /* @__PURE__ */ jsxs65("div", {
        style: checkBoxWrapper,
        children: [
          /* @__PURE__ */ jsx129(Checkbox, {
            checked: isChecked,
            onChange: onCheckBoxChange,
            disabled: false,
            name: jsonPath.join(".")
          }),
          /* @__PURE__ */ jsx129(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx129("div", {
            style: labelStyle4,
            children: String(nullishValue)
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodNullableEditor.tsx
import { jsx as jsx130 } from "react/jsx-runtime";
var ZodNullableEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const innerType = getInnerType(schema);
  return /* @__PURE__ */ jsx130(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: innerType,
    setValue,
    showSaveButton,
    value,
    nullishValue: null,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodNumberEditor.tsx
import { useCallback as useCallback62 } from "react";

// src/components/RenderModal/SchemaEditor/zod-number-constraints.ts
var getZodNumberMinimum = (schema) => {
  const { checks } = getZodDef(schema);
  if (!checks)
    return -Infinity;
  if (isZodV3Schema(schema)) {
    const minCheck = checks.find((c) => c.kind === "min");
    if (!minCheck || !minCheck.inclusive)
      return -Infinity;
    return minCheck.value;
  }
  for (const c of checks) {
    const def = c._zod?.def;
    if (def?.check === "greater_than" && def.inclusive) {
      return def.value;
    }
  }
  return -Infinity;
};
var getZodNumberMaximum = (schema) => {
  const { checks } = getZodDef(schema);
  if (!checks)
    return Infinity;
  if (isZodV3Schema(schema)) {
    const maxCheck = checks.find((c) => c.kind === "max");
    if (!maxCheck || !maxCheck.inclusive)
      return Infinity;
    return maxCheck.value;
  }
  for (const c of checks) {
    const def = c._zod?.def;
    if (def?.check === "less_than" && def.inclusive) {
      return def.value;
    }
  }
  return Infinity;
};
var getZodNumberStep = (schema) => {
  const { checks } = getZodDef(schema);
  if (!checks)
    return;
  if (isZodV3Schema(schema)) {
    const multipleStep = checks.find((c) => c.kind === "multipleOf");
    if (!multipleStep)
      return;
    return multipleStep.value;
  }
  for (const c of checks) {
    const def = c._zod?.def;
    if (def?.check === "multiple_of") {
      return def.value;
    }
  }
  return;
};

// src/components/RenderModal/SchemaEditor/ZodNumberEditor.tsx
import { jsx as jsx131, jsxs as jsxs66 } from "react/jsx-runtime";
var fullWidth6 = {
  width: "100%"
};
var ZodNumberEditor = ({
  jsonPath,
  value,
  schema,
  setValue,
  onSave,
  defaultValue,
  onRemove,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const onNumberChange = useCallback62((newValue) => {
    setLocalValue(() => newValue, false, false);
  }, [setLocalValue]);
  const isDefault = localValue.value === defaultValue;
  const onTextChange = useCallback62((newValue) => {
    setLocalValue(() => Number(newValue), false, false);
  }, [setLocalValue]);
  const save = useCallback62(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs66(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx131(SchemaLabel, {
        handleClick: null,
        isDefaultValue: isDefault,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs66("div", {
        style: fullWidth6,
        children: [
          /* @__PURE__ */ jsx131(InputDragger, {
            type: "number",
            value: localValue.value,
            style: fullWidth6,
            status: localValue.zodValidation.success ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onTextChange,
            onValueChange: onNumberChange,
            min: getZodNumberMinimum(schema),
            max: getZodNumberMaximum(schema),
            step: getZodNumberStep(schema),
            rightAlign: false
          }),
          /* @__PURE__ */ jsx131(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodOptionalEditor.tsx
import { jsx as jsx132 } from "react/jsx-runtime";
var ZodOptionalEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const innerType = getInnerType(schema);
  return /* @__PURE__ */ jsx132(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    setValue,
    showSaveButton,
    value,
    nullishValue: undefined,
    saving,
    saveDisabledByParent,
    mayPad,
    innerSchema: innerType
  });
};

// src/components/RenderModal/SchemaEditor/ZodStaticFileEditor.tsx
import { useCallback as useCallback63, useMemo as useMemo75 } from "react";
import { jsx as jsx133, jsxs as jsxs67 } from "react/jsx-runtime";
var container30 = {
  width: "100%"
};
var ZodStaticFileEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const isRoot = jsonPath.length === 0;
  const staticFiles = useStaticFiles();
  const comboBoxValues = useMemo75(() => {
    return staticFiles.map((option) => {
      return {
        value: option.src,
        label: option.name,
        id: option.src,
        keyHint: null,
        leftItem: option.src === value ? /* @__PURE__ */ jsx133(Checkmark, {}) : null,
        onClick: (id) => {
          setLocalValue(() => id, false, false);
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item"
      };
    });
  }, [setLocalValue, staticFiles, value]);
  const save = useCallback63(() => {
    onSave(() => value);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs67(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx133(SchemaLabel, {
        handleClick: null,
        onSave: save,
        showSaveButton,
        isDefaultValue: localValue.value === defaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsx133("div", {
        style: isRoot ? undefined : container30,
        children: /* @__PURE__ */ jsx133(Combobox, {
          values: comboBoxValues,
          selectedId: localValue.value,
          title: value
        })
      }),
      /* @__PURE__ */ jsx133(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodStringEditor.tsx
import { useCallback as useCallback64 } from "react";
import { jsx as jsx134, jsxs as jsxs68 } from "react/jsx-runtime";
var fullWidth7 = {
  width: "100%"
};
var ZodStringEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback64((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback64(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs68(Fieldset, {
    shouldPad: mayPad,
    success: false,
    children: [
      /* @__PURE__ */ jsx134(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs68("div", {
        style: fullWidth7,
        children: [
          /* @__PURE__ */ jsx134(RemotionInput, {
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            onChange,
            rightAlign: false,
            name: jsonPath.join(".")
          }),
          /* @__PURE__ */ jsx134(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodTextareaEditor.tsx
import { useCallback as useCallback65 } from "react";
import { jsx as jsx135, jsxs as jsxs69 } from "react/jsx-runtime";
var fullWidth8 = {
  width: "100%"
};
var textareaStyle = {
  resize: "vertical",
  minHeight: 100
};
var ZodTextareaEditor = ({
  jsonPath,
  value,
  setValue,
  showSaveButton,
  defaultValue,
  schema,
  onSave,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  if (!zodTypes) {
    throw new Error("expected zod textarea");
  }
  const {
    localValue,
    onChange: setLocalValue,
    reset
  } = useLocalState({
    schema,
    setValue,
    unsavedValue: value,
    savedValue: defaultValue
  });
  const onChange = useCallback65((e) => {
    setLocalValue(() => e.target.value, false, false);
  }, [setLocalValue]);
  const save = useCallback65(() => {
    onSave(() => value, false, false);
  }, [onSave, value]);
  return /* @__PURE__ */ jsxs69(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx135(SchemaLabel, {
        handleClick: null,
        isDefaultValue: localValue.value === defaultValue,
        jsonPath,
        onReset: reset,
        onSave: save,
        showSaveButton,
        onRemove,
        saving,
        valid: localValue.zodValidation.success,
        saveDisabledByParent,
        suffix: null
      }),
      /* @__PURE__ */ jsxs69("div", {
        style: fullWidth8,
        children: [
          /* @__PURE__ */ jsx135(RemTextarea, {
            onChange,
            value: localValue.value,
            status: localValue.zodValidation ? "ok" : "error",
            placeholder: jsonPath.join("."),
            name: jsonPath.join("."),
            style: textareaStyle
          }),
          /* @__PURE__ */ jsx135(ZodFieldValidation, {
            path: jsonPath,
            localValue
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodTupleEditor.tsx
import React92, { useMemo as useMemo77, useState as useState50 } from "react";

// src/components/RenderModal/SchemaEditor/ZodTupleItemEditor.tsx
import { useCallback as useCallback66, useMemo as useMemo76 } from "react";
import { jsx as jsx136 } from "react/jsx-runtime";
var ZodTupleItemEditor = ({
  tupleItems,
  onChange,
  jsonPath,
  index,
  value,
  defaultValue,
  onSave: onSaveObject,
  showSaveButton,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const setValue = useCallback66((val) => {
    onChange((oldV) => [
      ...oldV.slice(0, index),
      typeof val === "function" ? val(oldV[index]) : val,
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onChange]);
  const newJsonPath = useMemo76(() => [...jsonPath, index], [index, jsonPath]);
  const onSave = useCallback66((updater) => {
    onSaveObject((oldV) => [
      ...oldV.slice(0, index),
      updater(oldV[index]),
      ...oldV.slice(index + 1)
    ], false, false);
  }, [index, onSaveObject]);
  return /* @__PURE__ */ jsx136("div", {
    children: /* @__PURE__ */ jsx136(ZodSwitch, {
      jsonPath: newJsonPath,
      schema: tupleItems[index],
      value,
      setValue,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove: null,
      saving,
      saveDisabledByParent,
      mayPad
    })
  });
};

// src/components/RenderModal/SchemaEditor/ZodTupleEditor.tsx
import { jsx as jsx137, jsxs as jsxs70 } from "react/jsx-runtime";
var ZodTupleEditor = ({
  schema,
  jsonPath,
  setValue,
  defaultValue,
  value,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    unsavedValue: value,
    schema,
    setValue,
    savedValue: defaultValue
  });
  const [expanded, setExpanded] = useState50(true);
  const tupleItems = getTupleItems(schema);
  const suffix2 = useMemo77(() => {
    return expanded ? " [" : " [...] ";
  }, [expanded]);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const isDefaultValue = useMemo77(() => {
    return deepEqual(localValue.value, defaultValue);
  }, [defaultValue, localValue]);
  return /* @__PURE__ */ jsxs70(Fieldset, {
    shouldPad: mayPad,
    success: localValue.zodValidation.success,
    children: [
      /* @__PURE__ */ jsx137("div", {
        style: {
          display: "flex",
          flexDirection: "row"
        },
        children: /* @__PURE__ */ jsx137(SchemaLabel, {
          onReset: reset,
          isDefaultValue,
          jsonPath,
          onRemove,
          suffix: suffix2,
          onSave: () => {
            onSave(() => localValue.value, false, false);
          },
          saveDisabledByParent,
          saving,
          showSaveButton,
          valid: localValue.zodValidation.success,
          handleClick: () => setExpanded(!expanded)
        })
      }),
      expanded ? /* @__PURE__ */ jsx137(RevisionContextProvider, {
        children: /* @__PURE__ */ jsxs70(SchemaVerticalGuide, {
          isRoot: false,
          children: [
            localValue.value.map((child, i) => {
              return /* @__PURE__ */ jsxs70(React92.Fragment, {
                children: [
                  /* @__PURE__ */ jsx137(ZodTupleItemEditor, {
                    onChange,
                    value: child,
                    tupleItems,
                    index: i,
                    jsonPath,
                    defaultValue: defaultValue?.[i] ?? createZodValues(tupleItems[i], z, zodTypes),
                    onSave,
                    showSaveButton,
                    saving,
                    saveDisabledByParent,
                    mayPad
                  }),
                  /* @__PURE__ */ jsx137(SchemaArrayItemSeparationLine, {
                    schema,
                    index: i,
                    onChange,
                    isLast: i === localValue.value.length - 1,
                    showAddButton: false
                  })
                ]
              }, `${i}${localValue.keyStabilityRevision}`);
            }),
            value.length === 0 ? /* @__PURE__ */ jsx137(SchemaArrayItemSeparationLine, {
              schema,
              index: 0,
              onChange,
              isLast: true,
              showAddButton: false
            }) : null
          ]
        })
      }) : null,
      /* @__PURE__ */ jsx137(ZodFieldValidation, {
        path: jsonPath,
        localValue
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/ZodUnionEditor.tsx
import { jsx as jsx138 } from "react/jsx-runtime";
var findNull = (value) => {
  const nullIndex = value.findIndex((v) => {
    const type = getZodSchemaType(v);
    return type === "null" || type === "undefined";
  });
  if (nullIndex === -1) {
    return null;
  }
  const nullishValue = getZodSchemaType(value[nullIndex]) === "null" ? null : undefined;
  const otherSchema = value[nullIndex === 0 ? 1 : 0];
  const otherType = getZodSchemaType(otherSchema);
  const otherSchemaIsAlsoNullish = otherType === "null" || otherType === "undefined";
  return {
    nullIndex,
    nullishValue,
    otherSchema,
    otherSchemaIsAlsoNullish
  };
};
var ZodUnionEditor = ({
  jsonPath,
  schema,
  setValue,
  onSave,
  defaultValue,
  value,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const options = getUnionOptions(schema);
  if (options.length > 2) {
    return /* @__PURE__ */ jsx138(ZonNonEditableValue, {
      jsonPath,
      label: "Union with more than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  if (options.length < 2) {
    return /* @__PURE__ */ jsx138(ZonNonEditableValue, {
      jsonPath,
      label: "Union with less than 2 options not editable",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const nullResult = findNull(options);
  if (!nullResult) {
    return /* @__PURE__ */ jsx138(ZonNonEditableValue, {
      jsonPath,
      label: "Union only editable with 1 value being null",
      showSaveButton,
      saving,
      mayPad
    });
  }
  const { otherSchema, nullishValue, otherSchemaIsAlsoNullish } = nullResult;
  if (otherSchemaIsAlsoNullish) {
    return /* @__PURE__ */ jsx138(ZonNonEditableValue, {
      jsonPath,
      label: "Not editable - both union values are nullish",
      showSaveButton,
      saving,
      mayPad
    });
  }
  return /* @__PURE__ */ jsx138(ZodOrNullishEditor, {
    defaultValue,
    jsonPath,
    onRemove,
    onSave,
    schema,
    innerSchema: otherSchema,
    setValue,
    showSaveButton,
    value,
    nullishValue,
    saving,
    saveDisabledByParent,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodSwitch.tsx
import { jsx as jsx139 } from "react/jsx-runtime";
var ZodSwitch = ({
  schema,
  jsonPath,
  value,
  setValue,
  defaultValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad
}) => {
  const typeName = getZodSchemaType(schema);
  const description = getZodSchemaDescription(schema);
  const zodTypes = useZodTypesIfPossible();
  if (typeName === "object") {
    return /* @__PURE__ */ jsx139(ZodObjectEditor, {
      setValue,
      unsavedValue: value,
      savedValue: defaultValue,
      jsonPath,
      schema,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      discriminatedUnionReplacement: null
    });
  }
  if (typeName === "string") {
    if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
      return /* @__PURE__ */ jsx139(ZodColorEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (value.startsWith(window.remotion_staticBase)) {
      return /* @__PURE__ */ jsx139(ZodStaticFileEditor, {
        setValue,
        value,
        jsonPath,
        schema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_TEXTAREA_BRAND) {
      return /* @__PURE__ */ jsx139(ZodTextareaEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return /* @__PURE__ */ jsx139(ZodStringEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "date") {
    return /* @__PURE__ */ jsx139(ZodDateEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      onSave,
      defaultValue,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "number") {
    return /* @__PURE__ */ jsx139(ZodNumberEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "boolean") {
    return /* @__PURE__ */ jsx139(ZodBooleanEditor, {
      value,
      setValue,
      jsonPath,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad,
      schema
    });
  }
  if (typeName === "undefined") {
    return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "undefined",
      saving,
      mayPad
    });
  }
  if (typeName === "null") {
    return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "null",
      saving,
      mayPad
    });
  }
  if (typeName === "any") {
    return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "any (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === "bigint") {
    return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "BigInt (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === "unknown") {
    return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
      jsonPath,
      showSaveButton,
      label: "unknown (not editable)",
      saving,
      mayPad
    });
  }
  if (typeName === "array") {
    if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
      return /* @__PURE__ */ jsx139(ZodMatrixEditor, {
        setValue,
        value,
        jsonPath,
        schema,
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return /* @__PURE__ */ jsx139(ZodArrayEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "enum") {
    return /* @__PURE__ */ jsx139(ZodEnumEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving
    });
  }
  if (typeName === "effects") {
    if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_COLOR_BRAND) {
      return /* @__PURE__ */ jsx139(ZodColorEditor, {
        value,
        setValue,
        jsonPath,
        schema,
        onSave,
        defaultValue,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    if (zodTypes && description === zodTypes.ZodZypesInternals.REMOTION_MATRIX_BRAND) {
      return /* @__PURE__ */ jsx139(ZodMatrixEditor, {
        setValue,
        value,
        jsonPath,
        schema: getEffectsInner(schema),
        defaultValue,
        onSave,
        showSaveButton,
        onRemove,
        saving,
        saveDisabledByParent,
        mayPad
      });
    }
    return /* @__PURE__ */ jsx139(ZodEffectEditor, {
      value,
      setValue,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      mayPad
    });
  }
  if (typeName === "union") {
    return /* @__PURE__ */ jsx139(ZodUnionEditor, {
      schema,
      showSaveButton,
      jsonPath,
      value,
      defaultValue,
      setValue,
      onSave,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "optional") {
    return /* @__PURE__ */ jsx139(ZodOptionalEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "nullable") {
    return /* @__PURE__ */ jsx139(ZodNullableEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "default") {
    return /* @__PURE__ */ jsx139(ZodDefaultEditor, {
      jsonPath,
      showSaveButton,
      defaultValue,
      value,
      setValue,
      onSave,
      onRemove,
      schema,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  if (typeName === "discriminatedUnion") {
    return /* @__PURE__ */ jsx139(ZodDiscriminatedUnionEditor, {
      defaultValue,
      mayPad,
      schema,
      setValue,
      value,
      jsonPath,
      onRemove,
      onSave,
      saving,
      saveDisabledByParent,
      showSaveButton
    });
  }
  if (typeName === "tuple") {
    return /* @__PURE__ */ jsx139(ZodTupleEditor, {
      setValue,
      value,
      jsonPath,
      schema,
      defaultValue,
      onSave,
      showSaveButton,
      onRemove,
      saving,
      saveDisabledByParent,
      mayPad
    });
  }
  return /* @__PURE__ */ jsx139(ZonNonEditableValue, {
    jsonPath,
    showSaveButton,
    label: `${typeName} (not editable)`,
    saving,
    mayPad
  });
};

// src/components/RenderModal/SchemaEditor/ZodObjectEditor.tsx
import { jsx as jsx140, jsxs as jsxs71 } from "react/jsx-runtime";
var ZodObjectEditor = ({
  schema,
  jsonPath,
  setValue,
  unsavedValue,
  savedValue,
  onSave,
  showSaveButton,
  onRemove,
  saving,
  saveDisabledByParent,
  mayPad,
  discriminatedUnionReplacement
}) => {
  const [expanded, setExpanded] = useState51(true);
  const { localValue, onChange, RevisionContextProvider, reset } = useLocalState({
    schema,
    setValue,
    unsavedValue,
    savedValue
  });
  const typeName = getZodSchemaType(schema);
  if (typeName !== "object") {
    throw new Error("expected object");
  }
  const shape = getObjectShape(schema);
  const keys = Object.keys(shape);
  const isRoot = jsonPath.length === 0;
  const isDefaultValue = useMemo78(() => {
    return deepEqual(localValue.value, savedValue);
  }, [savedValue, localValue]);
  const suffix2 = useMemo78(() => {
    return expanded ? " {" : " {...}";
  }, [expanded]);
  return /* @__PURE__ */ jsxs71(Fieldset, {
    shouldPad: !isRoot && mayPad,
    success: localValue.zodValidation.success,
    children: [
      isRoot ? null : /* @__PURE__ */ jsx140(SchemaLabel, {
        isDefaultValue,
        onReset: reset,
        jsonPath,
        onRemove,
        suffix: suffix2,
        onSave: () => {
          onSave(() => {
            return localValue.value;
          }, false, false);
        },
        saveDisabledByParent,
        saving,
        showSaveButton,
        valid: localValue.zodValidation.success,
        handleClick: () => setExpanded(!expanded)
      }),
      expanded ? /* @__PURE__ */ jsx140(RevisionContextProvider, {
        children: /* @__PURE__ */ jsx140(SchemaVerticalGuide, {
          isRoot,
          children: keys.map((key, i) => {
            if (discriminatedUnionReplacement && key === discriminatedUnionReplacement.discriminator) {
              return discriminatedUnionReplacement.markup;
            }
            return /* @__PURE__ */ jsxs71(React93.Fragment, {
              children: [
                /* @__PURE__ */ jsx140(ZodSwitch, {
                  mayPad: true,
                  jsonPath: [...jsonPath, key],
                  schema: shape[key],
                  value: localValue.value[key],
                  defaultValue: (savedValue ?? unsavedValue)[key],
                  setValue: (val, forceApply) => {
                    onChange((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onSave: (val, forceApply) => {
                    onSave((oldVal) => {
                      return {
                        ...oldVal,
                        [key]: typeof val === "function" ? val(oldVal[key]) : val
                      };
                    }, forceApply, false);
                  },
                  onRemove: null,
                  showSaveButton,
                  saving,
                  saveDisabledByParent
                }),
                i === keys.length - 1 ? null : /* @__PURE__ */ jsx140(SchemaSeparationLine, {})
              ]
            }, key);
          })
        })
      }) : null,
      isRoot || !expanded ? null : /* @__PURE__ */ jsx140("div", {
        style: fieldsetLabel,
        children: "}"
      })
    ]
  });
};

// src/components/RenderModal/SchemaEditor/SchemaEditor.tsx
import { jsx as jsx141 } from "react/jsx-runtime";
var scrollable2 = {
  display: "flex",
  flexDirection: "column",
  overflowY: "auto"
};
var SchemaEditor = ({
  schema,
  unsavedDefaultProps,
  setValue,
  zodValidationResult,
  savedDefaultProps,
  onSave,
  showSaveButton,
  saving,
  saveDisabledByParent
}) => {
  const keybindings = useKeybinding();
  const [revision, setRevision] = useState52(0);
  const revisionState = useMemo79(() => {
    return {
      childResetRevision: revision
    };
  }, [revision]);
  useEffect47(() => {
    const bumpRevision = () => {
      setRevision((old) => old + 1);
    };
    window.addEventListener(Internals32.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    return () => {
      window.removeEventListener(Internals32.PROPS_UPDATED_EXTERNALLY, bumpRevision);
    };
  }, []);
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const hasChanged = useMemo79(() => {
    return !deepEqual(savedDefaultProps, unsavedDefaultProps);
  }, [savedDefaultProps, unsavedDefaultProps]);
  useEffect47(() => {
    setUnsavedProps(hasChanged);
  }, [hasChanged]);
  const onQuickSave = useCallback67(() => {
    if (hasChanged && showSaveButton) {
      onSave(() => {
        return unsavedDefaultProps;
      });
    }
  }, [hasChanged, onSave, showSaveButton, unsavedDefaultProps]);
  useEffect47(() => {
    const save = keybindings.registerKeybinding({
      event: "keydown",
      key: "s",
      commandCtrlKey: true,
      callback: onQuickSave,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true
    });
    return () => {
      save.unregister();
    };
  }, [keybindings, onQuickSave, onSave]);
  const typeName = getZodSchemaType(schema);
  const reset = useCallback67(() => {
    setValue(savedDefaultProps);
  }, [savedDefaultProps, setValue]);
  if (!zodValidationResult.success) {
    const defaultPropsValid = zodSafeParse(schema, savedDefaultProps);
    if (!defaultPropsValid.success) {
      return /* @__PURE__ */ jsx141(InvalidDefaultProps, {
        zodValidationResult
      });
    }
    return /* @__PURE__ */ jsx141(InvalidSchema, {
      reset,
      zodValidationResult
    });
  }
  if (typeName !== "object") {
    return /* @__PURE__ */ jsx141(TopLevelZodValue, {
      typeReceived: typeName
    });
  }
  return /* @__PURE__ */ jsx141("div", {
    ref: defaultPropsEditorScrollableAreaRef,
    style: scrollable2,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx141(RevisionContext.Provider, {
      value: revisionState,
      children: /* @__PURE__ */ jsx141(ZodObjectEditor, {
        discriminatedUnionReplacement: null,
        unsavedValue: unsavedDefaultProps,
        setValue,
        jsonPath: [],
        schema,
        savedValue: savedDefaultProps,
        onSave,
        showSaveButton,
        onRemove: null,
        saving,
        saveDisabledByParent,
        mayPad: true
      })
    })
  });
};

// src/components/RenderModal/WarningIndicatorButton.tsx
import { useCallback as useCallback68, useMemo as useMemo80 } from "react";
import { jsx as jsx142, jsxs as jsxs72 } from "react/jsx-runtime";
var style8 = {
  fontSize: 12,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "transparent",
  color: LIGHT_TEXT,
  borderStyle: "solid",
  borderWidth: 1,
  cursor: "pointer",
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 4,
  paddingBottom: 4
};
var triangleStyle2 = {
  width: 12,
  height: 12,
  flexShrink: 0,
  fill: WARNING_COLOR
};
var WarningTriangle2 = (props) => {
  return /* @__PURE__ */ jsx142("svg", {
    viewBox: "0 0 576 512",
    ...props,
    children: /* @__PURE__ */ jsx142("path", {
      d: "M248.747 204.705l6.588 112c.373 6.343 5.626 11.295 11.979 11.295h41.37a12 12 0 0 0 11.979-11.295l6.588-112c.405-6.893-5.075-12.705-11.979-12.705h-54.547c-6.903 0-12.383 5.812-11.978 12.705zM330 384c0 23.196-18.804 42-42 42s-42-18.804-42-42 18.804-42 42-42 42 18.804 42 42zm-.423-360.015c-18.433-31.951-64.687-32.009-83.154 0L6.477 440.013C-11.945 471.946 11.118 512 48.054 512H527.94c36.865 0 60.035-39.993 41.577-71.987L329.577 23.985zM53.191 455.002L282.803 57.008c2.309-4.002 8.085-4.002 10.394 0l229.612 397.993c2.308 4-.579 8.998-5.197 8.998H58.388c-4.617.001-7.504-4.997-5.197-8.997z"
    })
  });
};
var WarningIndicatorButton = ({ setShowWarning, showWarning, warningCount }) => {
  const onClick = useCallback68(() => {
    setShowWarning((s) => !s);
  }, [setShowWarning]);
  const buttonStyle3 = useMemo80(() => {
    return {
      ...style8,
      backgroundColor: showWarning ? INPUT_BACKGROUND : "transparent",
      borderColor: showWarning ? INPUT_BORDER_COLOR_HOVERED : INPUT_BORDER_COLOR_UNHOVERED,
      color: showWarning ? "white" : LIGHT_TEXT
    };
  }, [showWarning]);
  return /* @__PURE__ */ jsxs72("button", {
    type: "button",
    style: buttonStyle3,
    onClick,
    children: [
      /* @__PURE__ */ jsx142(WarningTriangle2, {
        style: triangleStyle2
      }),
      /* @__PURE__ */ jsx142(Spacing, {
        x: 0.5
      }),
      warningCount,
      /* @__PURE__ */ jsx142(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx142(AngleDown, {
        down: showWarning
      })
    ]
  });
};

// src/components/RenderModal/DataEditor.tsx
import { jsx as jsx143, jsxs as jsxs73 } from "react/jsx-runtime";
var errorExplanation2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer3 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center"
};
var outer = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflow: "hidden",
  backgroundColor: BACKGROUND
};
var controlContainer = {
  flexDirection: "column",
  display: "flex",
  padding: 12,
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var tabWrapper = {
  display: "flex",
  marginBottom: "4px",
  flexDirection: "row",
  alignItems: "center"
};
var persistanceKey = "remotion.show-render-modalwarning";
var getPersistedShowWarningState = () => {
  const val = localStorage.getItem(persistanceKey);
  if (!val) {
    return true;
  }
  return val === "true";
};
var setPersistedShowWarningState = (val) => {
  localStorage.setItem(persistanceKey, String(Boolean(val)));
};
var DataEditor = ({
  unresolvedComposition,
  defaultProps,
  setDefaultProps,
  mayShowSaveButton,
  propsEditType,
  saving,
  setSaving,
  readOnlyStudio
}) => {
  const [mode, setMode] = useState53("schema");
  const [showWarning, setShowWarningWithoutPersistance] = useState53(() => getPersistedShowWarningState());
  const { updateCompositionDefaultProps } = useContext38(Internals33.CompositionSetters);
  const inJSONEditor = mode === "json";
  const serializedJSON = useMemo81(() => {
    if (!inJSONEditor) {
      return null;
    }
    const value = defaultProps;
    return NoReactInternals10.serializeJSONWithSpecialTypes({
      data: value,
      indent: 2,
      staticBase: window.remotion_staticBase
    });
  }, [inJSONEditor, defaultProps]);
  const cliProps = getInputProps();
  const [canSaveDefaultPropsObjectState, setCanSaveDefaultProps] = useState53({
    [unresolvedComposition.id]: defaultTypeCanSaveState
  });
  const z = useZodIfPossible();
  const zodTypes = useZodTypesIfPossible();
  const schema = useMemo81(() => {
    if (!z) {
      return "no-zod";
    }
    if (!unresolvedComposition.schema) {
      return "no-schema";
    }
    if (!(typeof unresolvedComposition.schema.safeParse === "function")) {
      throw new Error("A value which is not a Zod schema was passed to `schema`");
    }
    return unresolvedComposition.schema;
  }, [unresolvedComposition.schema, z]);
  const zodValidationResult = useMemo81(() => {
    if (schema === "no-zod") {
      return "no-zod";
    }
    if (schema === "no-schema") {
      return "no-schema";
    }
    return zodSafeParse(schema, defaultProps);
  }, [defaultProps, schema]);
  const setShowWarning = useCallback69((val) => {
    setShowWarningWithoutPersistance((prevVal) => {
      if (typeof val === "boolean") {
        setPersistedShowWarningState(val);
        return val;
      }
      setPersistedShowWarningState(val(prevVal));
      return val(prevVal);
    });
  }, []);
  const canSaveDefaultProps = useMemo81(() => {
    return canSaveDefaultPropsObjectState[unresolvedComposition.id] ? canSaveDefaultPropsObjectState[unresolvedComposition.id] : defaultTypeCanSaveState;
  }, [canSaveDefaultPropsObjectState, unresolvedComposition.id]);
  const showSaveButton = mayShowSaveButton && canSaveDefaultProps.canUpdate;
  const { fastRefreshes } = useContext38(FastRefreshContext);
  const checkIfCanSaveDefaultProps = useCallback69(async () => {
    try {
      const can = await canUpdateDefaultProps(unresolvedComposition.id, readOnlyStudio);
      if (can.canUpdate) {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: true
          }
        }));
      } else {
        setCanSaveDefaultProps((prevState) => ({
          ...prevState,
          [unresolvedComposition.id]: {
            canUpdate: false,
            reason: can.reason,
            determined: true
          }
        }));
      }
    } catch (err) {
      setCanSaveDefaultProps((prevState) => ({
        ...prevState,
        [unresolvedComposition.id]: {
          canUpdate: false,
          reason: err.message,
          determined: true
        }
      }));
    }
  }, [readOnlyStudio, unresolvedComposition.id]);
  useEffect48(() => {
    checkIfCanSaveDefaultProps();
  }, [checkIfCanSaveDefaultProps]);
  const { previewServerState, subscribeToEvent } = useContext38(StudioServerConnectionCtx);
  useEffect48(() => {
    const unsub = subscribeToEvent("root-file-changed", checkIfCanSaveDefaultProps);
    return () => {
      unsub();
    };
  }, [checkIfCanSaveDefaultProps, subscribeToEvent]);
  const modeItems = useMemo81(() => {
    return [
      {
        key: "schema",
        label: "Schema",
        onClick: () => {
          setMode("schema");
        },
        selected: mode === "schema"
      },
      {
        key: "json",
        label: "JSON",
        onClick: () => {
          setMode("json");
        },
        selected: mode === "json"
      }
    ];
  }, [mode]);
  const onUpdate = useCallback69(() => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    callUpdateDefaultPropsApi(unresolvedComposition.id, defaultProps, extractEnumJsonPaths({ schema, zodRuntime: z, currentPath: [], zodTypes })).then((response) => {
      if (!response.success) {
        showNotification(`Cannot update default props: ${response.reason}`, 2000);
      }
    });
  }, [schema, z, unresolvedComposition.id, defaultProps, zodTypes]);
  const onSave = useCallback69((updater) => {
    if (schema === "no-zod" || schema === "no-schema" || z === null) {
      showNotification("Cannot update default props: No Zod schema", 2000);
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    setSaving(true);
    const newDefaultProps = updater(unresolvedComposition.defaultProps ?? {});
    callUpdateDefaultPropsApi(unresolvedComposition.id, newDefaultProps, extractEnumJsonPaths({
      schema,
      zodRuntime: z,
      currentPath: [],
      zodTypes
    })).then((response) => {
      if (!response.success) {
        console.log(response.stack);
        showNotification(`Cannot update default props: ${response.reason}. See console for more information.`, 2000);
      }
      updateCompositionDefaultProps(unresolvedComposition.id, newDefaultProps);
    }).catch((err) => {
      showNotification(`Cannot update default props: ${err.message}`, 2000);
    }).finally(() => {
      setSaving(false);
    });
  }, [
    schema,
    z,
    zodTypes,
    fastRefreshes,
    setSaving,
    unresolvedComposition.defaultProps,
    unresolvedComposition.id,
    updateCompositionDefaultProps
  ]);
  const connectionStatus = previewServerState.type;
  const warnings = useMemo81(() => {
    return getRenderModalWarnings({
      canSaveDefaultProps,
      cliProps,
      isCustomDateUsed: serializedJSON ? serializedJSON.customDateUsed : false,
      customFileUsed: serializedJSON ? serializedJSON.customFileUsed : false,
      inJSONEditor,
      propsEditType,
      jsMapUsed: serializedJSON ? serializedJSON.mapUsed : false,
      jsSetUsed: serializedJSON ? serializedJSON.setUsed : false
    });
  }, [
    cliProps,
    canSaveDefaultProps,
    inJSONEditor,
    propsEditType,
    serializedJSON
  ]);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ jsxs73("div", {
      style: explainer3,
      children: [
        /* @__PURE__ */ jsx143(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx143("div", {
          style: errorExplanation2,
          children: "The studio server has disconnected. Reconnect to edit the schema."
        }),
        /* @__PURE__ */ jsx143(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (schema === "no-zod") {
    return /* @__PURE__ */ jsx143(ZodNotInstalled, {});
  }
  if (schema === "no-schema") {
    return /* @__PURE__ */ jsx143(NoSchemaDefined, {});
  }
  if (!z) {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-zod") {
    throw new Error("expected zod");
  }
  if (zodValidationResult === "no-schema") {
    throw new Error("expected schema");
  }
  const typeName = getZodSchemaType(schema);
  if (typeName === "any") {
    return /* @__PURE__ */ jsx143(NoSchemaDefined, {});
  }
  if (!unresolvedComposition.defaultProps) {
    return /* @__PURE__ */ jsx143(NoDefaultProps, {});
  }
  return /* @__PURE__ */ jsxs73("div", {
    style: outer,
    children: [
      /* @__PURE__ */ jsxs73("div", {
        style: controlContainer,
        children: [
          /* @__PURE__ */ jsxs73("div", {
            style: tabWrapper,
            children: [
              /* @__PURE__ */ jsx143(SegmentedControl, {
                items: modeItems,
                needsWrapping: false
              }),
              /* @__PURE__ */ jsx143(Flex, {}),
              warnings.length > 0 ? /* @__PURE__ */ jsx143(WarningIndicatorButton, {
                setShowWarning,
                showWarning,
                warningCount: warnings.length
              }) : null
            ]
          }),
          showWarning && warnings.length > 0 ? warnings.map((warning) => /* @__PURE__ */ jsxs73(React96.Fragment, {
            children: [
              /* @__PURE__ */ jsx143(Spacing, {
                y: 1
              }),
              /* @__PURE__ */ jsx143(ValidationMessage, {
                message: warning,
                align: "flex-start",
                type: "warning"
              })
            ]
          }, warning)) : null
        ]
      }),
      mode === "schema" ? /* @__PURE__ */ jsx143(SchemaEditor, {
        unsavedDefaultProps: defaultProps,
        setValue: setDefaultProps,
        schema,
        zodValidationResult,
        savedDefaultProps: unresolvedComposition.defaultProps,
        onSave,
        showSaveButton,
        saving,
        saveDisabledByParent: !zodValidationResult.success
      }) : /* @__PURE__ */ jsx143(RenderModalJSONPropsEditor, {
        value: defaultProps ?? {},
        setValue: setDefaultProps,
        onSave: onUpdate,
        showSaveButton,
        serializedJSON,
        defaultProps: unresolvedComposition.defaultProps,
        schema
      })
    ]
  });
};

// src/components/RenderQueue/index.tsx
import React107, { useContext as useContext47, useEffect as useEffect51, useMemo as useMemo89 } from "react";
import { Internals as Internals36 } from "remotion";

// src/components/RenderQueue/RenderQueueItem.tsx
import {
  useCallback as useCallback80,
  useContext as useContext46,
  useEffect as useEffect50,
  useMemo as useMemo88,
  useState as useState54
} from "react";
import { Internals as Internals35 } from "remotion";

// src/components/RenderQueue/client-side-render-types.ts
var isRestoredClientJob = (job) => {
  return !("inputProps" in job);
};

// src/components/RenderQueue/item-style.ts
var renderQueueItemSubtitleStyle = {
  fontSize: 13,
  color: LIGHT_TEXT,
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  lineHeight: 1.2,
  textAlign: "left",
  whiteSpace: "nowrap",
  marginRight: SPACING_UNIT,
  overflowX: "hidden",
  maxWidth: 500,
  textOverflow: "ellipsis"
};

// src/components/RenderQueue/RenderQueueCancelledMessage.tsx
import { jsx as jsx144 } from "react/jsx-runtime";
var cancelledStyle = {
  ...renderQueueItemSubtitleStyle,
  color: LIGHT_TEXT,
  cursor: "default"
};
var RenderQueueCancelledMessage = () => {
  return /* @__PURE__ */ jsx144("span", {
    style: cancelledStyle,
    children: "Cancelled"
  });
};

// src/components/RenderQueue/RenderQueueCopyToClipboard.tsx
import { useCallback as useCallback70 } from "react";
import { jsx as jsx145 } from "react/jsx-runtime";
var revealIconStyle2 = {
  height: 12,
  color: "currentColor"
};
var supportsCopyingToClipboard = (job) => {
  if (job.status !== "done") {
    return false;
  }
  if (job.type !== "still") {
    return false;
  }
  if (job.imageFormat === "png") {
    return true;
  }
  if (job.imageFormat === "jpeg") {
    return true;
  }
  return false;
};
var RenderQueueCopyToClipboard = ({ job }) => {
  const renderCopyAction = useCallback70((color) => {
    return /* @__PURE__ */ jsx145(ClipboardIcon, {
      style: revealIconStyle2,
      color
    });
  }, []);
  const onClick = useCallback70(async (e) => {
    e.stopPropagation();
    try {
      const src = `${remotion_outputsBase}/${job.outName}`;
      const content = await fetch(src);
      const contentType = content.headers.get("content-type");
      if (!contentType) {
        throw new Error("Expected content-type header");
      }
      const blob = await content.blob();
      await navigator.clipboard.write([
        new ClipboardItem({
          [contentType]: blob
        })
      ]);
      showNotification("Copied to clipboard!", 1000);
    } catch (err) {
      showNotification(`Could not copy to clipboard: ${err.message}`, 2000);
    }
  }, [job.outName]);
  return /* @__PURE__ */ jsx145(InlineAction, {
    title: "Copy to clipboard",
    renderAction: renderCopyAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueDownloadItem.tsx
import { useCallback as useCallback72, useMemo as useMemo82 } from "react";

// src/components/RenderQueue/ClientRenderQueueProcessor.tsx
import { renderMediaOnWeb, renderStillOnWeb } from "@remotion/web-renderer";
import { useCallback as useCallback71, useContext as useContext39, useEffect as useEffect49 } from "react";

// src/api/save-render-output.ts
var throwIfNotOk = async (response) => {
  if (!response.ok) {
    try {
      const jsonResponse = await response.json();
      throw new Error(jsonResponse.error);
    } catch (parseError2) {
      if (parseError2 instanceof Error && parseError2.message) {
        throw parseError2;
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  }
};
var saveOutputFile = async ({
  blob,
  filePath
}) => {
  const url = new URL("/api/upload-output", window.location.origin);
  url.search = new URLSearchParams({ filePath }).toString();
  const response = await fetch(url, {
    method: "POST",
    body: blob
  });
  await throwIfNotOk(response);
};
var registerClientRender = async (render) => {
  const response = await fetch("/api/register-client-render", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(render)
  });
  await throwIfNotOk(response);
};
var unregisterClientRender = async (id) => {
  const response = await fetch("/api/unregister-client-render", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id })
  });
  await throwIfNotOk(response);
};

// src/components/RenderQueue/ClientRenderQueueProcessor.tsx
var downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const cleanFilename = filename.includes("/") ? filename.substring(filename.lastIndexOf("/") + 1) : filename;
  a.download = cleanFilename;
  a.click();
  URL.revokeObjectURL(url);
};
var ClientRenderQueueProcessor = () => {
  const {
    getAbortController: getAbortController2,
    getCompositionForJob: getCompositionForJob2,
    updateClientJobProgress,
    markClientJobSaving,
    markClientJobDone,
    markClientJobFailed,
    markClientJobCancelled,
    setProcessJobCallback
  } = useContext39(RenderQueueContext);
  const processStillJob = useCallback71(async (job, signal) => {
    const compositionRef = getCompositionForJob2(job.id);
    if (!compositionRef) {
      throw new Error(`Composition not found for job ${job.id}`);
    }
    const { blob } = await renderStillOnWeb({
      composition: {
        component: compositionRef.component,
        width: compositionRef.width,
        height: compositionRef.height,
        fps: compositionRef.fps,
        durationInFrames: compositionRef.durationInFrames,
        defaultProps: compositionRef.defaultProps,
        calculateMetadata: compositionRef.calculateMetadata ?? undefined,
        id: job.compositionId
      },
      frame: job.frame,
      imageFormat: job.imageFormat,
      inputProps: job.inputProps,
      delayRenderTimeoutInMilliseconds: job.delayRenderTimeout,
      mediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
      logLevel: job.logLevel,
      licenseKey: job.licenseKey ?? undefined,
      scale: job.scale,
      signal
    });
    return {
      getBlob: () => Promise.resolve(blob),
      width: compositionRef.width,
      height: compositionRef.height
    };
  }, [getCompositionForJob2]);
  const processVideoJob = useCallback71(async (job, signal, onProgress) => {
    const compositionRef = getCompositionForJob2(job.id);
    if (!compositionRef) {
      throw new Error(`Composition not found for job ${job.id}`);
    }
    const totalFrames = job.endFrame - job.startFrame + 1;
    const { getBlob } = await renderMediaOnWeb({
      composition: {
        component: compositionRef.component,
        width: compositionRef.width,
        height: compositionRef.height,
        fps: compositionRef.fps,
        durationInFrames: compositionRef.durationInFrames,
        defaultProps: compositionRef.defaultProps,
        calculateMetadata: compositionRef.calculateMetadata ?? undefined,
        id: job.compositionId
      },
      inputProps: job.inputProps,
      delayRenderTimeoutInMilliseconds: job.delayRenderTimeout,
      mediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
      logLevel: job.logLevel,
      videoCodec: job.videoCodec ?? undefined,
      audioCodec: job.audioCodec,
      audioBitrate: job.audioBitrate,
      container: job.container,
      videoBitrate: job.videoBitrate,
      hardwareAcceleration: job.hardwareAcceleration,
      keyframeIntervalInSeconds: job.keyframeIntervalInSeconds,
      frameRange: [job.startFrame, job.endFrame],
      transparent: job.transparent,
      muted: job.muted,
      scale: job.scale,
      signal,
      onProgress: (progress) => {
        onProgress(job.id, {
          encodedFrames: progress.encodedFrames,
          totalFrames,
          doneIn: progress.doneIn,
          renderEstimatedTime: progress.renderEstimatedTime,
          progress: progress.progress
        });
      },
      outputTarget: "web-fs",
      licenseKey: job.licenseKey ?? undefined
    });
    return {
      getBlob,
      width: compositionRef.width,
      height: compositionRef.height
    };
  }, [getCompositionForJob2]);
  const processJob = useCallback71(async (job) => {
    const abortController = getAbortController2(job.id);
    try {
      let result;
      if (job.type === "client-still") {
        result = await processStillJob(job, abortController.signal);
      } else if (job.type === "client-video") {
        result = await processVideoJob(job, abortController.signal, updateClientJobProgress);
      } else {
        throw new Error(`Unknown job type`);
      }
      const blob = await result.getBlob();
      const metadata = {
        width: result.width,
        height: result.height,
        sizeInBytes: blob.size
      };
      markClientJobSaving(job.id);
      const getBlob = () => Promise.resolve(blob);
      const downloadAndFinish = () => {
        downloadBlob(blob, job.outName);
        markClientJobDone(job.id, metadata, getBlob);
      };
      if (window.remotion_isReadOnlyStudio) {
        downloadAndFinish();
      } else {
        try {
          await saveOutputFile({ blob, filePath: job.outName });
          await registerClientRender({
            id: job.id,
            type: job.type,
            compositionId: job.compositionId,
            outName: job.outName,
            startedAt: job.startedAt,
            deletedOutputLocation: false,
            metadata
          });
          markClientJobDone(job.id, metadata);
        } catch (err) {
          console.error("Failed to save render output, falling back to browser download.", err);
          downloadAndFinish();
        }
      }
    } catch (err) {
      if (abortController.signal.aborted) {
        markClientJobCancelled(job.id);
      } else {
        markClientJobFailed(job.id, err);
      }
    }
  }, [
    getAbortController2,
    processStillJob,
    processVideoJob,
    updateClientJobProgress,
    markClientJobSaving,
    markClientJobDone,
    markClientJobFailed,
    markClientJobCancelled
  ]);
  useEffect49(() => {
    setProcessJobCallback(processJob);
    return () => setProcessJobCallback(null);
  }, [processJob, setProcessJobCallback]);
  return null;
};

// src/components/RenderQueue/RenderQueueDownloadItem.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
var RenderQueueDownloadItem = ({ job }) => {
  const onClick = useCallback72((e) => {
    e.stopPropagation();
    if (job.status !== "done" || !job.getBlob) {
      return;
    }
    job.getBlob().then((blob) => {
      downloadBlob(blob, job.outName);
    }).catch((err) => {
      showNotification(`Could not download file: ${err.message}`, 2000);
    });
  }, [job]);
  const icon5 = useMemo82(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback72((color) => {
    return /* @__PURE__ */ jsx146("svg", {
      style: icon5,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx146("path", {
        fill: color,
        d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx146(InlineAction, {
    renderAction,
    onClick,
    title: "Download"
  });
};

// src/components/RenderQueue/RenderQueueError.tsx
import { useCallback as useCallback73, useContext as useContext40 } from "react";
import { jsx as jsx147 } from "react/jsx-runtime";
var outputLocation = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueError = ({ job }) => {
  const { setSelectedModal } = useContext40(ModalsContext);
  const { tabIndex } = useZIndex();
  const onClick = useCallback73(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status !== "failed") {
    throw new Error("should not have rendered this component");
  }
  return /* @__PURE__ */ jsx147("button", {
    onClick,
    type: "button",
    style: outputLocation,
    tabIndex,
    title: job.error.message,
    children: job.error.message
  });
};

// src/components/RenderQueue/RenderQueueItemCancelButton.tsx
import { useCallback as useCallback74, useContext as useContext41, useMemo as useMemo83 } from "react";
import { jsx as jsx148 } from "react/jsx-runtime";
var RenderQueueCancelButton = ({ job }) => {
  const isClientJob = isClientRenderJob(job);
  const { cancelClientJob } = useContext41(RenderQueueContext);
  const onClick = useCallback74((e) => {
    e.stopPropagation();
    if (isClientJob) {
      cancelClientJob(job.id);
      return;
    }
    cancelRenderJob(job).catch((err) => {
      showNotification(`Could not cancel job: ${err.message}`, 2000);
    });
  }, [job, isClientJob, cancelClientJob]);
  const icon5 = useMemo83(() => {
    return {
      height: 14,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback74((color) => {
    return /* @__PURE__ */ jsx148("svg", {
      style: icon5,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx148("path", {
        fill: color,
        d: "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx148(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import React100, { useCallback as useCallback75, useContext as useContext42 } from "react";

// src/components/RenderQueue/CircularProgress.tsx
import { jsx as jsx149 } from "react/jsx-runtime";
var RENDER_STATUS_INDICATOR_SIZE = 16;
var STROKE_WIDTH = 3;
var container31 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE,
  transform: `rotate(-90deg)`
};
var CircularProgress = ({ progress }) => {
  const r = RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH;
  const circumference = r * Math.PI * 2;
  return /* @__PURE__ */ jsx149("svg", {
    style: container31,
    viewBox: `0 0 ${RENDER_STATUS_INDICATOR_SIZE} ${RENDER_STATUS_INDICATOR_SIZE}`,
    children: /* @__PURE__ */ jsx149("circle", {
      r: RENDER_STATUS_INDICATOR_SIZE / 2 - STROKE_WIDTH,
      stroke: LIGHT_TEXT,
      fill: "none",
      strokeWidth: STROKE_WIDTH,
      cx: RENDER_STATUS_INDICATOR_SIZE / 2,
      cy: RENDER_STATUS_INDICATOR_SIZE / 2,
      strokeDasharray: `${circumference} ${circumference}`,
      strokeMiterlimit: 0,
      strokeDashoffset: (1 - progress) * circumference
    })
  });
};

// src/components/RenderQueue/RenderQueueItemStatus.tsx
import { jsx as jsx150 } from "react/jsx-runtime";
var iconStyle3 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var invisibleStyle = {
  appearance: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  display: "flex"
};
var RenderQueueItemStatus = ({ job }) => {
  const { setSelectedModal } = useContext42(ModalsContext);
  const [hovered, setHovered] = React100.useState(false);
  const isClientJob = isClientRenderJob(job);
  const onPointerEnter = useCallback75(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback75(() => {
    setHovered(false);
  }, []);
  const onClick = useCallback75((e) => {
    e.stopPropagation();
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  if (job.status === "failed") {
    return /* @__PURE__ */ jsx150("button", {
      type: "button",
      style: invisibleStyle,
      onClick,
      children: /* @__PURE__ */ jsx150("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: /* @__PURE__ */ jsx150("path", {
          fill: FAIL_COLOR,
          d: "M0 160V352L160 512H352L512 352V160L352 0H160L0 160zm353.9 32l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"
        })
      })
    });
  }
  if (job.status === "idle") {
    return /* @__PURE__ */ jsx150("svg", {
      style: iconStyle3,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx150("path", {
        fill: LIGHT_TEXT,
        d: "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
      })
    });
  }
  if (job.status === "done") {
    return /* @__PURE__ */ jsx150("button", {
      type: "button",
      style: invisibleStyle,
      onPointerEnter,
      onPointerLeave,
      onClick,
      children: /* @__PURE__ */ jsx150("svg", {
        style: iconStyle3,
        viewBox: "0 0 512 512",
        children: /* @__PURE__ */ jsx150("path", {
          fill: hovered ? "white" : LIGHT_TEXT,
          d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
        })
      })
    });
  }
  if (job.status === "running") {
    let progressValue;
    if (isClientJob) {
      progressValue = job.progress.progress;
    } else {
      progressValue = job.progress.value;
    }
    return /* @__PURE__ */ jsx150("button", {
      type: "button",
      style: invisibleStyle,
      onClick,
      children: /* @__PURE__ */ jsx150(CircularProgress, {
        progress: Math.max(0.07, progressValue)
      })
    });
  }
  if (job.status === "saving") {
    return /* @__PURE__ */ jsx150("button", {
      type: "button",
      style: invisibleStyle,
      onClick,
      children: /* @__PURE__ */ jsx150(CircularProgress, {
        progress: 0.95
      })
    });
  }
  if (job.status === "cancelled") {
    return /* @__PURE__ */ jsx150("svg", {
      style: iconStyle3,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx150("path", {
        fill: FAIL_COLOR,
        d: "M0 160V352L160 512H352L512 352V160L352 0H160L0 160zm353.9 32l-17 17-47 47 47 47 17 17L320 353.9l-17-17-47-47-47 47-17 17L158.1 320l17-17 47-47-47-47-17-17L192 158.1l17 17 47 47 47-47 17-17L353.9 192z"
      })
    });
  }
  throw new Error("Unknown job status");
};

// src/components/RenderQueue/RenderQueueOpenInFolder.tsx
import { useCallback as useCallback76, useMemo as useMemo84 } from "react";
import { jsx as jsx151 } from "react/jsx-runtime";
var RenderQueueOpenInFinderItem = ({ job }) => {
  const onClick = useCallback76((e) => {
    e.stopPropagation();
    openInFileExplorer({ directory: job.outName }).catch((err) => {
      showNotification(`Could not open file: ${err.message}`, 2000);
    });
  }, [job.outName]);
  const icon5 = useMemo84(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback76((color) => {
    return /* @__PURE__ */ jsx151(ExpandedFolderIconSolid, {
      style: icon5,
      color
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx151(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueOutputName.tsx
import { useMemo as useMemo85 } from "react";
import { jsx as jsx152 } from "react/jsx-runtime";
var RenderQueueOutputName = ({ job }) => {
  const deletedOutputLocation = "deletedOutputLocation" in job && job.deletedOutputLocation;
  const style9 = useMemo85(() => {
    return {
      ...renderQueueItemSubtitleStyle,
      textDecoration: deletedOutputLocation ? "line-through" : "none",
      color: renderQueueItemSubtitleStyle.color,
      cursor: "inherit"
    };
  }, [deletedOutputLocation]);
  const getTitle = () => {
    if (deletedOutputLocation) {
      return "File was deleted";
    }
    return job.outName;
  };
  return /* @__PURE__ */ jsx152("span", {
    style: style9,
    title: getTitle(),
    children: job.outName
  });
};

// src/components/RenderQueue/RenderQueueProgressMessage.tsx
import { useCallback as useCallback77, useContext as useContext43 } from "react";

// src/components/RenderQueue/client-render-progress.ts
var formatEtaString = (timeRemainingInMilliseconds) => {
  const remainingTime = timeRemainingInMilliseconds / 1000;
  const remainingTimeHours = Math.floor(remainingTime / 3600);
  const remainingTimeMinutes = Math.floor(remainingTime % 3600 / 60);
  const remainingTimeSeconds = Math.floor(remainingTime % 60);
  return [
    remainingTimeHours ? `${remainingTimeHours}h` : null,
    remainingTimeMinutes ? `${remainingTimeMinutes}m` : null,
    `${remainingTimeSeconds}s`
  ].filter((value) => Boolean(value)).join(" ");
};
var getClientRenderProgressMessage = (progress) => {
  if (progress.totalFrames === 0) {
    return "Getting composition";
  }
  if (progress.doneIn !== null) {
    return `Encoded ${progress.totalFrames}/${progress.totalFrames}`;
  }
  if (progress.renderEstimatedTime > 0) {
    const etaString = `, time remaining: ${formatEtaString(progress.renderEstimatedTime)}`;
    return `Rendering ${progress.encodedFrames}/${progress.totalFrames}${etaString}`;
  }
  return `Encoded ${progress.encodedFrames}/${progress.totalFrames}`;
};

// src/components/RenderQueue/RenderQueueProgressMessage.tsx
import { jsx as jsx153 } from "react/jsx-runtime";
var outputLocation2 = {
  ...renderQueueItemSubtitleStyle
};
var RenderQueueProgressMessage = ({ job }) => {
  if (job.status !== "running") {
    throw new Error("should not have rendered this component");
  }
  const { setSelectedModal } = useContext43(ModalsContext);
  const { tabIndex } = useZIndex();
  const isClientJob = isClientRenderJob(job);
  const onClick = useCallback77(() => {
    setSelectedModal({
      type: "render-progress",
      jobId: job.id
    });
  }, [job.id, setSelectedModal]);
  const message = isClientJob ? getClientRenderProgressMessage(job.progress) : job.progress.message;
  return /* @__PURE__ */ jsx153("button", {
    onClick,
    type: "button",
    style: outputLocation2,
    tabIndex,
    title: message,
    children: message
  });
};

// src/components/RenderQueue/RenderQueueRemoveItem.tsx
import { useCallback as useCallback78, useContext as useContext44, useMemo as useMemo86 } from "react";
import { Internals as Internals34 } from "remotion";
import { jsx as jsx154 } from "react/jsx-runtime";
var RenderQueueRemoveItem = ({ job }) => {
  const isClientJob = isClientRenderJob(job);
  const { removeClientJob } = useContext44(RenderQueueContext);
  const { canvasContent } = useContext44(Internals34.CompositionManager);
  const { setCanvasContent } = useContext44(Internals34.CompositionSetters);
  const onClick = useCallback78((e) => {
    e.stopPropagation();
    if (isClientJob) {
      if (canvasContent && canvasContent.type === "output" && job.status === "done" && canvasContent.path === `/${job.outName}`) {
        setCanvasContent(null);
      }
      removeClientJob(job.id);
      unregisterClientRender(job.id).catch(() => {});
      showNotification("Removed job", 2000);
      return;
    }
    removeRenderJob(job).then(() => {
      showNotification("Removed job", 2000);
    }).catch((err) => {
      showNotification(`Could not remove item: ${err.message}`, 2000);
    });
  }, [job, isClientJob, removeClientJob, canvasContent, setCanvasContent]);
  const icon5 = useMemo86(() => {
    return {
      height: 16,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback78((color) => {
    return /* @__PURE__ */ jsx154("svg", {
      style: icon5,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      children: /* @__PURE__ */ jsx154("path", {
        fill: color,
        d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx154(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import { useCallback as useCallback79, useContext as useContext45, useMemo as useMemo87 } from "react";

// src/helpers/retry-payload.ts
import { NoReactInternals as NoReactInternals11 } from "remotion/no-react";
var makeRetryPayload = (job) => {
  const defaults = window.remotion_renderDefaults;
  if (!defaults) {
    throw new Error("defaults not set");
  }
  if (job.type === "still") {
    return {
      type: "server-render",
      compositionId: job.compositionId,
      initialFrame: job.frame,
      initialStillImageFormat: job.imageFormat,
      initialVideoImageFormat: null,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: null,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      initialDarkMode: job.chromiumOptions.darkMode,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      inFrameMark: null,
      outFrameMark: null,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "still",
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: job.chromeMode,
      initialMediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
      renderDefaults: defaults,
      readOnlyStudio: false
    };
  }
  if (job.type === "sequence") {
    return {
      type: "server-render",
      initialFrame: 0,
      compositionId: job.compositionId,
      initialVideoImageFormat: null,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: null,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: defaults.pixelFormat,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      initialDarkMode: job.chromiumOptions.darkMode,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      initialStillImageFormat: defaults.stillImageFormat,
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "sequence",
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: job.chromeMode,
      initialMediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
      renderDefaults: defaults,
      readOnlyStudio: false
    };
  }
  if (job.type === "video") {
    return {
      type: "server-render",
      compositionId: job.compositionId,
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: job.imageFormat,
      initialJpegQuality: job.jpegQuality ?? defaults.jpegQuality,
      initialScale: job.scale,
      initialLogLevel: job.logLevel,
      initialFrame: 0,
      initialConcurrency: job.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: job.muted,
      initialEnforceAudioTrack: job.enforceAudioTrack,
      initialProResProfile: job.proResProfile ?? null,
      initialx264Preset: job.x264Preset ?? defaults.x264Preset,
      initialPixelFormat: job.pixelFormat,
      initialAudioBitrate: job.audioBitrate,
      initialVideoBitrate: job.videoBitrate,
      initialEveryNthFrame: job.everyNthFrame,
      initialNumberOfGifLoops: job.numberOfGifLoops,
      initialDelayRenderTimeout: job.delayRenderTimeout,
      initialEnvVariables: job.envVariables,
      initialDisableWebSecurity: job.chromiumOptions.disableWebSecurity,
      initialOpenGlRenderer: job.chromiumOptions.gl,
      initialHeadless: job.chromiumOptions.headless,
      initialIgnoreCertificateErrors: job.chromiumOptions.ignoreCertificateErrors,
      initialDarkMode: job.chromiumOptions.darkMode,
      defaultProps: NoReactInternals11.deserializeJSONWithSpecialTypes(job.serializedInputPropsWithCustomSchema),
      inFrameMark: job.startFrame,
      outFrameMark: job.endFrame,
      initialOffthreadVideoCacheSizeInBytes: job.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: job.offthreadVideoThreads,
      initialColorSpace: job.colorSpace,
      initialMultiProcessOnLinux: job.multiProcessOnLinux,
      defaultConfigurationVideoCodec: job.codec,
      defaultConfigurationAudioCodec: job.audioCodec,
      initialEncodingBufferSize: job.encodingBufferSize,
      initialEncodingMaxRate: job.encodingMaxRate,
      initialUserAgent: job.chromiumOptions.userAgent,
      initialBeep: job.beepOnFinish,
      initialRepro: job.repro,
      initialForSeamlessAacConcatenation: job.forSeamlessAacConcatenation,
      defaulMetadata: job.metadata,
      renderTypeOfLastRender: "video",
      initialHardwareAcceleration: job.hardwareAcceleration,
      initialChromeMode: job.chromeMode,
      initialMediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
      renderDefaults: defaults,
      readOnlyStudio: false
    };
  }
  throw new Error(`Job ${JSON.stringify(job)} Not implemented`);
};
var makeClientRetryPayload = (job) => {
  return {
    type: "web-render",
    compositionId: job.compositionId,
    initialFrame: job.type === "client-still" ? job.frame : 0,
    initialLogLevel: job.logLevel,
    initialLicenseKey: job.licenseKey,
    defaultProps: job.inputProps,
    inFrameMark: job.type === "client-video" ? job.startFrame : null,
    outFrameMark: job.type === "client-video" ? job.endFrame : null,
    initialDefaultOutName: job.outName,
    initialScale: job.scale,
    initialDelayRenderTimeout: job.delayRenderTimeout,
    initialMediaCacheSizeInBytes: job.mediaCacheSizeInBytes,
    initialAudioBitrate: job.type === "client-video" ? job.audioBitrate : null,
    initialAudioCodec: job.type === "client-video" ? job.audioCodec : null,
    initialContainer: job.type === "client-video" ? job.container : null,
    initialHardwareAcceleration: job.type === "client-video" ? job.hardwareAcceleration : null,
    initialVideoBitrate: job.type === "client-video" ? job.videoBitrate : null,
    initialVideoCodec: job.type === "client-video" ? job.videoCodec : null,
    initialStillImageFormat: job.type === "client-still" ? job.imageFormat : "png",
    initialKeyframeIntervalInSeconds: job.type === "client-video" ? job.keyframeIntervalInSeconds : null,
    initialMuted: job.type === "client-video" ? job.muted : null,
    initialTransparent: job.type === "client-video" ? job.transparent : null
  };
};

// src/components/RenderQueue/RenderQueueRepeat.tsx
import { jsx as jsx155 } from "react/jsx-runtime";
var RenderQueueRepeatItem = ({ job }) => {
  const { setSelectedModal } = useContext45(ModalsContext);
  const isMobileLayout = useMobileLayout();
  const { setSidebarCollapsedState } = useContext45(SidebarContext);
  const isClientJob = isClientRenderJob(job);
  const onClick = useCallback79((e) => {
    e.stopPropagation();
    if (isClientJob) {
      const retryPayload = makeClientRetryPayload(job);
      setSelectedModal(retryPayload);
    } else {
      const retryPayload = makeRetryPayload(job);
      setSelectedModal(retryPayload);
    }
    if (isMobileLayout) {
      setSidebarCollapsedState({ left: "collapsed", right: "collapsed" });
    }
  }, [
    isMobileLayout,
    job,
    isClientJob,
    setSelectedModal,
    setSidebarCollapsedState
  ]);
  const icon5 = useMemo87(() => {
    return {
      height: 12,
      color: "currentColor"
    };
  }, []);
  const renderAction = useCallback79((color) => {
    return /* @__PURE__ */ jsx155("svg", {
      style: icon5,
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx155("path", {
        fill: color,
        d: "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
      })
    });
  }, [icon5]);
  return /* @__PURE__ */ jsx155(InlineAction, {
    onClick,
    renderAction
  });
};

// src/components/RenderQueue/RenderQueueSavingMessage.tsx
import { jsx as jsx156 } from "react/jsx-runtime";
var savingStyle = {
  ...renderQueueItemSubtitleStyle,
  cursor: "default"
};
var RenderQueueSavingMessage = () => {
  return /* @__PURE__ */ jsx156("span", {
    style: savingStyle,
    children: "Saving to out/..."
  });
};

// src/components/RenderQueue/RenderQueueItem.tsx
import { jsx as jsx157, jsxs as jsxs74 } from "react/jsx-runtime";
var container32 = {
  padding: 12,
  display: "flex",
  flexDirection: "row",
  paddingBottom: 10,
  paddingRight: 4
};
var title4 = {
  fontSize: 13,
  lineHeight: 1
};
var right = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};
var subtitle3 = {
  maxWidth: "100%",
  flex: 1,
  display: "flex",
  overflow: "hidden"
};
var SELECTED_CLASSNAME = "__remotion_selected_classname";
var RenderQueueItem = ({ job, selected }) => {
  const [hovered, setHovered] = useState54(false);
  const { setCanvasContent } = useContext46(Internals35.CompositionSetters);
  const isClientJob = isClientRenderJob(job);
  const onPointerEnter = useCallback80(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback80(() => {
    setHovered(false);
  }, []);
  const isHoverable = job.status === "done" && (isClientJob || job.type !== "sequence");
  const containerStyle3 = useMemo88(() => {
    return {
      ...container32,
      backgroundColor: getBackgroundFromHoverState({
        hovered: isHoverable && hovered,
        selected
      }),
      userSelect: "none",
      WebkitUserSelect: "none"
    };
  }, [hovered, isHoverable, selected]);
  const scrollCurrentIntoView = useCallback80(() => {
    document.querySelector(`.${SELECTED_CLASSNAME}`)?.scrollIntoView({ behavior: "smooth" });
  }, []);
  const clientBlobInfo = useMemo88(() => {
    if (!isClientJob || job.status !== "done" || !job.getBlob) {
      return null;
    }
    return {
      getBlob: job.getBlob,
      width: job.metadata.width,
      height: job.metadata.height,
      sizeInBytes: job.metadata.sizeInBytes
    };
  }, [isClientJob, job]);
  const onClick = useCallback80(() => {
    if (job.status !== "done") {
      return;
    }
    if (!isClientJob && job.type === "sequence") {
      return;
    }
    if (clientBlobInfo) {
      setCanvasContent((c) => {
        const isAlreadySelected = c && c.type === "output-blob" && c.displayName === job.outName;
        if (isAlreadySelected && !selected) {
          scrollCurrentIntoView();
          return c;
        }
        return {
          type: "output-blob",
          displayName: job.outName,
          getBlob: clientBlobInfo.getBlob,
          width: clientBlobInfo.width,
          height: clientBlobInfo.height,
          sizeInBytes: clientBlobInfo.sizeInBytes
        };
      });
      return;
    }
    setCanvasContent((c) => {
      const isAlreadySelected = c && c.type === "output" && c.path === `/${job.outName}`;
      if (isAlreadySelected && !selected) {
        scrollCurrentIntoView();
        return c;
      }
      return { type: "output", path: `/${job.outName}` };
    });
    pushUrl(`/outputs/${job.outName}`);
  }, [
    job,
    isClientJob,
    clientBlobInfo,
    scrollCurrentIntoView,
    selected,
    setCanvasContent
  ]);
  useEffect50(() => {
    if (selected) {
      scrollCurrentIntoView();
    }
  }, [scrollCurrentIntoView, selected]);
  const canCopyToClipboard = job.status === "done" && !isClientJob && supportsCopyingToClipboard(job);
  const canRepeat = (job.status === "done" || job.status === "failed" || job.status === "cancelled") && !(isClientRenderJob(job) && isRestoredClientJob(job));
  return /* @__PURE__ */ jsxs74(Row, {
    onPointerEnter,
    onPointerLeave,
    style: containerStyle3,
    align: "center",
    onClick,
    className: selected ? SELECTED_CLASSNAME : undefined,
    children: [
      /* @__PURE__ */ jsx157(RenderQueueItemStatus, {
        job
      }),
      /* @__PURE__ */ jsx157(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsxs74("div", {
        style: right,
        children: [
          /* @__PURE__ */ jsx157("div", {
            style: title4,
            children: job.compositionId
          }),
          /* @__PURE__ */ jsx157("div", {
            style: subtitle3,
            children: job.status === "done" ? /* @__PURE__ */ jsx157(RenderQueueOutputName, {
              job
            }) : job.status === "failed" ? /* @__PURE__ */ jsx157(RenderQueueError, {
              job
            }) : job.status === "running" ? /* @__PURE__ */ jsx157(RenderQueueProgressMessage, {
              job
            }) : job.status === "saving" ? /* @__PURE__ */ jsx157(RenderQueueSavingMessage, {}) : job.status === "cancelled" ? /* @__PURE__ */ jsx157(RenderQueueCancelledMessage, {}) : null
          })
        ]
      }),
      /* @__PURE__ */ jsx157(Spacing, {
        x: 1
      }),
      canCopyToClipboard ? /* @__PURE__ */ jsx157(RenderQueueCopyToClipboard, {
        job
      }) : null,
      canRepeat ? /* @__PURE__ */ jsx157(RenderQueueRepeatItem, {
        job
      }) : null,
      job.status === "running" ? /* @__PURE__ */ jsx157(RenderQueueCancelButton, {
        job
      }) : /* @__PURE__ */ jsx157(RenderQueueRemoveItem, {
        job
      }),
      job.status === "done" ? clientBlobInfo ? /* @__PURE__ */ jsx157(RenderQueueDownloadItem, {
        job
      }) : /* @__PURE__ */ jsx157(RenderQueueOpenInFinderItem, {
        job
      }) : null
    ]
  });
};

// src/components/RenderQueue/index.tsx
import { jsx as jsx158, jsxs as jsxs75 } from "react/jsx-runtime";
var separatorStyle = {
  borderBottom: `1px solid ${BORDER_COLOR}`
};
var errorExplanation3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var explainer4 = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  padding: "0 12px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  background: BACKGROUND
};
var renderQueue = {
  background: BACKGROUND,
  flex: 1,
  overflowY: "auto"
};
var RenderQueue = () => {
  const connectionStatus = useContext47(StudioServerConnectionCtx).previewServerState.type;
  const { jobs } = useContext47(RenderQueueContext);
  const { canvasContent } = useContext47(Internals36.CompositionManager);
  const previousJobCount = React107.useRef(jobs.length);
  const jobCount = jobs.length;
  const divRef = React107.useRef(null);
  useEffect51(() => {
    if (!divRef.current) {
      return;
    }
    if (jobCount > previousJobCount.current) {
      divRef.current.scrollTo({
        top: divRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
    previousJobCount.current = jobCount;
  }, [jobCount]);
  const selectedJob = useMemo89(() => {
    if (!canvasContent) {
      return -1;
    }
    if (canvasContent.type === "output") {
      for (let i = 0;i < jobs.length; i++) {
        const job = jobs[i];
        if (job.status === "done" && canvasContent.path === `/${job.outName}`) {
          return i;
        }
      }
    }
    return -1;
  }, [canvasContent, jobs]);
  if (connectionStatus === "disconnected" && !SHOW_BROWSER_RENDERING) {
    return /* @__PURE__ */ jsxs75("div", {
      style: explainer4,
      children: [
        /* @__PURE__ */ jsx158(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx158("div", {
          style: errorExplanation3,
          children: "The studio server has disconnected."
        }),
        /* @__PURE__ */ jsx158(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  if (jobCount === 0) {
    return /* @__PURE__ */ jsxs75("div", {
      style: explainer4,
      children: [
        /* @__PURE__ */ jsx158(Spacing, {
          y: 5
        }),
        /* @__PURE__ */ jsx158("div", {
          style: errorExplanation3,
          children: "No renders in the queue."
        }),
        /* @__PURE__ */ jsx158(Spacing, {
          y: 2,
          block: true
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx158("div", {
    ref: divRef,
    style: renderQueue,
    className: ["css-reset", VERTICAL_SCROLLBAR_CLASSNAME].join(" "),
    children: jobs.map((j, index) => {
      return /* @__PURE__ */ jsx158("div", {
        style: index === jobs.length - 1 ? undefined : separatorStyle,
        children: /* @__PURE__ */ jsx158(RenderQueueItem, {
          selected: selectedJob === index,
          job: j
        })
      }, j.id);
    })
  });
};

// src/components/RendersTab.tsx
import { useContext as useContext48, useMemo as useMemo90 } from "react";
import { jsx as jsx159, jsxs as jsxs76, Fragment as Fragment20 } from "react/jsx-runtime";
var row4 = {
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  flex: 1
};
var badge = {
  height: 16,
  width: 16,
  borderRadius: 3,
  fontSize: 10,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var RendersTab = ({ selected, onClick }) => {
  const { jobs } = useContext48(RenderQueueContext);
  const failedJobs = jobs.filter((j) => j.status === "failed").length;
  const jobCount = jobs.length;
  const badgeStyle = useMemo90(() => {
    return {
      ...badge,
      backgroundColor: failedJobs > 0 ? FAIL_COLOR : "transparent",
      color: failedJobs > 0 ? "white" : LIGHT_TEXT,
      borderWidth: failedJobs > 0 ? 0 : 1,
      borderStyle: "solid",
      borderColor: LIGHT_TEXT
    };
  }, [failedJobs]);
  return /* @__PURE__ */ jsx159(Tab, {
    selected,
    onClick,
    children: /* @__PURE__ */ jsxs76("div", {
      style: row4,
      children: [
        "Renders",
        jobCount > 0 ? /* @__PURE__ */ jsxs76(Fragment20, {
          children: [
            /* @__PURE__ */ jsx159(Flex, {}),
            /* @__PURE__ */ jsx159("div", {
              style: badgeStyle,
              children: jobCount
            })
          ]
        }) : null
      ]
    })
  });
};

// src/components/VisualControls/VisualControlsContent.tsx
import React110, { useContext as useContext50 } from "react";

// src/components/VisualControls/VisualControlHandle.tsx
import { useCallback as useCallback82, useContext as useContext49, useEffect as useEffect53, useState as useState57 } from "react";
import { NoReactInternals as NoReactInternals12 } from "remotion/no-react";

// src/components/VisualControls/get-original-stack-trace.ts
import { useEffect as useEffect52, useState as useState55 } from "react";

// src/components/Timeline/TimelineStack/get-stack.ts
import { SourceMapConsumer as SourceMapConsumer2 } from "source-map";

// src/helpers/get-location-of-sequence.ts
var getLocationOfSequence = (stack2) => {
  if (!stack2) {
    return null;
  }
  const parsed = parseStack(stack2.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame2 = parsed[i];
    if (frame2.functionName === "apply") {
      i++;
      continue;
    }
    return frame2;
  }
  return null;
};
var getLocationOfFunctionCall = (stack2, functionName) => {
  if (!stack2) {
    return null;
  }
  const parsed = parseStack(stack2.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame2 = parsed[i];
    if (frame2.functionName !== functionName) {
      i++;
      continue;
    }
    return parsed[i + 1];
  }
  return null;
};

// src/components/Timeline/TimelineStack/get-stack.ts
var waiters = [];
var sourceMapConsumerCache = {};
var isCreating = {};
var getSourceMapCache = async (fileName) => {
  if (sourceMapConsumerCache[fileName]) {
    return sourceMapConsumerCache[fileName];
  }
  if (isCreating[fileName]) {
    return new Promise((resolve) => {
      waiters.push({
        id: String(Math.random()),
        forFileName: fileName,
        resolve
      });
    });
  }
  isCreating[fileName] = true;
  const res = await fetch(`${fileName}.map`);
  const json = await res.json();
  const map = await new Promise((resolve) => {
    SourceMapConsumer2.with(json, null, (consumer) => {
      resolve(consumer);
    });
  });
  waiters.filter((w) => {
    if (w.forFileName === fileName) {
      w.resolve(map);
      return false;
    }
    return true;
  });
  sourceMapConsumerCache[fileName] = map;
  isCreating[fileName] = false;
  return map;
};
var getOriginalLocationFromStack = async (stack2, type) => {
  const location2 = type === "sequence" ? getLocationOfSequence(stack2) : getLocationOfFunctionCall(stack2, "visualControl");
  if (!location2) {
    return null;
  }
  const map = await getSourceMapCache(location2.fileName);
  const originalPosition = getOriginalPosition(map, location2.lineNumber, location2.columnNumber);
  return originalPosition;
};

// src/components/VisualControls/get-original-stack-trace.ts
var useOriginalFileName = (stack2) => {
  const [originalFileName, setOriginalFileName] = useState55({ type: "loading" });
  useEffect52(() => {
    if (!stack2) {
      return;
    }
    getOriginalLocationFromStack(stack2, "visual-control").then((frame2) => {
      if (frame2 === null) {
        setOriginalFileName({
          type: "error",
          error: new Error("No frame found")
        });
      } else {
        setOriginalFileName({ type: "loaded", originalFileName: frame2 });
      }
    }).catch((err) => {
      console.error("Could not get original location of Sequence", err);
    });
  }, [stack2]);
  return originalFileName;
};

// src/components/VisualControls/ClickableFileName.tsx
import { useCallback as useCallback81, useMemo as useMemo91, useState as useState56 } from "react";

// src/components/Timeline/TimelineStack/source-attribution.ts
var getOriginalSourceAttribution = (originalLocation) => {
  if (!originalLocation.source) {
    return "";
  }
  const split = originalLocation.source.split("/");
  const last = split[split.length - 1];
  if (last.startsWith("index")) {
    const lastTwo = split[split.length - 2];
    return `${lastTwo}/${last}:${originalLocation.line}`;
  }
  return `${last}:${originalLocation.line}`;
};

// src/components/VisualControls/ClickableFileName.tsx
import { jsx as jsx160 } from "react/jsx-runtime";
var container33 = {
  paddingLeft: SCHEMA_EDITOR_FIELDSET_PADDING,
  paddingTop: SCHEMA_EDITOR_FIELDSET_PADDING / 2
};
var ClickableFileName = ({
  originalFileName
}) => {
  const [titleHovered, setTitleHovered] = useState56(false);
  const hoverEffect = titleHovered && originalFileName.type === "loaded";
  const onTitlePointerEnter = useCallback81(() => {
    setTitleHovered(true);
  }, []);
  const onTitlePointerLeave = useCallback81(() => {
    setTitleHovered(false);
  }, []);
  const style9 = useMemo91(() => {
    return {
      fontSize: 12,
      cursor: originalFileName.type === "loaded" ? "pointer" : undefined,
      borderBottom: hoverEffect ? "1px solid #fff" : "none",
      color: hoverEffect ? "#fff" : LIGHT_COLOR
    };
  }, [originalFileName, hoverEffect]);
  const onClick = useCallback81(async () => {
    if (originalFileName.type !== "loaded") {
      return;
    }
    await openOriginalPositionInEditor(originalFileName.originalFileName);
  }, [originalFileName]);
  return /* @__PURE__ */ jsx160("div", {
    style: container33,
    children: /* @__PURE__ */ jsx160("span", {
      style: style9,
      onClick,
      onPointerEnter: onTitlePointerEnter,
      onPointerLeave: onTitlePointerLeave,
      children: originalFileName.type === "loaded" ? getOriginalSourceAttribution(originalFileName.originalFileName) : originalFileName.type === "loading" ? "Loading..." : "Error loading"
    })
  });
};

// src/components/VisualControls/VisualControlHandleHeader.tsx
import { jsx as jsx161 } from "react/jsx-runtime";
var VisualControlHandleHeader = ({ originalFileName }) => {
  return /* @__PURE__ */ jsx161(ClickableFileName, {
    originalFileName
  });
};

// src/components/VisualControls/VisualControlHandle.tsx
import { jsx as jsx162, jsxs as jsxs77, Fragment as Fragment21 } from "react/jsx-runtime";
var VisualControlHandle = ({ value, keyName }) => {
  const z = useZodIfPossible();
  if (!z) {
    throw new Error("expected zod");
  }
  const zodTypes = useZodTypesIfPossible();
  const state = useContext49(VisualControlsContext);
  const { updateValue } = useContext49(SetVisualControlsContext);
  const { fastRefreshes, increaseManualRefreshes } = useContext49(FastRefreshContext);
  const [saving, setSaving] = useState57(false);
  const currentValue = getVisualControlEditedValue({
    handles: state.handles,
    key: keyName
  });
  const originalFileName = useOriginalFileName(value.stack);
  const { localValue, RevisionContextProvider, onChange } = useLocalState({
    schema: value.schema,
    setValue: (updater) => {
      updateValue(keyName, updater(currentValue));
      increaseManualRefreshes();
    },
    unsavedValue: currentValue,
    savedValue: value.valueInCode
  });
  const disableSave = window.remotion_isReadOnlyStudio || originalFileName.type !== "loaded";
  const onSave = useCallback82((updater) => {
    if (disableSave) {
      return;
    }
    if (originalFileName.type !== "loaded") {
      throw new Error("Original file name is not loaded");
    }
    const val = updater(value.valueInCode);
    window.remotion_ignoreFastRefreshUpdate = fastRefreshes + 1;
    const enumPaths = extractEnumJsonPaths({
      schema: value.schema,
      zodRuntime: z,
      currentPath: [],
      zodTypes
    });
    setSaving(true);
    Promise.resolve().then(() => {
      return applyVisualControlChange({
        fileName: originalFileName.originalFileName.source,
        changes: [
          {
            id: keyName,
            newValueSerialized: NoReactInternals12.serializeJSONWithSpecialTypes({
              data: val,
              indent: 2,
              staticBase: window.remotion_staticBase
            }).serializedString,
            enumPaths
          }
        ]
      });
    }).catch((e) => {
      showNotification(`Could not save visual control: ${e.message}`, 3000);
    });
  }, [
    disableSave,
    value.valueInCode,
    value.schema,
    fastRefreshes,
    z,
    originalFileName,
    keyName,
    zodTypes
  ]);
  useEffect53(() => {
    setSaving(false);
  }, [fastRefreshes]);
  return /* @__PURE__ */ jsxs77(Fragment21, {
    children: [
      /* @__PURE__ */ jsx162(VisualControlHandleHeader, {
        originalFileName
      }),
      /* @__PURE__ */ jsx162(Spacing, {
        block: true,
        y: 0.5
      }),
      /* @__PURE__ */ jsx162(RevisionContextProvider, {
        children: /* @__PURE__ */ jsx162(ZodSwitch, {
          mayPad: true,
          schema: value.schema,
          showSaveButton: !disableSave,
          saving,
          saveDisabledByParent: false,
          onSave,
          jsonPath: [keyName],
          value: localValue.value,
          defaultValue: value.valueInCode,
          setValue: onChange,
          onRemove: null
        })
      })
    ]
  });
};

// src/components/VisualControls/VisualControlsContent.tsx
import { jsx as jsx163, jsxs as jsxs78 } from "react/jsx-runtime";
var container34 = {
  overflowY: "auto"
};
var VisualControlsContent = () => {
  const { handles } = useContext50(VisualControlsContext);
  const entries = Object.entries(handles);
  return /* @__PURE__ */ jsx163("div", {
    style: container34,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: entries.map(([key, value], i) => {
      return /* @__PURE__ */ jsxs78(React110.Fragment, {
        children: [
          /* @__PURE__ */ jsx163(VisualControlHandle, {
            keyName: key,
            value
          }),
          i === entries.length - 1 ? null : /* @__PURE__ */ jsx163(SchemaSeparationLine, {})
        ]
      }, key);
    })
  });
};

// src/components/OptionsPanel.tsx
import { jsx as jsx164, jsxs as jsxs79 } from "react/jsx-runtime";
var localStorageKey3 = "remotion.sidebarPanel";
var getSelectedPanel2 = (renderingAvailable) => {
  if (!renderingAvailable) {
    return "input-props";
  }
  const panel2 = localStorage.getItem(localStorageKey3);
  if (panel2 === "renders") {
    return "renders";
  }
  if (panel2 === "visual-controls") {
    return "visual-controls";
  }
  return "input-props";
};
var tabsContainer3 = {
  backgroundColor: BACKGROUND
};
var persistSelectedOptionsSidebarPanel2 = (panel2) => {
  localStorage.setItem(localStorageKey3, panel2);
};
var optionsSidebarTabs = createRef9();
var OptionsPanel = ({ readOnlyStudio }) => {
  const { props, updateProps, resetUnsaved } = useContext51(Internals37.EditorPropsContext);
  const [saving, setSaving] = useState58(false);
  const renderingAvailable = !readOnlyStudio || SHOW_BROWSER_RENDERING;
  const isMobileLayout = useMobileLayout();
  const visualControlsTabActivated = useContext51(VisualControlsTabActivatedContext);
  const container35 = useMemo92(() => ({
    height: "100%",
    width: "100%",
    display: "flex",
    position: isMobileLayout ? "relative" : "absolute",
    flexDirection: "column",
    flex: 1
  }), [isMobileLayout]);
  const [panel2, setPanel] = useState58(() => getSelectedPanel2(renderingAvailable));
  const onPropsSelected = useCallback83(() => {
    setPanel("input-props");
    persistSelectedOptionsSidebarPanel2("input-props");
  }, []);
  const onRendersSelected = useCallback83(() => {
    setPanel("renders");
    persistSelectedOptionsSidebarPanel2("renders");
  }, []);
  const onVisualControlsSelected = useCallback83(() => {
    setPanel("visual-controls");
    persistSelectedOptionsSidebarPanel2("visual-controls");
  }, []);
  useImperativeHandle12(optionsSidebarTabs, () => {
    return {
      selectRendersPanel: () => {
        setPanel("renders");
        persistSelectedOptionsSidebarPanel2("renders");
      }
    };
  }, []);
  const { compositions, canvasContent } = useContext51(Internals37.CompositionManager);
  const composition = useMemo92(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return null;
    }
    for (const comp of compositions) {
      if (comp.id === canvasContent.compositionId) {
        return comp;
      }
    }
    return null;
  }, [canvasContent, compositions]);
  const setDefaultProps = useCallback83((newProps) => {
    if (composition === null) {
      return;
    }
    window.remotion_ignoreFastRefreshUpdate = null;
    updateProps({
      id: composition.id,
      defaultProps: composition.defaultProps,
      newProps
    });
  }, [composition, updateProps]);
  const currentDefaultProps = useMemo92(() => {
    if (composition === null) {
      return {};
    }
    return props[composition.id] ?? composition.defaultProps ?? {};
  }, [composition, props]);
  const unsavedChangesExist = useMemo92(() => {
    if (composition === null || composition.defaultProps === undefined) {
      return false;
    }
    return !deepEqual(composition.defaultProps, currentDefaultProps);
  }, [currentDefaultProps, composition]);
  const reset = useCallback83((e) => {
    if (e.detail.resetUnsaved) {
      resetUnsaved(e.detail.resetUnsaved);
    }
  }, [resetUnsaved]);
  useEffect54(() => {
    window.addEventListener(Internals37.PROPS_UPDATED_EXTERNALLY, reset);
    return () => {
      window.removeEventListener(Internals37.PROPS_UPDATED_EXTERNALLY, reset);
    };
  }, [reset]);
  return /* @__PURE__ */ jsxs79("div", {
    style: container35,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsx164("div", {
        style: tabsContainer3,
        children: /* @__PURE__ */ jsxs79(Tabs, {
          children: [
            visualControlsTabActivated ? /* @__PURE__ */ jsx164(Tab, {
              selected: panel2 === "visual-controls",
              onClick: onVisualControlsSelected,
              children: "Controls"
            }) : null,
            /* @__PURE__ */ jsxs79(Tab, {
              selected: panel2 === "input-props",
              onClick: onPropsSelected,
              style: { justifyContent: "space-between" },
              children: [
                "Props",
                unsavedChangesExist && composition ? /* @__PURE__ */ jsx164(GlobalPropsEditorUpdateButton, {
                  compositionId: composition.id,
                  currentDefaultProps
                }) : null
              ]
            }),
            renderingAvailable ? /* @__PURE__ */ jsx164(RendersTab, {
              onClick: onRendersSelected,
              selected: panel2 === "renders"
            }) : null
          ]
        })
      }),
      panel2 === "input-props" ? composition ? /* @__PURE__ */ jsx164(DataEditor, {
        unresolvedComposition: composition,
        defaultProps: currentDefaultProps,
        setDefaultProps,
        mayShowSaveButton: true,
        propsEditType: "default-props",
        saving,
        setSaving,
        readOnlyStudio
      }, composition.id) : null : panel2 === "visual-controls" && visualControlsTabActivated ? /* @__PURE__ */ jsx164(VisualControlsContent, {}) : !renderingAvailable ? null : /* @__PURE__ */ jsx164(RenderQueue, {})
    ]
  });
};

// src/components/PreviewToolbar.tsx
import { useContext as useContext57, useEffect as useEffect60, useRef as useRef32, useState as useState62 } from "react";
import { Internals as Internals45 } from "remotion";

// src/state/loop.ts
var key = "remotion.loop";
var persistLoopOption = (option) => {
  localStorage.setItem(key, String(option));
};
var loadLoopOption = () => {
  const item2 = localStorage.getItem(key);
  return item2 !== "false";
};

// src/components/CheckboardToggle.tsx
import { useCallback as useCallback84, useContext as useContext52 } from "react";
import { NoReactInternals as NoReactInternals13 } from "remotion/no-react";
import { jsx as jsx165 } from "react/jsx-runtime";
var accessibilityLabel2 = [
  "Show transparency as checkerboard",
  areKeyboardShortcutsDisabled() ? null : "(T)"
].filter(NoReactInternals13.truthy).join(" ");
var CheckboardToggle = () => {
  const { checkerboard, setCheckerboard } = useContext52(CheckerboardContext);
  const onClick = useCallback84(() => {
    setCheckerboard((c) => {
      return !c;
    });
  }, [setCheckerboard]);
  return /* @__PURE__ */ jsx165(ControlButton, {
    title: accessibilityLabel2,
    "aria-label": accessibilityLabel2,
    onClick,
    children: /* @__PURE__ */ jsx165("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "game-board-alt",
      className: "svg-inline--fa fa-game-board-alt fa-w-16",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      style: { width: 16, height: 16 },
      children: /* @__PURE__ */ jsx165("path", {
        fill: checkerboard ? BLUE : "white",
        d: "M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 256H256v192H64V256h192V64h192z"
      })
    })
  });
};

// src/components/FpsCounter.tsx
import {
  useEffect as useEffect55,
  useLayoutEffect,
  useMemo as useMemo93,
  useRef as useRef30,
  useState as useState59
} from "react";
import { Internals as Internals38 } from "remotion";
import { jsxs as jsxs80 } from "react/jsx-runtime";
var label6 = {
  color: "white",
  fontSize: 15,
  fontFamily: "Arial, Helvetica, sans-serif",
  whiteSpace: "nowrap"
};
var pushWithMaxSize = (arr, value, maxSize) => {
  arr.push(value);
  return arr.slice(-maxSize);
};
var FpsCounter = ({ playbackSpeed }) => {
  const videoConfig = Internals38.useUnsafeVideoConfig();
  const [playing] = Internals38.Timeline.usePlayingState();
  const frame2 = Internals38.Timeline.useTimelinePosition();
  const [marker, rerender] = useState59({});
  const [fps, setFps] = useState59(0);
  const previousUpdates = useRef30([]);
  const fpsRef = useRef30(0);
  const playingRef = useRef30(playing);
  useLayoutEffect(() => {
    fpsRef.current = 0;
    previousUpdates.current = [];
    playingRef.current = playing;
  }, [playing]);
  useLayoutEffect(() => {
    if (playingRef.current === false)
      return;
    previousUpdates.current = pushWithMaxSize(previousUpdates.current, performance.now(), 15);
    if (previousUpdates.current.length < 2)
      return;
    const diff = Math.max(...previousUpdates.current) - Math.min(...previousUpdates.current);
    const averageDistanceBetween = diff / (previousUpdates.current.length - 1);
    fpsRef.current = 1000 / averageDistanceBetween;
    if (previousUpdates.current.length === 2)
      setFps(fpsRef.current);
  }, [frame2]);
  useEffect55(() => {
    if (playing) {
      const t = setTimeout(() => {
        rerender({});
        setFps(fpsRef.current);
      }, 1000);
      return () => clearTimeout(t);
    }
  }, [marker, playing]);
  const style9 = useMemo93(() => {
    if (!videoConfig) {
      return {};
    }
    const expectedFps = Math.abs(playbackSpeed) * videoConfig.fps;
    return {
      ...label6,
      color: fps < expectedFps * 0.9 ? "red" : "white"
    };
  }, [fps, playbackSpeed, videoConfig]);
  if (fps === 0) {
    return null;
  }
  if (playing === false) {
    return null;
  }
  if (videoConfig === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs80("div", {
    style: style9,
    children: [
      fps.toFixed(1),
      " FPS"
    ]
  });
};

// src/components/FullscreenToggle.tsx
import { useCallback as useCallback85, useContext as useContext53, useEffect as useEffect56 } from "react";
import { Internals as Internals39 } from "remotion";
import { NoReactInternals as NoReactInternals14 } from "remotion/no-react";
import { jsx as jsx166 } from "react/jsx-runtime";
var accessibilityLabel3 = [
  "Enter fullscreen preview",
  areKeyboardShortcutsDisabled() ? null : "(F)"
].filter(NoReactInternals14.truthy).join(" ");
var FullScreenToggle = () => {
  const keybindings = useKeybinding();
  const { setSize } = useContext53(Internals39.PreviewSizeContext);
  const onClick = useCallback85(() => {
    drawRef.current?.requestFullscreen();
    if (document.fullscreenElement)
      setSize(() => ({
        size: "auto",
        translation: {
          x: 0,
          y: 0
        }
      }));
  }, [setSize]);
  useEffect56(() => {
    const f = keybindings.registerKeybinding({
      event: "keydown",
      key: "f",
      callback: onClick,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      f.unregister();
    };
  }, [keybindings, onClick]);
  return /* @__PURE__ */ jsx166(ControlButton, {
    title: accessibilityLabel3,
    "aria-label": accessibilityLabel3,
    onClick,
    children: /* @__PURE__ */ jsx166("svg", {
      style: { width: 18, height: 18 },
      viewBox: "0 0 448 512",
      fill: "#fff",
      children: /* @__PURE__ */ jsx166("path", {
        d: "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
      })
    })
  });
};

// src/components/LoopToggle.tsx
import { useCallback as useCallback86 } from "react";
import { jsx as jsx167 } from "react/jsx-runtime";
var accessibilityLabel4 = "Loop video";
var LoopToggle = ({ loop, setLoop }) => {
  const onClick = useCallback86(() => {
    setLoop((c) => {
      persistLoopOption(!c);
      return !c;
    });
  }, [setLoop]);
  return /* @__PURE__ */ jsx167(ControlButton, {
    title: accessibilityLabel4,
    "aria-label": accessibilityLabel4,
    onClick,
    children: /* @__PURE__ */ jsx167("svg", {
      viewBox: "0 0 512 512",
      style: { width: 18, height: 18 },
      children: /* @__PURE__ */ jsx167("path", {
        fill: loop ? BLUE : "white",
        d: "M493.544 181.463c11.956 22.605 18.655 48.4 18.452 75.75C511.339 345.365 438.56 416 350.404 416H192v47.495c0 22.475-26.177 32.268-40.971 17.475l-80-80c-9.372-9.373-9.372-24.569 0-33.941l80-80C166.138 271.92 192 282.686 192 304v48h158.875c52.812 0 96.575-42.182 97.12-94.992.155-15.045-3.17-29.312-9.218-42.046-4.362-9.185-2.421-20.124 4.8-27.284 4.745-4.706 8.641-8.555 11.876-11.786 11.368-11.352 30.579-8.631 38.091 5.571zM64.005 254.992c.545-52.81 44.308-94.992 97.12-94.992H320v47.505c0 22.374 26.121 32.312 40.971 17.465l80-80c9.372-9.373 9.372-24.569 0-33.941l-80-80C346.014 16.077 320 26.256 320 48.545V96H161.596C73.44 96 .661 166.635.005 254.788c-.204 27.35 6.495 53.145 18.452 75.75 7.512 14.202 26.723 16.923 38.091 5.57 3.235-3.231 7.13-7.08 11.876-11.786 7.22-7.16 9.162-18.098 4.8-27.284-6.049-12.735-9.374-27.001-9.219-42.046z"
      })
    })
  });
};

// src/components/MuteToggle.tsx
import { useCallback as useCallback87 } from "react";

// src/icons/media-volume.tsx
import { jsx as jsx168 } from "react/jsx-runtime";
var size3 = 22;
var VolumeOffIcon = () => {
  return /* @__PURE__ */ jsx168("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx168("path", {
      d: "M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z",
      fill: BLUE
    })
  });
};
var VolumeOnIcon = () => {
  return /* @__PURE__ */ jsx168("svg", {
    width: size3,
    height: size3,
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx168("path", {
      d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z",
      fill: "#fff"
    })
  });
};

// src/state/mute.ts
var key2 = "remotion.mute";
var persistMuteOption = (option) => {
  localStorage.setItem(key2, String(option));
};
var loadMuteOption = () => {
  const item2 = localStorage.getItem(key2);
  return item2 === "true";
};

// src/components/MuteToggle.tsx
import { jsx as jsx169 } from "react/jsx-runtime";
var MuteToggle = ({ muted, setMuted }) => {
  const onClick = useCallback87(() => {
    setMuted((m) => {
      persistMuteOption(!m);
      return !m;
    });
  }, [setMuted]);
  const accessibilityLabel5 = muted ? "Unmute video" : "Mute video";
  return /* @__PURE__ */ jsx169(ControlButton, {
    title: accessibilityLabel5,
    "aria-label": accessibilityLabel5,
    onClick,
    children: muted ? /* @__PURE__ */ jsx169(VolumeOffIcon, {}) : /* @__PURE__ */ jsx169(VolumeOnIcon, {})
  });
};

// src/components/PlaybackKeyboardShortcutsManager.tsx
import { PlayerInternals as PlayerInternals12 } from "@remotion/player";
import { useCallback as useCallback88, useEffect as useEffect57 } from "react";
var PlaybackKeyboardShortcutsManager = ({ setPlaybackRate }) => {
  const keybindings = useKeybinding();
  const { play, pause, playing } = PlayerInternals12.usePlayer();
  const onJKey = useCallback88(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return -1;
      }
      if (prevPlaybackRate > -1) {
        return -1;
      }
      if (prevPlaybackRate > -2) {
        return -2;
      }
      return -4;
    });
    play();
  }, [play, playing, setPlaybackRate]);
  const onKKey = useCallback88(() => {
    setPlaybackRate(1);
    pause();
  }, [pause, setPlaybackRate]);
  const onLKey = useCallback88(() => {
    setPlaybackRate((prevPlaybackRate) => {
      if (!playing) {
        return 1;
      }
      if (prevPlaybackRate < 1) {
        return 1;
      }
      if (prevPlaybackRate < 2) {
        return 2;
      }
      return 4;
    });
    play();
  }, [play, playing, setPlaybackRate]);
  useEffect57(() => {
    const jKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "j",
      callback: onJKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const kKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: onKKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const lKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "l",
      callback: onLKey,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      jKey.unregister();
      kKey.unregister();
      lKey.unregister();
    };
  }, [keybindings, onJKey, onKKey, onLKey]);
  return null;
};

// src/components/PlaybackRatePersistor.tsx
import { useEffect as useEffect58 } from "react";
import { Internals as Internals40 } from "remotion";

// src/state/playbackrate.ts
var key3 = "remotion.playbackrate";
var persistPlaybackRate = (option) => {
  localStorage.setItem(key3, String(option));
};
var loadPlaybackRate = () => {
  if (typeof window !== "undefined") {
    return 1;
  }
  const item2 = localStorage.getItem(key3);
  if (item2 === null) {
    return 1;
  }
  return Number(item2);
};

// src/components/PlaybackRatePersistor.tsx
var PlaybackRatePersistor = () => {
  const { setPlaybackRate, playbackRate } = Internals40.useTimelineContext();
  useEffect58(() => {
    setPlaybackRate(loadPlaybackRate());
  }, [setPlaybackRate]);
  useEffect58(() => {
    persistPlaybackRate(playbackRate);
  }, [playbackRate]);
  return null;
};

// src/components/PlaybackRateSelector.tsx
import { useContext as useContext54, useMemo as useMemo94 } from "react";
import { Internals as Internals41 } from "remotion";
import { jsx as jsx170 } from "react/jsx-runtime";
var commonPlaybackRates = [
  -4,
  -2,
  -1,
  -0.5,
  -0.25,
  0.25,
  0.5,
  1,
  1.5,
  2,
  4
];
var getPlaybackRateLabel = (playbackRate) => {
  return `${playbackRate}x`;
};
var accessibilityLabel5 = "Change the playback rate";
var comboStyle2 = { width: 80 };
var PlaybackRateSelector = ({ playbackRate, setPlaybackRate }) => {
  const { canvasContent } = useContext54(Internals41.CompositionManager);
  const isStill = useIsStill();
  const style9 = useMemo94(() => {
    return {
      padding: CONTROL_BUTTON_PADDING
    };
  }, []);
  const items = useMemo94(() => {
    const divider = {
      type: "divider",
      id: "divider"
    };
    const values = commonPlaybackRates.map((newPlaybackRate) => {
      return {
        id: String(newPlaybackRate),
        label: getPlaybackRateLabel(newPlaybackRate),
        onClick: () => {
          return setPlaybackRate(() => {
            persistPlaybackRate(newPlaybackRate);
            return newPlaybackRate;
          });
        },
        type: "item",
        value: newPlaybackRate,
        keyHint: null,
        leftItem: String(playbackRate) === String(newPlaybackRate) ? /* @__PURE__ */ jsx170(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null
      };
    });
    const middle = Math.floor(commonPlaybackRates.length / 2);
    return [...values.slice(0, middle), divider, ...values.slice(middle)];
  }, [playbackRate, setPlaybackRate]);
  if (isStill || canvasContent === null || canvasContent.type === "asset") {
    return null;
  }
  return /* @__PURE__ */ jsx170("div", {
    style: style9,
    "aria-label": accessibilityLabel5,
    children: /* @__PURE__ */ jsx170(Combobox, {
      title: accessibilityLabel5,
      style: comboStyle2,
      selectedId: String(playbackRate),
      values: items
    })
  });
};

// src/components/PlayPause.tsx
import { PlayerInternals as PlayerInternals13 } from "@remotion/player";
import { useCallback as useCallback89, useEffect as useEffect59, useState as useState60 } from "react";
import { Internals as Internals42 } from "remotion";

// src/icons/jump-to-start.tsx
import { jsx as jsx171 } from "react/jsx-runtime";
var JumpToStart = (props) => {
  return /* @__PURE__ */ jsx171("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ...props,
    children: /* @__PURE__ */ jsx171("path", {
      fill: "currentColor",
      d: "M0 415.1V96.03c0-17.67 14.33-31.1 31.1-31.1C49.67 64.03 64 78.36 64 96.03v131.8l171.5-156.5C256.1 54.28 288 68.66 288 96.03v131.9l171.5-156.5C480.1 54.28 512 68.66 512 96.03v319.9c0 27.37-31.88 41.74-52.5 24.62L288 285.2v130.7c0 27.37-31.88 41.74-52.5 24.62L64 285.2v130.7c0 17.67-14.33 31.1-31.1 31.1C14.33 447.1 0 433.6 0 415.1z"
    })
  });
};

// src/icons/pause.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
var Pause = (props) => /* @__PURE__ */ jsx172("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "pause",
  className: "svg-inline--fa fa-pause fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: /* @__PURE__ */ jsx172("path", {
    fill: "currentColor",
    d: "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
  })
});

// src/icons/play.tsx
import { jsx as jsx173 } from "react/jsx-runtime";
var Play = (props) => /* @__PURE__ */ jsx173("svg", {
  ...props,
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "play",
  className: "svg-inline--fa fa-play fa-w-14",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  children: /* @__PURE__ */ jsx173("path", {
    fill: "currentColor",
    d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
  })
});

// src/icons/step-back.tsx
import { jsx as jsx174 } from "react/jsx-runtime";
var StepBack = (props) => {
  return /* @__PURE__ */ jsx174("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx174("path", {
      fill: "currentColor",
      d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    })
  });
};

// src/icons/step-forward.tsx
import { jsx as jsx175 } from "react/jsx-runtime";
var StepForward = (props) => {
  return /* @__PURE__ */ jsx175("svg", {
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx175("path", {
      fill: "currentColor",
      d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    })
  });
};

// src/components/PlayPause.tsx
import { jsx as jsx176, jsxs as jsxs81, Fragment as Fragment22 } from "react/jsx-runtime";
var backStyle = {
  height: 18,
  color: "white"
};
var forwardBackStyle = {
  height: 16,
  color: "white"
};
var iconButton = {
  height: 14,
  width: 14,
  color: "white"
};
var PlayPause = ({ playbackRate, loop, bufferStateDelayInMilliseconds }) => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals42.useUnsafeVideoConfig();
  const [showBufferIndicator, setShowBufferState] = useState60(false);
  const {
    playing,
    play,
    pause,
    pauseAndReturnToPlayStart,
    frameBack,
    seek,
    frameForward,
    isLastFrame,
    isFirstFrame,
    emitter,
    getCurrentFrame: getCurrentFrame2
  } = PlayerInternals13.usePlayer();
  PlayerInternals13.usePlayback({
    loop,
    playbackRate,
    moveToBeginningWhenEnded: true,
    inFrame,
    outFrame,
    getCurrentFrame: getCurrentFrame2,
    browserMediaControlsBehavior: {
      mode: "register-media-session"
    }
  });
  const isStill = useIsStill();
  useEffect59(() => {
    if (isStill) {
      pause();
    }
  }, [isStill, pause]);
  const onSpace = useCallback89((e) => {
    if (playing) {
      pause();
    } else {
      play();
    }
    e.preventDefault();
  }, [pause, play, playing]);
  const onEnter = useCallback89((e) => {
    if (playing) {
      e.preventDefault();
      pauseAndReturnToPlayStart();
    }
  }, [pauseAndReturnToPlayStart, playing]);
  const onArrowLeft = useCallback89((e) => {
    e.preventDefault();
    if (e.altKey) {
      seek(0);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: 0
      });
    } else if (e.shiftKey) {
      frameBack(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame2() - getCurrentFps())
      });
    } else {
      frameBack(1);
      ensureFrameIsInViewport({
        direction: "fit-left",
        durationInFrames: getCurrentDuration(),
        frame: Math.max(0, getCurrentFrame2() - 1)
      });
    }
  }, [frameBack, seek, getCurrentFrame2]);
  const onArrowRight = useCallback89((e) => {
    if (e.altKey) {
      seek(getCurrentDuration() - 1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration() - 1,
        frame: getCurrentDuration() - 1
      });
    } else if (e.shiftKey) {
      frameForward(getCurrentFps());
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame2() + getCurrentFps())
      });
    } else {
      frameForward(1);
      ensureFrameIsInViewport({
        direction: "fit-right",
        durationInFrames: getCurrentDuration(),
        frame: Math.min(getCurrentDuration() - 1, getCurrentFrame2() + 1)
      });
    }
    e.preventDefault();
  }, [frameForward, seek, getCurrentFrame2]);
  const oneFrameBack = useCallback89(() => {
    frameBack(1);
  }, [frameBack]);
  const oneFrameForward = useCallback89(() => {
    frameForward(1);
  }, [frameForward]);
  const jumpToStart = useCallback89(() => {
    seek(inFrame ?? 0);
  }, [seek, inFrame]);
  const jumpToEnd = useCallback89(() => {
    seek(outFrame ?? getCurrentDuration() - 1);
  }, [seek, outFrame]);
  const keybindings = useKeybinding();
  useEffect59(() => {
    const arrowLeft = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowLeft",
      callback: onArrowLeft,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const arrowRight = keybindings.registerKeybinding({
      event: "keydown",
      key: "ArrowRight",
      callback: onArrowRight,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const space = keybindings.registerKeybinding({
      event: "keydown",
      key: " ",
      callback: onSpace,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const enter = keybindings.registerKeybinding({
      event: "keydown",
      key: "enter",
      callback: onEnter,
      commandCtrlKey: false,
      preventDefault: false,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const a = keybindings.registerKeybinding({
      event: "keydown",
      key: "a",
      callback: jumpToStart,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const e = keybindings.registerKeybinding({
      event: "keydown",
      key: "e",
      callback: jumpToEnd,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      arrowLeft.unregister();
      arrowRight.unregister();
      space.unregister();
      enter.unregister();
      a.unregister();
      e.unregister();
    };
  }, [
    jumpToEnd,
    jumpToStart,
    keybindings,
    onArrowLeft,
    onArrowRight,
    onEnter,
    onSpace
  ]);
  useEffect59(() => {
    let timeout = null;
    let stopped = false;
    const onBuffer = () => {
      requestAnimationFrame(() => {
        stopped = false;
        timeout = setTimeout(() => {
          if (!stopped) {
            setShowBufferState(true);
          }
        }, bufferStateDelayInMilliseconds);
      });
    };
    const onResume = () => {
      requestAnimationFrame(() => {
        setShowBufferState(false);
        stopped = true;
        if (timeout) {
          clearTimeout(timeout);
        }
      });
    };
    emitter.addEventListener("waiting", onBuffer);
    emitter.addEventListener("resume", onResume);
    return () => {
      emitter.removeEventListener("waiting", onBuffer);
      emitter.removeEventListener("resume", onResume);
      setShowBufferState(false);
      if (timeout) {
        clearTimeout(timeout);
      }
      stopped = true;
    };
  }, [bufferStateDelayInMilliseconds, emitter]);
  return /* @__PURE__ */ jsxs81(Fragment22, {
    children: [
      /* @__PURE__ */ jsx176(ControlButton, {
        "aria-label": "Jump to beginning",
        title: "Jump to beginning",
        disabled: !videoConfig || isFirstFrame,
        onClick: jumpToStart,
        children: /* @__PURE__ */ jsx176(JumpToStart, {
          style: backStyle
        })
      }),
      /* @__PURE__ */ jsx176(ControlButton, {
        "aria-label": "Step back one frame",
        title: "Step back one frame",
        disabled: !videoConfig || isFirstFrame,
        onClick: oneFrameBack,
        children: /* @__PURE__ */ jsx176(StepBack, {
          style: forwardBackStyle
        })
      }),
      /* @__PURE__ */ jsx176(ControlButton, {
        "aria-label": playing ? "Pause" : "Play",
        title: playing ? "Pause" : "Play",
        onClick: playing ? pause : play,
        disabled: !videoConfig,
        children: playing ? showBufferIndicator ? /* @__PURE__ */ jsx176(PlayerInternals13.BufferingIndicator, {
          type: "studio"
        }) : /* @__PURE__ */ jsx176(Pause, {
          style: iconButton
        }) : /* @__PURE__ */ jsx176(Play, {
          style: iconButton
        })
      }),
      /* @__PURE__ */ jsx176(ControlButton, {
        "aria-label": "Step forward one frame",
        title: "Step forward one frame",
        disabled: !videoConfig || isLastFrame,
        onClick: oneFrameForward,
        children: /* @__PURE__ */ jsx176(StepForward, {
          style: forwardBackStyle
        })
      })
    ]
  });
};

// src/components/RenderButton.tsx
import { PlayerInternals as PlayerInternals14 } from "@remotion/player";
import { useCallback as useCallback90, useContext as useContext55, useMemo as useMemo95, useRef as useRef31, useState as useState61 } from "react";
import ReactDOM8 from "react-dom";
import { Internals as Internals43 } from "remotion";
import { jsx as jsx177, jsxs as jsxs82, Fragment as Fragment23 } from "react/jsx-runtime";
var splitButtonContainer = {
  display: "inline-flex",
  flexDirection: "row",
  alignItems: "stretch",
  borderRadius: 4,
  border: `1px solid ${INPUT_BORDER_COLOR_UNHOVERED}`,
  backgroundColor: INPUT_BACKGROUND,
  overflow: "hidden"
};
var mainButtonStyle = {
  paddingLeft: 7,
  paddingRight: 7,
  paddingTop: 7,
  paddingBottom: 7,
  background: "transparent",
  border: "none",
  color: "white",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  fontSize: 14,
  fontFamily: "inherit"
};
var dividerStyle = {
  width: 1,
  backgroundColor: INPUT_BORDER_COLOR_UNHOVERED,
  alignSelf: "stretch"
};
var dropdownTriggerStyle = {
  paddingLeft: 6,
  paddingRight: 6,
  paddingTop: 7,
  paddingBottom: 7,
  background: "transparent",
  border: "none",
  color: "white",
  cursor: "pointer",
  display: "flex",
  alignItems: "center"
};
var mainButtonContent = {
  paddingLeft: 4,
  paddingRight: 6
};
var label7 = {
  fontSize: 14
};
var RENDER_TYPE_STORAGE_KEY = "remotion.renderType";
var getInitialRenderType = (readOnlyStudio) => {
  if (!SHOW_BROWSER_RENDERING) {
    return readOnlyStudio ? "render-command" : "server-render";
  }
  if (readOnlyStudio) {
    return "client-render";
  }
  try {
    const stored = localStorage.getItem(RENDER_TYPE_STORAGE_KEY);
    if (stored === "server-render" || stored === "client-render") {
      return stored;
    }
  } catch {}
  return "server-render";
};
var RenderButton = ({
  readOnlyStudio
}) => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setSelectedModal } = useContext55(ModalsContext);
  const [preferredRenderType, setPreferredRenderType] = useState61(() => getInitialRenderType(readOnlyStudio));
  const [dropdownOpened, setDropdownOpened] = useState61(false);
  const dropdownRef = useRef31(null);
  const containerRef = useRef31(null);
  const { currentZIndex } = useZIndex();
  const size4 = PlayerInternals14.useElementSize(dropdownRef, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const refresh = size4?.refresh;
  const onPointerDown = useCallback90(() => {
    setDropdownOpened((o) => {
      if (!o) {
        refresh?.();
      }
      return !o;
    });
  }, [refresh]);
  const onClickDropdown = useCallback90((e) => {
    e.stopPropagation();
    const isKeyboardInitiated = e.detail === 0;
    if (!isKeyboardInitiated) {
      return;
    }
    setDropdownOpened((o) => {
      if (!o) {
        refresh?.();
        window.addEventListener("pointerup", (evt) => {
          if (!isMenuItem(evt.target)) {
            setDropdownOpened(false);
          }
        }, {
          once: true
        });
      }
      return !o;
    });
  }, [refresh]);
  const connectionStatus = useContext55(StudioServerConnectionCtx).previewServerState.type;
  const canServerRender = connectionStatus === "connected";
  const canRender = canServerRender || SHOW_BROWSER_RENDERING || readOnlyStudio;
  const renderType = useMemo95(() => {
    if (readOnlyStudio) {
      if (!SHOW_BROWSER_RENDERING) {
        return "render-command";
      }
      return preferredRenderType === "render-command" ? "render-command" : "client-render";
    }
    if (connectionStatus === "disconnected" && SHOW_BROWSER_RENDERING) {
      return "client-render";
    }
    if (!SHOW_BROWSER_RENDERING) {
      return "server-render";
    }
    return preferredRenderType;
  }, [connectionStatus, preferredRenderType, readOnlyStudio]);
  const shortcut = areKeyboardShortcutsDisabled() ? "" : "(R)";
  const tooltip = renderType === "render-command" ? "Copy a CLI command to render this composition " + shortcut : canRender ? "Export the current composition " + shortcut : "Connect to the Studio server to render";
  const iconStyle4 = useMemo95(() => {
    return {
      style: {
        height: 16,
        color: "currentColor"
      }
    };
  }, []);
  const video = Internals43.useVideo();
  const getCurrentFrame2 = PlayerInternals14.useFrameImperative();
  const { props } = useContext55(Internals43.EditorPropsContext);
  const openServerRenderModal = useCallback90((copyCommandOnly) => {
    if (!video) {
      return null;
    }
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new TypeError("Expected defaults");
    }
    setSelectedModal({
      type: "server-render",
      readOnlyStudio: copyCommandOnly,
      compositionId: video.id,
      initialFrame: getCurrentFrame2(),
      initialStillImageFormat: defaults.stillImageFormat,
      initialVideoImageFormat: null,
      initialJpegQuality: defaults.jpegQuality,
      initialScale: window.remotion_renderDefaults?.scale ?? 1,
      initialLogLevel: defaults.logLevel,
      initialConcurrency: defaults.concurrency,
      maxConcurrency: defaults.maxConcurrency,
      minConcurrency: defaults.minConcurrency,
      initialMuted: defaults.muted,
      initialEnforceAudioTrack: defaults.enforceAudioTrack,
      initialProResProfile: defaults.proResProfile,
      initialx264Preset: defaults.x264Preset,
      initialPixelFormat: null,
      initialAudioBitrate: defaults.audioBitrate,
      initialVideoBitrate: defaults.videoBitrate,
      initialEveryNthFrame: defaults.everyNthFrame,
      initialNumberOfGifLoops: defaults.numberOfGifLoops,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      defaultConfigurationAudioCodec: defaults.audioCodec,
      initialEnvVariables: window.process.env,
      initialDisableWebSecurity: defaults.disableWebSecurity,
      initialDarkMode: defaults.darkMode,
      initialOpenGlRenderer: defaults.openGlRenderer,
      initialHeadless: defaults.headless,
      initialIgnoreCertificateErrors: defaults.ignoreCertificateErrors,
      initialOffthreadVideoCacheSizeInBytes: defaults.offthreadVideoCacheSizeInBytes,
      initialOffthreadVideoThreads: defaults.offthreadVideoThreads,
      defaultProps: props[video.id] ?? video.defaultProps,
      inFrameMark: inFrame,
      outFrameMark: outFrame,
      initialColorSpace: defaults.colorSpace,
      initialMultiProcessOnLinux: defaults.multiProcessOnLinux,
      defaultConfigurationVideoCodec: defaults.codec,
      initialEncodingBufferSize: defaults.encodingBufferSize,
      initialEncodingMaxRate: defaults.encodingMaxRate,
      initialUserAgent: defaults.userAgent,
      initialBeep: defaults.beepOnFinish,
      initialRepro: defaults.repro,
      initialForSeamlessAacConcatenation: defaults.forSeamlessAacConcatenation,
      renderTypeOfLastRender: null,
      defaulMetadata: defaults.metadata,
      initialHardwareAcceleration: defaults.hardwareAcceleration,
      initialChromeMode: defaults.chromeMode,
      initialMediaCacheSizeInBytes: defaults.mediaCacheSizeInBytes,
      renderDefaults: defaults
    });
  }, [video, setSelectedModal, getCurrentFrame2, props, inFrame, outFrame]);
  const openClientRenderModal = useCallback90(() => {
    if (!video) {
      return null;
    }
    const defaults = window.remotion_renderDefaults;
    if (!defaults) {
      throw new TypeError("Expected defaults");
    }
    setSelectedModal({
      type: "web-render",
      compositionId: video.id,
      initialFrame: getCurrentFrame2(),
      defaultProps: props[video.id] ?? video.defaultProps,
      inFrameMark: inFrame,
      outFrameMark: outFrame,
      initialLogLevel: defaults.logLevel,
      initialLicenseKey: defaults.publicLicenseKey,
      initialStillImageFormat: defaults.stillImageFormat,
      initialScale: defaults.scale,
      initialDelayRenderTimeout: defaults.delayRenderTimeout,
      initialDefaultOutName: null,
      initialContainer: null,
      initialVideoCodec: null,
      initialAudioCodec: null,
      initialAudioBitrate: null,
      initialVideoBitrate: null,
      initialHardwareAcceleration: null,
      initialKeyframeIntervalInSeconds: null,
      initialTransparent: null,
      initialMuted: null,
      initialMediaCacheSizeInBytes: defaults.mediaCacheSizeInBytes
    });
  }, [video, setSelectedModal, getCurrentFrame2, props, inFrame, outFrame]);
  const onClick = useCallback90(() => {
    if (renderType === "render-command") {
      openServerRenderModal(true);
      return;
    }
    if (!SHOW_BROWSER_RENDERING || renderType === "server-render") {
      openServerRenderModal(false);
    } else {
      openClientRenderModal();
    }
  }, [renderType, openServerRenderModal, openClientRenderModal]);
  const onHideDropdown = useCallback90(() => {
    setDropdownOpened(false);
  }, []);
  const handleRenderTypeChange = useCallback90((newType) => {
    setPreferredRenderType(newType);
    try {
      localStorage.setItem(RENDER_TYPE_STORAGE_KEY, newType);
    } catch {}
    setDropdownOpened(false);
    if (newType === "server-render") {
      openServerRenderModal(false);
    } else if (newType === "render-command") {
      openServerRenderModal(true);
    } else {
      openClientRenderModal();
    }
  }, [openClientRenderModal, openServerRenderModal]);
  const dropdownValues = useMemo95(() => {
    if (readOnlyStudio) {
      return [
        {
          type: "item",
          id: "client-render",
          label: "Render on web",
          value: "client-render",
          onClick: () => handleRenderTypeChange("client-render"),
          keyHint: null,
          leftItem: null,
          subMenu: null,
          quickSwitcherLabel: null
        },
        {
          type: "item",
          id: "render-command",
          label: "Render via CLI",
          value: "render-command",
          onClick: () => handleRenderTypeChange("render-command"),
          keyHint: null,
          leftItem: null,
          subMenu: null,
          quickSwitcherLabel: null
        }
      ];
    }
    return [
      {
        type: "item",
        id: "server-render",
        label: "Server-side render",
        value: "server-render",
        onClick: () => handleRenderTypeChange("server-render"),
        keyHint: null,
        leftItem: null,
        subMenu: null,
        quickSwitcherLabel: null
      },
      {
        type: "item",
        id: "client-render",
        label: "Client-side render",
        value: "client-render",
        onClick: () => handleRenderTypeChange("client-render"),
        keyHint: null,
        leftItem: null,
        subMenu: null,
        quickSwitcherLabel: null
      }
    ];
  }, [handleRenderTypeChange, readOnlyStudio]);
  const spaceToBottom = useMemo95(() => {
    const margin2 = 10;
    if (size4 && dropdownOpened) {
      return size4.windowSize.height - (size4.top + size4.height) - margin2;
    }
    return 0;
  }, [dropdownOpened, size4]);
  const spaceToTop = useMemo95(() => {
    const margin2 = 10;
    if (size4 && dropdownOpened) {
      return size4.top - margin2;
    }
    return 0;
  }, [dropdownOpened, size4]);
  const derivedMaxHeight = useMemo95(() => {
    return spaceToTop > spaceToBottom ? spaceToTop : spaceToBottom;
  }, [spaceToBottom, spaceToTop]);
  const portalStyle = useMemo95(() => {
    if (!dropdownOpened || !size4) {
      return null;
    }
    const verticalLayout = spaceToTop > spaceToBottom ? "bottom" : "top";
    return {
      ...verticalLayout === "top" ? {
        ...menuContainerTowardsBottom,
        top: size4.top + size4.height
      } : {
        ...menuContainerTowardsTop,
        bottom: size4.windowSize.height - size4.top
      },
      right: size4.windowSize.width - size4.left - size4.width
    };
  }, [dropdownOpened, size4, spaceToBottom, spaceToTop]);
  const containerStyle3 = useMemo95(() => {
    return {
      ...splitButtonContainer,
      borderColor: INPUT_BORDER_COLOR_UNHOVERED,
      opacity: canRender ? 1 : 0.7,
      cursor: canRender ? "pointer" : "inherit"
    };
  }, [canRender]);
  const renderLabel = renderType === "server-render" ? "Render" : renderType === "render-command" ? "Render via CLI" : "Render on web";
  const shouldShowDropdown = useMemo95(() => {
    if (readOnlyStudio) {
      return SHOW_BROWSER_RENDERING;
    }
    if (!SHOW_BROWSER_RENDERING) {
      return false;
    }
    return true;
  }, [readOnlyStudio]);
  if (!video) {
    return null;
  }
  return /* @__PURE__ */ jsxs82(Fragment23, {
    children: [
      /* @__PURE__ */ jsx177("button", {
        style: { display: "none" },
        id: "render-modal-button-server",
        disabled: !canServerRender,
        onClick: () => openServerRenderModal(false),
        type: "button"
      }),
      " ",
      /* @__PURE__ */ jsx177("button", {
        style: { display: "none" },
        id: "render-modal-button-client",
        onClick: openClientRenderModal,
        type: "button"
      }),
      /* @__PURE__ */ jsxs82("div", {
        ref: containerRef,
        style: containerStyle3,
        title: tooltip,
        children: [
          /* @__PURE__ */ jsx177("button", {
            type: "button",
            style: mainButtonStyle,
            onClick,
            id: "render-modal-button",
            disabled: !canRender,
            children: /* @__PURE__ */ jsxs82(Row, {
              align: "center",
              style: mainButtonContent,
              children: [
                /* @__PURE__ */ jsx177(ThinRenderIcon, {
                  fill: "currentcolor",
                  svgProps: iconStyle4
                }),
                /* @__PURE__ */ jsx177(Spacing, {
                  x: 1
                }),
                /* @__PURE__ */ jsx177("span", {
                  style: label7,
                  children: renderLabel
                })
              ]
            })
          }),
          shouldShowDropdown ? /* @__PURE__ */ jsxs82(Fragment23, {
            children: [
              /* @__PURE__ */ jsx177("div", {
                style: dividerStyle
              }),
              /* @__PURE__ */ jsx177("button", {
                ref: dropdownRef,
                type: "button",
                style: dropdownTriggerStyle,
                disabled: !readOnlyStudio && connectionStatus !== "connected",
                className: MENU_INITIATOR_CLASSNAME,
                onPointerDown,
                onClick: onClickDropdown,
                children: /* @__PURE__ */ jsx177(CaretDown, {})
              })
            ]
          }) : null
        ]
      }),
      portalStyle ? ReactDOM8.createPortal(/* @__PURE__ */ jsx177("div", {
        style: fullScreenOverlay,
        children: /* @__PURE__ */ jsx177("div", {
          style: outerPortal,
          className: "css-reset",
          children: /* @__PURE__ */ jsx177(HigherZIndex, {
            onOutsideClick: onHideDropdown,
            onEscape: onHideDropdown,
            children: /* @__PURE__ */ jsx177("div", {
              style: portalStyle,
              children: /* @__PURE__ */ jsx177(MenuContent, {
                onNextMenu: () => {},
                onPreviousMenu: () => {},
                values: dropdownValues,
                onHide: onHideDropdown,
                leaveLeftSpace: false,
                preselectIndex: dropdownValues.findIndex((v) => v.id === renderType),
                topItemCanBeUnselected: false,
                fixedHeight: derivedMaxHeight
              })
            })
          })
        })
      }), getPortal(currentZIndex)) : null
    ]
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import { useCallback as useCallback91, useContext as useContext56 } from "react";
import { Internals as Internals44 } from "remotion";

// src/icons/minus.tsx
import { jsx as jsx178 } from "react/jsx-runtime";
var Minus = (props) => {
  return /* @__PURE__ */ jsx178("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx178("path", {
      fill: "currentColor",
      d: "M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"
    })
  });
};

// src/components/Timeline/TimelineZoomControls.tsx
import { jsx as jsx179, jsxs as jsxs83 } from "react/jsx-runtime";
var container35 = {
  color: "black",
  flexDirection: "row",
  display: "flex",
  alignItems: "center"
};
var buttonStyle3 = {
  fontSize: 24
};
var iconStyle4 = {
  color: "white",
  width: 14
};
var TimelineZoomControls = () => {
  const { canvasContent } = useContext56(Internals44.CompositionManager);
  const { setZoom, zoom: zoomMap } = useContext56(TimelineZoomCtx);
  const { tabIndex } = useZIndex();
  const onMinusClicked = useCallback91(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.max(TIMELINE_MIN_ZOOM, z - 0.2));
  }, [canvasContent, setZoom]);
  const onPlusClicked = useCallback91(() => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, (z) => Math.min(TIMELINE_MAX_ZOOM, z + 0.2));
  }, [canvasContent, setZoom]);
  const onChange = useCallback91((e) => {
    if (canvasContent === null || canvasContent.type !== "composition") {
      return;
    }
    setZoom(canvasContent.compositionId, () => Number(e.target.value));
  }, [canvasContent, setZoom]);
  const isStill = useIsStill();
  if (isStill || canvasContent === null || canvasContent.type !== "composition") {
    return null;
  }
  const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
  return /* @__PURE__ */ jsxs83("div", {
    style: container35,
    children: [
      /* @__PURE__ */ jsx179(ControlButton, {
        onClick: onMinusClicked,
        style: buttonStyle3,
        title: "Zoom out timeline",
        role: "ControlButton",
        type: "button",
        disabled: TIMELINE_MIN_ZOOM === zoom,
        children: /* @__PURE__ */ jsx179(Minus, {
          style: iconStyle4
        })
      }),
      /* @__PURE__ */ jsx179(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx179("input", {
        title: `Timeline zoom (${zoom}x)`,
        alt: `Timeline zoom (${zoom}x)`,
        type: "range",
        min: TIMELINE_MIN_ZOOM,
        step: 0.1,
        value: zoom,
        max: TIMELINE_MAX_ZOOM,
        onChange,
        className: "__remotion-timeline-slider",
        tabIndex
      }),
      /* @__PURE__ */ jsx179(Spacing, {
        x: 0.5
      }),
      /* @__PURE__ */ jsx179(ControlButton, {
        onClick: onPlusClicked,
        style: buttonStyle3,
        title: "Zoom in timeline",
        role: "button",
        type: "button",
        disabled: TIMELINE_MAX_ZOOM === zoom,
        children: /* @__PURE__ */ jsx179(Plus, {
          color: "currentcolor",
          style: iconStyle4
        })
      })
    ]
  });
};

// src/components/PreviewToolbar.tsx
import { jsx as jsx180, jsxs as jsxs84, Fragment as Fragment24 } from "react/jsx-runtime";
var TOOLBAR_HEIGHT = 56;
var container36 = {
  display: "flex",
  justifyContent: "center",
  borderTop: "1px solid rgba(0, 0, 0, 0.5)",
  paddingTop: 2,
  paddingBottom: 2,
  alignItems: "center",
  flexDirection: "row",
  background: BACKGROUND,
  height: TOOLBAR_HEIGHT
};
var mobileContainer = {
  ...container36,
  position: "relative",
  overflowY: "auto",
  justifyContent: "flex-start"
};
var scrollIndicatorLeft = {
  position: "fixed",
  display: "none",
  top: 0,
  left: 0,
  width: 40,
  height: "100%",
  pointerEvents: "none",
  background: `linear-gradient(to right, ${BACKGROUND}, ${BACKGROUND__TRANSPARENT})`
};
var scrollIndicatorRight = {
  position: "fixed",
  display: "none",
  top: 0,
  right: 0,
  width: 40,
  height: "100%",
  pointerEvents: "none",
  background: `linear-gradient(to left, ${BACKGROUND}, ${BACKGROUND__TRANSPARENT})`
};
var sideContainer = {
  width: 300,
  height: 38,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var padding2 = {
  width: TIMELINE_PADDING
};
var PreviewToolbar = ({ readOnlyStudio, bufferStateDelayInMilliseconds }) => {
  const { playbackRate, setPlaybackRate } = Internals45.useTimelineContext();
  const { mediaMuted } = useContext57(Internals45.MediaVolumeContext);
  const { setMediaMuted } = useContext57(Internals45.SetMediaVolumeContext);
  const { canvasContent } = useContext57(Internals45.CompositionManager);
  const isVideoComposition = useIsVideoComposition();
  const previewToolbarRef = useRef32(null);
  const leftScrollIndicatorRef = useRef32(null);
  const rightScrollIndicatorRef = useRef32(null);
  const isStill = useIsStill();
  const [loop, setLoop] = useState62(loadLoopOption());
  const isFullscreenSupported = checkFullscreenSupport();
  const isMobileLayout = useMobileLayout();
  useEffect60(() => {
    if (isMobileLayout && previewToolbarRef.current) {
      const updateScrollableIndicatorProps = (target) => {
        const boundingBox = target.getBoundingClientRect();
        const { scrollLeft, scrollWidth, clientWidth } = target;
        const scrollRight = scrollWidth - clientWidth - scrollLeft;
        if (!leftScrollIndicatorRef.current || !rightScrollIndicatorRef.current) {
          return;
        }
        if (scrollLeft !== 0) {
          Object.assign(leftScrollIndicatorRef.current.style, {
            display: "block",
            height: `${boundingBox.height}px`,
            top: `${boundingBox.top}px`,
            left: `${boundingBox.left}px`
          });
        } else {
          Object.assign(leftScrollIndicatorRef.current.style, {
            display: "none"
          });
        }
        if (scrollRight !== 0) {
          const itemWidth = rightScrollIndicatorRef.current?.clientWidth || 0;
          Object.assign(rightScrollIndicatorRef.current.style, {
            display: "block",
            height: `${boundingBox.height}px`,
            top: `${boundingBox.top}px`,
            left: `${boundingBox.left + boundingBox.width - itemWidth}px`
          });
        } else {
          Object.assign(rightScrollIndicatorRef.current.style, {
            display: "none"
          });
        }
      };
      const previewToolbar = previewToolbarRef.current;
      const scrollHandler = () => {
        updateScrollableIndicatorProps(previewToolbar);
      };
      previewToolbar.addEventListener("scroll", scrollHandler);
      scrollHandler();
      return () => {
        previewToolbar.removeEventListener("scroll", scrollHandler);
      };
    }
  });
  return /* @__PURE__ */ jsxs84("div", {
    ref: previewToolbarRef,
    style: isMobileLayout ? mobileContainer : container36,
    className: "css-reset",
    children: [
      /* @__PURE__ */ jsx180("div", {
        ref: leftScrollIndicatorRef,
        style: scrollIndicatorLeft
      }),
      isMobileLayout ? null : /* @__PURE__ */ jsxs84(Fragment24, {
        children: [
          /* @__PURE__ */ jsxs84("div", {
            style: sideContainer,
            children: [
              /* @__PURE__ */ jsx180("div", {
                style: padding2
              }),
              /* @__PURE__ */ jsx180(TimelineZoomControls, {})
            ]
          }),
          /* @__PURE__ */ jsx180(Flex, {}),
          /* @__PURE__ */ jsx180(SizeSelector, {}),
          isStill || isVideoComposition ? /* @__PURE__ */ jsx180(PlaybackRateSelector, {
            setPlaybackRate,
            playbackRate
          }) : null
        ]
      }),
      isVideoComposition ? /* @__PURE__ */ jsxs84(Fragment24, {
        children: [
          /* @__PURE__ */ jsx180(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx180(PlayPause, {
            bufferStateDelayInMilliseconds,
            loop,
            playbackRate
          }),
          /* @__PURE__ */ jsx180(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx180(LoopToggle, {
            loop,
            setLoop
          }),
          /* @__PURE__ */ jsx180(MuteToggle, {
            muted: mediaMuted,
            setMuted: setMediaMuted
          }),
          /* @__PURE__ */ jsx180(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx180(TimelineInOutPointToggle, {}),
          /* @__PURE__ */ jsx180(Spacing, {
            x: 2
          })
        ]
      }) : null,
      canvasContent?.type === "composition" ? /* @__PURE__ */ jsx180(CheckboardToggle, {}) : null,
      /* @__PURE__ */ jsx180(Spacing, {
        x: 1
      }),
      canvasContent && isFullscreenSupported ? /* @__PURE__ */ jsx180(FullScreenToggle, {}) : null,
      /* @__PURE__ */ jsx180(Flex, {}),
      isMobileLayout && /* @__PURE__ */ jsxs84(Fragment24, {
        children: [
          /* @__PURE__ */ jsx180(Flex, {}),
          /* @__PURE__ */ jsx180(SizeSelector, {}),
          isStill || isVideoComposition ? /* @__PURE__ */ jsx180(PlaybackRateSelector, {
            setPlaybackRate,
            playbackRate
          }) : null
        ]
      }),
      /* @__PURE__ */ jsxs84("div", {
        style: sideContainer,
        children: [
          /* @__PURE__ */ jsx180(Flex, {}),
          !isMobileLayout && /* @__PURE__ */ jsx180(FpsCounter, {
            playbackSpeed: playbackRate
          }),
          /* @__PURE__ */ jsx180(Spacing, {
            x: 2
          }),
          /* @__PURE__ */ jsx180(RenderButton, {
            readOnlyStudio
          }),
          /* @__PURE__ */ jsx180(Spacing, {
            x: 1.5
          })
        ]
      }),
      /* @__PURE__ */ jsx180(PlaybackKeyboardShortcutsManager, {
        setPlaybackRate
      }),
      /* @__PURE__ */ jsx180(PlaybackRatePersistor, {}),
      /* @__PURE__ */ jsx180("div", {
        ref: rightScrollIndicatorRef,
        style: scrollIndicatorRight
      })
    ]
  });
};

// src/components/Splitter/SplitterContainer.tsx
import { useMemo as useMemo96, useRef as useRef33, useState as useState63 } from "react";

// src/state/timeline.ts
var localStorageKey4 = (id) => `remotion.editor.timelineFlex.${id}`;
var persistTimelineFlex = (value, id) => {
  localStorage.setItem(localStorageKey4(id), String(value));
};
var loadTimelineFlex = (id) => {
  const item2 = localStorage.getItem(localStorageKey4(id));
  return item2 ? parseFloat(item2) : null;
};
var useTimelineFlex = (id) => {
  return [
    loadTimelineFlex(id),
    (value) => persistTimelineFlex(value, id)
  ];
};

// src/components/Splitter/SplitterContext.tsx
import React120 from "react";
var SplitterContext = React120.createContext({
  flexValue: 1,
  ref: { current: null },
  setFlexValue: () => {
    return;
  },
  isDragging: { current: false },
  orientation: "horizontal",
  maxFlex: 1,
  minFlex: 1,
  defaultFlex: 1,
  id: "--",
  persistFlex: () => {
    return;
  }
});

// src/components/Splitter/SplitterContainer.tsx
import { jsx as jsx181 } from "react/jsx-runtime";
var containerRow = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  height: "100%",
  width: "100%"
};
var containerColumn = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var SplitterContainer = ({ orientation, children, defaultFlex, maxFlex, minFlex, id }) => {
  const [initialTimelineFlex, persistFlex] = useTimelineFlex(id);
  const [flexValue, setFlexValue] = useState63(initialTimelineFlex ?? defaultFlex);
  const ref = useRef33(null);
  const isDragging = useRef33(false);
  const value = useMemo96(() => {
    return {
      flexValue,
      ref,
      setFlexValue,
      isDragging,
      orientation,
      id,
      maxFlex,
      minFlex,
      defaultFlex,
      persistFlex
    };
  }, [
    defaultFlex,
    flexValue,
    id,
    maxFlex,
    minFlex,
    orientation,
    persistFlex,
    ref
  ]);
  return /* @__PURE__ */ jsx181(SplitterContext.Provider, {
    value,
    children: /* @__PURE__ */ jsx181("div", {
      ref,
      style: orientation === "horizontal" ? containerColumn : containerRow,
      children
    })
  });
};

// src/components/Splitter/SplitterElement.tsx
import { useContext as useContext58, useMemo as useMemo97 } from "react";
import { interpolateColors, random } from "remotion";
import { jsx as jsx182, jsxs as jsxs85, Fragment as Fragment25 } from "react/jsx-runtime";
var SplitterElement = ({ children, type, sticky }) => {
  const context = useContext58(SplitterContext);
  const style9 = useMemo97(() => {
    return {
      flex: (type === "flexer" ? context.flexValue : 1 - context.flexValue) * 1000,
      display: "flex",
      position: "relative",
      overflow: "hidden",
      flexDirection: "column"
    };
  }, [context.flexValue, type]);
  const stickStyle = useMemo97(() => {
    return {
      position: "absolute",
      left: (type === "flexer" ? 0 : context.flexValue) * 100 + "%",
      width: (type === "flexer" ? context.flexValue : 1 - context.flexValue) * 100 + "%",
      backgroundColor: interpolateColors(random(context.flexValue), [0, 1], ["red", "blue"])
    };
  }, [context.flexValue, type]);
  return /* @__PURE__ */ jsxs85(Fragment25, {
    children: [
      /* @__PURE__ */ jsx182("div", {
        style: style9,
        children
      }),
      /* @__PURE__ */ jsx182("div", {
        style: stickStyle,
        children: sticky ?? null
      })
    ]
  });
};

// src/components/Splitter/SplitterHandle.tsx
import { PlayerInternals as PlayerInternals15 } from "@remotion/player";
import { useContext as useContext59, useEffect as useEffect61, useRef as useRef34, useState as useState64 } from "react";
import { jsx as jsx183 } from "react/jsx-runtime";
var SPLITTER_HANDLE_SIZE = 3;
var containerRow2 = {
  height: SPLITTER_HANDLE_SIZE
};
var containerColumn2 = {
  width: SPLITTER_HANDLE_SIZE
};
var SplitterHandle = ({ allowToCollapse, onCollapse }) => {
  const context = useContext59(SplitterContext);
  if (!context) {
    throw new Error("Cannot find splitter context");
  }
  const [lastPointerUp, setLastPointerUp] = useState64(() => Date.now());
  const ref = useRef34(null);
  useEffect61(() => {
    if (context.isDragging.current) {
      return;
    }
    const { current } = ref;
    if (!current) {
      return;
    }
    const getNewValue = (e, clamp) => {
      if (!context.isDragging.current) {
        throw new Error("cannot get value if not dragging");
      }
      if (!context.ref.current) {
        throw new Error("domRect is not mounted");
      }
      const { width, height } = context.ref.current.getBoundingClientRect();
      const change = (() => {
        if (context.orientation === "vertical") {
          return (e.clientX - context.isDragging.current.x) / (width - SPLITTER_HANDLE_SIZE);
        }
        return (e.clientY - context.isDragging.current.y) / (height - SPLITTER_HANDLE_SIZE);
      })();
      const newFlex = context.flexValue + change;
      if (clamp) {
        return Math.min(context.maxFlex, Math.max(context.minFlex, newFlex));
      }
      return newFlex;
    };
    const onPointerDown = (e) => {
      if (e.button !== 0) {
        return;
      }
      context.isDragging.current = {
        x: e.clientX,
        y: e.clientY
      };
      ref.current?.classList.add("remotion-splitter-active");
      window.addEventListener("pointerup", (ev) => {
        if (!context.isDragging.current) {
          return;
        }
        context.persistFlex(getNewValue(ev, true));
        cleanup();
        setLastPointerUp(Date.now());
      }, { once: true });
      window.addEventListener("pointermove", onPointerMove);
    };
    const onPointerMove = (e) => {
      if (context.isDragging.current) {
        const val = getNewValue(e, true);
        context.setFlexValue(val);
        if (allowToCollapse === "left") {
          const unclamped = getNewValue(e, false);
          if (unclamped < context.minFlex / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
        if (allowToCollapse === "right") {
          const unclamped = 1 - getNewValue(e, false);
          if (unclamped < (1 - context.maxFlex) / 2) {
            cleanup();
            onCollapse();
            setLastPointerUp(Date.now());
          }
        }
      }
    };
    const cleanup = () => {
      context.isDragging.current = false;
      ref.current?.classList.remove("remotion-splitter-active");
      current.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      PlayerInternals15.updateAllElementsSizes();
    };
    current.addEventListener("pointerdown", onPointerDown);
    return () => {
      if (!context.isDragging.current) {
        cleanup();
      }
    };
  }, [allowToCollapse, context, context.flexValue, lastPointerUp, onCollapse]);
  useEffect61(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    let isMouseDown = false;
    const onMouseDown = () => {
      isMouseDown = true;
    };
    const onMouseUp = () => {
      isMouseDown = false;
    };
    const onMouseEnter = (e) => {
      if (e.button !== 0) {
        return;
      }
      if (isMouseDown) {
        return;
      }
      current.classList.add("remotion-splitter-hover");
    };
    const onMouseLeave = (e) => {
      if (e.button !== 0) {
        return;
      }
      current.classList.remove("remotion-splitter-hover");
    };
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, []);
  return /* @__PURE__ */ jsx183("div", {
    ref,
    className: [
      "remotion-splitter",
      context.orientation === "horizontal" ? "remotion-splitter-horizontal" : "remotion-splitter-vertical"
    ].join(" "),
    style: context.orientation === "horizontal" ? containerRow2 : containerColumn2
  });
};

// src/components/TopPanel.tsx
import { jsx as jsx184, jsxs as jsxs86 } from "react/jsx-runtime";
var container37 = {
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1
};
var row5 = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  minHeight: 0
};
var useResponsiveSidebarStatus = () => {
  const { sidebarCollapsedStateLeft } = useContext60(SidebarContext);
  const responsiveLeftStatus = useBreakpoint(1200) ? "collapsed" : "expanded";
  const actualStateLeft = useMemo98(() => {
    if (sidebarCollapsedStateLeft === "collapsed") {
      return "collapsed";
    }
    if (sidebarCollapsedStateLeft === "expanded") {
      return "expanded";
    }
    return responsiveLeftStatus;
  }, [sidebarCollapsedStateLeft, responsiveLeftStatus]);
  return actualStateLeft;
};
var TopPanel = ({ readOnlyStudio, onMounted, drawRef: drawRef2, bufferStateDelayInMilliseconds }) => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext60(SidebarContext);
  const rulersAreVisible = useIsRulerVisible();
  const actualStateLeft = useResponsiveSidebarStatus();
  const actualStateRight = useMemo98(() => {
    if (sidebarCollapsedStateRight === "collapsed") {
      return "collapsed";
    }
    return "expanded";
  }, [sidebarCollapsedStateRight]);
  useEffect62(() => {
    onMounted();
  }, [onMounted]);
  const canvasContainerStyle = useMemo98(() => ({
    flex: 1,
    display: "flex",
    paddingTop: rulersAreVisible ? RULER_WIDTH : 0,
    paddingLeft: rulersAreVisible ? RULER_WIDTH : 0
  }), [rulersAreVisible]);
  const onCollapseLeft = useCallback92(() => {
    setSidebarCollapsedState({ left: "collapsed", right: null });
  }, [setSidebarCollapsedState]);
  const onCollapseRight = useCallback92(() => {
    setSidebarCollapsedState({ left: null, right: "collapsed" });
  }, [setSidebarCollapsedState]);
  const isMobileLayout = useMobileLayout();
  return /* @__PURE__ */ jsxs86("div", {
    style: container37,
    children: [
      /* @__PURE__ */ jsx184("div", {
        style: row5,
        children: /* @__PURE__ */ jsxs86(SplitterContainer, {
          minFlex: 0.15,
          maxFlex: 0.4,
          defaultFlex: 0.2,
          id: "sidebar-to-preview",
          orientation: "vertical",
          children: [
            actualStateLeft === "expanded" ? isMobileLayout ? /* @__PURE__ */ jsx184(MobilePanel, {
              onClose: onCollapseLeft,
              children: /* @__PURE__ */ jsx184(ExplorerPanel, {
                readOnlyStudio
              })
            }) : /* @__PURE__ */ jsx184(SplitterElement, {
              sticky: null,
              type: "flexer",
              children: /* @__PURE__ */ jsx184(ExplorerPanel, {
                readOnlyStudio
              })
            }) : null,
            actualStateLeft === "expanded" ? /* @__PURE__ */ jsx184(SplitterHandle, {
              allowToCollapse: "left",
              onCollapse: onCollapseLeft
            }) : null,
            /* @__PURE__ */ jsx184(SplitterElement, {
              sticky: null,
              type: "anti-flexer",
              children: /* @__PURE__ */ jsxs86(SplitterContainer, {
                minFlex: 0.5,
                maxFlex: 0.8,
                defaultFlex: 0.7,
                id: "canvas-to-right-sidebar",
                orientation: "vertical",
                children: [
                  /* @__PURE__ */ jsx184(SplitterElement, {
                    sticky: null,
                    type: "flexer",
                    children: /* @__PURE__ */ jsx184("div", {
                      ref: drawRef2,
                      style: canvasContainerStyle,
                      children: /* @__PURE__ */ jsx184(CanvasIfSizeIsAvailable, {})
                    })
                  }),
                  actualStateRight === "expanded" ? /* @__PURE__ */ jsx184(SplitterHandle, {
                    allowToCollapse: "right",
                    onCollapse: onCollapseRight
                  }) : null,
                  actualStateRight === "expanded" ? isMobileLayout ? /* @__PURE__ */ jsx184(MobilePanel, {
                    onClose: onCollapseRight,
                    children: /* @__PURE__ */ jsx184(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : /* @__PURE__ */ jsx184(SplitterElement, {
                    sticky: null,
                    type: "anti-flexer",
                    children: /* @__PURE__ */ jsx184(OptionsPanel, {
                      readOnlyStudio
                    })
                  }) : null
                ]
              })
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx184(PreviewToolbar, {
        bufferStateDelayInMilliseconds,
        readOnlyStudio
      }),
      /* @__PURE__ */ jsx184(CurrentCompositionKeybindings, {
        readOnlyStudio
      }),
      /* @__PURE__ */ jsx184(TitleUpdater, {})
    ]
  });
};

// src/components/SidebarCollapserControls.tsx
import { jsx as jsx185, jsxs as jsxs87, Fragment as Fragment26 } from "react/jsx-runtime";
var style9 = {
  width: 16,
  height: 16,
  minWidth: 16,
  border: "1px solid currentColor",
  borderRadius: 3,
  color: "currentColor",
  position: "relative"
};
var SidebarCollapserControls = () => {
  const { setSidebarCollapsedState, sidebarCollapsedStateRight } = useContext61(SidebarContext);
  const keybindings = useKeybinding();
  const leftSidebarStatus = useResponsiveSidebarStatus();
  const leftIcon = useCallback93((color) => {
    return {
      width: "35%",
      height: "100%",
      borderRight: "1px solid " + color,
      background: leftSidebarStatus === "expanded" ? color : "transparent"
    };
  }, [leftSidebarStatus]);
  const rightIcon = useCallback93((color) => {
    return {
      width: "35%",
      height: "100%",
      right: 0,
      position: "absolute",
      borderLeft: "1px solid " + color,
      background: sidebarCollapsedStateRight === "expanded" ? color : "transparent"
    };
  }, [sidebarCollapsedStateRight]);
  const toggleLeft = useCallback93(() => {
    setSidebarCollapsedState({
      left: (s) => {
        if (s === "responsive") {
          return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
        }
        return s === "collapsed" ? "expanded" : "collapsed";
      },
      right: null
    });
  }, [leftSidebarStatus, setSidebarCollapsedState]);
  const toggleRight = useCallback93(() => {
    setSidebarCollapsedState({
      right: (s) => s === "collapsed" ? "expanded" : "collapsed",
      left: null
    });
  }, [setSidebarCollapsedState]);
  const toggleBoth = useCallback93(() => {
    if (sidebarCollapsedStateRight === leftSidebarStatus) {
      setSidebarCollapsedState({
        left: (s) => {
          if (s === "responsive") {
            return leftSidebarStatus === "collapsed" ? "expanded" : "collapsed";
          }
          return s === "collapsed" ? "expanded" : "collapsed";
        },
        right: (s) => s === "collapsed" ? "expanded" : "collapsed"
      });
    } else if (sidebarCollapsedStateRight === "expanded") {
      toggleRight();
    } else if (leftSidebarStatus === "expanded") {
      toggleLeft();
    }
  }, [
    leftSidebarStatus,
    setSidebarCollapsedState,
    sidebarCollapsedStateRight,
    toggleLeft,
    toggleRight
  ]);
  useEffect63(() => {
    const left3 = keybindings.registerKeybinding({
      event: "keydown",
      key: "b",
      commandCtrlKey: true,
      callback: toggleLeft,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const right2 = keybindings.registerKeybinding({
      event: "keydown",
      key: "j",
      commandCtrlKey: true,
      callback: toggleRight,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const zen = keybindings.registerKeybinding({
      event: "keydown",
      key: "g",
      commandCtrlKey: true,
      callback: toggleBoth,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      left3.unregister();
      right2.unregister();
      zen.unregister();
    };
  }, [keybindings, toggleBoth, toggleLeft, toggleRight]);
  const toggleLeftTooltip = areKeyboardShortcutsDisabled() ? "Toggle Left Sidebar" : `Toggle Left Sidebar (${cmdOrCtrlCharacter}+B)`;
  const toggleRightTooltip = areKeyboardShortcutsDisabled() ? "Toggle Right Sidebar" : `Toggle Right Sidebar (${cmdOrCtrlCharacter}+J)`;
  const colorStyle = useCallback93((color) => {
    return {
      ...style9,
      color
    };
  }, []);
  const toggleLeftAction = useCallback93((color) => {
    return /* @__PURE__ */ jsx185("div", {
      style: colorStyle(color),
      title: toggleLeftTooltip,
      children: /* @__PURE__ */ jsx185("div", {
        style: leftIcon(color)
      })
    });
  }, [colorStyle, leftIcon, toggleLeftTooltip]);
  const toggleRightAction = useCallback93((color) => {
    return /* @__PURE__ */ jsx185("div", {
      style: colorStyle(color),
      title: toggleRightTooltip,
      children: /* @__PURE__ */ jsx185("div", {
        style: rightIcon(color)
      })
    });
  }, [colorStyle, rightIcon, toggleRightTooltip]);
  return /* @__PURE__ */ jsxs87(Fragment26, {
    children: [
      /* @__PURE__ */ jsx185(InlineAction, {
        onClick: toggleLeft,
        renderAction: toggleLeftAction
      }),
      /* @__PURE__ */ jsx185(InlineAction, {
        onClick: toggleRight,
        renderAction: toggleRightAction
      })
    ]
  });
};

// src/components/UpdateCheck.tsx
import {
  useCallback as useCallback94,
  useContext as useContext62,
  useEffect as useEffect64,
  useMemo as useMemo99,
  useState as useState65
} from "react";
import { VERSION } from "remotion";
import { jsx as jsx186 } from "react/jsx-runtime";
var buttonStyle4 = {
  appearance: "none",
  color: BLUE,
  border: "none",
  fontWeight: "bold",
  backgroundColor: "transparent",
  cursor: "pointer",
  fontSize: 14,
  display: "inline-flex",
  justifyContent: "center"
};
var UpdateCheck = () => {
  const [info, setInfo] = useState65(null);
  const { setSelectedModal } = useContext62(ModalsContext);
  const { tabIndex } = useZIndex();
  const [knownBugs, setKnownBugs] = useState65(null);
  const hasKnownBugs = useMemo99(() => {
    return knownBugs && knownBugs.length > 0;
  }, [knownBugs]);
  const checkForUpdates = useCallback94(() => {
    const controller = new AbortController;
    updateAvailable(controller.signal).then((d) => {
      setInfo(d);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for updates", err);
    });
    return controller;
  }, []);
  const checkForBugs = useCallback94(() => {
    const controller = new AbortController;
    fetch(`https://bugs.remotion.dev/api/${VERSION}`, {
      signal: controller.signal
    }).then(async (res) => {
      const body = await res.json();
      setKnownBugs(body.bugs);
    }).catch((err) => {
      if (err.message.includes("aborted")) {
        return;
      }
      console.log("Could not check for bugs in this version", err);
    });
    return controller;
  }, []);
  useEffect64(() => {
    const abortUpdate = checkForUpdates();
    const abortBugs = checkForBugs();
    return () => {
      abortUpdate.abort();
      abortBugs.abort();
    };
  }, [checkForBugs, checkForUpdates]);
  const openModal = useCallback94(() => {
    setSelectedModal({
      type: "update",
      info,
      knownBugs
    });
  }, [info, knownBugs, setSelectedModal]);
  const dynButtonStyle = useMemo99(() => {
    return {
      ...buttonStyle4,
      color: hasKnownBugs ? WARNING_COLOR : LIGHT_TEXT
    };
  }, [hasKnownBugs]);
  if (!info) {
    return null;
  }
  if (!info.updateAvailable) {
    return null;
  }
  return /* @__PURE__ */ jsx186("button", {
    tabIndex,
    style: dynButtonStyle,
    onClick: openModal,
    type: "button",
    title: hasKnownBugs ? "Bugfixes available" : "Update available",
    children: hasKnownBugs ? "Bugfixes available" : /* @__PURE__ */ jsx186("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        height: 16,
        width: 16
      },
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ jsx186("path", {
        fill: "currentcolor",
        d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
      })
    })
  });
};

// src/components/MenuToolbar.tsx
import { jsx as jsx187, jsxs as jsxs88 } from "react/jsx-runtime";
var row6 = {
  alignItems: "center",
  flexDirection: "row",
  display: "flex",
  color: "white",
  borderBottom: "1px solid black",
  fontSize: 13,
  paddingLeft: 6,
  paddingRight: 10,
  backgroundColor: BACKGROUND
};
var flex2 = {
  flex: 1
};
var MenuToolbar = ({ readOnlyStudio }) => {
  const [selected, setSelected] = useState66(null);
  const mobileLayout = useMobileLayout();
  const fixedWidthRight = useMemo100(() => {
    return {
      ...mobileLayout ? { width: "fit-content" } : {
        width: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end"
    };
  }, [mobileLayout]);
  const fixedWidthLeft = useMemo100(() => {
    return {
      ...mobileLayout ? { minWidth: "0px" } : {
        minWidth: "330px"
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start"
    };
  }, [mobileLayout]);
  const itemClicked = useCallback95((itemId) => {
    setSelected(itemId);
  }, [setSelected]);
  const itemHovered = useCallback95((itemId) => {
    if (selected) {
      setSelected(itemId);
    }
  }, [selected, setSelected]);
  const closeMenu = useCallback95(() => {
    setSelected(null);
  }, []);
  const structure = useMenuStructure(closeMenu, readOnlyStudio);
  const menus = useMemo100(() => {
    return structure.map((s) => s.id);
  }, [structure]);
  const onPreviousMenu = useCallback95(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      return menus[(menus.indexOf(s) + 1) % menus.length];
    });
  }, [menus]);
  const onNextMenu = useCallback95(() => {
    setSelected((s) => {
      if (s === null) {
        return null;
      }
      if (menus.indexOf(s) === 0) {
        return menus[menus.length - 1];
      }
      return menus[(menus.indexOf(s) - 1) % menus.length];
    });
  }, [menus]);
  const onItemQuit = useCallback95(() => {
    setSelected(null);
  }, [setSelected]);
  return /* @__PURE__ */ jsxs88(Row, {
    align: "center",
    className: "css-reset",
    style: row6,
    children: [
      /* @__PURE__ */ jsxs88("div", {
        style: fixedWidthLeft,
        children: [
          structure.map((s) => {
            return /* @__PURE__ */ jsx187(MenuItem, {
              selected: selected === s.id,
              onItemSelected: itemClicked,
              onItemHovered: itemHovered,
              id: s.id,
              label: s.label,
              onItemQuit,
              menu: s,
              onPreviousMenu,
              onNextMenu,
              leaveLeftPadding: s.leaveLeftPadding
            }, s.id);
          }),
          readOnlyStudio ? null : /* @__PURE__ */ jsx187(UpdateCheck, {})
        ]
      }),
      /* @__PURE__ */ jsx187("div", {
        style: flex2
      }),
      /* @__PURE__ */ jsx187(MenuBuildIndicator, {}),
      /* @__PURE__ */ jsx187("div", {
        style: flex2
      }),
      /* @__PURE__ */ jsx187("div", {
        style: fixedWidthRight,
        children: /* @__PURE__ */ jsx187(SidebarCollapserControls, {})
      }),
      /* @__PURE__ */ jsx187(Spacing, {
        x: 1
      })
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import { useContext as useContext75, useMemo as useMemo118 } from "react";
import { Internals as Internals57 } from "remotion";

// src/helpers/get-sequence-visible-range.ts
var getCascadedStart = (sequence, sequences) => {
  if (!sequence.parent) {
    return sequence.from;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return getCascadedStart(parent, sequences) + sequence.from;
};
var getTimelineVisibleStart = (sequence, sequences) => {
  const cascadedStart = Math.max(0, getCascadedStart(sequence, sequences));
  if (!sequence.parent) {
    return cascadedStart;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  const timelineVisibleStart = getTimelineVisibleStart(parent, sequences);
  return Math.max(timelineVisibleStart, cascadedStart);
};
var getTimelineVisibleDuration = (sequence, sequences) => {
  const visibleDuration = sequence.duration + Math.min(sequence.from, 0);
  if (!sequence.parent) {
    return visibleDuration;
  }
  const parent = sequences.find((s) => s.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return Math.min(visibleDuration, getTimelineVisibleDuration(parent, sequences));
};

// src/helpers/get-timeline-nestedness.ts
var getTimelineNestedLevel = (sequence, allSequences, depth) => {
  if (!sequence.parent) {
    return depth;
  }
  const parentSequence = allSequences.find((s) => s.id === sequence.parent);
  if (!parentSequence) {
    throw new Error("has parentId but no parent");
  }
  return getTimelineNestedLevel(parentSequence, allSequences, depth + 1);
};

// src/helpers/get-timeline-sequence-hash.ts
var getTimelineSequenceHash = (sequence, allSequences, hashesUsedInRoot, cache) => {
  if (cache[sequence.id]) {
    return cache[sequence.id];
  }
  const parent = allSequences.find((a) => a.id === sequence.parent);
  const baseHash = [
    parent ? getTimelineSequenceHash(parent, allSequences, hashesUsedInRoot, cache) : null,
    sequence.displayName,
    sequence.duration,
    sequence.from,
    sequence.type,
    sequence.type === "audio" ? sequence.src : null,
    sequence.type === "audio" ? sequence.volume : null,
    sequence.type === "video" ? sequence.src : null,
    sequence.type === "video" ? sequence.volume : null
  ].join("-");
  const actualHash = baseHash + hashesUsedInRoot[sequence.rootId].filter((h) => h === baseHash).length;
  hashesUsedInRoot[sequence.rootId].push(baseHash);
  cache[sequence.id] = actualHash;
  return actualHash;
};

// src/helpers/get-timeline-sequence-sort-key.ts
var getTimelineSequenceSequenceSortKey = (track, tracks, sameHashes = {}, nonceRanks = new Map) => {
  const firstSequenceWithSameHash = tracks.find((t) => sameHashes[track.hash].includes(t.sequence.id));
  const sequenceId = firstSequenceWithSameHash.sequence.id;
  const rank = nonceRanks.get(sequenceId) ?? 0;
  const id = String(rank).padStart(6, "0");
  if (!track.sequence.parent) {
    return id;
  }
  const parent = tracks.find((t) => t.sequence.id === track.sequence.parent);
  if (!parent) {
    return id;
  }
  const firstParentWithSameHash = tracks.find((a) => {
    return sameHashes[parent.hash].includes(a.sequence.id);
  });
  if (!firstParentWithSameHash) {
    throw new Error("could not find parent: " + track.sequence.parent);
  }
  return `${getTimelineSequenceSequenceSortKey(firstParentWithSameHash, tracks, sameHashes, nonceRanks)}-${id}`;
};

// src/helpers/calculate-timeline.ts
var calculateTimeline = ({
  sequences,
  sequenceDuration
}) => {
  const sortedSequences = sortItemsByNonceHistory(sequences);
  const tracks = [];
  if (sortedSequences.length === 0) {
    return [
      {
        sequence: {
          displayName: "",
          duration: sequenceDuration,
          from: 0,
          id: "seq",
          parent: null,
          type: "sequence",
          rootId: "-",
          showInTimeline: true,
          nonce: [[0, 0]],
          loopDisplay: undefined,
          stack: null,
          premountDisplay: null,
          postmountDisplay: null,
          controls: null
        },
        depth: 0,
        hash: "-"
      }
    ];
  }
  const sameHashes = {};
  const hashesUsedInRoot = {};
  const cache = {};
  for (let i = 0;i < sortedSequences.length; i++) {
    const sequence = sortedSequences[i];
    if (!hashesUsedInRoot[sequence.rootId]) {
      hashesUsedInRoot[sequence.rootId] = [];
    }
    const actualHash = getTimelineSequenceHash(sequence, sortedSequences, hashesUsedInRoot, cache);
    if (!sameHashes[actualHash]) {
      sameHashes[actualHash] = [];
    }
    sameHashes[actualHash].push(sequence.id);
    const cascadedStart = getCascadedStart(sequence, sortedSequences);
    const visibleStart = getTimelineVisibleStart(sequence, sortedSequences);
    const visibleDuration = getTimelineVisibleDuration(sequence, sortedSequences);
    tracks.push({
      sequence: {
        ...sequence,
        from: visibleStart,
        duration: visibleDuration
      },
      depth: getTimelineNestedLevel(sequence, sortedSequences, 0),
      hash: actualHash,
      cascadedStart,
      cascadedDuration: sequence.duration
    });
  }
  const uniqueTracks = [];
  for (const track of tracks) {
    if (!uniqueTracks.find((t) => t.hash === track.hash)) {
      const { cascadedDuration, cascadedStart, ...cleanTrack } = track;
      uniqueTracks.push(cleanTrack);
    }
  }
  const nonceRanks = new Map;
  for (let i = 0;i < tracks.length; i++) {
    nonceRanks.set(tracks[i].sequence.id, i);
  }
  return uniqueTracks.sort((a, b) => {
    const sortKeyA = getTimelineSequenceSequenceSortKey(a, tracks, sameHashes, nonceRanks);
    const sortKeyB = getTimelineSequenceSequenceSortKey(b, tracks, sameHashes, nonceRanks);
    return sortKeyA.localeCompare(sortKeyB);
  });
};

// src/components/Timeline/is-collapsed.ts
var isTrackHidden = (track) => {
  if (!track.sequence.parent) {
    return false;
  }
  return !track.sequence.showInTimeline;
};

// src/components/Timeline/MaxTimelineTracks.tsx
import { DEFAULT_TIMELINE_TRACKS } from "@remotion/studio-shared";
import { jsxs as jsxs89 } from "react/jsx-runtime";
var MAX_TIMELINE_TRACKS = typeof process.env.MAX_TIMELINE_TRACKS === "undefined" || process.env.MAX_TIMELINE_TRACKS === null ? DEFAULT_TIMELINE_TRACKS : Number(process.env.MAX_TIMELINE_TRACKS);
var MAX_TIMELINE_TRACKS_NOTICE_HEIGHT = 24;
var container38 = {
  height: MAX_TIMELINE_TRACKS_NOTICE_HEIGHT,
  display: "flex",
  alignItems: "center",
  color: "rgba(255, 255, 255, 0.6)",
  fontFamily: "sans-serif",
  fontSize: 12,
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  paddingLeft: TIMELINE_PADDING + 5
};
var MaxTimelineTracksReached = () => {
  return /* @__PURE__ */ jsxs89("div", {
    style: container38,
    children: [
      "Limited display to ",
      MAX_TIMELINE_TRACKS,
      " tracks to sustain performance.",
      "",
      "You can change this by setting Config.setMaxTimelineTracks() in your remotion.config.ts file."
    ]
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import { PlayerInternals as PlayerInternals16 } from "@remotion/player";
import {
  useCallback as useCallback96,
  useContext as useContext65,
  useEffect as useEffect65,
  useMemo as useMemo102,
  useRef as useRef35,
  useState as useState67
} from "react";
import { Internals as Internals47, useVideoConfig as useVideoConfig4 } from "remotion";

// src/components/Timeline/TimelineInOutPointer.tsx
import { createRef as createRef10, useContext as useContext63 } from "react";
import { Internals as Internals46 } from "remotion";
import { jsx as jsx188, jsxs as jsxs90, Fragment as Fragment27 } from "react/jsx-runtime";
var areaHighlight = {
  position: "absolute",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100%",
  bottom: 0,
  top: 0
};
var inMarkerAreaRef = createRef10();
var outMarkerAreaRef = createRef10();
var TimelineInOutPointer = () => {
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const videoConfig = Internals46.useUnsafeVideoConfig();
  const timelineWidth = useContext63(TimelineWidthContext);
  if (!videoConfig || timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs90(Fragment27, {
    children: [
      inFrame !== null && /* @__PURE__ */ jsx188("div", {
        ref: inMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: 0,
          width: getXPositionOfItemInTimelineImperatively(inFrame, videoConfig.durationInFrames, timelineWidth)
        }
      }),
      outFrame !== null && /* @__PURE__ */ jsx188("div", {
        ref: outMarkerAreaRef,
        style: {
          ...areaHighlight,
          left: getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth),
          width: timelineWidth - getXPositionOfItemInTimelineImperatively(outFrame, videoConfig.durationInFrames, timelineWidth)
        }
      })
    ]
  });
};

// src/components/Timeline/TimelineInOutPointerHandle.tsx
import { createRef as createRef11, useContext as useContext64, useMemo as useMemo101 } from "react";
import { useVideoConfig as useVideoConfig3 } from "remotion";
import { jsx as jsx189 } from "react/jsx-runtime";
var line3 = {
  height: "100%",
  width: 1,
  position: "absolute",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  cursor: "ew-resize",
  paddingLeft: 1,
  paddingRight: 1
};
var inPointerHandle = createRef11();
var outPointerHandle = createRef11();
var InnerTimelineInOutPointerHandle = ({ atFrame, dragging, timelineWidth, type }) => {
  const videoConfig = useVideoConfig3();
  const style10 = useMemo101(() => {
    return {
      ...line3,
      backgroundColor: dragging ? LIGHT_TRANSPARENT : "rgba(255, 255, 255, 0.1)",
      transform: `translateX(${getXPositionOfItemInTimelineImperatively(atFrame, videoConfig.durationInFrames, timelineWidth)}px)`
    };
  }, [atFrame, dragging, timelineWidth, videoConfig.durationInFrames]);
  return /* @__PURE__ */ jsx189("div", {
    ref: type === "in" ? inPointerHandle : outPointerHandle,
    style: style10
  });
};
var TimelineInOutPointerHandle = ({
  dragging,
  type,
  atFrame
}) => {
  const timelineWidth = useContext64(TimelineWidthContext);
  if (timelineWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx189(InnerTimelineInOutPointerHandle, {
    atFrame,
    dragging,
    timelineWidth,
    type
  });
};

// src/components/Timeline/TimelineDragHandler.tsx
import { jsx as jsx190, jsxs as jsxs91 } from "react/jsx-runtime";
var inner = {
  overflowY: "auto",
  overflowX: "hidden"
};
var container39 = {
  userSelect: "none",
  WebkitUserSelect: "none",
  position: "absolute",
  height: "100%",
  top: 0
};
var style10 = {
  width: "100%",
  height: "100%",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var getClientXWithScroll = (x) => {
  return x + scrollableRef.current?.scrollLeft;
};
var TimelineDragHandler = () => {
  const video = Internals47.useUnsafeVideoConfig();
  const { zoom: zoomMap } = useContext65(TimelineZoomCtx);
  const { canvasContent } = useContext65(Internals47.CompositionManager);
  const containerStyle3 = useMemo102(() => {
    if (!canvasContent || canvasContent.type !== "composition") {
      return {};
    }
    const zoom = zoomMap[canvasContent.compositionId] ?? TIMELINE_MIN_ZOOM;
    return {
      ...container39,
      width: 100 * zoom + "%"
    };
  }, [canvasContent, zoomMap]);
  if (!canvasContent || canvasContent.type !== "composition") {
    return null;
  }
  return /* @__PURE__ */ jsx190("div", {
    ref: sliderAreaRef,
    style: containerStyle3,
    children: video ? /* @__PURE__ */ jsx190(Inner2, {}) : null
  });
};
var Inner2 = () => {
  const videoConfig = useVideoConfig4();
  const size4 = PlayerInternals16.useElementSize(scrollableRef, {
    triggerOnWindowResize: true,
    shouldApplyCssTransforms: true
  });
  const { isHighestContext } = useZIndex();
  const setFrame = Internals47.useTimelineSetFrame();
  const [inOutDragging, setInOutDragging] = useState67({
    dragging: false
  });
  const timelineWidth = useContext65(TimelineWidthContext);
  const get = useCallback96((frame2) => {
    if (timelineWidth === null) {
      throw new Error("timeline width is not yet determined");
    }
    return getXPositionOfItemInTimelineImperatively(frame2, videoConfig.durationInFrames, timelineWidth);
  }, [timelineWidth, videoConfig.durationInFrames]);
  const width = scrollableRef.current?.scrollWidth ?? 0;
  const left3 = size4?.left ?? 0;
  const { inFrame, outFrame } = useTimelineInOutFramePosition();
  const { setInAndOutFrames } = useTimelineSetInOutFramePosition();
  const [dragging, setDragging] = useState67({
    dragging: false
  });
  const { playing, play, pause, seek } = PlayerInternals16.usePlayer();
  const scroller = useRef35(null);
  const stopInterval = () => {
    if (scroller.current) {
      clearInterval(scroller.current);
      scroller.current = null;
    }
  };
  const onPointerDown = useCallback96((e) => {
    if (e.button !== 0) {
      return;
    }
    if (!isHighestContext) {
      return;
    }
    stopInterval();
    if (!videoConfig) {
      return;
    }
    document.body.style.userSelect = "none";
    document.body.style.webkitUserSelect = "none";
    if (e.target === inPointerHandle.current) {
      if (inFrame === null) {
        throw new Error("expected outframe");
      }
      const inMarker = get(inFrame);
      const outMarker = outFrame === null ? Infinity : get(outFrame - 1);
      setInOutDragging({
        dragging: "in",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [-Infinity, outMarker - inMarker]
      });
      return;
    }
    if (e.target === outPointerHandle.current) {
      if (outFrame === null) {
        throw new Error("expected outframe");
      }
      const outMarker = get(outFrame);
      const inMarker = inFrame === null ? -Infinity : get(inFrame + 1);
      setInOutDragging({
        dragging: "out",
        initialOffset: getClientXWithScroll(e.clientX),
        boundaries: [inMarker - outMarker, Infinity]
      });
      return;
    }
    if (e.button !== 0) {
      return;
    }
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    seek(frame2);
    setDragging({
      dragging: true,
      wasPlaying: playing
    });
    pause();
  }, [
    isHighestContext,
    videoConfig,
    left3,
    width,
    seek,
    playing,
    pause,
    inFrame,
    get,
    outFrame
  ]);
  const onPointerMoveScrubbing = useCallback96((e) => {
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    const isRightOfArea = e.clientX >= scrollableRef.current?.clientWidth + left3 - TIMELINE_PADDING;
    const isLeftOfArea = e.clientX <= left3;
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    if (isLeftOfArea && canScrollTimelineIntoDirection().canScrollLeft) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollLeft) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingLeft({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnLeftEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else if (isRightOfArea && canScrollTimelineIntoDirection().canScrollRight) {
      if (scroller.current) {
        return;
      }
      const scrollEvery = () => {
        if (!canScrollTimelineIntoDirection().canScrollRight) {
          stopInterval();
          return;
        }
        const nextFrame = getFrameWhileScrollingRight({
          durationInFrames: videoConfig.durationInFrames,
          width
        });
        const scrollPos = getScrollPositionForCursorOnRightEdge({
          nextFrame,
          durationInFrames: videoConfig.durationInFrames
        });
        redrawTimelineSliderFast.current?.draw(nextFrame);
        seek(nextFrame);
        scrollToTimelineXOffset(scrollPos);
      };
      scrollEvery();
      scroller.current = setInterval(() => {
        scrollEvery();
      }, 100);
    } else {
      stopInterval();
      seek(frame2);
    }
  }, [videoConfig, dragging.dragging, left3, width, seek]);
  const onPointerMoveInOut = useCallback96((e) => {
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    const offset = Math.max(inOutDragging.boundaries[0], Math.min(inOutDragging.boundaries[1], getClientXWithScroll(e.clientX) - inOutDragging.initialOffset));
    if (inOutDragging.dragging === "in") {
      if (!inPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!inMarkerAreaRef.current) {
        throw new Error("expected inMarkerAreaRef");
      }
      if (!inFrame) {
        throw new Error("expected inframes");
      }
      inPointerHandle.current.style.transform = `translateX(${get(inFrame) + offset}px)`;
      inMarkerAreaRef.current.style.width = String(get(inFrame) + offset) + "px";
    }
    if (inOutDragging.dragging === "out") {
      if (!outPointerHandle.current) {
        throw new Error("in pointer handle");
      }
      if (!outMarkerAreaRef.current) {
        throw new Error("in outMarkerAreaRef");
      }
      if (!outFrame) {
        throw new Error("expected outframes");
      }
      outPointerHandle.current.style.transform = `translateX(${get(outFrame) + offset}px)`;
      outMarkerAreaRef.current.style.left = String(get(outFrame) + offset) + "px";
      outMarkerAreaRef.current.style.width = String(width - get(outFrame) - offset) + "px";
    }
  }, [get, inFrame, inOutDragging, outFrame, videoConfig, width]);
  const onPointerUpScrubbing = useCallback96((e) => {
    stopInterval();
    document.body.style.userSelect = "";
    document.body.style.webkitUserSelect = "";
    if (!videoConfig) {
      return;
    }
    if (!dragging.dragging) {
      return;
    }
    setDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "clamp"
    });
    setFrame((c) => {
      const newObj = { ...c, [videoConfig.id]: frame2 };
      Internals47.persistCurrentFrame(newObj);
      return newObj;
    });
    if (dragging.wasPlaying) {
      play();
    }
  }, [dragging, left3, play, videoConfig, setFrame, width]);
  const onPointerUpInOut = useCallback96((e) => {
    document.body.style.userSelect = "";
    document.body.style.webkitUserSelect = "";
    if (!videoConfig) {
      return;
    }
    if (!inOutDragging.dragging) {
      return;
    }
    setInOutDragging({
      dragging: false
    });
    const frame2 = getFrameFromX({
      clientX: getClientXWithScroll(e.clientX) - left3,
      durationInFrames: videoConfig.durationInFrames,
      width,
      extrapolate: "extend"
    });
    if (inOutDragging.dragging === "in") {
      if (frame2 < 1) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            inFrame: null
          }
        }));
      }
      const maxFrame = outFrame === null ? Infinity : outFrame - 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          inFrame: Math.min(maxFrame, frame2)
        }
      }));
    } else {
      if (frame2 > videoConfig.durationInFrames - 2) {
        return setInAndOutFrames((prev) => ({
          ...prev,
          [videoConfig.id]: {
            ...prev[videoConfig.id] ?? defaultInOutValue,
            outFrame: null
          }
        }));
      }
      const minFrame = inFrame === null ? -Infinity : inFrame + 1;
      setInAndOutFrames((prev) => ({
        ...prev,
        [videoConfig.id]: {
          ...prev[videoConfig.id] ?? defaultInOutValue,
          outFrame: Math.max(minFrame, frame2)
        }
      }));
    }
  }, [
    inFrame,
    inOutDragging.dragging,
    left3,
    outFrame,
    setInAndOutFrames,
    videoConfig,
    width
  ]);
  useEffect65(() => {
    if (!dragging.dragging) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveScrubbing);
    window.addEventListener("pointerup", onPointerUpScrubbing);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveScrubbing);
      window.removeEventListener("pointerup", onPointerUpScrubbing);
    };
  }, [dragging.dragging, onPointerMoveScrubbing, onPointerUpScrubbing]);
  useEffect65(() => {
    if (inOutDragging.dragging === false) {
      return;
    }
    window.addEventListener("pointermove", onPointerMoveInOut);
    window.addEventListener("pointerup", onPointerUpInOut);
    return () => {
      window.removeEventListener("pointermove", onPointerMoveInOut);
      window.removeEventListener("pointerup", onPointerUpInOut);
    };
  }, [inOutDragging.dragging, onPointerMoveInOut, onPointerUpInOut]);
  const inContextMenu = useMemo102(() => {
    return [
      {
        id: "hide-in",
        keyHint: null,
        label: "Clear In marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              inFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-in"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  const outContextMenu = useMemo102(() => {
    return [
      {
        id: "hide-out",
        keyHint: null,
        label: "Clear Out marker",
        leftItem: null,
        onClick: (_, e) => {
          e?.stopPropagation();
          e?.preventDefault();
          setInAndOutFrames((prev) => ({
            ...prev,
            [videoConfig.id]: {
              ...prev[videoConfig.id] ?? defaultInOutValue,
              outFrame: null
            }
          }));
        },
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "hide-out"
      }
    ];
  }, [setInAndOutFrames, videoConfig.id]);
  return /* @__PURE__ */ jsxs91("div", {
    style: style10,
    onPointerDown,
    children: [
      /* @__PURE__ */ jsx190("div", {
        style: inner,
        className: VERTICAL_SCROLLBAR_CLASSNAME
      }),
      inFrame !== null && /* @__PURE__ */ jsx190(ContextMenu, {
        values: inContextMenu,
        children: /* @__PURE__ */ jsx190(TimelineInOutPointerHandle, {
          type: "in",
          atFrame: inFrame,
          dragging: inOutDragging.dragging === "in"
        })
      }),
      outFrame !== null && /* @__PURE__ */ jsx190(ContextMenu, {
        values: outContextMenu,
        children: /* @__PURE__ */ jsx190(TimelineInOutPointerHandle, {
          type: "out",
          dragging: inOutDragging.dragging === "out",
          atFrame: outFrame
        })
      })
    ]
  });
};

// src/components/Timeline/TimelineList.tsx
import { PlayerInternals as PlayerInternals18 } from "@remotion/player";
import { useRef as useRef39 } from "react";

// src/components/Timeline/TimelineListItem.tsx
import { useCallback as useCallback106, useContext as useContext70, useMemo as useMemo111 } from "react";
import { Internals as Internals51 } from "remotion";

// src/components/ExpandedTracksProvider.tsx
import { createContext as createContext21, useCallback as useCallback97, useMemo as useMemo103, useState as useState68 } from "react";
import { jsx as jsx191 } from "react/jsx-runtime";
var ExpandedTracksContext = createContext21({
  expandedTracks: {},
  toggleTrack: () => {
    throw new Error("ExpandedTracksContext not initialized");
  }
});
var ExpandedTracksProvider = ({ children }) => {
  const [expandedTracks, setExpandedTracks] = useState68({});
  const toggleTrack = useCallback97((id) => {
    setExpandedTracks((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  }, []);
  const value = useMemo103(() => ({
    expandedTracks,
    toggleTrack
  }), [expandedTracks, toggleTrack]);
  return /* @__PURE__ */ jsx191(ExpandedTracksContext.Provider, {
    value,
    children
  });
};

// src/components/Timeline/TimelineExpandedSection.tsx
import React137, { useMemo as useMemo108 } from "react";

// src/components/Timeline/TimelineFieldRow.tsx
import { useCallback as useCallback102, useContext as useContext66, useMemo as useMemo107 } from "react";
import { Internals as Internals48 } from "remotion";

// src/components/Timeline/TimelineBooleanField.tsx
import { useCallback as useCallback98 } from "react";
import { jsx as jsx192 } from "react/jsx-runtime";
var checkboxContainer = {
  marginLeft: 8
};
var TimelineBooleanField = ({ field, codeValue, effectiveValue, canUpdate, onSave }) => {
  const checked = Boolean(effectiveValue);
  const onChange = useCallback98(() => {
    const newValue = !checked;
    if (canUpdate && newValue !== codeValue) {
      onSave(field.key, newValue);
    }
  }, [canUpdate, onSave, field.key, checked, codeValue]);
  return /* @__PURE__ */ jsx192("div", {
    style: checkboxContainer,
    children: /* @__PURE__ */ jsx192(Checkbox, {
      checked,
      onChange,
      name: field.key,
      disabled: !canUpdate
    })
  });
};

// src/components/Timeline/TimelineNumberField.tsx
import { useCallback as useCallback99, useEffect as useEffect66, useMemo as useMemo104, useState as useState69 } from "react";

// src/components/Timeline/timeline-field-utils.ts
var getDecimalPlaces = (num) => {
  const str = String(num);
  const decimalIndex = str.indexOf(".");
  return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
};
var draggerStyle = {
  width: 80
};

// src/components/Timeline/TimelineNumberField.tsx
import { jsx as jsx193 } from "react/jsx-runtime";
var TimelineNumberField = ({
  field,
  effectiveValue,
  canUpdate,
  onSave,
  onDragValueChange,
  onDragEnd,
  codeValue
}) => {
  const [dragValue, setDragValue] = useState69(null);
  const onValueChange = useCallback99((newVal) => {
    setDragValue(newVal);
    onDragValueChange(field.key, newVal);
  }, [onDragValueChange, field.key]);
  useEffect66(() => {
    setDragValue(null);
    onDragEnd();
  }, [field.currentValue, onDragEnd]);
  const onValueChangeEnd = useCallback99((newVal) => {
    if (canUpdate && newVal !== codeValue) {
      onSave(field.key, newVal).catch(() => {
        setDragValue(null);
      });
    } else {
      setDragValue(null);
    }
  }, [canUpdate, onSave, field.key, codeValue]);
  const onTextChange = useCallback99((newVal) => {
    if (canUpdate) {
      const parsed = Number(newVal);
      if (!Number.isNaN(parsed) && parsed !== codeValue) {
        setDragValue(parsed);
        onSave(field.key, parsed).catch(() => {
          setDragValue(null);
        });
      }
    }
  }, [canUpdate, onSave, field.key, codeValue]);
  const step = field.fieldSchema.type === "number" ? field.fieldSchema.step ?? 1 : 1;
  const stepDecimals = useMemo104(() => getDecimalPlaces(step), [step]);
  const formatter = useCallback99((v) => {
    const num = Number(v);
    const digits = Math.max(stepDecimals, getDecimalPlaces(num));
    return digits === 0 ? String(num) : num.toFixed(digits);
  }, [stepDecimals]);
  return /* @__PURE__ */ jsx193(InputDragger, {
    type: "number",
    value: dragValue ?? effectiveValue,
    style: draggerStyle,
    status: "ok",
    small: true,
    onValueChange,
    onValueChangeEnd,
    onTextChange,
    min: field.fieldSchema.type === "number" ? field.fieldSchema.min ?? -Infinity : -Infinity,
    max: field.fieldSchema.type === "number" ? field.fieldSchema.max ?? Infinity : Infinity,
    step,
    formatter,
    rightAlign: false
  });
};

// src/components/Timeline/TimelineRotationField.tsx
import { useCallback as useCallback100, useEffect as useEffect67, useMemo as useMemo105, useState as useState70 } from "react";
import { jsx as jsx194 } from "react/jsx-runtime";
var parseCssRotationToDegrees = (value) => {
  try {
    const m = new DOMMatrix(`rotate(${value})`);
    return Math.round(Math.atan2(m.b, m.a) * (180 / Math.PI) * 1e6) / 1e6;
  } catch {
    return 0;
  }
};
var TimelineRotationField = ({
  field,
  effectiveValue,
  codeValue,
  canUpdate,
  onSave,
  onDragValueChange,
  onDragEnd
}) => {
  const [dragValue, setDragValue] = useState70(null);
  const degrees = useMemo105(() => parseCssRotationToDegrees(String(effectiveValue ?? "0deg")), [effectiveValue]);
  const onValueChange = useCallback100((newVal) => {
    setDragValue(newVal);
    onDragValueChange(field.key, `${newVal}deg`);
  }, [onDragValueChange, field.key]);
  useEffect67(() => {
    setDragValue(null);
    onDragEnd();
  }, [field.currentValue, onDragEnd]);
  const onValueChangeEnd = useCallback100((newVal) => {
    const newStr = `${newVal}deg`;
    if (canUpdate && newStr !== codeValue) {
      onSave(field.key, newStr).catch(() => {
        setDragValue(null);
      });
    } else {
      setDragValue(null);
    }
  }, [canUpdate, onSave, field.key, codeValue]);
  const onTextChange = useCallback100((newVal) => {
    if (canUpdate) {
      const parsed = Number(newVal);
      if (!Number.isNaN(parsed)) {
        const newStr = `${parsed}deg`;
        if (newStr !== codeValue) {
          setDragValue(parsed);
          onSave(field.key, newStr).catch(() => {
            setDragValue(null);
          });
        }
      }
    }
  }, [canUpdate, onSave, field.key, codeValue]);
  const step = field.fieldSchema.type === "rotation" ? field.fieldSchema.step ?? 1 : 1;
  const stepDecimals = useMemo105(() => getDecimalPlaces(step), [step]);
  const formatter = useCallback100((v) => {
    const num = Number(v);
    const digits = Math.max(stepDecimals, getDecimalPlaces(num));
    const formatted = digits === 0 ? String(num) : num.toFixed(digits);
    return `${formatted}°`;
  }, [stepDecimals]);
  return /* @__PURE__ */ jsx194(InputDragger, {
    type: "number",
    value: dragValue ?? degrees,
    style: draggerStyle,
    status: "ok",
    small: true,
    onValueChange,
    onValueChangeEnd,
    onTextChange,
    min: -Infinity,
    max: Infinity,
    step,
    formatter,
    rightAlign: false
  });
};

// src/components/Timeline/TimelineTranslateField.tsx
import { useCallback as useCallback101, useEffect as useEffect68, useMemo as useMemo106, useState as useState71 } from "react";
import { jsx as jsx195, jsxs as jsxs92 } from "react/jsx-runtime";
var leftDraggerStyle = {
  paddingLeft: 0
};
var rightDraggerStyle = {
  paddingRight: 0
};
var PIXEL_PATTERN = /^(-?\d+(?:\.\d+)?)px(?:\s+(-?\d+(?:\.\d+)?)px)?$/;
var parseTranslate = (value) => {
  const m = value.match(PIXEL_PATTERN);
  if (!m) {
    return [0, 0];
  }
  return [Number(m[1]), m[2] !== undefined ? Number(m[2]) : 0];
};
var containerStyle3 = {
  display: "flex",
  gap: 4
};
var TimelineTranslateField = ({
  field,
  codeValue,
  effectiveValue,
  canUpdate,
  onSave,
  onDragValueChange,
  onDragEnd
}) => {
  const [dragX, setDragX] = useState71(null);
  const [dragY, setDragY] = useState71(null);
  const [codeX, codeY] = useMemo106(() => parseTranslate(String(effectiveValue ?? "0px 0px")), [effectiveValue]);
  const makeString = useCallback101((x, y) => `${x}px ${y}px`, []);
  useEffect68(() => {
    setDragX(null);
    setDragY(null);
    onDragEnd();
  }, [field.currentValue, onDragEnd]);
  const step = field.fieldSchema.type === "translate" ? field.fieldSchema.step ?? 1 : 1;
  const stepDecimals = useMemo106(() => getDecimalPlaces(step), [step]);
  const formatter = useCallback101((v) => {
    const num = Number(v);
    const digits = Math.max(stepDecimals, getDecimalPlaces(num));
    const formatted = digits === 0 ? String(num) : num.toFixed(digits);
    return `${formatted}px`;
  }, [stepDecimals]);
  const onXChange = useCallback101((newVal) => {
    setDragX(newVal);
    const currentY = dragY ?? codeY;
    onDragValueChange(field.key, makeString(newVal, currentY));
  }, [onDragValueChange, field.key, dragY, codeY, makeString]);
  const onXChangeEnd = useCallback101((newVal) => {
    const currentY = dragY ?? codeY;
    const newStr = makeString(newVal, currentY);
    if (canUpdate && newStr !== codeValue) {
      onSave(field.key, newStr).catch(() => {
        setDragX(null);
      });
    } else {
      setDragX(null);
    }
  }, [canUpdate, onSave, field.key, codeValue, dragY, codeY, makeString]);
  const onXTextChange = useCallback101((newVal) => {
    if (canUpdate) {
      const parsed = Number(newVal);
      if (!Number.isNaN(parsed)) {
        const currentY = dragY ?? codeY;
        const newStr = makeString(parsed, currentY);
        if (newStr !== codeValue) {
          setDragX(parsed);
          onSave(field.key, newStr).catch(() => {
            setDragX(null);
          });
        }
      }
    }
  }, [canUpdate, onSave, field.key, codeValue, dragY, codeY, makeString]);
  const onYChange = useCallback101((newVal) => {
    setDragY(newVal);
    const currentX = dragX ?? codeX;
    onDragValueChange(field.key, makeString(currentX, newVal));
  }, [onDragValueChange, field.key, dragX, codeX, makeString]);
  const onYChangeEnd = useCallback101((newVal) => {
    const currentX = dragX ?? codeX;
    const newStr = makeString(currentX, newVal);
    if (canUpdate && newStr !== codeValue) {
      onSave(field.key, newStr).catch(() => {
        setDragY(null);
      });
    } else {
      setDragY(null);
    }
  }, [canUpdate, onSave, field.key, codeValue, dragX, codeX, makeString]);
  const onYTextChange = useCallback101((newVal) => {
    if (canUpdate) {
      const parsed = Number(newVal);
      if (!Number.isNaN(parsed)) {
        const currentX = dragX ?? codeX;
        const newStr = makeString(currentX, parsed);
        if (newStr !== codeValue) {
          setDragY(parsed);
          onSave(field.key, newStr).catch(() => {
            setDragY(null);
          });
        }
      }
    }
  }, [canUpdate, onSave, field.key, codeValue, dragX, codeX, makeString]);
  return /* @__PURE__ */ jsxs92("span", {
    style: containerStyle3,
    children: [
      /* @__PURE__ */ jsx195(InputDragger, {
        type: "number",
        value: dragX ?? codeX,
        style: leftDraggerStyle,
        status: "ok",
        small: true,
        onValueChange: onXChange,
        onValueChangeEnd: onXChangeEnd,
        onTextChange: onXTextChange,
        min: -Infinity,
        max: Infinity,
        step,
        formatter,
        rightAlign: false
      }),
      /* @__PURE__ */ jsx195("div", {
        style: { marginLeft: -6, marginRight: -6 }
      }),
      /* @__PURE__ */ jsx195(InputDragger, {
        type: "number",
        value: dragY ?? codeY,
        style: rightDraggerStyle,
        status: "ok",
        small: true,
        onValueChange: onYChange,
        onValueChangeEnd: onYChangeEnd,
        onTextChange: onYTextChange,
        min: -Infinity,
        max: Infinity,
        step,
        formatter,
        rightAlign: false
      })
    ]
  });
};

// src/components/Timeline/TimelineSchemaField.tsx
import { jsx as jsx196 } from "react/jsx-runtime";
var unsupportedLabel = {
  color: "rgba(255, 255, 255, 0.4)",
  fontSize: 12,
  fontStyle: "italic"
};
var notEditableBackground = {
  backgroundColor: "rgba(255, 0, 0, 0.2)",
  borderRadius: 3,
  padding: "0 4px"
};
var TimelineFieldValue = ({
  field,
  onSave,
  onDragValueChange,
  onDragEnd,
  propStatus,
  canUpdate,
  effectiveValue,
  codeValue
}) => {
  const wrapperStyle = canUpdate === null || canUpdate === false ? notEditableBackground : undefined;
  if (!field.supported) {
    return /* @__PURE__ */ jsx196("span", {
      style: unsupportedLabel,
      children: "unsupported"
    });
  }
  if (propStatus !== null && !propStatus.canUpdate) {
    if (propStatus.reason === "computed") {
      return /* @__PURE__ */ jsx196("span", {
        style: unsupportedLabel,
        children: "computed"
      });
    }
    throw new Error(`Unsupported prop status: ${propStatus.reason}`);
  }
  if (propStatus === null) {
    return /* @__PURE__ */ jsx196("span", {
      style: notEditableBackground,
      children: /* @__PURE__ */ jsx196("span", {
        style: unsupportedLabel,
        children: "error"
      })
    });
  }
  if (field.typeName === "number") {
    return /* @__PURE__ */ jsx196("span", {
      style: wrapperStyle,
      children: /* @__PURE__ */ jsx196(TimelineNumberField, {
        field,
        effectiveValue,
        canUpdate,
        onSave,
        codeValue,
        onDragValueChange,
        onDragEnd
      })
    });
  }
  if (field.typeName === "rotation") {
    return /* @__PURE__ */ jsx196("span", {
      style: wrapperStyle,
      children: /* @__PURE__ */ jsx196(TimelineRotationField, {
        field,
        effectiveValue,
        codeValue,
        canUpdate,
        onSave,
        onDragValueChange,
        onDragEnd
      })
    });
  }
  if (field.typeName === "translate") {
    return /* @__PURE__ */ jsx196("span", {
      style: wrapperStyle,
      children: /* @__PURE__ */ jsx196(TimelineTranslateField, {
        field,
        effectiveValue,
        codeValue,
        canUpdate,
        onSave,
        onDragValueChange,
        onDragEnd
      })
    });
  }
  if (field.typeName === "boolean") {
    return /* @__PURE__ */ jsx196("span", {
      style: wrapperStyle,
      children: /* @__PURE__ */ jsx196(TimelineBooleanField, {
        field,
        codeValue,
        canUpdate,
        onSave,
        effectiveValue
      })
    });
  }
  return /* @__PURE__ */ jsx196("span", {
    style: { ...unsupportedLabel, fontStyle: "normal" },
    children: String(effectiveValue)
  });
};

// src/components/Timeline/TimelineFieldRow.tsx
import { jsx as jsx197, jsxs as jsxs93 } from "react/jsx-runtime";
var FIELD_ROW_PADDING_LEFT = 24;
var fieldRowBase = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  paddingRight: EXPANDED_SECTION_PADDING_RIGHT
};
var fieldName = {
  fontSize: 12,
  color: "rgba(255, 255, 255, 0.8)"
};
var fieldLabelRow = {
  flex: "0 0 50%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 6
};
var TimelineFieldRow = ({ field, overrideId, validatedLocation, nestedDepth, nodePath }) => {
  const {
    setDragOverrides,
    clearDragOverrides,
    dragOverrides,
    codeValues: allPropStatuses
  } = useContext66(Internals48.VisualModeOverridesContext);
  const propStatuses = allPropStatuses[overrideId] ?? null;
  const propStatus = propStatuses?.[field.key] ?? null;
  const dragOverrideValue = useMemo107(() => {
    return (dragOverrides[overrideId] ?? {})[field.key];
  }, [dragOverrides, overrideId, field.key]);
  const effectiveValue = Internals48.getEffectiveVisualModeValue({
    codeValue: propStatus,
    runtimeValue: field.currentValue,
    dragOverrideValue,
    defaultValue: field.fieldSchema.default,
    shouldResortToDefaultValueIfUndefined: true
  });
  const onSave = useCallback102((key4, value) => {
    if (!propStatuses || !validatedLocation || !nodePath) {
      return Promise.reject(new Error("Cannot save"));
    }
    const status = propStatuses[key4];
    if (!status || !status.canUpdate) {
      return Promise.reject(new Error("Cannot save"));
    }
    const defaultValue = field.fieldSchema.default !== undefined ? JSON.stringify(field.fieldSchema.default) : null;
    return callApi("/api/save-sequence-props", {
      fileName: validatedLocation.source,
      nodePath,
      key: key4,
      value: JSON.stringify(value),
      defaultValue
    }).then(() => {
      return;
    });
  }, [propStatuses, validatedLocation, nodePath, field.fieldSchema.default]);
  const onDragValueChange = useCallback102((key4, value) => {
    setDragOverrides(overrideId, key4, value);
  }, [setDragOverrides, overrideId]);
  const onDragEnd = useCallback102(() => {
    clearDragOverrides(overrideId);
  }, [clearDragOverrides, overrideId]);
  const style11 = useMemo107(() => {
    return {
      ...fieldRowBase,
      height: field.rowHeight,
      paddingLeft: EXPANDED_SECTION_PADDING_LEFT + FIELD_ROW_PADDING_LEFT + SPACING * 3 * nestedDepth
    };
  }, [field.rowHeight, nestedDepth]);
  return /* @__PURE__ */ jsxs93("div", {
    style: style11,
    children: [
      /* @__PURE__ */ jsx197("div", {
        style: fieldLabelRow,
        children: /* @__PURE__ */ jsx197("span", {
          style: fieldName,
          children: field.description ?? field.key
        })
      }),
      /* @__PURE__ */ jsx197(TimelineFieldValue, {
        field,
        propStatus,
        onSave,
        onDragValueChange,
        onDragEnd,
        canUpdate: propStatus?.canUpdate ?? false,
        effectiveValue,
        codeValue: propStatus
      })
    ]
  });
};

// src/components/Timeline/TimelineExpandedSection.tsx
import { jsx as jsx198, jsxs as jsxs94 } from "react/jsx-runtime";
var EXPANDED_SECTION_PADDING_LEFT = 28;
var EXPANDED_SECTION_PADDING_RIGHT = 10;
var expandedSectionBase = {
  color: "white",
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 12,
  display: "flex",
  flexDirection: "column",
  borderBottom: `1px solid ${TIMELINE_TRACK_SEPARATOR}`
};
var separator = {
  height: 1,
  backgroundColor: TIMELINE_TRACK_SEPARATOR
};
var TimelineExpandedSection = ({ sequence, originalLocation, nestedDepth, nodePath }) => {
  const overrideId = sequence.controls?.overrideId ?? sequence.id;
  const schemaFields = useMemo108(() => getSchemaFields(sequence.controls), [sequence.controls]);
  const validatedLocation = useMemo108(() => {
    if (!originalLocation || !originalLocation.source || !originalLocation.line) {
      return null;
    }
    return {
      source: originalLocation.source,
      line: originalLocation.line,
      column: originalLocation.column ?? 0
    };
  }, [originalLocation]);
  const expandedHeight = useMemo108(() => getExpandedTrackHeight(sequence.controls), [sequence.controls]);
  const style11 = useMemo108(() => {
    return {
      ...expandedSectionBase,
      height: expandedHeight
    };
  }, [expandedHeight]);
  return /* @__PURE__ */ jsx198("div", {
    style: style11,
    children: schemaFields ? schemaFields.map((field, i) => {
      return /* @__PURE__ */ jsxs94(React137.Fragment, {
        children: [
          i > 0 ? /* @__PURE__ */ jsx198("div", {
            style: separator
          }) : null,
          /* @__PURE__ */ jsx198(TimelineFieldRow, {
            field,
            overrideId,
            validatedLocation,
            nestedDepth,
            nodePath
          })
        ]
      }, field.key);
    }) : "No schema"
  });
};

// src/components/Timeline/TimelineLayerEye.tsx
import { useCallback as useCallback103 } from "react";
import { jsx as jsx199 } from "react/jsx-runtime";
var eyeIcon = {
  width: 12,
  color: "currentColor",
  pointerEvents: "none"
};
var speakerIcon = {
  ...eyeIcon,
  height: 10,
  marginLeft: -1
};
var container40 = {
  height: 16,
  width: 16,
  borderRadius: 2,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: 6,
  flexShrink: 0
};
var layerPointedDown = null;
var TimelineLayerEye = ({ onInvoked, hidden, type }) => {
  const renderAction = useCallback103((color) => {
    if (hidden) {
      return null;
    }
    if (type === "speaker") {
      return /* @__PURE__ */ jsx199("svg", {
        viewBox: "0 0 10 14",
        fill: "none",
        style: speakerIcon,
        children: /* @__PURE__ */ jsx199("path", {
          d: "M9.40938 0.0869018C9.76875 0.249402 10 0.605652 10 0.999402V12.9994C10 13.3932 9.76875 13.7494 9.40938 13.9119C9.05 14.0744 8.62813 14.0088 8.33438 13.7463L4.11875 9.9994H2C0.896875 9.9994 0 9.10253 0 7.9994V5.9994C0 4.89628 0.896875 3.9994 2 3.9994H4.11875L8.33438 0.252527C8.62813 -0.0099732 9.05 -0.0724732 9.40938 0.0869018Z",
          fill: color
        })
      });
    }
    return /* @__PURE__ */ jsx199("svg", {
      style: eyeIcon,
      viewBox: "0 0 24 16",
      fill: "none",
      children: /* @__PURE__ */ jsx199("path", {
        d: "M24 7.551C24 7.551 19.748 16 12.015 16C4.835 16 0 7.551 0 7.551C0 7.551 4.446 0 12.015 0C19.709 0 24 7.551 24 7.551ZM17 8C17 5.243 14.757 3 12 3C9.243 3 7 5.243 7 8C7 10.757 9.243 13 12 13C14.757 13 17 10.757 17 8Z",
        fill: color
      })
    });
  }, [hidden, type]);
  const onPointerDown = useCallback103((e) => {
    if (e.button !== 0) {
      return;
    }
    layerPointedDown = hidden ? "enable" : "disable";
    onInvoked(layerPointedDown);
    window.addEventListener("pointerup", () => {
      layerPointedDown = null;
    }, { once: true });
  }, [hidden, onInvoked]);
  const onPointerEnter = useCallback103(() => {
    if (layerPointedDown) {
      onInvoked(layerPointedDown);
    }
  }, [onInvoked]);
  return /* @__PURE__ */ jsx199("div", {
    style: container40,
    onPointerEnter,
    onPointerDown,
    children: renderAction(LIGHT_COLOR)
  });
};

// src/components/Timeline/TimelineStack/index.tsx
import { SOURCE_MAP_ENDPOINT } from "@remotion/studio-shared";
import { useCallback as useCallback104, useContext as useContext67, useMemo as useMemo109, useState as useState72 } from "react";
import { SourceMapConsumer as SourceMapConsumer3 } from "source-map";
import { jsx as jsx200, jsxs as jsxs95, Fragment as Fragment28 } from "react/jsx-runtime";
var publicPath = window.remotion_publicPath === "/" ? "" : window.remotion_publicPath;
var withoutSlashInTheEnd = publicPath.endsWith("/") ? publicPath.slice(0, -1) : publicPath;
SourceMapConsumer3.initialize({
  "lib/mappings.wasm": withoutSlashInTheEnd + SOURCE_MAP_ENDPOINT
});
var TimelineStack = ({ isCompact, sequence, originalLocation }) => {
  const [stackHovered, setStackHovered] = useState72(false);
  const [titleHovered, setTitleHovered] = useState72(false);
  const [opening, setOpening] = useState72(false);
  const selectAsset = useSelectAsset();
  const connectionStatus = useContext67(StudioServerConnectionCtx).previewServerState.type;
  const assetPath = useMemo109(() => {
    if (sequence.type !== "video" && sequence.type !== "audio") {
      return null;
    }
    const isStatic = sequence.src.startsWith(window.remotion_staticBase);
    if (!isStatic) {
      return null;
    }
    const relativePath = sequence.src.replace(window.remotion_staticBase + "/", "");
    return relativePath;
  }, [sequence]);
  const navigateToAsset = useCallback104((asset) => {
    selectAsset(asset);
    pushUrl(`/assets/${asset}`);
  }, [selectAsset]);
  const openEditor = useCallback104(async (location2) => {
    if (!window.remotion_editorName) {
      return;
    }
    setOpening(true);
    try {
      await openOriginalPositionInEditor(location2);
    } catch (err) {
      showNotification(err.message, 2000);
    } finally {
      setOpening(false);
    }
  }, []);
  const canOpenInEditor = window.remotion_editorName && connectionStatus === "connected" && originalLocation;
  const canOpenInGitHub = window.remotion_gitSource && originalLocation;
  const titleHoverable = isCompact && (canOpenInEditor || canOpenInGitHub) || assetPath;
  const stackHoverable = !isCompact && (canOpenInEditor || canOpenInGitHub);
  const onClickTitle = useCallback104(() => {
    if (!titleHoverable) {
      return null;
    }
    if (assetPath) {
      navigateToAsset(assetPath);
      return;
    }
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [
    assetPath,
    canOpenInEditor,
    canOpenInGitHub,
    navigateToAsset,
    openEditor,
    originalLocation,
    titleHoverable
  ]);
  const onClickStack = useCallback104(() => {
    if (!originalLocation) {
      return;
    }
    if (canOpenInEditor) {
      openEditor(originalLocation);
      return;
    }
    if (canOpenInGitHub) {
      window.open(getGitRefUrl(window.remotion_gitSource, originalLocation), "_blank");
    }
  }, [canOpenInEditor, canOpenInGitHub, openEditor, originalLocation]);
  const onStackPointerEnter = useCallback104(() => {
    setStackHovered(true);
  }, []);
  const onStackPointerLeave = useCallback104(() => {
    setStackHovered(false);
  }, []);
  const onTitlePointerEnter = useCallback104(() => {
    setTitleHovered(true);
  }, []);
  const onTitlePointerLeave = useCallback104(() => {
    setTitleHovered(false);
  }, []);
  const style11 = useMemo109(() => {
    return {
      fontSize: 12,
      color: opening ? VERY_LIGHT_TEXT : stackHovered && stackHoverable ? LIGHT_TEXT : VERY_LIGHT_TEXT,
      marginLeft: 10,
      cursor: stackHoverable ? "pointer" : undefined,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      flexShrink: 1e5
    };
  }, [opening, stackHovered, stackHoverable]);
  const titleStyle2 = useMemo109(() => {
    const hoverEffect = titleHovered && titleHoverable;
    return {
      fontSize: 12,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      lineHeight: 1.2,
      color: opening && isCompact ? VERY_LIGHT_TEXT : LIGHT_COLOR,
      userSelect: "none",
      WebkitUserSelect: "none",
      borderBottom: hoverEffect ? "1px solid #fff" : "none",
      cursor: hoverEffect ? "pointer" : undefined
    };
  }, [titleHoverable, isCompact, opening, titleHovered]);
  const text = sequence.displayName.length > 1000 ? sequence.displayName.slice(0, 1000) + "..." : sequence.displayName;
  return /* @__PURE__ */ jsxs95(Fragment28, {
    children: [
      /* @__PURE__ */ jsx200("div", {
        onPointerEnter: onTitlePointerEnter,
        onPointerLeave: onTitlePointerLeave,
        title: originalLocation ? getOriginalSourceAttribution(originalLocation) : text || "<Sequence>",
        style: titleStyle2,
        onClick: onClickTitle,
        children: text || "<Sequence>"
      }),
      isCompact || !originalLocation ? null : /* @__PURE__ */ jsx200("div", {
        onPointerEnter: onStackPointerEnter,
        onPointerLeave: onStackPointerLeave,
        onClick: onClickStack,
        style: style11,
        children: getOriginalSourceAttribution(originalLocation)
      }),
      opening ? /* @__PURE__ */ jsxs95(Fragment28, {
        children: [
          /* @__PURE__ */ jsx200(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx200(Spinner, {
            duration: 0.5,
            size: 12
          })
        ]
      }) : null
    ]
  });
};

// src/components/Timeline/use-resolved-stack.ts
import { useContext as useContext68, useEffect as useEffect69, useState as useState73 } from "react";
import { Internals as Internals49 } from "remotion";
var resolvedCache = new Map;
var inFlight = new Set;
var subscribers = new Map;
var useResolvedStack = (stack2) => {
  const updateResolvedStackTrace = useContext68(Internals49.SequenceStackTracesUpdateContext);
  const [value, setValue] = useState73(() => {
    if (!stack2) {
      return null;
    }
    return resolvedCache.get(stack2) ?? null;
  });
  useEffect69(() => {
    if (!stack2) {
      return;
    }
    if (resolvedCache.has(stack2)) {
      setValue(resolvedCache.get(stack2));
      return;
    }
    if (!subscribers.has(stack2)) {
      subscribers.set(stack2, new Set);
    }
    const subs = subscribers.get(stack2);
    subs.add(setValue);
    if (!inFlight.has(stack2)) {
      inFlight.add(stack2);
      getOriginalLocationFromStack(stack2, "sequence").then((frame2) => {
        resolvedCache.set(stack2, frame2);
        updateResolvedStackTrace(stack2, frame2);
        subs.forEach((fn) => fn(frame2));
      }).catch((err) => {
        console.error("Could not get original location of Sequence", err);
      }).finally(() => {
        inFlight.delete(stack2);
      });
    }
    return () => {
      subs.delete(setValue);
    };
  }, [stack2, updateResolvedStackTrace]);
  return value;
};

// src/components/Timeline/use-sequence-props-subscription.ts
import { useCallback as useCallback105, useContext as useContext69, useEffect as useEffect70, useMemo as useMemo110, useRef as useRef36 } from "react";
import { Internals as Internals50 } from "remotion";
var useSequencePropsSubscription = (sequence, originalLocation) => {
  const { setCodeValues } = useContext69(Internals50.VisualModeOverridesContext);
  const overrideId = sequence.controls?.overrideId ?? null;
  const setPropStatusesForSequence = useCallback105((statuses) => {
    if (!overrideId) {
      return;
    }
    setCodeValues(overrideId, statuses);
  }, [overrideId, setCodeValues]);
  const { previewServerState: state, subscribeToEvent } = useContext69(StudioServerConnectionCtx);
  const clientId = state.type === "connected" ? state.clientId : undefined;
  const schemaFields = useMemo110(() => getSchemaFields(sequence.controls), [sequence.controls]);
  const schemaKeysString = useMemo110(() => schemaFields ? schemaFields.map((f) => f.key).join(",") : null, [schemaFields]);
  const validatedLocation = useMemo110(() => {
    if (!originalLocation || !originalLocation.source || !originalLocation.line) {
      return null;
    }
    return {
      source: originalLocation.source,
      line: originalLocation.line,
      column: originalLocation.column ?? 0
    };
  }, [originalLocation]);
  const locationSource = validatedLocation?.source ?? null;
  const locationLine = validatedLocation?.line ?? null;
  const locationColumn = validatedLocation?.column ?? null;
  const currentLocationSource = useRef36(locationSource);
  currentLocationSource.current = locationSource;
  const currentLocationLine = useRef36(locationLine);
  currentLocationLine.current = locationLine;
  const currentLocationColumn = useRef36(locationColumn);
  currentLocationColumn.current = locationColumn;
  const nodePathRef = useRef36(null);
  const isMountedRef = useRef36(true);
  useEffect70(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  useEffect70(() => {
    if (!clientId || !locationSource || !locationLine || locationColumn === null || !schemaKeysString) {
      setPropStatusesForSequence(null);
      return;
    }
    const keys = schemaKeysString.split(",");
    callApi("/api/subscribe-to-sequence-props", {
      fileName: locationSource,
      line: locationLine,
      column: locationColumn,
      keys,
      clientId
    }).then((result) => {
      if (currentLocationSource.current !== locationSource || currentLocationLine.current !== locationLine || currentLocationColumn.current !== locationColumn) {
        return;
      }
      if (result.canUpdate) {
        nodePathRef.current = result.nodePath;
        setPropStatusesForSequence(result.props);
      } else {
        nodePathRef.current = null;
        setPropStatusesForSequence(null);
      }
    }).catch((err) => {
      nodePathRef.current = null;
      Internals50.Log.error(err);
      setPropStatusesForSequence(null);
    });
    return () => {
      const currentNodePath = nodePathRef.current;
      if (!isMountedRef.current) {
        setPropStatusesForSequence(null);
      }
      nodePathRef.current = null;
      if (currentNodePath) {
        callApi("/api/unsubscribe-from-sequence-props", {
          fileName: locationSource,
          nodePath: currentNodePath,
          clientId
        }).catch(() => {});
      }
    };
  }, [
    clientId,
    locationSource,
    locationLine,
    locationColumn,
    schemaKeysString,
    setPropStatusesForSequence
  ]);
  useEffect70(() => {
    if (!locationSource || !locationLine || locationColumn === null) {
      return;
    }
    const listener = (event) => {
      if (event.type !== "sequence-props-updated") {
        return;
      }
      if (event.fileName !== currentLocationSource.current || !nodePathRef.current || JSON.stringify(event.nodePath) !== JSON.stringify(nodePathRef.current)) {
        return;
      }
      if (event.result.canUpdate) {
        setPropStatusesForSequence(event.result.props);
      } else {
        setPropStatusesForSequence(null);
      }
    };
    const unsub = subscribeToEvent("sequence-props-updated", listener);
    return () => {
      unsub();
    };
  }, [
    locationSource,
    locationLine,
    locationColumn,
    subscribeToEvent,
    setPropStatusesForSequence
  ]);
  return nodePathRef.current;
};

// src/components/Timeline/TimelineListItem.tsx
import { jsx as jsx201, jsxs as jsxs96, Fragment as Fragment29 } from "react/jsx-runtime";
var SPACING = 5;
var space = {
  width: SPACING,
  flexShrink: 0
};
var arrowButton = {
  background: "none",
  border: "none",
  color: "white",
  cursor: "pointer",
  padding: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 12,
  height: 12,
  flexShrink: 0,
  fontSize: 8,
  marginRight: 4,
  userSelect: "none",
  outline: "none",
  lineHeight: 1
};
var TimelineListItem = ({ nestedDepth, sequence, isCompact }) => {
  const { previewServerState } = useContext70(StudioServerConnectionCtx);
  const visualModeEnabled = Boolean(process.env.EXPERIMENTAL_VISUAL_MODE_ENABLED) && previewServerState.type === "connected";
  const { hidden, setHidden } = useContext70(Internals51.SequenceVisibilityToggleContext);
  const { expandedTracks, toggleTrack } = useContext70(ExpandedTracksContext);
  const originalLocation = useResolvedStack(sequence.stack ?? null);
  const nodePath = useSequencePropsSubscription(sequence, originalLocation);
  const isExpanded = visualModeEnabled && (expandedTracks[sequence.id] ?? false);
  const onToggleExpand = useCallback106(() => {
    toggleTrack(sequence.id);
  }, [sequence.id, toggleTrack]);
  const padder = useMemo111(() => {
    return {
      width: Number(SPACING * 3) * nestedDepth,
      flexShrink: 0
    };
  }, [nestedDepth]);
  const isItemHidden = useMemo111(() => {
    return hidden[sequence.id] ?? false;
  }, [hidden, sequence.id]);
  const onToggleVisibility = useCallback106((type) => {
    setHidden((prev) => {
      return {
        ...prev,
        [sequence.id]: type !== "enable"
      };
    });
  }, [sequence.id, setHidden]);
  const outer2 = useMemo111(() => {
    return {
      height: getTimelineLayerHeight(sequence.type === "video" ? "video" : "other") + TIMELINE_ITEM_BORDER_BOTTOM,
      color: "white",
      fontFamily: "Arial, Helvetica, sans-serif",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      wordBreak: "break-all",
      textAlign: "left",
      paddingLeft: SPACING,
      borderBottom: `1px solid ${TIMELINE_TRACK_SEPARATOR}`
    };
  }, [sequence.type]);
  const arrowStyle = useMemo111(() => {
    return {
      ...arrowButton,
      transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)"
    };
  }, [isExpanded]);
  return /* @__PURE__ */ jsxs96(Fragment29, {
    children: [
      /* @__PURE__ */ jsxs96("div", {
        style: outer2,
        children: [
          /* @__PURE__ */ jsx201(TimelineLayerEye, {
            type: sequence.type === "audio" ? "speaker" : "eye",
            hidden: isItemHidden,
            onInvoked: onToggleVisibility
          }),
          /* @__PURE__ */ jsx201("div", {
            style: padder
          }),
          sequence.parent && nestedDepth > 0 ? /* @__PURE__ */ jsx201("div", {
            style: space
          }) : null,
          visualModeEnabled ? sequence.controls ? /* @__PURE__ */ jsx201("button", {
            type: "button",
            style: arrowStyle,
            onClick: onToggleExpand,
            "aria-expanded": isExpanded,
            "aria-label": `${isExpanded ? "Collapse" : "Expand"} track`,
            children: /* @__PURE__ */ jsx201("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 8 8",
              style: { display: "block" },
              children: /* @__PURE__ */ jsx201("path", {
                d: "M2 1L6 4L2 7Z",
                fill: "white"
              })
            })
          }) : /* @__PURE__ */ jsx201("div", {
            style: arrowButton
          }) : null,
          /* @__PURE__ */ jsx201(TimelineStack, {
            sequence,
            isCompact,
            originalLocation
          })
        ]
      }),
      visualModeEnabled && isExpanded && sequence.controls ? /* @__PURE__ */ jsx201(TimelineExpandedSection, {
        sequence,
        originalLocation,
        nestedDepth,
        nodePath
      }) : null
    ]
  });
};

// src/components/Timeline/TimelineTimeIndicators.tsx
import { useContext as useContext71, useEffect as useEffect72, useMemo as useMemo112, useRef as useRef38 } from "react";
import { Internals as Internals53 } from "remotion";

// src/components/TimeValue.tsx
import { PlayerInternals as PlayerInternals17 } from "@remotion/player";
import {
  useCallback as useCallback107,
  useEffect as useEffect71,
  useImperativeHandle as useImperativeHandle13,
  useRef as useRef37
} from "react";
import { Internals as Internals52, useCurrentFrame } from "remotion";
import { jsx as jsx202, jsxs as jsxs97 } from "react/jsx-runtime";
var text = {
  color: "white",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontVariantNumeric: "tabular-nums",
  lineHeight: 1,
  width: "100%"
};
var time = {
  display: "inline-block",
  fontSize: 16,
  lineHeight: 1,
  fontFamily: "monospace"
};
var frameStyle = {
  color: LIGHT_TEXT,
  fontWeight: 500,
  lineHeight: 1,
  fontSize: 16,
  fontFamily: "monospace",
  paddingRight: 10
};
var TimeValue = () => {
  const frame2 = useCurrentFrame();
  const config = Internals52.useUnsafeVideoConfig();
  const isStill = useIsStill();
  const { seek, play, pause, toggle } = PlayerInternals17.usePlayer();
  const keybindings = useKeybinding();
  const ref = useRef37(null);
  const onTextChange = useCallback107((newVal) => {
    seek(parseInt(newVal, 10));
  }, [seek]);
  const onValueChange = useCallback107((val) => {
    seek(val);
  }, [seek]);
  useImperativeHandle13(Internals52.timeValueRef, () => ({
    goToFrame: () => {
      ref.current?.click();
    },
    seek,
    play,
    pause,
    toggle
  }), [seek, play, pause, toggle]);
  useEffect71(() => {
    const gKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "g",
      callback: () => {
        ref.current?.click();
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      gKey.unregister();
    };
  }, [keybindings]);
  if (!config) {
    return null;
  }
  if (isStill) {
    return null;
  }
  return /* @__PURE__ */ jsxs97("div", {
    style: text,
    children: [
      /* @__PURE__ */ jsx202("div", {
        style: time,
        children: renderFrame(frame2, config.fps)
      }),
      /* @__PURE__ */ jsx202(Spacing, {
        x: 2
      }),
      /* @__PURE__ */ jsx202(Flex, {}),
      /* @__PURE__ */ jsx202(InputDragger, {
        ref,
        value: frame2,
        onTextChange,
        onValueChange,
        rightAlign: true,
        status: "ok",
        style: frameStyle
      })
    ]
  });
};

// src/components/Timeline/TimelineTimeIndicators.tsx
import { jsx as jsx203 } from "react/jsx-runtime";
var TIMELINE_TIME_INDICATOR_HEIGHT = 39;
var container41 = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT - 4,
  boxShadow: `0 0 4px ${TIMELINE_BACKGROUND}`,
  position: "absolute",
  backgroundColor: TIMELINE_BACKGROUND,
  top: 0
};
var tick = {
  width: 1,
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  height: 20,
  position: "absolute"
};
var secondTick = {
  ...tick,
  height: 15
};
var tickLabel = {
  fontSize: 12,
  marginLeft: 8,
  marginTop: 7,
  color: LIGHT_TEXT
};
var timeValue = {
  height: TIMELINE_TIME_INDICATOR_HEIGHT,
  position: "absolute",
  top: 0,
  width: "100%",
  paddingLeft: 10,
  display: "flex",
  alignItems: "center",
  backgroundColor: BACKGROUND,
  borderBottom: `${TIMELINE_ITEM_BORDER_BOTTOM}px solid ${TIMELINE_TRACK_SEPARATOR}`
};
var TimelineTimePlaceholders = () => {
  return /* @__PURE__ */ jsx203("div", {
    style: timeValue,
    children: /* @__PURE__ */ jsx203(TimeValue, {})
  });
};
var TimelineTimePadding = () => {
  return /* @__PURE__ */ jsx203("div", {
    style: {
      height: TIMELINE_TIME_INDICATOR_HEIGHT
    }
  });
};
var TimelineTimeIndicators = () => {
  const sliderTrack = useContext71(TimelineWidthContext);
  const video = Internals53.useVideo();
  if (sliderTrack === null) {
    return null;
  }
  if (video === null) {
    return null;
  }
  return /* @__PURE__ */ jsx203(Inner3, {
    durationInFrames: video.durationInFrames,
    fps: video.fps,
    windowWidth: sliderTrack
  });
};
var Inner3 = ({ windowWidth, durationInFrames, fps }) => {
  const ref = useRef38(null);
  useEffect72(() => {
    const currentRef = ref.current;
    if (!currentRef) {
      return;
    }
    const { current } = timelineVerticalScroll;
    if (!current) {
      return;
    }
    const onScroll = () => {
      currentRef.style.top = current.scrollTop + "px";
    };
    current.addEventListener("scroll", onScroll);
    return () => {
      current.removeEventListener("scroll", onScroll);
    };
  }, []);
  const style11 = useMemo112(() => {
    return {
      ...container41,
      width: windowWidth - SPLITTER_HANDLE_SIZE / 2,
      overflow: "hidden",
      marginLeft: SPLITTER_HANDLE_SIZE / 2,
      pointerEvents: "none"
    };
  }, [windowWidth]);
  const ticks = useMemo112(() => {
    const frameInterval = getFrameIncrementFromWidth(durationInFrames, windowWidth);
    const MIN_SPACING_BETWEEN_TICKS_PX = 5;
    const seconds = Math.floor(durationInFrames / fps);
    const secondMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX * fps / (frameInterval * fps));
    const frameMarkerEveryNth = Math.ceil(MIN_SPACING_BETWEEN_TICKS_PX / frameInterval);
    const secondTicks = new Array(seconds).fill(true).map((_, index) => {
      return {
        frame: index * fps,
        style: {
          ...secondTick,
          left: frameInterval * index * fps + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2
        },
        showTime: index > 0
      };
    }).filter((_, idx) => idx % secondMarkerEveryNth === 0);
    const frameTicks = new Array(durationInFrames).fill(true).map((_, index) => {
      return {
        frame: index,
        style: {
          ...tick,
          left: frameInterval * index + TIMELINE_PADDING - SPLITTER_HANDLE_SIZE / 2,
          height: index % fps === 0 ? 10 : index / frameMarkerEveryNth % 2 === 0 ? 5 : 2
        },
        showTime: false
      };
    }).filter((_, idx) => idx % frameMarkerEveryNth === 0);
    const hasTicks = [];
    return [...secondTicks, ...frameTicks].filter((t) => {
      const alreadyUsed = hasTicks.find((ht) => ht === t.frame) !== undefined;
      hasTicks.push(t.frame);
      return !alreadyUsed;
    });
  }, [durationInFrames, fps, windowWidth]);
  return /* @__PURE__ */ jsx203("div", {
    ref,
    style: style11,
    children: ticks.map((t) => {
      return /* @__PURE__ */ jsx203("div", {
        style: t.style,
        children: t.showTime ? /* @__PURE__ */ jsx203("div", {
          style: tickLabel,
          children: renderFrame(t.frame, fps)
        }) : null
      }, t.frame);
    })
  });
};

// src/components/Timeline/TimelineList.tsx
import { jsx as jsx204, jsxs as jsxs98 } from "react/jsx-runtime";
var container42 = {
  flex: 1,
  background: BACKGROUND
};
var TimelineList = ({ timeline }) => {
  const ref = useRef39(null);
  const size4 = PlayerInternals18.useElementSize(ref, {
    shouldApplyCssTransforms: false,
    triggerOnWindowResize: false
  });
  const isCompact = size4 ? size4.width < 250 : false;
  return /* @__PURE__ */ jsxs98("div", {
    ref,
    style: container42,
    children: [
      /* @__PURE__ */ jsx204(TimelineTimePadding, {}),
      timeline.map((track) => {
        return /* @__PURE__ */ jsx204("div", {
          children: /* @__PURE__ */ jsx204(TimelineListItem, {
            nestedDepth: track.depth,
            sequence: track.sequence,
            isCompact
          }, track.sequence.id)
        }, track.sequence.id);
      })
    ]
  });
};

// src/components/Timeline/TimelinePlayCursorSyncer.tsx
import { useContext as useContext72, useEffect as useEffect73 } from "react";
import { Internals as Internals54 } from "remotion";
var lastTimelinePositionWhileScrolling = null;
var TimelinePlayCursorSyncer = () => {
  const video = Internals54.useVideo();
  const timelineContext = Internals54.useTimelineContext();
  const timelinePosition = Internals54.Timeline.useTimelinePosition();
  const { canvasContent } = useContext72(Internals54.CompositionManager);
  const { zoom: zoomMap } = useContext72(TimelineZoomCtx);
  const compositionId = canvasContent && canvasContent.type === "composition" ? canvasContent.compositionId : null;
  const zoom = compositionId ? zoomMap[compositionId] ?? TIMELINE_MIN_ZOOM : null;
  if (zoom && video) {
    setCurrentFrame(timelinePosition);
    setCurrentZoom(zoom);
    setCurrentDuration(video.durationInFrames);
    setCurrentFps(video.fps);
  }
  const playing = timelineContext.playing ?? false;
  useEffect73(() => {
    if (!video) {
      return;
    }
    if (!playing) {
      return;
    }
    ensureFrameIsInViewport({
      direction: timelineContext.playbackRate > 0 ? "page-right" : "page-left",
      durationInFrames: video.durationInFrames,
      frame: timelinePosition
    });
  }, [playing, timelineContext, timelinePosition, video]);
  useEffect73(() => {
    const { current } = scrollableRef;
    if (!current) {
      return;
    }
    if (playing) {
      lastTimelinePositionWhileScrolling = {
        scrollLeft: current.scrollLeft,
        frame: getCurrentFrame(),
        zoomLevel: getCurrentZoom(),
        durationInFrames: getCurrentDuration()
      };
    } else if (lastTimelinePositionWhileScrolling !== null) {
      if (isCursorInViewport({
        frame: getCurrentFrame(),
        durationInFrames: getCurrentDuration()
      })) {
        return;
      }
      if (lastTimelinePositionWhileScrolling.zoomLevel === getCurrentZoom() && lastTimelinePositionWhileScrolling.durationInFrames === getCurrentDuration()) {
        current.scrollLeft = lastTimelinePositionWhileScrolling.scrollLeft;
      } else {
        ensureFrameIsInViewport({
          direction: "center",
          durationInFrames: getCurrentDuration(),
          frame: lastTimelinePositionWhileScrolling.frame
        });
      }
    }
  }, [playing]);
  return null;
};

// src/components/Timeline/TimelineScrollable.tsx
import { useMemo as useMemo113 } from "react";
import { jsx as jsx205 } from "react/jsx-runtime";
var outer2 = {
  width: "100%",
  height: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  position: "relative",
  backgroundColor: TIMELINE_BACKGROUND
};
var TimelineScrollable = ({ children }) => {
  const containerStyle4 = useMemo113(() => {
    return {
      width: "100%",
      minHeight: "100%"
    };
  }, []);
  return /* @__PURE__ */ jsx205("div", {
    ref: scrollableRef,
    style: outer2,
    className: HORIZONTAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx205("div", {
      style: containerStyle4,
      children
    })
  });
};

// src/components/Timeline/TimelineTracks.tsx
import { useContext as useContext74, useMemo as useMemo117 } from "react";

// src/components/Timeline/TimelineSequence.tsx
import { useContext as useContext73, useMemo as useMemo116 } from "react";
import { Internals as Internals56, useCurrentFrame as useCurrentFrame2 } from "remotion";

// src/helpers/get-timeline-sequence-layout.ts
var SEQUENCE_BORDER_WIDTH = 1;
var getWidthOfTrack = ({
  durationInFrames,
  lastFrame,
  windowWidth,
  spatialDuration,
  nonNegativeMarginLeft
}) => {
  const fullWidth9 = windowWidth - TIMELINE_PADDING * 2;
  const base = durationInFrames === Infinity || lastFrame === 0 ? fullWidth9 : spatialDuration / lastFrame * fullWidth9;
  return base - SEQUENCE_BORDER_WIDTH + nonNegativeMarginLeft;
};
var getTimelineSequenceLayout = ({
  durationInFrames,
  startFrom,
  maxMediaDuration,
  startFromMedia,
  video,
  windowWidth,
  premountDisplay,
  postmountDisplay
}) => {
  const maxMediaSequenceDuration = (maxMediaDuration ?? Infinity) - startFromMedia;
  const lastFrame = (video.durationInFrames ?? 1) - 1;
  const spatialDuration = Math.min(maxMediaSequenceDuration, durationInFrames - 1, lastFrame - startFrom);
  const naturalSpatialDuration = Math.min(maxMediaSequenceDuration, durationInFrames - 1);
  const marginLeft = lastFrame === 0 ? 0 : startFrom / lastFrame * (windowWidth - TIMELINE_PADDING * 2);
  const nonNegativeMarginLeft = Math.min(marginLeft, 0);
  const width = getWidthOfTrack({
    durationInFrames,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration,
    windowWidth
  });
  const naturalWidth = getWidthOfTrack({
    durationInFrames,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: naturalSpatialDuration,
    windowWidth
  });
  const premountWidth = premountDisplay ? getWidthOfTrack({
    durationInFrames: premountDisplay,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: premountDisplay,
    windowWidth
  }) : null;
  const postmountWidth = postmountDisplay ? getWidthOfTrack({
    durationInFrames: postmountDisplay,
    lastFrame,
    nonNegativeMarginLeft,
    spatialDuration: postmountDisplay,
    windowWidth
  }) : null;
  return {
    marginLeft: Math.max(marginLeft, 0) - (premountWidth ?? 0),
    width: width + (premountWidth ?? 0) + (postmountWidth ?? 0),
    naturalWidth: naturalWidth + (premountWidth ?? 0) + (postmountWidth ?? 0),
    premountWidth,
    postmountWidth
  };
};

// src/helpers/use-max-media-duration.ts
import { getVideoMetadata as getVideoMetadata2 } from "@remotion/media-utils";
import { ALL_FORMATS as ALL_FORMATS2, Input as Input2, InputDisposedError, UrlSource as UrlSource2 } from "mediabunny";
import { useEffect as useEffect74, useState as useState74 } from "react";
var cache = new Map;
var getSrc = (s) => {
  if (s.type === "video") {
    return s.src;
  }
  if (s.type === "audio") {
    return s.src;
  }
  return null;
};
var useMaxMediaDuration = (s, fps) => {
  const src = getSrc(s);
  const [maxMediaDuration, setMaxMediaDuration] = useState74(src ? cache.get(src) ?? null : Infinity);
  useEffect74(() => {
    if (!src) {
      return;
    }
    const input2 = new Input2({
      formats: ALL_FORMATS2,
      source: new UrlSource2(src)
    });
    input2.computeDuration().then((duration) => {
      cache.set(src, Math.floor(duration * fps));
      setMaxMediaDuration(Math.floor(duration * fps));
    }).catch((e) => {
      if (e instanceof InputDisposedError) {
        return;
      }
      return getVideoMetadata2(src).then((metadata) => {
        const durationOrInfinity = metadata.durationInSeconds ?? Infinity;
        cache.set(src, Math.floor(durationOrInfinity * fps));
        setMaxMediaDuration(Math.floor(durationOrInfinity * fps));
      }).catch(() => {});
    });
    return () => {
      input2.dispose();
    };
  }, [src, fps]);
  if (maxMediaDuration !== null && (s.type === "audio" || s.type === "video")) {
    return maxMediaDuration / s.playbackRate;
  }
  return maxMediaDuration;
};

// src/components/AudioWaveform.tsx
import { getAudioData, getWaveformPortion } from "@remotion/media-utils";
import { useEffect as useEffect75, useMemo as useMemo115, useRef as useRef40, useState as useState75 } from "react";
import { Internals as Internals55 } from "remotion";

// src/components/AudioWaveformBar.tsx
import { useMemo as useMemo114 } from "react";
import { jsx as jsx206 } from "react/jsx-runtime";
var WAVEFORM_BAR_LENGTH = 2;
var WAVEFORM_BAR_MARGIN = 1;
var container43 = {
  width: WAVEFORM_BAR_LENGTH,
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  marginLeft: WAVEFORM_BAR_MARGIN,
  borderRadius: 2
};
var AudioWaveformBar = ({ amplitude }) => {
  const style11 = useMemo114(() => {
    return {
      ...container43,
      height: getTimelineLayerHeight("other") * amplitude * (1 / 0.6366)
    };
  }, [amplitude]);
  return /* @__PURE__ */ jsx206("div", {
    style: style11
  });
};

// src/components/AudioWaveform.tsx
import { jsx as jsx207, jsxs as jsxs99 } from "react/jsx-runtime";
var container44 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  position: "absolute",
  height: getTimelineLayerHeight("other")
};
var errorMessage = {
  fontSize: 13,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  paddingRight: 12,
  alignSelf: "flex-start",
  maxWidth: 450,
  opacity: 0.75
};
var canvasStyle = {
  position: "absolute"
};
var AudioWaveform = ({
  src,
  startFrom,
  durationInFrames,
  visualizationWidth,
  volume,
  doesVolumeChange,
  playbackRate
}) => {
  const [metadata, setMetadata] = useState75(null);
  const [error, setError] = useState75(null);
  const mountState = useRef40({ isMounted: true });
  const vidConf = Internals55.useUnsafeVideoConfig();
  if (vidConf === null) {
    throw new Error("Expected video config");
  }
  const canvas = useRef40(null);
  useEffect75(() => {
    const { current } = mountState;
    current.isMounted = true;
    return () => {
      current.isMounted = false;
    };
  }, []);
  useEffect75(() => {
    if (!canvas.current) {
      return;
    }
    const context = canvas.current.getContext("2d");
    if (!context) {
      return;
    }
    context.clearRect(0, 0, visualizationWidth, getTimelineLayerHeight("other"));
    if (!doesVolumeChange || typeof volume === "number") {
      return;
    }
    const volumes = volume.split(",").map((v) => Number(v));
    context.beginPath();
    context.moveTo(0, getTimelineLayerHeight("other"));
    volumes.forEach((v, index) => {
      const x = index / (volumes.length - 1) * visualizationWidth;
      const y = (1 - v) * (getTimelineLayerHeight("other") - TIMELINE_BORDER * 2) + 1;
      if (index === 0) {
        context.moveTo(x, y);
      } else {
        context.lineTo(x, y);
      }
    });
    context.strokeStyle = LIGHT_TRANSPARENT;
    context.stroke();
  }, [visualizationWidth, metadata, startFrom, volume, doesVolumeChange]);
  useEffect75(() => {
    setError(null);
    getAudioData(src).then((data) => {
      if (mountState.current.isMounted) {
        setMetadata(data);
      }
    }).catch((err) => {
      if (mountState.current.isMounted) {
        setError(err);
      }
    });
  }, [src, vidConf.fps]);
  const normalized = useMemo115(() => {
    if (!metadata || metadata.numberOfChannels === 0) {
      return [];
    }
    const numberOfSamples = Math.floor(visualizationWidth / (WAVEFORM_BAR_LENGTH + WAVEFORM_BAR_MARGIN));
    return getWaveformPortion({
      audioData: metadata,
      startTimeInSeconds: startFrom / vidConf.fps,
      durationInSeconds: Math.min(durationInFrames / vidConf.fps * playbackRate, metadata.durationInSeconds),
      numberOfSamples,
      normalize: false
    });
  }, [
    durationInFrames,
    vidConf.fps,
    metadata,
    playbackRate,
    startFrom,
    visualizationWidth
  ]);
  if (error) {
    return /* @__PURE__ */ jsx207("div", {
      style: container44,
      children: /* @__PURE__ */ jsx207("div", {
        style: errorMessage,
        children: "No waveform available. Audio might not support CORS."
      })
    });
  }
  if (!metadata) {
    return null;
  }
  return /* @__PURE__ */ jsxs99("div", {
    style: container44,
    children: [
      normalized.map((w) => {
        return /* @__PURE__ */ jsx207(AudioWaveformBar, {
          amplitude: w.amplitude * (typeof volume === "number" ? volume : 1)
        }, w.index);
      }),
      /* @__PURE__ */ jsx207("canvas", {
        ref: canvas,
        style: canvasStyle,
        width: visualizationWidth,
        height: getTimelineLayerHeight("other")
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import React146 from "react";
import { AbsoluteFill as AbsoluteFill4 } from "remotion";

// src/components/Timeline/LoopedIndicator.tsx
import { AbsoluteFill as AbsoluteFill3 } from "remotion";
import { jsx as jsx208, jsxs as jsxs100 } from "react/jsx-runtime";
var width = {
  width: 0,
  flexDirection: "row",
  display: "flex",
  position: "relative"
};
var icon5 = {
  height: 12
};
var Icon = () => /* @__PURE__ */ jsx208("svg", {
  viewBox: "0 0 512 512",
  style: icon5,
  children: /* @__PURE__ */ jsx208("path", {
    fill: LIGHT_COLOR,
    d: "M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z"
  })
});
var topLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var bottomLine = {
  top: 0,
  height: 2,
  width: 1,
  background: LIGHT_COLOR
};
var topContainer = {
  justifyContent: "flex-start",
  alignItems: "center"
};
var centerContainer = {
  justifyContent: "center",
  alignItems: "center"
};
var bottomContainer = {
  justifyContent: "flex-end",
  alignItems: "center"
};
var LoopedIndicator = () => {
  return /* @__PURE__ */ jsxs100("div", {
    style: width,
    children: [
      /* @__PURE__ */ jsx208(AbsoluteFill3, {
        style: topContainer,
        children: /* @__PURE__ */ jsx208("div", {
          style: topLine
        })
      }),
      /* @__PURE__ */ jsx208(AbsoluteFill3, {
        style: bottomContainer,
        children: /* @__PURE__ */ jsx208("div", {
          style: bottomLine
        })
      }),
      /* @__PURE__ */ jsx208(AbsoluteFill3, {
        style: centerContainer,
        children: /* @__PURE__ */ jsx208(Icon, {})
      })
    ]
  });
};

// src/components/Timeline/LoopedTimelineIndicators.tsx
import { jsx as jsx209, jsxs as jsxs101 } from "react/jsx-runtime";
var row7 = {
  flexDirection: "row"
};
var LoopedTimelineIndicator = ({ loops }) => {
  const leftOver = loops % 1;
  return /* @__PURE__ */ jsxs101(AbsoluteFill4, {
    style: row7,
    children: [
      new Array(Math.floor(loops)).fill(true).map((_l, i) => {
        return /* @__PURE__ */ jsxs101(React146.Fragment, {
          children: [
            /* @__PURE__ */ jsx209(Flex, {}),
            i === loops - 1 ? null : /* @__PURE__ */ jsx209(LoopedIndicator, {})
          ]
        }, i);
      }),
      leftOver > 0 ? /* @__PURE__ */ jsx209("div", {
        style: { flex: leftOver }
      }) : null
    ]
  });
};

// src/components/Timeline/TimelineSequenceFrame.tsx
import { jsx as jsx210 } from "react/jsx-runtime";
var relativeFrameStyle = {
  fontSize: 11,
  fontFamily: "Arial, Helvetica, sans-serif",
  color: "white",
  opacity: 0.5,
  whiteSpace: "nowrap"
};
var TimelineSequenceFrame = ({ roundedFrame, premounted, postmounted }) => {
  return /* @__PURE__ */ jsx210("div", {
    style: relativeFrameStyle,
    children: premounted ? "0 (Premounted)" : postmounted !== null ? `${postmounted} (Postmounted)` : roundedFrame
  });
};

// src/components/Timeline/TimelineVideoInfo.tsx
import { useEffect as useEffect76, useRef as useRef41, useState as useState76 } from "react";
import { useVideoConfig as useVideoConfig5 } from "remotion";

// src/helpers/extract-frames.ts
import {
  ALL_FORMATS as ALL_FORMATS3,
  Input as Input3,
  InputDisposedError as InputDisposedError2,
  UrlSource as UrlSource3,
  VideoSampleSink
} from "mediabunny";
async function extractFrames({
  src,
  timestampsInSeconds,
  onVideoSample,
  signal
}) {
  const input2 = new Input3({
    formats: ALL_FORMATS3,
    source: new UrlSource3(src)
  });
  const dispose = () => {
    input2.dispose();
  };
  if (signal) {
    signal.addEventListener("abort", dispose, { once: true });
  }
  try {
    const [durationInSeconds, format, videoTrack] = await Promise.all([
      input2.computeDuration(),
      input2.getFormat(),
      input2.getPrimaryVideoTrack()
    ]);
    if (!videoTrack) {
      throw new Error("No video track found in the input");
    }
    const timestamps = typeof timestampsInSeconds === "function" ? await timestampsInSeconds({
      track: {
        width: videoTrack.displayWidth,
        height: videoTrack.displayHeight
      },
      container: format.name,
      durationInSeconds
    }) : timestampsInSeconds;
    if (timestamps.length === 0) {
      return;
    }
    const sink = new VideoSampleSink(videoTrack);
    const sampleIterator = sink.samplesAtTimestamps(timestamps);
    try {
      for await (const videoSample of sampleIterator) {
        if (signal?.aborted) {
          videoSample?.close();
          break;
        }
        if (!videoSample) {
          continue;
        }
        onVideoSample(videoSample);
      }
    } finally {
      try {
        await sampleIterator.return?.();
      } catch {}
    }
  } catch (error) {
    if (error instanceof InputDisposedError2) {
      return;
    }
    throw error;
  } finally {
    dispose();
    if (signal) {
      signal.removeEventListener("abort", dispose);
    }
  }
}

// src/helpers/frame-database.ts
var KEY_SEPARATOR = "|";
var makeFrameDatabaseKey = (src, timestamp) => `${src}${KEY_SEPARATOR}${timestamp}`;
var getFrameDatabaseKeyPrefix = (src) => {
  return `${src}${KEY_SEPARATOR}`;
};
var frameDatabase = new Map;
var aspectRatioCache = new Map;
var getTimestampFromFrameDatabaseKey = (key4) => {
  const split = key4.split(KEY_SEPARATOR);
  return Number(split[split.length - 1]);
};
var getAspectRatioFromCache = (src) => {
  const cached = aspectRatioCache.get(src);
  if (cached) {
    return cached;
  }
  return null;
};
var MAX_FRAMES_IN_CACHE = 12340;
var clearOldFrames = () => {
  if (frameDatabase.size <= MAX_FRAMES_IN_CACHE) {
    return;
  }
  const framesToRemove = Array.from(frameDatabase.entries()).sort((a, b) => a[1].lastUsed - b[1].lastUsed);
  for (const [key4, frame2] of framesToRemove.slice(0, framesToRemove.length - MAX_FRAMES_IN_CACHE)) {
    frame2.frame.close();
    frameDatabase.delete(key4);
  }
};
var clearFramesForSrc = (src) => {
  const keysToRemove = [];
  const prefix = getFrameDatabaseKeyPrefix(src);
  for (const [key4, frame2] of frameDatabase.entries()) {
    if (key4.startsWith(prefix)) {
      frame2.frame.close();
      keysToRemove.push(key4);
    }
  }
  for (const key4 of keysToRemove) {
    frameDatabase.delete(key4);
  }
};

// src/helpers/resize-video-frame.ts
var calculateNewDimensionsFromScale = ({
  width: width2,
  height,
  scale
}) => {
  const scaledWidth = Math.round(width2 * scale);
  const scaledHeight = Math.round(height * scale);
  return {
    width: scaledWidth,
    height: scaledHeight
  };
};
var resizeVideoFrame = ({
  frame: frame2,
  scale
}) => {
  if (scale === 1) {
    return frame2;
  }
  const { width: width2, height } = calculateNewDimensionsFromScale({
    height: frame2.displayHeight,
    width: frame2.displayWidth,
    scale
  });
  const canvas = new OffscreenCanvas(width2, height);
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get 2d context");
  }
  canvas.width = width2;
  canvas.height = height;
  ctx.scale(scale, scale);
  ctx.drawImage(frame2, 0, 0);
  return new VideoFrame(canvas, {
    displayHeight: height,
    displayWidth: width2,
    duration: frame2.duration ?? undefined,
    timestamp: frame2.timestamp
  });
};

// src/components/Timeline/TimelineVideoInfo.tsx
import { jsx as jsx211 } from "react/jsx-runtime";
var HEIGHT = getTimelineLayerHeight("video") - 2;
var containerStyle4 = {
  height: HEIGHT,
  width: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
  display: "flex",
  borderTopLeftRadius: 2,
  borderBottomLeftRadius: 2,
  fontSize: 10,
  fontFamily: "Arial, Helvetica"
};
var WEBCODECS_TIMESCALE = 1e6;
var MAX_TIME_DEVIATION = WEBCODECS_TIMESCALE * 0.05;
var getDurationOfOneFrame = ({
  visualizationWidth,
  aspectRatio,
  segmentDuration
}) => {
  const framesFitInWidthUnrounded = visualizationWidth / (HEIGHT * aspectRatio);
  return segmentDuration / framesFitInWidthUnrounded * WEBCODECS_TIMESCALE;
};
var fixRounding = (value) => {
  if (value % 1 >= 0.49999999) {
    return Math.ceil(value);
  }
  return Math.floor(value);
};
var calculateTimestampSlots = ({
  visualizationWidth,
  fromSeconds,
  segmentDuration,
  aspectRatio
}) => {
  const framesFitInWidthUnrounded = visualizationWidth / (HEIGHT * aspectRatio);
  const framesFitInWidth = Math.ceil(framesFitInWidthUnrounded);
  const durationOfOneFrame = getDurationOfOneFrame({
    visualizationWidth,
    aspectRatio,
    segmentDuration
  });
  const timestampTargets = [];
  for (let i = 0;i < framesFitInWidth + 1; i++) {
    const target = fromSeconds * WEBCODECS_TIMESCALE + durationOfOneFrame * (i + 0.5);
    const snappedToDuration = (Math.round(fixRounding(target / durationOfOneFrame)) - 1) * durationOfOneFrame;
    timestampTargets.push(snappedToDuration);
  }
  return timestampTargets;
};
var ensureSlots = ({
  filledSlots,
  naturalWidth,
  fromSeconds,
  toSeconds,
  aspectRatio
}) => {
  const segmentDuration = toSeconds - fromSeconds;
  const timestampTargets = calculateTimestampSlots({
    visualizationWidth: naturalWidth,
    fromSeconds,
    segmentDuration,
    aspectRatio
  });
  for (const timestamp of timestampTargets) {
    if (!filledSlots.has(timestamp)) {
      filledSlots.set(timestamp, undefined);
    }
  }
};
var drawSlot = ({
  frame: frame2,
  ctx,
  filledSlots,
  visualizationWidth,
  timestamp,
  segmentDuration,
  fromSeconds
}) => {
  const durationOfOneFrame = getDurationOfOneFrame({
    visualizationWidth,
    aspectRatio: frame2.displayWidth / frame2.displayHeight,
    segmentDuration
  });
  const relativeTimestamp = timestamp - fromSeconds * WEBCODECS_TIMESCALE;
  const frameIndex = relativeTimestamp / durationOfOneFrame;
  const left3 = Math.floor(frameIndex * frame2.displayWidth / window.devicePixelRatio);
  ctx.drawImage(frame2, left3, 0, frame2.displayWidth / window.devicePixelRatio, frame2.displayHeight / window.devicePixelRatio);
  filledSlots.set(timestamp, frame2.timestamp);
};
var fillWithCachedFrames = ({
  ctx,
  naturalWidth,
  filledSlots,
  src,
  segmentDuration,
  fromSeconds
}) => {
  const prefix = getFrameDatabaseKeyPrefix(src);
  const keys = Array.from(frameDatabase.keys()).filter((k) => k.startsWith(prefix));
  const targets = Array.from(filledSlots.keys());
  for (const timestamp of targets) {
    let bestKey;
    let bestDistance = Infinity;
    for (const key4 of keys) {
      const distance = Math.abs(getTimestampFromFrameDatabaseKey(key4) - timestamp);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestKey = key4;
      }
    }
    if (!bestKey) {
      continue;
    }
    const frame2 = frameDatabase.get(bestKey);
    if (!frame2) {
      continue;
    }
    const alreadyFilled = filledSlots.get(timestamp);
    if (alreadyFilled && Math.abs(alreadyFilled - timestamp) <= Math.abs(frame2.frame.timestamp - timestamp)) {
      continue;
    }
    frame2.lastUsed = Date.now();
    drawSlot({
      ctx,
      frame: frame2.frame,
      filledSlots,
      visualizationWidth: naturalWidth,
      timestamp,
      segmentDuration,
      fromSeconds
    });
  }
};
var fillFrameWhereItFits = ({
  frame: frame2,
  filledSlots,
  ctx,
  visualizationWidth,
  segmentDuration,
  fromSeconds
}) => {
  const slots = Array.from(filledSlots.keys());
  for (let i = 0;i < slots.length; i++) {
    const slot = slots[i];
    if (Math.abs(slot - frame2.timestamp) > MAX_TIME_DEVIATION) {
      continue;
    }
    const filled = filledSlots.get(slot);
    if (filled && Math.abs(filled - slot) <= Math.abs(filled - frame2.timestamp)) {
      continue;
    }
    drawSlot({
      ctx,
      frame: frame2,
      filledSlots,
      visualizationWidth,
      timestamp: slot,
      segmentDuration,
      fromSeconds
    });
  }
};
var TimelineVideoInfo = ({
  src,
  visualizationWidth,
  naturalWidth,
  trimBefore,
  durationInFrames,
  playbackRate
}) => {
  const { fps } = useVideoConfig5();
  const ref = useRef41(null);
  const [error, setError] = useState76(null);
  const aspectRatio = useRef41(getAspectRatioFromCache(src));
  useEffect76(() => {
    return () => {
      clearFramesForSrc(src);
    };
  }, [src]);
  useEffect76(() => {
    if (error) {
      return;
    }
    const { current } = ref;
    if (!current) {
      return;
    }
    const controller = new AbortController;
    const canvas = document.createElement("canvas");
    canvas.width = visualizationWidth;
    canvas.height = HEIGHT;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }
    current.appendChild(canvas);
    const filledSlots = new Map;
    const fromSeconds = trimBefore / fps;
    const toSeconds = fromSeconds + durationInFrames * playbackRate / fps;
    if (aspectRatio.current !== null) {
      ensureSlots({
        filledSlots,
        naturalWidth,
        fromSeconds,
        toSeconds,
        aspectRatio: aspectRatio.current
      });
      fillWithCachedFrames({
        ctx,
        naturalWidth,
        filledSlots,
        src,
        segmentDuration: toSeconds - fromSeconds,
        fromSeconds
      });
      const unfilled = Array.from(filledSlots.keys()).filter((timestamp) => !filledSlots.get(timestamp));
      if (unfilled.length === 0) {
        return () => {
          current.removeChild(canvas);
          clearOldFrames();
        };
      }
    }
    clearOldFrames();
    extractFrames({
      timestampsInSeconds: ({
        track
      }) => {
        aspectRatio.current = track.width / track.height;
        aspectRatioCache.set(src, aspectRatio.current);
        ensureSlots({
          filledSlots,
          fromSeconds,
          toSeconds,
          naturalWidth,
          aspectRatio: aspectRatio.current
        });
        return Array.from(filledSlots.keys()).map((timestamp) => timestamp / WEBCODECS_TIMESCALE);
      },
      src,
      onVideoSample: (sample) => {
        let frame2;
        try {
          frame2 = sample.toVideoFrame();
          const scale = HEIGHT / frame2.displayHeight * window.devicePixelRatio;
          const transformed = resizeVideoFrame({
            frame: frame2,
            scale
          });
          if (transformed !== frame2) {
            frame2.close();
          }
          frame2 = undefined;
          const databaseKey = makeFrameDatabaseKey(src, transformed.timestamp);
          const existingFrame = frameDatabase.get(databaseKey);
          if (existingFrame) {
            existingFrame.frame.close();
          }
          frameDatabase.set(databaseKey, {
            frame: transformed,
            lastUsed: Date.now()
          });
          if (aspectRatio.current === null) {
            throw new Error("Aspect ratio is not set");
          }
          ensureSlots({
            filledSlots,
            fromSeconds,
            toSeconds,
            naturalWidth,
            aspectRatio: aspectRatio.current
          });
          fillFrameWhereItFits({
            ctx,
            filledSlots,
            visualizationWidth: naturalWidth,
            frame: transformed,
            segmentDuration: toSeconds - fromSeconds,
            fromSeconds
          });
        } catch (e) {
          if (frame2) {
            frame2.close();
          }
          throw e;
        } finally {
          sample.close();
        }
      },
      signal: controller.signal
    }).then(() => {
      if (controller.signal.aborted) {
        return;
      }
      fillWithCachedFrames({
        ctx,
        naturalWidth,
        filledSlots,
        src,
        segmentDuration: toSeconds - fromSeconds,
        fromSeconds
      });
    }).catch((e) => {
      setError(e);
    }).finally(() => {
      clearOldFrames();
    });
    return () => {
      controller.abort();
      current.removeChild(canvas);
    };
  }, [
    durationInFrames,
    error,
    fps,
    naturalWidth,
    playbackRate,
    src,
    trimBefore,
    visualizationWidth
  ]);
  return /* @__PURE__ */ jsx211("div", {
    ref,
    style: containerStyle4
  });
};

// src/components/Timeline/TimelineSequence.tsx
import { jsx as jsx212, jsxs as jsxs102 } from "react/jsx-runtime";
var AUDIO_GRADIENT = "linear-gradient(rgb(16 171 58), rgb(43 165 63) 60%)";
var VIDEO_GRADIENT = "linear-gradient(to top, #8e44ad, #9b59b6)";
var TimelineSequence = ({ s }) => {
  const windowWidth = useContext73(TimelineWidthContext);
  if (windowWidth === null) {
    return null;
  }
  return /* @__PURE__ */ jsx212(Inner4, {
    windowWidth,
    s
  });
};
var Inner4 = ({ s, windowWidth }) => {
  const video = Internals56.useVideo();
  const maxMediaDuration = useMaxMediaDuration(s, video?.fps ?? 30);
  if (!video) {
    throw new TypeError("Expected video config");
  }
  const frame2 = useCurrentFrame2();
  const relativeFrame = frame2 - s.from;
  const relativeFrameWithPremount = relativeFrame + (s.premountDisplay ?? 0);
  const relativeFrameWithPostmount = relativeFrame - s.duration;
  const roundedFrame = Math.round(relativeFrame * 100) / 100;
  const isInRange = relativeFrame >= 0 && relativeFrame < s.duration;
  const isPremounting = relativeFrameWithPremount >= 0 && relativeFrameWithPremount < s.duration && !isInRange;
  const isPostmounting = relativeFrameWithPostmount >= 0 && relativeFrameWithPostmount < (s.postmountDisplay ?? 0) && !isInRange;
  const { marginLeft, width: width2, naturalWidth, premountWidth, postmountWidth } = useMemo116(() => {
    return getTimelineSequenceLayout({
      durationInFrames: s.loopDisplay ? s.loopDisplay.durationInFrames * s.loopDisplay.numberOfTimes : s.duration,
      startFrom: s.loopDisplay ? s.from + s.loopDisplay.startOffset : s.from,
      startFromMedia: s.type === "sequence" ? 0 : s.startMediaFrom,
      maxMediaDuration,
      video,
      windowWidth,
      premountDisplay: s.premountDisplay,
      postmountDisplay: s.postmountDisplay
    });
  }, [maxMediaDuration, s, video, windowWidth]);
  const style11 = useMemo116(() => {
    return {
      background: s.type === "audio" ? AUDIO_GRADIENT : s.type === "video" ? VIDEO_GRADIENT : BLUE,
      border: SEQUENCE_BORDER_WIDTH + "px solid rgba(255, 255, 255, 0.2)",
      borderRadius: 2,
      position: "absolute",
      height: getTimelineLayerHeight(s.type === "video" ? "video" : "other"),
      marginLeft,
      width: width2,
      color: "white",
      overflow: "hidden",
      opacity: isInRange ? 1 : 0.5
    };
  }, [isInRange, marginLeft, s.type, width2]);
  if (maxMediaDuration === null) {
    return null;
  }
  return /* @__PURE__ */ jsxs102("div", {
    style: style11,
    title: s.displayName,
    children: [
      premountWidth ? /* @__PURE__ */ jsx212("div", {
        style: {
          width: premountWidth,
          height: "100%",
          background: `repeating-linear-gradient(
							-45deg,
							transparent,
							transparent 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 2px,
							rgba(255, 255, 255, ${isPremounting ? 0.5 : 0.2}) 4px
						)`,
          position: "absolute"
        }
      }) : null,
      postmountWidth ? /* @__PURE__ */ jsx212("div", {
        style: {
          width: postmountWidth,
          height: "100%",
          background: `repeating-linear-gradient(
							-45deg,
							transparent,
							transparent 2px,
							rgba(255, 255, 255, ${isPostmounting ? 0.5 : 0.2}) 2px,
							rgba(255, 255, 255, ${isPostmounting ? 0.5 : 0.2}) 4px
						)`,
          position: "absolute",
          right: 0
        }
      }) : null,
      s.type === "audio" ? /* @__PURE__ */ jsx212(AudioWaveform, {
        src: s.src,
        doesVolumeChange: s.doesVolumeChange,
        visualizationWidth: width2,
        startFrom: s.startMediaFrom,
        durationInFrames: s.duration,
        volume: s.volume,
        playbackRate: s.playbackRate
      }) : null,
      s.type === "video" ? /* @__PURE__ */ jsx212(TimelineVideoInfo, {
        src: s.src,
        visualizationWidth: width2,
        naturalWidth,
        trimBefore: s.startMediaFrom,
        durationInFrames: s.duration,
        playbackRate: s.playbackRate
      }) : null,
      s.loopDisplay === undefined ? null : /* @__PURE__ */ jsx212(LoopedTimelineIndicator, {
        loops: s.loopDisplay.numberOfTimes
      }),
      s.type !== "audio" && s.type !== "video" && s.loopDisplay === undefined && (isInRange || isPremounting || isPostmounting) ? /* @__PURE__ */ jsx212("div", {
        style: {
          paddingLeft: 5 + (premountWidth ?? 0),
          height: "100%",
          display: "flex",
          alignItems: "center"
        },
        children: /* @__PURE__ */ jsx212(TimelineSequenceFrame, {
          premounted: isPremounting,
          postmounted: isPostmounting ? s.duration - 1 : null,
          roundedFrame
        })
      }) : null
    ]
  }, s.id);
};

// src/components/Timeline/TimelineTracks.tsx
import { jsx as jsx213, jsxs as jsxs103 } from "react/jsx-runtime";
var content = {
  paddingLeft: TIMELINE_PADDING,
  paddingRight: TIMELINE_PADDING,
  paddingTop: 1
};
var timelineContent = {
  minHeight: "100%"
};
var getExpandedPlaceholderStyle = (controls) => ({
  height: getExpandedTrackHeight(controls) + TIMELINE_ITEM_BORDER_BOTTOM
});
var TimelineTracks = ({ timeline, hasBeenCut }) => {
  const { expandedTracks } = useContext74(ExpandedTracksContext);
  const { previewServerState } = useContext74(StudioServerConnectionCtx);
  const visualModeEnabled = Boolean(process.env.EXPERIMENTAL_VISUAL_MODE_ENABLED) && previewServerState.type === "connected";
  const timelineStyle = useMemo117(() => {
    return {
      ...timelineContent,
      width: 100 + "%"
    };
  }, []);
  return /* @__PURE__ */ jsxs103("div", {
    style: timelineStyle,
    children: [
      /* @__PURE__ */ jsxs103("div", {
        style: content,
        children: [
          /* @__PURE__ */ jsx213(TimelineTimePadding, {}),
          timeline.map((track) => {
            if (isTrackHidden(track)) {
              return null;
            }
            const isExpanded = expandedTracks[track.sequence.id] ?? false;
            return /* @__PURE__ */ jsxs103("div", {
              children: [
                /* @__PURE__ */ jsx213("div", {
                  style: {
                    height: getTimelineLayerHeight(track.sequence.type === "video" ? "video" : "other"),
                    marginBottom: TIMELINE_ITEM_BORDER_BOTTOM
                  },
                  children: /* @__PURE__ */ jsx213(TimelineSequence, {
                    s: track.sequence
                  })
                }),
                visualModeEnabled && isExpanded ? /* @__PURE__ */ jsx213("div", {
                  style: getExpandedPlaceholderStyle(track.sequence.controls)
                }) : null
              ]
            }, track.sequence.id);
          })
        ]
      }),
      hasBeenCut ? /* @__PURE__ */ jsx213(MaxTimelineTracksReached, {}) : null
    ]
  });
};

// src/components/Timeline/Timeline.tsx
import { jsx as jsx214, jsxs as jsxs104 } from "react/jsx-runtime";
var container45 = {
  minHeight: "100%",
  flex: 1,
  display: "flex",
  height: 0,
  overflowY: "auto",
  backgroundColor: BACKGROUND
};
var noop3 = () => {
  return;
};
var Timeline = () => {
  const { sequences } = useContext75(Internals57.SequenceManager);
  const videoConfig = Internals57.useUnsafeVideoConfig();
  const timeline = useMemo118(() => {
    if (!videoConfig) {
      return [];
    }
    return calculateTimeline({
      sequences,
      sequenceDuration: videoConfig.durationInFrames
    });
  }, [sequences, videoConfig]);
  const durationInFrames = videoConfig?.durationInFrames ?? 0;
  const filtered = useMemo118(() => {
    const withoutHidden = timeline.filter((t) => !isTrackHidden(t));
    const withoutAfter = withoutHidden.filter((t) => {
      return t.sequence.from <= durationInFrames && t.sequence.duration > 0;
    });
    return withoutAfter.filter((t) => t.sequence.showInTimeline);
  }, [durationInFrames, timeline]);
  const shown = filtered.slice(0, MAX_TIMELINE_TRACKS);
  const hasBeenCut = filtered.length > shown.length;
  const inner2 = useMemo118(() => {
    return {
      height: shown.reduce((acc, track) => {
        return acc + getTimelineLayerHeight(track.sequence.type === "video" ? "video" : "other") + Number(TIMELINE_ITEM_BORDER_BOTTOM);
      }, 0) + TIMELINE_ITEM_BORDER_BOTTOM + (hasBeenCut ? MAX_TIMELINE_TRACKS_NOTICE_HEIGHT : 0) + TIMELINE_TIME_INDICATOR_HEIGHT,
      display: "flex",
      flex: 1,
      minHeight: "100%",
      overflowX: "hidden"
    };
  }, [hasBeenCut, shown]);
  return /* @__PURE__ */ jsx214("div", {
    ref: timelineVerticalScroll,
    style: container45,
    className: "css-reset " + VERTICAL_SCROLLBAR_CLASSNAME,
    children: /* @__PURE__ */ jsx214(TimelineWidthProvider, {
      children: /* @__PURE__ */ jsx214("div", {
        style: inner2,
        children: /* @__PURE__ */ jsxs104(SplitterContainer, {
          orientation: "vertical",
          defaultFlex: 0.2,
          id: "names-to-timeline",
          maxFlex: 0.5,
          minFlex: 0.15,
          children: [
            /* @__PURE__ */ jsx214(SplitterElement, {
              type: "flexer",
              sticky: /* @__PURE__ */ jsx214(TimelineTimePlaceholders, {}),
              children: /* @__PURE__ */ jsx214(TimelineList, {
                timeline: shown
              })
            }),
            /* @__PURE__ */ jsx214(SplitterHandle, {
              onCollapse: noop3,
              allowToCollapse: "none"
            }),
            /* @__PURE__ */ jsx214(SplitterElement, {
              type: "anti-flexer",
              sticky: null,
              children: /* @__PURE__ */ jsxs104(TimelineScrollable, {
                children: [
                  /* @__PURE__ */ jsx214(TimelineTracks, {
                    timeline: shown,
                    hasBeenCut
                  }),
                  /* @__PURE__ */ jsx214(TimelineInOutPointer, {}),
                  /* @__PURE__ */ jsx214(TimelinePlayCursorSyncer, {}),
                  /* @__PURE__ */ jsx214(TimelineDragHandler, {}),
                  /* @__PURE__ */ jsx214(TimelineTimeIndicators, {}),
                  /* @__PURE__ */ jsx214(TimelineSlider, {})
                ]
              })
            })
          ]
        })
      })
    })
  });
};

// src/components/Timeline/TimelineEmptyState.tsx
import { jsx as jsx215 } from "react/jsx-runtime";
var container46 = {
  display: "flex",
  flex: 1,
  height: 0,
  backgroundColor: BACKGROUND
};
var TimelineEmptyState = () => {
  return /* @__PURE__ */ jsx215("div", {
    style: container46
  });
};

// src/components/EditorContent.tsx
import { jsx as jsx216, jsxs as jsxs105 } from "react/jsx-runtime";
var noop4 = () => {
  return;
};
var container47 = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  height: 0
};
var EditorContent = ({ readOnlyStudio, children }) => {
  const isStill = useIsStill();
  const { canvasContent } = useContext76(Internals58.CompositionManager);
  const showTimeline = canvasContent !== null && !isStill && canvasContent.type === "composition";
  return /* @__PURE__ */ jsxs105("div", {
    style: container47,
    children: [
      /* @__PURE__ */ jsx216(InitialCompositionLoader, {}),
      /* @__PURE__ */ jsx216(MenuToolbar, {
        readOnlyStudio
      }),
      /* @__PURE__ */ jsxs105(SplitterContainer, {
        orientation: "horizontal",
        id: "top-to-bottom",
        maxFlex: 0.9,
        minFlex: 0.2,
        defaultFlex: 0.75,
        children: [
          /* @__PURE__ */ jsx216(SplitterElement, {
            sticky: null,
            type: "flexer",
            children
          }),
          /* @__PURE__ */ jsx216(SplitterHandle, {
            allowToCollapse: "none",
            onCollapse: noop4
          }),
          /* @__PURE__ */ jsx216(SplitterElement, {
            sticky: null,
            type: "anti-flexer",
            children: showTimeline ? /* @__PURE__ */ jsx216(Timeline, {}) : /* @__PURE__ */ jsx216(TimelineEmptyState, {})
          })
        ]
      })
    ]
  });
};

// src/components/GlobalKeybindings.tsx
import { useContext as useContext77, useEffect as useEffect77 } from "react";
var GlobalKeybindings = () => {
  const keybindings = useKeybinding();
  const { setSelectedModal } = useContext77(ModalsContext);
  const { setCheckerboard } = useContext77(CheckerboardContext);
  const { navigateToNextComposition, navigateToPreviousComposition } = useCompositionNavigation();
  useEffect77(() => {
    const nKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "n",
      callback: () => {
        showNotification(`To make a new composition, right-click an existing one and select "Duplicate"`, 5000);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const cmdKKey = keybindings.registerKeybinding({
      event: "keydown",
      key: "k",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "compositions",
          invocationTimestamp: Date.now()
        });
      },
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false,
      commandCtrlKey: true,
      preventDefault: true
    });
    const cmdIKey = process.env.ASK_AI_ENABLED ? keybindings.registerKeybinding({
      event: "keydown",
      key: "i",
      callback: () => {
        askAiModalRef.current?.toggle();
      },
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true,
      commandCtrlKey: true,
      preventDefault: true
    }) : null;
    const cKey = keybindings.registerKeybinding({
      event: "keypress",
      key: "t",
      callback: () => {
        setCheckerboard((c) => !c);
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const questionMark = keybindings.registerKeybinding({
      event: "keypress",
      key: "?",
      callback: () => {
        setSelectedModal({
          type: "quick-switcher",
          mode: "docs",
          invocationTimestamp: Date.now()
        });
      },
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const pageDown = keybindings.registerKeybinding({
      event: "keydown",
      key: "PageDown",
      callback: navigateToNextComposition,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    const pageUp = keybindings.registerKeybinding({
      event: "keydown",
      key: "PageUp",
      callback: navigateToPreviousComposition,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: false,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      nKey.unregister();
      cKey.unregister();
      questionMark.unregister();
      cmdKKey.unregister();
      cmdIKey?.unregister();
      pageDown.unregister();
      pageUp.unregister();
    };
  }, [
    keybindings,
    setCheckerboard,
    setSelectedModal,
    navigateToNextComposition,
    navigateToPreviousComposition
  ]);
  return null;
};

// src/components/Modals.tsx
import { useContext as useContext91 } from "react";

// src/components/InstallPackage.tsx
import {
  apiDocs,
  descriptions,
  extraPackages,
  installableMap
} from "@remotion/studio-shared";
import React154, { useCallback as useCallback109, useContext as useContext79, useEffect as useEffect78 } from "react";
import { VERSION as VERSION2 } from "remotion";

// src/api/install-package.ts
import { getRemotionEnvironment as getRemotionEnvironment5 } from "remotion";
var installPackages = (packageNames) => {
  if (!getRemotionEnvironment5().isStudio) {
    throw new Error("installPackages() is only available in the Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("installPackages() is not available in Read-Only Studio");
  }
  return callApi("/api/install-package", { packageNames });
};

// src/components/InstallablePackage.tsx
import { jsx as jsx217, jsxs as jsxs106 } from "react/jsx-runtime";
var FONT_SIZE = 13;
var InstallablePackageComp = ({ isInstalled, pkg, link, description }) => {
  return /* @__PURE__ */ jsxs106("div", {
    style: {
      fontSize: FONT_SIZE,
      lineHeight: 1.2,
      paddingBottom: 4,
      paddingTop: 4
    },
    children: [
      /* @__PURE__ */ jsx217("a", {
        href: link,
        style: {
          fontSize: FONT_SIZE,
          color: TEXT_COLOR,
          textDecoration: "none"
        },
        target: "_blank",
        children: pkg
      }),
      " ",
      isInstalled ? /* @__PURE__ */ jsx217("span", {
        style: { opacity: 0.3, fontSize: "inherit" },
        children: "(installed)"
      }) : null,
      /* @__PURE__ */ jsx217("br", {}),
      /* @__PURE__ */ jsx217("span", {
        style: { color: LIGHT_TEXT, fontSize: FONT_SIZE },
        children: description
      })
    ]
  });
};

// src/components/ModalButton.tsx
import { useMemo as useMemo119 } from "react";
import { jsx as jsx218 } from "react/jsx-runtime";
var buttonStyle5 = {
  backgroundColor: BLUE,
  color: "white"
};
var ModalButton = (props) => {
  const style11 = useMemo119(() => {
    return {
      ...buttonStyle5,
      backgroundColor: props.disabled ? BLUE_DISABLED : BLUE
    };
  }, [props.disabled]);
  return /* @__PURE__ */ jsx218(Button, {
    ...props,
    style: style11
  });
};

// src/components/ModalFooter.tsx
import { jsx as jsx219 } from "react/jsx-runtime";
var content2 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var ModalFooterContainer = ({ children }) => {
  return /* @__PURE__ */ jsx219("div", {
    style: { ...content2, borderTop: "1px solid black" },
    children
  });
};

// src/components/NewComposition/DismissableModal.tsx
import { useCallback as useCallback108, useContext as useContext78 } from "react";
import { jsx as jsx220 } from "react/jsx-runtime";
var DismissableModal = ({ children }) => {
  const { setSelectedModal } = useContext78(ModalsContext);
  const onQuit = useCallback108(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsx220(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children
  });
};

// src/components/InstallPackage.tsx
import { jsx as jsx221, jsxs as jsxs107 } from "react/jsx-runtime";
var container48 = {
  padding: 20,
  maxHeight: 400,
  overflowY: "auto"
};
var text2 = {
  fontSize: 14
};
var InstallPackageModal = ({ packageManager }) => {
  const [state, setState] = React154.useState({ type: "idle" });
  const [map, setMap] = React154.useState({});
  const { previewServerState: ctx } = useContext79(StudioServerConnectionCtx);
  const selectedPackages = Object.keys(map).filter((pkg) => map[pkg]);
  const onClick = useCallback109(async () => {
    if (state.type === "done") {
      setState({ type: "restarting" });
      restartStudio();
      return;
    }
    setState({ type: "installing" });
    try {
      await installPackages(selectedPackages);
      setState({ type: "done" });
    } catch (err) {
      setState({ type: "error", error: err });
    }
  }, [selectedPackages, state.type]);
  const canSelectPackages = state.type === "idle" && ctx.type === "connected";
  const disabled = !(canSelectPackages || state.type === "done") || selectedPackages.length === 0;
  const { registerKeybinding } = useKeybinding();
  useEffect78(() => {
    if (disabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        onClick();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: true
    });
    return () => {
      enter.unregister();
    };
  }, [disabled, onClick, registerKeybinding]);
  return /* @__PURE__ */ jsxs107(DismissableModal, {
    children: [
      /* @__PURE__ */ jsx221(ModalHeader, {
        title: "Install packages"
      }),
      /* @__PURE__ */ jsx221("div", {
        style: container48,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children: state.type === "done" ? /* @__PURE__ */ jsxs107("div", {
          style: text2,
          children: [
            "Installed package",
            selectedPackages.length === 1 ? "" : "s",
            " ",
            "successfully. Restart the server to complete."
          ]
        }) : state.type === "restarting" ? /* @__PURE__ */ jsx221("div", {
          style: text2,
          children: "Restarting the Studio server..."
        }) : state.type === "installing" ? /* @__PURE__ */ jsxs107("div", {
          style: text2,
          children: [
            "Installing package",
            selectedPackages.length === 1 ? "" : "s",
            ". Check your terminal for progress."
          ]
        }) : /* @__PURE__ */ jsxs107("div", {
          style: text2,
          children: [
            Object.entries(installableMap).filter(([, install]) => install).map(([pkgShort]) => {
              const pkg = pkgShort === "core" ? "remotion" : `@remotion/${pkgShort}`;
              const isInstalled = window.remotion_installedPackages?.includes(pkg) ?? false;
              const link = apiDocs[pkgShort];
              const description = descriptions[pkgShort];
              if (!link) {
                throw new Error("No link for " + pkg);
              }
              if (!description) {
                throw new Error("No description for " + pkg);
              }
              return /* @__PURE__ */ jsxs107(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx221(Checkbox, {
                    checked: map[pkg],
                    name: pkg,
                    onChange: () => {
                      setMap((prev) => ({ ...prev, [pkg]: !prev[pkg] }));
                    },
                    disabled: !canSelectPackages || isInstalled
                  }),
                  /* @__PURE__ */ jsx221(Spacing, {
                    x: 1.5
                  }),
                  /* @__PURE__ */ jsx221(InstallablePackageComp, {
                    description,
                    isInstalled,
                    link,
                    pkg
                  })
                ]
              }, pkg);
            }),
            extraPackages.map((extraPkg) => {
              const isInstalled = window.remotion_installedPackages?.includes(extraPkg.name) ?? false;
              return /* @__PURE__ */ jsxs107(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx221(Checkbox, {
                    checked: map[extraPkg.name],
                    name: extraPkg.name,
                    onChange: () => {
                      setMap((prev) => ({
                        ...prev,
                        [extraPkg.name]: !prev[extraPkg.name]
                      }));
                    },
                    disabled: !canSelectPackages || isInstalled
                  }),
                  /* @__PURE__ */ jsx221(Spacing, {
                    x: 1.5
                  }),
                  /* @__PURE__ */ jsx221(InstallablePackageComp, {
                    description: extraPkg.description,
                    isInstalled,
                    link: extraPkg.docsUrl,
                    pkg: `${extraPkg.name}@${extraPkg.version}`
                  })
                ]
              }, extraPkg.name);
            })
          ]
        })
      }),
      /* @__PURE__ */ jsx221(ModalFooterContainer, {
        children: /* @__PURE__ */ jsxs107(Row, {
          align: "center",
          children: [
            state.type === "idle" ? /* @__PURE__ */ jsxs107("span", {
              style: { color: LIGHT_TEXT, fontSize: 13, lineHeight: 1.2 },
              children: [
                "This will install ",
                selectedPackages.length,
                " package",
                selectedPackages.length === 1 ? "" : "s",
                /* @__PURE__ */ jsx221("br", {}),
                "using ",
                packageManager,
                ", Remotion v",
                VERSION2
              ]
            }) : null,
            /* @__PURE__ */ jsx221(Flex, {}),
            /* @__PURE__ */ jsxs107(ModalButton, {
              onClick,
              disabled,
              children: [
                state.type === "restarting" ? "Restarting..." : state.type === "installing" ? "Installing..." : state.type === "done" ? "Restart Server" : "Install",
                disabled ? null : /* @__PURE__ */ jsx221(ShortcutHint, {
                  keyToPress: "↵",
                  cmdOrCtrl: true
                })
              ]
            })
          ]
        })
      })
    ]
  });
};

// src/components/NewComposition/DeleteComposition.tsx
import { useCallback as useCallback111, useContext as useContext82, useMemo as useMemo121 } from "react";

// src/components/RenderModal/ResolveCompositionBeforeModal.tsx
import React155, { useContext as useContext80, useEffect as useEffect79, useMemo as useMemo120 } from "react";
import { Internals as Internals59 } from "remotion";
import { jsx as jsx222, jsxs as jsxs108 } from "react/jsx-runtime";
var loaderContainer2 = {
  paddingTop: 40,
  paddingBottom: 40,
  paddingLeft: 100,
  paddingRight: 100,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
};
var loaderLabel2 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  lineHeight: 1.5
};
var ResolvedCompositionContext = React155.createContext(null);
var ResolveCompositionBeforeModal = ({ compositionId, children }) => {
  const resolved = Internals59.useResolvedVideoConfig(compositionId);
  const unresolvedContext = useContext80(Internals59.CompositionManager);
  const unresolved = unresolvedContext.compositions.find((c) => compositionId === c.id);
  useEffect79(() => {
    const { current } = Internals59.resolveCompositionsRef;
    if (!current) {
      throw new Error("No ref to trigger composition calc");
    }
    current.setCurrentRenderModalComposition(compositionId);
    return () => {
      current.setCurrentRenderModalComposition(null);
    };
  }, [compositionId]);
  if (!unresolved) {
    throw new Error("Composition not found: " + compositionId);
  }
  const value = useMemo120(() => {
    return {
      resolved,
      unresolved
    };
  }, [resolved, unresolved]);
  if (!resolved || resolved.type === "loading") {
    return /* @__PURE__ */ jsx222(RunningCalculateMetadata, {});
  }
  if (resolved.type === "error") {
    return /* @__PURE__ */ jsxs108("div", {
      style: loaderContainer2,
      children: [
        /* @__PURE__ */ jsx222(Spacing, {
          y: 2
        }),
        /* @__PURE__ */ jsxs108("div", {
          style: loaderLabel2,
          children: [
            "Running ",
            /* @__PURE__ */ jsx222("code", {
              style: inlineCodeSnippet,
              children: "calculateMetadata()"
            }),
            " ",
            "yielded an error:"
          ]
        }),
        /* @__PURE__ */ jsx222(Spacing, {
          y: 1
        }),
        /* @__PURE__ */ jsx222("div", {
          style: loaderLabel2,
          children: resolved.error.message || "Unknown error"
        })
      ]
    });
  }
  return /* @__PURE__ */ jsx222(ResolvedCompositionContext.Provider, {
    value,
    children
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import { useCallback as useCallback110, useContext as useContext81, useEffect as useEffect80, useState as useState77 } from "react";

// src/components/NewComposition/DiffPreview.tsx
import { jsx as jsx223, jsxs as jsxs109 } from "react/jsx-runtime";
var CodemodDiffPreview = ({ status }) => {
  if (status.type === "loading") {
    return null;
  }
  if (status.type === "fail") {
    return /* @__PURE__ */ jsx223("span", {
      style: { color: FAIL_COLOR, fontSize: 13, lineHeight: 1.2 },
      children: status.error
    });
  }
  return /* @__PURE__ */ jsxs109("div", {
    style: { lineHeight: 1.2 },
    children: [
      /* @__PURE__ */ jsx223("span", {
        style: { color: LIGHT_TEXT, fontSize: 13, lineHeight: 1.2 },
        children: "This will edit your Root file."
      }),
      /* @__PURE__ */ jsx223("br", {}),
      /* @__PURE__ */ jsxs109("span", {
        style: { color: BLUE, fontSize: 13, lineHeight: 1.2 },
        children: [
          status.diff.additions,
          " addition",
          status.diff.additions === 1 ? "" : "s",
          ","
        ]
      }),
      " ",
      /* @__PURE__ */ jsxs109("span", {
        style: {
          color: SELECTED_GUIDE,
          fontSize: 13,
          lineHeight: 1.2
        },
        children: [
          status.diff.deletions,
          " deletion",
          status.diff.deletions === 1 ? "" : "s"
        ]
      })
    ]
  });
};

// src/components/NewComposition/CodemodFooter.tsx
import { jsx as jsx224, jsxs as jsxs110 } from "react/jsx-runtime";
var CodemodFooter = ({
  codemod,
  valid,
  loadingNotification,
  successNotification,
  errorNotification,
  genericSubmitLabel,
  submitLabel,
  onSuccess
}) => {
  const [submitting, setSubmitting] = useState77(false);
  const { setSelectedModal } = useContext81(ModalsContext);
  const [codemodStatus, setCanApplyCodemod] = useState77({
    type: "loading"
  });
  const [projectInfo, setProjectInfo] = useState77(null);
  useEffect80(() => {
    const controller = new AbortController;
    getProjectInfo(controller.signal).then((info) => {
      setProjectInfo(info.projectInfo);
    }).catch((err) => {
      showNotification(`Could not get project info: ${err.message}. Unable to duplicate composition`, 3000);
    });
    return () => {
      controller.abort();
    };
  }, []);
  const trigger = useCallback110(() => {
    setSubmitting(true);
    setSelectedModal(null);
    const notification2 = showNotification(loadingNotification, null);
    applyCodemod({
      codemod,
      dryRun: false,
      signal: new AbortController().signal
    }).then(() => {
      notification2.replaceContent(successNotification, 2000);
      onSuccess?.();
    }).catch((err) => {
      notification2.replaceContent(`${errorNotification}: ${err.message}`, 2000);
    });
  }, [
    codemod,
    errorNotification,
    loadingNotification,
    onSuccess,
    setSelectedModal,
    successNotification
  ]);
  const getCanApplyCodemod = useCallback110(async (signal) => {
    const res = await applyCodemod({
      codemod,
      dryRun: true,
      signal
    });
    if (res.success) {
      setCanApplyCodemod({ type: "success", diff: res.diff });
    } else {
      setCanApplyCodemod({
        type: "fail",
        error: res.reason
      });
    }
  }, [codemod]);
  useEffect80(() => {
    const abortController = new AbortController;
    let aborted = false;
    getCanApplyCodemod(abortController.signal).then(() => {
      return;
    }).catch((err) => {
      if (aborted) {
        return;
      }
      showNotification(`Cannot duplicate composition: ${err.message}`, 3000);
    });
    return () => {
      aborted = true;
      abortController.abort();
    };
  }, [getCanApplyCodemod]);
  const disabled = !valid || submitting || projectInfo === null || codemodStatus.type !== "success";
  const { registerKeybinding } = useKeybinding();
  useEffect80(() => {
    if (disabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [disabled, registerKeybinding, trigger, valid]);
  return /* @__PURE__ */ jsxs110(Row, {
    align: "center",
    children: [
      /* @__PURE__ */ jsx224(CodemodDiffPreview, {
        status: codemodStatus
      }),
      /* @__PURE__ */ jsx224(Flex, {}),
      /* @__PURE__ */ jsx224(Spacing, {
        block: true,
        x: 2
      }),
      /* @__PURE__ */ jsxs110(ModalButton, {
        onClick: trigger,
        disabled,
        children: [
          projectInfo && projectInfo.relativeRootFile ? submitLabel({ relativeRootPath: projectInfo.relativeRootFile }) : genericSubmitLabel,
          /* @__PURE__ */ jsx224(ShortcutHint, {
            keyToPress: "↵",
            cmdOrCtrl: true
          })
        ]
      })
    ]
  });
};

// src/components/NewComposition/DeleteComposition.tsx
import { jsx as jsx225, jsxs as jsxs111, Fragment as Fragment30 } from "react/jsx-runtime";
var content3 = {
  padding: 16,
  fontSize: 14,
  flex: 1,
  minWidth: 500
};
var DeleteCompositionLoaded = ({ compositionId }) => {
  const context = useContext82(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { unresolved } = context;
  const codemod = useMemo121(() => {
    return {
      type: "delete-composition",
      idToDelete: compositionId
    };
  }, [compositionId]);
  const onSubmit = useCallback111((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs111(Fragment30, {
    children: [
      /* @__PURE__ */ jsx225(ModalHeader, {
        title: "Delete composition"
      }),
      /* @__PURE__ */ jsxs111("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsxs111("div", {
            style: content3,
            children: [
              "Do you want to delete the",
              " ",
              /* @__PURE__ */ jsx225("code", {
                style: inlineCodeSnippet,
                children: unresolved.durationInFrames === 1 ? `<Still>` : "<Composition>"
              }),
              " ",
              "with ID ",
              '"',
              unresolved.id,
              '"',
              "?",
              /* @__PURE__ */ jsx225("br", {}),
              "The associated ",
              /* @__PURE__ */ jsx225("code", {
                style: inlineCodeSnippet,
                children: "component"
              }),
              " will remain in your code."
            ]
          }),
          /* @__PURE__ */ jsx225(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx225(CodemodFooter, {
              errorNotification: `Could not delete composition`,
              loadingNotification: "Deleting",
              successNotification: `Deleted ${unresolved.id}`,
              genericSubmitLabel: `Delete`,
              submitLabel: ({ relativeRootPath }) => `Delete from ${relativeRootPath}`,
              codemod,
              valid: true,
              onSuccess: null
            })
          })
        ]
      })
    ]
  });
};
var DeleteComposition = ({ compositionId }) => {
  return /* @__PURE__ */ jsx225(DismissableModal, {
    children: /* @__PURE__ */ jsx225(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx225(DeleteCompositionLoaded, {
        compositionId
      })
    })
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import { useCallback as useCallback113, useContext as useContext83, useMemo as useMemo122, useState as useState78 } from "react";
import { Internals as Internals61 } from "remotion";

// src/helpers/validate-new-comp-data.ts
import { Internals as Internals60 } from "remotion";
var validateCompositionName = (compName, compositions) => {
  if (!Internals60.isCompositionIdValid(compName)) {
    return Internals60.invalidCompositionErrorMessage;
  }
  if (compositions.find((c) => c.id === compName)) {
    return `A composition with that name already exists.`;
  }
  return null;
};
var validateCompositionDimension = (dimension, value) => {
  if (Number(value) % 2 !== 0) {
    return `${dimension} should be divisible by 2, since H264 codec doesn't support odd dimensions.`;
  }
  if (Number.isNaN(Number(value))) {
    return "Invalid number.";
  }
  if (Number(value) === 0) {
    return dimension + " cannot be zero.";
  }
  return null;
};
var validateCompositionDuration = (value) => {
  if (value % 1 !== 0) {
    return `Duration must be an integer.`;
  }
  if (Number.isNaN(value)) {
    return "Invalid number.";
  }
  if (value === 0) {
    return "Duration cannot be zero.";
  }
  return null;
};

// src/components/NewComposition/NewCompDuration.tsx
import { useCallback as useCallback112 } from "react";
import { jsx as jsx226, jsxs as jsxs112, Fragment as Fragment31 } from "react/jsx-runtime";
var NewCompDuration = ({ durationInFrames, setDurationInFrames }) => {
  const onDurationInFramesChanged = useCallback112((newValue) => {
    setDurationInFrames(Number(newValue));
  }, [setDurationInFrames]);
  const onDurationChangedDirectly = useCallback112((newVal) => {
    setDurationInFrames(newVal);
  }, [setDurationInFrames]);
  const compDurationErrMessage = validateCompositionDuration(durationInFrames);
  return /* @__PURE__ */ jsxs112("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx226("div", {
        style: label5,
        children: "Duration in frames"
      }),
      /* @__PURE__ */ jsxs112("div", {
        style: rightRow,
        children: [
          /* @__PURE__ */ jsx226(InputDragger, {
            type: "number",
            value: durationInFrames,
            onTextChange: onDurationInFramesChanged,
            placeholder: "Duration (frames)",
            name: "durationInFrames",
            min: 1,
            step: 1,
            required: true,
            status: "ok",
            max: 300000,
            onValueChange: onDurationChangedDirectly,
            rightAlign: false
          }),
          compDurationErrMessage ? /* @__PURE__ */ jsxs112(Fragment31, {
            children: [
              /* @__PURE__ */ jsx226(Spacing, {
                y: 1,
                block: true
              }),
              /* @__PURE__ */ jsx226(ValidationMessage, {
                align: "flex-start",
                message: compDurationErrMessage,
                type: "error"
              })
            ]
          }) : null
        ]
      })
    ]
  });
};

// src/components/NewComposition/DuplicateComposition.tsx
import { jsx as jsx227, jsxs as jsxs113, Fragment as Fragment32 } from "react/jsx-runtime";
var content4 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var comboBoxStyle = {
  width: 190
};
var DuplicateCompositionLoaded = ({ initialType }) => {
  const context = useContext83(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { resolved, unresolved } = context;
  const [initialCompType] = useState78(initialType);
  const hadDimensionsDefined = unresolved.width && unresolved.height;
  const hadFpsDefined = unresolved.fps !== undefined;
  const hadDurationDefined = unresolved.durationInFrames !== undefined;
  const [selectedFrameRate, setFrameRate] = useState78(resolved.result.fps);
  const { compositions } = useContext83(Internals61.CompositionManager);
  const [type, setType] = useState78(initialCompType);
  const [newId, setName] = useState78(() => {
    const numberAtEnd = resolved.result.id.match(/([0-9]+)$/)?.[0];
    let prefix = numberAtEnd ? Number(numberAtEnd) : 1;
    const initialName = resolved.result.id.replace(/([0-9]+)$/, "");
    let currentName = initialName;
    while (true) {
      currentName = initialName + prefix;
      const err = validateCompositionName(currentName, compositions);
      if (!err) {
        break;
      }
      prefix++;
    }
    return currentName;
  });
  const [size4, setSize] = useState78(() => ({
    width: resolved.result.width,
    height: resolved.result.height
  }));
  const [durationInFrames, setDurationInFrames] = useState78(resolved.result.durationInFrames);
  const onTypeChanged = useCallback113((newType) => {
    setType(newType);
  }, []);
  const onWidthChanged = useCallback113((newValue) => {
    setSize((s) => {
      const { height } = s;
      const newWidth = Number(newValue);
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onWidthDirectlyChanged = useCallback113((newWidth) => {
    setSize((s) => {
      const { height } = s;
      return {
        height,
        width: newWidth
      };
    });
  }, []);
  const onHeightDirectlyChanged = useCallback113((newHeight) => {
    setSize((s) => {
      const { width: width2 } = s;
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onHeightChanged = useCallback113((newValue) => {
    setSize((s) => {
      const { width: width2 } = s;
      const newHeight = Number(newValue);
      return {
        width: width2,
        height: newHeight
      };
    });
  }, []);
  const onNameChange = useCallback113((e) => {
    setName(e.target.value);
  }, []);
  const onTextFpsChange = useCallback113((newFps) => {
    setFrameRate(Number(newFps));
  }, []);
  const onFpsChange = useCallback113((newFps) => {
    setFrameRate(newFps);
  }, []);
  const compNameErrMessage = validateCompositionName(newId, compositions);
  const compWidthErrMessage = validateCompositionDimension("Width", size4.width);
  const compHeightErrMessage = validateCompositionDimension("Height", size4.height);
  const typeValues = useMemo122(() => {
    return [
      {
        id: "composition",
        keyHint: null,
        label: "<Composition />",
        leftItem: null,
        onClick: () => onTypeChanged("composition"),
        subMenu: null,
        type: "item",
        value: "composition",
        quickSwitcherLabel: null
      },
      {
        id: "still",
        keyHint: null,
        label: "<Still />",
        leftItem: null,
        onClick: () => onTypeChanged("still"),
        subMenu: null,
        type: "item",
        value: "still",
        quickSwitcherLabel: null
      }
    ];
  }, [onTypeChanged]);
  const valid = compNameErrMessage === null && compWidthErrMessage === null && compHeightErrMessage === null;
  const codemod = useMemo122(() => {
    return {
      type: "duplicate-composition",
      idToDuplicate: resolved.result.id,
      newDurationInFrames: hadDurationDefined ? Number(durationInFrames) : null,
      newFps: hadFpsDefined ? Number(selectedFrameRate) : null,
      newHeight: hadDimensionsDefined ? Number(size4.height) : null,
      newWidth: hadDimensionsDefined ? Number(size4.width) : null,
      newId,
      tag: type === "still" ? "Still" : "Composition"
    };
  }, [
    durationInFrames,
    hadDimensionsDefined,
    hadDurationDefined,
    hadFpsDefined,
    newId,
    resolved.result.id,
    selectedFrameRate,
    size4.height,
    size4.width,
    type
  ]);
  const onDuplicateSuccess = useCallback113(() => {
    pushUrl(`/${newId}`);
  }, [newId]);
  const onSubmit = useCallback113((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs113(Fragment32, {
    children: [
      /* @__PURE__ */ jsx227(ModalHeader, {
        title: `Duplicate ${resolved.result.id}`
      }),
      /* @__PURE__ */ jsxs113("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsxs113("div", {
            style: content4,
            children: [
              initialCompType === "composition" ? /* @__PURE__ */ jsxs113("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx227("div", {
                    style: label5,
                    children: "Type"
                  }),
                  /* @__PURE__ */ jsx227("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsx227(Combobox, {
                      title: "Type of composition",
                      style: comboBoxStyle,
                      values: typeValues,
                      selectedId: type
                    })
                  })
                ]
              }) : null,
              /* @__PURE__ */ jsxs113("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx227("div", {
                    style: label5,
                    children: "ID"
                  }),
                  /* @__PURE__ */ jsx227("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsxs113("div", {
                      children: [
                        /* @__PURE__ */ jsx227(RemotionInput, {
                          value: newId,
                          onChange: onNameChange,
                          type: "text",
                          autoFocus: true,
                          placeholder: "Composition ID",
                          status: "ok",
                          rightAlign: true
                        }),
                        compNameErrMessage ? /* @__PURE__ */ jsxs113(Fragment32, {
                          children: [
                            /* @__PURE__ */ jsx227(Spacing, {
                              y: 1,
                              block: true
                            }),
                            /* @__PURE__ */ jsx227(ValidationMessage, {
                              align: "flex-start",
                              message: compNameErrMessage,
                              type: "error"
                            })
                          ]
                        }) : null
                      ]
                    })
                  })
                ]
              }),
              hadDimensionsDefined ? /* @__PURE__ */ jsxs113(Fragment32, {
                children: [
                  /* @__PURE__ */ jsxs113("div", {
                    style: optionRow,
                    children: [
                      /* @__PURE__ */ jsx227("div", {
                        style: label5,
                        children: "Width"
                      }),
                      /* @__PURE__ */ jsxs113("div", {
                        style: rightRow,
                        children: [
                          /* @__PURE__ */ jsx227(InputDragger, {
                            type: "number",
                            value: size4.width,
                            placeholder: "Width",
                            onTextChange: onWidthChanged,
                            name: "width",
                            step: 2,
                            min: 2,
                            required: true,
                            status: "ok",
                            formatter: (w) => `${w}px`,
                            max: 1e8,
                            onValueChange: onWidthDirectlyChanged,
                            rightAlign: false
                          }),
                          compWidthErrMessage ? /* @__PURE__ */ jsxs113(Fragment32, {
                            children: [
                              /* @__PURE__ */ jsx227(Spacing, {
                                y: 1,
                                block: true
                              }),
                              /* @__PURE__ */ jsx227(ValidationMessage, {
                                align: "flex-start",
                                message: compWidthErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxs113("div", {
                    style: optionRow,
                    children: [
                      /* @__PURE__ */ jsx227("div", {
                        style: label5,
                        children: "Height"
                      }),
                      /* @__PURE__ */ jsxs113("div", {
                        style: rightRow,
                        children: [
                          /* @__PURE__ */ jsx227(InputDragger, {
                            type: "number",
                            value: size4.height,
                            onTextChange: onHeightChanged,
                            placeholder: "Height",
                            name: "height",
                            step: 2,
                            required: true,
                            formatter: (h) => `${h}px`,
                            min: 2,
                            status: "ok",
                            max: 1e8,
                            onValueChange: onHeightDirectlyChanged,
                            rightAlign: false
                          }),
                          compHeightErrMessage ? /* @__PURE__ */ jsxs113(Fragment32, {
                            children: [
                              /* @__PURE__ */ jsx227(Spacing, {
                                y: 1,
                                block: true
                              }),
                              /* @__PURE__ */ jsx227(ValidationMessage, {
                                align: "flex-start",
                                message: compHeightErrMessage,
                                type: "error"
                              })
                            ]
                          }) : null
                        ]
                      })
                    ]
                  })
                ]
              }) : null,
              type === "composition" && hadDurationDefined ? /* @__PURE__ */ jsx227(NewCompDuration, {
                durationInFrames,
                setDurationInFrames
              }) : null,
              type === "composition" && hadFpsDefined ? /* @__PURE__ */ jsxs113("div", {
                style: optionRow,
                children: [
                  /* @__PURE__ */ jsx227("div", {
                    style: label5,
                    children: "FPS"
                  }),
                  /* @__PURE__ */ jsx227("div", {
                    style: rightRow,
                    children: /* @__PURE__ */ jsx227(InputDragger, {
                      type: "number",
                      value: selectedFrameRate,
                      onTextChange: onTextFpsChange,
                      placeholder: "Frame rate (fps)",
                      name: "fps",
                      min: 1,
                      required: true,
                      status: "ok",
                      max: 240,
                      step: 0.01,
                      onValueChange: onFpsChange,
                      rightAlign: false
                    })
                  })
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx227(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx227(CodemodFooter, {
              loadingNotification: "Duplicating...",
              errorNotification: "Could not duplicate composition",
              successNotification: `Duplicated ${unresolved.id} as ${newId}`,
              genericSubmitLabel: "Duplicate",
              submitLabel: ({ relativeRootPath }) => `Add to ${relativeRootPath}`,
              codemod,
              valid,
              onSuccess: onDuplicateSuccess
            })
          })
        ]
      })
    ]
  });
};
var DuplicateComposition = ({ compositionId, compositionType }) => {
  return /* @__PURE__ */ jsx227(DismissableModal, {
    children: /* @__PURE__ */ jsx227(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx227(DuplicateCompositionLoaded, {
        initialType: compositionType
      })
    })
  });
};

// src/components/NewComposition/RenameComposition.tsx
import { useCallback as useCallback114, useContext as useContext84, useMemo as useMemo123, useState as useState79 } from "react";
import { Internals as Internals62 } from "remotion";
import { jsx as jsx228, jsxs as jsxs114, Fragment as Fragment33 } from "react/jsx-runtime";
var content5 = {
  padding: 12,
  paddingRight: 12,
  flex: 1,
  fontSize: 13,
  minWidth: 500
};
var RenameCompositionLoaded = () => {
  const context = useContext84(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Resolved composition context");
  }
  const { resolved } = context;
  const { compositions } = useContext84(Internals62.CompositionManager);
  const [newId, setName] = useState79(() => {
    return resolved.result.id;
  });
  const onNameChange = useCallback114((e) => {
    setName(e.target.value);
  }, []);
  const compNameErrMessage = newId === resolved.result.id ? null : validateCompositionName(newId, compositions);
  const valid = compNameErrMessage === null && resolved.result.id !== newId;
  const codemod = useMemo123(() => {
    return {
      type: "rename-composition",
      idToRename: resolved.result.id,
      newId
    };
  }, [newId, resolved.result.id]);
  const onSubmit = useCallback114((e) => {
    e.preventDefault();
  }, []);
  return /* @__PURE__ */ jsxs114(Fragment33, {
    children: [
      /* @__PURE__ */ jsx228(ModalHeader, {
        title: `Rename ${resolved.result.id}`
      }),
      /* @__PURE__ */ jsxs114("form", {
        onSubmit,
        children: [
          /* @__PURE__ */ jsx228("div", {
            style: content5,
            children: /* @__PURE__ */ jsxs114("div", {
              style: optionRow,
              children: [
                /* @__PURE__ */ jsx228("div", {
                  style: label5,
                  children: "ID"
                }),
                /* @__PURE__ */ jsx228("div", {
                  style: rightRow,
                  children: /* @__PURE__ */ jsxs114("div", {
                    children: [
                      /* @__PURE__ */ jsx228(RemotionInput, {
                        value: newId,
                        onChange: onNameChange,
                        type: "text",
                        autoFocus: true,
                        placeholder: "Composition ID",
                        status: "ok",
                        rightAlign: true
                      }),
                      compNameErrMessage ? /* @__PURE__ */ jsxs114(Fragment33, {
                        children: [
                          /* @__PURE__ */ jsx228(Spacing, {
                            y: 1,
                            block: true
                          }),
                          /* @__PURE__ */ jsx228(ValidationMessage, {
                            align: "flex-start",
                            message: compNameErrMessage,
                            type: "error"
                          })
                        ]
                      }) : null
                    ]
                  })
                })
              ]
            })
          }),
          /* @__PURE__ */ jsx228(ModalFooterContainer, {
            children: /* @__PURE__ */ jsx228(CodemodFooter, {
              loadingNotification: "Renaming...",
              errorNotification: "Could not rename composition",
              successNotification: `Renamed to ${newId}`,
              genericSubmitLabel: "Rename",
              submitLabel: ({ relativeRootPath }) => `Modify ${relativeRootPath}`,
              codemod,
              valid,
              onSuccess: null
            })
          })
        ]
      })
    ]
  });
};
var RenameComposition = ({ compositionId }) => {
  return /* @__PURE__ */ jsx228(DismissableModal, {
    children: /* @__PURE__ */ jsx228(ResolveCompositionBeforeModal, {
      compositionId,
      children: /* @__PURE__ */ jsx228(RenameCompositionLoaded, {})
    })
  });
};

// src/components/OverrideInputProps.tsx
import { useCallback as useCallback115, useContext as useContext85, useMemo as useMemo124, useState as useState80 } from "react";
import { Internals as Internals63 } from "remotion";
import { jsx as jsx229, jsxs as jsxs115 } from "react/jsx-runtime";
var style11 = {
  padding: 12,
  width: 500
};
var label8 = {
  color: LIGHT_TEXT,
  fontSize: 14,
  marginBottom: 10
};
var textAreaStyle = {
  fontFamily: "monospace",
  minHeight: 200
};
var codeSnippet2 = {
  fontSize: 14,
  color: BLUE,
  fontFamily: "monospace"
};
var row8 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between"
};
var isValidJSON = (value) => {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
};
var Inner5 = () => {
  const [value, setValue] = useState80(() => {
    const override = Internals63.getInputPropsOverride();
    if (override) {
      return JSON.stringify(override, null, 2);
    }
    return null;
  });
  const { setSelectedModal } = useContext85(ModalsContext);
  const valid = useMemo124(() => {
    if (!value)
      return true;
    return isValidJSON(value);
  }, [value]);
  const onChange = useCallback115((newValue) => {
    if (newValue.trim() === "") {
      setValue(null);
      Internals63.setInputPropsOverride(null);
      return;
    }
    setValue(newValue);
    if (!isValidJSON(newValue)) {
      return;
    }
    Internals63.setInputPropsOverride(JSON.parse(newValue));
  }, [setValue]);
  const onReset = useCallback115(() => {
    onChange("");
  }, [onChange]);
  const onReloadPage = useCallback115(() => {
    window.location.reload();
  }, []);
  const onDone = useCallback115(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  return /* @__PURE__ */ jsxs115("div", {
    style: style11,
    children: [
      /* @__PURE__ */ jsxs115("div", {
        style: label8,
        children: [
          "Enter a valid JSON to override the value that",
          " ",
          /* @__PURE__ */ jsx229("code", {
            style: codeSnippet2,
            children: "getInputProps()"
          }),
          " returns to preview a composition with different props. The Studio must be reloaded to see the changes."
        ]
      }),
      /* @__PURE__ */ jsx229(RemTextarea, {
        onChange: (e) => onChange(e.target.value),
        value: value ?? "",
        status: valid ? "ok" : "error",
        style: textAreaStyle
      }),
      /* @__PURE__ */ jsxs115("div", {
        style: row8,
        children: [
          /* @__PURE__ */ jsx229(Button, {
            onClick: onReset,
            children: "Reset"
          }),
          /* @__PURE__ */ jsx229(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx229(Button, {
            onClick: onReloadPage,
            children: "Reload page"
          }),
          /* @__PURE__ */ jsx229(Flex, {}),
          /* @__PURE__ */ jsx229(Button, {
            onClick: onDone,
            children: "Done"
          })
        ]
      })
    ]
  });
};
var OverrideInputPropsModal = () => {
  return /* @__PURE__ */ jsx229(DismissableModal, {
    children: /* @__PURE__ */ jsx229(Inner5, {})
  });
};

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
import {
  useCallback as useCallback116,
  useContext as useContext86,
  useEffect as useEffect82,
  useMemo as useMemo126,
  useRef as useRef43,
  useState as useState82
} from "react";
import { Internals as Internals64 } from "remotion";

// src/icons/keys.tsx
import { jsx as jsx230 } from "react/jsx-runtime";
var iconStyle5 = {
  width: 10,
  display: "inline"
};
var ShiftIcon = () => {
  return /* @__PURE__ */ jsx230("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx230("path", {
      fill: "currentColor",
      d: "M48.048 304h73.798v128c0 26.51 21.49 48 48 48h108.308c26.51 0 48-21.49 48-48V304h73.789c42.638 0 64.151-51.731 33.941-81.941l-175.943-176c-18.745-18.745-49.137-18.746-67.882 0l-175.952 176C-16.042 252.208 5.325 304 48.048 304zM224 80l176 176H278.154v176H169.846V256H48L224 80z"
    })
  });
};
var ArrowLeft = () => {
  return /* @__PURE__ */ jsx230("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx230("path", {
      fill: "currentColor",
      d: "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    })
  });
};
var ArrowRight = () => {
  return /* @__PURE__ */ jsx230("svg", {
    style: iconStyle5,
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ jsx230("path", {
      fill: "currentColor",
      d: "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    })
  });
};

// src/components/KeyboardShortcutsExplainer.tsx
import { jsx as jsx231, jsxs as jsxs116, Fragment as Fragment34 } from "react/jsx-runtime";
var left3 = {
  width: 85,
  paddingTop: 8,
  paddingBottom: 8
};
var key4 = {
  background: INPUT_BACKGROUND,
  padding: "3px 6px",
  color: "white",
  borderRadius: 3,
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  borderBottomWidth: 3,
  fontSize: 14,
  fontFamily: "monospace"
};
var right2 = {
  fontSize: 14,
  color: "#eee"
};
var container49 = {
  paddingLeft: 20,
  paddingRight: 40,
  paddingTop: 10,
  paddingBottom: 10
};
var title5 = {
  fontWeight: "bold",
  color: "white",
  fontSize: 14,
  marginBottom: 10
};
var keyboardShortcutsDisabled = {
  padding: 12,
  width: "100%",
  fontSize: 14,
  backgroundColor: "rgba(255, 255, 255, 0.1)"
};
var ul = {
  marginTop: 0,
  marginBottom: 0
};
var li = {
  fontSize: 14
};
var KeyboardShortcutsExplainer = () => {
  return /* @__PURE__ */ jsxs116("div", {
    children: [
      areKeyboardShortcutsDisabled() ? /* @__PURE__ */ jsxs116("div", {
        style: keyboardShortcutsDisabled,
        children: [
          "Keyboard shortcuts disabled either due to:",
          /* @__PURE__ */ jsxs116("ul", {
            style: ul,
            children: [
              /* @__PURE__ */ jsx231("li", {
                style: li,
                children: "a) --disable-keyboard-shortcuts being passed"
              }),
              /* @__PURE__ */ jsx231("li", {
                style: li,
                children: "b) Config.setKeyboardShortcutsEnabled(false) being set or"
              }),
              /* @__PURE__ */ jsx231("li", {
                style: li,
                children: " c) a Remotion version mismatch."
              })
            ]
          })
        ]
      }) : null,
      /* @__PURE__ */ jsxs116(Row, {
        style: container49,
        children: [
          /* @__PURE__ */ jsxs116(Column, {
            children: [
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Playback"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx231(ShiftIcon, {})
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx231(ArrowLeft, {})
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "1 second back"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: /* @__PURE__ */ jsx231(ArrowLeft, {})
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Previous frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "Space"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Play / Pause"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: /* @__PURE__ */ jsx231(ArrowRight, {})
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Next frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx231(ShiftIcon, {})
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: /* @__PURE__ */ jsx231(ArrowRight, {})
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "1 second forward"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "A"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Jump to beginning"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "E"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Jump to end"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "J"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Reverse playback"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "K"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Pause"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "L"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Play / Speed up"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "G"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Go to frame"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "Enter"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Pause & return to playback start"
                  })
                ]
              }),
              /* @__PURE__ */ jsx231("br", {}),
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Sidebar"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: "B"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Toggle left sidebar"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: "J"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Toggle right sidebar"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: "G"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Toggle both sidebars"
                  })
                ]
              }),
              /* @__PURE__ */ jsx231("br", {}),
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "View"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "F"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Enter fullscreen"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "Esc"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Exit fullscreen"
                  })
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx231(Spacing, {
            x: 8
          }),
          /* @__PURE__ */ jsxs116(Column, {
            children: [
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Navigation"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "PageUp"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Previous composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "PageDown"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Next composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "R"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Render composition"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "T"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Toggle checkerboard background"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "?"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Show keyboard shortcuts"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: "K"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Quick Switcher"
                  })
                ]
              }),
              /* @__PURE__ */ jsx231("br", {}),
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Playback range"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "I"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Set In Point"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "O"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Set Out Point"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "X"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Clear In/Out Points"
                  })
                ]
              }),
              /* @__PURE__ */ jsx231("br", {}),
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Zoom"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "+"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Zoom in"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "-"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Zoom out"
                  })
                ]
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsx231("div", {
                    style: left3,
                    children: /* @__PURE__ */ jsx231("kbd", {
                      style: key4,
                      children: "0"
                    })
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Reset zoom"
                  })
                ]
              }),
              " ",
              /* @__PURE__ */ jsx231("br", {}),
              /* @__PURE__ */ jsx231("div", {
                style: title5,
                children: "Props Editor"
              }),
              /* @__PURE__ */ jsxs116(Row, {
                align: "center",
                children: [
                  /* @__PURE__ */ jsxs116("div", {
                    style: left3,
                    children: [
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: cmdOrCtrlCharacter
                      }),
                      /* @__PURE__ */ jsx231(Spacing, {
                        x: 0.3
                      }),
                      /* @__PURE__ */ jsx231("kbd", {
                        style: key4,
                        children: "S"
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsx231("div", {
                    style: right2,
                    children: "Save"
                  })
                ]
              }),
              process.env.ASK_AI_ENABLED && /* @__PURE__ */ jsxs116(Fragment34, {
                children: [
                  /* @__PURE__ */ jsx231("br", {}),
                  /* @__PURE__ */ jsx231("div", {
                    style: title5,
                    children: "AI"
                  }),
                  /* @__PURE__ */ jsxs116(Row, {
                    align: "center",
                    children: [
                      /* @__PURE__ */ jsxs116("div", {
                        style: left3,
                        children: [
                          /* @__PURE__ */ jsx231("kbd", {
                            style: key4,
                            children: cmdOrCtrlCharacter
                          }),
                          /* @__PURE__ */ jsx231(Spacing, {
                            x: 0.3
                          }),
                          /* @__PURE__ */ jsx231("kbd", {
                            style: key4,
                            children: "I"
                          })
                        ]
                      }),
                      /* @__PURE__ */ jsx231("div", {
                        style: right2,
                        children: "Ask AI"
                      })
                    ]
                  })
                ]
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/QuickSwitcher/algolia-search.ts
import { NoReactInternals as NoReactInternals15 } from "remotion/no-react";
var ALGOLIA_API_KEY = "3e42dbd4f895fe93ff5cf40d860c4a85";
var ALGOLIA_APPLICATION_ID = "PLSDUOL1CA";
var AGOLIA_SEARCH_URL = "https://plsduol1ca-dsn.algolia.net/1/indexes/*/queries";
var algoliaSearch = async (query) => {
  const url = new URL(AGOLIA_SEARCH_URL);
  url.searchParams.set("x-algolia-agen", encodeURIComponent("Remotion Studio DocSearch"));
  url.searchParams.set("x-algolia-api-key", ALGOLIA_API_KEY);
  url.searchParams.set("x-algolia-application-id", ALGOLIA_APPLICATION_ID);
  const { results } = await fetch(url.toString(), {
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: JSON.stringify({
      requests: [
        {
          query,
          indexName: "remotion",
          params: 'attributesToRetrieve=["hierarchy.lvl0","hierarchy.lvl1","hierarchy.lvl2","hierarchy.lvl3","hierarchy.lvl4","hierarchy.lvl5","hierarchy.lvl6","content","type","url"]&attributesToSnippet=["hierarchy.lvl1:10","hierarchy.lvl2:10","hierarchy.lvl3:10","hierarchy.lvl4:10","hierarchy.lvl5:10","hierarchy.lvl6:10","content:10"]&hitsPerPage=20'
        }
      ]
    }),
    method: "POST"
  }).then((res) => res.json());
  const { hits } = results[0];
  return hits.map((hit) => {
    const entries = Object.values(hit._highlightResult.hierarchy);
    const result = entries.find((value) => value.matchLevel === "full") ?? entries.find((value) => value.matchLevel === "partial");
    const { subtitle: subtitle4, title: title6 } = splitMatchIntoTitleAndSubtitle(hit);
    if (!result) {
      return null;
    }
    return {
      type: "search-result",
      id: hit.objectID,
      title: "Should not display",
      titleLine: title6,
      subtitleLine: subtitle4,
      onSelected: () => {
        window.open(hit.url);
      }
    };
  }).filter(NoReactInternals15.truthy);
};
var splitMatchIntoTitleAndSubtitle = (match) => {
  const main = match.type === "content" ? match._highlightResult.content : match._highlightResult.hierarchy[match.type];
  const title6 = main.value;
  const subtitle4 = Object.entries(match._highlightResult.hierarchy).filter(([level]) => level !== match.type).map((value) => value[1].value).join(" • ");
  return { title: title6, subtitle: subtitle4 };
};

// src/components/QuickSwitcher/AlgoliaCredit.tsx
import { jsx as jsx232 } from "react/jsx-runtime";
var link = {
  display: "inline-flex"
};
var AlgoliaCredit = () => {
  return /* @__PURE__ */ jsx232("a", {
    style: link,
    href: "https://www.algolia.com/ref/docsearch/?utm_source=www.remotion.dev&utm_medium=referral&utm_content=powered_by&utm_campaign=docsearch",
    target: "_blank",
    rel: "noopener noreferrer",
    children: /* @__PURE__ */ jsx232("svg", {
      width: "77",
      height: "19",
      "aria-label": "Algolia",
      role: "img",
      children: /* @__PURE__ */ jsx232("path", {
        d: "M2.5067 0h14.0245c1.384.001 2.5058 1.1205 2.5068 2.5017V16.5c-.0014 1.3808-1.1232 2.4995-2.5068 2.5H2.5067C1.1232 18.9995.0014 17.8808 0 16.5V2.4958A2.495 2.495 0 01.735.7294 2.505 2.505 0 012.5068 0zM37.95 15.0695c-3.7068.0168-3.7068-2.986-3.7068-3.4634L34.2372.3576 36.498 0v11.1794c0 .2715 0 1.9889 1.452 1.994v1.8961zm-9.1666-1.8388c.694 0 1.2086-.0397 1.5678-.1088v-2.2934a5.3639 5.3639 0 00-1.3303-.1679 4.8283 4.8283 0 00-.758.0582 2.2845 2.2845 0 00-.688.2024c-.2029.0979-.371.2362-.4919.4142-.1268.1788-.185.2826-.185.5533 0 .5297.185.8359.5205 1.0375.3355.2016.7928.3053 1.365.3053v-.0008zm-.1969-8.1817c.7463 0 1.3768.092 1.8856.2767.5088.1838.9195.4428 1.2204.7717.3068.334.5147.7777.6423 1.251.1327.4723.196.991.196 1.5603v5.798c-.5235.1036-1.05.192-1.5787.2649-.7048.1037-1.4976.156-2.3774.156-.5832 0-1.1215-.0582-1.6016-.167a3.385 3.385 0 01-1.2432-.5364 2.6034 2.6034 0 01-.8037-.9565c-.191-.3922-.29-.9447-.29-1.5208 0-.5533.11-.905.3246-1.2863a2.7351 2.7351 0 01.8849-.9329c.376-.242.8029-.415 1.2948-.5187a7.4517 7.4517 0 011.5381-.156 7.1162 7.1162 0 011.6667.2024V8.886c0-.259-.0296-.5061-.093-.7372a1.5847 1.5847 0 00-.3245-.6158 1.5079 1.5079 0 00-.6119-.4158 2.6788 2.6788 0 00-.966-.173c-.5206 0-.9948.0634-1.4283.1384a6.5481 6.5481 0 00-1.065.259l-.2712-1.849c.2831-.0986.7048-.1964 1.2491-.2943a9.2979 9.2979 0 011.752-.1501v.0008zm44.6597 8.1193c.6947 0 1.2086-.0405 1.567-.1097v-2.2942a5.3743 5.3743 0 00-1.3303-.1679c-.2485 0-.503.0177-.7573.0582a2.2853 2.2853 0 00-.688.2024 1.2333 1.2333 0 00-.4918.4142c-.1268.1788-.1843.2826-.1843.5533 0 .5297.1843.8359.5198 1.0375.3414.2066.7927.3053 1.365.3053v.0009zm-.191-8.1767c.7463 0 1.3768.0912 1.8856.2759.5087.1847.9195.4436 1.2204.7717.3.329.5147.7786.6414 1.251a5.7248 5.7248 0 01.197 1.562v5.7972c-.3466.0742-.874.1602-1.5788.2648-.7049.1038-1.4976.1552-2.3774.1552-.5832 0-1.1215-.0573-1.6016-.167a3.385 3.385 0 01-1.2432-.5356 2.6034 2.6034 0 01-.8038-.9565c-.191-.3922-.2898-.9447-.2898-1.5216 0-.5533.1098-.905.3245-1.2854a2.7373 2.7373 0 01.8849-.9338c.376-.2412.8029-.4141 1.2947-.5178a7.4545 7.4545 0 012.325-.1097c.2781.0287.5672.081.879.156v-.3686a2.7781 2.7781 0 00-.092-.738 1.5788 1.5788 0 00-.3246-.6166 1.5079 1.5079 0 00-.612-.415 2.6797 2.6797 0 00-.966-.1729c-.5205 0-.9947.0633-1.4282.1384a6.5608 6.5608 0 00-1.065.259l-.2712-1.8498c.283-.0979.7048-.1957 1.2491-.2935a9.8597 9.8597 0 011.752-.1494zm-6.79-1.072c-.7576.001-1.373-.6103-1.3759-1.3664 0-.755.6128-1.3664 1.376-1.3664.764 0 1.3775.6115 1.3775 1.3664s-.6195 1.3664-1.3776 1.3664zm1.1393 11.1507h-2.2726V5.3409l2.2734-.3568v10.0845l-.0008.0017zm-3.984 0c-3.707.0168-3.707-2.986-3.707-3.4642L59.7069.3576 61.9685 0v11.1794c0 .2715 0 1.9889 1.452 1.994V15.0703zm-7.3512-4.979c0-.975-.2138-1.7873-.6305-2.3516-.4167-.571-.9998-.852-1.747-.852-.7454 0-1.3302.281-1.7452.852-.4166.5702-.6195 1.3765-.6195 2.3516 0 .9851.208 1.6473.6254 2.2183.4158.576.9998.8587 1.7461.8587.7454 0 1.3303-.2885 1.747-.8595.4158-.5761.6237-1.2315.6237-2.2184v.0009zm2.3132-.006c0 .7609-.1099 1.3361-.3356 1.9654a4.654 4.654 0 01-.9533 1.6076A4.214 4.214 0 0155.613 14.69c-.579.2412-1.4697.3795-1.9143.3795-.4462-.005-1.3303-.1324-1.9033-.3795a4.307 4.307 0 01-1.474-1.0316c-.4115-.4445-.7293-.9801-.9609-1.6076a5.3423 5.3423 0 01-.3465-1.9653c0-.7608.104-1.493.3356-2.1155a4.683 4.683 0 01.9719-1.5958 4.3383 4.3383 0 011.479-1.0257c.5739-.242 1.2043-.3567 1.8864-.3567.6829 0 1.3125.1197 1.8906.3567a4.1245 4.1245 0 011.4816 1.0257 4.7587 4.7587 0 01.9592 1.5958c.2426.6225.3643 1.3547.3643 2.1155zm-17.0198 0c0 .9448.208 1.9932.6238 2.431.4166.4386.955.6579 1.6142.6579.3584 0 .6998-.0523 1.0176-.1502.3186-.0978.5721-.2134.775-.3517V7.0784a8.8706 8.8706 0 00-1.4926-.1906c-.8206-.0236-1.4452.312-1.8847.8468-.4335.5365-.6533 1.476-.6533 2.3516v-.0008zm6.2863 4.4485c0 1.5385-.3938 2.662-1.1866 3.3773-.791.7136-2.0005 1.0712-3.6308 1.0712-.5958 0-1.834-.1156-2.8228-.334l.3643-1.7865c.8282.173 1.9202.2193 2.4932.2193.9077 0 1.555-.1847 1.943-.5533.388-.3686.578-.916.578-1.643v-.3687a6.8289 6.8289 0 01-.8848.3349c-.3634.1096-.786.167-1.261.167-.6246 0-1.1917-.0979-1.7055-.2944a3.5554 3.5554 0 01-1.3244-.8645c-.3642-.3796-.6541-.8579-.8561-1.4289-.2028-.571-.3068-1.59-.3068-2.339 0-.7034.1099-1.5856.3245-2.1735.2198-.5871.5316-1.0949.9542-1.515.4167-.42.9255-.743 1.5213-.98a5.5923 5.5923 0 012.052-.3855c.7353 0 1.4114.092 2.0707.2024.6592.1088 1.2204.2236 1.6776.35v8.945-.0008zM11.5026 4.2418v-.6511c-.0005-.4553-.3704-.8241-.8266-.8241H8.749c-.4561 0-.826.3688-.8265.824v.669c0 .0742.0693.1264.1445.1096a6.0346 6.0346 0 011.6768-.2362 6.125 6.125 0 011.6202.2185.1116.1116 0 00.1386-.1097zm-5.2806.852l-.3296-.3282a.8266.8266 0 00-1.168 0l-.393.3922a.8199.8199 0 000 1.164l.3237.323c.0524.0515.1268.0397.1733-.0117.191-.259.3989-.507.6305-.7372.2374-.2362.48-.4437.7462-.6335.0575-.0354.0634-.1155.017-.1687zm3.5159 2.069v2.818c0 .081.0879.1392.1622.0987l2.5102-1.2964c.0574-.0287.0752-.0987.0464-.1552a3.1237 3.1237 0 00-2.603-1.574c-.0575 0-.115.0456-.115.1097l-.0008-.0009zm.0008 6.789c-2.0933.0005-3.7915-1.6912-3.7947-3.7804C5.9468 8.0821 7.6452 6.39 9.7387 6.391c2.0932-.0005 3.7911 1.6914 3.794 3.7804a3.7783 3.7783 0 01-1.1124 2.675 3.7936 3.7936 0 01-2.6824 1.1054h.0008zM9.738 4.8002c-1.9218 0-3.6975 1.0232-4.6584 2.6841a5.359 5.359 0 000 5.3683c.9609 1.661 2.7366 2.6841 4.6584 2.6841a5.3891 5.3891 0 003.8073-1.5725 5.3675 5.3675 0 001.578-3.7987 5.3574 5.3574 0 00-1.5771-3.797A5.379 5.379 0 009.7387 4.801l-.0008-.0008z",
        fill: "currentColor",
        fillRule: "evenodd"
      })
    })
  });
};

// src/components/QuickSwitcher/fuzzy-search.ts
function fuzzySearch(query, dataset) {
  const q = query ? query.trim().toLowerCase() : "";
  const matchingIndices = [];
  if (q.length === 0) {
    for (let i = 0;i < dataset.length; i++) {
      matchingIndices.push(i);
    }
    return dataset.filter((_, i) => matchingIndices.includes(i));
  }
  dataset.forEach((d, index) => {
    const s = d.title.trim().toLowerCase();
    let i = 0;
    let n = -1;
    let l;
    for (;l = q[i++]; )
      if (!~(n = s.indexOf(l, n + 1)))
        return;
    matchingIndices.push(index);
  });
  return dataset.filter((_, i) => matchingIndices.includes(i));
}

// src/components/QuickSwitcher/NoResults.tsx
import { jsxs as jsxs117 } from "react/jsx-runtime";
var container50 = {
  padding: 80,
  color: LIGHT_TEXT,
  textAlign: "center",
  fontSize: 14
};
var MODE_TO_STRING = {
  commands: "commands",
  compositions: "compositions",
  docs: "documentation"
};
var QuickSwitcherNoResults = ({ query, mode }) => {
  return /* @__PURE__ */ jsxs117("div", {
    style: container50,
    children: [
      "No ",
      MODE_TO_STRING[mode],
      " matching ",
      '"',
      query,
      '"'
    ]
  });
};

// src/components/QuickSwitcher/QuickSwitcherResult.tsx
import { useEffect as useEffect81, useMemo as useMemo125, useRef as useRef42, useState as useState81 } from "react";
import { jsx as jsx233, jsxs as jsxs118, Fragment as Fragment35 } from "react/jsx-runtime";
var container51 = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer"
};
var label9 = {
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
var searchLabel = {
  ...label9,
  lineHeight: 1.25
};
var iconStyle6 = {
  width: 14,
  height: 14
};
var labelContainer = {
  overflow: "hidden",
  flex: 1,
  paddingTop: 5,
  paddingBottom: 5
};
var QuickSwitcherResult = ({ result, selected }) => {
  const [hovered, setIsHovered] = useState81(false);
  const ref = useRef42(null);
  const keybindings = useKeybinding();
  useEffect81(() => {
    const { current } = ref;
    if (!current) {
      return;
    }
    const onMouseEnter = () => setIsHovered(true);
    const onMouseLeave = () => setIsHovered(false);
    current.addEventListener("mouseenter", onMouseEnter);
    current.addEventListener("mouseleave", onMouseLeave);
    return () => {
      current.removeEventListener("mouseenter", onMouseEnter);
      current.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);
  useEffect81(() => {
    if (!selected) {
      return;
    }
    const binding = keybindings.registerKeybinding({
      key: "Enter",
      callback: result.onSelected,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, result.onSelected, selected]);
  useEffect81(() => {
    if (selected) {
      ref.current?.scrollIntoView({
        block: "nearest",
        inline: "center"
      });
    }
  }, [selected]);
  const style12 = useMemo125(() => {
    return {
      ...container51,
      backgroundColor: getBackgroundFromHoverState({
        hovered,
        selected
      })
    };
  }, [hovered, selected]);
  const labelStyle5 = useMemo125(() => {
    return {
      ...result.type === "search-result" ? searchLabel : label9,
      color: result.type === "search-result" ? LIGHT_TEXT : selected || hovered ? "white" : LIGHT_TEXT,
      fontSize: 15
    };
  }, [hovered, result.type, selected]);
  return /* @__PURE__ */ jsxs118("div", {
    ref,
    style: style12,
    onClick: result.onSelected,
    children: [
      result.type === "composition" ? result.compositionType === "still" ? /* @__PURE__ */ jsx233(StillIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : /* @__PURE__ */ jsx233(FilmIcon, {
        color: selected ? "white" : LIGHT_TEXT,
        style: iconStyle6
      }) : null,
      /* @__PURE__ */ jsx233(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx233("div", {
        style: labelContainer,
        children: result.type === "search-result" ? /* @__PURE__ */ jsxs118(Fragment35, {
          children: [
            /* @__PURE__ */ jsx233("div", {
              dangerouslySetInnerHTML: {
                __html: result.titleLine
              },
              style: labelStyle5
            }),
            /* @__PURE__ */ jsx233("div", {
              dangerouslySetInnerHTML: {
                __html: result.subtitleLine
              },
              style: labelStyle5
            })
          ]
        }) : /* @__PURE__ */ jsx233("div", {
          style: labelStyle5,
          children: result.title
        })
      })
    ]
  }, result.id);
};

// src/components/QuickSwitcher/QuickSwitcherContent.tsx
import { jsx as jsx234, jsxs as jsxs119, Fragment as Fragment36 } from "react/jsx-runtime";
var input2 = {
  width: "100%"
};
var modeSelector = {
  paddingLeft: 16,
  paddingRight: 16,
  display: "flex",
  flexDirection: "row",
  paddingTop: 8,
  paddingBottom: 5
};
var modeItem = {
  appearance: "none",
  border: "none",
  fontFamily: "inherit",
  padding: 0,
  fontSize: 13,
  cursor: "pointer"
};
var modeInactive = {
  ...modeItem,
  color: LIGHT_TEXT
};
var modeActive = {
  ...modeItem,
  color: "white",
  fontWeight: "bold"
};
var content6 = {
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 4,
  paddingBottom: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var loopIndex = (index, length) => {
  if (index < 0) {
    index += length;
  }
  return index % length;
};
var stripQuery = (query) => {
  if (query.startsWith(">") || query.startsWith("?")) {
    return query.substring(1).trim();
  }
  return query.trim();
};
var mapQueryToMode = (query) => {
  return query.startsWith(">") ? "commands" : query.startsWith("?") ? "docs" : "compositions";
};
var mapModeToQuery = (mode) => {
  if (mode === "commands") {
    return "> ";
  }
  if (mode === "compositions") {
    return "";
  }
  if (mode === "docs") {
    return "? ";
  }
  throw new Error("no mode" + mode);
};
var QuickSwitcherContent = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  const { compositions } = useContext86(Internals64.CompositionManager);
  const [state, setState] = useState82(() => {
    return {
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    };
  });
  useEffect82(() => {
    setState({
      query: mapModeToQuery(initialMode),
      selectedIndex: 0
    });
  }, [initialMode, invocationTimestamp]);
  const inputRef = useRef43(null);
  const selectComposition = useSelectComposition();
  const closeMenu = useCallback116(() => {
    return;
  }, []);
  const actions = useMenuStructure(closeMenu, readOnlyStudio);
  const [docResults, setDocResults] = useState82({ type: "initial" });
  const { setSelectedModal } = useContext86(ModalsContext);
  const keybindings = useKeybinding();
  const mode = mapQueryToMode(state.query);
  const actualQuery = useMemo126(() => {
    return stripQuery(state.query);
  }, [state.query]);
  const menuActions = useMemo126(() => {
    if (mode !== "commands") {
      return [];
    }
    return makeSearchResults(actions, setSelectedModal);
  }, [actions, mode, setSelectedModal]);
  const resultsArray = useMemo126(() => {
    if (mode === "commands") {
      return fuzzySearch(actualQuery, menuActions);
    }
    if (mode === "docs" && docResults.type === "results") {
      return docResults.results;
    }
    return fuzzySearch(actualQuery, compositions.map((c) => {
      return {
        id: "composition-" + c.id,
        title: c.id,
        type: "composition",
        onSelected: () => {
          selectComposition(c, true);
          setSelectedModal(null);
          const selector = `.__remotion-composition[data-compname="${c.id}"]`;
          Internals64.compositionSelectorRef.current?.expandComposition(c.id);
          waitForElm(selector).then(() => {
            document.querySelector(selector)?.scrollIntoView({ block: "center" });
          });
        },
        compositionType: isCompositionStill(c) ? "still" : "composition"
      };
    }));
  }, [
    mode,
    actualQuery,
    compositions,
    menuActions,
    docResults,
    selectComposition,
    setSelectedModal
  ]);
  const onArrowDown = useCallback116(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex + 1
      };
    });
  }, []);
  const onArrowUp = useCallback116(() => {
    setState((s) => {
      return {
        ...s,
        selectedIndex: s.selectedIndex - 1
      };
    });
  }, []);
  useEffect82(() => {
    const binding = keybindings.registerKeybinding({
      key: "ArrowUp",
      callback: onArrowUp,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, onArrowDown, onArrowUp]);
  useEffect82(() => {
    if (mode !== "docs") {
      return;
    }
    if (actualQuery.trim() === "") {
      setDocResults({ type: "initial" });
      return;
    }
    let cancelled = false;
    setDocResults({ type: "loading" });
    algoliaSearch(actualQuery).then((agoliaResults) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "results", results: agoliaResults });
    }).catch((err) => {
      if (cancelled) {
        return;
      }
      setDocResults({ type: "error", error: err });
    });
    return () => {
      cancelled = true;
    };
  }, [actualQuery, mode]);
  useEffect82(() => {
    const binding = keybindings.registerKeybinding({
      key: "ArrowDown",
      callback: onArrowDown,
      commandCtrlKey: false,
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      binding.unregister();
    };
  }, [keybindings, onArrowDown]);
  const onTextChange = useCallback116((e) => {
    setState({ query: e.target.value, selectedIndex: 0 });
  }, []);
  const selectedIndexRounded = loopIndex(state.selectedIndex, resultsArray.length);
  const onActionsSelected = useCallback116(() => {
    setState((s) => ({
      query: `> ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onCompositionsSelected = useCallback116(() => {
    setState((s) => ({
      query: stripQuery(s.query),
      selectedIndex: 0
    }));
    inputRef.current?.focus();
  }, []);
  const onDocSearchSelected = useCallback116(() => {
    setState((s) => ({
      query: `? ${stripQuery(s.query)}`,
      selectedIndex: 0
    }));
    setDocResults({ type: "initial" });
    inputRef.current?.focus();
  }, []);
  const showKeyboardShortcuts = mode === "docs" && actualQuery.trim() === "";
  const showSearchLoadingState = mode === "docs" && docResults.type === "loading";
  const container52 = useMemo126(() => {
    return {
      width: showKeyboardShortcuts ? 800 : 500
    };
  }, [showKeyboardShortcuts]);
  const results = useMemo126(() => {
    if (showKeyboardShortcuts) {
      return {
        maxHeight: 600,
        overflowY: "auto"
      };
    }
    return {
      overflowY: "auto",
      height: 300
    };
  }, [showKeyboardShortcuts]);
  return /* @__PURE__ */ jsxs119("div", {
    style: container52,
    children: [
      /* @__PURE__ */ jsxs119("div", {
        style: modeSelector,
        children: [
          /* @__PURE__ */ jsx234("button", {
            onClick: onCompositionsSelected,
            style: mode === "compositions" ? modeActive : modeInactive,
            type: "button",
            children: "Compositions"
          }),
          /* @__PURE__ */ jsx234(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx234("button", {
            onClick: onActionsSelected,
            style: mode === "commands" ? modeActive : modeInactive,
            type: "button",
            children: "Actions"
          }),
          /* @__PURE__ */ jsx234(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx234("button", {
            onClick: onDocSearchSelected,
            style: mode === "docs" ? modeActive : modeInactive,
            type: "button",
            children: "Documentation"
          })
        ]
      }),
      /* @__PURE__ */ jsxs119("div", {
        style: content6,
        children: [
          /* @__PURE__ */ jsx234(RemotionInput, {
            ref: inputRef,
            type: "text",
            style: input2,
            autoFocus: true,
            status: "ok",
            value: state.query,
            onChange: onTextChange,
            placeholder: "Search compositions...",
            rightAlign: false
          }),
          showKeyboardShortcuts ? /* @__PURE__ */ jsxs119(Fragment36, {
            children: [
              /* @__PURE__ */ jsx234(Spacing, {
                x: 2
              }),
              " ",
              /* @__PURE__ */ jsx234(AlgoliaCredit, {})
            ]
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx234("div", {
        style: results,
        className: VERTICAL_SCROLLBAR_CLASSNAME,
        children: showKeyboardShortcuts ? /* @__PURE__ */ jsx234(KeyboardShortcutsExplainer, {}) : showSearchLoadingState ? null : resultsArray.length === 0 ? /* @__PURE__ */ jsx234(QuickSwitcherNoResults, {
          mode,
          query: actualQuery
        }) : resultsArray.map((result, i) => {
          return /* @__PURE__ */ jsx234(QuickSwitcherResult, {
            selected: selectedIndexRounded === i,
            result
          }, result.id);
        })
      })
    ]
  });
};
function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
      return;
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

// src/components/QuickSwitcher/QuickSwitcher.tsx
import { jsx as jsx235 } from "react/jsx-runtime";
var QuickSwitcher = ({ initialMode, invocationTimestamp, readOnlyStudio }) => {
  return /* @__PURE__ */ jsx235(DismissableModal, {
    children: /* @__PURE__ */ jsx235(QuickSwitcherContent, {
      readOnlyStudio,
      invocationTimestamp,
      initialMode
    })
  });
};
var QuickSwitcher_default = QuickSwitcher;

// src/components/RenderModal/RenderStatusModal.tsx
import { useCallback as useCallback118, useContext as useContext87 } from "react";

// src/components/RenderModal/ClientRenderProgress.tsx
import { formatBytes as formatBytes3 } from "@remotion/studio-shared";

// src/components/RenderQueue/SuccessIcon.tsx
import { jsx as jsx236 } from "react/jsx-runtime";
var iconStyle7 = {
  height: RENDER_STATUS_INDICATOR_SIZE,
  width: RENDER_STATUS_INDICATOR_SIZE
};
var SuccessIcon = () => {
  return /* @__PURE__ */ jsx236("svg", {
    style: iconStyle7,
    viewBox: "0 0 512 512",
    children: /* @__PURE__ */ jsx236("path", {
      fill: LIGHT_TEXT,
      d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z"
    })
  });
};

// src/components/RenderModal/ClientRenderProgress.tsx
import { jsx as jsx237, jsxs as jsxs120 } from "react/jsx-runtime";
var progressItem = {
  padding: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var label10 = {
  fontSize: 14,
  width: 400,
  color: "white"
};
var right3 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  textAlign: "right",
  flex: 1
};
var ProgressStatus = ({ encodedFrames, totalFrames, doneIn, renderEstimatedTime, progress }) => {
  const done = doneIn !== null;
  const message = getClientRenderProgressMessage({
    encodedFrames,
    totalFrames,
    doneIn,
    renderEstimatedTime,
    progress
  });
  return /* @__PURE__ */ jsxs120("div", {
    style: progressItem,
    children: [
      done ? /* @__PURE__ */ jsx237(SuccessIcon, {}) : /* @__PURE__ */ jsx237(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx237(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx237("div", {
        style: label10,
        children: message
      }),
      doneIn !== null ? /* @__PURE__ */ jsxs120("div", {
        style: right3,
        children: [
          doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var DoneStatus = ({ job }) => {
  return /* @__PURE__ */ jsxs120("div", {
    style: progressItem,
    children: [
      /* @__PURE__ */ jsx237(SuccessIcon, {}),
      /* @__PURE__ */ jsx237(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx237("div", {
        style: label10,
        children: job.outName
      }),
      /* @__PURE__ */ jsx237("div", {
        style: right3,
        children: formatBytes3(job.metadata.sizeInBytes)
      })
    ]
  });
};
var ClientRenderProgress = ({ job }) => {
  if (job.status === "idle" || job.status === "failed" || job.status === "cancelled") {
    throw new Error("This component should not be rendered when the job is idle, failed, or cancelled");
  }
  if (job.status === "done") {
    return /* @__PURE__ */ jsxs120("div", {
      children: [
        /* @__PURE__ */ jsx237(Spacing, {
          y: 0.5
        }),
        /* @__PURE__ */ jsx237(DoneStatus, {
          job
        }),
        /* @__PURE__ */ jsx237(Spacing, {
          y: 1
        })
      ]
    });
  }
  if (job.status === "saving") {
    return /* @__PURE__ */ jsxs120("div", {
      children: [
        /* @__PURE__ */ jsx237(Spacing, {
          y: 0.5
        }),
        /* @__PURE__ */ jsx237("div", {
          style: label10,
          children: "Saving to out/..."
        }),
        /* @__PURE__ */ jsx237(Spacing, {
          y: 1
        })
      ]
    });
  }
  const { encodedFrames, totalFrames, doneIn, renderEstimatedTime, progress } = job.progress;
  return /* @__PURE__ */ jsxs120("div", {
    children: [
      /* @__PURE__ */ jsx237(Spacing, {
        y: 0.5
      }),
      job.type === "client-video" && /* @__PURE__ */ jsx237(ProgressStatus, {
        encodedFrames,
        totalFrames,
        doneIn,
        renderEstimatedTime,
        progress
      }),
      /* @__PURE__ */ jsx237(Spacing, {
        y: 1
      })
    ]
  });
};

// src/components/RenderModal/GuiRenderStatus.tsx
import { useCallback as useCallback117, useMemo as useMemo127 } from "react";
import { jsx as jsx238, jsxs as jsxs121 } from "react/jsx-runtime";
var progressItem2 = {
  padding: 10,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var label11 = {
  fontSize: 14,
  width: 400,
  color: "white"
};
var right4 = {
  fontSize: 14,
  color: LIGHT_TEXT,
  textAlign: "right",
  flex: 1
};
var BundlingProgress = ({ progress, doneIn }) => {
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      progress === 1 ? /* @__PURE__ */ jsx238(SuccessIcon, {}) : /* @__PURE__ */ jsx238(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx238("div", {
        style: label11,
        children: progress === 1 ? "Bundled" : `Bundling ${progress * 100}%`
      }),
      doneIn ? /* @__PURE__ */ jsxs121("div", {
        style: right4,
        children: [
          doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var BrowserSetupProgress = ({ progress, doneIn, startedBundling, alreadyAvailable }) => {
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      progress === 1 || alreadyAvailable ? /* @__PURE__ */ jsx238(SuccessIcon, {}) : /* @__PURE__ */ jsx238(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx238("div", {
        style: label11,
        children: alreadyAvailable && startedBundling ? "Headless browser already available" : progress === 1 ? "Downloaded Headless Shell" : `Downloading Headless Shell ${Math.round(progress * 100)}%`
      }),
      doneIn ? /* @__PURE__ */ jsxs121("div", {
        style: right4,
        children: [
          doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var RenderingProgress = ({ progress }) => {
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      progress.frames === progress.totalFrames ? /* @__PURE__ */ jsx238(SuccessIcon, {}) : /* @__PURE__ */ jsx238(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx238("div", {
        style: label11,
        children: progress.doneIn ? `Rendered ${progress.totalFrames} frames` : `Rendering ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? /* @__PURE__ */ jsxs121("div", {
        style: right4,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var StitchingProgress = ({ progress }) => {
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      progress.frames === progress.totalFrames ? /* @__PURE__ */ jsx238(SuccessIcon, {}) : /* @__PURE__ */ jsx238(CircularProgress, {
        progress: progress.frames / progress.totalFrames
      }),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx238("div", {
        style: label11,
        children: progress.doneIn ? `Encoded ${progress.totalFrames} frames` : `Encoding ${progress.frames} / ${progress.totalFrames} frames`
      }),
      progress.doneIn ? /* @__PURE__ */ jsxs121("div", {
        style: right4,
        children: [
          progress.doneIn,
          "ms"
        ]
      }) : null
    ]
  });
};
var DownloadsProgress = ({ downloads }) => {
  const allHaveProgress = downloads.every((a) => a.totalBytes);
  const totalBytes = allHaveProgress ? downloads.reduce((a, b) => a + b.totalBytes, 0) : null;
  const downloaded = allHaveProgress ? downloads.reduce((a, b) => a + b.downloaded, 0) : null;
  const progress = allHaveProgress ? downloaded / totalBytes : 0.1;
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      progress === 1 ? /* @__PURE__ */ jsx238(SuccessIcon, {}) : /* @__PURE__ */ jsx238(CircularProgress, {
        progress
      }),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsxs121("div", {
        style: label11,
        children: [
          "Downloading ",
          downloads.length,
          " file",
          downloads.length === 1 ? "" : "s"
        ]
      })
    ]
  });
};
var OpenFile = ({ job }) => {
  const labelStyle5 = useMemo127(() => {
    return {
      ...label11,
      textAlign: "left",
      appearance: "none",
      border: 0,
      paddingLeft: 0,
      cursor: job.deletedOutputLocation ? "inherit" : "pointer",
      textDecoration: job.deletedOutputLocation ? "line-through" : "none"
    };
  }, [job.deletedOutputLocation]);
  const onClick = useCallback117(() => {
    openInFileExplorer({ directory: job.outName });
  }, [job.outName]);
  return /* @__PURE__ */ jsxs121("div", {
    style: progressItem2,
    children: [
      /* @__PURE__ */ jsx238(SuccessIcon, {}),
      /* @__PURE__ */ jsx238(Spacing, {
        x: 1
      }),
      /* @__PURE__ */ jsx238("button", {
        style: labelStyle5,
        type: "button",
        onClick,
        children: job.outName
      }),
      /* @__PURE__ */ jsx238("div", {
        style: right4,
        children: /* @__PURE__ */ jsx238(RenderQueueOpenInFinderItem, {
          job
        })
      })
    ]
  });
};
var GuiRenderStatus = ({ job }) => {
  if (job.status === "idle" || job.status === "failed") {
    throw new Error("This component should not be rendered when the job is idle");
  }
  return /* @__PURE__ */ jsxs121("div", {
    children: [
      /* @__PURE__ */ jsx238(Spacing, {
        y: 0.5
      }),
      /* @__PURE__ */ jsx238(BrowserSetupProgress, {
        ...job.progress.browser,
        startedBundling: Boolean(job.progress.bundling)
      }),
      job.progress.bundling && /* @__PURE__ */ jsx238(BundlingProgress, {
        progress: job.progress.bundling.progress,
        doneIn: job.progress.bundling.doneIn
      }),
      job.progress.rendering ? /* @__PURE__ */ jsx238(RenderingProgress, {
        progress: job.progress.rendering
      }) : null,
      job.progress.stitching ? /* @__PURE__ */ jsx238(StitchingProgress, {
        progress: job.progress.stitching
      }) : null,
      job.progress.downloads.length > 0 ? /* @__PURE__ */ jsx238(DownloadsProgress, {
        downloads: job.progress.downloads
      }) : null,
      job.status === "done" ? /* @__PURE__ */ jsx238(OpenFile, {
        job
      }) : null,
      /* @__PURE__ */ jsx238(Spacing, {
        y: 1
      })
    ]
  });
};

// src/components/RenderModal/RenderStatusModal.tsx
import { jsx as jsx239, jsxs as jsxs122, Fragment as Fragment37 } from "react/jsx-runtime";
var container52 = {
  padding: 20,
  maxWidth: 900,
  paddingTop: 0
};
var codeBlock = {
  backgroundColor: "#222",
  whiteSpace: "pre",
  padding: 12,
  borderRadius: 4,
  fontFamily: "monospace",
  overflow: "auto",
  maxHeight: 300
};
var spacer3 = {
  height: SPACING_UNIT,
  width: SPACING_UNIT
};
var buttonRow = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end"
};
var RenderStatusModal = ({
  jobId
}) => {
  const { setSelectedModal } = useContext87(ModalsContext);
  const { jobs, removeClientJob, cancelClientJob } = useContext87(RenderQueueContext);
  const job = jobs.find((j) => j.id === jobId);
  if (!job) {
    throw new Error("job not found");
  }
  const isClientJob = isClientRenderJob(job);
  const onQuit = useCallback118(() => {
    setSelectedModal(null);
  }, [setSelectedModal]);
  const onRetry = useCallback118(() => {
    if (isClientJob) {
      if (isRestoredClientJob(job)) {
        return;
      }
      const retryPayload = makeClientRetryPayload(job);
      setSelectedModal(retryPayload);
    } else {
      const retryPayload = makeRetryPayload(job);
      setSelectedModal(retryPayload);
    }
  }, [job, isClientJob, setSelectedModal]);
  const onClickOnRemove = useCallback118(() => {
    setSelectedModal(null);
    if (isClientJob) {
      removeClientJob(job.id);
      showNotification("Removed render", 2000);
    } else {
      removeRenderJob(job).catch((err) => {
        showNotification(`Could not remove job: ${err.message}`, 2000);
      });
    }
  }, [job, isClientJob, removeClientJob, setSelectedModal]);
  const onClickOnCancel = useCallback118(() => {
    if (isClientJob) {
      cancelClientJob(job.id);
    } else {
      cancelRenderJob(job).catch((err) => {
        showNotification(`Could not cancel job: ${err.message}`, 2000);
      });
    }
  }, [job, isClientJob, cancelClientJob]);
  if (job.status === "idle") {
    throw new Error("should not have rendered this modal");
  }
  return /* @__PURE__ */ jsxs122(ModalContainer, {
    onOutsideClick: onQuit,
    onEscape: onQuit,
    children: [
      /* @__PURE__ */ jsx239(ModalHeader, {
        title: `Render ${job.compositionId}`
      }),
      /* @__PURE__ */ jsxs122("div", {
        style: container52,
        children: [
          job.status === "failed" ? /* @__PURE__ */ jsxs122(Fragment37, {
            children: [
              /* @__PURE__ */ jsx239("p", {
                children: "The render failed because of the following error:"
              }),
              /* @__PURE__ */ jsx239("div", {
                className: HORIZONTAL_SCROLLBAR_CLASSNAME,
                style: codeBlock,
                children: job.error.stack
              })
            ]
          }) : null,
          (job.status === "done" || job.status === "running") && (isClientJob ? /* @__PURE__ */ jsx239(ClientRenderProgress, {
            job
          }) : /* @__PURE__ */ jsx239(GuiRenderStatus, {
            job
          })),
          /* @__PURE__ */ jsx239("div", {
            style: spacer3
          }),
          /* @__PURE__ */ jsxs122("div", {
            style: buttonRow,
            children: [
              job.status === "running" ? /* @__PURE__ */ jsx239(Button, {
                onClick: onClickOnCancel,
                children: "Cancel render"
              }) : /* @__PURE__ */ jsx239(Button, {
                onClick: onClickOnRemove,
                children: "Remove render"
              }),
              /* @__PURE__ */ jsx239(Flex, {}),
              job.status === "failed" ? /* @__PURE__ */ jsx239(Button, {
                onClick: onRetry,
                children: "Retry"
              }) : null,
              /* @__PURE__ */ jsx239("div", {
                style: spacer3
              }),
              /* @__PURE__ */ jsx239(Button, {
                onClick: onQuit,
                children: "Close"
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/ServerRenderModal.tsx
import { BrowserSafeApis as BrowserSafeApis11 } from "@remotion/renderer/client";
import { getDefaultOutLocation } from "@remotion/studio-shared";
import {
  useCallback as useCallback136,
  useContext as useContext89,
  useEffect as useEffect85,
  useMemo as useMemo137,
  useReducer as useReducer2,
  useRef as useRef45,
  useState as useState88
} from "react";

// src/helpers/convert-env-variables.ts
var envVariablesObjectToArray = (envVariables) => {
  return Object.entries(envVariables).map(([key5, one]) => [
    key5.trim().toUpperCase(),
    one.trim()
  ]);
};
var envVariablesArrayToObject = (envVariables) => {
  return envVariables.map(([key5, val]) => [key5.trim(), val.trim()]).filter(([key5, val]) => key5 && val).reduce((acc, [key5, value]) => {
    acc[key5.toUpperCase()] = value;
    return acc;
  }, {});
};

// src/helpers/make-render-command.ts
import { BrowserSafeApis } from "@remotion/renderer/client";
var shellQuote = (value) => {
  return `'${value.replace(/'/g, "'\\''")}'`;
};
var addFlagWithValue = (flags, flag, value) => {
  if (value === null || value === undefined) {
    return;
  }
  flags.push(`--${flag}=${shellQuote(String(value))}`);
};
var addBooleanFlag = (flags, flag, value) => {
  if (value) {
    flags.push(`--${flag}`);
  }
};
var valueFlag = (flag, value, defaultValue) => {
  return { flag, value, defaultValue };
};
var booleanFlag = (flag, value, defaultValue) => {
  return { flag, value, defaultValue };
};
var addValueFlagsIfChanged = (flags, mappings) => {
  for (const mapping of mappings) {
    if (mapping.value !== mapping.defaultValue) {
      addFlagWithValue(flags, mapping.flag, mapping.value);
    }
  }
};
var addTrueBooleanFlagsIfChanged = (flags, mappings) => {
  for (const mapping of mappings) {
    if (mapping.value && mapping.value !== mapping.defaultValue) {
      addBooleanFlag(flags, mapping.flag, true);
    }
  }
};
var getNpmRemotionCommandPrefix = (version) => {
  return version.trim() === "" ? "bunx --yes --location=global -p @remotion/cli remotion" : `bunx --yes --location=global -p @remotion/cli@${version} remotion`;
};
var normalizeServeUrlForRenderCommand = ({
  locationHref,
  compositionId
}) => {
  const parsed = new URL(locationHref);
  parsed.hash = "";
  parsed.search = "";
  const suffix2 = `/${compositionId}`;
  if (parsed.pathname === suffix2) {
    parsed.pathname = "/";
  } else if (parsed.pathname.endsWith(suffix2)) {
    const basePath = parsed.pathname.slice(0, -suffix2.length);
    parsed.pathname = basePath === "" ? "/" : basePath;
  }
  if (parsed.pathname !== "/" && parsed.pathname.endsWith("/")) {
    parsed.pathname = parsed.pathname.slice(0, -1);
  }
  return `${parsed.origin}${parsed.pathname === "/" ? "" : parsed.pathname}`;
};
var trimDefaultOutPrefix = (outName) => {
  if (outName.startsWith("out/")) {
    const trimmed = outName.slice("out/".length);
    return trimmed.length === 0 ? outName : trimmed;
  }
  if (outName.startsWith("./out/")) {
    const trimmed = outName.slice("./out/".length);
    return trimmed.length === 0 ? outName : trimmed;
  }
  return outName;
};
var getRenderMediaFlag = (option) => {
  return BrowserSafeApis.optionsMap.renderMedia[option].cliFlag;
};
var renderMediaValueFlag = (option, value, defaultValue) => {
  return valueFlag(getRenderMediaFlag(option), value, defaultValue);
};
var renderMediaBooleanFlag = (option, value, defaultValue) => {
  return booleanFlag(getRenderMediaFlag(option), value, defaultValue);
};
var makeReadOnlyStudioRenderCommand = ({
  remotionVersion,
  locationHref,
  compositionId,
  outName,
  renderMode,
  renderDefaults,
  durationInFrames,
  concurrency,
  frame: frame2,
  startFrame,
  endFrame,
  stillImageFormat,
  sequenceImageFormat,
  videoImageFormat,
  jpegQuality,
  codec,
  muted,
  enforceAudioTrack,
  proResProfile,
  x264Preset,
  pixelFormat,
  crf,
  videoBitrate,
  audioBitrate,
  audioCodec,
  everyNthFrame,
  numberOfGifLoops,
  disallowParallelEncoding,
  encodingBufferSize,
  encodingMaxRate,
  forSeamlessAacConcatenation,
  separateAudioTo,
  colorSpace,
  scale,
  logLevel,
  delayRenderTimeout,
  hardwareAcceleration,
  chromeMode,
  headless,
  disableWebSecurity,
  ignoreCertificateErrors,
  gl,
  userAgent,
  multiProcessOnLinux,
  darkMode,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  mediaCacheSizeInBytes,
  beepOnFinish,
  repro,
  metadata,
  envVariables,
  inputProps
}) => {
  const serveUrl = normalizeServeUrlForRenderCommand({
    locationHref,
    compositionId
  });
  const isStillRender = renderMode === "still";
  const isSequenceRender = renderMode === "sequence";
  const hasCodecSpecificOptions = !isSequenceRender;
  const commandType = isStillRender ? "still" : "render";
  const command = getNpmRemotionCommandPrefix(remotionVersion);
  const { options } = BrowserSafeApis;
  const flags = [];
  addValueFlagsIfChanged(flags, [
    valueFlag(options.scaleOption.cliFlag, scale, renderDefaults.scale),
    renderMediaValueFlag("logLevel", logLevel, renderDefaults.logLevel),
    renderMediaValueFlag("timeoutInMilliseconds", delayRenderTimeout, renderDefaults.delayRenderTimeout),
    renderMediaValueFlag("chromeMode", chromeMode, renderDefaults.chromeMode),
    valueFlag(options.glOption.cliFlag, gl, renderDefaults.openGlRenderer),
    valueFlag(options.userAgentOption.cliFlag, userAgent, renderDefaults.userAgent),
    renderMediaValueFlag("offthreadVideoCacheSizeInBytes", offthreadVideoCacheSizeInBytes, renderDefaults.offthreadVideoCacheSizeInBytes),
    renderMediaValueFlag("offthreadVideoThreads", offthreadVideoThreads, renderDefaults.offthreadVideoThreads),
    renderMediaValueFlag("mediaCacheSizeInBytes", mediaCacheSizeInBytes, renderDefaults.mediaCacheSizeInBytes)
  ]);
  if (headless !== renderDefaults.headless) {
    addFlagWithValue(flags, options.headlessOption.cliFlag, !headless);
  }
  addTrueBooleanFlagsIfChanged(flags, [
    booleanFlag(options.disableWebSecurityOption.cliFlag, disableWebSecurity, renderDefaults.disableWebSecurity),
    booleanFlag(options.ignoreCertificateErrorsOption.cliFlag, ignoreCertificateErrors, renderDefaults.ignoreCertificateErrors),
    booleanFlag(options.enableMultiprocessOnLinuxOption.cliFlag, multiProcessOnLinux, renderDefaults.multiProcessOnLinux),
    booleanFlag(options.darkModeOption.cliFlag, darkMode, renderDefaults.darkMode),
    booleanFlag(options.beepOnFinishOption.cliFlag, beepOnFinish, renderDefaults.beepOnFinish)
  ]);
  if (isStillRender) {
    addValueFlagsIfChanged(flags, [
      valueFlag(options.stillFrameOption.cliFlag, frame2, 0),
      valueFlag(options.stillImageFormatOption.cliFlag, stillImageFormat, renderDefaults.stillImageFormat),
      valueFlag(options.jpegQualityOption.cliFlag, jpegQuality, renderDefaults.jpegQuality)
    ]);
  } else {
    addValueFlagsIfChanged(flags, [
      valueFlag(options.concurrencyOption.cliFlag, concurrency, renderDefaults.concurrency)
    ]);
    if (isSequenceRender) {
      addBooleanFlag(flags, options.imageSequenceOption.cliFlag, true);
      if (sequenceImageFormat !== "jpeg") {
        addFlagWithValue(flags, options.videoImageFormatOption.cliFlag, sequenceImageFormat);
      }
    } else {
      addValueFlagsIfChanged(flags, [
        valueFlag(options.videoImageFormatOption.cliFlag, videoImageFormat, renderDefaults.videoImageFormat),
        renderMediaValueFlag("hardwareAcceleration", hardwareAcceleration, renderDefaults.hardwareAcceleration)
      ]);
    }
    if (hasCodecSpecificOptions && codec !== renderDefaults.codec) {
      addFlagWithValue(flags, getRenderMediaFlag("codec"), codec);
    }
    if (startFrame !== 0 || endFrame !== durationInFrames - 1) {
      addFlagWithValue(flags, options.framesOption.cliFlag, `${startFrame}-${endFrame}`);
    }
    if (hasCodecSpecificOptions) {
      addTrueBooleanFlagsIfChanged(flags, [
        renderMediaBooleanFlag("muted", muted, renderDefaults.muted),
        booleanFlag(options.enforceAudioOption.cliFlag, enforceAudioTrack, renderDefaults.enforceAudioTrack),
        renderMediaBooleanFlag("forSeamlessAacConcatenation", forSeamlessAacConcatenation, renderDefaults.forSeamlessAacConcatenation)
      ]);
      addValueFlagsIfChanged(flags, [
        valueFlag(options.pixelFormatOption.cliFlag, pixelFormat, renderDefaults.pixelFormat),
        renderMediaValueFlag("colorSpace", colorSpace, renderDefaults.colorSpace),
        valueFlag(options.proResProfileOption.cliFlag, proResProfile, renderDefaults.proResProfile),
        renderMediaValueFlag("x264Preset", x264Preset, renderDefaults.x264Preset),
        valueFlag(options.crfOption.cliFlag, crf, null),
        valueFlag(options.jpegQualityOption.cliFlag, jpegQuality, renderDefaults.jpegQuality),
        renderMediaValueFlag("videoBitrate", videoBitrate, renderDefaults.videoBitrate),
        renderMediaValueFlag("audioBitrate", audioBitrate, renderDefaults.audioBitrate),
        valueFlag(options.everyNthFrameOption.cliFlag, everyNthFrame, renderDefaults.everyNthFrame),
        renderMediaValueFlag("numberOfGifLoops", numberOfGifLoops, renderDefaults.numberOfGifLoops),
        renderMediaValueFlag("encodingBufferSize", encodingBufferSize, renderDefaults.encodingBufferSize),
        renderMediaValueFlag("encodingMaxRate", encodingMaxRate, renderDefaults.encodingMaxRate),
        renderMediaValueFlag("separateAudioTo", separateAudioTo, null)
      ]);
      const defaultAudioCodec = BrowserSafeApis.defaultAudioCodecs[codec]?.compressed;
      if (audioCodec !== defaultAudioCodec) {
        addFlagWithValue(flags, getRenderMediaFlag("audioCodec"), audioCodec);
      }
    }
    addTrueBooleanFlagsIfChanged(flags, [
      renderMediaBooleanFlag("disallowParallelEncoding", disallowParallelEncoding, false),
      renderMediaBooleanFlag("repro", repro, renderDefaults.repro)
    ]);
  }
  if (metadata) {
    for (const [key5, value] of Object.entries(metadata)) {
      addFlagWithValue(flags, options.metadataOption.cliFlag, `${key5}=${value}`);
    }
  }
  if (Object.keys(inputProps).length > 0) {
    addFlagWithValue(flags, options.propsOption.cliFlag, JSON.stringify(inputProps));
  }
  const envArgs = Object.entries(envVariables).sort(([a], [b]) => a.localeCompare(b)).map(([key5, value]) => shellQuote(`${key5}=${value}`));
  const renderCommand = [
    command,
    commandType,
    shellQuote(serveUrl),
    shellQuote(compositionId),
    shellQuote(trimDefaultOutPrefix(outName)),
    ...flags
  ].join(" ");
  if (envArgs.length === 0) {
    return renderCommand;
  }
  return ["env", ...envArgs, renderCommand].join(" ");
};

// src/helpers/render-modal-sections.ts
import { useMemo as useMemo128, useState as useState83 } from "react";
var useRenderModalSections = (renderMode, codec) => {
  const [selectedTab, setTab] = useState83("general");
  const shownTabs = useMemo128(() => {
    if (renderMode === "audio") {
      return ["general", "data", "audio", "advanced"];
    }
    if (renderMode === "still") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "sequence") {
      return ["general", "data", "picture", "advanced"];
    }
    if (renderMode === "video") {
      if (codec === "gif") {
        return ["general", "data", "picture", "gif", "advanced"];
      }
      return ["general", "data", "picture", "audio", "advanced"];
    }
    throw new TypeError("Unknown render mode");
  }, [codec, renderMode]);
  const tab = useMemo128(() => {
    if (!shownTabs.includes(selectedTab)) {
      return shownTabs[0];
    }
    return selectedTab;
  }, [selectedTab, shownTabs]);
  return useMemo128(() => {
    return { tab, setTab, shownTabs };
  }, [tab, shownTabs]);
};

// src/icons/audio.tsx
import { jsx as jsx240 } from "react/jsx-runtime";
var AudioIcon = (props) => /* @__PURE__ */ jsx240("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx240("path", {
    fill: "currentcolor",
    d: "M243 32.32C105.5 39.15 0 157.8 0 295.5v120.4C0 451.3 28.63 480 64 480h32c17.62 0 32-14.38 32-32V288c0-17.62-14.38-32-32-32H64c-10.79 0-20.8 2.9-29.72 7.7 14.2-106.8 100.5-193.9 210.4-199.4 120.5-5.965 221.7 83.92 234 199.9-9.08-5.1-19.48-8.2-30.68-8.2h-32c-17.62 0-32 14.38-32 32v160c0 17.62 14.38 32 32 32h32c35.38 0 64-28.75 64-64.13V287.9c0-145.4-122-262.88-269-255.58zM64 288h32v160H64c-17.62 0-32-14.5-32-32.13v-95.75C32 302.5 46.38 288 64 288zm416 127.9c0 17.6-14.4 32.1-32 32.1h-32V288h32c17.62 0 32 14.5 32 32.13v95.77z"
  })
});

// src/icons/data.tsx
import { jsx as jsx241 } from "react/jsx-runtime";
var DataIcon = (props) => {
  return /* @__PURE__ */ jsx241("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ...props,
    children: /* @__PURE__ */ jsx241("path", {
      fill: "currentcolor",
      d: "M224 512C100.3 512 0 476.2 0 432V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80V432C448 476.2 347.7 512 224 512zM416 80.45C415.7 79.69 414.4 77.27 409.8 73.31C402.4 67.11 389.9 60.09 371.6 53.57C335.4 40.62 283.2 32 224 32C164.8 32 112.6 40.62 76.37 53.57C58.1 60.09 45.59 67.11 38.25 73.31C33.55 77.27 32.29 79.69 32 80.45V182.1C46.47 192.7 69.9 202.8 100.9 210.4C135.5 218.9 177.1 224 224 224C270 224 312.5 218.9 347.1 210.4C378.1 202.8 401.5 192.7 416 182.1V80.45zM416 219.5C398.8 228.4 377.9 235.8 354.8 241.5C317.3 250.7 272.2 256 224 256C175.8 256 130.7 250.7 93.22 241.5C70.11 235.8 49.18 228.4 32 219.5V310.1C46.47 320.7 69.9 330.8 100.9 338.4C135.5 346.9 177.1 352 224 352C270 352 312.5 346.9 347.1 338.4C378.1 330.8 401.5 320.7 416 310.1V219.5zM38.25 438.7C45.59 444.9 58.1 451.9 76.37 458.4C112.6 471.4 164.8 480 224 480C283.2 480 335.4 471.4 371.6 458.4C389.9 451.9 402.4 444.9 409.8 438.7C414.4 434.7 415.7 432.3 416 431.6V347.5C398.8 356.4 377.9 363.8 354.8 369.5C317.3 378.7 272.2 384 224 384C175.8 384 130.7 378.7 93.22 369.5C70.11 363.8 49.18 356.4 32 347.5V431.6C32.29 432.3 33.55 434.7 38.25 438.7zM416 431.4C416.1 431.3 416.1 431.3 416.1 431.3L416 431.4zM31.96 431.4C31.94 431.3 31.93 431.3 31.92 431.3L31.96 431.4zM31.96 80.56C31.93 80.65 31.92 80.7 31.92 80.7L31.96 80.56zM416.1 80.7C416.1 80.7 416.1 80.65 416 80.56z"
    })
  });
};

// src/icons/frame.tsx
import { jsx as jsx242 } from "react/jsx-runtime";
var PicIcon = (props) => /* @__PURE__ */ jsx242("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx242("path", {
    fill: "currentcolor",
    d: "M324.9 157.8c-11.38-17.38-39.89-17.31-51.23-.063L200.5 268.5l-16.4-22.6c-11.4-16.8-38.2-16-49.7 0l-64.52 89.16c-6.797 9.406-7.75 21.72-2.547 32C72.53 377.5 83.05 384 94.75 384h322.5c11.41 0 21.8-6.281 27.14-16.38a30.922 30.922 0 0 0-1.516-31.56L324.9 157.8zM95.8 352l62.39-87.38 29.91 41.34c3.1 4.24 8.3 7.24 13.3 6.64 5.25-.125 10.12-2.781 13.02-7.188l83.83-129.9L415 352H95.8zM447.1 32h-384C28.65 32-.01 60.65-.01 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96c.01-35.35-27.79-64-63.99-64zM480 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h384c17.64 0 32 14.36 32 32v320zM144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-64c8.822 0 15.1 7.178 15.1 16s-6.3 16-15.1 16-16-7.2-16-16 7.2-16 16-16z"
  })
});

// src/icons/gear.tsx
import { jsx as jsx243 } from "react/jsx-runtime";
var GearIcon = (props) => /* @__PURE__ */ jsx243("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx243("path", {
    fill: "currentcolor",
    d: "M168 255.1c0-47.7 39.4-88 88-88s88 40.3 88 88c0 49.5-39.4 88.9-88 88.9s-88-39.4-88-88.9zm88-56c-30.9 0-56 26-56 56 0 31.8 25.1 56 56 56s56-24.2 56-56c0-30-25.1-56-56-56zM65.67 230.6l-40.33-36.8c-11.12-10.1-13.68-26.6-6.16-39.6l30.24-52.4c7.52-13.02 23.09-19.05 37.42-14.48l51.96 16.58c13.4-10.34 28.2-18.94 44-25.47l11.7-53.27C197.7 10.47 210.7 0 225.8 0h60.4c15.1 0 28.1 10.47 31.3 25.16l11.7 53.27c14.9 6.53 30.6 15.13 44 25.47l52-16.58c14.3-4.57 29.9 1.46 37.4 14.48l30.2 52.4c7.5 13 5 29.5-6.1 39.6l-40.4 36.8c1.1 8.3 1.7 16.8 1.7 24.5 0 9.5-.6 18-1.7 26.3l40.4 36.8c11.1 10.1 13.6 26.6 6.1 39.6l-30.2 52.4c-7.5 13-23.1 19-37.4 14.5l-52-16.6c-13.4 10.3-29.1 18.9-44 25.5l-11.7 53.2c-3.2 14.7-16.2 25.2-31.3 25.2h-60.4c-15.1 0-28.1-10.5-31.3-25.2l-11.7-53.2c-15.8-6.6-30.6-15.2-44-25.5l-51.96 16.6c-14.33 4.5-29.9-1.5-37.42-14.5l-30.24-52.4c-7.52-13-4.96-29.5 6.16-39.6l40.33-36.8c-1.1-8.3-1.67-16.8-1.67-26.3 0-7.7.57-16.2 1.67-24.5zm92.73-101.4-13.3 10.3-67.97-21.7-30.24 52.4 52.69 48-2.19 16.6c-.92 6.9-1.39 14-1.39 20.3 0 8.1.47 15.2 1.39 22.1l2.19 16.6-52.69 48 30.24 52.4 67.97-21.7 13.3 10.3c11.1 8.6 23.5 15.8 36.6 20.3l15.5 7.3 15.3 69.6h60.4l15.3-69.6 14.6-7.3c14-4.5 26.4-11.7 37.5-20.3l13.3-10.3 68 21.7 30.2-52.4-52.7-48 2.2-16.6c.9-6.9 1.4-14 1.4-21.2 0-7.2-.5-14.3-1.4-21.2l-2.2-16.6 52.7-48-30.2-52.4-68 21.7-13.3-10.3c-11.1-8.6-23.5-15.8-37.5-21.2l-14.6-6.4L286.2 32h-60.4l-15.3 69.6L195 108c-13.1 5.4-25.5 12.6-36.6 21.2z"
  })
});

// src/icons/gif.tsx
import { jsx as jsx244 } from "react/jsx-runtime";
var GifIcon = (props) => /* @__PURE__ */ jsx244("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props,
  children: /* @__PURE__ */ jsx244("path", {
    fill: "currentcolor",
    d: "M512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96c0-35.35-28.7-64-64-64zm32 384c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h448c17.64 0 32 14.36 32 32v320zm-80-256h-96c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16v-64h56c8.844 0 16-7.156 16-16s-7.156-16-16-16h-56v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-160 0c-8.8 0-16 7.2-16 16v160c0 8.844 7.156 16 16 16s16-7.156 16-16V176c0-8.8-7.2-16-16-16zm-64 80h-64c-8.8 0-16 7.2-16 16s7.156 16 16 16h48v33.45c-24.83 19.91-69.13 18.16-91.48-4.203-24.95-24.95-24.95-65.55 0-90.5 25.03-25 64.19-25 89.22 0 6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62c-37.69-37.72-96.78-37.72-134.5 0-37.42 37.42-37.42 98.33 0 135.8C127.8 341.8 153.5 352 180.6 352c27.06 0 52.84-10.25 70.7-28.12 3-2.98 4.7-7.08 4.7-11.28V256c0-8.8-7.2-16-16-16z"
  })
});

// src/components/Tabs/vertical.tsx
import { useCallback as useCallback119, useMemo as useMemo129, useState as useState84 } from "react";
import { jsx as jsx245 } from "react/jsx-runtime";
var selectorButton2 = {
  border: "none",
  flex: 1,
  padding: 8,
  paddingLeft: 16,
  display: "flex",
  flexDirection: "row",
  fontSize: 14,
  color: "inherit",
  alignItems: "center",
  userSelect: "none",
  WebkitUserSelect: "none"
};
var VerticalTab = ({ children, onClick, style: style12, selected }) => {
  const [hovered, setHovered] = useState84(false);
  const { tabIndex } = useZIndex();
  const onPointerEnter = useCallback119(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback119(() => {
    setHovered(false);
  }, []);
  const definiteStyle = useMemo129(() => {
    return {
      ...selectorButton2,
      backgroundColor: selected ? SELECTED_BACKGROUND : hovered ? CLEAR_HOVER : "transparent",
      color: selected ? "white" : LIGHT_TEXT,
      boxShadow: selected ? "none" : undefined,
      ...style12
    };
  }, [hovered, selected, style12]);
  return /* @__PURE__ */ jsx245("button", {
    style: definiteStyle,
    type: "button",
    onClick,
    tabIndex,
    onPointerLeave,
    onPointerEnter,
    children
  });
};

// src/components/RenderModal/CrfSetting.tsx
import { BrowserSafeApis as BrowserSafeApis3 } from "@remotion/renderer/client";
import { useState as useState86 } from "react";

// src/components/RenderModal/NumberSetting.tsx
import { useCallback as useCallback121 } from "react";

// src/components/RenderModal/OptionExplainerBubble.tsx
import { BrowserSafeApis as BrowserSafeApis2 } from "@remotion/renderer/client";

// src/components/RenderModal/CliCopyButton.tsx
import { useCallback as useCallback120, useEffect as useEffect83, useMemo as useMemo130, useState as useState85 } from "react";
import { jsx as jsx246 } from "react/jsx-runtime";
var svgStyle2 = {
  width: 16,
  height: 16,
  verticalAlign: "sub"
};
var copiedStyle = {
  fontSize: "14px",
  minHeight: "30px",
  minWidth: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var buttonStyle6 = {
  width: "30px",
  height: "30px",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var CliCopyButton = ({
  valueToCopy
}) => {
  const [copied, setCopied] = useState85(false);
  const [hovered, setHovered] = useState85(false);
  const fillColor = useMemo130(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const clipboardIcon = /* @__PURE__ */ jsx246(ClipboardIcon, {
    color: fillColor,
    style: svgStyle2
  });
  const checkSvg = /* @__PURE__ */ jsx246("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    style: svgStyle2,
    children: /* @__PURE__ */ jsx246("path", {
      fill: fillColor,
      d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    })
  });
  const onPointerEnter = useCallback120(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback120(() => {
    setHovered(false);
  }, []);
  useEffect83(() => {
    if (!copied) {
      return;
    }
    const handleClear = () => {
      setCopied(false);
      setHovered(false);
    };
    const to = setTimeout(() => handleClear(), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return copied ? /* @__PURE__ */ jsx246("span", {
    style: copiedStyle,
    children: checkSvg
  }) : /* @__PURE__ */ jsx246("button", {
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle6,
    onClick: () => {
      navigator.clipboard.writeText(valueToCopy);
      setCopied(true);
    },
    children: clipboardIcon
  });
};

// src/components/RenderModal/OptionExplainer.tsx
import { jsx as jsx247, jsxs as jsxs123, Fragment as Fragment38 } from "react/jsx-runtime";
var container53 = {
  fontSize: 14,
  paddingTop: 10,
  paddingBottom: 10,
  backgroundColor: INPUT_BACKGROUND
};
var padding3 = {
  paddingLeft: 20,
  paddingRight: 20
};
var title6 = {
  fontSize: 14
};
var description = {
  fontSize: 14,
  maxWidth: 400
};
var link2 = {
  fontSize: 14,
  maxWidth: 200,
  color: "#0b84f3",
  wordWrap: "break-word",
  textDecoration: "none"
};
var infoRow = {
  ...padding3,
  fontSize: 14,
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var infoRowLabel = {
  width: 150,
  fontSize: 14,
  color: "white"
};
var flexSpacer = {
  display: "flex",
  flex: 1
};
var copyWrapper = {
  display: "flex",
  justifyContent: "flex-end"
};
var OptionExplainer = ({ option }) => {
  return /* @__PURE__ */ jsxs123("div", {
    style: container53,
    className: "__remotion-info-button-container",
    children: [
      /* @__PURE__ */ jsxs123("div", {
        style: padding3,
        children: [
          /* @__PURE__ */ jsxs123("div", {
            children: [
              /* @__PURE__ */ jsx247("strong", {
                style: title6,
                children: option.name
              }),
              option.docLink ? /* @__PURE__ */ jsxs123(Fragment38, {
                children: [
                  /* @__PURE__ */ jsx247(Spacing, {
                    x: 1
                  }),
                  /* @__PURE__ */ jsx247("a", {
                    style: link2,
                    href: option.docLink,
                    target: "_blank",
                    children: "Docs"
                  })
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx247("div", {
            style: description,
            children: option.description("ssr")
          })
        ]
      }),
      /* @__PURE__ */ jsx247(Spacing, {
        y: 0.5,
        block: true
      }),
      /* @__PURE__ */ jsx247(MenuDivider, {}),
      /* @__PURE__ */ jsx247(Spacing, {
        y: 0.5,
        block: true
      }),
      /* @__PURE__ */ jsxs123("div", {
        children: [
          /* @__PURE__ */ jsxs123("div", {
            style: infoRow,
            children: [
              /* @__PURE__ */ jsx247("div", {
                style: infoRowLabel,
                children: "CLI flag"
              }),
              /* @__PURE__ */ jsx247("div", {
                style: flexSpacer
              }),
              /* @__PURE__ */ jsxs123("code", {
                children: [
                  "--",
                  option.cliFlag
                ]
              }),
              /* @__PURE__ */ jsx247("div", {
                style: copyWrapper,
                children: /* @__PURE__ */ jsx247(CliCopyButton, {
                  valueToCopy: option.cliFlag
                })
              })
            ]
          }),
          option.ssrName ? /* @__PURE__ */ jsxs123("div", {
            style: infoRow,
            children: [
              /* @__PURE__ */ jsx247("div", {
                style: infoRowLabel,
                children: "Node.JS option"
              }),
              /* @__PURE__ */ jsx247("div", {
                style: flexSpacer
              }),
              /* @__PURE__ */ jsx247("code", {
                children: option.ssrName
              }),
              /* @__PURE__ */ jsx247(Spacing, {
                x: 3.75
              })
            ]
          }) : null,
          /* @__PURE__ */ jsx247("div", {
            style: infoRow
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/OptionExplainerBubble.tsx
import { jsx as jsx248 } from "react/jsx-runtime";
var OptionExplainerBubble = ({ id }) => {
  const option = BrowserSafeApis2.options[id];
  return /* @__PURE__ */ jsx248(InfoBubble, {
    title: "Learn more about this option",
    children: /* @__PURE__ */ jsx248(OptionExplainer, {
      option
    })
  });
};

// src/components/RenderModal/NumberSetting.tsx
import { jsx as jsx249, jsxs as jsxs124, Fragment as Fragment39 } from "react/jsx-runtime";
var NumberSetting = ({ name, value, step, hint, onValueChanged, max, min, formatter }) => {
  const onTextChanged = useCallback121((e) => {
    onValueChanged((q) => {
      const newSetting = step < 1 ? parseFloat(e) : parseInt(e, 10);
      if (Number.isNaN(newSetting)) {
        return q;
      }
      return Math.min(max ?? Infinity, Math.max(newSetting, min));
    });
  }, [max, min, onValueChanged, step]);
  const onValueChange = useCallback121((newConcurrency) => {
    onValueChanged(newConcurrency);
  }, [onValueChanged]);
  return /* @__PURE__ */ jsxs124("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs124("div", {
        style: label5,
        children: [
          name,
          hint ? /* @__PURE__ */ jsxs124(Fragment39, {
            children: [
              /* @__PURE__ */ jsx249(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx249(OptionExplainerBubble, {
                id: hint
              })
            ]
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx249("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx249(RightAlignInput, {
          children: /* @__PURE__ */ jsx249(InputDragger, {
            value,
            name: name.toLowerCase(),
            onTextChange: onTextChanged,
            onValueChange,
            step,
            placeholder: [min, max].map((f) => f !== null && f !== undefined ? f : "").join("-"),
            min,
            max,
            formatter,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/CrfSetting.tsx
import { jsx as jsx250 } from "react/jsx-runtime";
var getDefaultCrfState = () => {
  return BrowserSafeApis3.validCodecs.map((c) => {
    return [c, BrowserSafeApis3.getDefaultCrfForCodec(c)];
  }).reduce((acc, [codec, crf]) => {
    return {
      ...acc,
      [codec]: crf
    };
  }, {});
};
var useCrfState = (codec) => {
  const [state, setState] = useState86(() => getDefaultCrfState());
  const range = BrowserSafeApis3.getValidCrfRanges(codec);
  const setCrf = (updater) => {
    setState((q) => {
      const val = q[codec];
      if (val === null) {
        throw new TypeError(`Got unexpected codec "${codec}"`);
      }
      return {
        ...q,
        [codec]: typeof updater === "number" ? updater : updater(val)
      };
    });
  };
  return {
    crf: state[codec],
    setCrf,
    minCrf: range[0],
    maxCrf: range[1]
  };
};
var CrfSetting = ({ crf, setCrf, min, max, option }) => {
  return /* @__PURE__ */ jsx250(NumberSetting, {
    min,
    max,
    name: "CRF",
    onValueChanged: setCrf,
    value: crf,
    step: 1,
    hint: option
  });
};

// src/components/RenderModal/get-default-codecs.ts
import { BrowserSafeApis as BrowserSafeApis4 } from "@remotion/renderer/client";
import { NoReactAPIs } from "@remotion/renderer/pure";
var getDefaultCodecs = ({
  defaultConfigurationVideoCodec,
  compositionDefaultVideoCodec,
  renderType,
  defaultConfigurationAudioCodec
}) => {
  const userPreferredVideoCodec = compositionDefaultVideoCodec ?? defaultConfigurationVideoCodec ?? "h264";
  const userPreferredVideoCodecForAudioTab = userPreferredVideoCodec === "aac" ? "aac" : userPreferredVideoCodec === "mp3" ? "mp3" : userPreferredVideoCodec === "wav" ? "wav" : defaultConfigurationAudioCodec === "pcm-16" ? "wav" : defaultConfigurationAudioCodec === "mp3" ? "mp3" : "aac";
  const isVideoCodecAnAudioCodec = NoReactAPIs.isAudioCodec(userPreferredVideoCodec);
  if (isVideoCodecAnAudioCodec) {
    return {
      initialAudioCodec: null,
      initialRenderType: "audio",
      initialVideoCodec: userPreferredVideoCodec,
      initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
      initialVideoCodecForVideoTab: NoReactAPIs.isAudioCodec(defaultConfigurationVideoCodec) ? "h264" : defaultConfigurationVideoCodec
    };
  }
  const suitableAudioCodecForVideoCodec = BrowserSafeApis4.defaultAudioCodecs[userPreferredVideoCodec].compressed;
  return {
    initialAudioCodec: defaultConfigurationAudioCodec ?? suitableAudioCodecForVideoCodec,
    initialVideoCodec: userPreferredVideoCodec,
    initialRenderType: renderType,
    initialVideoCodecForAudioTab: userPreferredVideoCodecForAudioTab,
    initialVideoCodecForVideoTab: userPreferredVideoCodec
  };
};

// src/components/RenderModal/get-string-before-suffix.ts
var getStringBeforeSuffix = (fileName) => {
  const dotPos = fileName.lastIndexOf(".");
  if (dotPos === -1) {
    return fileName;
  }
  return fileName.substring(0, dotPos);
};

// src/components/RenderModal/out-name-checker.ts
import { BrowserSafeApis as BrowserSafeApis5 } from "@remotion/renderer/client";
var invalidCharacters = ["?", "*", "+", ":", "%"];
var isValidStillExtension = (extension, stillImageFormat) => {
  if (stillImageFormat === "jpeg" && extension === "jpg") {
    return true;
  }
  return extension === stillImageFormat;
};
var validateOutnameGui = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  try {
    isValidOutName({
      audioCodec,
      codec,
      outName,
      renderMode,
      stillImageFormat,
      separateAudioTo
    });
    return { valid: true };
  } catch (err) {
    return { valid: false, error: err };
  }
};
var isValidOutName = ({
  outName,
  codec,
  audioCodec,
  renderMode,
  stillImageFormat,
  separateAudioTo
}) => {
  const extension = outName.substring(outName.lastIndexOf(".") + 1);
  const prefix = outName.substring(0, outName.lastIndexOf("."));
  const map = BrowserSafeApis5.defaultFileExtensionMap[codec];
  if (BrowserSafeApis5.supportedAudioCodecs[codec].length > 0 && !(audioCodec in map.forAudioCodec)) {
    throw new Error(`Audio codec ${audioCodec} is not supported for codec ${codec}`);
  }
  const hasDotAfterSlash = () => {
    const substrings = prefix.split("/");
    for (const str of substrings) {
      if (str[0] === ".") {
        return true;
      }
    }
    return false;
  };
  const hasInvalidChar = () => {
    return prefix.split("").some((char) => invalidCharacters.includes(char));
  };
  if (renderMode === "video" || renderMode === "audio") {
    BrowserSafeApis5.validateOutputFilename({
      codec,
      audioCodecSetting: audioCodec ?? null,
      extension,
      preferLossless: false,
      separateAudioTo
    });
  }
  if (prefix.length < 1 && renderMode !== "sequence") {
    throw new Error("The prefix must be at least 1 character long");
  }
  if (prefix[0] === "." || hasDotAfterSlash()) {
    throw new Error("The output name must not start with a dot");
  }
  if (hasInvalidChar()) {
    throw new Error("Filename can't contain the following characters:  ?, *, +, %, :");
  }
  if (renderMode === "still" && stillImageFormat && !isValidStillExtension(extension, stillImageFormat)) {
    throw new Error(`The extension ${extension} is not supported for still image format ${stillImageFormat}`);
  }
  if (renderMode === "sequence") {
    if (outName.includes(".")) {
      throw new Error("Folder names must not contain a dot");
    }
  }
};

// src/components/RenderModal/render-modals.ts
var outerModalStyle = {
  width: getMaxModalWidth(1000),
  height: getMaxModalHeight(640),
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
};
var container54 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "12px 16px",
  borderBottom: "1px solid black"
};
var optionsPanel = {
  display: "flex",
  width: "100%"
};
var horizontalLayout = {
  display: "flex",
  flexDirection: "row",
  overflowY: "auto",
  flex: 1
};
var leftSidebar = {
  padding: 12
};
var horizontalTab = {
  width: 250,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  textAlign: "left",
  fontSize: 16,
  fontWeight: "bold",
  paddingLeft: 15,
  paddingTop: 12,
  paddingBottom: 12
};
var iconContainer = {
  width: 20,
  height: 20,
  marginRight: 15,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center"
};
var icon6 = {
  color: "currentcolor",
  height: 20
};
var buttonStyle7 = {
  backgroundColor: BLUE,
  color: "white"
};
var flexer = {
  flex: 1
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import { BrowserSafeApis as BrowserSafeApis6 } from "@remotion/renderer/client";
import { useCallback as useCallback125, useMemo as useMemo131 } from "react";

// src/helpers/presets-labels.ts
var labelx264Preset = (profile) => {
  if (profile === "ultrafast") {
    return "ultrafast";
  }
  if (profile === "superfast") {
    return "superfast";
  }
  if (profile === "veryfast") {
    return "veryfast";
  }
  if (profile === "faster") {
    return "faster";
  }
  if (profile === "fast") {
    return "fast";
  }
  if (profile === "medium") {
    return "medium";
  }
  if (profile === "slow") {
    return "slow";
  }
  if (profile === "slower") {
    return "slower";
  }
  if (profile === "veryslow") {
    return "veryslow";
  }
  if (profile === "placebo") {
    return "placebo";
  }
  throw new TypeError(`Unknown x264 preset: ${profile}`);
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import { useCallback as useCallback124 } from "react";

// src/components/RenderModal/EnvInput.tsx
import React167, { useCallback as useCallback123 } from "react";

// src/components/RenderModal/InlineEyeIcon.tsx
import { useCallback as useCallback122 } from "react";
import { jsx as jsx251 } from "react/jsx-runtime";
var clearIcon2 = {
  height: 14,
  color: "currentColor"
};
var InlineEyeButton = ({ onClick, enabled }) => {
  const renderAction = useCallback122((color) => {
    return enabled ? /* @__PURE__ */ jsx251("svg", {
      style: clearIcon2,
      viewBox: "0 0 640 512",
      children: /* @__PURE__ */ jsx251("path", {
        fill: color,
        d: "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM605.5 268.3c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72C106.1 336 77.3 288 64 256c9.2-22.1 25.9-52 49.5-81.5L88.4 154.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
      })
    }) : /* @__PURE__ */ jsx251("svg", {
      style: clearIcon2,
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ jsx251("path", {
        fill: color,
        d: "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
      })
    });
  }, [enabled]);
  return /* @__PURE__ */ jsx251(InlineAction, {
    renderAction,
    onClick
  });
};

// src/components/RenderModal/EnvInput.tsx
import { jsx as jsx252, jsxs as jsxs125, Fragment as Fragment40 } from "react/jsx-runtime";
var input3 = {
  flex: 1,
  width: "100%"
};
var validationStyle = {
  paddingLeft: optionRow.paddingLeft,
  paddingRight: optionRow.paddingRight
};
var EnvInput = ({
  onEnvKeyChange,
  onEnvValChange,
  envKey,
  envVal,
  onDelete,
  index,
  autoFocus,
  isDuplicate
}) => {
  const [showInPlainText, setShowInPlainText] = React167.useState(false);
  const [initialWarningKeyMissing, setKeyWarningEligible] = React167.useState(() => {
    return envKey.trim() === "" && envVal.trim() !== "";
  });
  const [initialWarningValMissing, setValueWarningEligible] = React167.useState(() => {
    return envKey.trim() !== "" && envVal.trim() === "";
  });
  const isKeyMissing = envKey.trim() === "" && initialWarningKeyMissing && envVal.trim() !== "";
  const isValMissing = envVal.trim() === "" && initialWarningValMissing && envKey.trim() !== "";
  const handleDelete = useCallback123(() => {
    onDelete(index);
  }, [index, onDelete]);
  const togglePlainText = useCallback123(() => {
    setShowInPlainText((prev) => !prev);
  }, []);
  const handleKeyChange = useCallback123((e) => {
    onEnvKeyChange(index, e.target.value);
  }, [index, onEnvKeyChange]);
  const handleValueChange = useCallback123((e) => {
    onEnvValChange(index, e.target.value);
  }, [index, onEnvValChange]);
  const makeKeyWarningEligible = useCallback123(() => {
    setKeyWarningEligible(true);
  }, []);
  const makeValueWarningEligible = useCallback123(() => {
    setValueWarningEligible(true);
  }, []);
  const isNodeEnvKey = envKey.trim() === "NODE_ENV";
  return /* @__PURE__ */ jsxs125(Fragment40, {
    children: [
      /* @__PURE__ */ jsxs125(Row, {
        align: "center",
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx252(RemotionInput, {
            status: isNodeEnvKey || isDuplicate || isKeyMissing ? "warning" : "ok",
            type: "text",
            placeholder: "Key",
            style: input3,
            value: envKey,
            onBlur: makeKeyWarningEligible,
            autoFocus,
            onChange: handleKeyChange,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx252(Spacing, {
            x: 1
          }),
          /* @__PURE__ */ jsx252(RemotionInput, {
            status: isValMissing ? "warning" : "ok",
            placeholder: "Value",
            type: showInPlainText ? "text" : "password",
            style: input3,
            value: envVal,
            onBlur: makeValueWarningEligible,
            onChange: handleValueChange,
            rightAlign: false
          }),
          /* @__PURE__ */ jsx252(Spacing, {
            x: 1.5
          }),
          /* @__PURE__ */ jsx252(InlineEyeButton, {
            enabled: !showInPlainText,
            onClick: togglePlainText
          }),
          /* @__PURE__ */ jsx252(InlineRemoveButton, {
            onClick: handleDelete
          })
        ]
      }),
      isNodeEnvKey ? /* @__PURE__ */ jsx252("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx252(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "NODE_ENV will be overwritten by Remotion during the render process."
        })
      }) : null,
      isDuplicate ? /* @__PURE__ */ jsx252("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx252(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: `${envKey.toUpperCase()} is already defined.`
        })
      }) : null,
      isKeyMissing ? /* @__PURE__ */ jsx252("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx252(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Key is missing."
        })
      }) : null,
      isValMissing ? /* @__PURE__ */ jsx252("div", {
        style: validationStyle,
        children: /* @__PURE__ */ jsx252(ValidationMessage, {
          align: "flex-start",
          type: "warning",
          message: "Value is missing."
        })
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalEnvironmentVariables.tsx
import { jsx as jsx253, jsxs as jsxs126 } from "react/jsx-runtime";
var title7 = {
  fontSize: 14,
  fontWeight: "bold",
  color: LIGHT_TEXT,
  marginLeft: 16
};
var container55 = {
  marginTop: 20
};
var button3 = {
  marginLeft: 16
};
var RenderModalEnvironmentVariables = ({ envVariables, setEnvVariables }) => {
  const onEnvValChange = useCallback124((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][1] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onEnvKeyChange = useCallback124((index, value) => {
    setEnvVariables((oldEnv) => {
      const newEnv = [...oldEnv];
      newEnv[index][0] = value;
      return newEnv;
    });
  }, [setEnvVariables]);
  const onDelete = useCallback124((index) => {
    setEnvVariables((oldEnv) => oldEnv.filter((_, idx) => idx !== index));
  }, [setEnvVariables]);
  const addField = useCallback124(() => {
    setEnvVariables((oldEnv) => [...oldEnv, ["", ""]]);
  }, [setEnvVariables]);
  const usedKeys = [];
  return /* @__PURE__ */ jsxs126("div", {
    style: container55,
    children: [
      /* @__PURE__ */ jsx253("strong", {
        style: title7,
        children: "Environment variables"
      }),
      envVariables.map((env, i) => {
        let isDuplicate = false;
        if (usedKeys.includes(env[0].toUpperCase())) {
          isDuplicate = true;
        }
        usedKeys.push(env[0].toUpperCase());
        return /* @__PURE__ */ jsx253(EnvInput, {
          onEnvKeyChange,
          onEnvValChange,
          envKey: env[0],
          envVal: env[1],
          onDelete,
          index: i,
          isDuplicate,
          autoFocus: i === envVariables.length - 1 && env[0] === ""
        }, i);
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        y: 1,
        block: true
      }),
      /* @__PURE__ */ jsx253(Button, {
        style: button3,
        onClick: addField,
        children: "+ Add env variable"
      }),
      /* @__PURE__ */ jsx253(Spacing, {
        y: 1,
        block: true
      })
    ]
  });
};

// src/components/RenderModal/RenderModalHr.tsx
import { jsx as jsx254 } from "react/jsx-runtime";
var hrStyle = {
  margin: "0 0 0 0",
  padding: "0 0 0 0",
  border: "none",
  borderTop: "1px solid #000",
  marginRight: 16,
  marginLeft: 16,
  marginTop: 8,
  marginBottom: 8
};
var RenderModalHr = () => {
  return /* @__PURE__ */ jsx254("div", {
    style: hrStyle
  });
};

// src/components/RenderModal/RenderModalAdvanced.tsx
import { jsx as jsx255, jsxs as jsxs127 } from "react/jsx-runtime";
var container56 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAdvanced = ({
  renderMode,
  maxConcurrency,
  minConcurrency,
  setConcurrency,
  concurrency,
  delayRenderTimeout,
  setDelayRenderTimeout,
  disallowParallelEncoding,
  setDisallowParallelEncoding,
  setDisableWebSecurity,
  setIgnoreCertificateErrors,
  setHeadless,
  headless,
  ignoreCertificateErrors,
  disableWebSecurity,
  openGlOption,
  setOpenGlOption,
  setEnvVariables,
  envVariables,
  setx264Preset,
  x264Preset,
  codec,
  setMediaCacheSizeInBytes,
  mediaCacheSizeInBytes,
  offthreadVideoCacheSizeInBytes,
  setOffthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  setOffthreadVideoThreads,
  enableMultiProcessOnLinux,
  setChromiumMultiProcessOnLinux,
  setUserAgent,
  userAgent,
  beep,
  setBeep,
  repro,
  setRepro,
  hardwareAcceleration,
  chromeModeOption,
  setChromeModeOption,
  setHardwareAcceleration,
  darkMode,
  setDarkMode
}) => {
  const extendedOpenGlOptions = useMemo131(() => {
    return [
      "angle",
      "egl",
      "swangle",
      "swiftshader",
      "vulkan",
      "angle-egl",
      "default"
    ];
  }, []);
  const toggleCustomMediaCacheSizeInBytes = useCallback125(() => {
    setMediaCacheSizeInBytes((previous) => {
      if (previous === null) {
        return 1000 * 1000 * 1000;
      }
      return null;
    });
  }, [setMediaCacheSizeInBytes]);
  const toggleCustomOffthreadVideoCacheSizeInBytes = useCallback125(() => {
    setOffthreadVideoCacheSizeInBytes((previous) => {
      if (previous === null) {
        return 512 * 1024 * 1024;
      }
      return null;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  const toggleCustomOffthreadVideoThreads = useCallback125(() => {
    setOffthreadVideoThreads((previous) => {
      if (previous === null) {
        return 2;
      }
      return null;
    });
  }, [setOffthreadVideoThreads]);
  const toggleCustomUserAgent = useCallback125(() => {
    setUserAgent((previous) => {
      if (previous === null) {
        return "Mozilla/5.0 (Remotion)";
      }
      return null;
    });
  }, [setUserAgent]);
  const onDisallowParallelEncodingChanged = useCallback125((e) => {
    setDisallowParallelEncoding(e.target.checked);
  }, [setDisallowParallelEncoding]);
  const onDisableWebSecurityChanged = useCallback125((e) => {
    setDisableWebSecurity(e.target.checked);
  }, [setDisableWebSecurity]);
  const onEnableMultiProcessOnLinux = useCallback125((e) => {
    setChromiumMultiProcessOnLinux(e.target.checked);
  }, [setChromiumMultiProcessOnLinux]);
  const onIgnoreCertificatErrors = useCallback125((e) => {
    setIgnoreCertificateErrors(e.target.checked);
  }, [setIgnoreCertificateErrors]);
  const onHeadless = useCallback125((e) => {
    setHeadless(e.target.checked);
  }, [setHeadless]);
  const onUserAgentChanged = useCallback125((e) => {
    setUserAgent(e.target.value);
  }, [setUserAgent]);
  const onDarkMode = useCallback125((e) => {
    setDarkMode(e.target.checked);
  }, [setDarkMode]);
  const onPlayBeepSound = useCallback125((e) => {
    setBeep(e.target.checked);
  }, [setBeep]);
  const onReproToggle = useCallback125((e) => {
    setRepro(e.target.checked);
  }, [setRepro]);
  const openGlOptions = useMemo131(() => {
    return extendedOpenGlOptions.map((option) => {
      return {
        label: option === "default" ? "Default" : option,
        onClick: () => setOpenGlOption(option),
        key: option,
        leftItem: openGlOption === option ? /* @__PURE__ */ jsx255(Checkmark, {}) : null,
        id: option,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [extendedOpenGlOptions, openGlOption, setOpenGlOption]);
  const chromeModeOptions = useMemo131(() => {
    return BrowserSafeApis6.validChromeModeOptions.map((option) => {
      return {
        label: option,
        onClick: () => setChromeModeOption(option),
        key: option,
        leftItem: chromeModeOption === option ? /* @__PURE__ */ jsx255(Checkmark, {}) : null,
        id: option,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [chromeModeOption, setChromeModeOption]);
  const x264PresetOptions = useMemo131(() => {
    return BrowserSafeApis6.x264PresetOptions.map((option) => {
      return {
        label: labelx264Preset(option),
        onClick: () => setx264Preset(option),
        key: option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: x264Preset === option ? /* @__PURE__ */ jsx255(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [setx264Preset, x264Preset]);
  const hardwareAccelerationValues = useMemo131(() => {
    return BrowserSafeApis6.hardwareAccelerationOptions.map((option) => {
      return {
        label: option,
        onClick: () => setHardwareAcceleration(option),
        leftItem: hardwareAcceleration === option ? /* @__PURE__ */ jsx255(Checkmark, {}) : null,
        subMenu: null,
        quickSwitcherLabel: null,
        type: "item",
        id: option,
        keyHint: null,
        value: option
      };
    });
  }, [hardwareAcceleration, setHardwareAcceleration]);
  const changeMediaCacheSizeInBytes = useCallback125((cb) => {
    setMediaCacheSizeInBytes((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setMediaCacheSizeInBytes]);
  const changeOffthreadVideoCacheSizeInBytes = useCallback125((cb) => {
    setOffthreadVideoCacheSizeInBytes((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setOffthreadVideoCacheSizeInBytes]);
  const changeOffthreadVideoThreads = useCallback125((cb) => {
    setOffthreadVideoThreads((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setOffthreadVideoThreads]);
  return /* @__PURE__ */ jsxs127("div", {
    style: container56,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "still" ? null : /* @__PURE__ */ jsx255(NumberSetting, {
        min: minConcurrency,
        max: maxConcurrency,
        step: 1,
        name: "Concurrency",
        formatter: (w) => `${w}x`,
        onValueChanged: setConcurrency,
        value: concurrency
      }),
      renderMode === "video" && codec === "h264" ? /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "x264 Preset",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "x264Option"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Combobox, {
              title: x264Preset,
              selectedId: x264Preset,
              values: x264PresetOptions
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Hardware acceleration",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "hardwareAccelerationOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Combobox, {
              title: hardwareAcceleration,
              selectedId: hardwareAcceleration,
              values: hardwareAccelerationValues
            })
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx255(NumberSetting, {
        min: 7000,
        max: 900000,
        name: "delayRender() timeout",
        onValueChanged: setDelayRenderTimeout,
        formatter: (w) => `${w}ms`,
        step: 1000,
        hint: "delayRenderTimeoutInMillisecondsOption",
        value: delayRenderTimeout
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx255("div", {
            style: label5,
            children: "No parallel encoding"
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: disallowParallelEncoding,
              onChange: onDisallowParallelEncodingChanged,
              name: "disallow-parallel-encoding"
            })
          })
        ]
      }),
      renderMode === "audio" ? null : /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Custom @remotion/media cache size",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "mediaCacheSizeInBytesOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: mediaCacheSizeInBytes !== null,
              onChange: toggleCustomMediaCacheSizeInBytes,
              name: "media-cache-size"
            })
          })
        ]
      }),
      renderMode === "audio" || mediaCacheSizeInBytes === null ? null : /* @__PURE__ */ jsx255(NumberSetting, {
        min: 0,
        max: 2000 * 1024 * 1024,
        step: 1024,
        name: "@remotion/media cache size",
        formatter: (w) => `${w} bytes`,
        onValueChanged: changeMediaCacheSizeInBytes,
        value: mediaCacheSizeInBytes
      }),
      renderMode === "audio" ? null : /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Custom OffthreadVideo cache",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "offthreadVideoCacheSizeInBytesOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: offthreadVideoCacheSizeInBytes !== null,
              onChange: toggleCustomOffthreadVideoCacheSizeInBytes,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      renderMode === "audio" || offthreadVideoCacheSizeInBytes === null ? null : /* @__PURE__ */ jsx255(NumberSetting, {
        min: 0,
        max: 2000 * 1024 * 1024,
        step: 1024,
        name: "OffthreadVideo cache size",
        formatter: (w) => `${w} bytes`,
        onValueChanged: changeOffthreadVideoCacheSizeInBytes,
        value: offthreadVideoCacheSizeInBytes
      }),
      renderMode === "audio" ? null : /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "OffthreadVideo threads ",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "offthreadVideoThreadsOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: offthreadVideoThreads !== null,
              onChange: toggleCustomOffthreadVideoThreads,
              name: "offthread-video-threads"
            })
          })
        ]
      }),
      renderMode === "audio" || offthreadVideoThreads === null ? null : /* @__PURE__ */ jsx255(NumberSetting, {
        min: 0,
        max: 16,
        step: 1,
        name: "OffthreadVideo threads",
        formatter: (w) => `${w}x`,
        onValueChanged: changeOffthreadVideoThreads,
        value: offthreadVideoThreads
      }),
      /* @__PURE__ */ jsx255(RenderModalHr, {}),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx255("div", {
            style: label5,
            children: "Disable web security"
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: disableWebSecurity,
              onChange: onDisableWebSecurityChanged,
              name: "disable-web-security"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx255("div", {
            style: label5,
            children: "Ignore certificate errors"
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: ignoreCertificateErrors,
              onChange: onIgnoreCertificatErrors,
              name: "ignore-certificate-errors"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Headless mode",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "headlessOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: headless,
              onChange: onHeadless,
              name: "headless"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Chrome Mode ",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "chromeModeOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Combobox, {
              values: chromeModeOptions,
              selectedId: chromeModeOption,
              title: "Chrome mode"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "OpenGL render backend ",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "glOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Combobox, {
              values: openGlOptions,
              selectedId: openGlOption,
              title: "OpenGl option"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Multi-process Chrome on Linux",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "enableMultiprocessOnLinuxOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: enableMultiProcessOnLinux,
              onChange: onEnableMultiProcessOnLinux,
              name: "enable-multi-process-on-linux"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Dark Mode",
              /* @__PURE__ */ jsx255(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "darkModeOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: darkMode,
              onChange: onDarkMode,
              name: "dark-mode"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx255("div", {
            style: label5,
            children: "Custom User Agent"
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: userAgent !== null,
              onChange: toggleCustomUserAgent,
              name: "custom-user-agent"
            })
          })
        ]
      }),
      userAgent === null ? null : /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx255("div", {
            style: label5,
            children: "User Agent"
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255("div", {
              children: /* @__PURE__ */ jsx255(RemotionInput, {
                style: input,
                value: userAgent,
                onChange: onUserAgentChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Create a reproduction ",
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "reproOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: repro,
              onChange: onReproToggle,
              name: "repro"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsxs127("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs127("div", {
            style: label5,
            children: [
              "Beep when finished ",
              /* @__PURE__ */ jsx255(OptionExplainerBubble, {
                id: "beepOnFinishOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx255("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx255(Checkbox, {
              checked: beep,
              onChange: onPlayBeepSound,
              name: "beep-when-finished"
            })
          })
        ]
      }),
      /* @__PURE__ */ jsx255(RenderModalHr, {}),
      /* @__PURE__ */ jsx255(RenderModalEnvironmentVariables, {
        envVariables,
        setEnvVariables
      })
    ]
  });
};

// src/components/RenderModal/RenderModalAudio.tsx
import { BrowserSafeApis as BrowserSafeApis8 } from "@remotion/renderer/client";
import { useCallback as useCallback129 } from "react";

// src/components/RenderModal/EnforceAudioTrackSetting.tsx
import { useCallback as useCallback126 } from "react";
import { jsx as jsx256, jsxs as jsxs128 } from "react/jsx-runtime";
var EnforceAudioTrackSetting = ({ enforceAudioTrack, muted, setEnforceAudioTrack }) => {
  const onEnforceAudioTrackChanged = useCallback126((e) => {
    setEnforceAudioTrack(e.target.checked);
  }, [setEnforceAudioTrack]);
  return /* @__PURE__ */ jsxs128("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs128("div", {
        style: label5,
        children: [
          "Enforce Audio Track",
          /* @__PURE__ */ jsx256(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx256(OptionExplainerBubble, {
            id: "enforceAudioOption"
          })
        ]
      }),
      /* @__PURE__ */ jsx256("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx256(Checkbox, {
          disabled: muted && !enforceAudioTrack,
          checked: enforceAudioTrack,
          onChange: onEnforceAudioTrackChanged,
          name: "enforce-audio-track"
        })
      })
    ]
  });
};

// src/components/RenderModal/human-readable-audio-codecs.ts
var humanReadableAudioCodec = (audioCodec) => {
  if (audioCodec === "aac") {
    return "AAC";
  }
  if (audioCodec === "mp3") {
    return "MP3";
  }
  if (audioCodec === "pcm-16") {
    return "Lossless";
  }
  if (audioCodec === "opus") {
    return "Opus";
  }
};

// src/components/RenderModal/MutedSetting.tsx
import { useCallback as useCallback127 } from "react";
import { jsx as jsx257, jsxs as jsxs129 } from "react/jsx-runtime";
var MutedSetting = ({ muted, setMuted, enforceAudioTrack }) => {
  const onMutedChanged = useCallback127((e) => {
    setMuted(e.target.checked);
  }, [setMuted]);
  return /* @__PURE__ */ jsxs129("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsxs129("div", {
        style: label5,
        children: [
          "Muted",
          /* @__PURE__ */ jsx257(Spacing, {
            x: 0.5
          }),
          /* @__PURE__ */ jsx257(OptionExplainerBubble, {
            id: "mutedOption"
          })
        ]
      }),
      /* @__PURE__ */ jsx257(Spacing, {
        x: 0.25
      }),
      /* @__PURE__ */ jsx257("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx257(Checkbox, {
          checked: muted,
          disabled: enforceAudioTrack && !muted,
          onChange: onMutedChanged,
          name: "muted"
        })
      })
    ]
  });
};

// src/components/RenderModal/SeparateAudioOption.tsx
import { BrowserSafeApis as BrowserSafeApis7 } from "@remotion/renderer/client";
import { useCallback as useCallback128, useMemo as useMemo132 } from "react";

// src/helpers/use-file-existence.ts
import { useContext as useContext88, useEffect as useEffect84, useRef as useRef44, useState as useState87 } from "react";
var useFileExistence = (outName) => {
  const [exists, setExists] = useState87(false);
  const { previewServerState: state, subscribeToEvent } = useContext88(StudioServerConnectionCtx);
  const clientId = state.type === "connected" ? state.clientId : undefined;
  const currentOutName = useRef44("");
  currentOutName.current = outName;
  useEffect84(() => {
    if (!clientId) {
      return;
    }
    subscribeToFileExistenceWatcher({
      file: outName,
      clientId
    }).then((_exists) => {
      if (currentOutName.current === outName) {
        setExists(_exists);
      }
    });
    return () => {
      unsubscribeFromFileExistenceWatcher({ file: outName, clientId });
    };
  }, [clientId, outName]);
  useEffect84(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-deleted") {
        return;
      }
      if (event.file !== currentOutName.current) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(false);
      }
    };
    const unsub = subscribeToEvent("watched-file-deleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  useEffect84(() => {
    const listener = (event) => {
      if (event.type !== "watched-file-undeleted") {
        return;
      }
      if (event.file !== outName) {
        return;
      }
      if (currentOutName.current === outName) {
        setExists(true);
      }
    };
    const unsub = subscribeToEvent("watched-file-undeleted", listener);
    return () => {
      unsub();
    };
  }, [outName, subscribeToEvent]);
  return exists;
};

// src/components/RenderModal/RenderModalOutputName.tsx
import { jsx as jsx258, jsxs as jsxs130, Fragment as Fragment41 } from "react/jsx-runtime";
var RenderModalOutputName = ({
  existence,
  inputStyle: inputStyle2,
  outName,
  onValueChange,
  validationMessage,
  label: labelText
}) => {
  return /* @__PURE__ */ jsxs130("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx258(Column, {
        children: /* @__PURE__ */ jsx258("div", {
          style: label5,
          children: labelText
        })
      }),
      /* @__PURE__ */ jsx258("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsxs130("div", {
          children: [
            /* @__PURE__ */ jsx258(RemotionInput, {
              status: validationMessage ? "error" : existence ? "warning" : "ok",
              style: inputStyle2,
              type: "text",
              value: outName,
              onChange: onValueChange,
              rightAlign: true
            }),
            validationMessage ? /* @__PURE__ */ jsxs130(Fragment41, {
              children: [
                /* @__PURE__ */ jsx258(Spacing, {
                  y: 1,
                  block: true
                }),
                /* @__PURE__ */ jsx258(ValidationMessage, {
                  align: "flex-end",
                  message: validationMessage,
                  type: "error"
                })
              ]
            }) : existence ? /* @__PURE__ */ jsxs130(Fragment41, {
              children: [
                /* @__PURE__ */ jsx258(Spacing, {
                  y: 1,
                  block: true
                }),
                /* @__PURE__ */ jsx258(ValidationMessage, {
                  align: "flex-end",
                  message: "Will be overwritten",
                  type: "warning"
                })
              ]
            }) : null
          ]
        })
      })
    ]
  });
};

// src/components/RenderModal/SeparateAudioOption.tsx
import { jsx as jsx259, jsxs as jsxs131, Fragment as Fragment42 } from "react/jsx-runtime";
var SeparateAudioOptionInput = ({ separateAudioTo, setSeparateAudioTo, audioCodec }) => {
  const existence = useFileExistence(separateAudioTo);
  const onValueChange = useCallback128((e) => {
    setSeparateAudioTo(e.target.value);
  }, [setSeparateAudioTo]);
  const validationMessage = useMemo132(() => {
    const expectedExtension = BrowserSafeApis7.getExtensionFromAudioCodec(audioCodec);
    const actualExtension = separateAudioTo.split(".").pop();
    if (actualExtension !== expectedExtension) {
      return `Expected extension: .${expectedExtension}`;
    }
    return null;
  }, [audioCodec, separateAudioTo]);
  return /* @__PURE__ */ jsx259(RenderModalOutputName, {
    existence,
    inputStyle: input,
    onValueChange,
    outName: separateAudioTo,
    label: "Separate audio to",
    validationMessage
  });
};
var SeparateAudioOption = ({ separateAudioTo, setSeparateAudioTo, audioCodec, outName }) => {
  const onSeparateAudioChange = useCallback128((e) => {
    if (e.target.checked) {
      const extension = BrowserSafeApis7.getExtensionFromAudioCodec(audioCodec);
      setSeparateAudioTo(`${getStringBeforeSuffix(outName)}.${extension}`);
    } else {
      setSeparateAudioTo(null);
    }
  }, [audioCodec, outName, setSeparateAudioTo]);
  return /* @__PURE__ */ jsxs131(Fragment42, {
    children: [
      /* @__PURE__ */ jsxs131("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs131("div", {
            style: label5,
            children: [
              "Separate audio",
              /* @__PURE__ */ jsx259(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx259(OptionExplainerBubble, {
                id: "separateAudioOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx259("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx259(Checkbox, {
              disabled: false,
              checked: Boolean(separateAudioTo),
              onChange: onSeparateAudioChange,
              name: "separate-audio-to"
            })
          })
        ]
      }),
      separateAudioTo === null ? null : /* @__PURE__ */ jsx259(SeparateAudioOptionInput, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec
      })
    ]
  });
};

// src/components/RenderModal/RenderModalAudio.tsx
import { jsx as jsx260, jsxs as jsxs132, Fragment as Fragment43 } from "react/jsx-runtime";
var container57 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalAudio = ({
  muted,
  setMuted,
  renderMode,
  enforceAudioTrack,
  setEnforceAudioTrackState,
  setShouldHaveCustomTargetAudioBitrate,
  shouldHaveCustomTargetAudioBitrate,
  setCustomTargetAudioBitrateValue,
  customTargetAudioBitrate,
  audioCodec,
  codec,
  setAudioCodec,
  forSeamlessAacConcatenation,
  setForSeamlessAacConcatenation,
  separateAudioTo,
  setSeparateAudioTo,
  outName
}) => {
  const onShouldHaveTargetAudioBitrateChanged = useCallback129((e) => {
    setShouldHaveCustomTargetAudioBitrate(e.target.checked);
  }, [setShouldHaveCustomTargetAudioBitrate]);
  const onTargetAudioBitrateChanged = useCallback129((e) => {
    setCustomTargetAudioBitrateValue(e.target.value);
  }, [setCustomTargetAudioBitrateValue]);
  const onSeamlessAacConcatenationChanges = useCallback129((e) => {
    setForSeamlessAacConcatenation(e.target.checked);
  }, [setForSeamlessAacConcatenation]);
  const audioCodecOptions = useCallback129((currentCodec) => {
    return BrowserSafeApis8.supportedAudioCodecs[currentCodec].map((audioCodecOption) => {
      return {
        label: humanReadableAudioCodec(audioCodecOption),
        onClick: () => setAudioCodec(audioCodecOption),
        key: audioCodecOption,
        leftItem: codec === audioCodecOption ? /* @__PURE__ */ jsx260(Checkmark, {}) : null,
        id: audioCodecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: audioCodecOption
      };
    });
  }, [codec, setAudioCodec]);
  return /* @__PURE__ */ jsxs132("div", {
    style: container57,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? /* @__PURE__ */ jsxs132(Fragment43, {
        children: [
          /* @__PURE__ */ jsx260(MutedSetting, {
            enforceAudioTrack,
            muted,
            setMuted
          }),
          /* @__PURE__ */ jsx260(RenderModalHr, {})
        ]
      }) : null,
      renderMode === "video" && audioCodecOptions(codec).length >= 2 && !muted ? /* @__PURE__ */ jsxs132("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs132("div", {
            style: label5,
            children: [
              "Audio Codec ",
              /* @__PURE__ */ jsx260(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx260(OptionExplainerBubble, {
                id: "audioCodecOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx260("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx260(Combobox, {
              values: audioCodecOptions(codec),
              selectedId: audioCodec,
              title: "AudioCodec"
            })
          })
        ]
      }) : null,
      (renderMode === "video" || renderMode === "audio") && !muted && /* @__PURE__ */ jsxs132(Fragment43, {
        children: [
          /* @__PURE__ */ jsx260(EnforceAudioTrackSetting, {
            muted,
            enforceAudioTrack,
            setEnforceAudioTrack: setEnforceAudioTrackState
          }),
          /* @__PURE__ */ jsx260(RenderModalHr, {})
        ]
      }),
      renderMode === "video" && !muted ? /* @__PURE__ */ jsx260(SeparateAudioOption, {
        separateAudioTo,
        setSeparateAudioTo,
        audioCodec,
        outName
      }) : null,
      audioCodec === "aac" && !muted ? /* @__PURE__ */ jsxs132("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs132("div", {
            style: label5,
            children: [
              "For seamless AAC concatenation",
              /* @__PURE__ */ jsx260(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx260(OptionExplainerBubble, {
                id: "forSeamlessAacConcatenationOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx260("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx260(Checkbox, {
              disabled: false,
              checked: forSeamlessAacConcatenation,
              onChange: onSeamlessAacConcatenationChanges,
              name: "enforce-audio-track"
            })
          })
        ]
      }) : null,
      renderMode === "still" || muted ? null : /* @__PURE__ */ jsxs132("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs132("div", {
            style: label5,
            children: [
              "Custom audio bitrate",
              " ",
              /* @__PURE__ */ jsx260(OptionExplainerBubble, {
                id: "audioBitrateOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx260("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx260(Checkbox, {
              checked: shouldHaveCustomTargetAudioBitrate,
              onChange: onShouldHaveTargetAudioBitrateChanged,
              name: "custom-audio-bitrate"
            })
          })
        ]
      }),
      shouldHaveCustomTargetAudioBitrate && renderMode !== "still" && !muted ? /* @__PURE__ */ jsxs132("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx260("div", {
            style: label5,
            children: "Target audio bitrate"
          }),
          /* @__PURE__ */ jsx260("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx260("div", {
              children: /* @__PURE__ */ jsx260(RemotionInput, {
                style: input,
                value: customTargetAudioBitrate,
                onChange: onTargetAudioBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalBasic.tsx
import { BrowserSafeApis as BrowserSafeApis9 } from "@remotion/renderer/client";
import { NoReactAPIs as NoReactAPIs2 } from "@remotion/renderer/pure";
import { useCallback as useCallback132, useMemo as useMemo134 } from "react";

// src/helpers/prores-labels.ts
var labelProResProfile = (profile) => {
  if (profile === "4444") {
    return "4444";
  }
  if (profile === "4444-xq") {
    return "4444 XQ (Best)";
  }
  if (profile === "hq") {
    return "HQ";
  }
  if (profile === "proxy") {
    return "Proxy (Worst)";
  }
  if (profile === "light") {
    return "Light";
  }
  if (profile === "standard") {
    return "Standard";
  }
  throw new TypeError(`Unknown ProRes profile: ${profile}`);
};

// src/components/RenderModal/FrameRangeSetting.tsx
import { useCallback as useCallback131 } from "react";

// src/components/RenderModal/MultiRangeSlider.tsx
import { useCallback as useCallback130, useMemo as useMemo133 } from "react";
import { jsx as jsx261, jsxs as jsxs133 } from "react/jsx-runtime";
var container58 = {
  borderColor: "black",
  borderStyle: "solid",
  borderWidth: "2px",
  height: 39,
  width: 220,
  position: "relative",
  backgroundColor: INPUT_BACKGROUND,
  marginLeft: 8,
  marginRight: 8,
  borderRadius: 2
};
var sliderRange = {
  position: "absolute",
  top: 0,
  backgroundColor: BLUE,
  height: 35
};
var MultiRangeSlider = ({
  min,
  max,
  start,
  end,
  step,
  onLeftThumbDrag,
  onRightThumbDrag
}) => {
  const getPercent = useCallback130((value) => Math.round((value - min) / (max - min) * 100), [min, max]);
  const rangeStyle = useMemo133(() => {
    const minPercent = getPercent(start);
    const maxPercent = getPercent(end);
    return {
      ...sliderRange,
      left: `${minPercent}%`,
      width: `${maxPercent - minPercent}%`
    };
  }, [end, getPercent, start]);
  const onChangeLeft = useCallback130((event) => {
    const value = Math.min(Number(event.target.value), end - 1);
    onLeftThumbDrag(value);
  }, [end, onLeftThumbDrag]);
  const onChangeRight = useCallback130((event) => {
    const value = Math.max(Number(event.target.value), start + 1);
    onRightThumbDrag(value);
  }, [onRightThumbDrag, start]);
  return /* @__PURE__ */ jsxs133("div", {
    style: container58,
    children: [
      /* @__PURE__ */ jsx261("input", {
        type: "range",
        min,
        max,
        value: start,
        step,
        onChange: onChangeLeft,
        className: "__remotion_thumb"
      }),
      /* @__PURE__ */ jsx261("input", {
        type: "range",
        min,
        max,
        value: end,
        step,
        onChange: onChangeRight,
        className: "__remotion_thumb"
      }),
      /* @__PURE__ */ jsx261("div", {
        style: rangeStyle
      })
    ]
  });
};

// src/components/RenderModal/FrameRangeSetting.tsx
import { jsx as jsx262, jsxs as jsxs134 } from "react/jsx-runtime";
var INPUT_WIDTH = 40;
var FrameRangeSetting = ({ startFrame, endFrame, setEndFrame, durationInFrames, setStartFrame }) => {
  const minStartFrame = 0;
  const maxEndFrame = durationInFrames - 1;
  const onStartFrameChangedDirectly = useCallback131((newStartFrame) => {
    setStartFrame(newStartFrame);
  }, [setStartFrame]);
  const onEndFrameChangedDirectly = useCallback131((newEndFrame) => {
    setEndFrame(newEndFrame);
  }, [setEndFrame]);
  const onStartFrameChanged = useCallback131((newVal) => {
    onStartFrameChangedDirectly(parseInt(newVal, 10));
  }, [onStartFrameChangedDirectly]);
  const onEndFrameChanged = useCallback131((newVal) => {
    onEndFrameChangedDirectly(parseInt(newVal, 10));
  }, [onEndFrameChangedDirectly]);
  return /* @__PURE__ */ jsxs134("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx262("div", {
        style: label5,
        children: "Frame range"
      }),
      /* @__PURE__ */ jsxs134("div", {
        style: rightRow,
        children: [
          /* @__PURE__ */ jsx262("div", {
            style: { width: INPUT_WIDTH },
            children: /* @__PURE__ */ jsx262(InputDragger, {
              min: minStartFrame,
              max: endFrame - 1,
              name: "Start frame",
              value: startFrame,
              step: 1,
              onTextChange: onStartFrameChanged,
              onValueChange: onStartFrameChangedDirectly,
              status: "ok",
              rightAlign: true,
              style: { width: INPUT_WIDTH }
            })
          }),
          /* @__PURE__ */ jsx262(MultiRangeSlider, {
            min: minStartFrame,
            max: maxEndFrame,
            start: startFrame,
            end: endFrame,
            step: 1,
            onLeftThumbDrag: onStartFrameChangedDirectly,
            onRightThumbDrag: onEndFrameChangedDirectly
          }),
          " ",
          /* @__PURE__ */ jsx262("div", {
            style: { width: INPUT_WIDTH },
            children: /* @__PURE__ */ jsx262(InputDragger, {
              min: startFrame + 1,
              max: maxEndFrame,
              name: "End frame",
              value: endFrame,
              step: 1,
              onTextChange: onEndFrameChanged,
              onValueChange: onEndFrameChangedDirectly,
              status: "ok",
              rightAlign: true,
              style: { width: INPUT_WIDTH }
            })
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/human-readable-codec.ts
var humanReadableCodec = (codec) => {
  if (codec === "aac") {
    return "AAC";
  }
  if (codec === "mp3") {
    return "MP3";
  }
  if (codec === "gif") {
    return "GIF";
  }
  if (codec === "h264") {
    return "H.264";
  }
  if (codec === "h264-mkv") {
    return "H.264 (Matroska)";
  }
  if (codec === "h264-ts") {
    return "H.264 (Transport Stream)";
  }
  if (codec === "h265") {
    return "H.265";
  }
  if (codec === "prores") {
    return "ProRes";
  }
  if (codec === "vp8") {
    return "VP8";
  }
  if (codec === "vp9") {
    return "VP9";
  }
  if (codec === "wav") {
    return "Waveform";
  }
  throw new TypeError(`Got unexpected codec "${codec}"`);
};

// src/components/RenderModal/human-readable-loglevel.ts
var humanReadableLogLevel = (logLevel) => {
  if (logLevel === "trace") {
    return "Trace";
  }
  if (logLevel === "verbose") {
    return "Verbose";
  }
  if (logLevel === "info") {
    return "Info";
  }
  if (logLevel === "warn") {
    return "Warn";
  }
  if (logLevel === "error") {
    return "Error";
  }
  throw new TypeError(`Got unexpected log level "${logLevel}"`);
};

// src/components/RenderModal/RenderModalBasic.tsx
import { jsx as jsx263, jsxs as jsxs135 } from "react/jsx-runtime";
var container59 = {
  flex: 1
};
var RenderModalBasic = ({
  renderMode,
  imageFormatOptions,
  outName,
  codec,
  setVideoCodec: setCodec,
  proResProfile,
  setProResProfile,
  frame: frame2,
  setFrame,
  resolvedComposition,
  setOutName,
  setEndFrame,
  endFrame,
  setStartFrame,
  startFrame,
  validationMessage,
  setVerboseLogging,
  logLevel,
  showOutputName
}) => {
  const existence = useFileExistence(outName);
  const videoCodecOptions = useMemo134(() => {
    return BrowserSafeApis9.validCodecs.filter((c) => {
      return NoReactAPIs2.isAudioCodec(c) === (renderMode === "audio");
    }).map((codecOption) => {
      return {
        label: humanReadableCodec(codecOption),
        onClick: () => setCodec(codecOption),
        key: codecOption,
        leftItem: codec === codecOption ? /* @__PURE__ */ jsx263(Checkmark, {}) : null,
        id: codecOption,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: codecOption
      };
    });
  }, [renderMode, setCodec, codec]);
  const proResProfileOptions = useMemo134(() => {
    return BrowserSafeApis9.proResProfileOptions.map((option) => {
      return {
        label: labelProResProfile(option),
        onClick: () => setProResProfile(option),
        key: option,
        selected: proResProfile === option,
        type: "item",
        id: option,
        keyHint: null,
        leftItem: null,
        quickSwitcherLabel: null,
        subMenu: null,
        value: option
      };
    });
  }, [proResProfile, setProResProfile]);
  const onFrameSetDirectly = useCallback132((newFrame) => {
    setFrame(newFrame);
  }, [setFrame]);
  const onFrameChanged = useCallback132((e) => {
    setFrame((q) => {
      const newFrame = parseFloat(e);
      if (Number.isNaN(newFrame)) {
        return q;
      }
      return newFrame;
    });
  }, [setFrame]);
  const onValueChange = useCallback132((e) => {
    setOutName(e.target.value);
  }, [setOutName]);
  const logLevelOptions = useMemo134(() => {
    return ["trace", "verbose", "info", "warn", "error"].map((level) => {
      return {
        label: humanReadableLogLevel(level),
        onClick: () => setVerboseLogging(level),
        leftItem: logLevel === level ? /* @__PURE__ */ jsx263(Checkmark, {}) : null,
        id: level,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: level
      };
    });
  }, [logLevel, setVerboseLogging]);
  return /* @__PURE__ */ jsxs135("div", {
    style: container59,
    children: [
      renderMode === "still" || renderMode === "sequence" ? /* @__PURE__ */ jsxs135("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx263("div", {
            style: label5,
            children: "Format"
          }),
          /* @__PURE__ */ jsx263("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx263(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: true
            })
          })
        ]
      }) : /* @__PURE__ */ jsxs135("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs135("div", {
            style: label5,
            children: [
              "Codec",
              /* @__PURE__ */ jsx263(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx263(OptionExplainerBubble, {
                id: "videoCodecOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx263("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx263(Combobox, {
              values: videoCodecOptions,
              selectedId: codec,
              title: "Codec"
            })
          })
        ]
      }),
      renderMode === "still" && resolvedComposition.durationInFrames > 1 ? /* @__PURE__ */ jsxs135("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx263("div", {
            style: label5,
            children: "Frame"
          }),
          /* @__PURE__ */ jsx263("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx263(RightAlignInput, {
              children: /* @__PURE__ */ jsx263(InputDragger, {
                value: frame2,
                onTextChange: onFrameChanged,
                placeholder: `0-${resolvedComposition.durationInFrames - 1}`,
                onValueChange: onFrameSetDirectly,
                name: "frame",
                step: 1,
                min: 0,
                status: "ok",
                max: resolvedComposition.durationInFrames - 1,
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" && codec === "prores" ? /* @__PURE__ */ jsxs135("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx263("div", {
            style: label5,
            children: "ProRes profile"
          }),
          /* @__PURE__ */ jsx263("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx263(Combobox, {
              title: "proResProfile",
              selectedId: proResProfile,
              values: proResProfileOptions
            })
          })
        ]
      }) : null,
      renderMode === "still" ? null : /* @__PURE__ */ jsx263(FrameRangeSetting, {
        durationInFrames: resolvedComposition.durationInFrames,
        endFrame,
        setEndFrame,
        setStartFrame,
        startFrame
      }),
      showOutputName ? /* @__PURE__ */ jsx263(RenderModalOutputName, {
        existence,
        inputStyle: input,
        outName,
        onValueChange,
        validationMessage,
        label: renderMode === "sequence" ? "Folder name" : "Output name"
      }) : null,
      /* @__PURE__ */ jsxs135("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs135("div", {
            style: label5,
            children: [
              "Log Level ",
              /* @__PURE__ */ jsx263(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx263(OptionExplainerBubble, {
                id: "logLevelOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx263("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx263(Combobox, {
              values: logLevelOptions,
              selectedId: logLevel,
              title: "Log Level"
            })
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import { useCallback as useCallback134 } from "react";

// src/components/RenderModal/NumberOfLoopsSetting.tsx
import { useCallback as useCallback133 } from "react";
import { jsx as jsx264, jsxs as jsxs136 } from "react/jsx-runtime";
var min = 0;
var NumberOfLoopsSetting = ({ numberOfGifLoops, setNumberOfGifLoops }) => {
  const onNumberOfGifLoopsChangedDirectly = useCallback133((newConcurrency) => {
    setNumberOfGifLoops(newConcurrency);
  }, [setNumberOfGifLoops]);
  const onNumberOfGifLoopsChanged = useCallback133((e) => {
    setNumberOfGifLoops((q) => {
      const newConcurrency = parseInt(e, 10);
      if (Number.isNaN(newConcurrency)) {
        return q;
      }
      const newConcurrencyClamped = Math.max(newConcurrency, min);
      return newConcurrencyClamped;
    });
  }, [setNumberOfGifLoops]);
  return /* @__PURE__ */ jsxs136("div", {
    style: optionRow,
    children: [
      /* @__PURE__ */ jsx264("div", {
        style: label5,
        children: "Number of loops"
      }),
      /* @__PURE__ */ jsx264("div", {
        style: rightRow,
        children: /* @__PURE__ */ jsx264(RightAlignInput, {
          children: /* @__PURE__ */ jsx264(InputDragger, {
            value: numberOfGifLoops,
            onTextChange: onNumberOfGifLoopsChanged,
            placeholder: `${min}-`,
            onValueChange: onNumberOfGifLoopsChangedDirectly,
            name: "number-of-gif-loops",
            step: 1,
            min,
            status: "ok",
            rightAlign: true
          })
        })
      })
    ]
  });
};

// src/components/RenderModal/RenderModalGif.tsx
import { jsx as jsx265, jsxs as jsxs137 } from "react/jsx-runtime";
var container60 = {
  flex: 1
};
var RenderModalGif = ({
  everyNthFrame,
  limitNumberOfGifLoops,
  numberOfGifLoopsSetting,
  setEveryNthFrameSetting,
  setLimitNumberOfGifLoops,
  setNumberOfGifLoopsSetting
}) => {
  const onShouldLimitNumberOfGifLoops = useCallback134((e) => {
    setLimitNumberOfGifLoops(e.target.checked);
  }, [setLimitNumberOfGifLoops]);
  return /* @__PURE__ */ jsxs137("div", {
    style: container60,
    children: [
      /* @__PURE__ */ jsx265(NumberSetting, {
        name: "Every nth frame",
        min: 1,
        onValueChanged: setEveryNthFrameSetting,
        value: everyNthFrame,
        step: 1
      }),
      /* @__PURE__ */ jsxs137("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs137("div", {
            style: label5,
            children: [
              "Limit GIF loops ",
              /* @__PURE__ */ jsx265(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx265(OptionExplainerBubble, {
                id: "numberOfGifLoopsOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx265("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx265(Checkbox, {
              checked: limitNumberOfGifLoops,
              onChange: onShouldLimitNumberOfGifLoops,
              name: "limitNumberOfGifLoops"
            })
          })
        ]
      }),
      limitNumberOfGifLoops ? /* @__PURE__ */ jsx265(NumberOfLoopsSetting, {
        numberOfGifLoops: numberOfGifLoopsSetting,
        setNumberOfGifLoops: setNumberOfGifLoopsSetting
      }) : null
    ]
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import { BrowserSafeApis as BrowserSafeApis10 } from "@remotion/renderer/client";
import { useCallback as useCallback135, useMemo as useMemo136 } from "react";

// src/components/RenderModal/JpegQualitySetting.tsx
import { jsx as jsx266 } from "react/jsx-runtime";
var MIN_JPEG_QUALITY = 1;
var MAX_JPEG_QUALITY = 100;
var JpegQualitySetting = ({ jpegQuality, setJpegQuality }) => {
  return /* @__PURE__ */ jsx266(NumberSetting, {
    min: MIN_JPEG_QUALITY,
    max: MAX_JPEG_QUALITY,
    step: 1,
    name: "JPEG Quality",
    onValueChanged: setJpegQuality,
    value: jpegQuality,
    hint: "jpegQualityOption"
  });
};

// src/components/RenderModal/ScaleSetting.tsx
import { useMemo as useMemo135 } from "react";
import { jsx as jsx267, jsxs as jsxs138, Fragment as Fragment44 } from "react/jsx-runtime";
var MIN_SCALE = 0.1;
var MAX_SCALE = 10;
var outputDimensionsStyle = {
  fontSize: 13,
  color: LIGHT_TEXT,
  fontFamily: "sans-serif",
  paddingRight: 16,
  textAlign: "right",
  marginBottom: 14,
  marginTop: -10
};
var ScaleSetting = ({ scale, setScale, compositionWidth, compositionHeight }) => {
  const outputDimensions = useMemo135(() => {
    const outputWidth = Math.round(compositionWidth * scale);
    const outputHeight = Math.round(compositionHeight * scale);
    return `${outputWidth}×${outputHeight}`;
  }, [compositionWidth, compositionHeight, scale]);
  return /* @__PURE__ */ jsxs138(Fragment44, {
    children: [
      /* @__PURE__ */ jsx267(NumberSetting, {
        min: MIN_SCALE,
        max: MAX_SCALE,
        step: 0.1,
        name: "Scale",
        formatter: (w) => {
          if (typeof w === "number") {
            return `${w.toFixed(1)}x`;
          }
          return `${w}x`;
        },
        onValueChanged: setScale,
        value: scale,
        hint: "scaleOption"
      }),
      scale !== 1 && /* @__PURE__ */ jsxs138("div", {
        style: outputDimensionsStyle,
        children: [
          "Output resolution: ",
          outputDimensions
        ]
      })
    ]
  });
};

// src/components/RenderModal/RenderModalPicture.tsx
import { jsx as jsx268, jsxs as jsxs139, Fragment as Fragment45 } from "react/jsx-runtime";
var qualityControlModes = ["crf", "bitrate"];
var container61 = {
  flex: 1,
  overflowY: "auto"
};
var RenderModalPicture = ({
  renderMode,
  scale,
  setScale,
  pixelFormat,
  imageFormatOptions,
  setQualityControl,
  qualityControlType,
  videoImageFormat,
  setJpegQuality,
  jpegQuality,
  maxCrf,
  minCrf,
  setCrf,
  shouldDisplayQualityControlPicker,
  setCustomTargetVideoBitrateValue,
  crf,
  customTargetVideoBitrate,
  stillImageFormat,
  colorSpace,
  setColorSpace,
  pixelFormatOptions,
  encodingBufferSize,
  encodingMaxRate,
  setEncodingBufferSize,
  setEncodingMaxRate,
  compositionWidth,
  compositionHeight
}) => {
  const colorSpaceOptions = useMemo136(() => {
    return BrowserSafeApis10.validColorSpaces.map((option) => {
      return {
        label: option,
        onClick: () => setColorSpace(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: colorSpace === option ? /* @__PURE__ */ jsx268(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [colorSpace, setColorSpace]);
  const qualityControlOptions = useMemo136(() => {
    return qualityControlModes.map((option) => {
      return {
        label: option === "crf" ? "CRF" : "Bitrate",
        onClick: () => setQualityControl(option),
        key: option,
        selected: qualityControlType === option
      };
    });
  }, [qualityControlType, setQualityControl]);
  const onTargetVideoBitrateChanged = useCallback135((e) => {
    setCustomTargetVideoBitrateValue(e.target.value);
  }, [setCustomTargetVideoBitrateValue]);
  const onEncodingBufferSizeToggled = useCallback135((e) => {
    setEncodingBufferSize(e.target.checked ? "10000k" : null);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateToggled = useCallback135((e) => {
    setEncodingMaxRate(e.target.checked ? "5000k" : null);
  }, [setEncodingMaxRate]);
  const onEncodingBufferSizeChanged = useCallback135((e) => {
    setEncodingBufferSize(e.target.value);
  }, [setEncodingBufferSize]);
  const onEncodingMaxRateChanged = useCallback135((e) => {
    setEncodingMaxRate(e.target.value);
  }, [setEncodingMaxRate]);
  return /* @__PURE__ */ jsxs139("div", {
    style: container61,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      renderMode === "video" ? /* @__PURE__ */ jsxs139("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx268("div", {
            style: label5,
            children: "Image Format"
          }),
          /* @__PURE__ */ jsx268("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx268(SegmentedControl, {
              items: imageFormatOptions,
              needsWrapping: false
            })
          })
        ]
      }) : null,
      renderMode === "video" && videoImageFormat === "jpeg" && /* @__PURE__ */ jsx268(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "still" && stillImageFormat === "jpeg" && /* @__PURE__ */ jsx268(JpegQualitySetting, {
        jpegQuality,
        setJpegQuality
      }),
      renderMode === "video" && qualityControlType !== null ? /* @__PURE__ */ jsx268(RenderModalHr, {}) : null,
      shouldDisplayQualityControlPicker && renderMode === "video" ? /* @__PURE__ */ jsxs139("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx268("div", {
            style: label5,
            children: "Quality control"
          }),
          /* @__PURE__ */ jsx268("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx268(SegmentedControl, {
              items: qualityControlOptions,
              needsWrapping: true
            })
          })
        ]
      }) : null,
      qualityControlType === "crf" && renderMode !== "still" && renderMode !== "sequence" && crf !== null ? /* @__PURE__ */ jsx268(CrfSetting, {
        crf,
        min: minCrf,
        max: maxCrf,
        setCrf,
        option: "crfOption"
      }) : null,
      qualityControlType === "bitrate" && renderMode === "video" ? /* @__PURE__ */ jsxs139("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs139("div", {
            style: label5,
            children: [
              "Target video bitrate",
              /* @__PURE__ */ jsx268(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx268(OptionExplainerBubble, {
                id: "videoBitrateOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx268("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx268("div", {
              children: /* @__PURE__ */ jsx268(RemotionInput, {
                style: input,
                value: customTargetVideoBitrate,
                onChange: onTargetVideoBitrateChanged,
                status: "ok",
                rightAlign: true
              })
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs139(Fragment45, {
        children: [
          /* @__PURE__ */ jsxs139("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs139("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -bufsize",
                  /* @__PURE__ */ jsx268(Spacing, {
                    x: 0.5
                  }),
                  /* @__PURE__ */ jsx268(OptionExplainerBubble, {
                    id: "encodingBufferSizeOption"
                  })
                ]
              }),
              /* @__PURE__ */ jsx268("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx268(Checkbox, {
                  checked: encodingBufferSize !== null,
                  onChange: onEncodingBufferSizeToggled,
                  name: "encoding-buffer-size"
                })
              })
            ]
          }),
          encodingBufferSize === null ? null : /* @__PURE__ */ jsxs139("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx268("div", {
                style: label5,
                children: "-bufsize value"
              }),
              /* @__PURE__ */ jsx268("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx268("div", {
                  children: /* @__PURE__ */ jsx268(RemotionInput, {
                    style: input,
                    value: encodingBufferSize,
                    onChange: onEncodingBufferSizeChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          }),
          /* @__PURE__ */ jsxs139("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs139("div", {
                style: label5,
                children: [
                  "Custom FFmpeg -maxrate",
                  /* @__PURE__ */ jsx268(Spacing, {
                    x: 0.5
                  }),
                  /* @__PURE__ */ jsx268(OptionExplainerBubble, {
                    id: "encodingMaxRateOption"
                  })
                ]
              }),
              /* @__PURE__ */ jsx268("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx268(Checkbox, {
                  checked: encodingMaxRate !== null,
                  onChange: onEncodingMaxRateToggled,
                  name: "encoding-max-rate"
                })
              })
            ]
          }),
          encodingMaxRate === null ? null : /* @__PURE__ */ jsxs139("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx268("div", {
                style: label5,
                children: "-maxrate value"
              }),
              /* @__PURE__ */ jsx268("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx268("div", {
                  children: /* @__PURE__ */ jsx268(RemotionInput, {
                    style: input,
                    value: encodingMaxRate,
                    onChange: onEncodingMaxRateChanged,
                    status: "ok",
                    rightAlign: true
                  })
                })
              })
            ]
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsx268(RenderModalHr, {}) : null,
      /* @__PURE__ */ jsx268(ScaleSetting, {
        scale,
        setScale,
        compositionWidth,
        compositionHeight
      }),
      renderMode === "video" ? /* @__PURE__ */ jsx268(RenderModalHr, {}) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs139("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx268("div", {
            style: label5,
            children: "Pixel format"
          }),
          /* @__PURE__ */ jsx268("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx268(Combobox, {
              values: pixelFormatOptions,
              selectedId: pixelFormat,
              title: "Pixel Format"
            })
          })
        ]
      }) : null,
      renderMode === "video" ? /* @__PURE__ */ jsxs139("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs139("div", {
            style: label5,
            children: [
              "Color space",
              /* @__PURE__ */ jsx268(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx268(OptionExplainerBubble, {
                id: "colorSpaceOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx268("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx268(Combobox, {
              values: colorSpaceOptions,
              selectedId: colorSpace,
              title: "Color Space"
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/ServerRenderModal.tsx
import { jsx as jsx269, jsxs as jsxs140 } from "react/jsx-runtime";
var initialState2 = { type: "idle" };
var reducer2 = (state, action) => {
  if (action.type === "start") {
    return {
      type: "load"
    };
  }
  if (action.type === "fail") {
    return {
      type: "error"
    };
  }
  if (action.type === "succeed") {
    return {
      type: "success"
    };
  }
  return state;
};
var RenderModal = ({
  readOnlyStudio,
  initialFrame,
  initialVideoImageFormat,
  initialStillImageFormat,
  initialJpegQuality,
  initialScale,
  initialLogLevel,
  initialConcurrency,
  maxConcurrency,
  minConcurrency,
  initialMuted,
  initialEnforceAudioTrack,
  initialProResProfile,
  initialx264Preset,
  initialPixelFormat,
  initialVideoBitrate,
  initialAudioBitrate,
  initialEveryNthFrame,
  initialNumberOfGifLoops,
  initialDelayRenderTimeout,
  initialOffthreadVideoCacheSizeInBytes,
  initialEnvVariables,
  initialDisableWebSecurity,
  initialGl,
  initialHeadless,
  initialIgnoreCertificateErrors,
  initialEncodingBufferSize,
  initialEncodingMaxRate,
  initialOffthreadVideoThreads,
  initialMediaCacheSizeInBytes,
  initialDarkMode,
  initialUserAgent,
  defaultProps,
  inFrameMark,
  outFrameMark,
  initialColorSpace,
  initialMultiProcessOnLinux,
  defaultConfigurationAudioCodec,
  defaultConfigurationVideoCodec,
  initialBeep,
  initialRepro,
  initialForSeamlessAacConcatenation,
  renderTypeOfLastRender,
  initialHardwareAcceleration,
  defaultMetadata,
  initialChromeMode,
  renderDefaults
}) => {
  const { setSelectedModal } = useContext89(ModalsContext);
  const context = useContext89(ResolvedCompositionContext);
  if (!context) {
    throw new Error("Should not be able to render without resolving comp first");
  }
  const {
    resolved: { result: resolvedComposition },
    unresolved: unresolvedComposition
  } = context;
  const isMounted = useRef45(true);
  const [isVideo] = useState88(() => {
    return typeof resolvedComposition.durationInFrames === "undefined" ? true : resolvedComposition.durationInFrames > 1;
  });
  const [
    {
      initialAudioCodec,
      initialRenderType,
      initialVideoCodec,
      initialVideoCodecForAudioTab,
      initialVideoCodecForVideoTab
    }
  ] = useState88(() => {
    return getDefaultCodecs({
      defaultConfigurationVideoCodec,
      compositionDefaultVideoCodec: resolvedComposition.defaultCodec,
      defaultConfigurationAudioCodec,
      renderType: renderTypeOfLastRender ?? (isVideo ? "video" : "still")
    });
  });
  const [state, dispatch] = useReducer2(reducer2, initialState2);
  const [unclampedFrame, setFrame] = useState88(() => initialFrame);
  const [saving, setSaving] = useState88(false);
  const [stillImageFormat, setStillImageFormat] = useState88(() => initialStillImageFormat);
  const [videoImageFormat, setVideoImageFormat] = useState88(() => initialVideoImageFormat ?? resolvedComposition.defaultVideoImageFormat ?? renderDefaults.videoImageFormat);
  const [sequenceImageFormat, setSequenceImageFormat] = useState88(() => initialStillImageFormat === "jpeg" ? "jpeg" : "png");
  const [concurrency, setConcurrency] = useState88(() => initialConcurrency);
  const [videoCodecForVideoTab, setVideoCodecForVideoTab] = useState88(() => initialVideoCodecForVideoTab);
  const [userSelectedAudioCodec, setUserSelectedAudioCodec] = useState88(() => initialAudioCodec);
  const [separateAudioTo, setSeparateAudioTo] = useState88(null);
  const [envVariables, setEnvVariables] = useState88(() => envVariablesObjectToArray(initialEnvVariables).filter(([key5]) => key5 !== "NODE_ENV"));
  const [initialOutName] = useState88(() => {
    return getDefaultOutLocation({
      compositionName: resolvedComposition.id,
      defaultExtension: initialRenderType === "still" ? initialStillImageFormat : isVideo ? BrowserSafeApis11.getFileExtensionFromCodec(initialVideoCodec, initialAudioCodec) : initialStillImageFormat,
      type: "asset",
      compositionDefaultOutName: resolvedComposition.defaultOutName,
      outputLocation: renderDefaults.outputLocation
    });
  });
  const [videoCodecForAudioTab, setVideoCodecForAudioTab] = useState88(() => initialVideoCodecForAudioTab);
  const [mutedState, setMuted] = useState88(() => initialMuted);
  const [repro, setRepro] = useState88(() => initialRepro);
  const [enforceAudioTrackState, setEnforceAudioTrackState] = useState88(() => initialEnforceAudioTrack);
  const [forSeamlessAacConcatenation, setForSeamlessAacConcatenation] = useState88(() => initialForSeamlessAacConcatenation);
  const [renderMode, setRenderModeState] = useState88(initialRenderType);
  const [jpegQuality, setJpegQuality] = useState88(() => initialJpegQuality);
  const [scale, setScale] = useState88(() => initialScale);
  const [logLevel, setLogLevel] = useState88(() => initialLogLevel);
  const [disallowParallelEncoding, setDisallowParallelEncoding] = useState88(false);
  const [disableWebSecurity, setDisableWebSecurity] = useState88(() => initialDisableWebSecurity);
  const [headless, setHeadless] = useState88(() => initialHeadless);
  const [beepOnFinish, setBeepOnFinish] = useState88(() => initialBeep);
  const [ignoreCertificateErrors, setIgnoreCertificateErrors] = useState88(() => initialIgnoreCertificateErrors);
  const [multiProcessOnLinux, setChromiumMultiProcessOnLinux] = useState88(() => initialMultiProcessOnLinux);
  const [darkMode, setDarkMode] = useState88(() => initialDarkMode);
  const [openGlOption, setOpenGlOption] = useState88(() => initialGl ?? "default");
  const [colorSpace, setColorSpace] = useState88(() => initialColorSpace);
  const [userAgent, setUserAgent] = useState88(() => initialUserAgent === null ? null : initialUserAgent.trim() === "" ? null : initialUserAgent);
  const chromiumOptions = useMemo137(() => {
    return {
      headless,
      disableWebSecurity,
      ignoreCertificateErrors,
      gl: openGlOption === "default" ? null : openGlOption,
      userAgent: userAgent === null ? null : userAgent.trim() === "" ? null : userAgent,
      enableMultiProcessOnLinux: multiProcessOnLinux,
      darkMode
    };
  }, [
    headless,
    disableWebSecurity,
    ignoreCertificateErrors,
    openGlOption,
    userAgent,
    multiProcessOnLinux,
    darkMode
  ]);
  const [outName, setOutName] = useState88(() => initialOutName);
  const [endFrameOrNull, setEndFrame] = useState88(() => outFrameMark ?? null);
  const [startFrameOrNull, setStartFrame] = useState88(() => inFrameMark ?? null);
  const [proResProfileSetting, setProResProfile] = useState88(() => initialProResProfile ?? resolvedComposition.defaultProResProfile ?? "hq");
  const [x264PresetSetting, setx264Preset] = useState88(() => initialx264Preset);
  const [hardwareAcceleration, setHardwareAcceleration] = useState88(() => initialHardwareAcceleration);
  const [userPreferredPixelFormat, setPixelFormat] = useState88(() => initialPixelFormat ?? resolvedComposition.defaultPixelFormat ?? renderDefaults.pixelFormat);
  const [preferredQualityControlType, setQualityControl] = useState88(() => initialVideoBitrate === null ? "crf" : "bitrate");
  const [
    shouldHaveCustomTargetAudioBitrate,
    setShouldHaveCustomTargetAudioBitrate
  ] = useState88(() => initialAudioBitrate !== null);
  const [customTargetAudioBitrate, setCustomTargetAudioBitrateValue] = useState88(() => initialAudioBitrate ?? "320K");
  const [customTargetVideoBitrate, setCustomTargetVideoBitrateValue] = useState88(() => initialVideoBitrate ?? "1M");
  const [encodingMaxRate, setEncodingMaxRate] = useState88(() => initialEncodingMaxRate ?? null);
  const [encodingBufferSize, setEncodingBufferSize] = useState88(() => initialEncodingBufferSize ?? null);
  const [limitNumberOfGifLoops, setLimitNumberOfGifLoops] = useState88(() => initialNumberOfGifLoops !== null);
  const [numberOfGifLoopsSetting, setNumberOfGifLoopsSetting] = useState88(() => initialNumberOfGifLoops ?? 0);
  const [delayRenderTimeout, setDelayRenderTimeout] = useState88(() => initialDelayRenderTimeout);
  const [chromeMode, setChromeMode] = useState88(() => initialChromeMode);
  const [offthreadVideoCacheSizeInBytes, setOffthreadVideoCacheSizeInBytes] = useState88(initialOffthreadVideoCacheSizeInBytes);
  const [mediaCacheSizeInBytes, setMediaCacheSizeInBytes] = useState88(initialMediaCacheSizeInBytes);
  const [offthreadVideoThreads, setOffthreadVideoThreads] = useState88(() => initialOffthreadVideoThreads);
  const codec = useMemo137(() => {
    if (renderMode === "audio") {
      return videoCodecForAudioTab;
    }
    return videoCodecForVideoTab;
  }, [videoCodecForAudioTab, renderMode, videoCodecForVideoTab]);
  const numberOfGifLoops = useMemo137(() => {
    if (codec === "gif" && limitNumberOfGifLoops) {
      return numberOfGifLoopsSetting;
    }
    return null;
  }, [codec, limitNumberOfGifLoops, numberOfGifLoopsSetting]);
  const audioBitrate = useMemo137(() => {
    if (shouldHaveCustomTargetAudioBitrate) {
      return customTargetAudioBitrate;
    }
    return null;
  }, [customTargetAudioBitrate, shouldHaveCustomTargetAudioBitrate]);
  const supportsCrf = BrowserSafeApis11.codecSupportsCrf(codec);
  const supportsVideoBitrate = BrowserSafeApis11.codecSupportsVideoBitrate(codec);
  const supportsBothQualityControls = useMemo137(() => {
    return supportsCrf && supportsVideoBitrate && hardwareAcceleration !== "if-possible" && hardwareAcceleration !== "required";
  }, [hardwareAcceleration, supportsCrf, supportsVideoBitrate]);
  const qualityControlType = useMemo137(() => {
    if (hardwareAcceleration === "if-possible" || hardwareAcceleration === "required") {
      if (supportsVideoBitrate) {
        return "bitrate";
      }
      return null;
    }
    if (supportsBothQualityControls) {
      return preferredQualityControlType;
    }
    if (supportsCrf) {
      return "crf";
    }
    if (supportsVideoBitrate) {
      return "bitrate";
    }
    return null;
  }, [
    hardwareAcceleration,
    preferredQualityControlType,
    supportsBothQualityControls,
    supportsCrf,
    supportsVideoBitrate
  ]);
  const videoBitrate = useMemo137(() => {
    if (qualityControlType === "bitrate") {
      return customTargetVideoBitrate;
    }
    return null;
  }, [customTargetVideoBitrate, qualityControlType]);
  const { crf, maxCrf, minCrf, setCrf } = useCrfState(codec);
  const dispatchIfMounted = useCallback136((payload) => {
    if (isMounted.current === false)
      return;
    dispatch(payload);
  }, []);
  const muted = useMemo137(() => {
    if (renderMode === "video") {
      return mutedState;
    }
    return false;
  }, [mutedState, renderMode]);
  const enforceAudioTrack = useMemo137(() => {
    if (renderMode === "video") {
      return enforceAudioTrackState;
    }
    if (renderMode === "audio") {
      return enforceAudioTrackState;
    }
    return false;
  }, [enforceAudioTrackState, renderMode]);
  const proResProfile = useMemo137(() => {
    if (renderMode === "video" && codec === "prores") {
      return proResProfileSetting;
    }
    return null;
  }, [codec, proResProfileSetting, renderMode]);
  const x264Preset = useMemo137(() => {
    if (renderMode === "video" && codec === "h264") {
      return x264PresetSetting;
    }
    return null;
  }, [codec, x264PresetSetting, renderMode]);
  const [inputProps, setInputProps] = useState88(() => defaultProps);
  const [metadata] = useState88(() => defaultMetadata);
  const endFrame = useMemo137(() => {
    if (endFrameOrNull === null) {
      return resolvedComposition.durationInFrames - 1;
    }
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, endFrameOrNull));
  }, [resolvedComposition.durationInFrames, endFrameOrNull]);
  const startFrame = useMemo137(() => {
    if (startFrameOrNull === null) {
      return 0;
    }
    return Math.max(0, Math.min(endFrame - 1, startFrameOrNull));
  }, [endFrame, startFrameOrNull]);
  const frame2 = useMemo137(() => {
    const parsed = Math.floor(unclampedFrame);
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, parsed));
  }, [resolvedComposition.durationInFrames, unclampedFrame]);
  const deriveFinalAudioCodec = useCallback136((passedVideoCodec, passedAudioCodec) => {
    if (passedAudioCodec !== null && BrowserSafeApis11.supportedAudioCodecs[passedVideoCodec].includes(passedAudioCodec)) {
      return passedAudioCodec;
    }
    return BrowserSafeApis11.defaultAudioCodecs[passedVideoCodec].compressed;
  }, []);
  const setDefaultOutName = useCallback136((options) => {
    if (options.type === "still") {
      setOutName((prev) => {
        const newFileName = getStringBeforeSuffix(prev) + "." + options.imageFormat;
        return newFileName;
      });
    } else if (options.type === "sequence") {
      setOutName((prev) => {
        const folderName = getStringBeforeSuffix(prev);
        return folderName;
      });
    } else {
      setOutName((prev) => {
        const codecSuffix = BrowserSafeApis11.getFileExtensionFromCodec(options.codec, deriveFinalAudioCodec(options.codec, options.audioCodec));
        const newFileName = getStringBeforeSuffix(prev) + "." + codecSuffix;
        return newFileName;
      });
    }
  }, [deriveFinalAudioCodec]);
  const setAudioCodec = useCallback136((newAudioCodec) => {
    setUserSelectedAudioCodec(newAudioCodec);
    setDefaultOutName({
      type: "render",
      codec: videoCodecForVideoTab,
      audioCodec: newAudioCodec
    });
    setSeparateAudioTo((prev) => {
      if (prev === null) {
        return null;
      }
      const newExtension = BrowserSafeApis11.getExtensionFromAudioCodec(newAudioCodec);
      const newFileName = getStringBeforeSuffix(prev) + "." + newExtension;
      return newFileName;
    });
  }, [setDefaultOutName, videoCodecForVideoTab]);
  const setCodec = useCallback136((newCodec) => {
    if (renderMode === "audio") {
      setVideoCodecForAudioTab(newCodec);
    } else {
      setVideoCodecForVideoTab(newCodec);
    }
    setDefaultOutName({
      type: "render",
      codec: newCodec,
      audioCodec: deriveFinalAudioCodec(newCodec, userSelectedAudioCodec)
    });
  }, [
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    renderMode,
    setDefaultOutName
  ]);
  const setStillFormat = useCallback136((format) => {
    setStillImageFormat(format);
    setDefaultOutName({ type: "still", imageFormat: format });
  }, [setDefaultOutName]);
  const { setSidebarCollapsedState } = useContext89(SidebarContext);
  const onClickStill = useCallback136(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addStillRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: stillImageFormat,
      jpegQuality,
      frame: frame2,
      scale,
      logLevel,
      chromiumOptions,
      delayRenderTimeout,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      multiProcessOnLinux,
      beepOnFinish,
      metadata,
      chromeMode,
      offthreadVideoThreads,
      mediaCacheSizeInBytes
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    stillImageFormat,
    jpegQuality,
    frame2,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    multiProcessOnLinux,
    beepOnFinish,
    setSelectedModal,
    metadata,
    chromeMode,
    offthreadVideoThreads,
    mediaCacheSizeInBytes
  ]);
  const [everyNthFrameSetting, setEveryNthFrameSetting] = useState88(() => initialEveryNthFrame);
  const everyNthFrame = useMemo137(() => {
    if (codec === "gif") {
      return everyNthFrameSetting;
    }
    return 1;
  }, [codec, everyNthFrameSetting]);
  const audioCodec = deriveFinalAudioCodec(codec, userSelectedAudioCodec);
  const availablePixelFormats = useMemo137(() => {
    return BrowserSafeApis11.validPixelFormatsForCodec(codec);
  }, [codec]);
  const pixelFormat = useMemo137(() => {
    if (availablePixelFormats.includes(userPreferredPixelFormat)) {
      return userPreferredPixelFormat;
    }
    return availablePixelFormats[0];
  }, [availablePixelFormats, userPreferredPixelFormat]);
  const onClickVideo = useCallback136(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addVideoRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: videoImageFormat,
      jpegQuality: stillImageFormat === "jpeg" ? jpegQuality : null,
      scale,
      logLevel,
      codec,
      concurrency,
      crf: qualityControlType === "crf" && hardwareAcceleration !== "if-possible" && hardwareAcceleration !== "required" ? crf : null,
      endFrame,
      startFrame,
      muted,
      enforceAudioTrack,
      proResProfile,
      x264Preset,
      pixelFormat,
      audioBitrate,
      videoBitrate,
      everyNthFrame,
      numberOfGifLoops,
      delayRenderTimeout,
      audioCodec,
      disallowParallelEncoding,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      colorSpace,
      multiProcessOnLinux,
      encodingBufferSize,
      encodingMaxRate,
      beepOnFinish,
      repro,
      forSeamlessAacConcatenation,
      separateAudioTo,
      metadata,
      hardwareAcceleration,
      chromeMode,
      offthreadVideoThreads,
      mediaCacheSizeInBytes
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    videoImageFormat,
    stillImageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    qualityControlType,
    crf,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    setSelectedModal,
    metadata,
    hardwareAcceleration,
    chromeMode,
    offthreadVideoThreads,
    mediaCacheSizeInBytes
  ]);
  const onClickSequence = useCallback136(() => {
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    dispatchIfMounted({ type: "start" });
    addSequenceRenderJob({
      compositionId: resolvedComposition.id,
      outName,
      imageFormat: sequenceImageFormat,
      scale,
      logLevel,
      concurrency,
      endFrame,
      jpegQuality,
      startFrame,
      delayRenderTimeout,
      chromiumOptions,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps,
      offthreadVideoCacheSizeInBytes,
      disallowParallelEncoding,
      multiProcessOnLinux,
      beepOnFinish,
      repro,
      metadata,
      chromeMode,
      offthreadVideoThreads,
      mediaCacheSizeInBytes
    }).then(() => {
      dispatchIfMounted({ type: "succeed" });
      setSelectedModal(null);
    }).catch(() => {
      dispatchIfMounted({ type: "fail" });
    });
  }, [
    setSidebarCollapsedState,
    dispatchIfMounted,
    resolvedComposition.id,
    outName,
    sequenceImageFormat,
    scale,
    logLevel,
    concurrency,
    endFrame,
    jpegQuality,
    startFrame,
    delayRenderTimeout,
    chromiumOptions,
    envVariables,
    inputProps,
    offthreadVideoCacheSizeInBytes,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    setSelectedModal,
    metadata,
    chromeMode,
    offthreadVideoThreads,
    mediaCacheSizeInBytes
  ]);
  useEffect85(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const imageFormatOptions = useMemo137(() => {
    if (renderMode === "still") {
      return [
        {
          label: "PNG",
          onClick: () => setStillFormat("png"),
          key: "png",
          selected: stillImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setStillFormat("jpeg"),
          key: "jpeg",
          selected: stillImageFormat === "jpeg"
        },
        {
          label: "PDF",
          onClick: () => setStillFormat("pdf"),
          key: "pdf",
          selected: stillImageFormat === "pdf"
        },
        {
          label: "WebP",
          onClick: () => setStillFormat("webp"),
          key: "webp",
          selected: stillImageFormat === "webp"
        }
      ];
    }
    if (renderMode === "sequence") {
      return [
        {
          label: "PNG",
          onClick: () => setSequenceImageFormat("png"),
          key: "png",
          selected: sequenceImageFormat === "png"
        },
        {
          label: "JPEG",
          onClick: () => setSequenceImageFormat("jpeg"),
          key: "jpeg",
          selected: sequenceImageFormat === "jpeg"
        }
      ];
    }
    return [
      {
        label: "PNG",
        onClick: () => setVideoImageFormat("png"),
        key: "png",
        selected: videoImageFormat === "png"
      },
      {
        label: "JPEG",
        onClick: () => setVideoImageFormat("jpeg"),
        key: "jpeg",
        selected: videoImageFormat === "jpeg"
      }
    ];
  }, [
    renderMode,
    videoImageFormat,
    stillImageFormat,
    setStillFormat,
    sequenceImageFormat
  ]);
  const setRenderMode = useCallback136((newRenderMode) => {
    setRenderModeState(newRenderMode);
    if (newRenderMode === "audio") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForAudioTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForAudioTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "video") {
      setDefaultOutName({
        type: "render",
        codec: videoCodecForVideoTab,
        audioCodec: deriveFinalAudioCodec(videoCodecForVideoTab, userSelectedAudioCodec)
      });
    }
    if (newRenderMode === "still") {
      setDefaultOutName({ type: "still", imageFormat: stillImageFormat });
    }
    if (newRenderMode === "sequence") {
      setDefaultOutName({ type: "sequence" });
    }
  }, [
    videoCodecForAudioTab,
    userSelectedAudioCodec,
    deriveFinalAudioCodec,
    setDefaultOutName,
    stillImageFormat,
    videoCodecForVideoTab
  ]);
  const renderTabOptions = useMemo137(() => {
    if (resolvedComposition?.durationInFrames < 2) {
      return [
        {
          label: "Still",
          onClick: () => {
            setRenderMode("still");
          },
          key: "still",
          selected: renderMode === "still"
        }
      ];
    }
    return [
      {
        label: "Still",
        onClick: () => {
          setRenderMode("still");
        },
        key: "still",
        selected: renderMode === "still"
      },
      {
        label: "Video",
        onClick: () => {
          setRenderMode("video");
        },
        key: "video",
        selected: renderMode === "video"
      },
      {
        label: "Audio",
        onClick: () => {
          setRenderMode("audio");
        },
        key: "audio",
        selected: renderMode === "audio"
      },
      {
        label: "Image sequence",
        onClick: () => {
          setRenderMode("sequence");
        },
        key: "sequence",
        selected: renderMode === "sequence"
      }
    ];
  }, [resolvedComposition?.durationInFrames, renderMode, setRenderMode]);
  const outnameValidation = validateOutnameGui({
    outName,
    codec,
    audioCodec,
    renderMode,
    stillImageFormat,
    separateAudioTo
  });
  const { tab, setTab, shownTabs } = useRenderModalSections(renderMode, codec);
  const { registerKeybinding } = useKeybinding();
  const readOnlyRenderCommand = useMemo137(() => {
    if (!readOnlyStudio) {
      return null;
    }
    return makeReadOnlyStudioRenderCommand({
      remotionVersion: window.remotion_version,
      locationHref: window.location.href,
      compositionId: resolvedComposition.id,
      outName,
      renderMode,
      renderDefaults,
      durationInFrames: resolvedComposition.durationInFrames,
      concurrency,
      frame: frame2,
      startFrame,
      endFrame,
      stillImageFormat,
      sequenceImageFormat,
      videoImageFormat,
      jpegQuality: renderMode === "video" ? stillImageFormat === "jpeg" ? jpegQuality : null : renderMode === "audio" ? null : jpegQuality,
      codec,
      muted,
      enforceAudioTrack,
      proResProfile,
      x264Preset,
      pixelFormat,
      crf: qualityControlType === "crf" && hardwareAcceleration !== "if-possible" && hardwareAcceleration !== "required" ? crf : null,
      videoBitrate,
      audioBitrate,
      audioCodec,
      everyNthFrame,
      numberOfGifLoops,
      disallowParallelEncoding,
      encodingBufferSize,
      encodingMaxRate,
      forSeamlessAacConcatenation,
      separateAudioTo,
      colorSpace,
      scale,
      logLevel,
      delayRenderTimeout,
      hardwareAcceleration,
      chromeMode,
      headless,
      disableWebSecurity,
      ignoreCertificateErrors,
      gl: openGlOption === "default" ? null : openGlOption,
      userAgent,
      multiProcessOnLinux,
      darkMode,
      offthreadVideoCacheSizeInBytes,
      offthreadVideoThreads,
      mediaCacheSizeInBytes,
      beepOnFinish,
      repro,
      metadata,
      envVariables: envVariablesArrayToObject(envVariables),
      inputProps
    });
  }, [
    audioBitrate,
    audioCodec,
    beepOnFinish,
    chromeMode,
    codec,
    colorSpace,
    concurrency,
    crf,
    darkMode,
    delayRenderTimeout,
    disableWebSecurity,
    disallowParallelEncoding,
    endFrame,
    encodingBufferSize,
    encodingMaxRate,
    enforceAudioTrack,
    envVariables,
    everyNthFrame,
    frame2,
    forSeamlessAacConcatenation,
    hardwareAcceleration,
    headless,
    ignoreCertificateErrors,
    inputProps,
    jpegQuality,
    logLevel,
    mediaCacheSizeInBytes,
    metadata,
    multiProcessOnLinux,
    muted,
    numberOfGifLoops,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    openGlOption,
    outName,
    pixelFormat,
    proResProfile,
    qualityControlType,
    readOnlyStudio,
    renderDefaults,
    renderMode,
    repro,
    resolvedComposition.durationInFrames,
    resolvedComposition.id,
    scale,
    separateAudioTo,
    sequenceImageFormat,
    startFrame,
    stillImageFormat,
    userAgent,
    videoImageFormat,
    videoBitrate,
    x264Preset
  ]);
  const [commandCopiedAt, setCommandCopiedAt] = useState88(null);
  const renderDisabled = readOnlyStudio ? false : !outnameValidation.valid || state.type === "load";
  const trigger = useCallback136(() => {
    if (readOnlyStudio) {
      if (!readOnlyRenderCommand) {
        return;
      }
      copyText(readOnlyRenderCommand).then(() => {
        setCommandCopiedAt(Date.now());
      }).catch((err) => {
        showNotification(`Could not copy: ${err.message}`, 2000);
      });
      return;
    }
    if (renderMode === "still") {
      onClickStill();
    } else if (renderMode === "sequence") {
      onClickSequence();
    } else {
      onClickVideo();
    }
  }, [
    onClickSequence,
    onClickStill,
    onClickVideo,
    readOnlyRenderCommand,
    readOnlyStudio,
    renderMode
  ]);
  useEffect85(() => {
    if (commandCopiedAt === null) {
      return;
    }
    const timeout = setTimeout(() => {
      setCommandCopiedAt(null);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [commandCopiedAt]);
  useEffect85(() => {
    if (renderDisabled) {
      return;
    }
    const enter = registerKeybinding({
      callback() {
        trigger();
      },
      commandCtrlKey: true,
      key: "Enter",
      event: "keydown",
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      enter.unregister();
    };
  }, [registerKeybinding, renderDisabled, trigger]);
  const pixelFormatOptions = useMemo137(() => {
    return availablePixelFormats.map((option) => {
      return {
        label: option,
        onClick: () => setPixelFormat(option),
        key: option,
        id: option,
        keyHint: null,
        leftItem: pixelFormat === option ? /* @__PURE__ */ jsx269(Checkmark, {}) : null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: option
      };
    });
  }, [availablePixelFormats, pixelFormat]);
  return /* @__PURE__ */ jsxs140("div", {
    style: outerModalStyle,
    children: [
      /* @__PURE__ */ jsx269(ModalHeader, {
        title: `Render ${resolvedComposition.id}`
      }),
      /* @__PURE__ */ jsxs140("div", {
        style: container54,
        children: [
          /* @__PURE__ */ jsx269(SegmentedControl, {
            items: renderTabOptions,
            needsWrapping: false
          }),
          /* @__PURE__ */ jsx269("div", {
            style: flexer
          }),
          /* @__PURE__ */ jsxs140(Button, {
            autoFocus: true,
            onClick: trigger,
            disabled: renderDisabled,
            style: {
              ...buttonStyle7,
              backgroundColor: outnameValidation.valid ? BLUE : BLUE_DISABLED
            },
            children: [
              readOnlyStudio ? commandCopiedAt ? "Copied command!" : "Copy command" : state.type === "idle" ? `Render ${renderMode}` : "Rendering...",
              /* @__PURE__ */ jsx269(ShortcutHint, {
                keyToPress: "↵",
                cmdOrCtrl: true
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsxs140("div", {
        style: horizontalLayout,
        children: [
          /* @__PURE__ */ jsxs140("div", {
            style: leftSidebar,
            children: [
              shownTabs.includes("general") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "general",
                onClick: () => setTab("general"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(FileIcon, {
                      style: icon6
                    })
                  }),
                  "General"
                ]
              }) : null,
              shownTabs.includes("data") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "data",
                onClick: () => setTab("data"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(DataIcon, {
                      style: icon6
                    })
                  }),
                  "Input Props"
                ]
              }) : null,
              shownTabs.includes("picture") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "picture",
                onClick: () => setTab("picture"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(PicIcon, {
                      style: icon6
                    })
                  }),
                  "Picture"
                ]
              }) : null,
              shownTabs.includes("audio") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "audio",
                onClick: () => setTab("audio"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(AudioIcon, {
                      style: icon6
                    })
                  }),
                  "Audio"
                ]
              }) : null,
              shownTabs.includes("gif") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "gif",
                onClick: () => setTab("gif"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(GifIcon, {
                      style: icon6
                    })
                  }),
                  "GIF"
                ]
              }) : null,
              shownTabs.includes("advanced") ? /* @__PURE__ */ jsxs140(VerticalTab, {
                style: horizontalTab,
                selected: tab === "advanced",
                onClick: () => setTab("advanced"),
                children: [
                  /* @__PURE__ */ jsx269("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx269(GearIcon, {
                      style: icon6
                    })
                  }),
                  "Other"
                ]
              }) : null
            ]
          }),
          /* @__PURE__ */ jsx269("div", {
            style: optionsPanel,
            className: VERTICAL_SCROLLBAR_CLASSNAME,
            children: tab === "general" ? /* @__PURE__ */ jsx269(RenderModalBasic, {
              codec,
              resolvedComposition,
              frame: frame2,
              imageFormatOptions,
              outName,
              proResProfile,
              renderMode,
              setVideoCodec: setCodec,
              setFrame,
              setOutName,
              setProResProfile,
              endFrame,
              setEndFrame,
              setStartFrame,
              setVerboseLogging: setLogLevel,
              logLevel,
              showOutputName: !readOnlyStudio,
              startFrame,
              validationMessage: outnameValidation.valid ? null : outnameValidation.error.message
            }) : tab === "picture" ? /* @__PURE__ */ jsx269(RenderModalPicture, {
              renderMode,
              scale,
              setScale,
              pixelFormat,
              pixelFormatOptions,
              imageFormatOptions,
              crf,
              setCrf,
              customTargetVideoBitrate,
              maxCrf,
              minCrf,
              jpegQuality,
              qualityControlType,
              setJpegQuality,
              setColorSpace,
              colorSpace,
              setCustomTargetVideoBitrateValue,
              setQualityControl,
              videoImageFormat,
              stillImageFormat,
              shouldDisplayQualityControlPicker: supportsBothQualityControls,
              encodingBufferSize,
              setEncodingBufferSize,
              encodingMaxRate,
              setEncodingMaxRate,
              compositionWidth: resolvedComposition.width,
              compositionHeight: resolvedComposition.height
            }) : tab === "audio" ? /* @__PURE__ */ jsx269(RenderModalAudio, {
              muted,
              renderMode,
              setMuted,
              codec,
              audioCodec,
              setAudioCodec,
              enforceAudioTrack,
              setEnforceAudioTrackState,
              customTargetAudioBitrate,
              setCustomTargetAudioBitrateValue,
              setShouldHaveCustomTargetAudioBitrate,
              shouldHaveCustomTargetAudioBitrate,
              forSeamlessAacConcatenation,
              setForSeamlessAacConcatenation,
              separateAudioTo,
              setSeparateAudioTo,
              outName
            }) : tab === "gif" ? /* @__PURE__ */ jsx269(RenderModalGif, {
              everyNthFrame,
              limitNumberOfGifLoops,
              numberOfGifLoopsSetting,
              setEveryNthFrameSetting,
              setLimitNumberOfGifLoops,
              setNumberOfGifLoopsSetting
            }) : tab === "data" ? /* @__PURE__ */ jsx269(DataEditor, {
              defaultProps: inputProps,
              setDefaultProps: setInputProps,
              unresolvedComposition,
              mayShowSaveButton: false,
              propsEditType: "input-props",
              saving,
              setSaving,
              readOnlyStudio
            }) : /* @__PURE__ */ jsx269(RenderModalAdvanced, {
              x264Preset,
              setx264Preset,
              concurrency,
              maxConcurrency,
              minConcurrency,
              renderMode,
              setConcurrency,
              delayRenderTimeout,
              setDelayRenderTimeout,
              disallowParallelEncoding,
              setDisallowParallelEncoding,
              setDisableWebSecurity,
              setIgnoreCertificateErrors,
              setHeadless,
              headless,
              ignoreCertificateErrors,
              disableWebSecurity,
              openGlOption,
              setOpenGlOption,
              setEnvVariables,
              envVariables,
              offthreadVideoCacheSizeInBytes,
              setMediaCacheSizeInBytes,
              mediaCacheSizeInBytes,
              setOffthreadVideoCacheSizeInBytes,
              offthreadVideoThreads,
              setOffthreadVideoThreads,
              enableMultiProcessOnLinux: multiProcessOnLinux,
              setChromiumMultiProcessOnLinux,
              codec,
              userAgent,
              setUserAgent,
              setBeep: setBeepOnFinish,
              beep: beepOnFinish,
              repro,
              setRepro,
              hardwareAcceleration,
              setHardwareAcceleration,
              chromeModeOption: chromeMode,
              setChromeModeOption: setChromeMode,
              darkMode,
              setDarkMode
            })
          })
        ]
      })
    ]
  });
};
var RenderModalWithLoader = (props) => {
  return /* @__PURE__ */ jsx269(DismissableModal, {
    children: /* @__PURE__ */ jsx269(ResolveCompositionBeforeModal, {
      compositionId: props.compositionId,
      children: /* @__PURE__ */ jsx269(RenderModal, {
        ...props
      })
    })
  });
};

// src/components/RenderModal/WebRenderModal.tsx
import { getDefaultOutLocation as getDefaultOutLocation2 } from "@remotion/studio-shared";
import {
  getDefaultAudioCodecForContainer,
  getDefaultContainerForCodec,
  getDefaultVideoCodecForContainer,
  isAudioOnlyContainer
} from "@remotion/web-renderer";
import { useCallback as useCallback140, useContext as useContext90, useMemo as useMemo142, useState as useState92 } from "react";

// src/icons/certificate.tsx
import { jsx as jsx270 } from "react/jsx-runtime";
var CertificateIcon = (props) => /* @__PURE__ */ jsx270("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512",
  ...props,
  children: /* @__PURE__ */ jsx270("path", {
    fill: "currentcolor",
    d: "M192 32l128 0 0 96c0 35.3 28.7 64 64 64l96 0 0 256c0 17.7-14.3 32-32 32l-192 0 0 32 192 0c35.3 0 64-28.7 64-64l0-261.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 80c10.9 0 21.6 1 32 2.9L160 64c0-17.7 14.3-32 32-32zM352 45.3L466.7 160 384 160c-17.7 0-32-14.3-32-32l0-82.7zM32 320a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM176 438.7l0 66.3-40.1-22.9c-4.9-2.8-11-2.8-15.9 0L80 505 80 438.7c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3zm32-18.8c29.3-23.5 48-59.5 48-99.9 0-70.7-57.3-128-128-128S0 249.3 0 320c0 40.4 18.7 76.5 48 99.9l0 101.8c0 12.3 10 22.3 22.3 22.3 3.9 0 7.7-1 11.1-2.9l46.6-26.6 46.6 26.6c3.4 1.9 7.2 2.9 11.1 2.9 12.3 0 22.3-10 22.3-22.3l0-101.8zM128 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-80a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
  })
});

// src/components/RenderModal/use-encodable-audio-codecs.ts
import {
  getEncodableAudioCodecs,
  getSupportedAudioCodecsForContainer
} from "@remotion/web-renderer";
import { useEffect as useEffect86, useRef as useRef46, useState as useState89 } from "react";
var useEncodableAudioCodecs = (container62) => {
  const cacheRef = useRef46({});
  const [codecsByContainer, setCodecsByContainer] = useState89(() => {
    return {
      [container62]: getSupportedAudioCodecsForContainer(container62)
    };
  });
  useEffect86(() => {
    const cached = cacheRef.current[container62];
    if (cached) {
      return;
    }
    const supported = getSupportedAudioCodecsForContainer(container62);
    cacheRef.current[container62] = {
      codecs: supported,
      status: "fetching"
    };
    getEncodableAudioCodecs(container62).then((encodable) => {
      cacheRef.current[container62] = {
        codecs: encodable,
        status: "done"
      };
      setCodecsByContainer((prev) => ({
        ...prev,
        [container62]: encodable
      }));
    }).catch(() => {
      cacheRef.current[container62] = {
        codecs: supported,
        status: "done"
      };
    });
  }, [container62]);
  return codecsByContainer[container62] ?? getSupportedAudioCodecsForContainer(container62);
};

// src/components/RenderModal/use-encodable-video-codecs.ts
import {
  getEncodableVideoCodecs,
  getSupportedVideoCodecsForContainer
} from "@remotion/web-renderer";
import { useEffect as useEffect87, useRef as useRef47, useState as useState90 } from "react";
var useEncodableVideoCodecs = (container62) => {
  const cacheRef = useRef47({});
  const [codecsByContainer, setCodecsByContainer] = useState90(() => {
    return {
      [container62]: getSupportedVideoCodecsForContainer(container62)
    };
  });
  useEffect87(() => {
    const cached = cacheRef.current[container62];
    if (cached) {
      return;
    }
    const supported = getSupportedVideoCodecsForContainer(container62);
    cacheRef.current[container62] = {
      codecs: supported,
      status: "fetching"
    };
    getEncodableVideoCodecs(container62).then((encodable) => {
      cacheRef.current[container62] = {
        codecs: encodable,
        status: "done"
      };
      setCodecsByContainer((prev) => ({
        ...prev,
        [container62]: encodable
      }));
    }).catch(() => {
      cacheRef.current[container62] = {
        codecs: supported,
        status: "done"
      };
    });
  }, [container62]);
  return codecsByContainer[container62] ?? getSupportedVideoCodecsForContainer(container62);
};

// src/components/RenderModal/WebRendererExperimentalBadge.tsx
import { jsx as jsx271, jsxs as jsxs141 } from "react/jsx-runtime";
var row9 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center"
};
var text3 = {
  fontSize: 14,
  fontFamily: "sans-serif",
  color: LIGHT_TEXT
};
var icon7 = {
  width: 14,
  height: 14,
  flexShrink: 0,
  fill: WARNING_COLOR,
  marginRight: 8
};
var link3 = {
  color: "inherit",
  textDecoration: "underline",
  fontSize: 14
};
var WebRendererExperimentalBadge = () => {
  return /* @__PURE__ */ jsxs141("div", {
    style: row9,
    children: [
      /* @__PURE__ */ jsx271(WarningTriangle, {
        type: "warning",
        style: icon7
      }),
      /* @__PURE__ */ jsxs141("div", {
        style: text3,
        children: [
          "The Remotion Web Renderer is experimental.",
          " ",
          /* @__PURE__ */ jsx271("a", {
            href: "https://github.com/remotion-dev/remotion/issues/5913",
            target: "_blank",
            rel: "noopener noreferrer",
            style: link3,
            children: "Track progress on GitHub"
          }),
          " ",
          "and discuss in the",
          " ",
          /* @__PURE__ */ jsx271("a", {
            href: "https://remotion.dev/discord",
            target: "_blank",
            rel: "noopener noreferrer",
            style: link3,
            children: "#web-renderer"
          }),
          " ",
          "channel on Discord."
        ]
      })
    ]
  });
};

// src/components/RenderModal/WebRenderModalAdvanced.tsx
import { useCallback as useCallback137, useMemo as useMemo138 } from "react";
import { jsx as jsx272, jsxs as jsxs142 } from "react/jsx-runtime";
var tabContainer = {
  flex: 1
};
var WebRenderModalAdvanced = ({
  renderMode,
  delayRenderTimeout,
  setDelayRenderTimeout,
  mediaCacheSizeInBytes,
  setMediaCacheSizeInBytes,
  hardwareAcceleration,
  setHardwareAcceleration
}) => {
  const toggleCustomMediaCacheSizeInBytes = useCallback137(() => {
    setMediaCacheSizeInBytes((previous) => {
      if (previous === null) {
        return 1000 * 1000 * 1000;
      }
      return null;
    });
  }, [setMediaCacheSizeInBytes]);
  const changeMediaCacheSizeInBytes = useCallback137((cb) => {
    setMediaCacheSizeInBytes((prev) => {
      if (prev === null) {
        throw new TypeError("Expected previous value");
      }
      if (typeof cb === "function") {
        return cb(prev);
      }
      return cb;
    });
  }, [setMediaCacheSizeInBytes]);
  const hardwareAccelerationOptions = useMemo138(() => {
    return [
      {
        label: "No Preference",
        onClick: () => setHardwareAcceleration("no-preference"),
        leftItem: hardwareAcceleration === "no-preference" ? /* @__PURE__ */ jsx272(Checkmark, {}) : null,
        id: "no-preference",
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "no-preference"
      },
      {
        label: "Prefer Hardware",
        onClick: () => setHardwareAcceleration("prefer-hardware"),
        leftItem: hardwareAcceleration === "prefer-hardware" ? /* @__PURE__ */ jsx272(Checkmark, {}) : null,
        id: "prefer-hardware",
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "prefer-hardware"
      },
      {
        label: "Prefer Software",
        onClick: () => setHardwareAcceleration("prefer-software"),
        leftItem: hardwareAcceleration === "prefer-software" ? /* @__PURE__ */ jsx272(Checkmark, {}) : null,
        id: "prefer-software",
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: "prefer-software"
      }
    ];
  }, [hardwareAcceleration, setHardwareAcceleration]);
  return /* @__PURE__ */ jsxs142("div", {
    style: tabContainer,
    children: [
      /* @__PURE__ */ jsx272(NumberSetting, {
        name: "Delay Render Timeout",
        formatter: (v) => `${v}ms`,
        min: 0,
        max: 1e9,
        step: 1000,
        value: delayRenderTimeout,
        onValueChanged: setDelayRenderTimeout,
        hint: "delayRenderTimeoutInMillisecondsOption"
      }),
      /* @__PURE__ */ jsxs142("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs142("div", {
            style: label5,
            children: [
              "Custom @remotion/media cache size ",
              /* @__PURE__ */ jsx272(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx272(OptionExplainerBubble, {
                id: "mediaCacheSizeInBytesOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx272("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx272(Checkbox, {
              checked: mediaCacheSizeInBytes !== null,
              onChange: toggleCustomMediaCacheSizeInBytes,
              name: "media-cache-size"
            })
          })
        ]
      }),
      mediaCacheSizeInBytes === null ? null : /* @__PURE__ */ jsx272(NumberSetting, {
        name: "@remotion/media cache size",
        formatter: (w) => `${w} bytes`,
        min: 0,
        max: 10000000000,
        step: 10 * 1024 * 1024,
        value: mediaCacheSizeInBytes,
        onValueChanged: changeMediaCacheSizeInBytes
      }),
      renderMode === "video" ? /* @__PURE__ */ jsxs142("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsx272("div", {
            style: label5,
            children: "Hardware Acceleration"
          }),
          /* @__PURE__ */ jsx272("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx272(Combobox, {
              values: hardwareAccelerationOptions,
              selectedId: hardwareAcceleration,
              title: "Hardware Acceleration"
            })
          })
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/WebRenderModalAudio.tsx
import { getSupportedAudioCodecsForContainer as getSupportedAudioCodecsForContainer2 } from "@remotion/web-renderer";
import { useMemo as useMemo139 } from "react";

// src/components/RenderModal/quality-options.tsx
import { jsx as jsx273 } from "react/jsx-runtime";
var QUALITY_OPTIONS = [
  { value: "very-low", label: "Very Low" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "very-high", label: "Very High" }
];
var getQualityOptions = (selectedQuality, setQuality) => {
  return QUALITY_OPTIONS.map(({ value, label: label12 }) => ({
    label: label12,
    onClick: () => setQuality(value),
    leftItem: selectedQuality === value ? /* @__PURE__ */ jsx273(Checkmark, {}) : null,
    id: value,
    keyHint: null,
    quickSwitcherLabel: null,
    subMenu: null,
    type: "item",
    value
  }));
};

// src/components/RenderModal/WebRenderModalAudio.tsx
import { jsx as jsx274, jsxs as jsxs143, Fragment as Fragment46 } from "react/jsx-runtime";
var container62 = {
  flex: 1,
  overflowY: "auto"
};
var fallbackNoticeStyle = {
  backgroundColor: "rgba(59, 130, 246, 0.15)",
  border: "1px solid rgba(59, 130, 246, 0.4)",
  borderRadius: 4,
  padding: "8px 12px",
  marginLeft: 16,
  marginRight: 16,
  marginTop: 8,
  fontSize: 13,
  lineHeight: 1.4,
  color: "#60a5fa"
};
var humanReadableWebAudioCodec = (audioCodec) => {
  switch (audioCodec) {
    case "aac":
      return "AAC";
    case "opus":
      return "Opus";
    case "mp3":
      return "MP3";
    case "vorbis":
      return "Vorbis";
    case "pcm-s16":
      return "Lossless (PCM)";
    case "flac":
      return "FLAC";
    default:
      throw new Error(`Unsupported audio codec: ${audioCodec}`);
  }
};
var WebRenderModalAudio = ({
  renderMode,
  muted,
  setMuted,
  audioCodec,
  setAudioCodec,
  audioBitrate,
  setAudioBitrate,
  container: videoContainer,
  encodableCodecs,
  effectiveAudioCodec
}) => {
  const containerSupported = useMemo139(() => getSupportedAudioCodecsForContainer2(videoContainer), [videoContainer]);
  const audioCodecOptions = useMemo139(() => {
    return containerSupported.map((codec) => {
      const isEncodable = encodableCodecs.includes(codec);
      return {
        label: humanReadableWebAudioCodec(codec),
        onClick: () => setAudioCodec(codec),
        leftItem: audioCodec === codec ? /* @__PURE__ */ jsx274(Checkmark, {}) : null,
        id: codec,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: codec,
        disabled: !isEncodable
      };
    });
  }, [containerSupported, encodableCodecs, audioCodec, setAudioCodec]);
  const audioBitrateOptions = useMemo139(() => getQualityOptions(audioBitrate, setAudioBitrate), [audioBitrate, setAudioBitrate]);
  const isAudioOnly = renderMode === "audio";
  const showAudioSettings = isAudioOnly || !muted;
  const showAudioCodecSetting = !isAudioOnly || containerSupported.length > 1;
  return /* @__PURE__ */ jsxs143("div", {
    style: container62,
    className: VERTICAL_SCROLLBAR_CLASSNAME,
    children: [
      isAudioOnly ? null : /* @__PURE__ */ jsx274(MutedSetting, {
        enforceAudioTrack: false,
        muted,
        setMuted
      }),
      showAudioSettings ? /* @__PURE__ */ jsxs143(Fragment46, {
        children: [
          isAudioOnly ? null : /* @__PURE__ */ jsx274(RenderModalHr, {}),
          /* @__PURE__ */ jsxs143("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs143("div", {
                style: label5,
                children: [
                  "Audio Quality",
                  /* @__PURE__ */ jsx274(Spacing, {
                    x: 0.5
                  })
                ]
              }),
              /* @__PURE__ */ jsx274("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx274(Combobox, {
                  values: audioBitrateOptions,
                  selectedId: audioBitrate,
                  title: "Audio Quality"
                })
              })
            ]
          }),
          showAudioCodecSetting ? /* @__PURE__ */ jsxs143("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs143("div", {
                style: label5,
                children: [
                  "Audio Codec",
                  /* @__PURE__ */ jsx274(Spacing, {
                    x: 0.5
                  })
                ]
              }),
              /* @__PURE__ */ jsx274("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx274(Combobox, {
                  values: audioCodecOptions,
                  selectedId: audioCodec,
                  title: "Audio Codec"
                })
              })
            ]
          }) : null,
          showAudioCodecSetting && effectiveAudioCodec !== audioCodec ? /* @__PURE__ */ jsxs143("div", {
            style: fallbackNoticeStyle,
            children: [
              humanReadableWebAudioCodec(audioCodec),
              " is not available in this browser. Using ",
              humanReadableWebAudioCodec(effectiveAudioCodec),
              " ",
              "instead."
            ]
          }) : null
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/WebRenderModalBasic.tsx
import { useMemo as useMemo140 } from "react";
import { jsx as jsx275, jsxs as jsxs144, Fragment as Fragment47 } from "react/jsx-runtime";
var tabContainer2 = {
  flex: 1
};
var containerLabels = {
  mp4: "MP4",
  webm: "WebM",
  mkv: "MKV",
  mov: "MOV",
  wav: "WAV",
  mp3: "MP3",
  aac: "AAC",
  ogg: "OGG",
  flac: "FLAC"
};
var videoContainers = ["mp4", "webm", "mkv", "mov"];
var audioContainers = [
  "wav",
  "mp3",
  "aac",
  "ogg",
  "flac"
];
var codecLabels = {
  h264: "H.264",
  h265: "H.265",
  vp8: "VP8",
  vp9: "VP9",
  av1: "AV1"
};
var WebRenderModalBasic = ({
  renderMode,
  resolvedComposition,
  imageFormat,
  setStillFormat,
  frame: frame2,
  onFrameChanged,
  onFrameSetDirectly,
  container: container63,
  setContainerFormat,
  setCodec,
  encodableVideoCodecs,
  effectiveVideoCodec,
  startFrame,
  setStartFrame,
  endFrame,
  setEndFrame,
  outName,
  onOutNameChange,
  validationMessage,
  logLevel,
  setLogLevel
}) => {
  const imageFormatOptions = useMemo140(() => {
    return [
      {
        label: "PNG",
        onClick: () => setStillFormat("png"),
        key: "png",
        selected: imageFormat === "png"
      },
      {
        label: "JPEG",
        onClick: () => setStillFormat("jpeg"),
        key: "jpeg",
        selected: imageFormat === "jpeg"
      },
      {
        label: "WebP",
        onClick: () => setStillFormat("webp"),
        key: "webp",
        selected: imageFormat === "webp"
      }
    ];
  }, [imageFormat, setStillFormat]);
  const logLevelOptions = useMemo140(() => {
    return ["trace", "verbose", "info", "warn", "error"].map((level) => {
      return {
        label: humanReadableLogLevel(level),
        onClick: () => setLogLevel(level),
        leftItem: logLevel === level ? /* @__PURE__ */ jsx275(Checkmark, {}) : null,
        id: level,
        keyHint: null,
        quickSwitcherLabel: null,
        subMenu: null,
        type: "item",
        value: level
      };
    });
  }, [logLevel, setLogLevel]);
  const containerOptions = useMemo140(() => {
    const containers = renderMode === "audio" ? audioContainers : videoContainers;
    return containers.map((c) => ({
      label: containerLabels[c],
      onClick: () => setContainerFormat(c),
      leftItem: container63 === c ? /* @__PURE__ */ jsx275(Checkmark, {}) : null,
      id: c,
      keyHint: null,
      quickSwitcherLabel: null,
      subMenu: null,
      type: "item",
      value: c
    }));
  }, [container63, setContainerFormat, renderMode]);
  const codecOptions = useMemo140(() => {
    return encodableVideoCodecs.map((c) => ({
      label: codecLabels[c],
      onClick: () => setCodec(c),
      leftItem: effectiveVideoCodec === c ? /* @__PURE__ */ jsx275(Checkmark, {}) : null,
      id: c,
      keyHint: null,
      quickSwitcherLabel: null,
      subMenu: null,
      type: "item",
      value: c
    }));
  }, [encodableVideoCodecs, effectiveVideoCodec, setCodec]);
  return /* @__PURE__ */ jsxs144("div", {
    style: tabContainer2,
    children: [
      renderMode === "still" ? /* @__PURE__ */ jsxs144(Fragment47, {
        children: [
          /* @__PURE__ */ jsxs144("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx275("div", {
                style: label5,
                children: "Format"
              }),
              /* @__PURE__ */ jsx275("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx275(SegmentedControl, {
                  items: imageFormatOptions,
                  needsWrapping: true
                })
              })
            ]
          }),
          resolvedComposition.durationInFrames > 1 ? /* @__PURE__ */ jsxs144("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx275("div", {
                style: label5,
                children: "Frame"
              }),
              /* @__PURE__ */ jsx275("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx275(RightAlignInput, {
                  children: /* @__PURE__ */ jsx275(InputDragger, {
                    value: frame2,
                    onTextChange: onFrameChanged,
                    placeholder: `0-${resolvedComposition.durationInFrames - 1}`,
                    onValueChange: onFrameSetDirectly,
                    name: "frame",
                    step: 1,
                    min: 0,
                    status: "ok",
                    max: resolvedComposition.durationInFrames - 1,
                    rightAlign: true
                  })
                })
              })
            ]
          }) : null
        ]
      }) : /* @__PURE__ */ jsxs144(Fragment47, {
        children: [
          /* @__PURE__ */ jsxs144("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx275("div", {
                style: label5,
                children: "Container"
              }),
              /* @__PURE__ */ jsx275("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx275(Combobox, {
                  values: containerOptions,
                  selectedId: container63,
                  title: "Container"
                })
              })
            ]
          }),
          renderMode === "video" ? /* @__PURE__ */ jsxs144("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsxs144("div", {
                style: label5,
                children: [
                  "Codec",
                  /* @__PURE__ */ jsx275(Spacing, {
                    x: 0.5
                  }),
                  /* @__PURE__ */ jsx275(OptionExplainerBubble, {
                    id: "videoCodecOption"
                  })
                ]
              }),
              /* @__PURE__ */ jsx275("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx275(Combobox, {
                  values: codecOptions,
                  selectedId: effectiveVideoCodec,
                  title: "Codec"
                })
              })
            ]
          }) : null,
          /* @__PURE__ */ jsx275(FrameRangeSetting, {
            durationInFrames: resolvedComposition.durationInFrames,
            startFrame: startFrame ?? 0,
            endFrame: endFrame ?? resolvedComposition.durationInFrames - 1,
            setStartFrame,
            setEndFrame
          })
        ]
      }),
      /* @__PURE__ */ jsx275(RenderModalOutputName, {
        existence: false,
        inputStyle: input,
        outName,
        onValueChange: onOutNameChange,
        validationMessage,
        label: window.remotion_isReadOnlyStudio ? "Download name" : "Output name"
      }),
      /* @__PURE__ */ jsxs144("div", {
        style: optionRow,
        children: [
          /* @__PURE__ */ jsxs144("div", {
            style: label5,
            children: [
              "Log Level ",
              /* @__PURE__ */ jsx275(Spacing, {
                x: 0.5
              }),
              /* @__PURE__ */ jsx275(OptionExplainerBubble, {
                id: "logLevelOption"
              })
            ]
          }),
          /* @__PURE__ */ jsx275("div", {
            style: rightRow,
            children: /* @__PURE__ */ jsx275(Combobox, {
              values: logLevelOptions,
              selectedId: logLevel,
              title: "Log Level"
            })
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/WebRenderModalLicense.tsx
import { useCallback as useCallback138, useEffect as useEffect88, useState as useState91 } from "react";

// src/icons/check-circle-filled.tsx
import { jsx as jsx276 } from "react/jsx-runtime";
var CheckCircleFilled = (props) => /* @__PURE__ */ jsx276("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  style: { width: 14, height: 14 },
  viewBox: "0 0 512 512",
  ...props,
  children: /* @__PURE__ */ jsx276("path", {
    d: "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z"
  })
});

// src/components/RenderModal/WebRenderModalLicenseKeyDetails.tsx
import { jsx as jsx277, jsxs as jsxs145 } from "react/jsx-runtime";
var textStyle2 = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "sans-serif",
  lineHeight: 1.5,
  display: "flex",
  alignItems: "center"
};
var linkStyle = {
  fontSize: 14,
  fontFamily: "sans-serif",
  lineHeight: 1.5,
  cursor: "pointer"
};
var bulletStyle = {
  display: "flex",
  alignItems: "center",
  gap: 6
};
var icon8 = {
  width: 14,
  height: 14,
  flexShrink: 0
};
var PRO_HOST = "https://remotion.pro";
var fetchLicenseKeyDetails = async (licenseKey) => {
  const response = await fetch(`${PRO_HOST}/api/validate-license-key`, {
    method: "POST",
    body: JSON.stringify({
      licenseKey
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response.json();
};
var WebRenderModalLicenseKeyDetails = ({ details }) => {
  return /* @__PURE__ */ jsxs145("div", {
    children: [
      /* @__PURE__ */ jsxs145("div", {
        style: bulletStyle,
        children: [
          /* @__PURE__ */ jsx277(CheckCircleFilled, {
            style: { ...icon8, fill: LIGHT_TEXT }
          }),
          /* @__PURE__ */ jsxs145("div", {
            style: textStyle2,
            children: [
              "Belongs to ",
              /* @__PURE__ */ jsx277("a", {
                href: `${PRO_HOST}/projects/${details.projectSlug}`,
                target: "_blank",
                style: linkStyle,
                children: details.projectName
              }),
              " - ",
              /* @__PURE__ */ jsx277("a", {
                href: `${PRO_HOST}/projects/${details.projectSlug}/usage#client-renders-usage`,
                target: "_blank",
                style: linkStyle,
                children: "View usage"
              })
            ]
          })
        ]
      }),
      details.hasActiveSubscription ? /* @__PURE__ */ jsxs145("div", {
        style: bulletStyle,
        children: [
          /* @__PURE__ */ jsx277(CheckCircleFilled, {
            style: { ...icon8, fill: LIGHT_TEXT }
          }),
          /* @__PURE__ */ jsx277("div", {
            style: textStyle2,
            children: "Active Company License"
          })
        ]
      }) : /* @__PURE__ */ jsxs145("div", {
        style: bulletStyle,
        children: [
          /* @__PURE__ */ jsx277(WarningTriangle, {
            type: "warning",
            style: { ...icon8, fill: WARNING_COLOR }
          }),
          /* @__PURE__ */ jsx277("div", {
            style: textStyle2,
            children: "No active Company License"
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/WebRenderModalLicense.tsx
import { jsx as jsx278, jsxs as jsxs146, Fragment as Fragment48 } from "react/jsx-runtime";
var row10 = {
  display: "flex",
  flexDirection: "row",
  paddingLeft: 16,
  paddingRight: 16
};
var tabContainer3 = {
  flex: 1
};
var descriptionStyle = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "sans-serif",
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 8,
  lineHeight: 1.5
};
var paddedDescriptionStyle = {
  color: LIGHT_TEXT,
  fontSize: 14,
  fontFamily: "sans-serif",
  padding: 9,
  border: "1px solid " + INPUT_BORDER_COLOR_UNHOVERED,
  borderRadius: 8,
  lineHeight: 1.5,
  marginLeft: 16,
  marginRight: 16
};
var descriptionLink = {
  color: "white",
  fontSize: 14
};
var checkboxLabel = {
  fontSize: 14,
  lineHeight: "40px",
  color: LIGHT_TEXT,
  flex: 1,
  fontFamily: "sans-serif",
  cursor: "pointer",
  userSelect: "none"
};
var inputStyle2 = {
  minWidth: 250
};
var justifyCenter = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  flex: 1
};
var codeStyle = {
  fontSize: 14,
  fontFamily: "monospace",
  color: BLUE
};
var codeLine = {
  fontSize: 14,
  fontFamily: "monospace",
  color: LIGHT_TEXT,
  backgroundColor: INPUT_BACKGROUND,
  padding: 6,
  borderRadius: 3,
  marginTop: 6,
  overflowX: "auto",
  maxWidth: "100%"
};
var codeLineSmall = {
  ...codeLine,
  fontSize: 11
};
var LICENSE_KEY_LENGTH = 55;
var LICENSE_KEY_PREFIX = "rm_pub_";
var validateLicenseKey = (key5) => {
  if (key5.length === 0) {
    return { valid: false, message: null, details: null };
  }
  if (!key5.startsWith(LICENSE_KEY_PREFIX)) {
    return {
      valid: false,
      message: `License key must start with "${LICENSE_KEY_PREFIX}"`,
      details: null
    };
  }
  const afterPrefix = key5.slice(LICENSE_KEY_PREFIX.length);
  if (!/^[a-zA-Z0-9]*$/.test(afterPrefix)) {
    return {
      valid: false,
      message: "License key must contain only alphanumeric characters after the prefix",
      details: null
    };
  }
  if (key5.length !== LICENSE_KEY_LENGTH) {
    return {
      valid: false,
      message: `License key must be ${LICENSE_KEY_LENGTH} characters long`,
      details: null
    };
  }
  return { valid: true, message: null, details: null };
};
var WebRenderModalLicense = ({
  licenseKey,
  setLicenseKey,
  initialPublicLicenseKey
}) => {
  const [licenseValidation, setLicenseValidation] = useState91({ valid: true, message: null, details: null });
  const [isLoading, setIsLoading] = useState91(false);
  useEffect88(() => {
    if (licenseKey === null || licenseKey === "free-license") {
      return setLicenseValidation({
        valid: true,
        message: null,
        details: null
      });
    }
    const validation = validateLicenseKey(licenseKey);
    if (!validation.valid) {
      return setLicenseValidation(validation);
    }
    setLicenseValidation({ valid: true, message: null, details: null });
    setIsLoading(true);
    fetchLicenseKeyDetails(licenseKey).then((details) => {
      setIsLoading(false);
      if (details.isValid) {
        setLicenseValidation({ valid: true, message: null, details });
      } else {
        setLicenseValidation({
          valid: false,
          message: "License key is invalid or has been reset",
          details: null
        });
      }
    }).catch(() => {
      setIsLoading(false);
      setLicenseValidation({
        valid: false,
        message: "Failed to fetch license key details",
        details: null
      });
    });
  }, [licenseKey]);
  const onFreeLicenseChange = useCallback138(() => {
    setLicenseKey("free-license");
  }, [setLicenseKey]);
  const onCompanyLicenseChange = useCallback138(() => {
    setLicenseKey(initialPublicLicenseKey ?? "");
  }, [initialPublicLicenseKey, setLicenseKey]);
  const onLicenseKeyChange = useCallback138((e) => {
    setLicenseKey(e.target.value);
  }, [setLicenseKey]);
  return /* @__PURE__ */ jsxs146("div", {
    style: tabContainer3,
    children: [
      /* @__PURE__ */ jsxs146("div", {
        style: descriptionStyle,
        children: [
          "Remotion is free if you are an individual or company with a headcount of 3 or less. See",
          " ",
          /* @__PURE__ */ jsx278("a", {
            style: descriptionLink,
            href: "https://remotion.dev/license",
            children: "LICENSE.md"
          }),
          "."
        ]
      }),
      /* @__PURE__ */ jsx278("div", {
        style: row10,
        children: /* @__PURE__ */ jsxs146("div", {
          style: justifyCenter,
          children: [
            /* @__PURE__ */ jsx278(Checkbox, {
              checked: licenseKey === "free-license",
              onChange: onFreeLicenseChange,
              name: "free-license",
              rounded: true
            }),
            /* @__PURE__ */ jsxs146("div", {
              style: checkboxLabel,
              onClick: onFreeLicenseChange,
              children: [
                "I am eligible for the Free License, ",
                "don't",
                " print a warning"
              ]
            })
          ]
        })
      }),
      licenseKey === "free-license" ? /* @__PURE__ */ jsxs146("div", {
        style: paddedDescriptionStyle,
        children: [
          "Enjoy Remotion! Add the following to",
          " ",
          /* @__PURE__ */ jsx278("code", {
            style: codeStyle,
            children: "remotion.config.ts"
          }),
          " to persist this setting:",
          /* @__PURE__ */ jsx278("div", {
            style: codeLine,
            children: "Config.setPublicLicenseKey('free-license');"
          })
        ]
      }) : null,
      /* @__PURE__ */ jsx278("div", {
        style: row10,
        children: /* @__PURE__ */ jsxs146("div", {
          style: justifyCenter,
          children: [
            /* @__PURE__ */ jsx278(Checkbox, {
              checked: licenseKey !== "free-license" && licenseKey !== null,
              onChange: onCompanyLicenseChange,
              name: "company-license",
              rounded: true
            }),
            /* @__PURE__ */ jsx278("div", {
              style: checkboxLabel,
              onClick: onCompanyLicenseChange,
              children: "I have a Company License"
            })
          ]
        })
      }),
      licenseKey !== "free-license" && licenseKey !== null ? /* @__PURE__ */ jsxs146("div", {
        style: paddedDescriptionStyle,
        children: [
          "Add your public license key from",
          " ",
          /* @__PURE__ */ jsx278("a", {
            href: "https://remotion.pro/dashboard",
            target: "_blank",
            style: descriptionLink,
            children: "remotion.pro"
          }),
          " ",
          "below.",
          /* @__PURE__ */ jsx278(Spacing, {
            y: 1,
            block: true
          }),
          /* @__PURE__ */ jsx278(RemotionInput, {
            value: licenseKey,
            onChange: onLicenseKeyChange,
            placeholder: "remotion.pro public license key (starts with rm_pub_)",
            status: licenseValidation.valid || licenseKey.length === 0 ? "ok" : "error",
            rightAlign: false,
            style: inputStyle2,
            autoFocus: true
          }),
          licenseValidation.message ? /* @__PURE__ */ jsxs146(Fragment48, {
            children: [
              /* @__PURE__ */ jsx278(Spacing, {
                y: 1,
                block: true
              }),
              /* @__PURE__ */ jsx278(ValidationMessage, {
                message: licenseValidation.message,
                align: "flex-start",
                type: "error"
              })
            ]
          }) : null,
          licenseValidation.valid && licenseKey.length > 0 ? /* @__PURE__ */ jsxs146(Fragment48, {
            children: [
              /* @__PURE__ */ jsx278(Spacing, {
                y: 1,
                block: true
              }),
              "Add the following to",
              " ",
              /* @__PURE__ */ jsx278("code", {
                style: codeStyle,
                children: "remotion.config.ts"
              }),
              " to persist this setting:",
              /* @__PURE__ */ jsx278("div", {
                style: codeLineSmall,
                children: "Config.setPublicLicenseKey('" + licenseKey + "');"
              })
            ]
          }) : null,
          isLoading && /* @__PURE__ */ jsxs146(Fragment48, {
            children: [
              /* @__PURE__ */ jsx278(Spacing, {
                y: 1,
                block: true
              }),
              "Loading license key details..."
            ]
          }),
          licenseValidation.details && /* @__PURE__ */ jsxs146(Fragment48, {
            children: [
              /* @__PURE__ */ jsx278(Spacing, {
                y: 1,
                block: true
              }),
              /* @__PURE__ */ jsx278(WebRenderModalLicenseKeyDetails, {
                details: licenseValidation.details
              })
            ]
          })
        ]
      }) : null,
      licenseKey === null ? /* @__PURE__ */ jsxs146("div", {
        style: descriptionStyle,
        children: [
          "If you are not eligible for the free license, you need to obtain a",
          " ",
          /* @__PURE__ */ jsx278("a", {
            style: descriptionLink,
            target: "_blank",
            href: "https://remotion.pro/license",
            children: "Company License"
          }),
          "."
        ]
      }) : null
    ]
  });
};

// src/components/RenderModal/WebRenderModalPicture.tsx
import { useCallback as useCallback139, useMemo as useMemo141 } from "react";
import { jsx as jsx279, jsxs as jsxs147, Fragment as Fragment49 } from "react/jsx-runtime";
var tabContainer4 = {
  flex: 1
};
var WebRenderModalPicture = ({
  renderMode,
  videoBitrate,
  setVideoBitrate,
  keyframeIntervalInSeconds,
  setKeyframeIntervalInSeconds,
  transparent,
  setTransparent,
  scale,
  setScale,
  compositionWidth,
  compositionHeight
}) => {
  const qualityOptions = useMemo141(() => getQualityOptions(videoBitrate, setVideoBitrate), [videoBitrate, setVideoBitrate]);
  const onTransparentChanged = useCallback139((e) => {
    setTransparent(e.target.checked);
  }, [setTransparent]);
  return /* @__PURE__ */ jsxs147("div", {
    style: tabContainer4,
    children: [
      /* @__PURE__ */ jsx279(ScaleSetting, {
        scale,
        setScale,
        compositionWidth,
        compositionHeight
      }),
      renderMode !== "video" ? null : /* @__PURE__ */ jsxs147(Fragment49, {
        children: [
          /* @__PURE__ */ jsxs147("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx279("div", {
                style: label5,
                children: "Quality"
              }),
              /* @__PURE__ */ jsx279("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx279(Combobox, {
                  values: qualityOptions,
                  selectedId: videoBitrate,
                  title: "Quality"
                })
              })
            ]
          }),
          /* @__PURE__ */ jsx279(NumberSetting, {
            name: "Keyframe Interval",
            formatter: (v) => `${v}s`,
            min: 1,
            max: 300,
            step: 1,
            value: keyframeIntervalInSeconds,
            onValueChanged: setKeyframeIntervalInSeconds
          }),
          /* @__PURE__ */ jsxs147("div", {
            style: optionRow,
            children: [
              /* @__PURE__ */ jsx279("div", {
                style: label5,
                children: "Transparent"
              }),
              /* @__PURE__ */ jsx279("div", {
                style: rightRow,
                children: /* @__PURE__ */ jsx279(Checkbox, {
                  checked: transparent,
                  onChange: onTransparentChanged,
                  name: "transparent"
                })
              })
            ]
          })
        ]
      })
    ]
  });
};

// src/components/RenderModal/WebRenderModal.tsx
import { jsx as jsx280, jsxs as jsxs148 } from "react/jsx-runtime";
var invalidCharacters2 = ["?", "*", "+", ":", "%"];
var isValidStillExtension2 = (extension, stillImageFormat) => {
  if (stillImageFormat === "jpeg" && extension === "jpg") {
    return true;
  }
  return extension === stillImageFormat;
};
var validateOutnameForStill = ({
  outName,
  stillImageFormat
}) => {
  try {
    const extension = outName.substring(outName.lastIndexOf(".") + 1);
    const prefix = outName.substring(0, outName.lastIndexOf("."));
    const hasDotAfterSlash = () => {
      const substrings = prefix.split("/");
      for (const str of substrings) {
        if (str[0] === ".") {
          return true;
        }
      }
      return false;
    };
    const hasInvalidChar = () => {
      return prefix.split("").some((char) => invalidCharacters2.includes(char));
    };
    if (prefix.length < 1) {
      throw new Error("The prefix must be at least 1 character long");
    }
    if (prefix[0] === "." || hasDotAfterSlash()) {
      throw new Error("The output name must not start with a dot");
    }
    if (hasInvalidChar()) {
      throw new Error("Filename can't contain the following characters:  ?, *, +, %, :");
    }
    if (!isValidStillExtension2(extension, stillImageFormat)) {
      throw new Error(`The extension ${extension} is not supported for still image format ${stillImageFormat}`);
    }
    return { valid: true };
  } catch (err) {
    return { valid: false, error: err };
  }
};
var WebRenderModal = ({
  initialFrame,
  defaultProps,
  inFrameMark,
  outFrameMark,
  initialLogLevel,
  initialLicenseKey,
  initialStillImageFormat,
  initialDefaultOutName,
  initialScale,
  initialDelayRenderTimeout,
  initialMediaCacheSizeInBytes,
  initialContainer,
  initialVideoCodec,
  initialAudioCodec,
  initialAudioBitrate,
  initialVideoBitrate,
  initialHardwareAcceleration,
  initialKeyframeIntervalInSeconds,
  initialTransparent,
  initialMuted
}) => {
  const context = useContext90(ResolvedCompositionContext);
  const { setSelectedModal } = useContext90(ModalsContext);
  const { setSidebarCollapsedState } = useContext90(SidebarContext);
  const { addClientStillJob, addClientVideoJob } = useContext90(RenderQueueContext);
  if (!context) {
    throw new Error("Should not be able to render without resolving comp first");
  }
  const {
    resolved: { result: resolvedComposition },
    unresolved: unresolvedComposition
  } = context;
  const [isVideo] = useState92(() => {
    return typeof resolvedComposition.durationInFrames === "undefined" ? true : resolvedComposition.durationInFrames > 1;
  });
  const [renderMode, setRenderMode] = useState92(initialContainer && isAudioOnlyContainer(initialContainer) ? "audio" : isVideo ? "video" : "still");
  const [tab, setTab] = useState92("general");
  const [imageFormat, setImageFormat] = useState92(() => initialStillImageFormat ?? "png");
  const [frame2, setFrame] = useState92(() => initialFrame);
  const [logLevel, setLogLevel] = useState92(() => initialLogLevel);
  const [inputProps, setInputProps] = useState92(() => defaultProps);
  const [delayRenderTimeout, setDelayRenderTimeout] = useState92(initialDelayRenderTimeout ?? 30000);
  const [mediaCacheSizeInBytes, setMediaCacheSizeInBytes] = useState92(initialMediaCacheSizeInBytes);
  const [saving, setSaving] = useState92(false);
  const [codec, setCodec] = useState92(initialVideoCodec ?? "h264");
  const [container63, setContainer] = useState92(initialContainer ?? "mp4");
  const [audioCodec, setAudioCodec] = useState92(initialAudioCodec ?? "aac");
  const [audioBitrate, setAudioBitrate] = useState92(initialAudioBitrate ?? "medium");
  const [videoBitrate, setVideoBitrate] = useState92(initialVideoBitrate ?? "high");
  const [hardwareAcceleration, setHardwareAcceleration] = useState92(initialHardwareAcceleration ?? "no-preference");
  const [keyframeIntervalInSeconds, setKeyframeIntervalInSeconds] = useState92(initialKeyframeIntervalInSeconds ?? 5);
  const [startFrame, setStartFrame] = useState92(() => inFrameMark);
  const [endFrame, setEndFrame] = useState92(() => outFrameMark);
  const [transparent, setTransparent] = useState92(initialTransparent ?? false);
  const [muted, setMuted] = useState92(initialMuted ?? false);
  const [scale, setScale] = useState92(initialScale ?? 1);
  const [licenseKey, setLicenseKey] = useState92(initialLicenseKey);
  const encodableAudioCodecs = useEncodableAudioCodecs(container63);
  const encodableVideoCodecs = useEncodableVideoCodecs(container63);
  const effectiveAudioCodec = useMemo142(() => {
    if (encodableAudioCodecs.includes(audioCodec)) {
      return audioCodec;
    }
    return encodableAudioCodecs[0] ?? audioCodec;
  }, [audioCodec, encodableAudioCodecs]);
  const effectiveVideoCodec = useMemo142(() => {
    if (encodableVideoCodecs.includes(codec)) {
      return codec;
    }
    return encodableVideoCodecs[0] ?? codec;
  }, [codec, encodableVideoCodecs]);
  const finalEndFrame = useMemo142(() => {
    if (endFrame === null) {
      return resolvedComposition.durationInFrames - 1;
    }
    return Math.max(0, Math.min(resolvedComposition.durationInFrames - 1, endFrame));
  }, [endFrame, resolvedComposition.durationInFrames]);
  const finalStartFrame = useMemo142(() => {
    if (startFrame === null) {
      return 0;
    }
    return Math.max(0, Math.min(finalEndFrame, startFrame));
  }, [finalEndFrame, startFrame]);
  const [initialOutNameState] = useState92(() => {
    if (initialDefaultOutName) {
      return initialDefaultOutName;
    }
    const defaultOut = getDefaultOutLocation2({
      compositionName: resolvedComposition.id,
      defaultExtension: renderMode === "still" ? imageFormat : isVideo ? container63 : imageFormat,
      type: "asset",
      compositionDefaultOutName: resolvedComposition.defaultOutName,
      outputLocation: window.remotion_renderDefaults?.outputLocation ?? null
    });
    if (window.remotion_isReadOnlyStudio) {
      return defaultOut.replace(/^out\//, "");
    }
    return defaultOut;
  });
  const [outName, setOutName] = useState92(() => initialOutNameState);
  const updateOutNameExtension = useCallback140((extension) => {
    setOutName((prev) => getStringBeforeSuffix(prev) + "." + extension);
  }, []);
  const setStillFormat = useCallback140((format) => {
    setImageFormat(format);
    updateOutNameExtension(format);
  }, [updateOutNameExtension]);
  const setContainerFormat = useCallback140((newContainer) => {
    setContainer(newContainer);
    const defaultVideoCodec = getDefaultVideoCodecForContainer(newContainer);
    if (defaultVideoCodec) {
      setCodec(defaultVideoCodec);
    }
    setAudioCodec(getDefaultAudioCodecForContainer(newContainer));
    updateOutNameExtension(newContainer);
  }, [updateOutNameExtension]);
  const setCodecWithContainer = useCallback140((newCodec) => {
    setCodec(newCodec);
    const newContainer = getDefaultContainerForCodec(newCodec);
    setContainer(newContainer);
    setAudioCodec(getDefaultAudioCodecForContainer(newContainer));
    updateOutNameExtension(newContainer);
  }, [updateOutNameExtension]);
  const onRenderModeChange = useCallback140((newMode) => {
    setRenderMode(newMode);
    if (newMode === "video") {
      const newContainer = isAudioOnlyContainer(container63) ? "mp4" : container63;
      setContainer(newContainer);
      setAudioCodec(getDefaultAudioCodecForContainer(newContainer));
      updateOutNameExtension(newContainer);
    } else if (newMode === "audio") {
      const newContainer = "wav";
      setContainer(newContainer);
      setMuted(false);
      setAudioCodec(getDefaultAudioCodecForContainer(newContainer));
      updateOutNameExtension(newContainer);
      setTab((prev) => prev === "picture" ? "general" : prev);
    } else if (newMode === "still") {
      updateOutNameExtension(imageFormat);
      setTab((prev) => prev === "audio" ? "general" : prev);
    }
  }, [container63, imageFormat, updateOutNameExtension]);
  const renderTabOptions = useMemo142(() => {
    const options = [
      {
        label: "Still",
        onClick: () => {
          onRenderModeChange("still");
        },
        key: "still",
        selected: renderMode === "still"
      }
    ];
    if (resolvedComposition.durationInFrames > 1) {
      options.push({
        label: "Video",
        onClick: () => {
          onRenderModeChange("video");
        },
        key: "video",
        selected: renderMode === "video"
      });
      options.push({
        label: "Audio",
        onClick: () => {
          onRenderModeChange("audio");
        },
        key: "audio",
        selected: renderMode === "audio"
      });
    }
    return options;
  }, [renderMode, resolvedComposition.durationInFrames, onRenderModeChange]);
  const onFrameSetDirectly = useCallback140((newFrame) => {
    setFrame(newFrame);
  }, [setFrame]);
  const onFrameChanged = useCallback140((e) => {
    setFrame((q) => {
      const newFrame = parseFloat(e);
      if (Number.isNaN(newFrame)) {
        return q;
      }
      return newFrame;
    });
  }, [setFrame]);
  const onOutNameChange = useCallback140((e) => {
    setOutName(e.target.value);
  }, []);
  const outnameValidation = useMemo142(() => {
    if (renderMode === "still") {
      return validateOutnameForStill({
        outName,
        stillImageFormat: imageFormat
      });
    }
    try {
      const extension = outName.substring(outName.lastIndexOf(".") + 1);
      const prefix = outName.substring(0, outName.lastIndexOf("."));
      const hasDotAfterSlash = () => {
        const substrings = prefix.split("/");
        for (const str of substrings) {
          if (str[0] === ".") {
            return true;
          }
        }
        return false;
      };
      const hasInvalidChar = () => {
        return prefix.split("").some((char) => invalidCharacters2.includes(char));
      };
      if (prefix.length < 1) {
        throw new Error("The prefix must be at least 1 character long");
      }
      if (prefix[0] === "." || hasDotAfterSlash()) {
        throw new Error("The output name must not start with a dot");
      }
      if (hasInvalidChar()) {
        throw new Error("Filename can't contain the following characters:  ?, *, +, %, :");
      }
      if (extension !== container63) {
        throw new Error(`The extension ${extension} is not supported for container format ${container63}`);
      }
      return { valid: true };
    } catch (err) {
      return { valid: false, error: err };
    }
  }, [outName, imageFormat, renderMode, container63]);
  const onAddToQueue = useCallback140(() => {
    const compositionRef = {
      component: unresolvedComposition.component,
      calculateMetadata: unresolvedComposition.calculateMetadata ?? null,
      width: resolvedComposition.width,
      height: resolvedComposition.height,
      fps: resolvedComposition.fps,
      durationInFrames: resolvedComposition.durationInFrames,
      defaultProps: resolvedComposition.defaultProps
    };
    if (renderMode === "still") {
      addClientStillJob({
        type: "client-still",
        compositionId: resolvedComposition.id,
        outName,
        imageFormat,
        frame: frame2,
        inputProps,
        delayRenderTimeout,
        mediaCacheSizeInBytes,
        logLevel,
        licenseKey,
        scale
      }, compositionRef);
    } else {
      addClientVideoJob({
        type: "client-video",
        compositionId: resolvedComposition.id,
        outName,
        container: container63,
        videoCodec: isAudioOnlyContainer(container63) ? null : effectiveVideoCodec,
        audioCodec: effectiveAudioCodec,
        startFrame: finalStartFrame,
        endFrame: finalEndFrame,
        audioBitrate,
        videoBitrate,
        hardwareAcceleration,
        keyframeIntervalInSeconds,
        transparent,
        muted,
        inputProps,
        delayRenderTimeout,
        mediaCacheSizeInBytes,
        logLevel,
        licenseKey,
        scale
      }, compositionRef);
    }
    setSidebarCollapsedState({ left: null, right: "expanded" });
    persistSelectedOptionsSidebarPanel2("renders");
    optionsSidebarTabs.current?.selectRendersPanel();
    setSelectedModal(null);
  }, [
    renderMode,
    unresolvedComposition.component,
    unresolvedComposition.calculateMetadata,
    resolvedComposition.width,
    resolvedComposition.height,
    resolvedComposition.fps,
    resolvedComposition.durationInFrames,
    resolvedComposition.defaultProps,
    resolvedComposition.id,
    setSidebarCollapsedState,
    outName,
    imageFormat,
    frame2,
    inputProps,
    delayRenderTimeout,
    mediaCacheSizeInBytes,
    logLevel,
    licenseKey,
    container63,
    effectiveVideoCodec,
    effectiveAudioCodec,
    finalStartFrame,
    finalEndFrame,
    audioBitrate,
    videoBitrate,
    hardwareAcceleration,
    keyframeIntervalInSeconds,
    transparent,
    muted,
    setSelectedModal,
    addClientStillJob,
    addClientVideoJob,
    scale
  ]);
  return /* @__PURE__ */ jsxs148("div", {
    style: outerModalStyle,
    children: [
      /* @__PURE__ */ jsx280(ModalHeader, {
        title: `Render ${resolvedComposition.id}`
      }),
      /* @__PURE__ */ jsxs148("div", {
        style: container54,
        children: [
          /* @__PURE__ */ jsx280(SegmentedControl, {
            items: renderTabOptions,
            needsWrapping: false
          }),
          /* @__PURE__ */ jsx280("div", {
            style: flexer
          }),
          /* @__PURE__ */ jsxs148(Button, {
            autoFocus: true,
            onClick: onAddToQueue,
            style: buttonStyle7,
            disabled: !outnameValidation.valid,
            children: [
              "Render ",
              renderMode,
              /* @__PURE__ */ jsx280(ShortcutHint, {
                keyToPress: "↵",
                cmdOrCtrl: true
              })
            ]
          })
        ]
      }),
      /* @__PURE__ */ jsx280("div", {
        style: container54,
        children: /* @__PURE__ */ jsx280(WebRendererExperimentalBadge, {})
      }),
      /* @__PURE__ */ jsxs148("div", {
        style: horizontalLayout,
        children: [
          /* @__PURE__ */ jsxs148("div", {
            style: leftSidebar,
            children: [
              /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "general",
                onClick: () => setTab("general"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(FileIcon, {
                      style: icon6
                    })
                  }),
                  "General"
                ]
              }),
              /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "data",
                onClick: () => setTab("data"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(DataIcon, {
                      style: icon6
                    })
                  }),
                  "Input Props"
                ]
              }),
              renderMode !== "audio" ? /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "picture",
                onClick: () => setTab("picture"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(PicIcon, {
                      style: icon6
                    })
                  }),
                  "Picture"
                ]
              }) : null,
              renderMode === "video" || renderMode === "audio" ? /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "audio",
                onClick: () => setTab("audio"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(AudioIcon, {
                      style: icon6
                    })
                  }),
                  "Audio"
                ]
              }) : null,
              /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "advanced",
                onClick: () => setTab("advanced"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(GearIcon, {
                      style: icon6
                    })
                  }),
                  "Other"
                ]
              }),
              /* @__PURE__ */ jsxs148(VerticalTab, {
                style: horizontalTab,
                selected: tab === "license",
                onClick: () => setTab("license"),
                children: [
                  /* @__PURE__ */ jsx280("div", {
                    style: iconContainer,
                    children: /* @__PURE__ */ jsx280(CertificateIcon, {
                      style: icon6
                    })
                  }),
                  "License"
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx280("div", {
            style: optionsPanel,
            className: VERTICAL_SCROLLBAR_CLASSNAME,
            children: tab === "general" ? /* @__PURE__ */ jsx280(WebRenderModalBasic, {
              renderMode,
              resolvedComposition,
              imageFormat,
              setStillFormat,
              frame: frame2,
              onFrameChanged,
              onFrameSetDirectly,
              container: container63,
              setContainerFormat,
              setCodec: setCodecWithContainer,
              encodableVideoCodecs,
              effectiveVideoCodec,
              startFrame: finalStartFrame,
              setStartFrame,
              endFrame: finalEndFrame,
              setEndFrame,
              outName,
              onOutNameChange,
              validationMessage: outnameValidation.valid ? null : outnameValidation.error.message,
              logLevel,
              setLogLevel
            }) : tab === "data" ? /* @__PURE__ */ jsx280(DataEditor, {
              defaultProps: inputProps,
              setDefaultProps: setInputProps,
              unresolvedComposition,
              mayShowSaveButton: false,
              propsEditType: "input-props",
              saving,
              setSaving,
              readOnlyStudio: false
            }) : tab === "picture" ? /* @__PURE__ */ jsx280(WebRenderModalPicture, {
              renderMode,
              videoBitrate,
              setVideoBitrate,
              keyframeIntervalInSeconds,
              setKeyframeIntervalInSeconds,
              transparent,
              setTransparent,
              scale,
              setScale,
              compositionWidth: resolvedComposition.width,
              compositionHeight: resolvedComposition.height
            }) : tab === "audio" ? /* @__PURE__ */ jsx280(WebRenderModalAudio, {
              renderMode,
              muted,
              setMuted,
              audioCodec,
              setAudioCodec,
              audioBitrate,
              setAudioBitrate,
              container: container63,
              encodableCodecs: encodableAudioCodecs,
              effectiveAudioCodec
            }) : tab === "advanced" ? /* @__PURE__ */ jsx280(WebRenderModalAdvanced, {
              renderMode,
              delayRenderTimeout,
              setDelayRenderTimeout,
              mediaCacheSizeInBytes,
              setMediaCacheSizeInBytes,
              hardwareAcceleration,
              setHardwareAcceleration
            }) : /* @__PURE__ */ jsx280(WebRenderModalLicense, {
              licenseKey,
              setLicenseKey,
              initialPublicLicenseKey: initialLicenseKey
            })
          })
        ]
      })
    ]
  });
};
var WebRenderModalWithLoader = (props) => {
  return /* @__PURE__ */ jsx280(DismissableModal, {
    children: /* @__PURE__ */ jsx280(ResolveCompositionBeforeModal, {
      compositionId: props.compositionId,
      children: /* @__PURE__ */ jsx280(WebRenderModal, {
        ...props
      })
    })
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import { useCallback as useCallback143, useMemo as useMemo144 } from "react";

// src/components/CopyButton.tsx
import { useCallback as useCallback141, useEffect as useEffect89, useState as useState93 } from "react";
import { jsx as jsx281, jsxs as jsxs149 } from "react/jsx-runtime";
var iconStyle8 = {
  width: 16,
  height: 16,
  color: "white"
};
var buttonContainerStyle = {
  display: "flex",
  minWidth: "114px"
};
var copyIcon = /* @__PURE__ */ jsx281("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "far",
  "data-icon": "clipboard",
  className: "svg-inline--fa fa-clipboard fa-w-12",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512",
  style: iconStyle8,
  children: /* @__PURE__ */ jsx281("path", {
    fill: "currentColor",
    d: "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
  })
});
var labelStyle5 = {
  fontSize: 14
};
var CopyButton = ({ textToCopy, label: label12, labelWhenCopied }) => {
  const [copied, setCopied] = useState93(false);
  const onClick = useCallback141(() => {
    copyText(textToCopy).then(() => {
      setCopied(Date.now());
    }).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [textToCopy]);
  useEffect89(() => {
    if (!copied) {
      return;
    }
    const to = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(to);
  }, [copied]);
  return /* @__PURE__ */ jsxs149(Button, {
    onClick,
    buttonContainerStyle,
    children: [
      copyIcon,
      /* @__PURE__ */ jsx281(Spacing, {
        x: 1.5
      }),
      " ",
      /* @__PURE__ */ jsx281("span", {
        style: labelStyle5,
        children: copied ? labelWhenCopied : label12
      })
    ]
  });
};

// src/components/UpdateModal/OpenIssueButton.tsx
import { useCallback as useCallback142, useMemo as useMemo143, useState as useState94 } from "react";
import { jsx as jsx282 } from "react/jsx-runtime";
var svgStyle3 = {
  width: "11px",
  height: "11px"
};
var buttonStyle8 = {
  border: "none",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
var OpenIssueButton = ({ link: link4 }) => {
  const [hovered, setHovered] = useState94(false);
  const buttonTooltip = `Open GitHub issue in new Tab`;
  const handleClick = useCallback142(() => {
    window.open(link4, "_blank");
  }, [link4]);
  const svgFillColor = useMemo143(() => {
    return hovered ? "white" : LIGHT_TEXT;
  }, [hovered]);
  const openInEditorSvg = /* @__PURE__ */ jsx282("svg", {
    viewBox: "0 0 512 512",
    style: svgStyle3,
    children: /* @__PURE__ */ jsx282("path", {
      fill: svgFillColor,
      d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    })
  });
  const onPointerEnter = useCallback142(() => {
    setHovered(true);
  }, []);
  const onPointerLeave = useCallback142(() => {
    setHovered(false);
  }, []);
  return /* @__PURE__ */ jsx282("button", {
    title: buttonTooltip,
    type: "button",
    onPointerEnter,
    onPointerLeave,
    style: buttonStyle8,
    onClick: handleClick,
    children: openInEditorSvg
  });
};

// src/components/KnownBugs.tsx
import { jsx as jsx283, jsxs as jsxs150 } from "react/jsx-runtime";
var container63 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};
var text4 = {
  fontSize: 14,
  flex: 1
};
var KnownBugs = ({ bugs }) => {
  const bugElements = bugs.map((bug) => {
    return /* @__PURE__ */ jsxs150("div", {
      style: container63,
      children: [
        /* @__PURE__ */ jsxs150("div", {
          style: text4,
          children: [
            "\uD83E\uDEB2 ",
            bug.title
          ]
        }),
        /* @__PURE__ */ jsx283(OpenIssueButton, {
          link: bug.link
        })
      ]
    }, bug.description + bug.link);
  });
  return /* @__PURE__ */ jsx283("div", {
    children: bugElements
  });
};

// src/components/UpdateModal/UpdateModal.tsx
import { jsx as jsx284, jsxs as jsxs151, Fragment as Fragment50 } from "react/jsx-runtime";
var container64 = {
  padding: 20,
  paddingTop: 0
};
var text5 = {
  fontSize: 14
};
var title8 = {
  paddingTop: 12,
  paddingBottom: 8,
  ...text5
};
var code = {
  background: SELECTED_BACKGROUND,
  padding: "12px 10px",
  fontSize: 14,
  marginTop: 10,
  marginBottom: 10
};
var link4 = {
  fontWeight: "bold",
  color: BLUE,
  textDecoration: "none",
  ...text5
};
var commands = {
  npm: "npx remotion upgrade",
  yarn: "yarn remotion upgrade",
  pnpm: "pnpm exec remotion upgrade",
  bun: "bun remotion upgrade",
  unknown: "npx remotion upgrade"
};
var UpdateModal = ({ info, knownBugs }) => {
  const hasKnownBugs = useMemo144(() => {
    return knownBugs && knownBugs?.length > 0;
  }, [knownBugs]);
  const command = commands[info.packageManager];
  const onClick = useCallback143(() => {
    copyText(command).catch((err) => {
      showNotification(`Could not copy: ${err.message}`, 2000);
    });
  }, [command]);
  return /* @__PURE__ */ jsxs151(DismissableModal, {
    children: [
      /* @__PURE__ */ jsx284(ModalHeader, {
        title: "Update available"
      }),
      /* @__PURE__ */ jsxs151("div", {
        style: container64,
        children: [
          hasKnownBugs ? /* @__PURE__ */ jsxs151(Fragment50, {
            children: [
              /* @__PURE__ */ jsxs151("div", {
                style: title8,
                children: [
                  "The currently installed version ",
                  info.currentVersion,
                  " has the following known bugs:"
                ]
              }),
              /* @__PURE__ */ jsx284(KnownBugs, {
                bugs: knownBugs
              }),
              /* @__PURE__ */ jsx284("div", {
                style: { height: "20px" }
              }),
              /* @__PURE__ */ jsx284("div", {
                style: text5,
                children: "To upgrade, run the following command:"
              })
            ]
          }) : /* @__PURE__ */ jsx284("div", {
            style: title8,
            children: "A new update for Remotion is available! Run the following command:"
          }),
          /* @__PURE__ */ jsxs151(Row, {
            align: "center",
            children: [
              /* @__PURE__ */ jsx284(Flex, {
                children: /* @__PURE__ */ jsx284("pre", {
                  onClick,
                  style: code,
                  children: command
                })
              }),
              /* @__PURE__ */ jsx284(Spacing, {
                x: 1
              }),
              /* @__PURE__ */ jsx284(CopyButton, {
                textToCopy: command,
                label: "Copy",
                labelWhenCopied: "Copied!"
              })
            ]
          }),
          /* @__PURE__ */ jsxs151("div", {
            style: text5,
            children: [
              "This will upgrade Remotion from ",
              info.currentVersion,
              " to",
              " ",
              info.latestVersion,
              "."
            ]
          }),
          /* @__PURE__ */ jsxs151("div", {
            style: text5,
            children: [
              "Read the",
              " ",
              /* @__PURE__ */ jsx284("a", {
                style: link4,
                target: "_blank",
                href: "https://github.com/remotion-dev/remotion/releases",
                children: "Release notes"
              }),
              " ",
              "to know what",
              "'s",
              " new in Remotion."
            ]
          })
        ]
      })
    ]
  });
};

// src/components/Modals.tsx
import { jsx as jsx285, jsxs as jsxs152, Fragment as Fragment51 } from "react/jsx-runtime";
var Modals = ({ readOnlyStudio }) => {
  const { selectedModal: modalContextType } = useContext91(ModalsContext);
  const canRender = useContext91(StudioServerConnectionCtx).previewServerState.type === "connected";
  return /* @__PURE__ */ jsxs152(Fragment51, {
    children: [
      modalContextType && modalContextType.type === "duplicate-comp" && /* @__PURE__ */ jsx285(DuplicateComposition, {
        compositionType: modalContextType.compositionType,
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "delete-comp" && /* @__PURE__ */ jsx285(DeleteComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "rename-comp" && /* @__PURE__ */ jsx285(RenameComposition, {
        compositionId: modalContextType.compositionId
      }),
      modalContextType && modalContextType.type === "input-props-override" && /* @__PURE__ */ jsx285(OverrideInputPropsModal, {}),
      modalContextType && modalContextType.type === "web-render" && /* @__PURE__ */ jsx285(WebRenderModalWithLoader, {
        ...modalContextType
      }),
      modalContextType && modalContextType.type === "server-render" && (canRender || modalContextType.readOnlyStudio) ? /* @__PURE__ */ jsx285(RenderModalWithLoader, {
        readOnlyStudio: modalContextType.readOnlyStudio ?? false,
        initialFrame: modalContextType.initialFrame,
        initialDarkMode: modalContextType.initialDarkMode,
        compositionId: modalContextType.compositionId,
        initialVideoImageFormat: modalContextType.initialVideoImageFormat,
        initialJpegQuality: modalContextType.initialJpegQuality,
        initialScale: modalContextType.initialScale,
        initialLogLevel: modalContextType.initialLogLevel,
        initialOffthreadVideoCacheSizeInBytes: modalContextType.initialOffthreadVideoCacheSizeInBytes,
        initialOffthreadVideoThreads: modalContextType.initialOffthreadVideoThreads,
        initialMediaCacheSizeInBytes: modalContextType.initialMediaCacheSizeInBytes,
        initialConcurrency: modalContextType.initialConcurrency,
        maxConcurrency: modalContextType.maxConcurrency,
        minConcurrency: modalContextType.minConcurrency,
        initialStillImageFormat: modalContextType.initialStillImageFormat,
        initialMuted: modalContextType.initialMuted,
        initialEnforceAudioTrack: modalContextType.initialEnforceAudioTrack,
        initialProResProfile: modalContextType.initialProResProfile,
        initialx264Preset: modalContextType.initialx264Preset,
        initialPixelFormat: modalContextType.initialPixelFormat,
        initialAudioBitrate: modalContextType.initialAudioBitrate,
        initialVideoBitrate: modalContextType.initialVideoBitrate,
        initialEveryNthFrame: modalContextType.initialEveryNthFrame,
        initialNumberOfGifLoops: modalContextType.initialNumberOfGifLoops,
        initialDelayRenderTimeout: modalContextType.initialDelayRenderTimeout,
        initialEnvVariables: modalContextType.initialEnvVariables,
        initialDisableWebSecurity: modalContextType.initialDisableWebSecurity,
        initialGl: modalContextType.initialOpenGlRenderer,
        initialHeadless: modalContextType.initialHeadless,
        initialIgnoreCertificateErrors: modalContextType.initialIgnoreCertificateErrors,
        initialEncodingBufferSize: modalContextType.initialEncodingBufferSize,
        initialEncodingMaxRate: modalContextType.initialEncodingMaxRate,
        initialUserAgent: modalContextType.initialUserAgent,
        initialColorSpace: modalContextType.initialColorSpace,
        initialMultiProcessOnLinux: modalContextType.initialMultiProcessOnLinux,
        initialRepro: modalContextType.initialRepro,
        initialBeep: modalContextType.initialBeep,
        initialForSeamlessAacConcatenation: modalContextType.initialForSeamlessAacConcatenation,
        defaultProps: modalContextType.defaultProps,
        inFrameMark: modalContextType.inFrameMark,
        outFrameMark: modalContextType.outFrameMark,
        defaultConfigurationAudioCodec: modalContextType.defaultConfigurationAudioCodec,
        defaultConfigurationVideoCodec: modalContextType.defaultConfigurationVideoCodec,
        renderTypeOfLastRender: modalContextType.renderTypeOfLastRender,
        defaultMetadata: modalContextType.defaulMetadata,
        initialHardwareAcceleration: modalContextType.initialHardwareAcceleration,
        initialChromeMode: modalContextType.initialChromeMode,
        renderDefaults: modalContextType.renderDefaults
      }) : null,
      modalContextType && modalContextType.type === "render-progress" && /* @__PURE__ */ jsx285(RenderStatusModal, {
        jobId: modalContextType.jobId
      }),
      modalContextType && modalContextType.type === "update" && /* @__PURE__ */ jsx285(UpdateModal, {
        info: modalContextType.info,
        knownBugs: modalContextType.knownBugs
      }),
      modalContextType && modalContextType.type === "install-packages" && /* @__PURE__ */ jsx285(InstallPackageModal, {
        packageManager: modalContextType.packageManager
      }),
      modalContextType && modalContextType.type === "quick-switcher" && /* @__PURE__ */ jsx285(QuickSwitcher_default, {
        readOnlyStudio,
        invocationTimestamp: modalContextType.invocationTimestamp,
        initialMode: modalContextType.mode
      }),
      process.env.ASK_AI_ENABLED && /* @__PURE__ */ jsx285(AskAiModal, {})
    ]
  });
};

// src/components/Editor.tsx
import { jsx as jsx286, jsxs as jsxs153 } from "react/jsx-runtime";
var background2 = {
  backgroundColor: BACKGROUND,
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  position: "absolute"
};
var DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS = 300;
var BUFFER_STATE_DELAY_IN_MILLISECONDS = typeof process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === "undefined" || process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS === null ? DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS : Number(process.env.BUFFER_STATE_DELAY_IN_MILLISECONDS);
var Editor = ({ Root, readOnlyStudio }) => {
  const size4 = PlayerInternals19.useElementSize(drawRef, {
    triggerOnWindowResize: false,
    shouldApplyCssTransforms: true
  });
  useEffect90(() => {
    if (readOnlyStudio) {
      return;
    }
    const listenToChanges = (e) => {
      if (window.remotion_unsavedProps) {
        e.returnValue = "Are you sure you want to leave?";
      }
    };
    window.addEventListener("beforeunload", listenToChanges);
    return () => {
      window.removeEventListener("beforeunload", listenToChanges);
    };
  }, [readOnlyStudio]);
  const [canvasMounted, setCanvasMounted] = React187.useState(false);
  const onMounted = useCallback144(() => {
    setCanvasMounted(true);
  }, []);
  const value = useMemo145(() => {
    if (!size4) {
      return null;
    }
    return {
      type: "canvas-size",
      canvasSize: size4
    };
  }, [size4]);
  const MemoRoot = useMemo145(() => {
    return React187.memo(Root);
  }, [Root]);
  return /* @__PURE__ */ jsx286(HigherZIndex, {
    onEscape: noop,
    onOutsideClick: noop,
    children: /* @__PURE__ */ jsxs153(TimelineZoomContext, {
      children: [
        /* @__PURE__ */ jsx286(Internals65.CurrentScaleContext.Provider, {
          value,
          children: /* @__PURE__ */ jsxs153("div", {
            style: background2,
            children: [
              canvasMounted ? /* @__PURE__ */ jsx286(MemoRoot, {}) : null,
              /* @__PURE__ */ jsxs153(Internals65.CanUseRemotionHooksProvider, {
                children: [
                  /* @__PURE__ */ jsx286(EditorContent, {
                    readOnlyStudio,
                    children: /* @__PURE__ */ jsx286(TopPanel, {
                      drawRef,
                      bufferStateDelayInMilliseconds: BUFFER_STATE_DELAY_IN_MILLISECONDS,
                      onMounted,
                      readOnlyStudio
                    })
                  }),
                  /* @__PURE__ */ jsx286(GlobalKeybindings, {})
                ]
              })
            ]
          })
        }),
        /* @__PURE__ */ jsx286(Modals, {
          readOnlyStudio
        }),
        /* @__PURE__ */ jsx286(NotificationCenter, {})
      ]
    })
  });
};

// src/components/EditorContexts.tsx
import { PlayerInternals as PlayerInternals20 } from "@remotion/player";

// src/state/preview-size.tsx
import { useCallback as useCallback145, useContext as useContext92, useMemo as useMemo146, useState as useState95 } from "react";
import { Internals as Internals66 } from "remotion";
import { jsx as jsx287 } from "react/jsx-runtime";
var key5 = "remotion.previewSize";
var persistPreviewSizeOption = (option) => {
  localStorage.setItem(key5, JSON.stringify(option));
};
var loadPreviewSizeOption = () => {
  const item2 = localStorage.getItem(key5);
  if (item2 === null) {
    return {
      size: "auto",
      translation: {
        x: 0,
        y: 0
      }
    };
  }
  return JSON.parse(item2);
};
var PreviewSizeProvider = ({ children }) => {
  const [size4, setSizeState] = useState95(() => loadPreviewSizeOption());
  const [translation, setTranslation] = useState95(() => {
    return {
      x: 0,
      y: 0
    };
  });
  const { editorZoomGestures } = useContext92(EditorZoomGesturesContext);
  const setSize = useCallback145((newValue) => {
    setSizeState((prevState) => {
      const newVal = newValue(prevState);
      persistPreviewSizeOption(newVal);
      return newVal;
    });
  }, []);
  const previewSizeCtx = useMemo146(() => {
    return {
      size: editorZoomGestures ? size4 : {
        size: size4.size,
        translation: {
          x: 0,
          y: 0
        }
      },
      setSize,
      translation,
      setTranslation
    };
  }, [editorZoomGestures, size4, setSize, translation]);
  return /* @__PURE__ */ jsx287(Internals66.PreviewSizeContext.Provider, {
    value: previewSizeCtx,
    children
  });
};

// src/components/CheckerboardProvider.tsx
import { useCallback as useCallback146, useMemo as useMemo147, useState as useState96 } from "react";
import { jsx as jsx288 } from "react/jsx-runtime";
var CheckerboardProvider = ({ children }) => {
  const [checkerboard, setCheckerboardState] = useState96(() => loadCheckerboardOption());
  const setCheckerboard = useCallback146((newValue) => {
    setCheckerboardState((prevState) => {
      const newVal = newValue(prevState);
      persistCheckerboardOption(newVal);
      return newVal;
    });
  }, []);
  const checkerboardCtx = useMemo147(() => {
    return {
      checkerboard,
      setCheckerboard
    };
  }, [checkerboard, setCheckerboard]);
  return /* @__PURE__ */ jsx288(CheckerboardContext.Provider, {
    value: checkerboardCtx,
    children
  });
};

// src/components/MediaVolumeProvider.tsx
import { useMemo as useMemo148, useState as useState97 } from "react";
import { Internals as Internals67 } from "remotion";
import { jsx as jsx289 } from "react/jsx-runtime";
var MediaVolumeProvider = ({ children }) => {
  const [mediaMuted, setMediaMuted] = useState97(() => loadMuteOption());
  const [mediaVolume, setMediaVolume] = useState97(1);
  const mediaVolumeContextValue = useMemo148(() => {
    return {
      mediaMuted,
      mediaVolume
    };
  }, [mediaMuted, mediaVolume]);
  const setMediaVolumeContextValue = useMemo148(() => {
    return {
      setMediaMuted,
      setMediaVolume
    };
  }, []);
  return /* @__PURE__ */ jsx289(Internals67.MediaVolumeContext.Provider, {
    value: mediaVolumeContextValue,
    children: /* @__PURE__ */ jsx289(Internals67.SetMediaVolumeContext.Provider, {
      value: setMediaVolumeContextValue,
      children
    })
  });
};

// src/components/ModalsProvider.tsx
import { useMemo as useMemo149, useState as useState98 } from "react";
import { jsx as jsx290 } from "react/jsx-runtime";
var ModalsProvider = ({ children }) => {
  const [modalContextType, setModalContextType] = useState98(null);
  const modalsContext = useMemo149(() => {
    return {
      selectedModal: modalContextType,
      setSelectedModal: setModalContextType
    };
  }, [modalContextType]);
  return /* @__PURE__ */ jsx290(ModalsContext.Provider, {
    value: modalsContext,
    children
  });
};

// src/components/SetTimelineInOutProvider.tsx
import { useEffect as useEffect91, useMemo as useMemo150, useState as useState99 } from "react";

// src/state/marks.ts
var localStorageKey5 = () => `remotion.editor.marksv2`;
var persistMarks = (marks) => {
  localStorage.setItem(localStorageKey5(), JSON.stringify(marks));
};
var loadMarks = () => {
  const item2 = localStorage.getItem(localStorageKey5());
  if (item2 === null) {
    return {};
  }
  return JSON.parse(item2);
};

// src/components/SetTimelineInOutProvider.tsx
import { jsx as jsx291 } from "react/jsx-runtime";
var SetTimelineInOutProvider = ({ children }) => {
  const [inAndOutFrames, setInAndOutFrames] = useState99(() => loadMarks());
  const setTimelineInOutContextValue = useMemo150(() => {
    return {
      setInAndOutFrames
    };
  }, []);
  useEffect91(() => {
    persistMarks(inAndOutFrames);
  }, [inAndOutFrames]);
  return /* @__PURE__ */ jsx291(TimelineInOutContext.Provider, {
    value: inAndOutFrames,
    children: /* @__PURE__ */ jsx291(SetTimelineInOutContext.Provider, {
      value: setTimelineInOutContextValue,
      children
    })
  });
};

// src/components/ShowGuidesProvider.tsx
import { useCallback as useCallback147, useMemo as useMemo151, useRef as useRef48, useState as useState100 } from "react";
import { jsx as jsx292 } from "react/jsx-runtime";
var ShowGuidesProvider = ({ children }) => {
  const [guidesList, setGuidesList] = useState100(() => loadGuidesList());
  const [selectedGuideId, setSelectedGuideId] = useState100(null);
  const [hoveredGuideId, setHoveredGuideId] = useState100(null);
  const [editorShowGuides, setEditorShowGuidesState] = useState100(() => loadEditorShowGuidesOption());
  const shouldCreateGuideRef = useRef48(false);
  const shouldDeleteGuideRef = useRef48(false);
  const setEditorShowGuides = useCallback147((newValue) => {
    setEditorShowGuidesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowGuidesOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowGuidesCtx = useMemo151(() => {
    return {
      editorShowGuides,
      setEditorShowGuides,
      guidesList,
      setGuidesList,
      selectedGuideId,
      setSelectedGuideId,
      shouldCreateGuideRef,
      shouldDeleteGuideRef,
      hoveredGuideId,
      setHoveredGuideId
    };
  }, [
    editorShowGuides,
    setEditorShowGuides,
    guidesList,
    selectedGuideId,
    hoveredGuideId
  ]);
  return /* @__PURE__ */ jsx292(EditorShowGuidesContext.Provider, {
    value: editorShowGuidesCtx,
    children
  });
};

// src/components/ShowRulersProvider.tsx
import { useCallback as useCallback148, useMemo as useMemo152, useState as useState101 } from "react";
import { jsx as jsx293 } from "react/jsx-runtime";
var ShowRulersProvider = ({ children }) => {
  const [editorShowRulers, setEditorShowRulersState] = useState101(() => loadEditorShowRulersOption());
  const setEditorShowRulers = useCallback148((newValue) => {
    setEditorShowRulersState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorShowRulersOption(newVal);
      return newVal;
    });
  }, []);
  const editorShowRulersCtx = useMemo152(() => {
    return {
      editorShowRulers,
      setEditorShowRulers
    };
  }, [editorShowRulers, setEditorShowRulers]);
  return /* @__PURE__ */ jsx293(EditorShowRulersContext.Provider, {
    value: editorShowRulersCtx,
    children
  });
};

// src/components/ZoomGesturesProvider.tsx
import { useCallback as useCallback149, useMemo as useMemo153, useState as useState102 } from "react";
import { jsx as jsx294 } from "react/jsx-runtime";
var ZoomGesturesProvider = ({ children }) => {
  const [editorZoomGestures, setEditorZoomGesturesState] = useState102(() => loadEditorZoomGesturesOption());
  const setEditorZoomGestures = useCallback149((newValue) => {
    setEditorZoomGesturesState((prevState) => {
      const newVal = newValue(prevState);
      persistEditorZoomGesturesOption(newVal);
      return newVal;
    });
  }, []);
  const editorZoomGesturesCtx = useMemo153(() => {
    return {
      editorZoomGestures,
      setEditorZoomGestures
    };
  }, [editorZoomGestures, setEditorZoomGestures]);
  return /* @__PURE__ */ jsx294(EditorZoomGesturesContext.Provider, {
    value: editorZoomGesturesCtx,
    children
  });
};

// src/components/EditorContexts.tsx
import { jsx as jsx295, jsxs as jsxs154 } from "react/jsx-runtime";
var EditorContexts = ({ children, readOnlyStudio }) => {
  return /* @__PURE__ */ jsx295(ZodProvider, {
    children: /* @__PURE__ */ jsx295(VisualControlsProvider, {
      children: /* @__PURE__ */ jsx295(PreviewServerConnection, {
        readOnlyStudio,
        children: /* @__PURE__ */ jsxs154(RenderQueueContextProvider, {
          children: [
            /* @__PURE__ */ jsx295(ClientRenderQueueProcessor, {}),
            /* @__PURE__ */ jsx295(KeybindingContextProvider, {
              children: /* @__PURE__ */ jsx295(CheckerboardProvider, {
                children: /* @__PURE__ */ jsx295(ZoomGesturesProvider, {
                  children: /* @__PURE__ */ jsx295(ShowRulersProvider, {
                    children: /* @__PURE__ */ jsx295(ShowGuidesProvider, {
                      children: /* @__PURE__ */ jsx295(PreviewSizeProvider, {
                        children: /* @__PURE__ */ jsx295(ModalsProvider, {
                          children: /* @__PURE__ */ jsx295(MediaVolumeProvider, {
                            children: /* @__PURE__ */ jsx295(PlayerInternals20.PlayerEmitterProvider, {
                              currentPlaybackRate: null,
                              children: /* @__PURE__ */ jsx295(SidebarContextProvider, {
                                children: /* @__PURE__ */ jsx295(FolderContextProvider, {
                                  children: /* @__PURE__ */ jsx295(HighestZIndexProvider, {
                                    children: /* @__PURE__ */ jsx295(SetTimelineInOutProvider, {
                                      children: /* @__PURE__ */ jsx295(ExpandedTracksProvider, {
                                        children
                                      })
                                    })
                                  })
                                })
                              })
                            })
                          })
                        })
                      })
                    })
                  })
                })
              })
            })
          ]
        })
      })
    })
  });
};

// src/components/Notifications/ServerDisconnected.tsx
import { useContext as useContext93 } from "react";
import { jsx as jsx296, jsxs as jsxs155 } from "react/jsx-runtime";
var container65 = {
  position: "fixed",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
  padding: 30,
  pointerEvents: "none",
  backgroundColor: "transparent",
  fontFamily: "SF Pro, Arial, Helvetica, sans-serif"
};
var message = {
  backgroundColor: "#e74c3c",
  color: "white",
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 12,
  paddingBottom: 12,
  borderRadius: 4,
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
  lineHeight: 1.5
};
var inlineCode = {
  fontSize: 16,
  fontFamily: "monospace"
};
var pageIsGoingToReload = false;
window.addEventListener("beforeunload", () => {
  pageIsGoingToReload = true;
});
var ServerDisconnected = () => {
  const { previewServerState: ctx } = useContext93(StudioServerConnectionCtx);
  const fav = document.getElementById("__remotion_favicon");
  if (ctx.type !== "disconnected") {
    fav.setAttribute("href", "/favicon.ico");
    return null;
  }
  if (pageIsGoingToReload) {
    return null;
  }
  const base64Favicon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARiSURBVHgB7d1NThRBFAfw/2tGgru5gXMD8QZ4AmVjAi6kN0TiAm8gnkBcGARNumcx4E48Ae0JaE9gewLHlQSZelaNgyHGL/RVd1X3+y10RQL58+rVx1QBKKWUUkoppZRSSimllFJKKVUjQs32stEiJcktZiwxzKL9Fvqzb6S0/44JVBKbtwa9aj29U6JjagtkJzsYzBEyBi9d5utsQIULCcxvelgo03R5jBarJZCXw/17E+bt82r4Hy4gtuEQekUbK8h7IHvDV5vMZht+VAlRfmYw3EhXKrSA10Ce2X7RIzpGDVzlgM1wPb2bI2JeA9nN99/b/waoV+XCmTAex1g13gLZyUZrdjjJ0CAbTB5bMN4C2ctHxwxaRABiCsZLIG6KmxC/R2BiCCaBBwn4NgJk10B2GOWj3Wz/IQLlpUL28oOjyy4AG1AZppuhVYt4hWRZ1o8gDGc6rL4YHjxCQMQDOcNCEI38bxnmLTc9d30PARAPZAITZP/4A1ctx3bjcw0NEw8koeQ64tRnu25qeggTb+q2/BmRcyv9K7yw3MTOsmiFuLMOtICblJzS5+Mm+opoIBOgFYHMuL5yVHcoooFQuwJxag9FNJCIG/rv1BqKaCDfzshbqbZQxAJxK3SJI9qATUPJstdef0axQGJbof+jwRc6eQ2PxAIx4DZXx3duSrybv3oCTyR7yACdYR762sIXDKQbFfId4ZGPJi8YCA3QLf05YvF+IhYIEV1Dx9hNu8XdbLQFQV6OcDuFaFNyKiwWiJ19DNBN/VN8XoMQrRABDFqCEJ32CiBisT08rRAZAwjRQAKjgcgQO+rVQARMb3gJ0UAkML+DEA1EwAQkdkNMcnOx1Zcxf8V9ol7y88GSm4tdDKRy1xsgSIes/0BM4ndN5HZ7OzZkMePperqSQ5jkkFWhO6r76WrYJ4b2N+YTumF60QeeSG6/d2DI4rHvW1eCPaT9Q9YZw/sVOMlZVoUWM8zpg/Su97dVJGdZFVrKhbFR05MdYoFcwWmF1rF9kbG8UeP7KaI3qBp628QTHrueUccwdZHw/ZDWNHY7tU1u1B2GIxqIYSO2Dd0Ud79wnq/eaOpBgR4EMVDW/oijINu87d7U6hYaJBrInA0k0iu4bvVtZ1KrBRrm4Vr06GNkF3cO7RCVhvK4pmiFOISkjOStk1lVrBQIiPh5SAyN3fWKWeMuEBjxCmEkh3bVvokAzd5idL2iQqDEA1nASXmK+XFIfeTCo5gFAudllvo8G20TUeNVElMQ58QrxLHD1jbB3GumSnhsz7qHE9BhTEGc87aOm16KJHi7rfqj8yfI53E1j/l9eK8L651stJUQeXx/iuzU1QztZLGIsRp+xvtOh3Qo3/qCedumEC6qZetpJztwz7O6UAa4FNsP7ELTfXbWbskUdjgq9M9VCJoFcwvTlfyPDd9t3XNJjA+2IZcGpmxi+7tpjW3OupurJziZhtKWPzWhlFJKKaWUUkoppZRSSiml/uwrgZ/Bfwo/wccAAAAASUVORK5CYII=";
  fav.setAttribute("href", base64Favicon);
  return /* @__PURE__ */ jsx296("div", {
    style: container65,
    className: "css-reset",
    children: /* @__PURE__ */ jsxs155("div", {
      style: message,
      children: [
        "The studio server has disconnected. ",
        /* @__PURE__ */ jsx296("br", {}),
        window.remotion_studioServerCommand ? /* @__PURE__ */ jsxs155("span", {
          children: [
            "Run",
            " ",
            /* @__PURE__ */ jsx296("code", {
              style: inlineCode,
              children: window.remotion_studioServerCommand
            }),
            " ",
            "to run it again."
          ]
        }) : /* @__PURE__ */ jsx296("span", {
          children: "Fast refresh will not work."
        })
      ]
    })
  });
};

// src/FastRefreshProvider.tsx
import { useCallback as useCallback150, useEffect as useEffect92, useMemo as useMemo154, useState as useState103 } from "react";
import { jsx as jsx297 } from "react/jsx-runtime";
var FastRefreshProvider = ({ children }) => {
  const [fastRefreshes, setFastRefreshes] = useState103(0);
  const [manualRefreshes, setManualRefreshes] = useState103(0);
  const increaseManualRefreshes = useCallback150(() => {
    setManualRefreshes((i) => i + 1);
  }, []);
  useEffect92(() => {
    if (typeof __webpack_module__ !== "undefined") {
      if (__webpack_module__.hot) {
        __webpack_module__.hot.addStatusHandler((status) => {
          if (status === "idle") {
            setFastRefreshes((i) => i + 1);
          }
        });
      }
    }
  }, []);
  const value = useMemo154(() => ({ fastRefreshes, manualRefreshes, increaseManualRefreshes }), [fastRefreshes, manualRefreshes, increaseManualRefreshes]);
  return /* @__PURE__ */ jsx297(FastRefreshContext.Provider, {
    value,
    children
  });
};

// src/helpers/inject-css.ts
import { Internals as Internals68 } from "remotion";
var makeDefaultGlobalCSS = () => {
  const unhoveredDragAreaFactor = 2;
  const fromMiddle = 50 / unhoveredDragAreaFactor;
  const hoveredDragAreaFactor = 6;
  const fromMiddleHovered = 50 / hoveredDragAreaFactor;
  return `
  html {
    --remotion-cli-internals-blue: #0b84f3;
    --remotion-cli-internals-blue-hovered: #4da3f7;
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
  }
  
  body {
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;
    /* Override Chakra UI position: relative on body */
    position: static !important;
  }

  .remotion-splitter {
    user-select: none;
    -webkit-user-select: none;
  }
  
  .remotion-splitter-horizontal {
    transform: scaleY(${unhoveredDragAreaFactor});
    background: linear-gradient(
      to bottom,
      transparent ${50 - fromMiddle}%,
      black ${50 - fromMiddle}%,
      black ${50 + fromMiddle}%,
      transparent ${50 + fromMiddle}%
    );
  }
  
  .remotion-splitter-horizontal.remotion-splitter-active, .remotion-splitter-horizontal.remotion-splitter-hover {
    background: linear-gradient(
      to bottom,
      transparent ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 + fromMiddleHovered}%,
      transparent ${50 + fromMiddleHovered}%
    );
    cursor: row-resize;
    transform: scaleY(${hoveredDragAreaFactor});
    z-index: 1000;
  }
  
  .remotion-splitter-vertical {
    transform: scaleX(${unhoveredDragAreaFactor});
    background: linear-gradient(
      to right,
      transparent ${50 - fromMiddle}%,
      black ${50 - fromMiddle}%,
      black ${50 + fromMiddle}%,
      transparent ${50 + fromMiddle}%
    );
  }
  
  .remotion-splitter-vertical.remotion-splitter-active, .remotion-splitter-vertical.remotion-splitter-hover {
    background: linear-gradient(
      to right,
      transparent ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 - fromMiddleHovered}%,
      var(--remotion-cli-internals-blue) ${50 + fromMiddleHovered}%,
      transparent ${50 + fromMiddleHovered}%
    );
    transform: scaleX(${hoveredDragAreaFactor});
    cursor: col-resize;
    z-index: 1000;
  }
  
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input:focus,
  textarea:focus,
  button:focus:not(.__remotion_input_dragger),
  a:focus {
    outline: none;
    box-shadow:
      inset 1px 1px #555,
      inset -1px -1px #555,
      inset 1px -1px #555,
      inset -1px 1px #555;
  }
  
  input[type='color'].__remotion_color_picker::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  input[type='color'].__remotion_color_picker::-webkit-color-swatch {
    border: none;
  }
  
  .__remotion_thumb,
  .__remotion_thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  .__remotion_thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    outline: none;
    top: 15.5px;
    width: 221px;
    margin-left: -2px;
    z-index: 2;
  }
  
  /* For Firefox browsers */
  .__remotion_thumb::-moz-range-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 37px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }
  
  /* For Chrome browsers */
  .__remotion_thumb::-webkit-slider-thumb {
    border: 1px solid black;
    border-radius: 2px;
    cursor: pointer;
    height: 39px;
    width: 10px;
    pointer-events: all;
    border-color: black;
    background-color: white;
    position: relative;
  }  

  .__remotion_input_dragger:hover span {
    color: var(--remotion-cli-internals-blue-hovered) !important;
  }

  .${DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME} span {
    color: var(--remotion-cli-internals-blue) !important;
    transition: color 0.2s ease-in-out;
  }
  `.trim();
};
var injected = false;
var injectCSS = () => {
  if (injected) {
    return;
  }
  Internals68.CSSUtils.injectCSS(makeDefaultGlobalCSS());
  injected = true;
};

// src/ResolveCompositionConfigInStudio.tsx
import {
  useCallback as useCallback151,
  useContext as useContext94,
  useEffect as useEffect93,
  useImperativeHandle as useImperativeHandle14,
  useMemo as useMemo155,
  useState as useState104
} from "react";
import { getInputProps as getInputProps2, Internals as Internals69 } from "remotion";
import { jsx as jsx298 } from "react/jsx-runtime";
var ResolveCompositionConfigInStudio = ({ children }) => {
  const [currentRenderModalComposition, setCurrentRenderModalComposition] = useState104(null);
  const { compositions, canvasContent, currentCompositionMetadata } = useContext94(Internals69.CompositionManager);
  const { fastRefreshes, manualRefreshes } = useContext94(FastRefreshContext);
  if (manualRefreshes) {}
  const selectedComposition = useMemo155(() => {
    return compositions.find((c) => canvasContent && canvasContent.type === "composition" && canvasContent.compositionId === c.id);
  }, [canvasContent, compositions]);
  const renderModalComposition = compositions.find((c) => c.id === currentRenderModalComposition);
  const { props: allEditorProps } = useContext94(Internals69.EditorPropsContext);
  const env = Internals69.getRemotionEnvironment();
  const inputProps = useMemo155(() => {
    return typeof window === "undefined" || env.isPlayer ? {} : getInputProps2() ?? {};
  }, [env.isPlayer]);
  const [resolvedConfigs, setResolvedConfigs] = useState104({});
  const selectedEditorProps = useMemo155(() => {
    return selectedComposition ? allEditorProps[selectedComposition.id] ?? {} : {};
  }, [allEditorProps, selectedComposition]);
  const renderModalProps = useMemo155(() => {
    return renderModalComposition ? allEditorProps[renderModalComposition.id] ?? {} : {};
  }, [allEditorProps, renderModalComposition]);
  const hasResolution = Boolean(currentCompositionMetadata);
  const doResolution = useCallback151(({
    calculateMetadata,
    combinedProps,
    compositionDurationInFrames,
    compositionFps,
    compositionHeight,
    compositionId,
    compositionWidth,
    defaultProps
  }) => {
    const controller = new AbortController;
    if (hasResolution) {
      return controller;
    }
    const { signal } = controller;
    const result = Internals69.resolveVideoConfigOrCatch({
      compositionId,
      calculateMetadata,
      inputProps: combinedProps,
      signal,
      defaultProps,
      compositionDurationInFrames,
      compositionFps,
      compositionHeight,
      compositionWidth
    });
    if (result.type === "error") {
      setResolvedConfigs((r) => ({
        ...r,
        [compositionId]: {
          type: "error",
          error: result.error
        }
      }));
      return controller;
    }
    const promOrNot = result.result;
    if (typeof promOrNot === "object" && "then" in promOrNot) {
      setResolvedConfigs((r) => {
        const prev = r[compositionId];
        if (prev?.type === "success" || prev?.type === "success-and-refreshing") {
          return {
            ...r,
            [compositionId]: {
              type: "success-and-refreshing",
              result: prev.result
            }
          };
        }
        return {
          ...r,
          [compositionId]: {
            type: "loading"
          }
        };
      });
      promOrNot.then((c) => {
        if (controller.signal.aborted) {
          return;
        }
        setResolvedConfigs((r) => ({
          ...r,
          [compositionId]: {
            type: "success",
            result: c
          }
        }));
      }).catch((err) => {
        if (controller.signal.aborted) {
          return;
        }
        setResolvedConfigs((r) => ({
          ...r,
          [compositionId]: {
            type: "error",
            error: err
          }
        }));
      });
    } else {
      setResolvedConfigs((r) => ({
        ...r,
        [compositionId]: {
          type: "success",
          result: promOrNot
        }
      }));
    }
    return controller;
  }, [hasResolution]);
  const currentComposition = canvasContent?.type === "composition" ? canvasContent.compositionId : null;
  useImperativeHandle14(Internals69.resolveCompositionsRef, () => {
    return {
      setCurrentRenderModalComposition: (id) => {
        setCurrentRenderModalComposition(id);
      },
      reloadCurrentlySelectedComposition: () => {
        if (!currentComposition) {
          return;
        }
        const composition = compositions.find((c) => c.id === currentComposition);
        if (!composition) {
          throw new Error(`Could not find composition with id ${currentComposition}`);
        }
        const editorProps = allEditorProps[currentComposition] ?? {};
        const defaultProps = {
          ...composition.defaultProps ?? {},
          ...editorProps ?? {}
        };
        const props = {
          ...defaultProps,
          ...inputProps ?? {}
        };
        doResolution({
          defaultProps,
          calculateMetadata: composition.calculateMetadata,
          combinedProps: props,
          compositionDurationInFrames: composition.durationInFrames ?? null,
          compositionFps: composition.fps ?? null,
          compositionHeight: composition.height ?? null,
          compositionWidth: composition.width ?? null,
          compositionId: composition.id
        });
      }
    };
  }, [
    allEditorProps,
    compositions,
    currentComposition,
    doResolution,
    inputProps
  ]);
  const isTheSame = selectedComposition?.id === renderModalComposition?.id;
  const currentDefaultProps = useMemo155(() => {
    return {
      ...selectedComposition?.defaultProps ?? {},
      ...selectedEditorProps ?? {}
    };
  }, [selectedComposition?.defaultProps, selectedEditorProps]);
  const originalProps = useMemo155(() => {
    return {
      ...currentDefaultProps,
      ...inputProps ?? {}
    };
  }, [currentDefaultProps, inputProps]);
  const canResolve = selectedComposition && Boolean(selectedComposition.calculateMetadata);
  const shouldIgnoreUpdate = typeof window !== "undefined" && window.remotion_ignoreFastRefreshUpdate && fastRefreshes <= window.remotion_ignoreFastRefreshUpdate;
  useEffect93(() => {
    if (shouldIgnoreUpdate) {
      return;
    }
    if (canResolve) {
      const controller = doResolution({
        calculateMetadata: selectedComposition.calculateMetadata,
        combinedProps: originalProps,
        compositionDurationInFrames: selectedComposition.durationInFrames ?? null,
        compositionFps: selectedComposition.fps ?? null,
        compositionHeight: selectedComposition.height ?? null,
        compositionWidth: selectedComposition.width ?? null,
        defaultProps: currentDefaultProps,
        compositionId: selectedComposition.id
      });
      return () => {
        controller.abort();
      };
    }
  }, [
    canResolve,
    currentDefaultProps,
    doResolution,
    originalProps,
    selectedComposition?.calculateMetadata,
    selectedComposition?.durationInFrames,
    selectedComposition?.fps,
    selectedComposition?.height,
    selectedComposition?.id,
    selectedComposition?.width,
    shouldIgnoreUpdate
  ]);
  useEffect93(() => {
    if (renderModalComposition && !isTheSame) {
      const combinedProps = {
        ...renderModalComposition.defaultProps ?? {},
        ...renderModalProps ?? {},
        ...inputProps ?? {}
      };
      const controller = doResolution({
        calculateMetadata: renderModalComposition.calculateMetadata,
        compositionDurationInFrames: renderModalComposition.durationInFrames ?? null,
        compositionFps: renderModalComposition.fps ?? null,
        compositionHeight: renderModalComposition.height ?? null,
        compositionId: renderModalComposition.id,
        compositionWidth: renderModalComposition.width ?? null,
        defaultProps: currentDefaultProps,
        combinedProps
      });
      return () => {
        controller.abort();
      };
    }
  }, [
    currentDefaultProps,
    doResolution,
    inputProps,
    isTheSame,
    renderModalComposition,
    renderModalProps
  ]);
  const resolvedConfigsIncludingStaticOnes = useMemo155(() => {
    const staticComps = compositions.filter((c) => {
      return c.calculateMetadata === null;
    });
    return {
      ...resolvedConfigs,
      ...staticComps.reduce((acc, curr) => {
        return {
          ...acc,
          [curr.id]: {
            type: "success",
            result: { ...curr, defaultProps: curr.defaultProps ?? {} }
          }
        };
      }, {})
    };
  }, [compositions, resolvedConfigs]);
  return /* @__PURE__ */ jsx298(Internals69.ResolveCompositionContext.Provider, {
    value: resolvedConfigsIncludingStaticOnes,
    children
  });
};

// src/Studio.tsx
import { jsx as jsx299, jsxs as jsxs156 } from "react/jsx-runtime";
var getServerDisconnectedDomElement = () => {
  return document.getElementById("server-disconnected-overlay");
};
var StudioInner = ({ rootComponent, readOnly, visualModeEnabled }) => {
  return /* @__PURE__ */ jsx299(Internals70.CompositionManagerProvider, {
    onlyRenderComposition: null,
    currentCompositionMetadata: null,
    initialCompositions: [],
    initialCanvasContent: null,
    children: /* @__PURE__ */ jsx299(Internals70.RemotionRootContexts, {
      visualModeEnabled,
      frameState: null,
      audioEnabled: window.remotion_audioEnabled,
      videoEnabled: window.remotion_videoEnabled,
      logLevel: window.remotion_logLevel,
      numberOfAudioTags: window.remotion_numberOfAudioTags,
      audioLatencyHint: window.remotion_audioLatencyHint ?? "interactive",
      children: /* @__PURE__ */ jsx299(StaticFilesProvider, {
        children: /* @__PURE__ */ jsx299(ResolveCompositionConfigInStudio, {
          children: /* @__PURE__ */ jsxs156(EditorContexts, {
            readOnlyStudio: readOnly,
            children: [
              /* @__PURE__ */ jsx299(Editor, {
                readOnlyStudio: readOnly,
                Root: rootComponent
              }),
              readOnly ? null : createPortal(/* @__PURE__ */ jsx299(ServerDisconnected, {}), getServerDisconnectedDomElement())
            ]
          })
        })
      })
    })
  });
};
var Studio = ({ rootComponent, readOnly, visualModeEnabled }) => {
  useLayoutEffect2(() => {
    injectCSS();
  }, []);
  return /* @__PURE__ */ jsx299(FastRefreshProvider, {
    children: /* @__PURE__ */ jsx299(StudioInner, {
      rootComponent,
      readOnly,
      visualModeEnabled
    })
  });
};

// src/internals.ts
var StudioInternals = {
  Studio
};
export {
  StudioInternals
};
